webpackJsonp([1],{

/***/ "+aMm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+avS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/5du":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/RA0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/dvw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_SL360_new.7fa562f.png";

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "00Da":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0asO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0wlN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1IzS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1XQ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1kVi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1xi3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "25ou":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2RqM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2mr5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Im1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3ilW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4EZE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4LeQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5+4R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5FH3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5I7h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5TKu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5xTq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6qH4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6t2/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "79lC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7gN+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8I+S":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "8jTq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AUSj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AgSV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Anwz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BMOd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BVRP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BegD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-awesome/components/Icon.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ var Icon = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return defineProperty_default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e22f0aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-awesome/components/Icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-awesome/components/Icon.vue
function injectStyle (ssrContext) {
  __webpack_require__("DQX6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Icon,
  components_Icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_awesome_components_Icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DBpU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DNZR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DPhx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DQX6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dbrg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E7fJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EX1H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ezwu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F2Zz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F9MN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FVAw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FXVC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FZdT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fj4u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FzI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H6kr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HQJ8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KHvb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KQVM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KVKU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KnrZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LRkm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LUED":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LV+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lygm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M19j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M27I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MfYH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var filters_namespaceObject = {};
__webpack_require__.d(filters_namespaceObject, "numberFormat", function() { return numberFormat; });
__webpack_require__.d(filters_namespaceObject, "formatMonth", function() { return formatMonth; });
__webpack_require__.d(filters_namespaceObject, "formatDay", function() { return formatDay; });
__webpack_require__.d(filters_namespaceObject, "formatYear", function() { return formatYear; });
__webpack_require__.d(filters_namespaceObject, "formatDate", function() { return formatDate; });
var directives_namespaceObject = {};
__webpack_require__.d(directives_namespaceObject, "mUaEvent", function() { return mUaEvent; });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__("Y81h");
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./src/assets/utils/map.js


/**
 * Created by seaasun on 2017/12/20.
 */



/* harmony default export */ var utils_map = (function (id, options) {
  /* eslint-disable no-undef */
  var googleMap = google.maps;
  googleMap.Polygon.prototype.getBounds = function () {
    var bounds = new googleMap.LatLngBounds();
    var paths = this.getPaths();
    var path = void 0;
    for (var i = 0; i < paths.getLength(); i++) {
      path = paths.getAt(i);
      for (var ii = 0; ii < path.getLength(); ii++) {
        bounds.extend(path.getAt(ii));
      }
    }
    return bounds;
  };
  if (document.getElementById(id) === null) {
    return false;
  }
  var map = new googleMap.Map(document.getElementById(id), options);
  var x = null;
  var polygon = null;
  var address = null;
  var placesresult = null;
  return {
    id: id,
    options: options,
    map: map,
    googleMap: googleMap,
    x: x,
    polygon: polygon,
    address: address,
    placesresult: placesresult,
    markers: [],
    polygonBounder: null, // polygon
    isPolygonDrawing: false, // disabled start button in polygon UI
    polygonAddress: {}, // for commit address information in vuex
    initPolygonDrawing: function initPolygonDrawing(searchPlace) {
      var _this = this;

      if (src_main.$store.state.isPolygonDrawing) {
        return;
      }
      if (!searchPlace) {
        return false;
      }

      src_main.$store.commit('geo/saveKey', ['isPolygonDrawing', true]);

      var drawingManager = new googleMap.drawing.DrawingManager({
        drawingMode: googleMap.drawing.OverlayType.POLYGON,
        drawingControl: false,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: []
        },
        polygonOptions: {
          strokeColor: '#f33f00',
          strokeWeight: 5,
          strokeOpacity: 0.8,
          fillColor: '#ff0000',
          fillOpacity: 0.2,
          draggable: true,
          editable: true,
          geodesic: true,
          zIndex: 1,
          map: this.map
        }
      });
      drawingManager.setMap(this.map);
      googleMap.event.addListener(drawingManager, 'polygoncomplete', function (polygon) {
        drawingManager.setOptions({
          drawingMode: null
        });
        src_main.$store.commit('geo/saveKey', ['isPolygonDrawing', false]);
        // polygon.getPaths().getArray()[0].b,
        _this.initPolygon(null, true, {
          address: searchPlace.formatted_address,
          lat: searchPlace.geometry.location.lat().toString(),
          lng: searchPlace.geometry.location.lng().toString() // TODO A better way to get the center of polygon https://gist.github.com/jeremejazz/9407568
        }, polygon);
        if (_this.map.getZoom() < 9) {
          src_main.$store.commit('order/cleanGeo');
          _this.clearMarkers();
          _this.clearPolygon();
          alert('Please Zoom in to use the polygon mapping tool.\nTo select larger geographic regions, please use a radius select, scf, ZIP code, or county selection.');
          // return
        }
      });
    },
    initPolygon: function initPolygon(paths, editable, polygonAddress, polygon) {
      var _this2 = this;

      // paths: the path of polygon, if provide polygon ,it can be null
      // editable: if ture, user can drag polygon,
      // polygonAddress, the data save in vuex,
      // polygon: the polygon

      if (polygonAddress) {
        this.polygonAddress = polygonAddress;
      }

      if (polygon) {
        this.polygonBounder = polygon;
      } else {
        if (this.polygonBounder) {
          this.polygonBounder.setMap(null);
        }
        this.polygonBounder = new googleMap.Polygon({
          paths: paths,
          strokeColor: '#f33f00',
          strokeWeight: 5,
          strokeOpacity: 0.8,
          fillColor: '#ff0000',
          fillOpacity: 0.2,
          editable: editable,
          draggable: editable
        });

        this.polygonBounder.setMap(this.map);
        setTimeout(function () {
          _this2.map.fitBounds(_this2.polygonBounder.getBounds()); // Don't know why need delay fit map
        }, 1);
      }
      if (editable) {
        this.savePolygonAddress();
        // detail: https://stackoverflow.com/questions/15563420/polygon-coordinates-changed-edited-moved-event-google-maps-v3
        googleMap.event.addListener(this.polygonBounder.getPath(), 'set_at', function (polygon) {
          _this2.savePolygonAddress();
        });
        googleMap.event.addListener(this.polygonBounder.getPath(), 'remove_at', function (polygon) {
          _this2.savePolygonAddress();
        });
        googleMap.event.addListener(this.polygonBounder.getPath(), 'insert_at', function (polygon) {
          _this2.savePolygonAddress();
        });
      }
    },
    savePolygonAddress: function savePolygonAddress() {
      src_main.$store.dispatch('order/changeGeoType', src_main.$store.state.geo.geoTypes.Polygon.Code);
      var searchString = '';
      var paths = [];
      paths = this.polygonBounder.getPath().getArray();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(paths), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var path = _step.value;

          searchString += path.lng() + ':' + path.lat() + '|';
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      searchString = searchString + paths[0].lng() + ':' + paths[0].lat();
      if (src_main.$store.state.order.OrderAddresses.length > 0 && src_main.$store.state.order.OrderAddresses[0].AddrSearchString !== searchString) {
        src_main.$store.commit('order/cleanGeo');
      }
      src_main.$store.commit('order/addAddress', {
        Radius: 0,
        AddrSearchString: searchString,
        AddressLine: this.polygonAddress.address,
        AddressName: this.polygonAddress.address,
        Latitude: this.polygonAddress.lat,
        Longitude: this.polygonAddress.lng
      });
      src_main.$store.commit('order/addGeo', {
        AddressLine: searchString,
        GeoKeyCode: searchString,
        GeoKeyDesc: this.polygonAddress.address,
        GeoType: src_main.$store.state.order.GeoType
      });
    },
    clearMarkers: function clearMarkers() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.markers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var marker = _step2.value;

          marker.setMap(null);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.markers = [];
    },
    clearPolygon: function clearPolygon() {
      if (this.polygonBounder) {
        this.polygonBounder.setMap(null);
        this.polygonBounder = null;
      }
    },
    initCircleDrawing: function initCircleDrawing(orderAddresses, isMark) {
      var _this3 = this;

      var circleMaps = [];
      if (orderAddresses.length === 0) {
        return;
      }
      var bounds = new googleMap.LatLngBounds();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(orderAddresses), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _address = _step3.value;

          var circle = new googleMap.Circle({
            strokeColor: '#f33f00',
            strokeWeight: 5,
            strokeOpacity: 0.8,
            fillColor: '#ff0000',
            fillOpacity: 0.2,
            draggable: false,
            editable: false,
            geodesic: true,
            zIndex: 1,
            map: map,
            radius: _address.Radius * 1609.344,
            center: { lat: Number(_address.Latitude), lng: Number(_address.Longitude) }
          });
          bounds.union(circle.getBounds());
          var market = null;
          if (isMark) {
            market = new googleMap.Marker({
              position: { lat: Number(_address.Latitude), lng: Number(_address.Longitude) },
              center: { lat: Number(_address.Latitude), lng: Number(_address.Longitude) },
              map: map
            });
          }
          circleMaps.push({ c: circle, m: market });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      setTimeout(function () {
        _this3.map.fitBounds(bounds);
      }, 1);
      return circleMaps;
    },
    clearTextSearchMarks: function clearTextSearchMarks() {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(this.textSearchMarks), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          item.setMap(null);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.textSearchMarks = [];
    },

    textSearchMarks: [],
    textSearch: function textSearch(query, cb, clearMark) {
      var _this4 = this;

      var service = new googleMap.places.PlacesService(map);
      var that = this;
      service.textSearch({
        query: query,
        componentRestrictions: { country: 'us' }
      }, function (result, status) {
        if (status === googleMap.places.PlacesServiceStatus.OK) {
          if (clearMark) {
            _this4.clearTextSearchMarks();
          }
          that.map.setCenter(result[0].geometry.location);
          that.map.setZoom(12);
          var m = new googleMap.Marker({
            position: result[0].geometry.location,
            center: result[0].geometry.location,
            map: that.map
          });
          _this4.textSearchMarks.push(m);
          /* eslint-disable standard/no-callback-literal */
          cb({ placesresult: result[0], marker: m });
        } else {
          cb({ placesresult: null });
        }
      });
    },
    marker: function marker(place) {
      var m = new googleMap.Marker({
        position: place,
        center: place,
        map: this.map
      });
      return m;
    },
    resize: function resize() {
      googleMap.event.trigger(map, 'resize');
    },
    getAddress: function getAddress(query, cb) {
      var service = new googleMap.places.PlacesService(map);
      var that = this;
      service.textSearch({
        query: query,
        componentRestrictions: { country: 'us' }
      }, function (result, status) {
        if (status === googleMap.places.PlacesServiceStatus.OK) {
          /* eslint-disable*/
          that.map.setCenter(result[0].geometry.location);
          that.map.setZoom(12);
          cb({
            placesresult: result[0]
          });
        }
      });
    },

    hasAddLayer: false,
    addLayer: function addLayer(layer_name, layer_title, isdefault) {
      var _this5 = this;

      layer_name = layer_name || 'ZIP';
      layer_title = layer_title || layer_name;
      isdefault = isdefault || 1;

      var wmsUrl = src_main.$store.getters['config/wmsLink'];
      var wmsLayer = this.createWMSTileLayer(wmsUrl, layer_name, null, "image/png", null, null, null, .1, map);

      var zoomLevel = map.getZoom();
      if (zoomLevel > 8) {
        this.hasAddLayer = true;
        map.overlayMapTypes.setAt(0, wmsLayer);
      }
      googleMap.event.addListener(map, 'zoom_changed', function () {
        zoomLevel = map.getZoom();
        if (zoomLevel > 8 && !_this5.hasAddLayer) {
          _this5.hasAddLayer = true;
          map.overlayMapTypes.setAt(0, wmsLayer);
        }

        if (zoomLevel <= 8 && _this5.hasAddLayer) {
          _this5.hasAddLayer = false;
          map.overlayMapTypes.clear();
        }
      });
    },
    createWMSTileLayer: function createWMSTileLayer(wmsUrl, wmsLayers, wmsStyles, wmsFormat, wmsVersion, wmsBgColor, wmsSrs, opacity, map) {
      return new googleMap.ImageMapType({
        getTileUrl: this.CustomGetTileUrl,
        tileSize: new googleMap.Size(256, 256),
        isPng: true,
        maxZoom: 1,
        getOpacity: 1,
        name: 'bounder',
        myLayers: wmsLayers,
        myStyles: wmsStyles ? wmsStyles : "RedBorder",
        myFormat: wmsFormat ? wmsFormat : "image/png",
        myVersion: wmsVersion ? wmsVersion : "1.1.1",
        myBgColor: wmsBgColor ? wmsBgColor : "0xffffff",
        myBaseURL: wmsUrl
      });
    },
    CustomGetTileUrl: function CustomGetTileUrl(a, b, c) {
      //cover the pixel to LatLng
      var proj = map.getProjection();
      var zfactor = Math.pow(2, b);
      var lUL = proj.fromPointToLatLng(new googleMap.Point(a.x * 256 / zfactor, (a.y + 1) * 256 / zfactor));
      var lLR = proj.fromPointToLatLng(new googleMap.Point((a.x + 1) * 256 / zfactor, a.y * 256 / zfactor));

      var lSRS = "EPSG:4326";
      var lBbox = lUL.lng() + "," + lUL.lat() + "," + lLR.lng() + "," + lLR.lat();
      var lURL = this.myBaseURL;

      lURL += "&REQUEST=GetMap";
      lURL += "&SERVICE=WMS";
      lURL += "&VERSION=" + this.myVersion;
      lURL += "&LAYERS=" + this.myLayers;
      // lURL += "&STYLES=" + this.myStyles;
      lURL += "&FORMAT=" + this.myFormat;
      lURL += "&BGCOLOR=" + this.myBgColor;
      lURL += "&TRANSPARENT=TRUE";
      lURL += "&SRS=" + lSRS;
      lURL += "&BBOX=" + lBbox;
      lURL += "&WIDTH=256";
      lURL += "&HEIGHT=256";
      lURL += "&reaspect=false";
      return lURL;
    },

    loadBoundId: [],
    loadPolygons: {},
    clearSelecteBounder: function clearSelecteBounder() {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(keys_default()(this.loadPolygons)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var key = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(this.loadPolygons[key]), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var item = _step6.value;

              item.setOptions({
                strokeOpacity: 0,
                fillOpacity: 0
              });
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    fitZipBounder: function fitZipBounder() {
      var _this6 = this;

      var bounds = new googleMap.LatLngBounds();
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = get_iterator_default()(src_main.$store.getters['order/geoItems']), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var item = _step7.value;

          if (this.loadPolygons[item.GeoKeyCode]) {
            // TODO@PONY I don't why can't find 0, so I add this condition
            for (var d in this.loadPolygons[item.GeoKeyCode]) {
              bounds.union(this.loadPolygons[item.GeoKeyCode][d].getBounds());
            }
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      if (src_main.$store.getters['order/geoItems'].length === 0) {
        // move to the center of USA
        // this.map.setZoom(4)
        // this.map.setCenter(new this.googleMap.LatLng(37.1, -95.7))
      } else {
        setTimeout(function () {
          _this6.map.fitBounds(bounds);
        });
      }
    },
    addBounder: function addBounder(geo, isAdded, isFitMap) {
      var _this7 = this;

      if (!src_main.$store.state.geo.catchZipBounders.hasOwnProperty(geo.id) || src_main.$store.state.geo.catchZipBounders[geo.id] === 'loading') {
        src_main.$set(src_main.$store.state.geo.catchZipBounders, geo.id, geo);
      }

      if (this.loadBoundId.indexOf(geo.id) > 0) {
        if (isAdded) {
          src_main.$store.commit('order/addGeo', {
            GeoKeyCode: geo.id,
            GeoKeyDesc: geo.id,
            GeoType: 5
          });

          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = get_iterator_default()(this.loadPolygons[geo.id]), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var item = _step8.value;

              item.setOptions({
                fillColor: '#FF0000',
                strokeOpacity: 1,
                fillOpacity: 0.2
              });
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
        return;
      }
      this.loadBoundId.push(geo.id);

      this.loadPolygons[geo.id] = [];
      // for (let item of geo.data) {

      var _loop = function _loop(d) {
        var item = geo.data[d]; // TODO@PONY it save time
        var polygon = new googleMap.Polygon({
          path: googleMap.geometry.encoding.decodePath(item[0].encodedPoints),
          levels: item[0].encodedLevels,
          strokeColor: '#FF0000',
          strokeOpacity: 0,
          strokeWeight: 2,
          fillOpacity: 0,
          map: _this7.map,
          id: geo.id,
          zIndex: 1000
        });

        googleMap.event.addListener(polygon, 'click', function (event) {
          if (!src_main.$store.getters['order/hasGeoItem'](polygon.id)) {
            src_main.$store.commit('order/addGeo', {
              GeoKeyCode: geo.id,
              GeoKeyDesc: geo.id,
              GeoType: 5
            });

            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
              for (var _iterator10 = get_iterator_default()(_this7.loadPolygons[polygon.id]), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                var _item2 = _step10.value;

                _item2.setOptions({
                  fillColor: '#FF0000',
                  strokeOpacity: 1,
                  fillOpacity: 0.4
                });
              }
            } catch (err) {
              _didIteratorError10 = true;
              _iteratorError10 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                  _iterator10.return();
                }
              } finally {
                if (_didIteratorError10) {
                  throw _iteratorError10;
                }
              }
            }
          } else {
            src_main.$store.commit('order/deleteGeo', polygon.id);

            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
              for (var _iterator11 = get_iterator_default()(_this7.loadPolygons[polygon.id]), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                var _item3 = _step11.value;

                polygon.setOptions({
                  fillColor: '#FF0000',
                  strokeOpacity: 0,
                  fillOpacity: 0
                });
              }
            } catch (err) {
              _didIteratorError11 = true;
              _iteratorError11 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                  _iterator11.return();
                }
              } finally {
                if (_didIteratorError11) {
                  throw _iteratorError11;
                }
              }
            }
          }
        });

        _this7.loadPolygons[geo.id].push(polygon);
      };

      for (var d in geo.data) {
        _loop(d);
      }

      if (isAdded) {
        if (!src_main.$store.getters['order/hasGeoItem'](geo.id)) {
          src_main.$store.commit('order/addGeo', {
            GeoKeyCode: geo.id,
            GeoKeyDesc: geo.id,
            GeoType: 5
          });
        }
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = get_iterator_default()(this.loadPolygons[geo.id]), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var _item = _step9.value;

            _item.setOptions({
              fillColor: '#FF0000',
              strokeOpacity: 1,
              fillOpacity: 0.2
            });
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }
      }
      if (isFitMap) {
        this.fitZipBounder();
      }
    },
    startSelect: function startSelect(geoType) {
      var _this8 = this;

      this.map.addListener('click', function (event) {
        if (src_main.$store.state.order.GeoType !== geoType) {
          src_main.$store.dispatch('order/changeGeoType', geoType);
        }
        _this8.getXYBounder(event.latLng.lng(), event.latLng.lat(), true);
      });
    },
    getXYBounder: function getXYBounder(x, y, isAdded) {
      var _this9 = this;

      src_main.$http.get(src_main.$store.getters['config/mapDataLink'] + 'type=zipxy&x=' + x + '&y=' + y).then(function (resp) {
        if (resp.body === '') {
          return;
        }
        _this9.addBounder(resp.body, isAdded, true);
      });
    },
    getZipBounder: function getZipBounder(zip, isAdded, isFitMap) {
      var _this10 = this;

      if (zip.length !== 5) {
        return;
      }
      var catchZipBounders = src_main.$store.state.geo.catchZipBounders;
      if (catchZipBounders.hasOwnProperty(zip) && catchZipBounders[zip] !== 'loading') {
        this.addBounder(catchZipBounders[zip], isAdded);
        if (isFitMap) {
          this.fitZipBounder();
        }
      } else if (catchZipBounders[zip] === 'loading') {
        return;
      } else {
        src_main.$set(src_main.$store.state.geo.catchZipBounders, zip, 'loading');

        src_main.$http.get(src_main.$store.getters['config/mapDataLink'] + 'type=zip&zip=' + zip).then(function (resp) {
          if (resp.body === '') {
            return;
          }
          _this10.addBounder(resp.body, isAdded);
          if (isFitMap) {
            _this10.fitZipBounder();
          }
        });
      }
    },
    updateZipBounders: function updateZipBounders() {
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = get_iterator_default()(keys_default()(this.loadPolygons)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var code = _step12.value;

          if (!src_main.$store.getters['order/hasGeoItem'](code)) {
            var _iteratorNormalCompletion14 = true;
            var _didIteratorError14 = false;
            var _iteratorError14 = undefined;

            try {
              for (var _iterator14 = get_iterator_default()(this.loadPolygons[code]), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                var item = _step14.value;

                item.setOptions({
                  strokeOpacity: 0,
                  fillOpacity: 0
                });
              }
            } catch (err) {
              _didIteratorError14 = true;
              _iteratorError14 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion14 && _iterator14.return) {
                  _iterator14.return();
                }
              } finally {
                if (_didIteratorError14) {
                  throw _iteratorError14;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      for (var i = 0; i < src_main.$store.getters['order/geoItems'].length; i++) {
        var geo = src_main.$store.getters['order/geoItems'][i];
        if (geo.GeoType === 5) {
          var isExist = false;
          var _iteratorNormalCompletion13 = true;
          var _didIteratorError13 = false;
          var _iteratorError13 = undefined;

          try {
            for (var _iterator13 = get_iterator_default()(keys_default()(this.loadPolygons)), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
              var _code = _step13.value;

              if (geo.GeoKeyCode === _code) {
                isExist = true;
              }
            }
          } catch (err) {
            _didIteratorError13 = true;
            _iteratorError13 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion13 && _iterator13.return) {
                _iterator13.return();
              }
            } finally {
              if (_didIteratorError13) {
                throw _iteratorError13;
              }
            }
          }

          if (!isExist) {
            this.getZipBounder(geo.GeoKeyCode, true, i === src_main.$store.getters['order/geoItems'].length - 1);
          }
        }
      }
    },
    getRadioBounders: function getRadioBounders(x, y, r, isAdded) {
      var _this11 = this;

      src_main.$http.get(src_main.$store.getters['config/mapDataLink'] + 'type=radius_zip&x=' + x + '&y=' + y + '&r=' + r).then(function (resp) {
        if (resp.body === '') {
          return;
        }
        var _iteratorNormalCompletion15 = true;
        var _didIteratorError15 = false;
        var _iteratorError15 = undefined;

        try {
          for (var _iterator15 = get_iterator_default()(resp.body), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
            var geo = _step15.value;

            _this11.addBounder(geo, isAdded);
          }
        } catch (err) {
          _didIteratorError15 = true;
          _iteratorError15 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion15 && _iterator15.return) {
              _iterator15.return();
            }
          } finally {
            if (_didIteratorError15) {
              throw _iteratorError15;
            }
          }
        }
      });
    },

    autocomplete: null,
    startZipMapAutocomplete: function startZipMapAutocomplete(id) {
      this.autocomplete = new this.googleMap.places.Autocomplete(document.getElementById(id), {
        types: ['(regions)'],
        componentRestrictions: { 'country': 'us' }
      });
    },
    startZipAutocomplete: function startZipAutocomplete(id, cb) {
      this.autocomplete = new this.googleMap.places.Autocomplete(document.getElementById(id), {
        types: ['(regions)'],
        componentRestrictions: { 'country': 'us' }
      });
      this.autocomplete.addListener('place_changed', this.autocompleteFill(id));
    },
    startPolygonAutocomplete: function startPolygonAutocomplete(id, cb) {
      this.autocomplete = new this.googleMap.places.Autocomplete(document.getElementById(id), {
        types: ['(regions)'],
        componentRestrictions: { 'country': 'us' }
      });
      this.autocomplete.addListener('place_changed', cb);
    },

    autocompleteMark: null,
    autocompleteFill: function autocompleteFill(id) {
      var _this12 = this;

      return function () {
        if (_this12.autocompleteMark) {
          _this12.autocompleteMark.setMap(null);
        }
        var place = _this12.autocomplete.getPlace();
        if (place.address_components && place.address_components[0] && place.address_components[0].long_name.length === 5 && !isNaN(place.address_components[0].long_name)) {
          src_main.$store.dispatch('order/changeGeoType', _this12.geoType);
          _this12.getZipBounder(place.address_components[0].long_name, true, true);
          document.getElementById(id).value = place.address_components[0].long_name;
        } else if (place.geometry) {
          _this12.map.setZoom(12);
          _this12.map.panTo(place.geometry.location);
          _this12.autocompleteMark = new google.maps.Marker({
            position: place.geometry.location,
            center: place.geometry.location,
            map: _this12.map
          });
          _this12.places = place;
        } else {
          document.getElementById(id).placeholder = 'Enter a ZIP Code/Address';
        }
      };
    },
    drawCircle: function drawCircle(lng, lat, radius) {
      var circle = new googleMap.Circle({
        strokeColor: '#f33f00',
        strokeWeight: 5,
        strokeOpacity: 0.8,
        fillColor: '#ff0000',
        fillOpacity: 0.2,
        draggable: false,
        editable: false,
        geodesic: true,
        zIndex: 1,
        map: map,
        radius: radius * 1609.344,
        center: { lat: lat, lng: lng }
      });

      map.fitBounds(circle.getBounds());
      return circle;

      // var bounds = new google.maps.LatLngBounds();
      //
      // $.each(circles, function(index, circle){
      //   bounds.union(circle.getBounds());
      // });
      //
      // map.fitBounds(bounds);
    }
  };
});
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__("JDN0");
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);

// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var isNumber = __webpack_require__("J009");
var isNumber_default = /*#__PURE__*/__webpack_require__.n(isNumber);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// CONCATENATED MODULE: ./src/assets/utils/validate.js



 /**
                                        * Created by seaasun on 2018/2/9.
                                        */

var rulesDict = {
  require: {
    fu: function fu(val) {
      return !isEmpty_default()(val) || isNumber_default()(val);
    },

    desc: 'Required'
  },
  email: {
    fu: function fu(val) {
      return isString_default()(val) && val.indexOf('@') > 0 && val.indexOf('@') < val.length - 1;
    },

    desc: 'Need Email'
  },
  zip: {
    fu: function fu(val) {
      return !isNaN(val) && val.length === 5;
    },

    desc: 'Need ZIP Code, 5 digits'
  },
  number: {
    fu: function fu(val) {
      return !isNaN(val);
    },

    desc: 'Need Number'
  },
  min: {
    fu: function fu(val, payload) {
      return val >= payload;
    },

    desc: 'mus'
  },
  minLength: {
    fu: function fu(val, payload) {
      return val.length >= payload;
    },

    desc: 'mus'
  },
  max: {
    fu: function fu(val, payload) {
      return val <= payload;
    },

    desc: 'max'
  },
  creditCard: {
    fu: function fu(val, payload) {
      return !isNaN(val) && val.length <= 17 && val.length >= 14;
    },

    desc: 'Need creditCard number, '
  }
};

function parseErryType(rule) {
  if (isString_default()(rule)) {
    return {
      val: true,
      desc: rulesDict[rule].desc,
      fu: rulesDict[rule].fu
    };
  } else {
    return assign_default()({}, rulesDict[rule.type], rule);
  }
}

function onlyErroy(val, rules) {
  for (var i = 0; i < rules.length; i++) {
    var rule = parseErryType(rules[i]);
    if (!rule.fu(val, rule.payload)) {
      return {
        isError: true,
        desc: rule.desc
      };
    }
  }
  return {
    isError: false,
    desc: ''
  };
}

function manyErrory() {}
/* harmony default export */ var validate = (function (val, rules, only) {
  only = only === undefined ? true : only; // display only one error
  if (isString_default()(rules)) rules = [rules];

  if (only) {
    return onlyErroy(val, rules);
  } else {
    return manyErrory(val, rules);
  }
});
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/assets/utils/index.js

/**
 * Created by seaasun on 2018/2/9.
 */
/**
 * Created by seaasun on 2017/12/12.
 */




// import globalError from './globalError.js'


/* harmony default export */ var utils = ({
  delayTime: 3000, // Non-first screen API lazy loading time, millisecond
  post: function post(url, data, success, error) {
    success = success || function () {};
    error = error || function () {};
    var ajax = new XMLHttpRequest();
    ajax.open('post', url);
    ajax.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
    ajax.timeout = 4000;
    ajax.onreadystatechange = function () {
      if (ajax.readyState === 4) {
        if (ajax.status === 504) {
          error(ajax.responseText);
          ajax.abort();
        } else if (ajax.status === 200) {
          success(ajax.responseText);
        } else {
          error(ajax.responseTex);
        }
        ajax = null;
      }
    };
    ajax.send(stringify_default()(data));
  },
  createMap: function createMap(id, options) {
    this.maps[id] = utils_map(id, options);
  },

  maps: {},
  numberFormat: function numberFormat(num, symbol, decimal, rounding, isThousands) {
    /*
      num: number,
      symbol: default: '$'
      decimal: default: 2
      rounding: 'round', 'no',
      isThousands: default: true
     */
    if (symbol === undefined) symbol = '$';

    if (decimal === 0) {} else if (!decimal) {
      decimal = 2;
    }

    rounding = rounding || 'round';
    isThousands = isThousands || true;

    num = parseFloat(num);
    // rounding
    if (rounding === 'no') {} else if (rounding === 'round') {
      num = num.toFixed(decimal);
    }
    // Thousands
    num = num && num.toString().replace(/(^|\s)\d+/g, function (m) {
      return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
    });
    // money symbol
    return symbol + num;
  },
  dateFormat: function dateFormat(date, format) {
    date = date || new Date();
    format = format || 'MMMM Do YYYY, hh:mm:ss';
    return moment_default()(date).format(format);
  },
  vaildZip: function vaildZip(code, type) {
    type = type || 'zip';
    //  ZipRegExp = new RegExp(page.placeorder.ZipRegularExpression, "i");
    if (type === 'zip') {
      return (/^[0-9]{5}$/.test(code)
      );
    } else if (type === 'zip4') {
      return (/^[0-9]{9}$/.test(code)
      );
    } else if (type === 'crrt') {
      return (/^[0-9]{5}[:]{1}[A-Za-z]{1}[0-9]{3}$/.test(code)
      );
    } else {
      return true;
    }
  },
  progressStart: function progressStart() {
    nprogress_default.a.start();
  },
  progressDone: function progressDone() {
    nprogress_default.a.done();
  },
  sortJson: function sortJson(jsonObjects, sortBy, direction, convertTypeFun) {
    if (jsonObjects == null) {
      return;
    }
    var intDirection = direction === 'asc' ? 1 : -1;
    var fn = function fn(r1, r2) {
      var v1, v2;
      var tmpArr = sortBy.split('.');
      v1 = r1[tmpArr[0]];
      v2 = r2[tmpArr[0]];
      for (var i = 1; i < tmpArr.length; i++) {
        v1 = v1[tmpArr[i]];
        v2 = v2[tmpArr[i]];
      }
      if (convertTypeFun != null && typeof convertTypeFun === 'function') {
        v1 = convertTypeFun(v1);
        v2 = convertTypeFun(v2);
      }
      var result = v1 > v2 ? 1 : v1 < v2 ? -1 : 0;
      return intDirection * result;
    };
    jsonObjects.sort(fn);
  },
  getUrlParam: function getUrlParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r !== null) {
      return decodeURI(r[2]);
    }
    return null;
  },
  getRootPath: function getRootPath() {
    return window.first.rootUrl();
  },

  validate: validate,
  verify: function verify(val, rules) {
    return this.validate(val, rules, true).isError;
  },
  log: function log(type, name, message, info) {
    if (typeof message !== 'string') {
      message = stringify_default()(message);
    }
    var data = {
      type: type || 'error',
      name: name || 'error',
      message: message,
      info: stringify_default()(info) || '',
      url: '',
      referenceUrl: '',
      clientDate: new Date().toISOString()
    };

    this.post(this.getRootPath() + 'PlaceOrder.aspx/AddErrorLog', data);
    return data;
  },
  uaEvent: function uaEvent(category, action, label) {
    window.dataLayer.push({
      'event': 'uaEvent',
      'uaEventCategory': category,
      'uaEventAction': action,
      'uaEventLabel': label
    });
  },
  uaEcommerce: function uaEcommerce(order, itemName, SKU) {
    var totalCharge = Math.round(order.TotalEstmCost * 100) / 100;
    var unitPrice = Math.round(totalCharge / order.TotalDesiredQty * 100000) / 100000;
    window.dataLayer.push({
      'event': 'uaEcommerce',
      'transactionId': order.OrderCode, // order.code
      'transactionAffiliation': 'SL360', // siteName
      'transactionTotal': totalCharge, // totalCharge
      'transactionTax': 0.00,
      'transactionShipping': order.ShippingCharge, // order.ShippingCharge
      'transactionProducts': [{
        'sku': SKU, // uc.success.FormatItemCode(order.ListType)
        'name': itemName, //  entity.lookup.DataSource.getByCode(order.ListType).DisplayName
        'category': 'Mailing Lists',
        'price': unitPrice, // unitPrice
        'quantity': order.TotalDesiredQty // Quantites
      }]
    });
  },
  loadCss: function loadCss(url, cb) {
    var link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = url;
    document.getElementsByTagName('head')[0].appendChild(link);
    if (typeof cb === 'function') {
      link.onload = function () {
        cb();
      };
    }
  },
  loadJs: function loadJs(url, cb) {
    var script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
    if (typeof cb === 'function') {
      script.onload = script.onreadystatechange = function () {
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
          cb();
          script.onload = script.onreadystatechange = null;
        }
      };
    }
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/lodash/findIndex.js
var findIndex = __webpack_require__("KgVm");
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);

// CONCATENATED MODULE: ./src/components/common/notification.js

 /**
                                            * Created by seaasun on 2018/2/9.
                                            */

/* harmony default export */ var notification = ({
  options: {
    duration: 5000,
    hasClose: true,
    onlyGroup: false
  },
  id: 1,
  templates: {
    networkError: {
      type: 'error',
      title: 'Error',
      msg: 'Network connect fail'
    }
  },
  notice: function notice(type, msg, options) {
    var _this = this;

    var item = {};
    if (this.templates.hasOwnProperty(type)) {
      item = assign_default()({}, this.templates[type]);
    } else {
      item.type = type;
    }
    item = assign_default()(item, this.options, options);
    item.msg = msg || item.msg;
    item.id = this.id;

    if (item.onlyGroup && findIndex_default()(this.news, function (val) {
      return val.onlyGroup === item.onlyGroup;
    }) > -1) {
      return false;
    }

    this.news.push(item);
    this.id += 1;
    // set delete
    var id = this.id;
    if (item.duration !== 0) {
      setTimeout(function () {
        _this.close(id);
      }, item.duration);
    }
    return id;
  },
  close: function close(id) {
    this.news.splice(findIndex_default()(this.news, function (item) {
      return item.id === id;
    }), 1);
  },
  clear: function clear() {
    this.news.splice(0);
  },

  news: []
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/MNotification.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MNotification = ({
  props: {},
  data: function data() {
    return {
      news: notification.news
    };
  },

  computed: {},
  methods: {
    classType: function classType(item) {
      var key = item.type || 'info';
      return defineProperty_default()({}, key, true);
    },
    close: function close(id) {
      this.news.splice(lodash_default.a.findIndex(this.news, function (item) {
        return item.id === id;
      }), 1);
    },
    doAction: function doAction(action, id) {
      if (action.hasOwnProperty('fun')) {
        action.fun();
      }
      if (action.close === true) {
        notification.close(id);
      }
    }
  },
  created: function created() {
    // notification.notice('info', 'It may take some time, please wait', {
    //   title: 'Counting',
    //   duration: 0,
    //   actions: [{
    //     text: 'close',
    //     close: true
    //   }]
    // })
    // TODO@PONY expample need to delete
    // this.$notice('networkError')
    // this.$notice('error', 'Network connection failed', {
    //   title: 'Error',
    //   duration: 0,
    //   hasClose: true,
    //   actions: [
    //     {
    //       text: 'refresh',
    //       fun () {
    //         alert('ok')
    //       }
    //     }
    //   ]
    // })
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42e99cb5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MNotification.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-box"},_vm._l((_vm.news),function(item){return _c('div',{staticClass:"notification-card",class:_vm.classType(item)},[(item.hasClose)?_c('span',{staticClass:"close-btn",on:{"click":function($event){return _vm.close(item.id)}}},[_c('icon',{attrs:{"name":"close"}})],1):_vm._e(),_vm._v(" "),_c('p',{staticClass:"card-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"card-p"},[_vm._v(_vm._s(item.msg))]),_vm._v(" "),_c('div',_vm._l((item.actions),function(action){return _c('b-link',{key:action.text,staticClass:"card-a",on:{"click":function($event){return _vm.doAction(action, item.id)}}},[_vm._v("\n        "+_vm._s(action.text)+"\n      ")])}),1)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_MNotification = (esExports);
// CONCATENATED MODULE: ./src/components/common/MNotification.vue
function injectStyle (ssrContext) {
  __webpack_require__("4EZE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42e99cb5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MNotification,
  common_MNotification,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_MNotification = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//




// import jsCookie from 'js-cookie'

/* harmony default export */ var App = ({
  name: 'app',
  components: {
    MNotification: components_common_MNotification
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    var _this = this;

    this.checkLogin();
    if (this.$route.query.ui) {
      this.$store.commit('config/saveKey', ['uiVersion', parseInt(this.$route.query.ui)]);
    }
    this.$root.$on('run', function () {
      _this.run();
    });
  },

  methods: {
    checkLogin: function checkLogin() {
      this.$store.commit('config/setRootUrl', utils.getRootPath());
      document.getElementById('loading-title').style.display = 'none';

      // User has logged in
      if (window.first.isLogin === 'ok') {
        this.run();
        this.$store.dispatch('user/getUserInit');
        this.$store.dispatch('user/getEditUserInfo');
      } else {
        utils.progressDone();
        this.$router.push({ name: 'signin' });
      }
    },
    run: function run() {
      this.getDatasource();
      this.$store.dispatch('site/init');
      this.$store.dispatch('geo/getStates');
    },

    // Using first datasouce
    getDatasource: function getDatasource() {
      var _this2 = this;

      if (window.first.datasourceStatus === 'loading') {
        setTimeout(this.getDatasource, 10);
        return false;
      } else if (window.first.datasourceStatus === 'unLoad') {
        window.first.getDataSource();
        setTimeout(this.getDatasource, 10);
        return false;
      }

      var data = window.first.datasource;
      var allowDatasources = [];
      data.forEach(function (item) {
        allowDatasources.push(item.ListType);
      });
      this.$store.commit('config/saveKey', ['allowDatasources', allowDatasources]);

      // check datasource route
      if (this.$route.path.split('/')[1] === 'order' && !this.$store.getters['config/checkDatasource'](this.$route.params.listType)) {
        this.$router.replace({ name: 'landing' });
        this.$notice('warning', 'No this datasource, please choose one');
      }

      // TODO@PONY need to optimal datasource
      data = lodash_default.a.map(data, function (item) {
        // TODO@PONY it's not good
        if (item.Desc === 'Occupant') {
          item.Desc = 'Saturation';
          item.Sequence = 1;
        }
        var datasource = _this2.$store.state.config.datasource[item.ListType.toString()];
        assign_default()(item, datasource);
        return item;
      });
      this.$store.commit('user/saveKey', ['userDataSources', data]);

      var serviceData = window.first.serviceDataSource;
      this.$store.commit('user/saveKey', ['userServiceDataSources', serviceData]);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ecc5049","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"m-fade","appear":""}},[_c('div',[_c('m-notification'),_vm._v(" "),_c('transition',{attrs:{"name":"m-fade"}},[_c('router-view')],1)],1)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("aPG7")
  __webpack_require__("c7fO")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = "data-v-6ecc5049"
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MModalPricing.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MModalPricing = ({
  data: function data() {
    return {
      price: {},
      dataSourcePrice: {},
      currentPrice: {},
      currentPriceCode: '',
      pageSize: 10,
      dataServices: {
        '-1': { code: -1, displayName: 'Clean a List' },
        '-2': { code: -2, displayName: 'Enhance a List' },
        '-6': { code: -6, displayName: 'Enhance Bundle' },
        '-4': { code: -4, displayName: 'Email Append' },
        '-5': { code: -5, displayName: 'Email Verification' },
        '-3': { code: -3, displayName: 'Portrait Reports services' },
        '-7': { code: -7, displayName: 'Phone Append' },
        '-8': { code: -8, displayName: 'Phone Append Confirmation' },
        '-9': { code: -9, displayName: 'Reverse Phone Append' }
      }
    };
  },

  computed: {
    datasources: function datasources() {
      return this.$store.state.config.datasource;
    },
    displayPrice: function displayPrice() {
      return this.$store.state.config.allowPriceListHelp;
    }
  },
  created: function created() {},

  methods: {
    checkPrice: function checkPrice(code) {
      return this.displayPrice.find(function (val) {
        return val === code;
      });
    },
    resize: function resize() {
      this.currentPrice = {};
      this.currentPriceCode = '';
      this.pageSize = 10;
    },
    init: function init() {
      var _this = this;

      this.$http.post('faq/Faqs-Pricing.aspx/GetPricingDisplayData', {}, {
        progressBar: false,
        errorType: 'silent'
      }).then(function (resp) {
        _this.$store.commit('config/saveKey', ['allowPriceListHelp', resp.body.d.DataSource.DisplayData]);
      });
    },
    viewMore: function viewMore() {
      this.pageSize += 20;
    },
    getPriceByDataSource: function getPriceByDataSource(code) {
      var _this2 = this;

      if (this.currentPriceCode === code) {
        this.currentPriceCode = '';
        return;
      }
      this.resize();
      this.currentPriceCode = code;
      this.$http.post('faq/Faqs-Pricing.aspx/GetPriceByDataSource', {
        listType: code
      }).then(function (resp) {
        _this2.currentPrice = resp.body.d.DataSource;
      });
    },
    getPriceByService: function getPriceByService(code) {
      var _this3 = this;

      if (this.currentPriceCode === code) {
        this.currentPriceCode = '';
        return;
      }
      this.resize();
      this.currentPriceCode = code;

      this.$http.post('faq/Faqs-Pricing.aspx/GetMAPrice', {
        listType: [code]
      }).then(function (resp) {
        _this3.currentPrice = resp.body.d.DataSource[0];
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e3c280","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MModalPricing.vue
var MModalPricing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modalPricing","size":"lg","hide-footer":true,"lazy":true,"title":"Service Pricing"},on:{"hide":_vm.resize,"show":_vm.init}},[_c('p',[_vm._v("Choose any service below to view your costs for that service. If you have any questions, please contact us at 800.399.8611.\n  ")]),_vm._v(" "),_c('h2',[_vm._v("List")]),_vm._v(" "),_c('m-loader',{attrs:{"show":_vm.displayPrice.length === 0,"size":"smBox"}}),_vm._v(" "),_c('div',{staticClass:"list-group"},_vm._l((_vm.datasources),function(datasource){return (_vm.checkPrice(datasource.code))?_c('div',{staticClass:"list-group-item"},[_c('div',{staticClass:"list-group-item-title",class:{'list-group-item-active': _vm.currentPriceCode === datasource.code},on:{"click":function($event){return _vm.getPriceByDataSource(datasource.code)}}},[_vm._v("\n        "+_vm._s(datasource.title)+"\n      ")]),_vm._v(" "),(_vm.currentPriceCode === datasource.code)?_c('div',{staticClass:"table-box"},[_c('m-loader',{attrs:{"show":!_vm.currentPrice.priceListDetail,"size":"smBox"}}),_vm._v(" "),(_vm.currentPrice.priceListDetail)?_c('div',[_c('table',{staticClass:"table b-table table-striped table-hover"},[_c('tr',[_c('td',{staticClass:"th-title"},[_vm._v("Price Attribute")]),_vm._v(" "),_c('td',{staticClass:"th-title"},[_vm._v("Price per Record\n              ")])]),_vm._v(" "),_vm._l((_vm.currentPrice.priceListDetail.slice(1, _vm.pageSize)),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.Price_Attribute))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("numberFormat")(item.Range1_Price,'$', 4)))])])})],2),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPrice.priceListDetail.length > _vm.pageSize),expression:"currentPrice.priceListDetail.length > pageSize"}],staticClass:"view-more",on:{"click":_vm.viewMore}},[_vm._v("View More")]),_vm._v(" "),_c('p',{staticClass:"min-box"},[_vm._v("\n            Your cost per name is the sum of the base record plus any filters/attributes you use to build the list or choose to include in its output."),_c('br'),_vm._v("\n            "+_vm._s(_vm._f("numberFormat")(_vm.currentPrice.minPrice,'$', 4))+"  minimum online order"),_c('br'),_vm._v(" "),_vm._l((_vm.currentPrice.ListMultiplePrice),function(listPrice){return (listPrice.MultipleId > 1)?_c('span',[_vm._v("\n              "+_vm._s(listPrice.Desc)+" use pricing is "+_vm._s(listPrice.Multiple)+"x single use pricing "),_c('br')]):_vm._e()})],2)]):_vm._e()],1):_vm._e()]):_vm._e()}),0),_vm._v(" "),_c('h2',{staticClass:"item-title"},[_vm._v("Data Services")]),_vm._v(" "),_c('m-loader',{attrs:{"show":_vm.displayPrice.length === 0,"size":"smBox"}}),_vm._v(" "),_c('div',{staticClass:"list-group"},_vm._l((_vm.dataServices),function(dataService){return (_vm.checkPrice(dataService.code))?_c('div',{staticClass:"list-group-item"},[_c('div',{staticClass:"list-group-item-title",class:{'list-group-item-active': _vm.currentPriceCode === dataService.code},on:{"click":function($event){return _vm.getPriceByService(dataService.code)}}},[_vm._v("\n        "+_vm._s(dataService.displayName))]),_vm._v(" "),(_vm.currentPriceCode === dataService.code )?_c('div',{staticClass:"table-box"},[_c('m-loader',{attrs:{"show":!_vm.currentPrice.MAUserPrice,"size":"smBox"}}),_vm._v(" "),(_vm.currentPrice.MAUserPrice)?_c('div',[_c('table',{staticClass:"table b-table table-striped table-hover"},[_c('tr',[_c('td',{staticClass:"th-title"},[_vm._v("Price Attribute")]),_vm._v(" "),_vm._l((_vm.currentPrice.MAUserPrice.BoundNames),function(item){return _c('td',{staticClass:"th-title"},[_vm._v("\n                "+_vm._s(item)+"\n              ")])})],2),_vm._v(" "),_vm._l((_vm.currentPrice.MAUserPrice.ElementPrice.slice(0, _vm.pageSize)),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.PriceDesc))]),_vm._v(" "),_vm._l((item.MAPrice),function(bound){return _c('td',[_vm._v(_vm._s(_vm._f("numberFormat")(bound.Price1,'$', 4)))])})],2)})],2),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPrice.MAUserPrice.ElementPrice.length > _vm.pageSize),expression:"currentPrice.MAUserPrice.ElementPrice.length > pageSize"}],staticClass:"view-more",on:{"click":_vm.viewMore}},[_vm._v("View More")]),_vm._v(" "),_c('p',{staticClass:"min-box"},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.currentPrice.MAMinOrderMount.Price1,'$', 4))+"  minimum online order"),_c('br')])]):_vm._e()],1):_vm._e()]):_vm._e()}),0)],1)}
var MModalPricing_staticRenderFns = []
var MModalPricing_esExports = { render: MModalPricing_render, staticRenderFns: MModalPricing_staticRenderFns }
/* harmony default export */ var landings_MModalPricing = (MModalPricing_esExports);
// CONCATENATED MODULE: ./src/components/landings/MModalPricing.vue
function MModalPricing_injectStyle (ssrContext) {
  __webpack_require__("BMOd")
}
var MModalPricing_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MModalPricing___vue_template_functional__ = false
/* styles */
var MModalPricing___vue_styles__ = MModalPricing_injectStyle
/* scopeId */
var MModalPricing___vue_scopeId__ = "data-v-36e3c280"
/* moduleIdentifier (server only) */
var MModalPricing___vue_module_identifier__ = null
var MModalPricing_Component = MModalPricing_normalizeComponent(
  MModalPricing,
  landings_MModalPricing,
  MModalPricing___vue_template_functional__,
  MModalPricing___vue_styles__,
  MModalPricing___vue_scopeId__,
  MModalPricing___vue_module_identifier__
)

/* harmony default export */ var components_landings_MModalPricing = (MModalPricing_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MUploadImg.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MUploadImg = ({
  props: ['imgSrc'],
  data: function data() {
    return {
      file: null,
      states: this.$store.state.user,
      img: null
    };
  },
  created: function created() {
    this.img = this.imgSrc;
  },

  watch: {
    imgSrc: function imgSrc(val) {
      this.img = val;
    }
  },
  methods: {
    upload: function upload() {
      var that = this;
      var inputDom = this.$refs.inputDom;
      this.file = inputDom.files[0];
      var reader = new FileReader();

      if (this.file.size > 2097152) {
        // toast({'title': 'UpLoad avatar Failed',
        //   'msg': 'The maximum size of the picture is 2M'})
        return false;
      }

      reader.readAsDataURL(this.file);
      reader.onloadend = function () {
        that.img = this.result;
        that.uploadSubmti(that.img);
        that.$store.commit('site/saveKey', ['UserImg', that.img]);
      };
    },
    uploadSubmti: function uploadSubmti(img) {
      this.$http.post('landingPage.aspx/UploadImg', {
        img: img,
        userId: this.states.userInfo.Userid
      }).then(function (resp) {
        if (resp.body.d.ResultFlag) {
          // toast({'title': 'Save Profile Settings Successed',
          //   'type': 'success'})
        } else {
            // toast({'title': 'Save Profile Settings Failed',
            //   'msg': 'Please try again, or cantact us'})
          }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c82c33","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MUploadImg.vue
var MUploadImg_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-upload-img"},[_c('input',{ref:"inputDom",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.upload}}),_vm._v(" "),_c('p',[_vm._v(" Upload Photo")]),_vm._v(" "),_c('img',{staticClass:"user xx-large",attrs:{"src":_vm.img}})])])}
var MUploadImg_staticRenderFns = []
var MUploadImg_esExports = { render: MUploadImg_render, staticRenderFns: MUploadImg_staticRenderFns }
/* harmony default export */ var landings_MUploadImg = (MUploadImg_esExports);
// CONCATENATED MODULE: ./src/components/landings/MUploadImg.vue
function MUploadImg_injectStyle (ssrContext) {
  __webpack_require__("1XQ7")
}
var MUploadImg_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MUploadImg___vue_template_functional__ = false
/* styles */
var MUploadImg___vue_styles__ = MUploadImg_injectStyle
/* scopeId */
var MUploadImg___vue_scopeId__ = "data-v-23c82c33"
/* moduleIdentifier (server only) */
var MUploadImg___vue_module_identifier__ = null
var MUploadImg_Component = MUploadImg_normalizeComponent(
  MUploadImg,
  landings_MUploadImg,
  MUploadImg___vue_template_functional__,
  MUploadImg___vue_styles__,
  MUploadImg___vue_scopeId__,
  MUploadImg___vue_module_identifier__
)

/* harmony default export */ var components_landings_MUploadImg = (MUploadImg_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MModalSetting.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MModalSetting = ({
  components: {
    MUploadImg: components_landings_MUploadImg
  },
  data: function data() {
    return {
      states: this.$store.state.user,
      selected: 'overView',
      payment: {},
      oldPassword: '',
      newPassword: '',
      reNewPassword: '',
      checkedPassword: '',
      alertDesc: '',
      saveDisabled: false,
      passwordValid: {
        oldPassword: {
          state: null,
          text: ''
        },
        newPassword: {
          state: null,
          text: ''
        },
        reNewPassword: {
          state: null,
          text: ''
        }
      },
      userValid: {
        address: {
          state: null,
          text: ''
        },
        company: {
          state: null,
          text: ''
        },
        city: {
          state: null,
          text: ''
        },
        state: {
          state: null,
          text: ''
        },
        zip: {
          state: null,
          text: ''
        },
        password: {
          state: null,
          text: ''
        }
      },
      userPaymentCardValid: {
        HolderName: {
          state: null,
          text: ''
        },
        CardNumber: {
          state: null,
          text: ''
        },
        CardType: {
          state: null,
          text: ''
        },
        CVV: {
          state: null,
          text: ''
        },
        ExpirationMonth: {
          state: null,
          text: ''
        },
        ExpirationYear: {
          state: null,
          text: ''
        },
        Address: {
          state: null,
          text: ''
        },
        City: {
          state: null,
          text: ''
        },
        State: {
          state: null,
          text: ''
        },
        ZipCode: {
          state: null,
          text: ''
        },
        CompanyName: {
          state: null,
          text: ''
        }
      }
    };
  },

  computed: {
    userAddress: function userAddress() {
      return this.$store.state.user.userAddress;
    },
    userPaymantCard: function userPaymantCard() {
      return this.$store.state.user.userPaymentCard;
    },
    expiredYear: function expiredYear() {
      var result = [];
      var now = new Date();
      var year = now.getFullYear();
      for (var i = 0; i <= 6; i++) {
        result.push(year + i);
      }
      return result;
    },
    expiredMonth: function expiredMonth() {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    }
  },
  methods: {
    show: function show() {
      // this.$store.dispatch('user/getEditUserInfo')
      this.$store.dispatch('user/getUserPaymentCard');
      if (this.$store.state.site.UserImg) {
        this.states.userAvatar = this.$store.state.site.UserImg;
      }
    },
    selectMenu: function selectMenu(val) {
      this.selected = val;
    },
    close: function close() {
      this.$refs.modelSetting.hide();
    },
    validSetting: function validSetting() {
      var isValid = true;
      if (!this.userAddress.AddressLine) {
        this.userValid.address.state = false;
        this.userValid.address.text = "It's required";
        isValid = false;
      }
      if (!this.states.userInfo.Company) {
        this.userValid.company.state = false;
        this.userValid.company.text = "It's required";
        isValid = false;
      }
      if (!this.userAddress.CityName) {
        this.userValid.city.state = false;
        this.userValid.city.text = "It's required";
        isValid = false;
      }
      if (!this.userAddress.StateCode) {
        this.userValid.state.state = false;
        this.userValid.state.text = "It's required";
        isValid = false;
      }
      if (!this.userAddress.ZipCode && this.userAddress.ZipCode.lenght !== 5) {
        this.userValid.zip.state = false;
        this.userValid.zip.text = "It's required";
        isValid = false;
      }
      if (!this.checkedPassword) {
        this.userValid.password.state = false;
        this.userValid.password.text = "It's required";
        isValid = false;
      }

      return isValid;
    },
    validPaymentCard: function validPaymentCard() {
      var isValid = true;
      if (!this.userPaymantCard.HolderName) {
        this.userPaymentCardValid.HolderName.state = false;
        this.userPaymentCardValid.HolderName.text = "It's required";
        isValid = false;
      }
      if (!this.userPaymantCard.CardNumber) {
        this.userPaymentCardValid.CardNumber.state = false;
        this.userPaymentCardValid.CardNumber.text = "It's required";
        isValid = false;
      }
      if (!this.userPaymantCard.CVV) {
        this.userPaymentCardValid.CVV.state = false;
        this.userPaymentCardValid.CVV.text = "It's required";
        isValid = false;
      }
      if (!this.userPaymantCard.State) {
        this.userPaymentCardValid.State.state = false;
        this.userPaymentCardValid.State.text = "It's required";
        isValid = false;
      }
      if (!this.userPaymantCard.ZipCode && this.userAddress.ZipCode.lenght !== 5) {
        this.userPaymentCardValid.ZipCode.state = false;
        this.userPaymentCardValid.ZipCode.text = "It's required";
        isValid = false;
      }
      if (!this.userPaymantCard.ExpirationYear) {
        this.userPaymentCardValid.ExpirationYear.state = false;
        this.userPaymentCardValid.ExpirationYear.text = "It's required";
        isValid = false;
      }
      if (!this.userPaymantCard.ExpirationMonth) {
        this.userPaymentCardValid.ExpirationMonth.state = false;
        this.userPaymentCardValid.ExpirationMonth.text = "It's required";
        isValid = false;
      }
      if (!this.userPaymantCard.City) {
        this.userPaymentCardValid.City.state = false;
        this.userPaymentCardValid.City.text = "It's required";
        isValid = false;
      }
      if (!this.userPaymantCard.Address) {
        this.userPaymentCardValid.Address.state = false;
        this.userPaymentCardValid.Address.text = "It's required";
        isValid = false;
      }
      return isValid;
    },
    saveUserPaymentCard: function saveUserPaymentCard() {
      var _this = this;

      this.clearValid(this.userPaymentCardValid);
      if (!this.validPaymentCard()) {
        return false;
      }
      this.alertDesc = '';
      this.saveDisabled = true;
      this.$http.post('PlaceOrder.aspx/InsertOrUpdateUserPaymentCards', {
        cards: this.states.userPaymentCard
      }).then(function (resp) {
        if (resp.body.d.ResultFlag) {
          _this.saveDisabled = false;
          notification.notice('success', 'Save payment information successfully');
        }
      }, function (resp) {
        notification.notice('error', 'Failed to save payment information , please try again');
        _this.alertDesc = '';
        _this.saveDisabled = false;
      });
    },
    parseDate: function parseDate(item) {},
    saveSetting: function saveSetting() {
      var _this2 = this;

      this.saveDisabled = true;
      this.$http.post('ba/EditProfile.aspx/UpdateUser', {
        user: this.states.userInfo,
        userGuid: this.states.userInfo.UserGuid
      }).then(function (resp) {
        _this2.saveDisabled = false;
        _this2.checkedPassword = '';
        notification.notice('success', 'Save user information successfully');
        if (!_this2.states.userHasAddress) {
          _this2.states.userHasAddress = true;
        }
      }, function (resp) {
        _this2.saveDisabled = false;
        notification.notice('error', 'Failed to save user information , please try again');
      });
    },

    checkPasswordBeforeSave: function checkPasswordBeforeSave() {
      var _this3 = this;

      this.clearValid(this.userValid);
      if (!this.validSetting()) {
        return false;
      }
      this.saveDisabled = true;
      this.$http.post('ba/EditProfile.aspx/CheckPassword', {
        'oldPwd': this.checkedPassword
      }).then(function (resp) {
        _this3.saveSetting();
      }, function (resp) {
        _this3.saveDisabled = false;
        _this3.userValid.password.state = false;
        _this3.userValid.password.text = 'Wrong password.';
      });
    },
    savePassword: function savePassword() {
      var _this4 = this;

      this.clearValid(this.passwordValid);
      var isValid = true;
      this.passwordValid.newPassword.text = '';

      if (this.newPassword.length < 10) {
        this.passwordValid.newPassword.state = false;
        this.passwordValid.newPassword.text = 'least 8  characters; ';
        isValid = false;
      }
      if (!/\d/gi.test(this.newPassword)) {
        this.passwordValid.newPassword.state = false;
        this.passwordValid.newPassword.text += 'at least one number; ';
        isValid = false;
      }
      if (!/(?=.*[A-Z])/.test(this.newPassword)) {
        this.passwordValid.newPassword.state = false;
        this.passwordValid.newPassword.text += 'at least one uppercase letter; ';
        isValid = false;
      }
      if (!/(?=.*[a-z])/.test(this.newPassword)) {
        this.passwordValid.newPassword.state = false;
        this.passwordValid.newPassword.text += 'at least one lowercase letter; ';
        isValid = false;
      }
      if (this.newPassword !== this.reNewPassword) {
        this.passwordValid.reNewPassword.state = false;
        this.passwordValid.reNewPassword.text = 'The new passwords you\'ve entered do not match. Please re-enter.';
        isValid = false;
      }
      if (!this.oldPassword) {
        this.passwordValid.oldPassword.state = false;
        this.passwordValid.oldPassword.text = 'Please enter passwords';
        isValid = false;
      }
      if (!isValid) {
        return false;
      }
      this.saveDisabled = true;

      this.$http.post('ba/EditProfile.aspx/CheckPassword', {
        oldPwd: this.oldPassword
      }).then(function (resp) {
        _this4.saveDisabled = false;
        _this4.savePasswordSubmit();
      }, function (resp) {
        _this4.saveDisabled = false;
        _this4.passwordValid.oldPassword.state = false;
        _this4.passwordValid.oldPassword.text = 'The old password is invalid.';
      });
    },
    savePasswordSubmit: function savePasswordSubmit() {
      var _this5 = this;

      this.$http.post('ba/EditProfile.aspx/UpdatePassword', {
        newPwd: this.newPassword,
        userGuid: this.states.userInfo.UserGuid
      }).then(function (resp) {
        _this5.saveDisabled = false;
        if (resp.body.d.DataSource) {
          _this5.newPassword = '';
          _this5.oldPassword = '';
          _this5.reNewPassword = '';
          notification.notice('success', 'Update password successfully');
        } else {
          notification.notice('error', 'Failed to save update password, please try again');
        }
      }, function (resp) {
        _this5.saveDisabled = false;
        notification.notice('error', 'Failed to save update password, please try again');
      });
    },
    clearValid: function clearValid(items) {
      for (var key in items) {
        items[key].state = null;
        items[key].text = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dee1aa42","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MModalSetting.vue
var MModalSetting_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modelSetting",attrs:{"id":"modelSetting","size":"lg","hide-footer":true,"hide-header":true,"no-close-on-backdrop":!_vm.states.userHasAddress},on:{"show":_vm.show}},[_c('span',{staticClass:"close-icon",on:{"click":function($event){return _vm.close()}}},[_c('icon',{attrs:{"name":"close"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"setting-head",attrs:{"cols":"3"}},[_c('div',{staticClass:"upload"},[_c('m-upload-img',{attrs:{"img-src":_vm.states.userAvatar}})],1),_vm._v(" "),_c('p',{staticClass:"setting-head-title"},[_vm._v("Account Settings")]),_vm._v(" "),_c('div',{staticClass:"setting-menu",class:{'setting-menu-active': _vm.selected === 'overView'},on:{"click":function($event){return _vm.selectMenu('overView')}}},[_vm._v("\n        Overview\n      ")]),_vm._v(" "),(_vm.states.userHasAddress)?_c('div',{staticClass:"setting-menu",class:{'setting-menu-active': _vm.selected === 'changePassword'},on:{"click":function($event){return _vm.selectMenu('changePassword')}}},[_vm._v("\n        Change Password")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"setting-menu",class:{'setting-menu-active': _vm.selected === 'payments'},on:{"click":function($event){return _vm.selectMenu('payments')}}},[_vm._v("\n        Payment Info\n      ")])]),_vm._v(" "),_c('b-col',{staticClass:"bcol",attrs:{"cols":"9"}},[_c('b-alert',{attrs:{"show":!_vm.states.userHasAddress && !_vm.states.initUserInfo}},[_vm._v("\n        For the first time, Please fill your information\n      ")]),_vm._v(" "),(_vm.selected === 'overView')?_c('div',[_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("First Name :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"text","size":"sm","disabled":""},model:{value:(_vm.states.userInfo.FirstName),callback:function ($$v) {_vm.$set(_vm.states.userInfo, "FirstName", $$v)},expression:"states.userInfo.FirstName"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Last Name :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"text","size":"sm","disabled":""},model:{value:(_vm.states.userInfo.LastName),callback:function ($$v) {_vm.$set(_vm.states.userInfo, "LastName", $$v)},expression:"states.userInfo.LastName"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Email :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"text","size":"sm","disabled":""},model:{value:(_vm.states.userInfo.Email),callback:function ($$v) {_vm.$set(_vm.states.userInfo, "Email", $$v)},expression:"states.userInfo.Email"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Address* :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"text","size":"sm","state":_vm.userValid.address.state},model:{value:(_vm.userAddress.AddressLine),callback:function ($$v) {_vm.$set(_vm.userAddress, "AddressLine", $$v)},expression:"userAddress.AddressLine"}}),_vm._v(" "),(_vm.userValid.address.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userValid.address.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Company* :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"text","size":"sm","state":_vm.userValid.company.state},model:{value:(_vm.states.userInfo.Company),callback:function ($$v) {_vm.$set(_vm.states.userInfo, "Company", $$v)},expression:"states.userInfo.Company"}}),_vm._v(" "),(_vm.userValid.company.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userValid.company.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("City* :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"text","size":"sm","state":_vm.userValid.city.state},model:{value:(_vm.userAddress.CityName),callback:function ($$v) {_vm.$set(_vm.userAddress, "CityName", $$v)},expression:"userAddress.CityName"}}),_vm._v(" "),(_vm.userValid.city.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userValid.city.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("State* :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-select',{attrs:{"state":_vm.userValid.state.state},model:{value:(_vm.userAddress.StateCode),callback:function ($$v) {_vm.$set(_vm.userAddress, "StateCode", $$v)},expression:"userAddress.StateCode"}},_vm._l((_vm.$store.state.geo.states),function(item){return _c('option',{domProps:{"value":item.code}},[_vm._v("\n                "+_vm._s(item.name)+"\n              ")])}),0),_vm._v(" "),(_vm.userPaymentCardValid.State.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userPaymentCardValid.State.text))]):_vm._e(),_vm._v(" "),(_vm.userValid.state.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userValid.state.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("ZIP Code* :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"text","size":"sm","state":_vm.userValid.zip.state},model:{value:(_vm.userAddress.ZipCode),callback:function ($$v) {_vm.$set(_vm.userAddress, "ZipCode", $$v)},expression:"userAddress.ZipCode"}}),_vm._v(" "),(_vm.userValid.zip.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userValid.zip.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Phone :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"text","size":"sm"},model:{value:(_vm.states.userInfo.HomePhone),callback:function ($$v) {_vm.$set(_vm.states.userInfo, "HomePhone", $$v)},expression:"states.userInfo.HomePhone"}})],1)],1),_vm._v(" "),(_vm.states.userHasAddress)?_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Password* :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"password","size":"sm","state":_vm.userValid.password.state},model:{value:(_vm.checkedPassword),callback:function ($$v) {_vm.checkedPassword=$$v},expression:"checkedPassword"}}),_vm._v(" "),(_vm.userValid.password.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userValid.password.text)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.states.userHasAddress)?_c('span',[_vm._v("Please enter your old password to confirm any changes")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"setting-item-notice"},[_vm._v("* Required")]),_vm._v(" "),_c('b-row',{staticClass:"setting-btn justify-content-center"},[_c('b-btn',{attrs:{"disabled":_vm.saveDisabled},on:{"click":function($event){return _vm.checkPasswordBeforeSave()}}},[_vm._v("Save Profile Settings")])],1)],1):_vm._e(),_vm._v(" "),(_vm.selected === 'changePassword')?_c('div',[_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("New Password :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"password","size":"sm","state":_vm.passwordValid.newPassword.state},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}}),_vm._v(" "),(_vm.passwordValid.newPassword.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.passwordValid.newPassword.text))]):_vm._e(),_vm._v(" "),(_vm.newPassword === '')?_c('span',[_vm._v("More than 8 characters, at least one number, at least one uppercase letter")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Re-enter New Password :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"password","size":"sm","state":_vm.passwordValid.reNewPassword.state},model:{value:(_vm.reNewPassword),callback:function ($$v) {_vm.reNewPassword=$$v},expression:"reNewPassword"}}),_vm._v(" "),(_vm.passwordValid.reNewPassword.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.passwordValid.reNewPassword.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Old Password :")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-form-input',{attrs:{"type":"password","size":"sm","state":_vm.passwordValid.oldPassword.state},model:{value:(_vm.oldPassword),callback:function ($$v) {_vm.oldPassword=$$v},expression:"oldPassword"}}),_vm._v(" "),_c('span',[_vm._v("Please enter your current password to confirm any changes")]),_vm._v(" "),(_vm.passwordValid.oldPassword.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.passwordValid.oldPassword.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-btn justify-content-center"},[_c('b-btn',{attrs:{"disabled":_vm.saveDisabled},on:{"click":function($event){return _vm.savePassword()}}},[_vm._v("Save Profile Settings")])],1)],1):_vm._e(),_vm._v(" "),(_vm.selected === 'payments')?_c('div',[_c('h3',[_vm._v("Save a Credit Card")]),_vm._v(" "),_c('p',[_vm._v("Expedite the checkout process by securely saving your card here.")]),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"4"}},[_vm._v("Card Holder Name: ")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","state":_vm.userPaymentCardValid.HolderName.state},model:{value:(_vm.userPaymantCard.HolderName),callback:function ($$v) {_vm.$set(_vm.userPaymantCard, "HolderName", $$v)},expression:"userPaymantCard.HolderName"}}),_vm._v(" "),(_vm.userPaymentCardValid.HolderName.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userPaymentCardValid.HolderName.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Credit Card Number :")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","state":_vm.userPaymentCardValid.CardNumber.state},model:{value:(_vm.userPaymantCard.CardNumber),callback:function ($$v) {_vm.$set(_vm.userPaymantCard, "CardNumber", $$v)},expression:"userPaymantCard.CardNumber"}}),_vm._v(" "),(_vm.userPaymentCardValid.CardNumber.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userPaymentCardValid.CardNumber.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Card Type :")])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{model:{value:(_vm.userPaymantCard.CardType),callback:function ($$v) {_vm.$set(_vm.userPaymantCard, "CardType", $$v)},expression:"userPaymantCard.CardType"}},[_c('option',{attrs:{"value":"10","selected":"true"}},[_vm._v("VISA")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("MasterCard")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("American Express")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("Discover")])])],1),_vm._v(" "),_c('b-col',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"sm":"1"}},[_vm._v("\n            CVV\n          ")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"state":_vm.userPaymentCardValid.CVV.state},model:{value:(_vm.userPaymantCard.CVV),callback:function ($$v) {_vm.$set(_vm.userPaymantCard, "CVV", $$v)},expression:"userPaymantCard.CVV"}})],1),_vm._v(" "),(_vm.userPaymentCardValid.CVV.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userPaymentCardValid.CVV.text))]):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Expiration :")])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"options":_vm.expiredMonth},model:{value:(_vm.userPaymantCard.ExpirationMonth),callback:function ($$v) {_vm.$set(_vm.userPaymantCard, "ExpirationMonth", $$v)},expression:"userPaymantCard.ExpirationMonth"}}),_vm._v(" "),(_vm.userPaymentCardValid.ExpirationMonth.text)?_c('span',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.userPaymentCardValid.ExpirationMonth.text))]):_vm._e()],1),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"state":_vm.userPaymentCardValid.ExpirationYear.state,"options":_vm.expiredYear},model:{value:(_vm.userPaymantCard.ExpirationYear),callback:function ($$v) {_vm.$set(_vm.userPaymantCard, "ExpirationYear", $$v)},expression:"userPaymantCard.ExpirationYear"}}),_vm._v(" "),(_vm.userPaymentCardValid.ExpirationYear.text)?_c('span',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.userPaymentCardValid.ExpirationYear.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_vm._v(" ")])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h3',[_vm._v("Billling Information")])])],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Address :")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","size":"sm","state":_vm.userPaymentCardValid.Address.state},model:{value:(_vm.userPaymantCard.Address),callback:function ($$v) {_vm.$set(_vm.userPaymantCard, "Address", $$v)},expression:"userPaymantCard.Address"}}),_vm._v(" "),(_vm.userPaymentCardValid.Address.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userPaymentCardValid.Address.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("City :")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","size":"sm","state":_vm.userPaymentCardValid.City.state},model:{value:(_vm.userPaymantCard.City),callback:function ($$v) {_vm.$set(_vm.userPaymantCard, "City", $$v)},expression:"userPaymantCard.City"}}),_vm._v(" "),(_vm.userPaymentCardValid.City.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userPaymentCardValid.City.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("State :")])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"state":_vm.userPaymentCardValid.State.state},model:{value:(_vm.userPaymantCard.State),callback:function ($$v) {_vm.$set(_vm.userPaymantCard, "State", $$v)},expression:"userPaymantCard.State"}},_vm._l((_vm.$store.state.geo.states),function(item){return _c('option',{domProps:{"value":item.code}},[_vm._v("\n                "+_vm._s(item.name)+"\n              ")])}),0),_vm._v(" "),(_vm.userPaymentCardValid.State.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userPaymentCardValid.State.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("ZIP Code :")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","size":"sm","state":_vm.userPaymentCardValid.ZipCode.state},model:{value:(_vm.userPaymantCard.ZipCode),callback:function ($$v) {_vm.$set(_vm.userPaymantCard, "ZipCode", $$v)},expression:"userPaymantCard.ZipCode"}}),_vm._v(" "),(_vm.userPaymentCardValid.ZipCode.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userPaymentCardValid.ZipCode.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-item"},[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Company Name(optional) :")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"type":"text","size":"sm"},model:{value:(_vm.userPaymantCard.CompanyName),callback:function ($$v) {_vm.$set(_vm.userPaymantCard, "CompanyName", $$v)},expression:"userPaymantCard.CompanyName"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-alert',{staticClass:"the-box",attrs:{"show":_vm.alertDesc!=='',"variant":"success"}},[_vm._v(_vm._s(_vm.alertDesc))])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"setting-btn justify-content-center"},[_c('b-btn',{attrs:{"disabled":_vm.saveDisabled},on:{"click":_vm.saveUserPaymentCard}},[_vm._v("Save")])],1)],1):_vm._e()],1)],1)],1)}
var MModalSetting_staticRenderFns = []
var MModalSetting_esExports = { render: MModalSetting_render, staticRenderFns: MModalSetting_staticRenderFns }
/* harmony default export */ var landings_MModalSetting = (MModalSetting_esExports);
// CONCATENATED MODULE: ./src/components/landings/MModalSetting.vue
function MModalSetting_injectStyle (ssrContext) {
  __webpack_require__("5xTq")
  __webpack_require__("fHIT")
}
var MModalSetting_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MModalSetting___vue_template_functional__ = false
/* styles */
var MModalSetting___vue_styles__ = MModalSetting_injectStyle
/* scopeId */
var MModalSetting___vue_scopeId__ = "data-v-dee1aa42"
/* moduleIdentifier (server only) */
var MModalSetting___vue_module_identifier__ = null
var MModalSetting_Component = MModalSetting_normalizeComponent(
  MModalSetting,
  landings_MModalSetting,
  MModalSetting___vue_template_functional__,
  MModalSetting___vue_styles__,
  MModalSetting___vue_scopeId__,
  MModalSetting___vue_module_identifier__
)

/* harmony default export */ var components_landings_MModalSetting = (MModalSetting_Component.exports);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MContactUs.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MContactUs = ({
  data: function data() {
    return {
      info: {
        name: '',
        email: '',
        message: ''
      },
      btnDisable: false,
      infoValid: {
        name: {
          state: null,
          text: ''
        },
        email: {
          state: null,
          text: ''
        },
        message: {
          state: null,
          text: ''
        }
      },
      isShowSuccess: false
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.clearValid(this.infoValid);
      var that = this;
      if (this.validInfo()) {
        this.btnDisable = true;
        this.$http.post(this.$store.getters['config/link']('sendMessage'), {
          Action: 'save-contact-info',
          FormData: stringify_default()({
            FirstName: this.info.name,
            LastName: '',
            Company: '',
            Email: this.info.email,
            Phone: '',
            Comment: this.info.message,
            Page: 'SL360',
            PageInfo: 'SL360',
            FromSite: 'SL360',
            Source: '',
            fromsite: 'SL360'
          })
        }, {
          emulateJSON: true
        }).then(function (resp) {
          that.btnDisable = false;
          if (resp.body.Status === 1) {
            that.isShowSuccess = true;
          }
        }, function (resp) {
          notification.notice('error', 'Failed to sent contact information , please try again');
          _this.btnDisable = false;
        });
      }
    },
    validInfo: function validInfo() {
      var isValid = true;
      if (!this.info.name) {
        this.infoValid.name.state = false;
        this.infoValid.name.text = "It's required";
        isValid = false;
      }
      if (!(this.info.email.indexOf('@') > 0 && this.info.email.indexOf('@') < this.info.email.length - 1)) {
        this.infoValid.email.state = false;
        this.infoValid.email.text = 'E-mail must be valid';
        isValid = false;
      }
      if (!this.info.email) {
        this.infoValid.email.state = false;
        this.infoValid.email.text = "It's required";
        isValid = false;
      }
      if (!this.info.message) {
        this.infoValid.message.state = false;
        this.infoValid.message.text = "It's required";
        isValid = false;
      }
      return isValid;
    },
    clearValid: function clearValid(items) {
      for (var key in items) {
        items[key].state = null;
        items[key].text = false;
      }
    },
    load: function load() {
      this.name = this.$store.getters['user/userInfo'].Name;
      this.email = this.$store.getters['user/userInfo'].Email;
      this.isShowSuccess = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c905568","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MContactUs.vue
var MContactUs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modalContactUs","size":"lg","hide-footer":true,"title":"Contact Us"},on:{"show":_vm.load}},[_c('b-container',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShowSuccess),expression:"!isShowSuccess"}]},[_c('b-row',[_c('b-col',{staticClass:"colcenter"},[_c('h1',[_c('icon',{attrs:{"name":"commenting-o","width":"80px","height":"80px"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"colcenter"},[_c('h3',[_vm._v("Have any questions? Send us a message.")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-input',{attrs:{"placeholder":"Name *","state":this.infoValid.name.state},model:{value:(_vm.info.name),callback:function ($$v) {_vm.$set(_vm.info, "name", $$v)},expression:"info.name"}}),_vm._v(" "),(_vm.infoValid.name.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.name.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-input',{attrs:{"placeholder":"Email address *","state":this.infoValid.email.state,"type":"email"},model:{value:(_vm.info.email),callback:function ($$v) {_vm.$set(_vm.info, "email", $$v)},expression:"info.email"}}),_vm._v(" "),(_vm.infoValid.email.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.email.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-textarea',{attrs:{"rows":5,"state":this.infoValid.message.state,"placeholder":"Message *"},model:{value:(_vm.info.message),callback:function ($$v) {_vm.$set(_vm.info, "message", $$v)},expression:"info.message"}}),_vm._v(" "),(_vm.infoValid.message.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.message.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"colcenter"},[_c('b-btn',{attrs:{"disabled":_vm.btnDisable},on:{"click":_vm.submit}},[_vm._v("Send Message")])],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowSuccess),expression:"isShowSuccess"}],staticClass:"colcenter"},[_c('b-row',[_c('b-col',[_c('h1',[_c('icon',{attrs:{"name":"check","width":"80px","height":"80px"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Thanks for contacting us!")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h3',[_vm._v("We will get back to you very soon.")])])],1)],1)])],1)}
var MContactUs_staticRenderFns = []
var MContactUs_esExports = { render: MContactUs_render, staticRenderFns: MContactUs_staticRenderFns }
/* harmony default export */ var landings_MContactUs = (MContactUs_esExports);
// CONCATENATED MODULE: ./src/components/landings/MContactUs.vue
function MContactUs_injectStyle (ssrContext) {
  __webpack_require__("HQJ8")
}
var MContactUs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MContactUs___vue_template_functional__ = false
/* styles */
var MContactUs___vue_styles__ = MContactUs_injectStyle
/* scopeId */
var MContactUs___vue_scopeId__ = "data-v-1c905568"
/* moduleIdentifier (server only) */
var MContactUs___vue_module_identifier__ = null
var MContactUs_Component = MContactUs_normalizeComponent(
  MContactUs,
  landings_MContactUs,
  MContactUs___vue_template_functional__,
  MContactUs___vue_styles__,
  MContactUs___vue_scopeId__,
  MContactUs___vue_module_identifier__
)

/* harmony default export */ var components_landings_MContactUs = (MContactUs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MModalDigitalCampaigns.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MModalDigitalCampaigns = ({
  data: function data() {
    return {
      step: 'input',
      okTitle: 'Submit',
      prospectsTypeOther: '',
      other: false,
      order: {
        text: '',
        prospectsType: [],
        budget: '$2,500 - $4,999',
        startDate: 'ASAP',
        name: '',
        email: '',
        phone: ''
      },
      budgetOptions: [{ value: 'Less than $2,500', text: 'Less than $2,500' }, { value: '$2,500 - $4,999', text: '$2,500 - $4,999' }, { value: '$5,000 - $9,999', text: '$5,000 - $9,999' }, { value: '$10,000 - $19,999', text: '$10,000 - $19,999' }, { value: '$20,000 or more', text: '$20,000 or more' }],
      startDateOptions: [{ value: 'ASAP', text: 'ASAP' }, { value: '2-4 Weeks', text: '2-4 Weeks' }, { value: '4-8 Weeks', text: '4-8 Weeks' }, { value: 'More than 8 Weeks', text: 'More than 8 Weeks' }],
      alertDesc: '',
      textValid: {
        state: null,
        text: 'please enter'
      },
      nameValid: {
        state: null,
        text: ''
      },
      emailValid: {
        state: null,
        text: ''
      },
      phoneValid: {
        state: null,
        text: ''
      }
    };
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.getters['user/userInfo'];
    }
  },
  watch: {
    userInfo: function userInfo() {
      this.order.name = this.userInfo.Name;
      this.order.email = this.userInfo.Email;
      this.order.phone = this.userInfo.HomePhone;
    }
  },
  methods: {
    init: function init() {
      this.order.name = this.userInfo.Name;
      this.order.email = this.userInfo.Email;
      this.order.phone = this.userInfo.HomePhone;
      this.step = 'input';
      this.okTitle = 'Submit';
    },
    nameChange: function nameChange() {
      if (this.order.name.length > 0) {
        this.nameValid.state = true;
        this.nameValid.text = '';
      } else {
        this.nameValid.state = false;
        this.nameValid.text = 'Name is required';
      }
    },
    emailChange: function emailChange() {
      if (this.order.email.length > 0) {
        this.emailValid.state = true;
        this.emailValid.text = '';
      } else {
        this.emailValid.state = false;
        this.emailValid.text = 'Email is required or E-mail must be valid';
      }
    },
    phoneChange: function phoneChange() {
      if (this.order.phone.length > 0) {
        this.phoneValid.state = true;
        this.phoneValid.text = '';
      } else {
        this.phoneValid.state = false;
        this.phoneValid.text = 'Phone is required';
      }
    },
    textChange: function textChange() {
      if (this.order.text.length >= 10) {
        this.textValid.state = true;
        this.textValid.text = '';
      } else {
        this.textValid.state = false;
        this.textValid.text = 'Enter at least 10 characters';
      }
    },
    validData: function validData() {
      this.textChange();
      this.nameChange();
      this.emailChange();
      this.phoneChange();
      if (!this.textValid.state || !this.nameValid.state || !this.emailValid.state || !this.phoneValid.state) {
        return true;
      }
      return false;
    },
    submit: function submit(evt) {
      var _this = this;

      this.alertDesc = '';
      if (this.step === 'input') {
        evt.preventDefault();
      } else {
        return;
      }
      var isError = false;
      if (this.other[0] === 'Other' && this.prospectsTypeOther === '') {
        this.alertDesc = 'Please enter other text.';
        return;
      }
      if (this.validData()) {
        return;
      }
      if (this.order.prospectsType.length === 0) {
        this.alertDesc = 'Please select prospects';
        return;
      }
      var prospectString = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.order.prospectsType), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item === 'Other') {
            item = 'Other:' + this.prospectsTypeOther;
          }
          prospectString = prospectString + item + ',';
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      prospectString = prospectString.substring(0, prospectString.length - 1);
      if (!isError) {
        this.$http.post('PlaceOrder.aspx/AddMarketingEmail', {
          name: this.order.name,
          phone: this.order.phone,
          email: this.order.email,
          accomplish: this.order.text,
          prospects: prospectString,
          campaignBudget: this.order.budget,
          startDate: this.order.startDate
        }).then(function (resp) {
          _this.step = 'success';
          _this.okTitle = 'Close';
        }, function (resp) {});
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f882ad92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MModalDigitalCampaigns.vue
var MModalDigitalCampaigns_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modelDigitalCampaigns","size":"lg","title":"Full Service Digital Campaigns","ok-only":_vm.step==='success',"ok-title":_vm.okTitle,"lazy":""},on:{"ok":_vm.submit,"show":_vm.init}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step==='input'),expression:"step==='input'"}]},[_c('h4',{staticStyle:{"margin-bottom":"16px"}},[_vm._v("Complete the form below and one of our digital experts will reach out to you.")]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"What are you trying to accomplish? (Campaign goals/objectives)","invalid-feedback":_vm.textValid.text,"state":_vm.textValid.state}},[_c('b-form-textarea',{attrs:{"placeholder":"","rows":3,"state":_vm.textValid.state},on:{"input":function($event){return _vm.textChange()}},model:{value:(_vm.order.text),callback:function ($$v) {_vm.$set(_vm.order, "text", $$v)},expression:"order.text"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"How do you wish to reach new prospects? Check all that apply."}},[_c('b-form-checkbox-group',{attrs:{"stacked":""},model:{value:(_vm.order.prospectsType),callback:function ($$v) {_vm.$set(_vm.order, "prospectsType", $$v)},expression:"order.prospectsType"}},[_c('b-form-checkbox',{attrs:{"value":"Email"}},[_vm._v("Email")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"Mobile & Desktop Display banners"}},[_vm._v("Mobile & Desktop Display banners")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"Social Media Ads"}},[_vm._v("Social Media Ads")]),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"display":"inherit"},attrs:{"value":"Other"},model:{value:(_vm.other),callback:function ($$v) {_vm.other=$$v},expression:"other"}},[_vm._v("\n        Other "),_c('b-form-input',{attrs:{"type":"text","size":"sm"},model:{value:(_vm.prospectsTypeOther),callback:function ($$v) {_vm.prospectsTypeOther=$$v},expression:"prospectsTypeOther"}})],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Campaign Budget: (dropdown with these options)"}},[_c('b-form-select',{attrs:{"options":_vm.budgetOptions},model:{value:(_vm.order.budget),callback:function ($$v) {_vm.$set(_vm.order, "budget", $$v)},expression:"order.budget"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Desired Start Date: (dropdown with these options)"}},[_c('b-form-select',{attrs:{"options":_vm.startDateOptions},model:{value:(_vm.order.startDate),callback:function ($$v) {_vm.$set(_vm.order, "startDate", $$v)},expression:"order.startDate"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Name","invalid-feedback":_vm.nameValid.text,"state":_vm.nameValid.state}},[_c('b-form-input',{attrs:{"state":_vm.nameValid.state},on:{"input":_vm.nameChange},model:{value:(_vm.order.name),callback:function ($$v) {_vm.$set(_vm.order, "name", $$v)},expression:"order.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","invalid-feedback":_vm.emailValid.text,"state":_vm.emailValid.state}},[_c('b-form-input',{attrs:{"state":_vm.emailValid.state},on:{"input":_vm.emailChange},model:{value:(_vm.order.email),callback:function ($$v) {_vm.$set(_vm.order, "email", $$v)},expression:"order.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Phone","invalid-feedback":_vm.phoneValid.text,"state":_vm.phoneValid.state}},[_c('b-form-input',{attrs:{"state":_vm.phoneValid.state},on:{"input":_vm.phoneChange},model:{value:(_vm.order.phone),callback:function ($$v) {_vm.$set(_vm.order, "phone", $$v)},expression:"order.phone"}})],1),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.alertDesc!=='',"variant":"warning"}},[_vm._v(_vm._s(_vm.alertDesc))])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step !='input'),expression:"step !='input'"}]},[_c('H1',[_vm._v("Thank you!")]),_vm._v(" "),_c('p',[_vm._v("A member of our Digital Team will contact you within the next business day to discuss your campaign in more detail.\n    ")])],1)])}
var MModalDigitalCampaigns_staticRenderFns = []
var MModalDigitalCampaigns_esExports = { render: MModalDigitalCampaigns_render, staticRenderFns: MModalDigitalCampaigns_staticRenderFns }
/* harmony default export */ var landings_MModalDigitalCampaigns = (MModalDigitalCampaigns_esExports);
// CONCATENATED MODULE: ./src/components/landings/MModalDigitalCampaigns.vue
function MModalDigitalCampaigns_injectStyle (ssrContext) {
  __webpack_require__("2RqM")
}
var MModalDigitalCampaigns_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MModalDigitalCampaigns___vue_template_functional__ = false
/* styles */
var MModalDigitalCampaigns___vue_styles__ = MModalDigitalCampaigns_injectStyle
/* scopeId */
var MModalDigitalCampaigns___vue_scopeId__ = "data-v-f882ad92"
/* moduleIdentifier (server only) */
var MModalDigitalCampaigns___vue_module_identifier__ = null
var MModalDigitalCampaigns_Component = MModalDigitalCampaigns_normalizeComponent(
  MModalDigitalCampaigns,
  landings_MModalDigitalCampaigns,
  MModalDigitalCampaigns___vue_template_functional__,
  MModalDigitalCampaigns___vue_styles__,
  MModalDigitalCampaigns___vue_scopeId__,
  MModalDigitalCampaigns___vue_module_identifier__
)

/* harmony default export */ var components_landings_MModalDigitalCampaigns = (MModalDigitalCampaigns_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layouts/MNav.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MNav = ({
  props: {
    code: {
      type: String
    }
  },
  data: function data() {
    return {
      isShow: false
    };
  },
  created: function created() {
    var _this = this;

    this.$root.$on('openNav', function (code) {
      _this.isShow = code === _this.code;
    });
    this.$root.$on('closeAllNav', function () {
      _this.isShow = false;
    });
  },

  methods: {
    hide: function hide() {
      this.isShow = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a1c0628","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/MNav.vue
var MNav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"m-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"nav-background",on:{"click":_vm.hide}},[_c('div',{staticClass:"nav-box",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])])}
var MNav_staticRenderFns = []
var MNav_esExports = { render: MNav_render, staticRenderFns: MNav_staticRenderFns }
/* harmony default export */ var layouts_MNav = (MNav_esExports);
// CONCATENATED MODULE: ./src/components/layouts/MNav.vue
function MNav_injectStyle (ssrContext) {
  __webpack_require__("sxFT")
}
var MNav_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MNav___vue_template_functional__ = false
/* styles */
var MNav___vue_styles__ = MNav_injectStyle
/* scopeId */
var MNav___vue_scopeId__ = "data-v-2a1c0628"
/* moduleIdentifier (server only) */
var MNav___vue_module_identifier__ = null
var MNav_Component = MNav_normalizeComponent(
  MNav,
  layouts_MNav,
  MNav___vue_template_functional__,
  MNav___vue_styles__,
  MNav___vue_scopeId__,
  MNav___vue_module_identifier__
)

/* harmony default export */ var components_layouts_MNav = (MNav_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layouts/MHeader.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var MHeader = ({
  components: {
    MModalPricing: components_landings_MModalPricing,
    MModalSetting: components_landings_MModalSetting,
    MContactUs: components_landings_MContactUs,
    MModalDigitalCampaigns: components_landings_MModalDigitalCampaigns,
    MNav: components_layouts_MNav
  },
  computed: {
    username: function username() {
      return this.$store.state.site.User_FullName || 'welcome';
    },
    userimg: function userimg() {
      return this.$store.state.site.UserImg;
    },
    userDataSources: function userDataSources() {
      return this.$store.state.user.userDataSources;
    },
    userServiceDataSources: function userServiceDataSources() {
      return this.$store.state.user.userServiceDataSources;
    },
    topBtns: function topBtns() {
      var result = [];
      for (var i = 0; i < this.userDataSources.length; i++) {
        var item = this.userDataSources[i];
        if (item.ListType === 10 || item.ListType === 170) {
          result.push(item);
        }
      }
      return result;
    },
    normalBtns: function normalBtns() {
      var result = [];
      for (var i = 0; i < this.userDataSources.length; i++) {
        var item = this.userDataSources[i];
        if (item.ListType !== 10 && item.ListType !== 170) {
          result.push(item);
        }
      }
      return result;
    },
    menus: function menus() {
      var result = [{
        title: 'Append Demographics or Psychographics',
        benefit: 'Gives your customer database more segmentation capabilities and helps you better communicate with customers around their interests and life stage.',
        link: 'enhanceList',
        icon: 'share-alt',
        type: 'enhance',
        show: this.userServiceDataSources.showEnhanceList
      }, {
        title: 'Clean your Database',
        benefit: 'Save money avoiding duplicate and undeliverable mail, and marketing to only those qualified for your product or service.',
        link: 'cleanList',
        icon: 'eraser',
        type: 'clean',
        show: this.userServiceDataSources.showCleanList
      }, {
        title: 'Append Email Addresses',
        benefit: 'Adding email addresses to your database helps you communicate with customers through a new and low-cost channel.',
        link: 'emailAppend',
        icon: 'envelope-open-o',
        type: 'enhance',
        show: this.userServiceDataSources.showEmailAppend
      }, {
        title: 'Verify Email Addresses',
        benefit: 'Reduces undeliverable email which helps keep your sender reputation strong so ESPs continue delivering your email.',
        link: 'emailVerification',
        icon: 'envelope-o',
        type: 'clean',
        show: this.userServiceDataSources.showEmailVerification
      }, {
        title: 'Append Phone Numbers',
        benefit: 'Provides an additional and low cost channel to communicate with customers.',
        link: 'phoneAppend',
        icon: 'phone',
        type: 'enhance',
        show: this.userServiceDataSources.showPhoneAppend
      }, {
        title: 'Reverse Phone Append',
        benefit: 'Helps reveal who contacted you and enables you to reach them via direct mail.',
        link: 'phoneReverse',
        icon: 'phone',
        type: 'enhance',
        show: this.userServiceDataSources.showPhoneReverse
      }, {
        title: 'Reverse Email Append',
        benefit: 'Helps reveal who contacted you and enables you to reach them via direct mail.',
        link: 'reverseEmailAppend',
        icon: 'envelope-open-o',
        type: 'enhance',
        show: this.userServiceDataSources.showEmailReverse
      }, {
        title: 'Phone Confirmation & Append',
        benefit: 'Saves you time calling bad numbers and improves your connection rate with customers.',
        link: 'phoneVerification',
        icon: 'volume-control-phone',
        type: 'clean',
        show: this.userServiceDataSources.showPhoneVerification
      }];
      return result;
    },
    showHistoryMenu: function showHistoryMenu() {
      if (this.$store.state.user.ShowDigitalHistory && this.$store.state.user.ShowOrderHistory) {
        return true;
      } else {
        return false;
      }
    },
    showOrderHistoryMenu: function showOrderHistoryMenu() {
      if (!this.$store.state.user.ShowDigitalHistory && this.$store.state.user.ShowOrderHistory) {
        return true;
      } else {
        return false;
      }
    },
    showDigitalHistoryMenu: function showDigitalHistoryMenu() {
      if (this.$store.state.user.ShowDigitalHistory && !this.$store.state.user.ShowOrderHistory) {
        return true;
      } else {
        return false;
      }
    }
  },
  data: function data() {
    return {
      info: {
        name: '',
        email: '',
        message: ''
      },
      btnDisable: false,
      infoValid: {
        name: {
          state: null,
          text: ''
        },
        email: {
          state: null,
          text: ''
        },
        message: {
          state: null,
          text: ''
        }
      },
      isShowSuccess: false
    };
  },

  methods: {
    go: function go(listType) {
      this.$router.push({
        name: 'order',
        params: {
          listType: listType
        }
      });
      this.$root.$emit('closeAllNav');
    },
    goPage: function goPage(cb) {
      if (typeof cb === 'function') {
        cb();
      }
      this.$root.$emit('closeAllNav');
    },
    gotoDigitalReporting: function gotoDigitalReporting() {
      this.$router.push({
        name: 'DigitalReporting'
      });
    },
    showContactUs: function showContactUs() {
      this.$root.$emit('bv::show::modal', 'modalContactUs');
      this.$root.$emit('closeAllNav');
    },
    showContactUsFreeDiagnostic: function showContactUsFreeDiagnostic() {
      this.$root.$emit('bv::show::modal', 'modalContactUsFreeDiagnostic');
      this.$root.$emit('closeAllNav');
    },
    logOut: function logOut() {
      window.location = this.$store.getters['config/link']('logOut');
      js_cookie_default.a.remove('denglu');
    },
    submit: function submit() {
      var _this = this;

      this.clearValid(this.infoValid);
      var that = this;
      if (this.validInfo()) {
        this.btnDisable = true;
        this.$http.post(this.$store.getters['config/link']('sendMessage'), {
          Action: 'save-contact-info',
          FormData: stringify_default()({
            FirstName: this.info.name,
            LastName: '',
            Company: '',
            Email: this.info.email,
            Phone: '',
            Comment: this.info.message,
            Page: 'SL360',
            PageInfo: 'SL360',
            FromSite: 'SL360',
            Source: '',
            fromsite: 'SL360'
          })
        }, {
          emulateJSON: true
        }).then(function (resp) {
          that.btnDisable = false;
          if (resp.body.Status === 1) {
            notification.notice('success', 'Message successfully sent');
            _this.$root.$emit('closeAllNav');
          } else {
            notification.notice('error', 'Message failed to be sent');
          }
        }, function (resp) {
          _this.btnDisable = false;
        });
      }
    },
    validInfo: function validInfo() {
      var isValid = true;
      if (!this.info.name) {
        this.infoValid.name.state = false;
        this.infoValid.name.text = "It's required";
        isValid = false;
      }
      if (!(this.info.email.indexOf('@') > 0 && this.info.email.indexOf('@') < this.info.email.length - 1)) {
        this.infoValid.email.state = false;
        this.infoValid.email.text = 'E-mail must be valid';
        isValid = false;
      }
      if (!this.info.email) {
        this.infoValid.email.state = false;
        this.infoValid.email.text = "It's required";
        isValid = false;
      }
      if (!this.info.message) {
        this.infoValid.message.state = false;
        this.infoValid.message.text = "It's required";
        isValid = false;
      }
      return isValid;
    },
    clearValid: function clearValid(items) {
      for (var key in items) {
        items[key].state = null;
        items[key].text = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ab3f489","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/MHeader.vue
var MHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-modal-setting',{ref:"modalSetting"}),_vm._v(" "),_c('m-modal-pricing'),_vm._v(" "),_c('m-modal-digital-campaigns'),_vm._v(" "),_c('m-contact-us'),_vm._v(" "),_c('b-navbar',{staticClass:"navbar header-top-scrool",attrs:{"toggleable":"md"}},[_c('b-container',{staticClass:"m-layout-content",attrs:{"fluid":""}},[(this.$store.state.site.User_RoleName === 'Digital User')?_c('b-navbar-brand',{attrs:{"href":"#"}},[_c('b-link',{attrs:{"to":{name: 'DigitalReporting'}}},[_c('img',{staticClass:"img-logo",attrs:{"src":__webpack_require__("/dvw")}})])],1):_c('b-navbar-brand',{attrs:{"href":"#"}},[_c('b-link',{attrs:{"to":{name: 'landing'}}},[_c('img',{staticClass:"img-logo",attrs:{"src":__webpack_require__("/dvw")}})])],1),_vm._v(" "),_c('b-nav-toggle',{attrs:{"target":"nav_collapse","postion":"left","right":""}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('a',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'user', 'order history']),expression:"['header', 'user', 'order history']"}],staticClass:"nav-link nav-link-top",attrs:{"href":_vm.$store.getters['config/link']('history')}},[_vm._v("\n          Order History")]),_vm._v(" "),_c('a',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'user', 'SLC']),expression:"['header', 'user', 'SLC']"}],staticClass:"nav-link nav-link-top",attrs:{"href":_vm.$store.getters['config/link']('mysavecount'),"hidden":this.$store.state.site.User_RoleName === 'Digital User'}},[_vm._v("\n          Saved List Counts")]),_vm._v(" "),_c('a',{staticClass:"nav-link nav-link-top",attrs:{"hidden":this.$store.state.site.User_RoleName === 'Digital User'},on:{"click":function($event){return _vm.$root.$emit('openNav', 'reach')}}},[_vm._v("Choose Audience")]),_vm._v(" "),((_vm.userServiceDataSources.showEnhanceList||_vm.userServiceDataSources.showEmailAppend||_vm.userServiceDataSources.showPhoneAppend||_vm.userServiceDataSources.showPhoneReverse||_vm.userServiceDataSources.showEmailReverse||_vm.userServiceDataSources.showCleanList||_vm.userServiceDataSources.showEmailVerification||_vm.userServiceDataSources.showPhoneVerification))?_c('a',{staticClass:"nav-link nav-link-top",on:{"click":function($event){return _vm.$root.$emit('openNav', 'manage')}}},[_vm._v("Manage Customer Data")]):_vm._e(),_vm._v(" "),(_vm.userServiceDataSources.showPortraitReports)?_c('a',{staticClass:"nav-link nav-link-top",on:{"click":function($event){return _vm.$root.$emit('openNav', 'analyze')}}},[_vm._v("Analyze Customers")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"nav-link nav-link-top",on:{"click":function($event){return _vm.$root.$emit('openNav', 'contact')}}},[_vm._v("Contact Us")]),_vm._v(" "),_c('a',{staticClass:"nav-link nav-link-top",attrs:{"data-test":"headUserName"},on:{"click":function($event){return _vm.$root.$emit('openNav', 'user-name')}}},[_c('img',{staticClass:"user",attrs:{"src":_vm.userimg}}),_vm._v("\n          "+_vm._s(_vm.username))])])],1),_vm._v(" "),_c('m-nav',{attrs:{"code":"reach"}},[_c('div',{staticClass:"the-nav-box",attrs:{"data-test":"mailing-list"}},[_c('div',{staticClass:"nav-block"},[_c('p',{staticClass:"nav-title"},[_vm._v("Choose Your Audience")]),_vm._v(" "),_c('p',{staticClass:"nav-brief"},[_vm._v("Build, order and download in just minutes! Start by selecting the type of prospects you want to contact:")]),_vm._v(" "),_vm._l((_vm.topBtns),function(item,index){return _c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'datasource', item.Desc]),expression:"['header', 'datasource', item.Desc]"}],key:item.ListType,staticClass:"nav-link",attrs:{"data-test":'head1'+ index},on:{"click":function($event){return _vm.go(item.ListType)}}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":item.icon}}),_vm._v("\n              "+_vm._s(item.Desc))],1)}),_vm._v(" "),_vm._l((_vm.normalBtns),function(item,index){return _c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'datasource', item.Desc]),expression:"['header', 'datasource', item.Desc]"}],key:item.ListType,staticClass:"nav-link",attrs:{"data-test":'head1'+ (index + 2)},on:{"click":function($event){return _vm.go(item.ListType)}}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":item.icon}}),_vm._v("\n              "+_vm._s(item.Desc))],1)})],2),_vm._v(" "),_c('div',{staticClass:"nav-block"},[_c('p',{staticClass:"nav-title"},[_vm._v("Begin a Digital Campaign")]),_vm._v(" "),_c('p',{staticClass:"nav-brief"},[_vm._v("Tell us your goals and budget. Our experts will craft and manage a full-service campaign.")]),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'datasource', 'Email Marketing']),expression:"['header', 'datasource', 'Email Marketing']"}],staticClass:"nav-link",attrs:{"data-test":"head20"},on:{"click":function($event){_vm.goPage(function () {_vm.$root.$emit('bv::show::modal', 'modelDigitalCampaigns')})}}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"at"}}),_vm._v("\n              Email Marketing")],1),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'datasource', 'Display & Social Medial']),expression:"['header', 'datasource', 'Display & Social Medial']"}],staticClass:"nav-link",attrs:{"data-test":"head21"},on:{"click":function($event){_vm.goPage(function () {_vm.$root.$emit('bv::show::modal', 'modelDigitalCampaigns')})}}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"television"}}),_vm._v("\n              Display & Social Media")],1),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'datasource', 'Multi-channel Marketing']),expression:"['header', 'datasource', 'Multi-channel Marketing']"}],staticClass:"nav-link",attrs:{"data-test":"head22"},on:{"click":function($event){_vm.goPage(function () {_vm.$root.$emit('bv::show::modal', 'modelDigitalCampaigns')})}}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"share-alt"}}),_vm._v("\n              Multi-Channel Marketing")],1)],1)])]),_vm._v(" "),_c('m-nav',{attrs:{"code":"manage"}},[_c('div',{staticClass:"the-nav-box"},[_c('div',{staticClass:"nav-block"},[_c('p',{staticClass:"nav-title"},[_vm._v("Enhance Your Data")]),_vm._v(" "),_c('p',{staticClass:"nav-brief"},[_vm._v("Append data to your customer database so you may increase its segmentation capabilities, expand your communication reach, and more effectively communicate.")]),_vm._v(" "),_vm._l((_vm.menus),function(menu,index){return (menu.type === 'enhance' && menu.show)?_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'dataservice', menu.title]),expression:"['header', 'dataservice', menu.title]"}],key:menu.title,staticClass:"nav-link",attrs:{"data-test":'headenhance'+index,"href":_vm.$store.getters['config/link'](menu.link)}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":menu.icon}}),_vm._v("\n              "+_vm._s(menu.title))],1):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"nav-block"},[_c('p',{staticClass:"nav-title"},[_vm._v("Clean & Verify Your Data")]),_vm._v(" "),_c('p',{staticClass:"nav-brief"},[_vm._v("De-duplicate records, correct undeliverable addresses and screen for privacy... all to save time and money.")]),_vm._v(" "),_vm._l((_vm.menus),function(menu,index){return (menu.type === 'clean' && menu.show)?_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'dataservice', menu.title]),expression:"['header', 'dataservice', menu.title]"}],key:menu.title,staticClass:"nav-link",attrs:{"data-test":'headeclean'+index,"href":_vm.$store.getters['config/link'](menu.link)}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":menu.icon}}),_vm._v("\n              "+_vm._s(menu.title))],1):_vm._e()})],2)])]),_vm._v(" "),_c('m-nav',{attrs:{"code":"analyze"}},[_c('div',{staticClass:"the-nav-box"},[_c('div',{staticClass:"nav-block"},[_c('p',{staticClass:"nav-title"},[_vm._v("Analyze My Customers\n          ")]),_vm._v(" "),_c('p',{staticClass:"nav-brief"},[_vm._v("Order a report to gain insight into the demographic and psychographic characteristics of your customers so you may more effectively choose new prospects who are more likely to become customers.\n          ")]),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'dataservice', 'Analyze your customers']),expression:"['header', 'dataservice', 'Analyze your customers']"}],staticClass:"nav-link",attrs:{"href":_vm.$store.getters['config/link']('portaitreports'),"data-test":"customerPortraitReports"}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"file-text-o"}}),_vm._v("\n            Customer Portrait Reports\n          ")],1)],1),_vm._v(" "),_c('div',{staticClass:"nav-block"},[_c('p',{staticClass:"nav-title"},[_vm._v("View Sample Reports")]),_vm._v(" "),_c('b-link',{staticClass:"nav-link",attrs:{"data-test":"viewSampleReports1","href":_vm.$store.getters['config/link']('reportLookALike'),"target":"_blank"}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"file-text-o"}}),_vm._v("Preview a Look-Alike Report")],1),_vm._v(" "),_c('b-link',{staticClass:"nav-link",attrs:{"data-test":"viewSampleReports2","href":_vm.$store.getters['config/link']('reportEnhanceLookAlike'),"target":"_blank"}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"file-text-o"}}),_vm._v("Preview an Enhanced Look-Alike Report")],1),_vm._v(" "),_c('b-link',{staticClass:"nav-link",attrs:{"data-test":"viewSampleReports3","href":_vm.$store.getters['config/link']('reportPortrait'),"target":"_blank"}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"file-text-o"}}),_vm._v("Preview a PersonicX Portrait Report")],1),_vm._v(" "),_c('b-link',{staticClass:"nav-link",attrs:{"data-test":"viewSampleReports4","href":_vm.$store.getters['config/link']('reportPortraitRegional'),"target":"_blank"}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"file-text-o"}}),_vm._v("Preview a Data Portrait Analysis")],1)],1)])]),_vm._v(" "),_c('m-nav',{attrs:{"code":"contact"}},[_c('div',{staticClass:"the-nav-box"},[_c('div',{staticClass:"nav-block"},[_c('p',{staticClass:"nav-title"},[_vm._v("Contact Us\n          ")]),_vm._v(" "),_c('p',{staticClass:"nav-brief"},[_vm._v("We're available Monday through Friday, 9am to 5pm Eastern Time.\n          ")]),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'contactUs', 'message']),expression:"['header', 'contactUs', 'message']"}],staticClass:"nav-link",attrs:{"data-test":"contactus"},on:{"click":_vm.showContactUs}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"comments-o"}}),_vm._v("\n            Contact Us\n          ")],1),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'contactUs', 'phone']),expression:"['header', 'contactUs', 'phone']"}],staticClass:"nav-link",attrs:{"href":"tel://800-399-8611","data-test":"tel"}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"phone"}}),_vm._v("\n            800-399-8611\n          ")],1),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'contactUs', 'email']),expression:"['header', 'contactUs', 'email']"}],staticClass:"nav-link",attrs:{"href":"mailto:support@sl360.com","data-test":"email"}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"envelope-o"}}),_vm._v("\n            support@sl360.com\n          ")],1),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'contactUs', 'twitter']),expression:"['header', 'contactUs', 'twitter']"}],staticClass:"nav-link",attrs:{"href":_vm.$store.state.config.link.twitter,"data-test":"twitter"}},[_c('icon',{staticClass:"twitter-icon nav-icon",attrs:{"name":"twitter"}}),_vm._v("\n            Follow @SL360.com\n          ")],1)],1),_vm._v(" "),_c('div',{staticClass:"nav-block",staticStyle:{"max-width":"66%"}},[_c('p',{staticClass:"nav-title"},[_vm._v("Jot Us a Note")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-textarea',{attrs:{"rows":5,"state":this.infoValid.message.state,"placeholder":"Message *"},model:{value:(_vm.info.message),callback:function ($$v) {_vm.$set(_vm.info, "message", $$v)},expression:"info.message"}}),_vm._v(" "),(_vm.infoValid.message.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.message.text))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-input',{attrs:{"placeholder":"Name *","state":this.infoValid.name.state},model:{value:(_vm.info.name),callback:function ($$v) {_vm.$set(_vm.info, "name", $$v)},expression:"info.name"}}),_vm._v(" "),(_vm.infoValid.name.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.name.text))]):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-input',{attrs:{"placeholder":"Email address *","state":this.infoValid.email.state,"type":"email"},model:{value:(_vm.info.email),callback:function ($$v) {_vm.$set(_vm.info, "email", $$v)},expression:"info.email"}}),_vm._v(" "),(_vm.infoValid.email.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.email.text))]):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-btn',{attrs:{"disabled":_vm.btnDisable},on:{"click":_vm.submit}},[_vm._v("Send")])],1)],1)],1)])]),_vm._v(" "),_c('m-nav',{attrs:{"code":"user-name"}},[_c('div',{staticClass:"the-nav-box"},[_c('div',{staticClass:"nav-block",attrs:{"hidden":this.$store.state.site.User_RoleName === 'Digital User'}},[_c('p',{staticClass:"nav-title"},[_vm._v("Review Account History\n          ")]),_vm._v(" "),_c('p',{staticClass:"nav-breif"},[_vm._v("Download a list from a past order. Pick up where you left off with a saved count. Redeem or check on rewards.")]),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'user', 'order history']),expression:"['header', 'user', 'order history']"}],staticClass:"nav-link",attrs:{"data-test":"headOrderHistory","href":_vm.$store.getters['config/link']('history')}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"history"}}),_vm._v("\n            Order History\n          ")],1),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'user', 'SLC']),expression:"['header', 'user', 'SLC']"}],staticClass:"nav-link",attrs:{"data-test":"headSavedListCounts","href":_vm.$store.getters['config/link']('mysavecount')}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"save"}}),_vm._v("\n            Saved List Counts\n          ")],1),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'user', 'reward']),expression:"['header', 'user', 'reward']"}],staticClass:"nav-link",attrs:{"data-test":"headRewards"},on:{"click":function($event){_vm.goPage(function () {_vm.$router.push({name: 'reward'})})}}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"gift"}}),_vm._v("\n            Rewards\n          ")],1)],1),_vm._v(" "),_c('div',{staticClass:"nav-block"},[_c('p',{staticClass:"nav-title"},[_vm._v("Manage Your Account")]),_vm._v(" "),_c('p',{staticClass:"nav-breif"},[_vm._v("Access your rate sheet for lists and services. Adjust your account preferences and settings, or exit SL360.")]),_vm._v(" "),_c('b-link',{directives:[{name:"b-modal",rawName:"v-b-modal.modalPricing",modifiers:{"modalPricing":true}},{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'user', 'pricing']),expression:"['header', 'user', 'pricing']"}],staticClass:"nav-link",attrs:{"data-test":"headPricing","hidden":this.$store.state.site.User_RoleName === 'Digital User'},on:{"click":_vm.goPage}},[_c('icon',{staticClass:"nav-icon",staticStyle:{"margin-right":"8px"},attrs:{"name":"dollar"}}),_vm._v("Pricing\n          ")],1),_vm._v(" "),_c('b-link',{directives:[{name:"b-modal",rawName:"v-b-modal.modelSetting",modifiers:{"modelSetting":true}},{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'user', 'setting']),expression:"['header', 'user', 'setting']"}],staticClass:"nav-link",attrs:{"data-test":"headSetting","id":"sheadernavuser"},on:{"click":_vm.goPage}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"user-o"}}),_vm._v("Settings\n          ")],1),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['header', 'user', 'logout']),expression:"['header', 'user', 'logout']"}],staticClass:"nav-link",attrs:{"data-test":"headLogOut"},on:{"click":_vm.logOut}},[_c('icon',{staticClass:"nav-icon",attrs:{"name":"sign-out"}}),_vm._v("Log out\n          ")],1)],1)])])],1)],1)],1)}
var MHeader_staticRenderFns = []
var MHeader_esExports = { render: MHeader_render, staticRenderFns: MHeader_staticRenderFns }
/* harmony default export */ var layouts_MHeader = (MHeader_esExports);
// CONCATENATED MODULE: ./src/components/layouts/MHeader.vue
function MHeader_injectStyle (ssrContext) {
  __webpack_require__("SFhX")
  __webpack_require__("RMt6")
}
var MHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MHeader___vue_template_functional__ = false
/* styles */
var MHeader___vue_styles__ = MHeader_injectStyle
/* scopeId */
var MHeader___vue_scopeId__ = "data-v-7ab3f489"
/* moduleIdentifier (server only) */
var MHeader___vue_module_identifier__ = null
var MHeader_Component = MHeader_normalizeComponent(
  MHeader,
  layouts_MHeader,
  MHeader___vue_template_functional__,
  MHeader___vue_styles__,
  MHeader___vue_scopeId__,
  MHeader___vue_module_identifier__
)

/* harmony default export */ var components_layouts_MHeader = (MHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layouts/MHeaderTop.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MHeaderTop = ({
  components: {
    MContactUs: components_landings_MContactUs
  },
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {
    showContactUs: function showContactUs() {
      this.$root.$emit('bv::show::modal', 'modalContactUs');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709af8d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/MHeaderTop.vue
var MHeaderTop_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-top"},[_c('m-contact-us'),_vm._v(" "),_c('span',{staticClass:"d-flex justify-content-end"},[_c('span',{staticClass:"head-top-item"},[_c('b-link',{attrs:{"href":"tel://800-399-8611"}},[_vm._v("\n            800-399-8611 ")])],1),_vm._v(" "),_c('span',{staticClass:"head-top-item"},[_c('b-link',{staticClass:"contact-us",attrs:{"target":"_blank"},on:{"click":_vm.showContactUs}},[_vm._v("\n                  Contact Us\n                  ")])],1),_vm._v(" "),_c('span',{staticClass:"head-top-item"},[_c('icon',{staticClass:"twitter-icon",attrs:{"name":"twitter"}}),_vm._v(" "),_c('b-link',{attrs:{"href":_vm.$store.state.config.link.twitter,"target":"_blank"}},[_vm._v("\n             Follow @SL360.com\n           ")])],1)])],1)}
var MHeaderTop_staticRenderFns = []
var MHeaderTop_esExports = { render: MHeaderTop_render, staticRenderFns: MHeaderTop_staticRenderFns }
/* harmony default export */ var layouts_MHeaderTop = (MHeaderTop_esExports);
// CONCATENATED MODULE: ./src/components/layouts/MHeaderTop.vue
function MHeaderTop_injectStyle (ssrContext) {
  __webpack_require__("Anwz")
}
var MHeaderTop_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MHeaderTop___vue_template_functional__ = false
/* styles */
var MHeaderTop___vue_styles__ = MHeaderTop_injectStyle
/* scopeId */
var MHeaderTop___vue_scopeId__ = "data-v-709af8d2"
/* moduleIdentifier (server only) */
var MHeaderTop___vue_module_identifier__ = null
var MHeaderTop_Component = MHeaderTop_normalizeComponent(
  MHeaderTop,
  layouts_MHeaderTop,
  MHeaderTop___vue_template_functional__,
  MHeaderTop___vue_styles__,
  MHeaderTop___vue_scopeId__,
  MHeaderTop___vue_module_identifier__
)

/* harmony default export */ var components_layouts_MHeaderTop = (MHeaderTop_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layouts/MFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MFooter = ({
  data: function data() {
    return {
      btns: [{
        name: 'About Us',
        url: this.$store.state.config.link.aboutUs
      }, {
        name: 'Privacy Policy',
        url: this.$store.state.config.link.privacy
      }, {
        name: 'Twitter',
        url: this.$store.state.config.link.twitter
      }]
    };
  },

  computed: {
    year: function year() {
      var today = new Date();
      return today.getFullYear();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-716943c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/MFooter.vue
var MFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container landing-footer"},[_c('div',[_c('p',{staticStyle:{"color":"#aaa"}},[_vm._v("Copyright © "+_vm._s(_vm.year)+" SL360, Inc. All rights reserved.")])]),_vm._v(" "),_c('div',{staticClass:"right-box"},[_c('p',{staticClass:"powered-by"},[_vm._v("Powered By")]),_vm._v(" "),_c('b-link',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['footer', 'logo', 'usa data']),expression:"['footer', 'logo', 'usa data']"}],staticClass:"powered-by",attrs:{"href":this.$store.state.config.link.home,"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("8I+S")}})]),_vm._v(" "),_c('p',{staticClass:"powered-by"},[_vm._v("875 3rd Ave, 6th floor, New York, NY 10022")]),_vm._v(" "),_c('p',{staticClass:"powered-by"},[_vm._v("800.395.7707 | info@usadata.com")])],1)])}
var MFooter_staticRenderFns = []
var MFooter_esExports = { render: MFooter_render, staticRenderFns: MFooter_staticRenderFns }
/* harmony default export */ var layouts_MFooter = (MFooter_esExports);
// CONCATENATED MODULE: ./src/components/layouts/MFooter.vue
function MFooter_injectStyle (ssrContext) {
  __webpack_require__("5+4R")
}
var MFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MFooter___vue_template_functional__ = false
/* styles */
var MFooter___vue_styles__ = MFooter_injectStyle
/* scopeId */
var MFooter___vue_scopeId__ = "data-v-716943c6"
/* moduleIdentifier (server only) */
var MFooter___vue_module_identifier__ = null
var MFooter_Component = MFooter_normalizeComponent(
  MFooter,
  layouts_MFooter,
  MFooter___vue_template_functional__,
  MFooter___vue_styles__,
  MFooter___vue_scopeId__,
  MFooter___vue_module_identifier__
)

/* harmony default export */ var components_layouts_MFooter = (MFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layouts/MBase.vue
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MBase = ({
  components: {
    MHeader: components_layouts_MHeader,
    MFooter: components_layouts_MFooter,
    MHeaderTop: components_layouts_MHeaderTop,
    MContactUs: components_landings_MContactUs
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5c4b59c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/MBase.vue
var MBase_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base"},[_c('m-header'),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('m-footer')],2)}
var MBase_staticRenderFns = []
var MBase_esExports = { render: MBase_render, staticRenderFns: MBase_staticRenderFns }
/* harmony default export */ var layouts_MBase = (MBase_esExports);
// CONCATENATED MODULE: ./src/components/layouts/MBase.vue
function MBase_injectStyle (ssrContext) {
  __webpack_require__("Roy/")
}
var MBase_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MBase___vue_template_functional__ = false
/* styles */
var MBase___vue_styles__ = MBase_injectStyle
/* scopeId */
var MBase___vue_scopeId__ = "data-v-e5c4b59c"
/* moduleIdentifier (server only) */
var MBase___vue_module_identifier__ = null
var MBase_Component = MBase_normalizeComponent(
  MBase,
  layouts_MBase,
  MBase___vue_template_functional__,
  MBase___vue_styles__,
  MBase___vue_scopeId__,
  MBase___vue_module_identifier__
)

/* harmony default export */ var components_layouts_MBase = (MBase_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MSectionBanner.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MSectionBanner = ({
  data: function data() {
    return {
      menus: [{
        title: 'Reach New Prospects',
        desc: '... through traditional direct mail or via a digital marketing campaign.',
        img: './static/img/prospectLists.png',
        point: '#prospects'
      }, {
        title: 'Enhance or Clean My Customer Database',
        desc: '... by verifying or by enhancing the information I have collected.',
        img: './static/img/dataEnhancement.png',
        point: '#service'
      }, {
        title: 'Analyze My Customers',
        desc: '... to discover characteristics they may share with others in my area.',
        img: './static/img/portraitReportsWhite.png',
        point: '#analyze'
      }]
    };
  },

  computed: {
    username: function username() {
      return this.$store.state.site.User_FullName || '';
    },
    welcomeText: function welcomeText() {
      var text = '';
      var now = new Date().getHours();
      if (now >= 5 && now < 12) {
        text = 'Good morning';
      } else if (now >= 12 && now < 18) {
        text = 'Good afternoon';
      } else if (now >= 18 && now < 22) {
        text = 'Good evening';
      } else {
        text = 'Good night';
      }
      return text + ', ';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59998d9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MSectionBanner.vue
var MSectionBanner_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"landing-top"}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"menu-notice"},[_c('h1',{staticClass:"h1"},[_vm._v("\n          "+_vm._s(_vm.welcomeText)+"\n          "),_c('transition',{staticStyle:{"min-width":"100px"},attrs:{"name":"m-fade"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.username.length > 0),expression:"username.length > 0"}]},[_vm._v(_vm._s(_vm.username))])])],1),_vm._v(" "),_c('p',{staticClass:"menu-notice-p"},[_vm._v("How can we help you today?")])]),_vm._v(" "),_c('div',{staticClass:"menu-box"},_vm._l((_vm.menus),function(menu){return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:(menu.point),expression:"menu.point"},{name:"m-ua-event",rawName:"v-m-ua-event",value:(['landing', 'banner', menu.title]),expression:"['landing', 'banner', menu.title]"}],staticClass:"menu-card",attrs:{"href":"#"}},[_c('div',{staticClass:"img-box"},[_c('img',{staticClass:"img",attrs:{"src":menu.img}})]),_vm._v(" "),_c('h3',{staticClass:"menuh3"},[_vm._v(_vm._s(menu.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(menu.desc))])])}),0)])],1)],1)}
var MSectionBanner_staticRenderFns = []
var MSectionBanner_esExports = { render: MSectionBanner_render, staticRenderFns: MSectionBanner_staticRenderFns }
/* harmony default export */ var landings_MSectionBanner = (MSectionBanner_esExports);
// CONCATENATED MODULE: ./src/components/landings/MSectionBanner.vue
function MSectionBanner_injectStyle (ssrContext) {
  __webpack_require__("DPhx")
}
var MSectionBanner_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSectionBanner___vue_template_functional__ = false
/* styles */
var MSectionBanner___vue_styles__ = MSectionBanner_injectStyle
/* scopeId */
var MSectionBanner___vue_scopeId__ = "data-v-59998d9c"
/* moduleIdentifier (server only) */
var MSectionBanner___vue_module_identifier__ = null
var MSectionBanner_Component = MSectionBanner_normalizeComponent(
  MSectionBanner,
  landings_MSectionBanner,
  MSectionBanner___vue_template_functional__,
  MSectionBanner___vue_styles__,
  MSectionBanner___vue_scopeId__,
  MSectionBanner___vue_module_identifier__
)

/* harmony default export */ var components_landings_MSectionBanner = (MSectionBanner_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MSectionProspects.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MSectionProspects = ({
  data: function data() {
    return {};
  },

  computed: {
    userDataSources: function userDataSources() {
      return this.$store.state.user.userDataSources;
    },
    topBtns: function topBtns() {
      var result = [];
      for (var i = 0; i < this.userDataSources.length; i++) {
        var item = this.userDataSources[i];
        if (item.ListType === 10 || item.ListType === 170) {
          result.push(item);
        }
      }
      return result;
    },
    normalBtns: function normalBtns() {
      var result = [];
      var isSaturation = false;
      for (var i = 0; i < this.userDataSources.length; i++) {
        var item = this.userDataSources[i];
        if (item.ListType === 50) {
          isSaturation = true;
        } else if (item.ListType !== 10 && item.ListType !== 170) {
          result.push(item);
        }
      }
      if (isSaturation) {
        for (var _i = 0; _i < this.userDataSources.length; _i++) {
          var _item = this.userDataSources[_i];
          if (_item.ListType === 50) {
            result.push(_item);
          }
        }
      }
      return result;
    }
  },
  methods: {
    go: function go(listType) {
      this.$router.push({
        name: 'order',
        params: {
          listType: listType
        }
      });
    },
    showDigital: function showDigital() {
      this.$root.$emit('bv::show::modal', 'modelDigitalCampaigns');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f40776e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MSectionProspects.vue
var MSectionProspects_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backgournd-box",attrs:{"id":"prospects"}},[_c('b-container',[_c('b-row',{staticClass:"prospects-title"},[_c('b-col',{staticClass:"m-landing-h1-center"},[_c('h1',{staticClass:"m-landing-h1"},[_vm._v("Reach New Prospects")]),_vm._v(" "),_c('p',{staticClass:"m-landing-h1-brief"},[_vm._v("Connect with your best prospects through privacy-compliant digital or traditional channels to win new customers. Do it yourself or work with a specialist.\n        ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"padding-left":"32px"}},[_c('h3',{staticClass:"m-landing-h3"},[_vm._v("Begin a digital campaign")]),_vm._v(" "),_c('p',[_vm._v("Tell us your goals and and budget. Our experts will craft and manage a full-service campaign for you.")]),_vm._v(" "),_c('b-btn',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['landing', 'datasource', 'Full Service Digital Campaigns']),expression:"['landing', 'datasource', 'Full Service Digital Campaigns']"}],staticClass:"digital-btn",attrs:{"variant":"primary"},on:{"click":_vm.showDigital}},[_vm._v("\n          Choose email")]),_vm._v(" "),_c('b-btn',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['landing', 'datasource', 'Full Service Digital Campaigns']),expression:"['landing', 'datasource', 'Full Service Digital Campaigns']"}],staticClass:"digital-btn",on:{"click":_vm.showDigital}},[_vm._v("\n          Choose display & social")]),_vm._v(" "),_c('b-btn',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['landing', 'datasource', 'Full Service Digital Campaigns']),expression:"['landing', 'datasource', 'Full Service Digital Campaigns']"}],staticClass:"digital-btn",on:{"click":_vm.showDigital}},[_vm._v("\n          Choose multi-channel")])],1),_vm._v(" "),_c('b-col',[_c('h3',{staticClass:"m-landing-h3"},[_vm._v("Order Mailing Lists")]),_vm._v(" "),_c('p',[_vm._v("Build, order and download a new list of prospects—in just minutes. Add phone numbers (where available) for follow-up.")]),_vm._v(" "),_c('transition',{attrs:{"name":"m-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userDataSources.length > 0),expression:"userDataSources.length > 0"}],staticClass:"btns-box"},[_vm._l((_vm.topBtns),function(item){return _c('b-btn',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['landing', 'datasource', item.Desc]),expression:"['landing', 'datasource', item.Desc]"}],key:item.ListType,staticClass:"order-btn",attrs:{"variant":"primary"},domProps:{"textContent":_vm._s(item.Desc)},on:{"click":function($event){return _vm.go(item.ListType)}}})}),_vm._v(" "),_vm._l((_vm.normalBtns),function(item){return _c('b-btn',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['landing', 'datasource', item.Desc]),expression:"['landing', 'datasource', item.Desc]"}],key:item.ListType,staticClass:"order-btn",domProps:{"textContent":_vm._s(item.Desc)},on:{"click":function($event){return _vm.go(item.ListType)}}})})],2)])],1)],1)],1)],1)}
var MSectionProspects_staticRenderFns = []
var MSectionProspects_esExports = { render: MSectionProspects_render, staticRenderFns: MSectionProspects_staticRenderFns }
/* harmony default export */ var landings_MSectionProspects = (MSectionProspects_esExports);
// CONCATENATED MODULE: ./src/components/landings/MSectionProspects.vue
function MSectionProspects_injectStyle (ssrContext) {
  __webpack_require__("r4Fl")
}
var MSectionProspects_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSectionProspects___vue_template_functional__ = false
/* styles */
var MSectionProspects___vue_styles__ = MSectionProspects_injectStyle
/* scopeId */
var MSectionProspects___vue_scopeId__ = "data-v-5f40776e"
/* moduleIdentifier (server only) */
var MSectionProspects___vue_module_identifier__ = null
var MSectionProspects_Component = MSectionProspects_normalizeComponent(
  MSectionProspects,
  landings_MSectionProspects,
  MSectionProspects___vue_template_functional__,
  MSectionProspects___vue_styles__,
  MSectionProspects___vue_scopeId__,
  MSectionProspects___vue_module_identifier__
)

/* harmony default export */ var components_landings_MSectionProspects = (MSectionProspects_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MSectionService.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MSectionService = ({
  data: function data() {
    return {
      menus: [{
        title: 'Append Demographics or Psychographics',
        benefit: 'Gives your customer database more segmentation capabilities and helps you better communicate with customers around their interests and life stage.',
        link: 'enhanceList',
        icon: 'share-alt',
        type: 'enhance'
      }, {
        title: 'Clean your Database',
        benefit: 'Save money avoiding duplicate and undeliverable mail, and marketing to only those qualified for your product or service.',
        link: 'cleanList',
        icon: 'eraser',
        type: 'clean'
      }, {
        title: 'Append Email Addresses',
        benefit: 'Adding email addresses to your database helps you communicate with customers through a new and low-cost channel.',
        link: 'emailAppend',
        icon: 'envelope-open-o',
        type: 'enhance'
      }, {
        title: 'Verify Email Addresses',
        benefit: 'Reduces undeliverable email which helps keep your sender reputation strong so ESPs continue delivering your email.',
        link: 'emailVerification',
        icon: 'envelope-o',
        type: 'clean'
      }, {
        title: 'Append Phone Numbers',
        benefit: 'Provides an additional and low cost channel to communicate with customers.',
        link: 'phoneAppend',
        icon: 'mobile',
        type: 'enhance'
      }, {
        title: 'Reverse Phone Append',
        benefit: 'Helps reveal who contacted you and enables you to reach them via direct mail.',
        link: 'phoneReverse',
        icon: 'phone',
        type: 'enhance'
      }, {
        title: 'Verify phone numbers',
        benefit: 'Saves you time calling bad numbers and improves your connection rate with customers.',
        link: 'phoneVerification',
        icon: 'volume-control-phone',
        type: 'clean'
      }]
    };
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5958e4d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MSectionService.vue
var MSectionService_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backgournd-box",attrs:{"id":"service"}},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"m-landing-h1-center"},[_c('h1',{staticClass:"m-landing-h1"},[_vm._v("Manage your customer data")]),_vm._v(" "),_c('p',{staticClass:"m-landing-h1-brief"},[_vm._v("Improve and enrich the information in your customer database. Simply choose a service and load your file. Go refill your coffee and your updated file already may be waiting for you!\n        ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h3',{staticClass:"m-landing-h3"},[_vm._v("Enhance your data")]),_vm._v(" "),_c('p',[_vm._v("Append our data to your current book of business so you can segment and target customers better. Send more relevant messaging and offers, for better ROI.")]),_vm._v(" "),_c('div',{staticClass:"service-box"},_vm._l((_vm.menus),function(menu){return (menu.type === 'enhance')?_c('a',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['landing', 'dataservice', menu.title]),expression:"['landing', 'dataservice', menu.title]"}],staticClass:"menu-box",attrs:{"href":_vm.$store.getters['config/link'](menu.link)}},[_c('h3',{staticClass:"service-btn"},[_c('div',{staticClass:"icon-box"},[_c('icon',{staticClass:"service-icon",attrs:{"name":menu.icon,"scale":"2"}})],1),_vm._v("\n              "+_vm._s(menu.title)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"menu-content-box"},[_c('p',[_vm._v(_vm._s(menu.benefit))])])]):_vm._e()}),0)])],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"24px"}},[_c('b-col',[_c('h3',{staticClass:"m-landing-h3"},[_vm._v("Clean & verify your data")]),_vm._v(" "),_c('p',[_vm._v("De-duplicate records, correct undeliverable addresses and screen for privacy... all to save you time and money.")]),_vm._v(" "),_c('div',{staticClass:"service-box"},_vm._l((_vm.menus),function(menu){return (menu.type === 'clean')?_c('a',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['landing', 'dataservice', menu.title]),expression:"['landing', 'dataservice', menu.title]"}],staticClass:"menu-box",attrs:{"href":_vm.$store.getters['config/link'](menu.link)}},[_c('h3',{staticClass:"service-btn"},[_c('div',{staticClass:"icon-box"},[_c('icon',{staticClass:"service-icon",attrs:{"name":menu.icon,"scale":"2"}})],1),_vm._v("\n              "+_vm._s(menu.title)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"menu-content-box"},[_c('p',[_vm._v(_vm._s(menu.benefit))])])]):_vm._e()}),0)])],1)],1)],1)}
var MSectionService_staticRenderFns = []
var MSectionService_esExports = { render: MSectionService_render, staticRenderFns: MSectionService_staticRenderFns }
/* harmony default export */ var landings_MSectionService = (MSectionService_esExports);
// CONCATENATED MODULE: ./src/components/landings/MSectionService.vue
function MSectionService_injectStyle (ssrContext) {
  __webpack_require__("ld55")
}
var MSectionService_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSectionService___vue_template_functional__ = false
/* styles */
var MSectionService___vue_styles__ = MSectionService_injectStyle
/* scopeId */
var MSectionService___vue_scopeId__ = "data-v-5958e4d2"
/* moduleIdentifier (server only) */
var MSectionService___vue_module_identifier__ = null
var MSectionService_Component = MSectionService_normalizeComponent(
  MSectionService,
  landings_MSectionService,
  MSectionService___vue_template_functional__,
  MSectionService___vue_styles__,
  MSectionService___vue_scopeId__,
  MSectionService___vue_module_identifier__
)

/* harmony default export */ var components_landings_MSectionService = (MSectionService_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MSectionAnalyze.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MSectionAnalyze = ({
  data: function data() {
    return {
      menus: [{
        title: 'look-Alike Report',
        benefit: 'This report includes a demographic portrait of your file plus a calculated Market Penetration Index ("MPI") which enables you to define the prospective market potential. The higher the index calculation, the greater success you had.',
        link: 'reportLookALike'
      }, {
        title: 'Enhanced Look-Alike Report',
        benefit: 'This report helps you take a broad view of your customer base, identify where you have a strong or weak market presence, learn who your best customers are and how they are different from the rest, and more!',
        link: 'reportEnhanceLookAlike'
      }, {
        title: 'PersonicX Portrait Report',
        benefit: 'This report enables you to better understand who your best customers are using segmentation. It includes an index that enables you to define the prospective market potential.',
        link: 'reportPortrait'
      }, {
        title: 'Data Portrait Analysis',
        benefit: 'This report compares the demographic and lifestyle/interest characteristics of customer households to the characteristics of households in your local or regional geographic area.',
        link: 'reportPortraitRegional'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86d416f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MSectionAnalyze.vue
var MSectionAnalyze_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backgournd-box"},[_c('b-container',{attrs:{"id":"analyze"}},[_c('b-row',[_c('b-col',{staticClass:"m-landing-h1-center"},[_c('h1',{staticClass:"m-landing-h1"},[_vm._v("Analyze your customer data")]),_vm._v(" "),_c('p',{staticClass:"m-landing-h1-brief"},[_vm._v("We offer a series of reports, starting at just $200. Upload your customer file\n          and choose a target area. Turnaround time varies from one to five business days.")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h3',{staticClass:"m-landing-h3"},[_vm._v("Choose a report")]),_vm._v(" "),_c('p',[_vm._v("We offer a series of reports, starting at just $200. Upload your customer file and choose a target area. Turnaround time varies from one to five business days.")]),_vm._v(" "),_c('div',{staticClass:"analyze-btn"},[_c('b-btn',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['landing', 'dataservice', 'Analyze your customers']),expression:"['landing', 'dataservice', 'Analyze your customers']"}],attrs:{"variant":"primary","href":_vm.$store.getters['config/link']('portaitreports')}},[_vm._v("Get Started & View Samples ")]),_vm._v(" "),_c('b-btn',[_vm._v("Ask an expert")])],1)]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"center"}},[_c('b-img',{attrs:{"src":"./static/img/portraitReportsWhite.png"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h3',{staticClass:"m-landing-h3"},[_vm._v("View sample reports")]),_vm._v(" "),_c('p',[_vm._v("Learn about each report before you begin.")]),_vm._v(" "),_c('div',{staticClass:"service-box"},_vm._l((_vm.menus),function(menu){return _c('a',{directives:[{name:"m-ua-event",rawName:"v-m-ua-event",value:(['landing', 'analyzeReport', menu.title]),expression:"['landing', 'analyzeReport', menu.title]"}],staticClass:"menu-box",attrs:{"href":_vm.$store.getters['config/link'](menu.link)}},[_c('h3',{staticClass:"service-btn"},[_vm._v("\n              "+_vm._s(menu.title)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"menu-content-box"},[_c('p',[_vm._v(_vm._s(menu.benefit))])])])}),0)])],1)],1)],1)}
var MSectionAnalyze_staticRenderFns = []
var MSectionAnalyze_esExports = { render: MSectionAnalyze_render, staticRenderFns: MSectionAnalyze_staticRenderFns }
/* harmony default export */ var landings_MSectionAnalyze = (MSectionAnalyze_esExports);
// CONCATENATED MODULE: ./src/components/landings/MSectionAnalyze.vue
function MSectionAnalyze_injectStyle (ssrContext) {
  __webpack_require__("Fj4u")
}
var MSectionAnalyze_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSectionAnalyze___vue_template_functional__ = false
/* styles */
var MSectionAnalyze___vue_styles__ = MSectionAnalyze_injectStyle
/* scopeId */
var MSectionAnalyze___vue_scopeId__ = "data-v-86d416f4"
/* moduleIdentifier (server only) */
var MSectionAnalyze___vue_module_identifier__ = null
var MSectionAnalyze_Component = MSectionAnalyze_normalizeComponent(
  MSectionAnalyze,
  landings_MSectionAnalyze,
  MSectionAnalyze___vue_template_functional__,
  MSectionAnalyze___vue_styles__,
  MSectionAnalyze___vue_scopeId__,
  MSectionAnalyze___vue_module_identifier__
)

/* harmony default export */ var components_landings_MSectionAnalyze = (MSectionAnalyze_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MOrderDetail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MOrderDetail = ({
  props: ['order'],
  data: function data() {
    return {
      states: this.$store.state.user,
      detail: { OrderAddresses: [] }
    };
  },

  computed: {
    orderDetail: function orderDetail() {
      var _this = this;

      if (this.detail.OrderAddresses.length === 0) {
        this.$http.post('dialogs/OrderDetails.aspx/GetOrder', {
          sessionId: this.order.SessionGuid
        }).then(function (resp) {
          if (resp.body.d.ResultFlag) {
            _this.detail = resp.body.d.DataSource.Order;
          } else {}
        }, function (resp) {});
      }
      return this.detail;
    }
  },
  methods: {
    getName: function getName(v) {
      if (v.length > 32) {
        return v.substring(0, 29) + '...';
      } else {
        return v;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-110c539f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MOrderDetail.vue
var MOrderDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card m-order-detail"},[_c('p',{staticClass:"m-order-detail-title color-primary ",staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm.getName(_vm.order.OrderDesc)))]),_vm._v(" "),(_vm.order.OrderType)?_c('p',[_vm._v(_vm._s(_vm.states.dataSources[_vm.order.ListType])+" List")]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._l((_vm.orderDetail.OrderAddresses),function(item){return _c('p',{staticClass:"m-order-detail-item"},[(item.ZipCode)?_c('span',[_vm._v("\n              "+_vm._s(item.ZipCode)+"\n              ")]):_vm._e()])}),_vm._v(" "),_c('p',{attrs:{"if":"order.XIpCode"}},[_vm._v("\n  "+_vm._s(_vm.order.ZipCode)+"\n")])],2)}
var MOrderDetail_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br'),_vm._v("ZIP")])}]
var MOrderDetail_esExports = { render: MOrderDetail_render, staticRenderFns: MOrderDetail_staticRenderFns }
/* harmony default export */ var landings_MOrderDetail = (MOrderDetail_esExports);
// CONCATENATED MODULE: ./src/components/landings/MOrderDetail.vue
function MOrderDetail_injectStyle (ssrContext) {
  __webpack_require__("e/zq")
}
var MOrderDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MOrderDetail___vue_template_functional__ = false
/* styles */
var MOrderDetail___vue_styles__ = MOrderDetail_injectStyle
/* scopeId */
var MOrderDetail___vue_scopeId__ = "data-v-110c539f"
/* moduleIdentifier (server only) */
var MOrderDetail___vue_module_identifier__ = null
var MOrderDetail_Component = MOrderDetail_normalizeComponent(
  MOrderDetail,
  landings_MOrderDetail,
  MOrderDetail___vue_template_functional__,
  MOrderDetail___vue_styles__,
  MOrderDetail___vue_scopeId__,
  MOrderDetail___vue_module_identifier__
)

/* harmony default export */ var components_landings_MOrderDetail = (MOrderDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MCardOrder.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MCardOrder = ({
  components: {
    MOrderDetail: components_landings_MOrderDetail
  },
  props: ['orders', 'orderType'],
  data: function data() {
    return {
      states: this.$store.state.user,
      isOrdering: false
    };
  },
  methods: {
    orderMoreDisabled: function orderMoreDisabled(item) {
      // let orderDate = new Date(parseInt(/-?\d+/.exec(item.OrderDate)[0]))
      // let today = new Date()
      // let day = today.getTime() - orderDate.getTime()
      // day = day / 64000000

      // return !(item.state === 75 && item.OnlineOrder && item.OrderType === 10 && !this.isOrdering && day<365)
      return item.OrderType !== 10;
    },
    orderMoreError: function orderMoreError(resp) {
      this.isOrdering = false;
      notification.notice('error', 'Please try again, or cantact us', { title: 'Order More Failed', onlyGroup: 'connectError' });
    },
    orderMore: function orderMore(orderItem) {
      if (this.orderMoreDisabled(orderItem)) {
        return false;
      } else {
        this.isOrdering = true;
      }
      // utils.ga('getCount','goto')
      var that = this;
      this.$http.post('rpt/MyOrdersHistory.aspx/GetOrderMoreByOrder', {
        orderId: orderItem.OrderId
      }).then(function (resp) {
        if (resp.body.d.ResultFlag) {
          var order = {
            SuppressionType: 2,
            // OrderSuppressions
            OrderSuppressions: [{
              SuppressedOrderId: orderItem.OrderId,
              SuppressionName: orderItem.OrderDesc,
              SuppressionValue: orderItem.OrderCode,
              OriginalOrderId: orderItem.OrderId,
              SuppressedOrderCode: orderItem.OrderCode,
              SuppressedOrderDesc: orderItem.OrderDesc
            }],
            ListType: orderItem.ListType,
            AccountId: resp.body.d.DataSource.AccountId
            // entity Order
          };
          if (order.ListType === 50) {
            // entity.enums.DataSourceType.Occupant
            order.OrderSuppressions = [];
            order.SuppressionType = 0;
          }
          that.submitOrderMore(order);
          return order;
        } else {
          that.orderMoreError(resp);
        }
      }, function (resp) {
        that.orderMoreError(resp);
      });
    },
    submitOrderMore: function submitOrderMore(order) {
      var _this = this;

      var that = this;
      this.$http.post('rpt/MyOrdersHistory.aspx/SubmitForOrderMore', {
        order: order
      }).then(function (resp) {
        if (resp.body.d.ResultFlag) {
          _this.isOrdering = false;
          window.location.href = _this.$store.getters['config/link']('getOrderMoreCountGo');
        } else {
          that.orderMoreError(resp);
        }
      }, function (resp) {
        that.orderMoreError(resp);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79986018","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MCardOrder.vue
var MCardOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-card"},[_c('b-row',{staticClass:"m-card-padding"},[_c('b-col',{attrs:{"cols":"8"}},[_c('span',{staticClass:"m-card-title"},[_vm._t("title")],2)]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"4"}},[_c('span',{staticClass:"m-card-sub-title"},[_vm._v("Qty Available")])])],1),_vm._v(" "),_vm._l((_vm.orders),function(item,index){return _c('b-row',{key:item.name,staticClass:"m-card-order-item"},[_c('b-col',{attrs:{"cols":"2"}},[_c('span',{staticClass:"m-card-month"},[_vm._v(_vm._s(_vm._f("formatMonth")(item.OrderDate)))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"m-card-date"},[_vm._v(_vm._s(_vm._f("formatDay")(item.OrderDate)))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"5"}},[_c('div',{staticClass:"m-card-order-item-title text-one-line"},[_vm._v(_vm._s(item.OrderDesc))]),_vm._v(" "),_c('span',{staticClass:"box-subtitle text-one-line"},[_vm._v(_vm._s(_vm.states.dataSources[item.OrderType])+" List")]),_vm._v(" "),_c('span',{staticClass:"box-subtitle text-one-line"},[_vm._v(_vm._s(item.OrderCode))])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"5"}},[_c('div',{staticClass:"m-card-order-item-qty"},[_vm._v(_vm._s(_vm._f("numberFormat")(item.TotalAvailableQty,'',0)))]),_vm._v(" "),(_vm.orderType === 'savedOrder')?_c('a',{staticClass:"btn btn-outline-primary x-width",attrs:{"href":_vm.$store.getters['config/link']('getSavedCount')+item.SessionGuid}},[_vm._v("\n        Retrieve Counts\n      ")]):_vm._e(),_vm._v(" "),(_vm.orderType === 'recentOrder')?_c('div',{staticClass:"btn btn-outline-primary x-width",class:{disabled: _vm.orderMoreDisabled(item)},on:{"click":function($event){return _vm.orderMore(item)}}},[_vm._v("\n        Order More\n      ")]):_vm._e()]),_vm._v(" "),_c('m-order-detail',{attrs:{"order":item}})],1)}),_vm._v(" "),_c('b-row',{staticClass:"m-card-footer"},[_vm._t("footer")],2)],2)}
var MCardOrder_staticRenderFns = []
var MCardOrder_esExports = { render: MCardOrder_render, staticRenderFns: MCardOrder_staticRenderFns }
/* harmony default export */ var landings_MCardOrder = (MCardOrder_esExports);
// CONCATENATED MODULE: ./src/components/landings/MCardOrder.vue
function MCardOrder_injectStyle (ssrContext) {
  __webpack_require__("FzI9")
}
var MCardOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MCardOrder___vue_template_functional__ = false
/* styles */
var MCardOrder___vue_styles__ = MCardOrder_injectStyle
/* scopeId */
var MCardOrder___vue_scopeId__ = "data-v-79986018"
/* moduleIdentifier (server only) */
var MCardOrder___vue_module_identifier__ = null
var MCardOrder_Component = MCardOrder_normalizeComponent(
  MCardOrder,
  landings_MCardOrder,
  MCardOrder___vue_template_functional__,
  MCardOrder___vue_styles__,
  MCardOrder___vue_scopeId__,
  MCardOrder___vue_module_identifier__
)

/* harmony default export */ var components_landings_MCardOrder = (MCardOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MDataDiagnostic.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MDataDiagnostic = ({
  data: function data() {
    return {
      info: {
        fname: '',
        lname: '',
        company: '',
        email: '',
        qty: '',
        message: ''
      },
      btnDisable: false,
      infoValid: {
        fname: {
          state: null,
          text: ''
        },
        lname: {
          state: null,
          text: ''
        },
        email: {
          state: null,
          text: ''
        },
        message: {
          state: null,
          text: ''
        }
      },
      isShowSuccess: false
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.clearValid(this.infoValid);
      var that = this;
      if (this.validInfo()) {
        this.btnDisable = true;
        this.$http.post(this.$store.getters['config/link']('sendMessage'), {
          Action: 'save-contact-info',
          FormData: stringify_default()({
            FirstName: this.info.fname,
            LastName: this.info.lname,
            Company: this.info.company,
            Email: this.info.email,
            Phone: '',
            Comment: this.info.message,
            Page: this.info.qty,
            PageInfo: window.location.hostname === 'dev.sl360.com' ? '[Staging]Landing Page Data Diagnostic Inquiry' : 'Landing Page Data Diagnostic Inquiry',
            FromSite: 'sl360.com',
            Source: 'LandingPage-Data-Diagnostic'
          })
        }, {
          emulateJSON: true
        }).then(function (resp) {
          that.btnDisable = false;
          if (resp.body.Status === 1) {
            that.isShowSuccess = true;
            // notification.notice('error', 'Failed to sent contact information , please try again')
          }
        }, function (resp) {
          notification.notice('error', 'Failed to sent contact information , please try again');
          _this.btnDisable = false;
        });
      }
    },
    showDemo: function showDemo() {
      window.open('/DHA_v7.pdf');
    },
    validInfo: function validInfo() {
      var isValid = true;
      if (!this.info.fname) {
        this.infoValid.fname.state = false;
        this.infoValid.fname.text = "It's required";
        isValid = false;
      }
      if (!this.info.lname) {
        this.infoValid.lname.state = false;
        this.infoValid.lname.text = "It's required";
        isValid = false;
      }
      if (!(this.info.email.indexOf('@') > 0 && this.info.email.indexOf('@') < this.info.email.length - 1)) {
        this.infoValid.email.state = false;
        this.infoValid.email.text = 'E-mail must be valid';
        isValid = false;
      }
      if (!this.info.email) {
        this.infoValid.email.state = false;
        this.infoValid.email.text = "It's required";
        isValid = false;
      }
      if (!this.info.message) {
        this.infoValid.message.state = false;
        this.infoValid.message.text = "It's required";
        isValid = false;
      }
      return isValid;
    },
    clearValid: function clearValid(items) {
      for (var key in items) {
        items[key].state = null;
        items[key].text = false;
      }
    },
    load: function load() {
      this.info.fname = this.$store.getters['user/userInfo'].FirstName;
      this.info.lname = this.$store.getters['user/userInfo'].LastName;
      this.info.email = this.$store.getters['user/userInfo'].Email;
      this.isShowSuccess = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-618f86f3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MDataDiagnostic.vue
var MDataDiagnostic_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modalDataDiagnostic","hide-footer":true,"title":"New Data Diagnostic!"},on:{"show":_vm.load}},[_c('b-container',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShowSuccess),expression:"!isShowSuccess"}]},[_c('div',{staticClass:"col-sm-12",staticStyle:{"padding-left":"0","padding-right":"0"}},[_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"First Name *","state":this.infoValid.fname.state},model:{value:(_vm.info.fname),callback:function ($$v) {_vm.$set(_vm.info, "fname", $$v)},expression:"info.fname"}}),_vm._v(" "),(_vm.infoValid.fname.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.fname.text))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"Last Name *","state":this.infoValid.lname.state},model:{value:(_vm.info.lname),callback:function ($$v) {_vm.$set(_vm.info, "lname", $$v)},expression:"info.lname"}}),_vm._v(" "),(_vm.infoValid.lname.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.lname.text))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"Company Name"},model:{value:(_vm.info.company),callback:function ($$v) {_vm.$set(_vm.info, "company", $$v)},expression:"info.company"}})],1),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"Email Address *","state":this.infoValid.email.state,"type":"email"},model:{value:(_vm.info.email),callback:function ($$v) {_vm.$set(_vm.info, "email", $$v)},expression:"info.email"}}),_vm._v(" "),(_vm.infoValid.email.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.email.text))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"Qty of Records in Database"},model:{value:(_vm.info.qty),callback:function ($$v) {_vm.$set(_vm.info, "qty", $$v)},expression:"info.qty"}})],1),_vm._v(" "),_c('b-form-group',[_c('b-form-textarea',{attrs:{"rows":3,"placeholder":"Questions/Comments *","state":this.infoValid.message.state},model:{value:(_vm.info.message),callback:function ($$v) {_vm.$set(_vm.info, "message", $$v)},expression:"info.message"}}),_vm._v(" "),(_vm.infoValid.message.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.message.text))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"text-align":"left","font-size":"12px"}},[_c('label',[_c('i',[_vm._v("* Required")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5",staticStyle:{"padding-left":"0","padding-right":"0"}}),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-sm-7"},[_c('b-col',{staticClass:"colcenter"},[_c('b-btn',{attrs:{"disabled":_vm.btnDisable},on:{"click":_vm.submit}},[_vm._v("CONTACT US")])],1)],1)])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowSuccess),expression:"isShowSuccess"}],staticClass:"colcenter"},[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Thanks for contacting us!")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h3',[_vm._v("We will get back to you very soon.")])])],1)],1)])],1)}
var MDataDiagnostic_staticRenderFns = []
var MDataDiagnostic_esExports = { render: MDataDiagnostic_render, staticRenderFns: MDataDiagnostic_staticRenderFns }
/* harmony default export */ var landings_MDataDiagnostic = (MDataDiagnostic_esExports);
// CONCATENATED MODULE: ./src/components/landings/MDataDiagnostic.vue
function MDataDiagnostic_injectStyle (ssrContext) {
  __webpack_require__("6qH4")
}
var MDataDiagnostic_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MDataDiagnostic___vue_template_functional__ = false
/* styles */
var MDataDiagnostic___vue_styles__ = MDataDiagnostic_injectStyle
/* scopeId */
var MDataDiagnostic___vue_scopeId__ = "data-v-618f86f3"
/* moduleIdentifier (server only) */
var MDataDiagnostic___vue_module_identifier__ = null
var MDataDiagnostic_Component = MDataDiagnostic_normalizeComponent(
  MDataDiagnostic,
  landings_MDataDiagnostic,
  MDataDiagnostic___vue_template_functional__,
  MDataDiagnostic___vue_styles__,
  MDataDiagnostic___vue_scopeId__,
  MDataDiagnostic___vue_module_identifier__
)

/* harmony default export */ var components_landings_MDataDiagnostic = (MDataDiagnostic_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MUserData.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MUserData = ({
  components: {
    MCardOrder: components_landings_MCardOrder,
    MDataDiagnostic: components_landings_MDataDiagnostic
  },
  data: function data() {
    return {
      states: this.$store.state.user
    };
  },

  computed: {
    position1: function position1() {
      if (!this.states.init.userPoint) {
        return 'blank';
      } else {
        return 'point';
      }
    },
    position2: function position2() {
      if (!this.states.init.recentOrder || !this.states.init.saveOrder) {
        return 'blank';
      } else if (this.states.recentOrder.length === 0 & this.states.saveOrder.length === 0) {
        return 'video';
      } else if (this.states.saveOrder.length > 0 && this.states.recentOrder.length > 0) {
        return 'recentOrder';
      } else {
        return 'video';
      }
    },
    position3: function position3() {
      if (!this.states.init.recentOrder || !this.states.init.saveOrder) {
        return 'blank';
      } else if (this.states.recentOrder.length === 0 & this.states.saveOrder.length === 0) {
        return 'refer';
      } else if (this.states.saveOrder.length > 0) {
        return 'saveOrder';
      } else {
        return 'recentOrder';
      }
    }
  },
  methods: {
    dataDiagnostic: function dataDiagnostic() {
      this.$root.$emit('bv::show::modal', 'modalDataDiagnostic');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-418af248","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MUserData.vue
var MUserData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('m-data-diagnostic'),_vm._v(" "),_c('b-col',{staticClass:"m-cards-col",attrs:{"cols":"12","md":"12","lg":"4","xl":"4"}},[(_vm.position1 === 'blank')?_c('div',{staticClass:"m-card"},[_c('div',{staticClass:"spinner"})]):_vm._e(),_vm._v(" "),(_vm.position1 == 'point')?_c('div',{staticClass:"m-card"},[_c('b-row',[_c('b-col',{staticClass:"min-col-border",attrs:{"cols":"3"}},[_c('img',{staticClass:"user x-large",attrs:{"src":_vm.$store.state.site.UserImg}})]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('p',[_vm._v(" Welcome "),_c('strong',[_vm._v(_vm._s(_vm.$store.state.site.User_FullName)+"!")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"dated"},[_vm._v("CUSTOMER SINCE "+_vm._s(_vm._f("formatYear")(_vm.states.userInfo.CrtTimestamp)))])]),_vm._v(" "),_c('div',{attrs:{"id":"rewards"}},[_vm._v("\n            Rewards Points"),_c('br'),_vm._v(" "),_c('span',{staticClass:"points"},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.states.userPoint,'', 0)))])])])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$router.push('reward')}}},[_vm._v("REDEEM POINTS")])])],1):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"m-cards-col",attrs:{"cols":"12","md":"12","lg":"4","xl":"4"}},[(_vm.position2 === 'blank')?_c('div',{staticClass:"m-card"},[_c('div',{staticClass:"spinner"})]):_vm._e(),_vm._v(" "),(_vm.position2 == 'video')?_c('div',{staticClass:"m-card",staticStyle:{"text-align":"center"}},[_c('a',{attrs:{"data-fancybox":"","href":"https://vimeo.com/305828142"}},[_c('img',{staticStyle:{"max-width":"300px","width":"100%"},attrs:{"src":"https://www.sl360.com/images/sl360_video_thumb_V6.jpg","alt":"SL360 Video Tour"}})])]):_vm._e(),_vm._v(" "),(_vm.position2 == 'recentOrder')?_c('m-card-order',{staticStyle:{"margin-top":"24px"},attrs:{"orderType":"recentOrder","orders":_vm.states.recentOrder}},[_c('span',{staticStyle:{"display":"flex"},attrs:{"slot":"title"},slot:"title"},[_c('div',[_vm._v("Recent Order ")]),_c('a',{attrs:{"data-fancybox":"","href":"https://vimeo.com/388283376/beebf2a74b"}},[_c('img',{attrs:{"src":__webpack_require__("aQR6"),"alt":"Video"}})])]),_vm._v(" "),_c('a',{attrs:{"slot":"footer","href":_vm.$store.getters['config/link']('history')},slot:"footer"},[_vm._v("VIEW MORE >")])]):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"m-cards-col",attrs:{"cols":"12","md":"12","lg":"4","xl":"4"}},[(_vm.position3 === 'blank')?_c('div',{staticClass:"m-card"},[_c('div',{staticClass:"spinner"})]):_vm._e(),_vm._v(" "),(_vm.position3 == 'refer')?_c('div',{staticClass:"m-card"},[_c('b-row',[_c('p',{staticStyle:{"margin-top":"-12px"}},[_vm._v(" New Data Diagnostic! The Data Diagnostic is a report that shows the accuracy of your postal, phone, and email data compared to industry norms, and the potential cost savings and revenue boost you can expect by refreshing your data. If your database has 100,000 or more records, you are eligible for a FREE Data Diagnostic.")])]),_vm._v(" "),_c('b-row',{staticClass:"m-card-footer"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":"#"},on:{"click":_vm.dataDiagnostic}},[_vm._v("Tell Me More")])])],1):_vm._e(),_vm._v(" "),(_vm.position3 == 'saveOrder')?_c('m-card-order',{attrs:{"orders":_vm.states.saveOrder,"orderType":"savedOrder"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Saved Order")]),_vm._v(" "),_c('a',{attrs:{"slot":"footer","href":_vm.$store.getters['config/link']('mysavecount')},slot:"footer"},[_vm._v("VIEW MORE >")])]):_vm._e(),_vm._v(" "),(_vm.position3 == 'recentOrder')?_c('m-card-order',{attrs:{"orders":_vm.states.recentOrder,"orderType":"recentOrder"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Recent Order")]),_vm._v(" "),_c('a',{attrs:{"slot":"footer","href":_vm.$store.getters['config/link']('history')},slot:"footer"},[_vm._v("VIEW MORE >")])]):_vm._e()],1)],1)}
var MUserData_staticRenderFns = []
var MUserData_esExports = { render: MUserData_render, staticRenderFns: MUserData_staticRenderFns }
/* harmony default export */ var landings_MUserData = (MUserData_esExports);
// CONCATENATED MODULE: ./src/components/landings/MUserData.vue
function MUserData_injectStyle (ssrContext) {
  __webpack_require__("gvFx")
}
var MUserData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MUserData___vue_template_functional__ = false
/* styles */
var MUserData___vue_styles__ = MUserData_injectStyle
/* scopeId */
var MUserData___vue_scopeId__ = "data-v-418af248"
/* moduleIdentifier (server only) */
var MUserData___vue_module_identifier__ = null
var MUserData_Component = MUserData_normalizeComponent(
  MUserData,
  landings_MUserData,
  MUserData___vue_template_functional__,
  MUserData___vue_styles__,
  MUserData___vue_scopeId__,
  MUserData___vue_module_identifier__
)

/* harmony default export */ var components_landings_MUserData = (MUserData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MModalCreateAccount.vue
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MModalCreateAccount = ({
  data: function data() {
    return {
      name: ''
    };
  },

  methods: {
    create: function create(evt) {
      var _this = this;

      evt.preventDefault();
      if (this.name.length === 0) {
        notification.notice('warning', 'Please Enter Account Name!');
        return;
      }
      this.$http.post('LandingPage.aspx/CreateAccount', {
        AccountName: this.name
      }).then(function (resp) {
        if (resp.body.d.DataSource) {
          notification.notice('success', 'Create successfully');
          _this.$nextTick(function () {
            _this.$root.$emit('bv::hide::modal', 'modelAddAccount');
          });
          _this.$store.dispatch('user/getUserInit');
        }
      }, function (resp) {
        notification.notice('error', 'Failed to Create Account , please try again');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fd559c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MModalCreateAccount.vue
var MModalCreateAccount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modelAddAccount","size":"lg","title":"Create A New Account"},on:{"ok":_vm.create}},[_vm._v("\n  Please Enter New Account Name\n  "),_c('b-form-input',{model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)}
var MModalCreateAccount_staticRenderFns = []
var MModalCreateAccount_esExports = { render: MModalCreateAccount_render, staticRenderFns: MModalCreateAccount_staticRenderFns }
/* harmony default export */ var landings_MModalCreateAccount = (MModalCreateAccount_esExports);
// CONCATENATED MODULE: ./src/components/landings/MModalCreateAccount.vue
function MModalCreateAccount_injectStyle (ssrContext) {
  __webpack_require__("LUED")
}
var MModalCreateAccount_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MModalCreateAccount___vue_template_functional__ = false
/* styles */
var MModalCreateAccount___vue_styles__ = MModalCreateAccount_injectStyle
/* scopeId */
var MModalCreateAccount___vue_scopeId__ = "data-v-5fd559c9"
/* moduleIdentifier (server only) */
var MModalCreateAccount___vue_module_identifier__ = null
var MModalCreateAccount_Component = MModalCreateAccount_normalizeComponent(
  MModalCreateAccount,
  landings_MModalCreateAccount,
  MModalCreateAccount___vue_template_functional__,
  MModalCreateAccount___vue_styles__,
  MModalCreateAccount___vue_scopeId__,
  MModalCreateAccount___vue_module_identifier__
)

/* harmony default export */ var components_landings_MModalCreateAccount = (MModalCreateAccount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MHero.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MHero = ({
  components: { MModalCreateAccount: components_landings_MModalCreateAccount },
  data: function data() {
    return {
      item: {},
      status: this.$store.state.user,
      datasourceImage: [{ 10: '../../../static/img/datasource/consumer.png' }, { 170: '../../../static/img/datasource/business.png' }]
    };
  },

  computed: {
    topBtns: function topBtns() {
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.status.userDataSources), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.ListType === 10 || item.ListType === 170) {
            result.push(item);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    normalBtns: function normalBtns() {
      var result = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.status.userDataSources), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item.ListType !== 10 && item.ListType !== 170) {
            result.push(item);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return result;
    },
    userServiceDataSources: function userServiceDataSources() {
      return this.$store.state.user.userServiceDataSources;
    },
    accountList: function accountList() {
      return this.$store.getters['user/accountList'];
    },

    accountId: {
      get: function get() {
        return this.$store.getters['user/accountId'];
      },
      set: function set(val) {
        this.$store.commit('user/saveKey', ['accountId', val]);
      }
    },
    menus: function menus() {
      var result = [{
        title: 'Append Demographics or Psychographics',
        benefit: 'Gives your customer database more segmentation capabilities and helps you better communicate with customers around their interests and life stage.',
        link: 'enhanceList',
        icon: 'share-alt',
        type: 'enhance',
        show: this.userServiceDataSources.showEnhanceList
      }, {
        title: 'Clean your Database',
        benefit: 'Save money avoiding duplicate and undeliverable mail, and marketing to only those qualified for your product or service.',
        link: 'cleanList',
        icon: 'eraser',
        type: 'clean',
        show: this.userServiceDataSources.showCleanList
      }, {
        title: 'Append Email Addresses',
        benefit: 'Adding email addresses to your database helps you communicate with customers through a new and low-cost channel.',
        link: 'emailAppend',
        icon: 'envelope-open-o',
        type: 'enhance',
        show: this.userServiceDataSources.showEmailAppend
      }, {
        title: 'Verify Email Addresses',
        benefit: 'Reduces undeliverable email which helps keep your sender reputation strong so ESPs continue delivering your email.',
        link: 'emailVerification',
        icon: 'envelope-o',
        type: 'clean',
        show: this.userServiceDataSources.showEmailVerification
      }, {
        title: 'Append Phone Numbers',
        benefit: 'Provides an additional and low cost channel to communicate with customers.',
        link: 'phoneAppend',
        icon: 'phone',
        type: 'enhance',
        show: this.userServiceDataSources.showPhoneAppend
      }, {
        title: 'Reverse Phone Append',
        benefit: 'Helps reveal who contacted you and enables you to reach them via direct mail.',
        link: 'phoneReverse',
        icon: 'phone',
        type: 'enhance',
        show: this.userServiceDataSources.showPhoneReverse
      }, {
        title: 'Reverse Email Append',
        benefit: 'Helps reveal who contacted you and enables you to reach them via direct mail.',
        link: 'reverseEmailAppend',
        icon: 'envelope-open-o',
        type: 'enhance',
        show: this.userServiceDataSources.showEmailReverse || this.userServiceDataSources.showEmailAppend
      }, {
        title: 'Phone Confirmation & Append',
        benefit: 'Saves you time calling bad numbers and improves your connection rate with customers.',
        link: 'phoneVerification',
        icon: 'volume-control-phone',
        type: 'clean',
        show: this.userServiceDataSources.showPhoneVerification
      }];
      return result;
    },
    showHistoryMenu: function showHistoryMenu() {
      if (this.$store.state.user.ShowDigitalHistory && this.$store.state.user.ShowOrderHistory) {
        return true;
      } else {
        return false;
      }
    },
    showOrderHistoryMenu: function showOrderHistoryMenu() {
      if (!this.$store.state.user.ShowDigitalHistory && this.$store.state.user.ShowOrderHistory) {
        return true;
      } else {
        return false;
      }
    },
    showDigitalHistoryMenu: function showDigitalHistoryMenu() {
      if (this.$store.state.user.ShowDigitalHistory && !this.$store.state.user.ShowOrderHistory) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    next: function next(listType) {
      this.$router.push({
        name: 'order',
        params: {
          listType: listType
        }
      });
    },
    serviceList: function serviceList(type) {
      return lodash_default.a.filter(this.menus, function (item) {
        return item.type === type && item.show;
      }).length > 0;
    },
    getImageNmae: function getImageNmae(listType) {
      if (listType === 80 || listType === 220 || listType === 230 || listType === 240 || listType === 100 || listType === 250 || listType === 270 || listType === 150) {
        return 10;
      } else if (listType === 140) {
        return 60;
      } else if (listType === 130) {
        return 50;
      } else if (listType === 90 || listType === 120 || listType === 160 || listType === 170 || listType === 260) {
        return 20;
      } else {
        return listType;
      }
    },
    showCreateAccount: function showCreateAccount() {
      this.$root.$emit('bv::show::modal', 'modelAddAccount');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d53e71","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MHero.vue
var MHero_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-modal-create-account'),_vm._v(" "),_c('b-tabs',{attrs:{"content-class":"mt-5","active-nav-item-class":"navitemactive","fill":""}},[_c('b-tab',{attrs:{"title":"Reach My Audience","title-link-class":"navitem","active":""}},[_c('b-row',{staticClass:"m-hero-title"},[_c('b-col',[_c('h1',[_vm._v("\n          Reach My Audience\n        ")]),_vm._v(" "),(_vm.topBtns.length===0&&_vm.normalBtns.length===0)?_c('p',{staticClass:"mt-2"},[_vm._v("In this section you may choose an audience using a variety of filters for a direct mail, digital, and/or telemarketing campaign. Contact us at "),_c('b-link',{attrs:{"href":"tel://800-399-8611"}},[_vm._v("800-399-8611")]),_vm._v(" or at "),_c('b-link',{attrs:{"href":"mailto:support@sl360.com"}},[_vm._v("support@sl360.com")]),_vm._v(" to activate this section of your account.")],1):_vm._e()])],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"-60px","margin-bottom":"24px"},attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"sm":"8","md":"8"}}),_vm._v(" "),_c('b-col',[_c('b-form-select',{model:{value:(_vm.accountId),callback:function ($$v) {_vm.accountId=$$v},expression:"accountId"}},_vm._l((_vm.accountList),function(item){return _c('option',{domProps:{"value":item.AccountId}},[_vm._v("\n              "+_vm._s(item.AccountName)+"\n            ")])}),0)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('span',{directives:[{name:"b-modal",rawName:"v-b-modal.modelAddAccount",modifiers:{"modelAddAccount":true}}],staticStyle:{"padding-left":"10px","cursor":"pointer","color":"#f66","font-weight":"bold"}},[_c('icon',{attrs:{"name":"plus-circle"}})],1)])],1),_vm._v(" "),(_vm.topBtns.length!==0||_vm.normalBtns.length!==0)?_c('b-row',{attrs:{"align-h":"center"}},[_vm._l((_vm.topBtns),function(item){return _c('b-col',{key:item.ListType,attrs:{"sm":"2","md":"2","lg":"2"}},[_c('div',{staticClass:"datasource-item"},[_c('div',[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.next(item.ListType)}}},[_c('img',{attrs:{"src":'./static/img/datasource/'+ _vm.getImageNmae(item.ListType) +'_v3.png'}})])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"datasource-a",attrs:{"href":"javascript:void(0);"},domProps:{"textContent":_vm._s(item.Desc.toUpperCase())},on:{"click":function($event){return _vm.next(item.ListType)}}})])])])}),_vm._v(" "),_vm._l((_vm.normalBtns),function(item){return _c('b-col',{key:item.ListType,attrs:{"sm":"2","md":"2","lg":"2"}},[_c('div',{staticClass:"datasource-item"},[_c('div',[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.next(item.ListType)}}},[_c('img',{attrs:{"src":'./static/img/datasource/'+ _vm.getImageNmae(item.ListType) +'_v3.png'}})])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"datasource-a",attrs:{"href":"javascript:void(0);"},domProps:{"textContent":_vm._s(item.Desc.toUpperCase())},on:{"click":function($event){return _vm.next(item.ListType)}}})])])])})],2):_vm._e()],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Enhance Your Data","title-link-class":"navitem"}},[_c('b-row',{staticClass:"m-hero-title"},[_c('b-col',[_c('h1',[_vm._v("\n            Enhance Your Data\n          ")]),_vm._v(" "),(_vm.serviceList('enhance'))?_c('p',{staticClass:"mt-2"},[_vm._v("Append our data to your current book of business so you can segment and target customers better.")]):_vm._e(),_vm._v(" "),(!_vm.serviceList('enhance'))?_c('p',{staticClass:"mt-2"},[_vm._v("In this section you are able to append any combination of demographic, psychographic, and contact information (e.g. phone numbers, email addresses, postal addresses) to your customer database. Contact us at "),_c('b-link',{attrs:{"href":"tel://800-399-8611"}},[_vm._v("800-399-8611")]),_vm._v(" or at "),_c('b-link',{attrs:{"href":"mailto:support@sl360.com"}},[_vm._v("support@sl360.com")]),_vm._v(" to activate this section of your account.")],1):_vm._e()])],1),_vm._v(" "),(_vm.serviceList('enhance'))?_c('b-row',{attrs:{"align-h":"center"}},_vm._l((_vm.menus),function(menu){return (menu.type === 'enhance' && menu.show)?_c('b-col',{key:_vm.item.link,attrs:{"sm":"3","md":"3","lg":"3"}},[_c('div',{staticClass:"datasource-item"},[_c('div',[_c('a',{attrs:{"href":_vm.$store.getters['config/link'](menu.link)}},[_c('img',{attrs:{"src":'./static/img/datasource/'+ menu.link +'.png'}})])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"datasource-a",attrs:{"href":"$store.getters['config/link'](menu.link)"},domProps:{"textContent":_vm._s(menu.title.toUpperCase())}})])])]):_vm._e()}),1):_vm._e()],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Clean & Verify Your Data","title-link-class":"navitem"}},[_c('b-row',{staticClass:"m-hero-title"},[_c('b-col',[_c('h1',[_vm._v("\n            Clean & Verify Your Data\n          ")]),_vm._v(" "),(_vm.serviceList('clean'))?_c('p',{staticClass:"mt-2"},[_vm._v("De-duplicate records, correct undeliverable addresses and screen for privacy… all to save time and money.")]):_vm._e(),_vm._v(" "),(!_vm.serviceList('clean'))?_c('p',{staticClass:"mt-2"},[_vm._v("\n            In this section you are able to refresh the contact information in your database and flag records with privacy concerns (e.g. Do Not Contact, Underage). Contact us at "),_c('b-link',{attrs:{"href":"tel://800-399-8611"}},[_vm._v("800-399-8611")]),_vm._v(" or at "),_c('b-link',{attrs:{"href":"mailto:support@sl360.com"}},[_vm._v("support@sl360.com")]),_vm._v(" to activate this section of your account.\n          ")],1):_vm._e()])],1),_vm._v(" "),(_vm.serviceList('clean'))?_c('b-row',{attrs:{"align-h":"center"}},_vm._l((_vm.menus),function(menu){return (menu.type === 'clean' && menu.show)?_c('b-col',{key:_vm.item.link,attrs:{"sm":"3","md":"3","lg":"3"}},[_c('div',{staticClass:"datasource-item"},[_c('div',[_c('a',{attrs:{"href":_vm.$store.getters['config/link'](menu.link)}},[_c('img',{attrs:{"src":'./static/img/datasource/'+ menu.link +'.png'}})])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"datasource-a",attrs:{"href":"$store.getters['config/link'](menu.link)"},domProps:{"textContent":_vm._s(menu.title.toUpperCase())}})])])]):_vm._e()}),1):_vm._e()],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Analyze My Customers","title-link-class":"navitem"}},[_c('b-row',{staticClass:"m-hero-title"},[_c('b-col',[_c('h1',[_vm._v("\n            Analyze My Customers\n          ")]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("Gain insight into the demographic and psychographic characteristics of your customers, and identify prospects likely to become new customers.")]),_vm._v(" "),(false)?_c('p',{staticClass:"mt-2"},[_vm._v("In this section you can order reports which provide insight into the demographic and psychographic composition of your customers including which characteristics they’re more likely to have relative to all adults in your area. Contact us at "),_c('b-link',{attrs:{"href":"tel://800-399-8611"}},[_vm._v("800-399-8611")]),_vm._v(" or at "),_c('b-link',{attrs:{"href":"mailto:support@sl360.com"}},[_vm._v("support@sl360.com")]),_vm._v(" to activate this section of your account.")],1):_vm._e()])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"sm":"5","md":"5","lg":"5"}},[_c('div',{staticClass:"datasource-item"},[_c('div',[_c('a',{attrs:{"href":_vm.$store.getters['config/link']('portaitreports')}},[_c('img',{attrs:{"src":'./static/img/datasource/portaitreports_v3.png'}})])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"datasource-a",attrs:{"href":"$store.getters['config/link']('portaitreports')"},domProps:{"textContent":_vm._s('Customer Portrait Reports'.toUpperCase())}})])])])],1)],1)],1)],1)}
var MHero_staticRenderFns = []
var MHero_esExports = { render: MHero_render, staticRenderFns: MHero_staticRenderFns }
/* harmony default export */ var landings_MHero = (MHero_esExports);
// CONCATENATED MODULE: ./src/components/landings/MHero.vue
function MHero_injectStyle (ssrContext) {
  __webpack_require__("xcFm")
  __webpack_require__("xYc4")
}
var MHero_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MHero___vue_template_functional__ = false
/* styles */
var MHero___vue_styles__ = MHero_injectStyle
/* scopeId */
var MHero___vue_scopeId__ = "data-v-29d53e71"
/* moduleIdentifier (server only) */
var MHero___vue_module_identifier__ = null
var MHero_Component = MHero_normalizeComponent(
  MHero,
  landings_MHero,
  MHero___vue_template_functional__,
  MHero___vue_styles__,
  MHero___vue_scopeId__,
  MHero___vue_module_identifier__
)

/* harmony default export */ var components_landings_MHero = (MHero_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MV2.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MV2 = ({
  components: {
    MUserData: components_landings_MUserData,
    MHero: components_landings_MHero
  },
  data: function data() {
    return {
      firstUserName: window.first.userName,
      secondDatasource: {}
    };
  },

  computed: {
    username: function username() {
      if (this.firstUserName) {
        return this.firstUserName;
      } else {
        return this.$store.state.site.User_FullName || '';
      }
    },
    welcomeText: function welcomeText() {
      var text = '';
      var now = new Date().getHours();
      if (now >= 5 && now < 12) {
        text = 'Good Morning';
      } else if (now >= 12 && now < 18) {
        text = 'Good Afternoon';
      } else if (now >= 18 && now < 22) {
        text = 'Good Evening';
      } else {
        text = 'Good Night';
      }
      return text + ', ';
    },
    userDataSources: function userDataSources() {
      return this.$store.state.user.userDataSources;
    },
    userServiceDataSources: function userServiceDataSources() {
      return this.$store.state.user.userServiceDataSources;
    },
    normalBtns: function normalBtns() {
      var result = [];
      var isSaturation = false;
      var hasBusiness = false;

      for (var i = 0; i < this.userDataSources.length; i++) {
        var item = this.userDataSources[i];

        if (item.ListType === 170) {
          hasBusiness = true;
          this.secondDatasource = item;
        }
        if (item.ListType === 50) {
          isSaturation = true;
        } else if (item.ListType !== 10 && item.ListType !== 170) {
          result.push(item);
        }
      }

      if (isSaturation) {
        for (var _i = 0; _i < this.userDataSources.length; _i++) {
          var _item = this.userDataSources[_i];
          if (_item.ListType === 50) {
            _item.Desc = 'Occupant/Saturation';
            result.push(_item);
          }
        }
      }
      if (!hasBusiness) {
        this.secondDatasource = result[0];
        result.shift();
      }
      if (!this.secondDatasource) {
        this.secondDatasource = {};
      }
      return result;
    },
    datasourceWidth: function datasourceWidth() {
      var num = this.normalBtns.length;
      if (num === 1) {
        return 'calc(100% - 32px)';
      } else if (num === 2) {
        return 'calc(50% - 32px)';
      } else if (num === 3 || num === 5 || num === 6 || num === 9 || num === 12) {
        return 'calc(33.33% - 32px)';
      } else {
        return 'calc(25% - 32px)';
      }
    },

    blockClass: {
      get: function get() {
        if (this.$store.state.user.ShowVideos) {
          return 'col-sm-12 col-md-3';
        } else {
          return 'col-sm-12 col-md-3';
        }
      }
    },
    videoVisibleFlag: function videoVisibleFlag() {
      if (this.$store.state.user.ShowVideos) {
        return 'margin-bottom: 16px';
      } else {
        return 'margin-bottom: 16px;display: none';
      }
    }
  },
  methods: {
    go: function go(listType) {
      this.$router.push({
        name: 'order',
        params: {
          listType: listType
        }
      });
    },
    gotoVideo: function gotoVideo() {
      this.$router.push({
        name: 'videos'
      });
    },
    showDigital: function showDigital() {
      this.$root.$emit('bv::show::modal', 'modelDigitalCampaigns');
    },
    showContactUs: function showContactUs() {
      this.$root.$emit('bv::show::modal', 'modalContactUs');
    },
    showContactUsFreeDiagnostic: function showContactUsFreeDiagnostic() {
      this.$root.$emit('bv::show::modal', 'modalContactUsFreeDiagnostic');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20fad62c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MV2.vue
var MV2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",attrs:{"id":"landing-top"}},[_c('article',{staticClass:"container-fluid"},[_c('section',{staticClass:"container"},[_c('div',{staticClass:"jumbotron"},[_c('m-hero'),_vm._v(" "),_c('m-user-data')],1)])])])}
var MV2_staticRenderFns = []
var MV2_esExports = { render: MV2_render, staticRenderFns: MV2_staticRenderFns }
/* harmony default export */ var landings_MV2 = (MV2_esExports);
// CONCATENATED MODULE: ./src/components/landings/MV2.vue
function MV2_injectStyle (ssrContext) {
  __webpack_require__("M27I")
}
var MV2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MV2___vue_template_functional__ = false
/* styles */
var MV2___vue_styles__ = MV2_injectStyle
/* scopeId */
var MV2___vue_scopeId__ = "data-v-20fad62c"
/* moduleIdentifier (server only) */
var MV2___vue_module_identifier__ = null
var MV2_Component = MV2_normalizeComponent(
  MV2,
  landings_MV2,
  MV2___vue_template_functional__,
  MV2___vue_styles__,
  MV2___vue_scopeId__,
  MV2___vue_module_identifier__
)

/* harmony default export */ var components_landings_MV2 = (MV2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MV4.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MV4 = ({
  data: function data() {
    return {
      firstUserName: window.first.userName,
      secondDatasource: {}
    };
  },

  computed: {
    username: function username() {
      if (this.firstUserName) {
        return this.firstUserName;
      } else {
        return this.$store.state.site.User_FullName || '';
      }
    },
    welcomeText: function welcomeText() {
      var text = '';
      var now = new Date().getHours();
      if (now >= 5 && now < 12) {
        text = 'Good Morning';
      } else if (now >= 12 && now < 18) {
        text = 'Good Afternoon';
      } else if (now >= 18 && now < 22) {
        text = 'Good Evening';
      } else {
        text = 'Good Night';
      }
      return text + ', ';
    },
    userDataSources: function userDataSources() {
      return this.$store.state.user.userDataSources;
    },
    userServiceDataSources: function userServiceDataSources() {
      return this.$store.state.user.userServiceDataSources;
    },
    normalBtns: function normalBtns() {
      var result = [];
      var isSaturation = false;
      var hasBusiness = false;
      for (var i = 0; i < this.userDataSources.length; i++) {
        var item = this.userDataSources[i];
        if (item.ListType === 170) {
          hasBusiness = true;
          this.secondDatasource = item;
        }
        if (item.ListType === 50) {
          isSaturation = true;
        } else if (item.ListType !== 10 && item.ListType !== 170) {
          result.push(item);
        }
      }
      if (isSaturation) {
        for (var _i = 0; _i < this.userDataSources.length; _i++) {
          var _item = this.userDataSources[_i];
          if (_item.ListType === 50) {
            _item.Desc = 'Occupant/Saturation';
            result.push(_item);
          }
        }
      }
      if (!hasBusiness) {
        this.secondDatasource = result[0];
        result.shift();
      }
      if (!this.secondDatasource) {
        this.secondDatasource = {};
      }
      return result;
    },
    datasourceWidth: function datasourceWidth() {
      var num = this.normalBtns.length;
      if (num === 1) {
        return 'calc(100% - 32px)';
      } else if (num === 2) {
        return 'calc(50% - 32px)';
      } else if (num === 3 || num === 5 || num === 6 || num === 9 || num === 12) {
        return 'calc(33.33% - 32px)';
      } else {
        return 'calc(25% - 32px)';
      }
    },

    blockClass: {
      get: function get() {
        if (this.$store.state.user.ShowVideos) {
          return 'col-sm-12 col-md-3';
        } else {
          return 'col-sm-12 col-md-4';
        }
      }
    },
    videoVisibleFlag: function videoVisibleFlag() {
      if (this.$store.state.user.ShowVideos) {
        return 'margin-bottom: 16px';
      } else {
        return 'margin-bottom: 16px;display: none';
      }
    }
  },
  methods: {
    go: function go(listType) {
      this.$router.push({
        name: 'order',
        params: {
          listType: listType
        }
      });
    },
    gotoVideo: function gotoVideo() {
      this.$router.push({
        name: 'videos'
      });
    },
    showDigital: function showDigital() {
      this.$root.$emit('bv::show::modal', 'modelDigitalCampaigns');
    },
    showContactUs: function showContactUs() {
      this.$root.$emit('bv::show::modal', 'modalContactUs');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e08bf37c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MV4.vue
var MV4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"container-fluid",attrs:{"id":"landing-top"}},[_c('section',{staticClass:"container-fluid hero"},[_c('div',{staticClass:"container"},[_c('h1',{attrs:{"id":"Greeting"}},[_vm._v(_vm._s(_vm.welcomeText)+" "+_vm._s(_vm.username))]),_vm._v(" "),_c('h2',{attrs:{"id":"Purpose"}},[_vm._v("What would you like to do today?")])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{class:_vm.blockClass,staticStyle:{"margin-bottom":"16px"}},[_c('div',{staticClass:"card banner-card-block"},[_c('img',{staticClass:"card-img-top",attrs:{"src":__webpack_require__("bKA3"),"alt":"Increase your brand's reach to new prospects"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('b-btn',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#prospects'),expression:"'#prospects'"}],staticClass:"btn btn-outline-secondary"},[_vm._v("Tell me more")])],1)])]),_vm._v(" "),_c('div',{class:_vm.blockClass,staticStyle:{"margin-bottom":"16px"}},[_c('div',{staticClass:"card banner-card-block"},[_c('img',{staticClass:"card-img-top",attrs:{"src":__webpack_require__("dE4I"),"alt":"Discover more facets of your customers"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('b-btn',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#service'),expression:"'#service'"}],staticClass:"btn btn-outline-secondary"},[_vm._v("Tell me more")])],1)])]),_vm._v(" "),_c('div',{class:_vm.blockClass,staticStyle:{"margin-bottom":"16px"}},[_c('div',{staticClass:"card banner-card-block"},[_c('img',{staticClass:"card-img-top",attrs:{"src":__webpack_require__("rzMY"),"alt":"Learn hor your customers fit together"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('b-btn',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#analyze'),expression:"'#analyze'"}],staticClass:"btn btn-outline-secondary"},[_vm._v("Tell me more")])],1)])]),_vm._v(" "),_c('div',{class:_vm.blockClass,style:(_vm.videoVisibleFlag)},[_c('div',{staticClass:"card banner-card-block"},[_c('img',{staticClass:"card-img-top",attrs:{"src":__webpack_require__("lfGP"),"alt":""}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('b-btn',{staticClass:"btn btn-outline-secondary",on:{"click":_vm.gotoVideo}},[_vm._v("Show Me")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._v("\n       \n    ")])]),_vm._v(" "),_c('section',{staticClass:"container"},[_c('div',{staticClass:"jumbotron"},[_c('h2',{staticClass:"display-4",attrs:{"id":"prospects"}},[_vm._v("Reach new prospects")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Connect with your best prospects through privacy-compliant digital or traditional channels to win new customers. Do it yourself or work with a specialist.")]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('h3',[_vm._v("Order a mailing list")]),_vm._v(" "),_c('p',[_vm._v("Build, order and download a new list of prospects in just minutes. Add phone numbers (where available) for follow-up.")]),_vm._v(" "),_c('div',{staticClass:"card-deck"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body box-btn-parent"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":"shopping-bag","scale":"1.5"}}),_vm._v("\n              Consumers")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Reach your best prospects using the widest selection of demographic lifestyle, and purchase behavior selection options.")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box box-btn-box-high"},[_c('b-btn',{staticClass:"btn btn-outline-primary",attrs:{"data-test":"landing-datasource-10"},on:{"click":function($event){return _vm.go(10)}}},[_vm._v("\n                Start here"),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body box-btn-parent"},[_c('h5',{staticClass:"card-title"},[(_vm.secondDatasource.icon)?_c('icon',{staticClass:"box-icon",attrs:{"name":_vm.secondDatasource.icon,"scale":"1.5"}}):_vm._e(),_vm._v("\n              "+_vm._s(_vm.secondDatasource.title)+"\n            ")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.secondDatasource.brief || 'First choose a geographic area, and then refine your targeting with demographics, interests and propensities.'))]),_vm._v(" "),_c('div',{staticClass:"box-btn-box box-btn-box-high"},[_c('b-btn',{staticClass:"btn btn-outline-primary",attrs:{"data-test":'landing-datasource-' + _vm.secondDatasource.ListType},on:{"click":function($event){return _vm.go(_vm.secondDatasource.ListType)}}},[_vm._v("\n                Start here"),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"card-deck",staticStyle:{"margin-top":"0","display":"flex","justify-content":"flex-start","align-items":"stretch"}},_vm._l((_vm.normalBtns),function(item){return _c('div',{key:item.ListType,staticClass:"card",staticStyle:{"margin-top":"16px","flex-grow":"0"},style:({'min-width': _vm.datasourceWidth})},[_c('div',{staticClass:"card-body box-btn-parent"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":item.icon,"scale":"1.5"}}),_vm._v("\n              "+_vm._s(item.title)+"\n            ")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(item.brief || 'First choose a geographic area, and then refine your targeting with demographics, interests and propensities.'))]),_vm._v(" "),_c('div',{staticClass:"box-btn-box box-btn-box-high"},[_c('b-btn',{staticClass:"btn btn-outline-primary",attrs:{"data-test":'landing-datasource-' + item.ListType},on:{"click":function($event){return _vm.go(item.ListType)}}},[_vm._v("\n                Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)],1)])])}),0),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('h3',[_vm._v("Begin a digital campaign")]),_vm._v(" "),_c('p',[_vm._v("Tell us your goals and budget. Our experts will craft and manage a full-service campaign for you.")]),_vm._v(" "),_c('div',{staticClass:"card-deck"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body box-btn-parent"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":"at","scale":"1.5"}}),_vm._v(" Choose email")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Reach new prospects more effectively via email with help from our digital experts, who manage campaigns for some of the nation's leading brands.")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box box-btn-box-high"},[_c('b-btn',{staticClass:"btn btn-outline-primary",on:{"click":_vm.showDigital}},[_vm._v("Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body box-btn-parent-sm"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",staticStyle:{"margin-right":"4px"},attrs:{"name":"desktop","scale":"1.5"}}),_vm._v("Choose display & social")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Deploy campaigns to the devices and networks people check every day. Our team will help you make a good first (and following) impression.")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box box-btn-box-high"},[_c('b-btn',{staticClass:"btn btn-outline-primary",on:{"click":_vm.showDigital}},[_vm._v("Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body box-btn-parent-sm"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":"share-alt","scale":"1.5"}}),_vm._v(" Choose multi-channel")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Multi-channel marketing increases your visibility and reinforces your messaging. Trust our digital experts to build a mix that's right for you.")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box box-btn-box-high"},[_c('b-btn',{staticClass:"btn btn-outline-primary",on:{"click":_vm.showDigital}},[_vm._v("Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)],1)])])])]),_vm._v(" "),(_vm.userServiceDataSources.showEnhanceList||_vm.userServiceDataSources.showEmailAppend||_vm.userServiceDataSources.showPhoneAppend||_vm.userServiceDataSources.showPhoneReverse||_vm.userServiceDataSources.showEmailReverse||_vm.userServiceDataSources.showCleanList||_vm.userServiceDataSources.showEmailVerification||_vm.userServiceDataSources.showPhoneVerification)?_c('div',{staticClass:"jumbotron"},[_c('h2',{staticClass:"display-4",attrs:{"id":"service"}},[_vm._v("Manage your customer data")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Improve and enrich the information in your customer database. Simply choose a service and load your file. Go refill your coffee and your updated file may already be waiting for you!")]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),(_vm.userServiceDataSources.showEnhanceList||_vm.userServiceDataSources.showEmailAppend||_vm.userServiceDataSources.showPhoneAppend||_vm.userServiceDataSources.showPhoneReverse||_vm.userServiceDataSources.showEmailReverse)?_c('div',[_c('h3',[_vm._v("Enhance your data")]),_vm._v(" "),_c('p',[_vm._v("Append our data to your current book of business so you can segment and target customers better. Send more relevant messaging and offers, for better ROI.")]),_vm._v(" "),_c('div',{staticClass:"card-deck"},[(_vm.userServiceDataSources.showEnhanceList)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body box-btn-parent"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":"adn","scale":"1.5"}}),_vm._v(" Append demographics or psychographics")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Add demographic and interest data to your customer database for more personalized communications.")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":_vm.$store.getters['config/link']('enhanceList')}},[_vm._v("Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.userServiceDataSources.showEmailAppend)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body box-btn-parent"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":"envelope","scale":"1.5"}}),_vm._v(" Append email addresses")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Match privacy-compliant email addresses to your customers so you can contact them through this low-cost service.")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":_vm.$store.getters['config/link']('emailAppend')}},[_vm._v("Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-deck",staticStyle:{"margin-top":"2.0rem"}},[(_vm.userServiceDataSources.showPhoneAppend)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body box-btn-parent"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":"phone","scale":"1.5"}}),_vm._v(" Append phone numbers")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Add phone numbers to your customer data for direct sales or for follow-up on a campaign sent via another channel.")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":_vm.$store.getters['config/link']('phoneAppend')}},[_vm._v("Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.userServiceDataSources.showPhoneReverse)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body box-btn-parent"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":"phone","scale":"1.5"}}),_vm._v(" Reverse-phone append")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Missed calls? Give us a list of phone numbers and we'll return a list of who called so you can reach them via direct mail.")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":_vm.$store.getters['config/link']('phoneReverse')}},[_vm._v("Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.userServiceDataSources.showEmailReverse)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body box-btn-parent"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":"envelope","scale":"1.5"}}),_vm._v(" Reverse email append")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("For each record where a customer may only have a email address for an individual, we append the individual’s name and postal address where available")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":_vm.$store.getters['config/link']('reverseEmailAppend')}},[_vm._v("Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.userServiceDataSources.showCleanList||_vm.userServiceDataSources.showEmailVerification||_vm.userServiceDataSources.showPhoneVerification)?_c('div',[_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('h3',[_vm._v("Clean & verify your data")]),_vm._v(" "),_c('p',[_vm._v("De-duplicate records, correct undeliverable addresses and screen for privacy... all to save you time and money.")]),_vm._v(" "),_c('div',{staticClass:"card-deck"},[(_vm.userServiceDataSources.showCleanList)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body box-btn-parent"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":"magic","scale":"1.5"}}),_vm._v(" Clean your database")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Save money by removing duplicate and undeliverable customer records. Update change of address to make sure your mail gets to your buyers.")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":_vm.$store.getters['config/link']('cleanList')}},[_vm._v("Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.userServiceDataSources.showEmailVerification)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":"envelope-square","scale":"1.5"}}),_vm._v(" Verify email addresses")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Keep your email deliverability score high and save money by avoiding outdated or invalid email addresses.")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":_vm.$store.getters['config/link']('emailVerification')}},[_vm._v("Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.userServiceDataSources.showPhoneVerification)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_c('icon',{staticClass:"box-icon",attrs:{"name":"phone-square","scale":"1.5"}}),_vm._v(" Verify phone numbers")],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Save time and money otherwise wasted on calling bad numbers, improving your connection rate and communications efficiency.")]),_vm._v(" "),_c('div',{staticClass:"box-btn-box"},[_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":_vm.$store.getters['config/link']('phoneVerification')}},[_vm._v("Start here "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])])]):_vm._e()])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.userServiceDataSources.showPortraitReports)?_c('div',{staticClass:"jumbotron"},[_c('h2',{staticClass:"display-4",attrs:{"id":"analyze"}},[_vm._v("Analyze your customer data")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Gain insight into the demographic and psychographic characteristics of your customers, and identify prospects likely to become new customers.")]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('h3',[_vm._v("View sample reports")]),_vm._v(" "),_c('p',[_vm._v("Learn about each report before you begin.")]),_vm._v(" "),_c('div',{staticClass:"card-deck"},[_c('div',{staticClass:"card"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('a',{staticClass:"btn btn-outline-secondary",attrs:{"href":_vm.$store.getters['config/link']('reportLookALike')}},[_vm._v("Preview "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('a',{staticClass:"btn btn-outline-secondary",attrs:{"href":_vm.$store.getters['config/link']('reportEnhanceLookAlike')}},[_vm._v("Preview "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('a',{staticClass:"btn btn-outline-secondary",attrs:{"href":_vm.$store.getters['config/link']('reportPortrait')}},[_vm._v("Preview "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('a',{staticClass:"btn btn-outline-secondary",attrs:{"href":_vm.$store.getters['config/link']('reportPortraitRegional')}},[_vm._v("Preview "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)])])]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('h3',[_vm._v("Choose a report")]),_vm._v(" "),_c('p',[_vm._v("We offer a series of reports, starting at just $350.00. Upload your customer file and choose a target area. Turnaround time varies from one to five business days.")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.$store.getters['config/link']('portaitreports')}},[_vm._v("Get started "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1),_vm._v(" "),_c('b-link',{staticClass:"btn btn-outline-primary",attrs:{"href":"#"},on:{"click":_vm.showContactUs}},[_vm._v("Ask an expert "),_c('icon',{staticClass:"icon-right",attrs:{"name":"caret-right"}})],1)],1):_vm._e()])])}
var MV4_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body banner-card"},[_c('h5',[_vm._v("Reach new prospects")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("\n                through traditional direct mail or via a digital marketing campaign.\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body banner-card"},[_c('h5',[_vm._v("Manage my customer data")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("\n                by verifying or by enhancing the information I have collected.\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body banner-card"},[_c('h5',[_vm._v("Analyze my customers")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("\n                to discover characteristics they may share with others in my area.\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body banner-card"},[_c('h5',[_vm._v("Display my videos")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("\n                See what else we can do for you.\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Look-Alike Report             ")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("This report includes a demographic portrait of your file plus a calculated Market Penetration Index (\"MPI\") which enables you to define the prospective market potential. The higher the index calculation, the greater success you had.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Enhanced Look-Alike Report")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("This report helps you take a broad view of your customer base, identify where you have a strong or weak market presence, learn who your best customers are and how they are different from the rest, and more!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("PersonicX Portrait Report")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("This report  enables you to better understand who your best customers are using segmentation. It includes an index that enables you to define the prospective market potential.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Data Portrait Analysis       ")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("This report compares the demographic and lifestyle/interest characteristics of customer households to the characteristics of households in your local or regional geographic area.")])])}]
var MV4_esExports = { render: MV4_render, staticRenderFns: MV4_staticRenderFns }
/* harmony default export */ var landings_MV4 = (MV4_esExports);
// CONCATENATED MODULE: ./src/components/landings/MV4.vue
function MV4_injectStyle (ssrContext) {
  __webpack_require__("m564")
}
var MV4_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MV4___vue_template_functional__ = false
/* styles */
var MV4___vue_styles__ = MV4_injectStyle
/* scopeId */
var MV4___vue_scopeId__ = "data-v-e08bf37c"
/* moduleIdentifier (server only) */
var MV4___vue_module_identifier__ = null
var MV4_Component = MV4_normalizeComponent(
  MV4,
  landings_MV4,
  MV4___vue_template_functional__,
  MV4___vue_styles__,
  MV4___vue_scopeId__,
  MV4___vue_module_identifier__
)

/* harmony default export */ var components_landings_MV4 = (MV4_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Landing.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Landing = ({
  components: {
    MV2: components_landings_MV2,
    MV4: components_landings_MV4,
    MBase: components_layouts_MBase,
    MSectionBanner: components_landings_MSectionBanner,
    MSectionProspects: components_landings_MSectionProspects,
    MSectionService: components_landings_MSectionService,
    MSectionAnalyze: components_landings_MSectionAnalyze
  },
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      showGoTop: false
    };
  },

  computed: {
    uiVerstion: function uiVerstion() {
      return this.$store.getters['user/isNewUI'];
    }
  },
  created: function created() {
    this.toggleGoTop();
  },

  methods: {
    toggleGoTop: function toggleGoTop() {
      var that = this;
      window.onscroll = function () {
        var top = document.documentElement.scrollTop || document.body.scrollTop;
        if (top > 300) {
          that.showGoTop = true;
        } else {
          that.showGoTop = false;
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c9b82a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Landing.vue
var Landing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-base',[_c('m-v4',{directives:[{name:"show",rawName:"v-show",value:(_vm.uiVerstion===1),expression:"uiVerstion===1"}]}),_vm._v(" "),_c('m-v2',{directives:[{name:"show",rawName:"v-show",value:(_vm.uiVerstion===2),expression:"uiVerstion===2"}]}),_vm._v(" "),_c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#landing-top'),expression:"'#landing-top'"},{name:"show",rawName:"v-show",value:(_vm.showGoTop),expression:"showGoTop"}],staticClass:"go-top"},[_c('icon',{attrs:{"name":"chevron-up"}})],1)],1)}
var Landing_staticRenderFns = []
var Landing_esExports = { render: Landing_render, staticRenderFns: Landing_staticRenderFns }
/* harmony default export */ var pages_Landing = (Landing_esExports);
// CONCATENATED MODULE: ./src/pages/Landing.vue
function Landing_injectStyle (ssrContext) {
  __webpack_require__("t/Eq")
}
var Landing_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Landing___vue_template_functional__ = false
/* styles */
var Landing___vue_styles__ = Landing_injectStyle
/* scopeId */
var Landing___vue_scopeId__ = "data-v-31c9b82a"
/* moduleIdentifier (server only) */
var Landing___vue_module_identifier__ = null
var Landing_Component = Landing_normalizeComponent(
  Landing,
  pages_Landing,
  Landing___vue_template_functional__,
  Landing___vue_styles__,
  Landing___vue_scopeId__,
  Landing___vue_module_identifier__
)

/* harmony default export */ var src_pages_Landing = (Landing_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/landings/MV3.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MV3 = ({
  components: {
    MSectionService: components_landings_MSectionService
  },
  data: function data() {
    return {
      banners: [{
        title: 'Reach new prospect',
        desc: 'Through traditional direct mail or via a digital marketing campaign.',
        img: __webpack_require__("bKA3"),
        link: ''
      }, {
        title: 'Manage my customer data',
        desc: 'By verifying or by enhancing the information I have collected.',
        img: __webpack_require__("dE4I"),
        link: ''
      }, {
        title: 'Analyze my customers',
        desc: 'To discover characteristics they may share with others in my area.',
        img: __webpack_require__("rzMY"),
        link: ''
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-379c3101","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MV3.vue
var MV3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"banner"},[_c('b-container',[_c('h1',{staticClass:"banner-h1"},[_vm._v("Expand market by technology")]),_vm._v(" "),_c('p',{staticClass:"banner-p"},[_vm._v("Good morning, What would you like to do today?")]),_vm._v(" "),_c('div',{staticClass:"banner-block"},_vm._l((_vm.banners),function(item){return _c('div',{key:item.title,staticClass:"banner-card"},[_c('img',{staticClass:"banner-card-img",attrs:{"src":item.img}}),_vm._v(" "),_c('div',{staticClass:"banner-context"},[_c('h2',{staticClass:"banner-h2"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"banner-card-p"},[_vm._v(_vm._s(item.desc))])])])}),0)])],1),_vm._v(" "),_c('div',{staticClass:"reach"},[_c('b-container',[_c('div',{staticClass:"reach-title"},[_c('h2',{staticClass:"reach-h2"},[_vm._v("Reach new prospects")]),_vm._v(" "),_c('p',{staticClass:"reach-h2-desc"},[_vm._v("Connect with your best prospects through privacy-compliant digital or traditional channels to win new customers. Do it yourself or work with a specialist.")])]),_vm._v(" "),_c('div',{staticClass:"reach-block"},[_c('div',{staticClass:"reach-card"},[_c('p',{staticClass:"reach-card-title"},[_vm._v("Consumer")]),_vm._v(" "),_c('p',{staticClass:"reach-card-text"},[_vm._v("Find consumers by precise area, demographics, interesting and propensities")]),_vm._v(" "),_c('b-btn',{staticClass:"reach-btn"},[_vm._v("Get Started")])],1),_vm._v(" "),_c('div',{staticClass:"reach-card",staticStyle:{"background-image":"url('http://dev.sl360.com/main/landBusiness.jpg')"}},[_c('p',{staticClass:"reach-card-title"},[_vm._v("Business")]),_vm._v(" "),_c('div',{staticClass:"reach-card-text"},[_vm._v("Find lots of business by geographic area and characteristics")]),_vm._v(" "),_c('b-btn',{staticClass:"reach-btn"},[_vm._v("Get Started")])],1)])])],1),_vm._v(" "),_c('MSectionService'),_vm._v(" "),_c('div',{staticClass:"analyze"},[_c('b-container',[_c('div',{staticClass:"analyze-title"},[_c('h2',{staticClass:"analyze-h2"},[_vm._v("Analyze your customer data")]),_vm._v(" "),_c('p',{staticClass:"analyze-h2-desc"},[_vm._v("Gain insight into the demographic and psychographic characteristics of your customers, and identify prospects likely to become new customers.")])])])],1)],1)}
var MV3_staticRenderFns = []
var MV3_esExports = { render: MV3_render, staticRenderFns: MV3_staticRenderFns }
/* harmony default export */ var landings_MV3 = (MV3_esExports);
// CONCATENATED MODULE: ./src/components/landings/MV3.vue
function MV3_injectStyle (ssrContext) {
  __webpack_require__("+avS")
}
var MV3_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MV3___vue_template_functional__ = false
/* styles */
var MV3___vue_styles__ = MV3_injectStyle
/* scopeId */
var MV3___vue_scopeId__ = "data-v-379c3101"
/* moduleIdentifier (server only) */
var MV3___vue_module_identifier__ = null
var MV3_Component = MV3_normalizeComponent(
  MV3,
  landings_MV3,
  MV3___vue_template_functional__,
  MV3___vue_styles__,
  MV3___vue_scopeId__,
  MV3___vue_module_identifier__
)

/* harmony default export */ var components_landings_MV3 = (MV3_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Landing2.vue
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Landing2 = ({
  components: {
    MV2: components_landings_MV2,
    MV3: components_landings_MV3,
    MBase: components_layouts_MBase,
    MSectionBanner: components_landings_MSectionBanner,
    MSectionProspects: components_landings_MSectionProspects,
    MSectionService: components_landings_MSectionService,
    MSectionAnalyze: components_landings_MSectionAnalyze
  },
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      showGoTop: false
    };
  },
  created: function created() {
    this.toggleGoTop();
  },

  methods: {
    toggleGoTop: function toggleGoTop() {
      var that = this;
      window.onscroll = function () {
        var top = document.documentElement.scrollTop || document.body.scrollTop;
        if (top > 300) {
          that.showGoTop = true;
        } else {
          that.showGoTop = false;
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0964cf14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Landing2.vue
var Landing2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-base',[_c('m-v3'),_vm._v(" "),_c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#landing-top'),expression:"'#landing-top'"},{name:"show",rawName:"v-show",value:(_vm.showGoTop),expression:"showGoTop"}],staticClass:"go-top"},[_c('icon',{attrs:{"name":"chevron-up"}})],1)],1)}
var Landing2_staticRenderFns = []
var Landing2_esExports = { render: Landing2_render, staticRenderFns: Landing2_staticRenderFns }
/* harmony default export */ var pages_Landing2 = (Landing2_esExports);
// CONCATENATED MODULE: ./src/pages/Landing2.vue
function Landing2_injectStyle (ssrContext) {
  __webpack_require__("oCzI")
}
var Landing2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Landing2___vue_template_functional__ = false
/* styles */
var Landing2___vue_styles__ = Landing2_injectStyle
/* scopeId */
var Landing2___vue_scopeId__ = "data-v-0964cf14"
/* moduleIdentifier (server only) */
var Landing2___vue_module_identifier__ = null
var Landing2_Component = Landing2_normalizeComponent(
  Landing2,
  pages_Landing2,
  Landing2___vue_template_functional__,
  Landing2___vue_styles__,
  Landing2___vue_scopeId__,
  Landing2___vue_module_identifier__
)

/* harmony default export */ var src_pages_Landing2 = (Landing2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Code403.vue
//
//
//
//

/* harmony default export */ var Code403 = ({
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d72f818","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Code403.vue
var Code403_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("403")])}
var Code403_staticRenderFns = []
var Code403_esExports = { render: Code403_render, staticRenderFns: Code403_staticRenderFns }
/* harmony default export */ var pages_Code403 = (Code403_esExports);
// CONCATENATED MODULE: ./src/pages/Code403.vue
function Code403_injectStyle (ssrContext) {
  __webpack_require__("Q5go")
}
var Code403_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Code403___vue_template_functional__ = false
/* styles */
var Code403___vue_styles__ = Code403_injectStyle
/* scopeId */
var Code403___vue_scopeId__ = "data-v-5d72f818"
/* moduleIdentifier (server only) */
var Code403___vue_module_identifier__ = null
var Code403_Component = Code403_normalizeComponent(
  Code403,
  pages_Code403,
  Code403___vue_template_functional__,
  Code403___vue_styles__,
  Code403___vue_scopeId__,
  Code403___vue_module_identifier__
)

/* harmony default export */ var src_pages_Code403 = (Code403_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/testSummary.vue
//
//
//
//
//
//
//
//

// import MBilling from '@/components/summary/MBilling'
// import utils from '@/assets/utils.js'

/* harmony default export */ var testSummary = ({
  name: 'test',
  components: {
    // MBilling
  },
  data: function data() {
    return {
      showBillingInfo: true
    };
  },
  created: function created() {},

  methods: {},
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78dca6fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/testSummary.vue
var testSummary_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":function($event){_vm.showBillingInfo = true}}},[_vm._v("open")])])}
var testSummary_staticRenderFns = []
var testSummary_esExports = { render: testSummary_render, staticRenderFns: testSummary_staticRenderFns }
/* harmony default export */ var pages_testSummary = (testSummary_esExports);
// CONCATENATED MODULE: ./src/pages/testSummary.vue
function testSummary_injectStyle (ssrContext) {
  __webpack_require__("DNZR")
}
var testSummary_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var testSummary___vue_template_functional__ = false
/* styles */
var testSummary___vue_styles__ = testSummary_injectStyle
/* scopeId */
var testSummary___vue_scopeId__ = "data-v-78dca6fa"
/* moduleIdentifier (server only) */
var testSummary___vue_module_identifier__ = null
var testSummary_Component = testSummary_normalizeComponent(
  testSummary,
  pages_testSummary,
  testSummary___vue_template_functional__,
  testSummary___vue_styles__,
  testSummary___vue_scopeId__,
  testSummary___vue_module_identifier__
)

/* harmony default export */ var src_pages_testSummary = (testSummary_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layouts/MContent.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MContent = ({
  components: {
    MBase: components_layouts_MBase
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    fluid: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dc63d82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/MContent.vue
var MContent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-base',[_c('b-container',{staticClass:"m-layout-content",attrs:{"fluid":_vm.fluid}},[_c('b-row',{staticStyle:{"margin-right":"0","margin-top":"16px"}},[_c('b-col',{staticClass:"title header-title"},[_c('div',[_c('h1',{staticStyle:{"margin-left":"16px"}},[_vm._v(_vm._s(_vm.title)+"\n          "),_c('a',{attrs:{"data-fancybox":"","href":'https://vimeo.com/386494641/'}},[_c('img',{staticStyle:{"vertical-align":"inherit"},attrs:{"src":__webpack_require__("aQR6"),"alt":"Video"}})])])]),_vm._v(" "),_vm._t("title-right")],2)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-right":"0"}},[_c('b-col',{staticStyle:{"padding-right":"0"}},[_vm._t("default")],2)],1)],1)],1)}
var MContent_staticRenderFns = []
var MContent_esExports = { render: MContent_render, staticRenderFns: MContent_staticRenderFns }
/* harmony default export */ var layouts_MContent = (MContent_esExports);
// CONCATENATED MODULE: ./src/components/layouts/MContent.vue
function MContent_injectStyle (ssrContext) {
  __webpack_require__("WMdO")
}
var MContent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MContent___vue_template_functional__ = false
/* styles */
var MContent___vue_styles__ = MContent_injectStyle
/* scopeId */
var MContent___vue_scopeId__ = "data-v-1dc63d82"
/* moduleIdentifier (server only) */
var MContent___vue_module_identifier__ = null
var MContent_Component = MContent_normalizeComponent(
  MContent,
  layouts_MContent,
  MContent___vue_template_functional__,
  MContent___vue_styles__,
  MContent___vue_scopeId__,
  MContent___vue_module_identifier__
)

/* harmony default export */ var components_layouts_MContent = (MContent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/MDemoAllCheck.vue
//
//
//
//
//
//

/* harmony default export */ var MDemoAllCheck = ({
  computed: {
    isAllHousehold: {
      get: function get() {
        return this.$store.state.order.DemoType === 99;
      },
      set: function set(val) {
        if (val) {
          this.$store.commit('order/setAllHouseholds');
        } else {
          this.$store.commit('order/setUnAllHouseholds');
        }
      }
    },
    household: function household() {
      return this.$store.state.demo.allHouseholdSetting || {};
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d2ae40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/MDemoAllCheck.vue
var MDemoAllCheck_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{staticClass:"all-household",attrs:{"data-test":"demo-allHousehold"},model:{value:(_vm.isAllHousehold),callback:function ($$v) {_vm.isAllHousehold=$$v},expression:"isAllHousehold"}},[_vm._v("\n  "+_vm._s(_vm.household.SettingDesc)+"\n")])}
var MDemoAllCheck_staticRenderFns = []
var MDemoAllCheck_esExports = { render: MDemoAllCheck_render, staticRenderFns: MDemoAllCheck_staticRenderFns }
/* harmony default export */ var demo_MDemoAllCheck = (MDemoAllCheck_esExports);
// CONCATENATED MODULE: ./src/components/demo/MDemoAllCheck.vue
function MDemoAllCheck_injectStyle (ssrContext) {
  __webpack_require__("boF+")
}
var MDemoAllCheck_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MDemoAllCheck___vue_template_functional__ = false
/* styles */
var MDemoAllCheck___vue_styles__ = MDemoAllCheck_injectStyle
/* scopeId */
var MDemoAllCheck___vue_scopeId__ = "data-v-00d2ae40"
/* moduleIdentifier (server only) */
var MDemoAllCheck___vue_module_identifier__ = null
var MDemoAllCheck_Component = MDemoAllCheck_normalizeComponent(
  MDemoAllCheck,
  demo_MDemoAllCheck,
  MDemoAllCheck___vue_template_functional__,
  MDemoAllCheck___vue_styles__,
  MDemoAllCheck___vue_scopeId__,
  MDemoAllCheck___vue_module_identifier__
)

/* harmony default export */ var components_demo_MDemoAllCheck = (MDemoAllCheck_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/MPhoneOption.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MPhoneOption = ({
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isBusiness: function isBusiness() {
      return this.$store.getters['demo/isBusiness'];
    },

    selectedPhoneOption: {
      get: function get() {
        return this.$store.state.order.PhoneOption;
      },
      set: function set(val) {
        this.$store.commit('order/savePhoneOption', val);
      }
    },
    demoInit: function demoInit() {
      return this.$store.state.demo.isInit;
    },
    phoneOptions: function phoneOptions() {
      return this.$store.getters['demo/phoneOptions'];
    },
    noPhoneOption: function noPhoneOption() {
      return this.$store.getters['demo/noPhoneOption'];
    },
    isHidePhoneOption: function isHidePhoneOption() {
      return this.$store.getters['demo/isHidePhoneOption'];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25dac472","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/MPhoneOption.vue
var MPhoneOption_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isHidePhoneOption),expression:"!isHidePhoneOption"}]},[_c('m-loader',{attrs:{"show":!_vm.demoInit,"size":"smBox"}}),_vm._v(" "),_c('b-form-radio-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.demoInit),expression:"demoInit"}],attrs:{"stacked":"","disabled":_vm.disabled},model:{value:(_vm.selectedPhoneOption),callback:function ($$v) {_vm.selectedPhoneOption=$$v},expression:"selectedPhoneOption"}},[_vm._l((_vm.phoneOptions),function(item,index){return _c('b-form-radio',{key:item.value,attrs:{"value":item.value,"data-test":("demo-phoneOption-" + index)}},[_vm._v("\n      "+_vm._s(item.desc)+"\n      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:((item.value === '2' || item.value === '3') && !_vm.isBusiness),expression:"(item.value === '2' || item.value === '3') && !isBusiness"}]},[_vm._v("*")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedPhoneOption==2 && item.value==2),expression:"selectedPhoneOption==2 && item.value==2"}]},[_c('span',{staticClass:"phone-span",staticStyle:{"font-size":"10px","color":"#e04557"}},[_vm._v("* Please note New York and Louisiana prohibit telemarketing during declared states of emergency.")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedPhoneOption==3 && item.value==3),expression:"selectedPhoneOption==3 && item.value==3"}]},[_c('span',{staticClass:"phone-span",staticStyle:{"font-size":"10px","color":"#e04557"}},[_vm._v("* Please note New York and Louisiana prohibit telemarketing during declared states of emergency.")])])])}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(Object.keys(_vm.phoneOptions).length > 1 & !_vm.isBusiness),expression:"Object.keys(phoneOptions).length > 1 & !isBusiness"}],staticClass:"phone-span",staticStyle:{"font-size":"10px"}},[_vm._v("    * Phone numbers have been pre-scrubbed against the Do Not Call list.")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.noPhoneOption),expression:"noPhoneOption"}]},[_vm._v("No Phone Option")])],2)],1)}
var MPhoneOption_staticRenderFns = []
var MPhoneOption_esExports = { render: MPhoneOption_render, staticRenderFns: MPhoneOption_staticRenderFns }
/* harmony default export */ var demo_MPhoneOption = (MPhoneOption_esExports);
// CONCATENATED MODULE: ./src/components/demo/MPhoneOption.vue
function MPhoneOption_injectStyle (ssrContext) {
  __webpack_require__("xZyS")
}
var MPhoneOption_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MPhoneOption___vue_template_functional__ = false
/* styles */
var MPhoneOption___vue_styles__ = MPhoneOption_injectStyle
/* scopeId */
var MPhoneOption___vue_scopeId__ = "data-v-25dac472"
/* moduleIdentifier (server only) */
var MPhoneOption___vue_module_identifier__ = null
var MPhoneOption_Component = MPhoneOption_normalizeComponent(
  MPhoneOption,
  demo_MPhoneOption,
  MPhoneOption___vue_template_functional__,
  MPhoneOption___vue_styles__,
  MPhoneOption___vue_scopeId__,
  MPhoneOption___vue_module_identifier__
)

/* harmony default export */ var components_demo_MPhoneOption = (MPhoneOption_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Geo/MGeoCount.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MGeoCount = ({
  components: {
    MDemoAllCheck: components_demo_MDemoAllCheck,
    MPhoneOption: components_demo_MPhoneOption
  },
  created: function created() {},
  data: function data() {
    return {
      alertDesc: ''
    };
  },

  computed: {
    isBusiness: function isBusiness() {
      return this.$store.getters['demo/isBusiness'];
    },
    phoneMessage: function phoneMessage() {
      if (this.isBusiness) {
        return 'I’d like to build my audience using business types and demographic options.';
      } else {
        return 'I’d like to build my audience using your available demographic and psychographic filters.';
      }
    },

    isAllHoseholds: {
      get: function get() {
        return this.$store.state.order.DemoType === 99;
      },
      set: function set(val) {
        if (val) {
          this.$store.commit('order/setAllHouseholds');
        } else {
          this.alertDesc = '';
          this.$store.commit('order/setUnAllHouseholds');
        }
      }
    },
    hoseholds: function hoseholds() {
      return this.$store.state.demo.allHouseholdSetting || {};
    },
    hasPhoneOption: function hasPhoneOption() {
      return this.$store.getters['order/hasPhoneOption'];
    },
    hasDemoWithotAll: function hasDemoWithotAll() {
      return this.$store.getters['order/hasDemoWithotAll'];
    },
    title: function title() {
      if (!this.hasDemoWithotAll) {
        return 'Who do you wish to target?';
      } else {
        return 'Please select a Phone Option';
      }
    },
    noPhoneOption: function noPhoneOption() {
      return this.$store.getters['demo/noPhoneOption'];
    }
  },
  methods: {
    next: function next(evt) {
      var _this = this;

      evt.preventDefault();
      this.alertDesc = '';
      if (this.isAllHoseholds || this.hasDemoWithotAll) {
        if (!this.hasPhoneOption && !this.noPhoneOption) {
          this.alertDesc += 'Please select a Phone Option<br>';
          return false;
        }
        this.$store.dispatch('order/submitOrder');
        this.$nextTick(function () {
          _this.$root.$emit('bv::hide::modal', 'geoCount');
        });
      } else {
        this.$router.push({ name: 'demo' });
        this.$nextTick(function () {
          _this.$root.$emit('bv::hide::modal', 'geoCount');
        });
      }
    },
    show: function show() {
      // if (!this.hasDemoWithotAll) {
      //   this.$store.commit('order/setAllHouseholds')
      // }
    },
    hidden: function hidden() {
      this.$store.commit('order/setUnAllHouseholds');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e3398ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Geo/MGeoCount.vue
var MGeoCount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"geoCount","title":_vm.title,"lazy":true,"ok-title":"Next"},on:{"hidden":_vm.hidden,"shown":_vm.show,"ok":_vm.next}},[_c('div',[(!_vm.hasDemoWithotAll)?_c('b-form-radio-group',{attrs:{"stacked":""},model:{value:(_vm.isAllHoseholds),callback:function ($$v) {_vm.isAllHoseholds=$$v},expression:"isAllHoseholds"}},[_c('div',{staticClass:"the-item"},[_c('b-form-radio',{staticClass:"h3",attrs:{"value":false}},[_vm._v(_vm._s(_vm.phoneMessage))])],1),_vm._v(" "),_c('div',{staticClass:"the-item"},[_c('b-form-radio',{staticClass:"h3",attrs:{"value":true}},[_vm._v(_vm._s(_vm.hoseholds.SettingDesc))]),_vm._v(" "),_c('m-phone-option',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllHoseholds),expression:"isAllHoseholds"}],staticClass:"phone-option",staticStyle:{"margin-top":"4px"},attrs:{"disabled":!_vm.isAllHoseholds}})],1)]):_vm._e(),_vm._v(" "),(_vm.hasDemoWithotAll)?_c('m-phone-option',{staticClass:"phone-option"}):_vm._e(),_vm._v(" "),_c('b-alert',{staticStyle:{"margin-top":"16px"},attrs:{"show":_vm.alertDesc!=='',"variant":"warning"},domProps:{"innerHTML":_vm._s(_vm.alertDesc)}})],1)])}
var MGeoCount_staticRenderFns = []
var MGeoCount_esExports = { render: MGeoCount_render, staticRenderFns: MGeoCount_staticRenderFns }
/* harmony default export */ var Geo_MGeoCount = (MGeoCount_esExports);
// CONCATENATED MODULE: ./src/components/Geo/MGeoCount.vue
function MGeoCount_injectStyle (ssrContext) {
  __webpack_require__("5FH3")
}
var MGeoCount_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MGeoCount___vue_template_functional__ = false
/* styles */
var MGeoCount___vue_styles__ = MGeoCount_injectStyle
/* scopeId */
var MGeoCount___vue_scopeId__ = "data-v-0e3398ce"
/* moduleIdentifier (server only) */
var MGeoCount___vue_module_identifier__ = null
var MGeoCount_Component = MGeoCount_normalizeComponent(
  MGeoCount,
  Geo_MGeoCount,
  MGeoCount___vue_template_functional__,
  MGeoCount___vue_styles__,
  MGeoCount___vue_scopeId__,
  MGeoCount___vue_module_identifier__
)

/* harmony default export */ var components_Geo_MGeoCount = (MGeoCount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/slide/MSlideItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'

/* harmony default export */ var MSlideItem = ({
  components: {},
  props: {
    canDelete: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    deleteFun: {
      type: Function,
      defualt: function defualt(item) {}
    }
  },
  data: function data() {
    return {
      toggleDict: {}
    };
  },

  computed: {},
  methods: {
    toggle: function toggle(key, stauts) {
      this.$set(this.toggleDict, key, stauts);
    },
    getToggle: function getToggle(key) {
      if (this.toggleDict.hasOwnProperty(key)) {
        return this.toggleDict[key];
      } else {
        return true;
      }
    },
    hasValues: function hasValues(item) {
      if (item.values === undefined) {
        return false;
      } else {
        return item.values.length > 0;
      }
    },
    theDelete: function theDelete(item) {
      this.deleteFun(item);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-378e7bcc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slide/MSlideItem.vue
var MSlideItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box m-max-height"},[_c('ul',{staticClass:"tree"},_vm._l((_vm.items),function(item,index){return _c('li',{staticClass:"item",attrs:{"data-test":"slide-item"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getToggle(item.title) && _vm.hasValues(item)),expression:"getToggle(item.title) && hasValues(item)"}],on:{"click":function($event){return _vm.toggle(item.title, false)}}},[_c('icon',{staticClass:"toggle-icon",attrs:{"name":"minus-circle"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.getToggle(item.title)),expression:"!getToggle(item.title)"}],on:{"click":function($event){return _vm.toggle(item.title, true)}}},[_c('icon',{staticClass:"toggle-icon",attrs:{"name":"plus-circle"}})],1),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasValues(item)),expression:"!hasValues(item)"}],staticClass:"toggle-icon",staticStyle:{"color":"#ccc"},attrs:{"name":"plus-circle"}}),_vm._v("\n      "+_vm._s(item.title)+"\n      "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.getToggle(item.title)),expression:"getToggle(item.title)"}],staticClass:"tree-sub"},_vm._l((item.values),function(subItem){return _c('li',{staticClass:"sub-item",staticStyle:{"flex-direction":"column"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"data-test":"slide-itemSub"}},[_vm._v("\n            "+_vm._s(subItem.title)+"\n            "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.canDelete && !subItem.noDelete),expression:"canDelete && !subItem.noDelete"}],on:{"click":function($event){return _vm.theDelete(subItem)}}},[_c('icon',{staticClass:"times-icon",attrs:{"name":"times-circle"}})],1)]),_vm._v(" "),(subItem.items && subItem.items.length > 0)?_c('ul',{staticClass:"tree-sub",staticStyle:{"width":"100%"}},_vm._l((subItem.items),function(subSubItem){return _c('li',{staticClass:"sub-item"},[_vm._v(_vm._s(subSubItem))])}),0):_vm._e()])}),0)],1)}),0)])}
var MSlideItem_staticRenderFns = []
var MSlideItem_esExports = { render: MSlideItem_render, staticRenderFns: MSlideItem_staticRenderFns }
/* harmony default export */ var slide_MSlideItem = (MSlideItem_esExports);
// CONCATENATED MODULE: ./src/components/slide/MSlideItem.vue
function MSlideItem_injectStyle (ssrContext) {
  __webpack_require__("eq/4")
}
var MSlideItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSlideItem___vue_template_functional__ = false
/* styles */
var MSlideItem___vue_styles__ = MSlideItem_injectStyle
/* scopeId */
var MSlideItem___vue_scopeId__ = "data-v-378e7bcc"
/* moduleIdentifier (server only) */
var MSlideItem___vue_module_identifier__ = null
var MSlideItem_Component = MSlideItem_normalizeComponent(
  MSlideItem,
  slide_MSlideItem,
  MSlideItem___vue_template_functional__,
  MSlideItem___vue_styles__,
  MSlideItem___vue_scopeId__,
  MSlideItem___vue_module_identifier__
)

/* harmony default export */ var components_slide_MSlideItem = (MSlideItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/slide/MSlideSummary.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MSlideSummary = ({
  components: {
    MSlideItem: components_slide_MSlideItem
  },
  data: function data() {
    return {
      geoTitle: {
        zip: 'Zip Codes'
      }
    };
  },

  computed: {
    order: function order() {
      return this.$store.state.order;
    },
    site: function site() {
      return this.$store.state.site;
    },
    demos: function demos() {
      return this.$store.getters['order/demos'];
    },
    geos: function geos() {
      return this.$store.getters['order/geos'];
    },
    currentGeoType: function currentGeoType() {
      return this.$store.getters['order/currentGeoType'];
    }
  },
  methods: {
    goDemo: function goDemo() {
      this.$router.push({ name: 'demo' });
    },
    goGeo: function goGeo() {
      if (this.currentGeoType.routeName) {
        this.$router.push({ name: 'geo' });
      } else {
        var geoType = this.currentGeoType.name;
        if (this.currentGeoType.title === 'Radius') {
          geoType = 'radius';
        }
        this.$router.push({ name: 'geo-' + geoType });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a582c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slide/MSlideSummary.vue
var MSlideSummary_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Order Summary")]),_vm._v(" "),_c('div',{staticClass:"m-slide-section"},[_c('div',{staticClass:"title"},[_c('h4',[_vm._v("Target Area")]),_vm._v(" "),_c('b-link',{staticClass:"title-edit",on:{"click":_vm.goGeo}},[_vm._v("Edit")])],1),_vm._v(" "),_c('m-slide-item',{attrs:{"items":_vm.geos,"canDelete":false}})],1),_vm._v(" "),_c('div',{staticClass:"m-slide-section"},[_c('div',{staticClass:"title"},[_c('h4',[_vm._v("Target Audience")]),_vm._v(" "),_c('b-link',{staticClass:"title-edit",on:{"click":_vm.goDemo}},[_vm._v("Edit")])],1),_vm._v(" "),_c('m-slide-item',{attrs:{"items":_vm.demos,"canDelete":false}})],1),_vm._v(" "),_c('div',{staticClass:"m-slide-section"},[_c('h4',[_vm._v("Count & Quote")]),_vm._v(" "),_c('p',{staticClass:"item"},[_vm._v("Selected/Available "),_c('br'),_vm._v("\n    "+_vm._s(_vm._f("numberFormat")(_vm.order.TotalDesiredQty,'', 0))+" / "+_vm._s(_vm._f("numberFormat")(_vm.order.TotalAvailableQty,'', 0)))]),_vm._v(" "),(_vm.$store.getters['summary/rewardsPoint'] > 0)?_c('p',{staticClass:"item"},[_vm._v("Earned Points:\n      "),_c('span',{staticClass:"color-primary"},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.$store.getters['summary/rewardsPoint'],'', 0)))])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"item"},[_vm._v("Order Total: "),_c('span',{staticClass:"primary"},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.order.TotalEstmCost))+" + Tax")])])])])}
var MSlideSummary_staticRenderFns = []
var MSlideSummary_esExports = { render: MSlideSummary_render, staticRenderFns: MSlideSummary_staticRenderFns }
/* harmony default export */ var slide_MSlideSummary = (MSlideSummary_esExports);
// CONCATENATED MODULE: ./src/components/slide/MSlideSummary.vue
function MSlideSummary_injectStyle (ssrContext) {
  __webpack_require__("PHAw")
}
var MSlideSummary_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSlideSummary___vue_template_functional__ = false
/* styles */
var MSlideSummary___vue_styles__ = MSlideSummary_injectStyle
/* scopeId */
var MSlideSummary___vue_scopeId__ = "data-v-e3a582c4"
/* moduleIdentifier (server only) */
var MSlideSummary___vue_module_identifier__ = null
var MSlideSummary_Component = MSlideSummary_normalizeComponent(
  MSlideSummary,
  slide_MSlideSummary,
  MSlideSummary___vue_template_functional__,
  MSlideSummary___vue_styles__,
  MSlideSummary___vue_scopeId__,
  MSlideSummary___vue_module_identifier__
)

/* harmony default export */ var components_slide_MSlideSummary = (MSlideSummary_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/slide/MSlide.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var MSlide = ({
  components: {
    MSlideSummary: components_slide_MSlideSummary,
    MSlideItem: components_slide_MSlideItem
  },
  computed: {
    step: function step() {
      if (this.$route.name === 'summary' || this.$route.name === 'success') {
        return 'summary';
      } else {
        return 'select';
      }
    },
    demos: function demos() {
      return this.$store.getters['order/demos'];
    },
    geos: function geos() {
      return this.$store.getters['order/geos'];
    }
  },
  methods: {
    deleteGeo: function deleteGeo(item) {
      this.$store.commit('order/deleteGeo', item.GeoKeyCode);
    },
    deleteDemo: function deleteDemo(item) {
      if (item.hasOwnProperty('is50')) {
        if (item.key === 'target') {
          var targetoption = this.$store.getters['order/targetOption'];
          this.$store.commit('order/saveKey', ['TargetOption', targetoption - item.value]);
          this.$store.commit('demo/removeoption', { key: 'target', val: item.value });
        } else {
          var _targetoption = this.$store.getters['order/routeOption'];
          this.$store.commit('order/saveKey', ['RouteOption', _targetoption - item.value]);
          this.$store.commit('demo/removeoption', { key: 'route', val: item.value });
        }
      } else {
        this.$store.dispatch('order/deleteDemo', {
          type: 'value',
          attributeValue: item.AttributeValue,
          columnName: item.ColumnName,
          name: item.AttributeValueName,
          demoCategoryType: item.DemoCategoryType
        });
      }
    },
    resetOrder: function resetOrder() {
      this.$store.dispatch('order/initOrder', parseInt(this.$route.params.listType));
      notification.notice('success', 'Order has been reset');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7567abbb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slide/MSlide.vue
var MSlide_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",staticStyle:{"width":"100%"}},[(_vm.step === 'select')?_c('div',{staticStyle:{"width":"100%"}},[_c('h2',[_vm._v("Review Your Selections")]),_vm._v(" "),_c('div',{staticClass:"m-slide-section"},[_c('h4',[_vm._v("Step 1 : Select Target Areas(s)")]),_vm._v(" "),_c('m-slide-item',{attrs:{"items":_vm.geos,"deleteFun":_vm.deleteGeo,"data-test":"slide-order-geo"}})],1),_vm._v(" "),_c('div',{staticClass:"m-slide-section"},[_c('h4',[_vm._v("Step 2 : Define Target Audience(s)")]),_vm._v(" "),_c('m-slide-item',{attrs:{"items":_vm.demos,"deleteFun":_vm.deleteDemo,"data-test":"slide-order-demo"}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('b-link',{directives:[{name:"b-modal",rawName:"v-b-modal.modal1",modifiers:{"modal1":true}}],staticClass:"reset-order"},[_vm._v("Reset Order")])],1)]):_vm._e(),_vm._v(" "),(_vm.step === 'summary')?_c('div',{staticStyle:{"width":"100%"}},[_c('m-slide-summary')],1):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Confirm"},on:{"ok":_vm.resetOrder}},[_c('p',{staticClass:"my-4"},[_vm._v("Are you sure you want to reset your order?\n    ")])])],1)}
var MSlide_staticRenderFns = []
var MSlide_esExports = { render: MSlide_render, staticRenderFns: MSlide_staticRenderFns }
/* harmony default export */ var slide_MSlide = (MSlide_esExports);
// CONCATENATED MODULE: ./src/components/slide/MSlide.vue
function MSlide_injectStyle (ssrContext) {
  __webpack_require__("0wlN")
}
var MSlide_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSlide___vue_template_functional__ = false
/* styles */
var MSlide___vue_styles__ = MSlide_injectStyle
/* scopeId */
var MSlide___vue_scopeId__ = "data-v-7567abbb"
/* moduleIdentifier (server only) */
var MSlide___vue_module_identifier__ = null
var MSlide_Component = MSlide_normalizeComponent(
  MSlide,
  slide_MSlide,
  MSlide___vue_template_functional__,
  MSlide___vue_styles__,
  MSlide___vue_scopeId__,
  MSlide___vue_module_identifier__
)

/* harmony default export */ var components_slide_MSlide = (MSlide_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/Order1.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Order1 = ({
  components: {
    MContent: components_layouts_MContent,
    MGeoCount: components_Geo_MGeoCount,
    MSlide: components_slide_MSlide
  },
  data: function data() {
    return {};
  },

  computed: {
    dataSource: function dataSource() {
      return this.$store.getters['config/datasource'];
    },
    recommendDemos: function recommendDemos() {
      return this.$store.state.demo.recommendDemos || [];
    },
    getCountId: function getCountId() {
      return this.$store.state.summary.getCountId || false;
    }
  },
  watch: {},
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae2e630","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/Order1.vue
var Order1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-geo-count'),_vm._v(" "),_c('m-content',{attrs:{"title":_vm.dataSource.Description}},[_c('b-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.name === 'summary'),expression:"$route.name === 'summary'"}],attrs:{"slot":"title-right"},on:{"click":function($event){return _vm.$root.$emit('bv::show::modal', 'sampleExample')}},slot:"title-right"},[_c('h3',{staticClass:"sample"},[_vm._v("Sample Output Example")])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$route.name !== 'success'),expression:"this.$route.name !== 'success'"}],staticClass:"the-slide"},[_c('m-slide')],1),_vm._v(" "),_c('div',{staticClass:"the-content"},[(!_vm.$route.meta.keepUnAlive)?_c('keep-alive',[_c('router-view')],1):_vm._e(),_vm._v(" "),(_vm.$route.meta.keepUnAlive)?_c('router-view'):_vm._e()],1)])],1)],1)}
var Order1_staticRenderFns = []
var Order1_esExports = { render: Order1_render, staticRenderFns: Order1_staticRenderFns }
/* harmony default export */ var order_Order1 = (Order1_esExports);
// CONCATENATED MODULE: ./src/pages/order/Order1.vue
function Order1_injectStyle (ssrContext) {
  __webpack_require__("dYrh")
}
var Order1_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Order1___vue_template_functional__ = false
/* styles */
var Order1___vue_styles__ = Order1_injectStyle
/* scopeId */
var Order1___vue_scopeId__ = "data-v-7ae2e630"
/* moduleIdentifier (server only) */
var Order1___vue_module_identifier__ = null
var Order1_Component = Order1_normalizeComponent(
  Order1,
  order_Order1,
  Order1___vue_template_functional__,
  Order1___vue_styles__,
  Order1___vue_scopeId__,
  Order1___vue_module_identifier__
)

/* harmony default export */ var pages_order_Order1 = (Order1_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/MBox.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MBox = ({
  props: {
    title: {
      type: String,
      default: ''
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3590c273","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MBox.vue
var MBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-box"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_vm._t("default")],2)}
var MBox_staticRenderFns = []
var MBox_esExports = { render: MBox_render, staticRenderFns: MBox_staticRenderFns }
/* harmony default export */ var common_MBox = (MBox_esExports);
// CONCATENATED MODULE: ./src/components/common/MBox.vue
function MBox_injectStyle (ssrContext) {
  __webpack_require__("QYvC")
}
var MBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MBox___vue_template_functional__ = false
/* styles */
var MBox___vue_styles__ = MBox_injectStyle
/* scopeId */
var MBox___vue_scopeId__ = "data-v-3590c273"
/* moduleIdentifier (server only) */
var MBox___vue_module_identifier__ = null
var MBox_Component = MBox_normalizeComponent(
  MBox,
  common_MBox,
  MBox___vue_template_functional__,
  MBox___vue_styles__,
  MBox___vue_scopeId__,
  MBox___vue_module_identifier__
)

/* harmony default export */ var components_common_MBox = (MBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/order2/MOrder2Demo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var MOrder2Demo = ({
  components: {
    MBox: components_common_MBox,
    MSlideItem: components_slide_MSlideItem,
    MDemoAllCheck: components_demo_MDemoAllCheck
  },
  data: function data() {
    return {};
  },

  computed: {
    demos: function demos() {
      return this.$store.getters['order/demos'];
    },
    datasource: function datasource() {
      return this.$store.getters['config/datasource'];
    },
    isAllHoseholds: function isAllHoseholds() {
      return this.$store.getters['order/isAllHoseholds'];
    }
  },
  methods: {
    deleteDemo: function deleteDemo(item) {
      if (item.hasOwnProperty('is50')) {
        if (item.key === 'target') {
          var targetoption = this.$store.getters['order/targetOption'];
          this.$store.commit('order/saveKey', ['TargetOption', targetoption - item.value]);
          this.$store.commit('demo/removeoption', { key: 'target', val: item.value });
        } else {
          var _targetoption = this.$store.getters['order/routeOption'];
          this.$store.commit('order/saveKey', ['RouteOption', _targetoption - item.value]);
          this.$store.commit('demo/removeoption', { key: 'route', val: item.value });
        }
      } else {
        this.$store.dispatch('order/deleteDemo', {
          type: 'value',
          attributeValue: item.AttributeValue,
          columnName: item.ColumnName,
          name: item.AttributeValueName,
          demoCategoryType: item.DemoCategoryType
        });
      }
    },
    saveQuickPick: function saveQuickPick() {
      this.$root.$emit('bv::show::modal', 'saveQuickPick');
    },
    showTotalRecords: function showTotalRecords() {
      this.$root.$emit('bv::show::modal', 'totalRecords');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77640924","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order2/MOrder2Demo.vue
var MOrder2Demo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-box',{attrs:{"title":"Demography"}},[_c('div',{staticClass:"m-block",staticStyle:{"margin-bottom":"0"}},[_c('div',{staticClass:"m-slide-height"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.demos.length === 0),expression:"demos.length === 0"}]},[_vm._v("Use the tabs below to define your target audience using demographic or interest and purchasing attributes")]),_vm._v(" "),_c('m-slide-item',{attrs:{"items":_vm.demos,"deleteFun":_vm.deleteDemo}})],1),_vm._v(" "),_c('b-btn',{staticClass:"m-btn-pup",attrs:{"disabled":_vm.isAllHoseholds},on:{"click":function($event){return _vm.$router.push({name:'demo'})}}},[_vm._v(" Edit")]),_vm._v(" "),_c('m-demo-all-check')],1),_vm._v(" "),_c('div',{staticClass:"m-block",staticStyle:{"margin-bottom":"0"}},[_c('div',{staticClass:"m-link-go",on:{"click":_vm.saveQuickPick}},[_vm._v("Save As a QuickPick ")]),_vm._v(" "),(_vm.datasource.hasRecordsWithPhone)?_c('div',{staticClass:"m-link-go",staticStyle:{"margin-top":"8px"}},[_c('span',{on:{"click":_vm.showTotalRecords}},[_vm._v("Total Records vs Total with Phone")])]):_vm._e()])])}
var MOrder2Demo_staticRenderFns = []
var MOrder2Demo_esExports = { render: MOrder2Demo_render, staticRenderFns: MOrder2Demo_staticRenderFns }
/* harmony default export */ var order2_MOrder2Demo = (MOrder2Demo_esExports);
// CONCATENATED MODULE: ./src/components/order2/MOrder2Demo.vue
function MOrder2Demo_injectStyle (ssrContext) {
  __webpack_require__("eVSk")
}
var MOrder2Demo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MOrder2Demo___vue_template_functional__ = false
/* styles */
var MOrder2Demo___vue_styles__ = MOrder2Demo_injectStyle
/* scopeId */
var MOrder2Demo___vue_scopeId__ = "data-v-77640924"
/* moduleIdentifier (server only) */
var MOrder2Demo___vue_module_identifier__ = null
var MOrder2Demo_Component = MOrder2Demo_normalizeComponent(
  MOrder2Demo,
  order2_MOrder2Demo,
  MOrder2Demo___vue_template_functional__,
  MOrder2Demo___vue_styles__,
  MOrder2Demo___vue_scopeId__,
  MOrder2Demo___vue_module_identifier__
)

/* harmony default export */ var components_order2_MOrder2Demo = (MOrder2Demo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/order2/MOrder2Geo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MOrder2Geo = ({
  components: {
    MBox: components_common_MBox,
    MSlideItem: components_slide_MSlideItem
  },
  data: function data() {
    return {};
  },

  computed: {
    geos: function geos() {
      return this.$store.getters['order/geos'];
    }
  },
  methods: {
    deleteGeo: function deleteGeo(item) {
      this.$store.commit('order/deleteGeo', item.GeoKeyCode);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1176814","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order2/MOrder2Geo.vue
var MOrder2Geo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-box',{attrs:{"title":"Geography"}},[_c('div',{staticClass:"m-block",staticStyle:{"margin-bottom":"0"}},[_c('div',{staticClass:"m-slide-height"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.geos.length === 0),expression:"geos.length === 0"}]},[_vm._v("Choose the type of geographic area you wish to use to target your prospects")]),_vm._v(" "),_c('m-slide-item',{attrs:{"items":_vm.geos,"deleteFun":_vm.deleteGeo}})],1),_vm._v(" "),_c('b-btn',{staticClass:"m-btn-pup",on:{"click":function($event){return _vm.$router.push({name:'geo'})}}},[_vm._v(" Edit")])],1)])}
var MOrder2Geo_staticRenderFns = []
var MOrder2Geo_esExports = { render: MOrder2Geo_render, staticRenderFns: MOrder2Geo_staticRenderFns }
/* harmony default export */ var order2_MOrder2Geo = (MOrder2Geo_esExports);
// CONCATENATED MODULE: ./src/components/order2/MOrder2Geo.vue
function MOrder2Geo_injectStyle (ssrContext) {
  __webpack_require__("+aMm")
}
var MOrder2Geo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MOrder2Geo___vue_template_functional__ = false
/* styles */
var MOrder2Geo___vue_styles__ = MOrder2Geo_injectStyle
/* scopeId */
var MOrder2Geo___vue_scopeId__ = "data-v-f1176814"
/* moduleIdentifier (server only) */
var MOrder2Geo___vue_module_identifier__ = null
var MOrder2Geo_Component = MOrder2Geo_normalizeComponent(
  MOrder2Geo,
  order2_MOrder2Geo,
  MOrder2Geo___vue_template_functional__,
  MOrder2Geo___vue_styles__,
  MOrder2Geo___vue_scopeId__,
  MOrder2Geo___vue_module_identifier__
)

/* harmony default export */ var components_order2_MOrder2Geo = (MOrder2Geo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/order2/MOrder2Option.vue
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MOrder2Option = ({
  components: {
    MBox: components_common_MBox,
    MPhoneOption: components_demo_MPhoneOption
  },
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df6cfd30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order2/MOrder2Option.vue
var MOrder2Option_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-box',{attrs:{"title":"Options"}},[_c('div',{staticClass:"m-block"},[_c('h5',[_vm._v("Phone Option")]),_vm._v(" "),_c('m-phone-option')],1),_vm._v(" "),_c('div',{staticClass:"m-block"},[_c('a',{on:{"click":function($event){return _vm.$router.push({'name': 'demo-suppression'})}}},[_vm._v("Add suppression")])])])}
var MOrder2Option_staticRenderFns = []
var MOrder2Option_esExports = { render: MOrder2Option_render, staticRenderFns: MOrder2Option_staticRenderFns }
/* harmony default export */ var order2_MOrder2Option = (MOrder2Option_esExports);
// CONCATENATED MODULE: ./src/components/order2/MOrder2Option.vue
function MOrder2Option_injectStyle (ssrContext) {
  __webpack_require__("acLg")
}
var MOrder2Option_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MOrder2Option___vue_template_functional__ = false
/* styles */
var MOrder2Option___vue_styles__ = MOrder2Option_injectStyle
/* scopeId */
var MOrder2Option___vue_scopeId__ = "data-v-df6cfd30"
/* moduleIdentifier (server only) */
var MOrder2Option___vue_module_identifier__ = null
var MOrder2Option_Component = MOrder2Option_normalizeComponent(
  MOrder2Option,
  order2_MOrder2Option,
  MOrder2Option___vue_template_functional__,
  MOrder2Option___vue_styles__,
  MOrder2Option___vue_scopeId__,
  MOrder2Option___vue_module_identifier__
)

/* harmony default export */ var components_order2_MOrder2Option = (MOrder2Option_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/Order2.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Order2 = ({
  components: {
    MContent: components_layouts_MContent,
    MOrder2Demo: components_order2_MOrder2Demo,
    MOrder2Geo: components_order2_MOrder2Geo,
    MOrder2Option: components_order2_MOrder2Option
  },
  data: function data() {
    return {
      alertDesc: ''
    };
  },

  computed: {
    datasource: function datasource() {
      return this.$store.getters['config/datasource'];
    },
    isTargetoption: function isTargetoption() {
      return this.$store.getters['demo/isTargetoption'];
    },
    isRouteoption: function isRouteoption() {
      return this.$store.getters['demo/isRouteoption'];
    },
    hasPhoneOption: function hasPhoneOption() {
      return this.$store.getters['order/hasPhoneOption'];
    },
    hasGeo: function hasGeo() {
      return this.$store.getters['order/hasGeo'];
    },
    hasDemo: function hasDemo() {
      return this.$store.getters['order/hasDemo'];
    },
    dataSource: function dataSource() {
      return this.$store.getters['config/datasource'];
    },
    title: function title() {
      return this.dataSource.Description;
    }
  },
  methods: {
    count: function count() {
      this.alertDesc = '';

      // Check Demo
      if (!this.hasDemo) {
        this.alertDesc += 'Please Defined Target Audience<br>';
      }
      if (this.datasource.isDemoOccupant && !this.isTargetoption) {
        this.alertDesc += 'Please select at least one targeting option<br>';
      }
      if (this.datasource.isDemoOccupant && !this.isRouteoption) {
        this.alertDesc += 'Please select at least one route option<br>';
      }

      // Check Phone Option
      if (!this.hasPhoneOption) {
        this.alertDesc += 'Please select a Phone Option<br>';
      }

      // Check Geo
      if (!(this.hasGeo || this.$store.state.order.GeoType === 20 || this.$store.state.order.GeoType === 23)) {
        this.alertDesc += 'Please Defined Target Georgaphy<br>';
      }

      if (this.alertDesc === '') {
        this.$store.dispatch('order/submitOrder');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a00533a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/Order2.vue
var Order2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-content',{attrs:{"fluid":false,"title":_vm.title}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.meta.isPage),expression:"!$route.meta.isPage"}]},[_c('m-order2-geo'),_vm._v(" "),_c('m-order2-demo'),_vm._v(" "),_c('m-order2-option'),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"8px","padding-right":"8px"}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.alertDesc !== ''),expression:"alertDesc !== ''"}],staticClass:"m-error-text",domProps:{"innerHTML":_vm._s(_vm.alertDesc)}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end"}},[_c('b-btn',{on:{"click":function($event){return _vm.$router.push({name: 'landing'})}}},[_vm._v("Back")]),_vm._v(" "),_c('b-btn',{staticStyle:{"margin-left":"8px"},attrs:{"variant":"primary"},on:{"click":_vm.count}},[_vm._v("Get Count")])],1)])],1),_vm._v(" "),_c('keep-alive',[_c('transition',{attrs:{"name":"my-fade"}},[_c('router-view')],1)],1)],1)}
var Order2_staticRenderFns = []
var Order2_esExports = { render: Order2_render, staticRenderFns: Order2_staticRenderFns }
/* harmony default export */ var order_Order2 = (Order2_esExports);
// CONCATENATED MODULE: ./src/pages/order/Order2.vue
function Order2_injectStyle (ssrContext) {
  __webpack_require__("W5Ou")
}
var Order2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Order2___vue_template_functional__ = false
/* styles */
var Order2___vue_styles__ = Order2_injectStyle
/* scopeId */
var Order2___vue_scopeId__ = "data-v-3a00533a"
/* moduleIdentifier (server only) */
var Order2___vue_module_identifier__ = null
var Order2_Component = Order2_normalizeComponent(
  Order2,
  order_Order2,
  Order2___vue_template_functional__,
  Order2___vue_styles__,
  Order2___vue_scopeId__,
  Order2___vue_module_identifier__
)

/* harmony default export */ var pages_order_Order2 = (Order2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MCounting.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MCounting = ({
  components: {},
  created: function created() {},
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  methods: {
    ok: function ok() {
      utils.progressDone();
      this.$store.commit('order/saveKey', ['CurrentStep', 'input']);
    },
    hide: function hide() {
      this.$root.$emit('bv::hide::modal', 'modal-counting');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a0ff37c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MCounting.vue
var MCounting_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modal-counting","title":"Let’s see what we’ve got!","ok-only":true,"ok-title":"Stop","lazy":true,"no-close-on-backdrop":"","no-close-on-esc":"","no-enforce-focus":"","hide-header-close":"","body-class":"the-modal"},on:{"ok":_vm.ok}},[_c('img',{attrs:{"src":__webpack_require__("Q1cx")}}),_vm._v(" "),_c('p',[_vm._v("We’re checking to see how many prospects we have based on your selections. Just a few more seconds.")])])}
var MCounting_staticRenderFns = []
var MCounting_esExports = { render: MCounting_render, staticRenderFns: MCounting_staticRenderFns }
/* harmony default export */ var summary_MCounting = (MCounting_esExports);
// CONCATENATED MODULE: ./src/components/summary/MCounting.vue
function MCounting_injectStyle (ssrContext) {
  __webpack_require__("FVAw")
}
var MCounting_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MCounting___vue_template_functional__ = false
/* styles */
var MCounting___vue_styles__ = MCounting_injectStyle
/* scopeId */
var MCounting___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MCounting___vue_module_identifier__ = null
var MCounting_Component = MCounting_normalizeComponent(
  MCounting,
  summary_MCounting,
  MCounting___vue_template_functional__,
  MCounting___vue_styles__,
  MCounting___vue_scopeId__,
  MCounting___vue_module_identifier__
)

/* harmony default export */ var components_summary_MCounting = (MCounting_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/MerrorText.vue
//
//
//
//
//
//
//



/* harmony default export */ var MerrorText = ({
  props: {
    val: [String, Number, Object, Array, Boolean],
    rules: [String, Object, Array],
    immediate: {
      type: Boolean,
      default: true
    },
    only: {
      type: Boolean,
      default: true
    },
    group: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      error: {},
      initError: {}
    };
  },

  watch: {
    val: function val() {
      this.error = utils.validate(this.val, this.rules, this.only);
    }
  },
  computed: {
    // errors () {
    //   return utils.validate(this.val, this.rules, this.only)
    // }
  },
  mounted: function mounted() {
    this.error = utils.validate(this.val, this.rules, this.only);
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6732d90b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MerrorText.vue
var MerrorText_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.immediate && _vm.error.isError)?_c('p',{staticClass:"m-error-text"},[(_vm.only)?_c('span',[_vm._v(_vm._s(_vm.error.desc))]):_vm._e()]):_vm._e()}
var MerrorText_staticRenderFns = []
var MerrorText_esExports = { render: MerrorText_render, staticRenderFns: MerrorText_staticRenderFns }
/* harmony default export */ var common_MerrorText = (MerrorText_esExports);
// CONCATENATED MODULE: ./src/components/common/MerrorText.vue
function MerrorText_injectStyle (ssrContext) {
  __webpack_require__("n2Tx")
}
var MerrorText_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MerrorText___vue_template_functional__ = false
/* styles */
var MerrorText___vue_styles__ = MerrorText_injectStyle
/* scopeId */
var MerrorText___vue_scopeId__ = "data-v-6732d90b"
/* moduleIdentifier (server only) */
var MerrorText___vue_module_identifier__ = null
var MerrorText_Component = MerrorText_normalizeComponent(
  MerrorText,
  common_MerrorText,
  MerrorText___vue_template_functional__,
  MerrorText___vue_styles__,
  MerrorText___vue_scopeId__,
  MerrorText___vue_module_identifier__
)

/* harmony default export */ var components_common_MerrorText = (MerrorText_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MSaveOrder.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MSaveOrder = ({
  components: {
    MErrorText: components_common_MerrorText
  },
  created: function created() {
    var _this = this;

    this.selectGeos = this.$store.state.order.OrderGeos;
    setTimeout(function () {
      _this.selectGeos = _this.$store.state.order.OrderGeos;
    }, 1000);
  },
  data: function data() {
    return {
      selectGeos: {},
      step: 'input', // input  , success
      okTitle: 'Save',
      showError: false,
      loading: false,
      alertDesc: ''
    };
  },

  computed: {
    order: function order() {
      return this.$store.state.order;
    },
    showsetting: function showsetting() {
      if (this.$store.getters['order/IsEmailCampaign']) {
        return {
          title: 'Save Email Campaign Count',
          message: 'Please complete the form below to save your list selections. Upon completion you will:<br>1. Instantly receive links to download (pdf) and print this Quote<br>2. Receive an email with a link to retrieve your saved count',
          orderforclienttext: 'I order campaigns for my clients. Contact me about USADATA’s Reseller Program.',
          CallMeText: 'Please contact me to discuss this email campaign in more detail.',
          callme: true,
          clients: true,
          IsContactMeByEmail: true, // TODO@Wilson not find
          IsSendEmailToList: false // @TODO@Wilson not find
        };
      } else {
        return {
          title: 'Save List Count',
          message: 'Please complete the form below to save your selections. Upon completion you will receive an email with a link to retrieve your saved count at any time.',
          orderforclienttext: 'I order leads for my clients. Contact me about your Reseller Program.',
          CallMeText: 'Please call me to discuss this list in more detail.',
          callme: false,
          clients: true
        };
      }
    },
    message: function message() {},
    orderContact: function orderContact() {
      return this.$store.state.order.OrderContactInformation || {};
    },

    OrderForClients: {
      get: function get() {
        return this.orderContact.OrderForClients;
      },
      set: function set(val) {
        this.$store.commit('order/updateContactInformation', {
          key: 'OrderForClients',
          val: val
        });
      }
    },
    CallMe: {
      get: function get() {
        return this.orderContact.CallMe;
      },
      set: function set(val) {
        this.$store.commit('order/updateContactInformation', {
          key: 'CallMe',
          val: val
        });
      }
    }
  },
  methods: {
    updateContact: function updateContact(key, e) {
      this.$store.commit('order/updateContactInformation', {
        key: key,
        val: e.target.value
      });
    },
    save: function save(evt) {
      var _this2 = this;

      if (this.step === 'input') {
        evt.preventDefault();
      } else {
        return;
      }
      this.alertDesc = '';
      if (!this.validate()) {
        return false;
      }
      this.loading = true;
      var order = JSON.parse(stringify_default()(this.order));
      order.OrderPaymentInformation = null;
      this.$http.post('PlaceOrder.aspx/SaveCount', {
        currentSessionId: this.$store.state.site.CurrentSessionId,
        order: order
      }, {
        errorType: 'custom'
      }).then(function (resp) {
        if (resp.body.d.DataSource.IsSuccess) {
          _this2.step = 'success';
          _this2.title = 'Thank you';
          _this2.okTitle = 'Close';
          _this2.loading = false;
        } else {
          _this2.loading = false;
          _this2.alertDesc = resp.body.d.DataSource.Message;
        }
      }, function (resp) {
        _this2.loading = false;
        _this2.alertDesc = resp.body.d.ResultMessage;
      });
    },
    validate: function validate() {
      this.showError = false;
      if (!this.orderContact.LastName) {
        this.showError = true;
      }
      if (!this.orderContact.FirstName) {
        this.showError = true;
      }
      if (!this.orderContact.Company) {
        this.showError = true;
      }
      if (!this.orderContact.Email) {
        this.showError = true;
      }
      if (!this.orderContact.Phone) {
        this.showError = true;
      }
      if (!this.orderContact.OrderName) {
        this.showError = true;
      }

      return !this.showError;
    },
    hidden: function hidden() {
      this.step = 'input';
      this.title = 'Save List Count';
      this.okTitle = 'Save';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e82ee81","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MSaveOrder.vue
var MSaveOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"saveorder","title":_vm.showsetting.title,"ok-only":_vm.step==='success',"lazy":true,"ok-title":_vm.okTitle,"ok-disabled":_vm.loading},on:{"hidden":_vm.hidden,"ok":_vm.save}},[_c('b-row',{staticClass:"row-box "},[_c('b-col',[(_vm.step === 'input')?_c('div',[_vm._v("\n      "+_vm._s(_vm.showsetting.message)+"\n     ")]):_vm._e(),_vm._v(" "),(_vm.step === 'success')?_c('div',[_c('b-alert',{attrs:{"show":"","variant":"success"}},[_vm._v("\n        An email has been sent to "+_vm._s(_vm.order.OrderContactInformation.Email)+" with a link to retrieve your saved count.\n        ")]),_vm._v(" "),_c('br')],1):_vm._e()])],1),_vm._v(" "),_c('b-form-group',{staticClass:"first-row-box",attrs:{"horizontal":"","label-cols":4,"label-size":"sm","label":"First Name :"}},[_c('b-input',{attrs:{"disabled":_vm.step==='success',"value":_vm.orderContact.FirstName,"data-test":"summary-saveCount-firstName"},nativeOn:{"input":function($event){return _vm.updateContact('FirstName', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.FirstName)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label-size":"sm","label":"Last Name :"}},[_c('b-input',{attrs:{"disabled":_vm.step==='success',"data-test":"summary-saveCount-lastName","value":_vm.orderContact.LastName},nativeOn:{"input":function($event){return _vm.updateContact('LastName', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.LastName)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label-size":"sm","label":"Company Name :"}},[_c('b-input',{attrs:{"disabled":_vm.step==='success',"value":_vm.orderContact.Company,"data-test":"summary-saveCount-company"},nativeOn:{"input":function($event){return _vm.updateContact('Company', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.Company)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label-size":"sm","label":"Email :"}},[_c('b-input',{attrs:{"disabled":_vm.step==='success',"value":_vm.orderContact.Email,"data-test":"summary-saveCount-email"},nativeOn:{"input":function($event){return _vm.updateContact('Email', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.Email)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label-size":"sm","label":"Telephone :"}},[_c('b-input',{attrs:{"disabled":_vm.step==='success',"value":_vm.orderContact.Phone,"data-test":"summary-saveCount-phone"},nativeOn:{"input":function($event){return _vm.updateContact('Phone', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.Phone)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label-size":"sm","label":"Name This Count :"}},[_c('b-input',{attrs:{"disabled":_vm.step==='success',"value":_vm.orderContact.OrderName,"data-test":"summary-saveCount-countName"},nativeOn:{"input":function($event){return _vm.updateContact('OrderName', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.OrderName)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"row-box"},[_c('b-col',[_c('b-form-checkbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.showsetting.callme),expression:"showsetting.callme"}],model:{value:(_vm.CallMe),callback:function ($$v) {_vm.CallMe=$$v},expression:"CallMe"}},[_vm._v(_vm._s(_vm.showsetting.CallMeText))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-checkbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.showsetting.clients),expression:"showsetting.clients"}],model:{value:(_vm.OrderForClients),callback:function ($$v) {_vm.OrderForClients=$$v},expression:"OrderForClients"}},[_vm._v(_vm._s(_vm.showsetting.orderforclienttext))])],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.alertDesc!==''),expression:"alertDesc!==''"}],staticClass:"row-box"},[_c('b-col',[_c('b-alert',{attrs:{"show":_vm.alertDesc!=='',"variant":"warning"}},[_vm._v(_vm._s(_vm.alertDesc))])],1)],1)],1)}
var MSaveOrder_staticRenderFns = []
var MSaveOrder_esExports = { render: MSaveOrder_render, staticRenderFns: MSaveOrder_staticRenderFns }
/* harmony default export */ var summary_MSaveOrder = (MSaveOrder_esExports);
// CONCATENATED MODULE: ./src/components/summary/MSaveOrder.vue
function MSaveOrder_injectStyle (ssrContext) {
  __webpack_require__("kQX9")
}
var MSaveOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSaveOrder___vue_template_functional__ = false
/* styles */
var MSaveOrder___vue_styles__ = MSaveOrder_injectStyle
/* scopeId */
var MSaveOrder___vue_scopeId__ = "data-v-0e82ee81"
/* moduleIdentifier (server only) */
var MSaveOrder___vue_module_identifier__ = null
var MSaveOrder_Component = MSaveOrder_normalizeComponent(
  MSaveOrder,
  summary_MSaveOrder,
  MSaveOrder___vue_template_functional__,
  MSaveOrder___vue_styles__,
  MSaveOrder___vue_scopeId__,
  MSaveOrder___vue_module_identifier__
)

/* harmony default export */ var components_summary_MSaveOrder = (MSaveOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MPlaceOrderTax.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MPlaceOrderTax = ({
  components: {},
  created: function created() {},
  data: function data() {
    return {
      tax: {},
      loading: true,
      placing: false
    };
  },

  computed: {
    order: function order() {
      return this.$store.state.order;
    }
  },
  methods: {
    getTax: function getTax() {
      var _this = this;

      this.loading = true;
      this.placing = false;
      this.$http.post('PlaceOrder.aspx/CalculateTax', {
        req: {
          AddressLine: this.order.OrderContactInformation.AddressLine,
          City: this.order.OrderContactInformation.City,
          Country: this.order.OrderContactInformation.CountryCode,
          DesiredQty: this.order.TotalDesiredQty,
          ListType: this.order.ListType,
          OrderAmount: this.order.TotalEstmCost,
          OrderNumber: '',
          State: this.order.OrderContactInformation.State,
          TaxAmount: 0,
          UserId: 0,
          Zip: this.order.OrderContactInformation.Zipcode
        }
      }).then(function (resp) {
        if (resp.body.d.ResultFlag) {
          _this.loading = false;
          _this.placing = true;
          _this.tax = resp.body.d.DataSource;

          _this.$store.commit('order/saveKey', ['TaxCharge', _this.tax.TotalTax]);
          _this.$store.commit('order/saveKey', ['OrderCharge', _this.tax.SubTotal]);
          _this.$store.commit('order/saveKey', ['TotalActualCost', _this.tax.Total]);
        }
      }, function (resp) {
        _this.loading = false;
        _this.placing = false;
      });
    },
    placeOrder: function placeOrder() {
      var _this2 = this;

      this.placing = false;
      this.$http.post('PlaceOrder.aspx/ProcessOrder', {
        currentSessionId: this.$store.state.site.CurrentSessionId,
        industry: '',
        licenseName: '',
        password: '',
        sanExpDate: '',
        sanNumber: '',
        order: this.order
      }).then(function (resp) {
        _this2.placing = true;
        var data = resp.body.d.DataSource;
        if (!data.IsSuccess) {
          notification.notice('error', 'Unfortunately, the system is unable to process your request. Our technical support specialists have been notified. Thank you for your patience while we work to resolve the error.', { title: 'Place Order Error', onlyGroup: 'placeOrderError' });
          return false;
        }

        _this2.$store.commit('order/saveKey', ['OrderCode', data.OrderCode]);
        _this2.$store.commit('order/saveKey', ['AccountName', data.AccountName]);
        _this2.$store.commit('order/saveKey', ['SessionGuid', data.OrderSessionGuid]);
        _this2.$store.commit('order/saveKey', ['OrderSubmittedDate', data.OrderSubmittedDate]);
        _this2.$store.commit('order/saveKey', ['CurrentStep', 'success']);

        utils.uaEcommerce(_this2.$store.state.order, _this2.$store.getters['config/datasource'].name, _this2.$store.getters['config/datasource'].SKU);
        _this2.$router.push({ path: 'success' });

        // update user point
        // TODO@PONY need to use new api
        _this2.$http.post('LandingPage.aspx/GetUserPoint', {}).then(function (resp) {}, function (resp) {
          _this2.$store.commit('user/saveKey', ['userPoint', resp.body.d.DataSource.UserPoint]);
        });
      }, function (resp) {
        _this2.placing = true;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c7a5e92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MPlaceOrderTax.vue
var MPlaceOrderTax_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"placeOrderTax","lazy":true,"ok-disabled":!_vm.placing,"title":"Confirm your order","ok-title":"Place Order"},on:{"ok":_vm.placeOrder,"show":_vm.getTax}},[_c('m-loader',{attrs:{"size":"box","show":_vm.loading}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_c('table',[_c('tr',[_c('td',[_vm._v("Sub Total:")]),_vm._v(" "),_c('td',{attrs:{"data-test":"summary-tax-subPrice"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.tax.SubTotal)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Tax Price:")]),_vm._v(" "),_c('td',{attrs:{"data-test":"summary-tax-taxPrice"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.tax.TotalTax)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Total Price:")]),_vm._v(" "),_c('td',{attrs:{"data-test":"summary-tax-totalPrice"}},[_vm._v(" "+_vm._s(_vm._f("numberFormat")(_vm.tax.Total)))])])])])],1)}
var MPlaceOrderTax_staticRenderFns = []
var MPlaceOrderTax_esExports = { render: MPlaceOrderTax_render, staticRenderFns: MPlaceOrderTax_staticRenderFns }
/* harmony default export */ var summary_MPlaceOrderTax = (MPlaceOrderTax_esExports);
// CONCATENATED MODULE: ./src/components/summary/MPlaceOrderTax.vue
function MPlaceOrderTax_injectStyle (ssrContext) {
  __webpack_require__("bUOA")
}
var MPlaceOrderTax_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MPlaceOrderTax___vue_template_functional__ = false
/* styles */
var MPlaceOrderTax___vue_styles__ = MPlaceOrderTax_injectStyle
/* scopeId */
var MPlaceOrderTax___vue_scopeId__ = "data-v-2c7a5e92"
/* moduleIdentifier (server only) */
var MPlaceOrderTax___vue_module_identifier__ = null
var MPlaceOrderTax_Component = MPlaceOrderTax_normalizeComponent(
  MPlaceOrderTax,
  summary_MPlaceOrderTax,
  MPlaceOrderTax___vue_template_functional__,
  MPlaceOrderTax___vue_styles__,
  MPlaceOrderTax___vue_scopeId__,
  MPlaceOrderTax___vue_module_identifier__
)

/* harmony default export */ var components_summary_MPlaceOrderTax = (MPlaceOrderTax_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/MSaveQuickPick.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var MSaveQuickPick = ({
  components: {
    MErrorText: components_common_MerrorText
  },
  created: function created() {},
  data: function data() {
    return {
      okTitle: 'save',
      step: 'input',
      quickPickDesc: '',
      quickPickName: '',
      alertDesc: '',
      loading: false,
      showError: false,
      unSelectedDemos: [],
      saveDemos: [],
      unSaveDemos: []
    };
  },

  computed: {
    order: function order() {
      return this.$store.state.order;
    },
    listType: function listType() {
      return this.$store.state.order.ListType;
    },
    demos: function demos() {
      var _this = this;

      var result = [];

      var _loop = function _loop(demo) {
        if (demo.type === 'column') {
          result.push({
            Values: lodash_default.a.filter(_this.saveDemos, function (x) {
              return x.ColumnName === demo.ColumnName && x.type === 'value';
            }),
            AttributeName: demo.AttributeValueName,
            ColumnName: demo.ColumnName,
            DemoCategoryType: demo.DemoCategoryType
          });
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.saveDemos), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var demo = _step.value;

          _loop(demo);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    selectedDemos: function selectedDemos() {
      var demos = this.$store.getters['order/demoItems'];
      var result = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(demos), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var column = _step2.value;

          // when save qp, we should remove the selected qp options
          if (column.DemoCategoryType === 2) continue;
          result.push({
            type: 'column',
            ColumnName: column.ColumnName,
            AttributeValueName: column.AttributeName,
            AttributeName: column.AttributeName,
            DemoCategoryType: column.DemoCategoryType
          });
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = get_iterator_default()(column.Values), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var value = _step3.value;

              result.push({
                type: 'value',
                AttributeValue: value.AttributeValue,
                ColumnName: value.ColumnName,
                AttributeValueName: value.AttributeValueName,
                AttributeName: column.AttributeName,
                DemoCategoryType: column.DemoCategoryType,
                ShortSeq: 5
              });
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return result;
    }
  },
  methods: {
    save: function save(evt) {
      var _this2 = this;

      this.alertDesc = '';
      if (this.step === 'input') {
        evt.preventDefault();
      } else {
        return;
      }
      if (this.demos.length === 0) {
        this.alertDesc = 'Please add quickpick criteria.';
        return;
      }
      this.showError = true;
      var existError = false;
      if (utils.verify(this.quickPickDesc, 'require')) existError = true;
      if (utils.verify(this.quickPickName, 'require')) existError = true;
      if (existError) return;

      this.loading = true;
      this.$http.post('PlaceOrder.aspx/SaveMyQuickpick', {
        listType: this.listType,
        quickPickDesc: this.quickPickDesc,
        quickPickName: this.quickPickName,
        targetOptions: this.demos
      }, {
        errorType: 'custom'
      }).then(function (resp) {
        _this2.step = 'success';
        _this2.title = 'Thank your';
        _this2.okTitle = 'Close';
        _this2.loading = false;
        _this2.quickPickName = '';
        _this2.quickPickDesc = '';
        _this2.$store.commit('demo/saveKey', ['saveNewQuickPick', true]);
        _this2.$store.commit('demo/saveKey', ['hasQuickPicks', true]);
      }, function (resp) {
        _this2.loading = false;
        _this2.alertDesc = resp.body.d.ResultMessage;
      });
    },
    hidden: function hidden() {
      this.step = 'input';
      this.okTitle = 'Save';
    },
    showDemo: function showDemo() {
      this.saveDemos = JSON.parse(stringify_default()(this.selectedDemos));
    },
    cleanDemos: function cleanDemos() {
      this.saveDemos = [];
    },
    deleteDemos: function deleteDemos() {
      var tempDemos = JSON.parse(stringify_default()(this.saveDemos));

      var _loop2 = function _loop2(item) {
        if (item.type === 'value') {
          lodash_default.a.remove(tempDemos, function (x) {
            return x.ColumnName === item.ColumnName && x.AttributeValue === item.AttributeValue;
          });
          if (lodash_default.a.findIndex(tempDemos, function (x) {
            return x.ColumnName === item.ColumnName && x.type === 'value';
          }) < 0) {
            lodash_default.a.remove(tempDemos, function (x) {
              return x.ColumnName === item.ColumnName;
            });
          }
        } else {
          lodash_default.a.remove(tempDemos, function (x) {
            return x.ColumnName === item.ColumnName;
          });
        }
      };

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(this.unSaveDemos), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          _loop2(item);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.saveDemos = tempDemos;
    },
    addDemos: function addDemos() {
      var _this3 = this;

      var tempDemos = JSON.parse(stringify_default()(this.saveDemos));

      var _loop3 = function _loop3(item) {
        if (item.type === 'value') {
          if (lodash_default.a.findIndex(tempDemos, function (x) {
            return x.ColumnName === item.ColumnName && x.AttributeValue === item.AttributeValue && x.AttributeName === item.AttributeName;
          }) < 0) {
            var colIndex = lodash_default.a.findIndex(tempDemos, function (x) {
              return x.ColumnName === item.ColumnName && x.type === 'column' && x.AttributeName === item.AttributeName;
            });
            if (colIndex < 0) {
              tempDemos.push(_this3.selectedDemos[lodash_default.a.findIndex(_this3.selectedDemos, function (x) {
                return x.ColumnName === item.ColumnName && x.type === 'column' && x.AttributeName === item.AttributeName;
              })]);
              tempDemos.push(item);
            } else {
              tempDemos.splice(colIndex + 1, 0, item);
            }
          }
        } else {
          var values = lodash_default.a.filter(_this3.selectedDemos, function (x) {
            return x.ColumnName === item.ColumnName && x.type === 'value' && x.AttributeName === item.AttributeName;
          });
          var _colIndex = lodash_default.a.findIndex(tempDemos, function (x) {
            return x.ColumnName === item.ColumnName && x.type === 'column' && x.AttributeName === item.AttributeName;
          });
          if (_colIndex < 0) {
            tempDemos.push(item);
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = get_iterator_default()(values), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var v = _step6.value;

                tempDemos.push(v);
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          } else {
            var _loop4 = function _loop4(_v) {
              if (lodash_default.a.findIndex(tempDemos, function (x) {
                return x.ColumnName === _v.ColumnName && x.AttributeValue === _v.AttributeValue && x.AttributeName === item.AttributeName;
              }) < 0) {
                tempDemos.splice(_colIndex + 1, 0, _v);
              }
            };

            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = get_iterator_default()(values), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var _v = _step7.value;

                _loop4(_v);
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          }
        }
      };

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.unSelectedDemos), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          _loop3(item);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.saveDemos = tempDemos;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d77f20c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/MSaveQuickPick.vue
var MSaveQuickPick_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"saveQuickPick","title":"Save as Quick Pick","ok-only":_vm.step==='success',"lazy":true,"ok-title":_vm.okTitle,"ok-disabled":_vm.loading,"size":"lg"},on:{"hidden":_vm.hidden,"show":_vm.showDemo,"ok":_vm.save}},[(_vm.step === 'input')?_c('div',[_c('b-row',[_c('b-col',{staticClass:"the-box",attrs:{"cols":"3"}},[_vm._v("My Quickpick Name: (*)")]),_vm._v(" "),_c('b-col',{staticClass:"input-box",attrs:{"cols":"3"}},[_c('b-input',{model:{value:(_vm.quickPickName),callback:function ($$v) {_vm.quickPickName=$$v},expression:"quickPickName"}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.quickPickName,"immediate":_vm.showError,"rules":['require']}})],1),_vm._v(" "),_c('b-col',{staticClass:"the-box",attrs:{"cols":"3"}},[_vm._v("My Quickpick Definition: (*)")]),_vm._v(" "),_c('b-col',{staticClass:"input-box",attrs:{"cols":"3"}},[_c('b-input',{model:{value:(_vm.quickPickDesc),callback:function ($$v) {_vm.quickPickDesc=$$v},expression:"quickPickDesc"}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.quickPickDesc,"immediate":_vm.showError,"rules":['require']}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-text-deep selectrow"},[_c('b-col',{attrs:{"md":"5"}},[_c('h4',{staticClass:"mt-2"},[_vm._v("Your Target Audience")]),_vm._v(" "),_c('b-select',{staticClass:"demo-select",attrs:{"select-size":20,"multiple":""},model:{value:(_vm.unSelectedDemos),callback:function ($$v) {_vm.unSelectedDemos=$$v},expression:"unSelectedDemos"}},_vm._l((_vm.selectedDemos),function(item){return _c('option',{staticClass:"demos-value",class:{'demos-column':item.type === 'column' },domProps:{"value":item}},[_vm._v("\n          "+_vm._s(item.AttributeValueName)+"\n        ")])}),0)],1),_vm._v(" "),_c('b-col',{staticClass:"m-select-btn-box",attrs:{"md":"2"}},[_c('b-btn',{staticClass:"m-select-btn",attrs:{"size":"sm"},on:{"click":function($event){return _vm.addDemos()}}},[_vm._v("\n        Add")]),_vm._v(" "),_c('b-btn',{staticClass:"m-select-btn",attrs:{"size":"sm"},on:{"click":function($event){return _vm.deleteDemos()}}},[_vm._v("\n        Remove")]),_vm._v(" "),_c('b-btn',{staticClass:"m-select-btn",attrs:{"size":"sm"},on:{"click":function($event){return _vm.cleanDemos()}}},[_vm._v("\n        Remove All")])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('h4',{staticClass:"mt-2"},[_vm._v("Your Target Audience")]),_vm._v(" "),_c('b-select',{staticClass:"demo-select",attrs:{"select-size":20,"multiple":""},model:{value:(_vm.unSaveDemos),callback:function ($$v) {_vm.unSaveDemos=$$v},expression:"unSaveDemos"}},_vm._l((_vm.saveDemos),function(item){return _c('option',{staticClass:"demos-value",class:{'demos-column':item.type === 'column' },domProps:{"value":item}},[_vm._v("\n          "+_vm._s(item.AttributeValueName)+"\n        ")])}),0)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-alert',{staticStyle:{"margin-top":"8px"},attrs:{"show":_vm.alertDesc!=='',"variant":"warning"},domProps:{"innerHTML":_vm._s(_vm.alertDesc)}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.step === 'success')?_c('div',[_c('b-row',[_c('b-col',[_vm._v("\n        Your quickpick has been saved and is available moving forward behind the QuickPicks tab\n    ")])],1)],1):_vm._e()])}
var MSaveQuickPick_staticRenderFns = []
var MSaveQuickPick_esExports = { render: MSaveQuickPick_render, staticRenderFns: MSaveQuickPick_staticRenderFns }
/* harmony default export */ var demo_MSaveQuickPick = (MSaveQuickPick_esExports);
// CONCATENATED MODULE: ./src/components/demo/MSaveQuickPick.vue
function MSaveQuickPick_injectStyle (ssrContext) {
  __webpack_require__("6t2/")
}
var MSaveQuickPick_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSaveQuickPick___vue_template_functional__ = false
/* styles */
var MSaveQuickPick___vue_styles__ = MSaveQuickPick_injectStyle
/* scopeId */
var MSaveQuickPick___vue_scopeId__ = "data-v-8d77f20c"
/* moduleIdentifier (server only) */
var MSaveQuickPick___vue_module_identifier__ = null
var MSaveQuickPick_Component = MSaveQuickPick_normalizeComponent(
  MSaveQuickPick,
  demo_MSaveQuickPick,
  MSaveQuickPick___vue_template_functional__,
  MSaveQuickPick___vue_styles__,
  MSaveQuickPick___vue_scopeId__,
  MSaveQuickPick___vue_module_identifier__
)

/* harmony default export */ var components_demo_MSaveQuickPick = (MSaveQuickPick_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MSendQuote.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var MsendQuote = {
  components: {},
  created: function created() {},
  data: function data() {
    return {};
  },

  computed: {
    order: function order() {
      return this.$store.state.order;
    }
  },
  watch: {},
  methods: {
    hidden: function hidden() {}
  }
};
/* harmony default export */ var MSendQuote = (MsendQuote);

/* eslint-disable */
page.OrderQuote = {
  CloseDialog: function CloseDialog() {
    MsendQuote.$root.$emit('bv::hide::modal', 'sendQuote');
  }
};
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b3e5ece","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MSendQuote.vue
var MSendQuote_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"sendQuote","title":"Send Quote","ok-only":true,"ok-title":"Close","lazy":true,"size":"lg"}},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.$store.getters['config/link']('sendQuote'),"width":"100","frameborder":"0"}})])}
var MSendQuote_staticRenderFns = []
var MSendQuote_esExports = { render: MSendQuote_render, staticRenderFns: MSendQuote_staticRenderFns }
/* harmony default export */ var summary_MSendQuote = (MSendQuote_esExports);
// CONCATENATED MODULE: ./src/components/summary/MSendQuote.vue
function MSendQuote_injectStyle (ssrContext) {
  __webpack_require__("MfYH")
  __webpack_require__("1xi3")
}
var MSendQuote_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSendQuote___vue_template_functional__ = false
/* styles */
var MSendQuote___vue_styles__ = MSendQuote_injectStyle
/* scopeId */
var MSendQuote___vue_scopeId__ = "data-v-5b3e5ece"
/* moduleIdentifier (server only) */
var MSendQuote___vue_module_identifier__ = null
var MSendQuote_Component = MSendQuote_normalizeComponent(
  MSendQuote,
  summary_MSendQuote,
  MSendQuote___vue_template_functional__,
  MSendQuote___vue_styles__,
  MSendQuote___vue_scopeId__,
  MSendQuote___vue_module_identifier__
)

/* harmony default export */ var components_summary_MSendQuote = (MSendQuote_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MDataUseAgreement.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MDataUseAgreement = ({
  data: function data() {
    return {
      content: ''
    };
  },

  methods: {
    getContent: function getContent() {
      var _this = this;

      this.content = false;
      this.$http.post('PlaceOrder.aspx/GetDataUseAgreement', {
        listType: this.$store.state.order.ListType
      }).then(function (resp) {
        _this.content = resp.body.d.DataSource;
      });
    },
    print: function print(evt) {
      evt.preventDefault();
      window.open(this.$store.getters['config/link']('aggrementPDF'));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a9765e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MDataUseAgreement.vue
var MDataUseAgreement_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"modal-box",attrs:{"id":"datauseagreement","size":"lg","title":"Data Use Agreement","lazy":true,"cancel-title":"Print","no-close-on-backdrop":"","no-close-on-esc":""},on:{"show":_vm.getContent,"cancel":_vm.print}},[(_vm.content)?_c('div',{staticClass:"aggreement-content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e(),_vm._v(" "),_c('m-loader',{directives:[{name:"show",rawName:"v-show",value:(!_vm.content),expression:"!content"}],attrs:{"size":"smBox"}})],1)}
var MDataUseAgreement_staticRenderFns = []
var MDataUseAgreement_esExports = { render: MDataUseAgreement_render, staticRenderFns: MDataUseAgreement_staticRenderFns }
/* harmony default export */ var summary_MDataUseAgreement = (MDataUseAgreement_esExports);
// CONCATENATED MODULE: ./src/components/summary/MDataUseAgreement.vue
function MDataUseAgreement_injectStyle (ssrContext) {
  __webpack_require__("n1Zb")
  __webpack_require__("Tk57")
}
var MDataUseAgreement_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MDataUseAgreement___vue_template_functional__ = false
/* styles */
var MDataUseAgreement___vue_styles__ = MDataUseAgreement_injectStyle
/* scopeId */
var MDataUseAgreement___vue_scopeId__ = "data-v-47a9765e"
/* moduleIdentifier (server only) */
var MDataUseAgreement___vue_module_identifier__ = null
var MDataUseAgreement_Component = MDataUseAgreement_normalizeComponent(
  MDataUseAgreement,
  summary_MDataUseAgreement,
  MDataUseAgreement___vue_template_functional__,
  MDataUseAgreement___vue_styles__,
  MDataUseAgreement___vue_scopeId__,
  MDataUseAgreement___vue_module_identifier__
)

/* harmony default export */ var components_summary_MDataUseAgreement = (MDataUseAgreement_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/MTotalRecords.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MTotalRecords = ({
  data: function data() {
    return {
      okTitle: 'close',
      responData: null,
      alertDesc: ''
    };
  },

  computed: {
    geoItems: function geoItems() {
      return this.$store.getters['order/geoItems'];
    },
    order: function order() {
      return this.$store.state.order;
    },
    showdata: function showdata() {
      if (this.responData !== null) {
        return { geo: this.responData.OrderGeoName, phonecount: this.responData.PhoneCount[1].Count, totalcount: this.responData.PhoneCount[1].Count + this.responData.PhoneCount[0].Count };
      }
      return { geo: '', phonecount: 0, totalcount: 0 };
    }
  },
  methods: {
    gettotalCount: function gettotalCount() {
      this.alertDesc = '';
      if (this.geoItems.length === 0 && this.$store.state.order.OrderAddresses.length === 0) {
        this.alertDesc = 'Please select at least one Geo Address';
        this.responData = null;
        return;
      }
      var that = this;
      this.$http.post('PlaceOrder.aspx/GetPhoneResult', {
        order: this.$store.state.order
      }).then(function (resp) {
        if (resp.body.d.ResultFlag) {
          that.responData = resp.body.d.DataSource;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da8b1544","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/MTotalRecords.vue
var MTotalRecords_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"totalRecords","title":"Total Records vs Total with Phones","ok-title":_vm.okTitle,"size":"lg","lazy":true,"ok-only":""},on:{"shown":_vm.gettotalCount}},[_c('b-row',[_c('b-col',[_c('b-alert',{attrs:{"show":_vm.alertDesc!=='',"variant":"warning"}},[_vm._v(_vm._s(_vm.alertDesc))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h3',[_vm._v("Geo Breakdown")])]),_vm._v(" "),_c('b-col',[_c('h3',[_vm._v("Total Records with Phone")])]),_vm._v(" "),_c('b-col',[_c('h3',[_vm._v("Total Records")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_vm._v("\n      "+_vm._s(_vm.showdata.geo)+"\n    ")]),_vm._v(" "),_c('b-col',[_vm._v("\n      "+_vm._s(_vm.showdata.phonecount)+"\n    ")]),_vm._v(" "),_c('b-col',[_vm._v("\n      "+_vm._s(_vm.showdata.totalcount)+"\n    ")])],1),_vm._v(" "),_c('m-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.responData === null && (this.geoItems.length !== 0 || this.$store.state.order.OrderAddresses.length !== 0)),expression:"responData === null && (this.geoItems.length !== 0 || this.$store.state.order.OrderAddresses.length !== 0)"}],attrs:{"size":"smBox"}})],1)}
var MTotalRecords_staticRenderFns = []
var MTotalRecords_esExports = { render: MTotalRecords_render, staticRenderFns: MTotalRecords_staticRenderFns }
/* harmony default export */ var demo_MTotalRecords = (MTotalRecords_esExports);
// CONCATENATED MODULE: ./src/components/demo/MTotalRecords.vue
function MTotalRecords_injectStyle (ssrContext) {
  __webpack_require__("LV+5")
}
var MTotalRecords_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MTotalRecords___vue_template_functional__ = false
/* styles */
var MTotalRecords___vue_styles__ = MTotalRecords_injectStyle
/* scopeId */
var MTotalRecords___vue_scopeId__ = "data-v-da8b1544"
/* moduleIdentifier (server only) */
var MTotalRecords___vue_module_identifier__ = null
var MTotalRecords_Component = MTotalRecords_normalizeComponent(
  MTotalRecords,
  demo_MTotalRecords,
  MTotalRecords___vue_template_functional__,
  MTotalRecords___vue_styles__,
  MTotalRecords___vue_scopeId__,
  MTotalRecords___vue_module_identifier__
)

/* harmony default export */ var components_demo_MTotalRecords = (MTotalRecords_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/MSampleExample.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MSampleExample = ({
  data: function data() {
    return {
      standardFields: ['Prefix Title', 'Individual Name (Full)', 'First Name', 'Middle Initial', 'Last Name', 'Address Line', 'Address Line 2', 'City', 'State', 'ZIP Code', 'ZIP+4', 'Delivery Point Code']
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80fa47e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MSampleExample.vue
var MSampleExample_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"sampleExample","size":"lg","ok-only":true,"lazy":true,"title":"What’s included in my list?","hide-footer":true}},[_c('p',[_vm._v("Your list order will include the fields listed below, any filters you’ve chosen in building your list, plus any optional fields you choose to include in the output of your list.\n  ")]),_vm._v(" "),_c('b-tabs',[_c('b-tab',{attrs:{"title":"Consumer"}},[_c('p',{staticClass:"example-title"},[_vm._v("Standard Consumer Fields")]),_vm._v(" "),_c('b-img',{staticClass:"example-img",attrs:{"src":"./static/example/consumer.gif","fluid":""}}),_vm._v(" "),_c('b-img',{staticClass:"example-img",attrs:{"src":"./static/example/consumer-2.gif","fluid":""}})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Business"}},[_c('p',{staticClass:"example-title"},[_vm._v("Standard Business Fields")]),_vm._v(" "),_c('b-img',{staticClass:"example-img",attrs:{"src":"./static/example/business.gif","fluid":""}}),_vm._v(" "),_c('b-img',{staticClass:"example-img",attrs:{"src":"./static/example/business-2.gif","fluid":""}})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"New Mover"}},[_c('p',{staticClass:"example-title"},[_vm._v("Standard New Mover Fields")]),_vm._v(" "),_c('b-img',{staticClass:"example-img",attrs:{"src":"./static/example/newmover.gif","fluid":""}})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"New Homeowner"}},[_c('p',{staticClass:"example-title"},[_vm._v("Standard New Homeowner Fields")]),_vm._v(" "),_c('b-img',{staticClass:"example-img",attrs:{"src":"./static/example/homeowners.gif","fluid":""}})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Saturation "}},[_c('p',{staticClass:"example-title"},[_vm._v("Standard Saturation Fields")]),_vm._v(" "),_c('b-img',{staticClass:"example-img",attrs:{"src":"./static/example/CIS.gif","fluid":""}})],1)],1)],1)}
var MSampleExample_staticRenderFns = []
var MSampleExample_esExports = { render: MSampleExample_render, staticRenderFns: MSampleExample_staticRenderFns }
/* harmony default export */ var common_MSampleExample = (MSampleExample_esExports);
// CONCATENATED MODULE: ./src/components/common/MSampleExample.vue
function MSampleExample_injectStyle (ssrContext) {
  __webpack_require__("3ilW")
  __webpack_require__("zrWs")
}
var MSampleExample_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSampleExample___vue_template_functional__ = false
/* styles */
var MSampleExample___vue_styles__ = MSampleExample_injectStyle
/* scopeId */
var MSampleExample___vue_scopeId__ = "data-v-80fa47e4"
/* moduleIdentifier (server only) */
var MSampleExample___vue_module_identifier__ = null
var MSampleExample_Component = MSampleExample_normalizeComponent(
  MSampleExample,
  common_MSampleExample,
  MSampleExample___vue_template_functional__,
  MSampleExample___vue_styles__,
  MSampleExample___vue_scopeId__,
  MSampleExample___vue_module_identifier__
)

/* harmony default export */ var components_common_MSampleExample = (MSampleExample_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/Order.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var Order = ({
  components: {
    Order1: pages_order_Order1,
    Order2: pages_order_Order2,
    MCounting: components_summary_MCounting,
    MSampleExample: components_common_MSampleExample,
    MSaveOrder: components_summary_MSaveOrder,
    MPlaceOrderTax: components_summary_MPlaceOrderTax,
    MSaveQuickPick: components_demo_MSaveQuickPick,
    MSendQuote: components_summary_MSendQuote,
    MDataUseAgreement: components_summary_MDataUseAgreement,
    MTotalRecords: components_demo_MTotalRecords
  },
  props: {},
  created: function created() {
    var listType = parseInt(this.$route.params.listType);

    this.$store.dispatch('demo/init', listType);
    // init savelistcount
    if (this.$route.query.FromGateway) {
      this.getOrderFromSession();
      this.$store.commit('site/saveKey', ['isSCL', true]);
    } else {
      this.$store.dispatch('order/initOrder', listType);
    }
    // init recommend
    // this.getRecommendDemo()
  },

  watch: {
    '$route.params.listType': function $routeParamsListType() {
      var listType = parseInt(this.$route.params.listType);

      if (!this.$store.getters['config/checkDatasource'](listType)) {
        this.$router.replace({ name: 'landing' });
      } else if (listType !== this.$store.state.order.ListType) {
        this.$store.dispatch('order/initOrder', listType);
        this.$store.dispatch('demo/init', listType);

        if (this.$route.name === 'summary') {
          // @TODO need add some notice about this
          this.$router.replace({ name: 'order' });
        }
      }
    }
  },
  computed: {
    uiVersion: function uiVersion() {
      return this.$store.state.config.uiVersion;
    }
  },
  methods: {
    getOrder: function getOrder() {
      // TODO@PONY no need this way
      if (this.getCountId) {
        this.$store.dispatch('order/getOrderAndCount', this.getCountId);

        this.$store.commit('summary/saveKey', ['getCountId', false]);
      }
    },
    getRecommendDemo: function getRecommendDemo() {
      if (this.recommendDemos.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(this.recommendDemos), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var demo = _step.value;

            this.$store.commit('order/addNewDemo', demo);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.$store.commit('demo/saveKey', ['recommendDemos', []]);
      }
    },
    getOrderFromSession: function getOrderFromSession() {
      var _this = this;

      this.$http.post('PlaceOrder.aspx/GetOrderFromSession', {}).then(function (resp) {
        if (resp.body.d.ResultFlag) {
          _this.$store.commit('order/saveOrder', resp.body.d.DataSource);
          _this.$store.dispatch('order/slcPollOrder');
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17e7d778","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/Order.vue
var Order_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-counting'),_vm._v(" "),_c('m-total-records'),_vm._v(" "),_c('m-save-order'),_vm._v(" "),_c('m-place-order-tax'),_vm._v(" "),_c('m-save-quick-pick'),_vm._v(" "),_c('m-send-quote'),_vm._v(" "),_c('m-data-use-agreement'),_vm._v(" "),_c('m-sample-example'),_vm._v(" "),(_vm.uiVersion === 1)?_c('order1',[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.uiVersion === 2)?_c('order2',[_vm._t("default")],2):_vm._e()],1)}
var Order_staticRenderFns = []
var Order_esExports = { render: Order_render, staticRenderFns: Order_staticRenderFns }
/* harmony default export */ var order_Order = (Order_esExports);
// CONCATENATED MODULE: ./src/pages/order/Order.vue
function Order_injectStyle (ssrContext) {
  __webpack_require__("00Da")
}
var Order_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Order___vue_template_functional__ = false
/* styles */
var Order___vue_styles__ = Order_injectStyle
/* scopeId */
var Order___vue_scopeId__ = "data-v-17e7d778"
/* moduleIdentifier (server only) */
var Order___vue_module_identifier__ = null
var Order_Component = Order_normalizeComponent(
  Order,
  order_Order,
  Order___vue_template_functional__,
  Order___vue_styles__,
  Order___vue_scopeId__,
  Order___vue_module_identifier__
)

/* harmony default export */ var pages_order_Order = (Order_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/SignIn.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import jsCookie from 'js-cookie'
// import _ from 'lodash'

/* harmony default export */ var SignIn = ({
  components: {
    MFooter: components_layouts_MFooter
  },
  data: function data() {
    return {
      user: {
        email: '',
        Password: '',
        remember: false
      },
      passButtonText: 'Show',
      passInputType: 'password',
      showType: 'signIn', // forgotPassword, resetPassword, signIn
      forgotPasswordState: null,
      errorDesc: '',
      userValid: {
        email: {
          state: null,
          text: ''
        },
        password: {
          state: null,
          text: ''
        }
      },
      emailValid: {
        email: {
          state: null,
          text: ''
        }
      },
      newPassword: '',
      reNewPassword: '',
      passwordValid: {
        newPassword: {
          state: null,
          text: ''
        },
        reNewPassword: {
          state: null,
          text: ''
        }
      },
      resetDisabled: false,
      sendEmail: ''
    };
  },

  methods: {
    togglePassword: function togglePassword() {
      if (this.passInputType === 'password') {
        this.passInputType = 'text';
        this.passButtonText = 'Hide';
      } else {
        this.passInputType = 'password';
        this.passButtonText = 'Show';
      }
    },
    validUser: function validUser() {
      var isValid = true;
      this.clearValid(this.userValid);
      if (this.user.email.indexOf('@') < 0 || this.user.email.indexOf('@') === this.user.email.length - 1) {
        this.userValid.email.state = false;
        this.userValid.email.text = 'E-mail must be valid';
        isValid = false;
      }
      if (!this.user.email) {
        this.userValid.email.state = false;
        this.userValid.email.text = "It's required";
        isValid = false;
      }
      if (!this.user.password) {
        this.userValid.password.state = false;
        this.userValid.password.text = "It's required";
        isValid = false;
      }
      return isValid;
    },
    validEmail: function validEmail() {
      var isValid = true;
      this.clearValid(this.emailValid);
      if (this.user.email.indexOf('@') < 0 || this.user.email.indexOf('@') === this.user.email.length - 1) {
        this.emailValid.email.state = false;
        this.emailValid.email.text = 'E-mail must be valid';
        isValid = false;
      }
      if (!this.user.email) {
        this.emailValid.email.state = false;
        this.emailValid.email.text = "It's required";
        isValid = false;
      }
      return isValid;
    },
    signIn: function signIn() {
      var _this = this;

      if (this.validUser()) {
        this.$http.post('Login.aspx/LoginUser', {
          // this.$http.get('UserLogin.ashx', {
          email: this.user.email,
          password: this.user.password
        }, {
          errorType: 'silent'
        }).then(function (resp) {
          _this.resetDisabled = false;
          var url = resp.body.d.DataSource.NextUrl;
          if (url.indexOf('main/#') > -1) {
            _this.$store.dispatch('user/getUserInit');
            _this.$store.dispatch('user/getEditUserInfo');
            window.first.isLogin = 'ok';
            _this.$root.$emit('run');
            _this.$router.push({ name: 'landing' });
          } else if (url.indexOf('Common/ResetPassword.aspx') > -1) {
            _this.showType = 'resetPassword';
          } else {
            window.location = url;
          }
        }, function (resp) {
          _this.resetDisabled = false;
          _this.forgotPasswordState = false;
          _this.errorDesc = 'The email address or password entered is invalid.';
        });
      }
    },
    requestPassword: function requestPassword() {
      var _this2 = this;

      var that = this;
      if (this.validEmail()) {
        this.$http.get('GeneratePwd.ashx', {
          params: {
            email: this.user.email
          }
        }).then(function (resp) {
          that.forgotPasswordState = JSON.parse(resp.body.substring(8)).ResultFlag;
          _this2.sendEmail = _this2.user.email;
        }, function (resp) {
          that.forgotPasswordState = false;
        });
      }
    },
    clearValid: function clearValid(items) {
      for (var key in items) {
        items[key].state = null;
        items[key].text = false;
      }
    },
    resetPassword: function resetPassword() {
      var _this3 = this;

      this.clearValid(this.passwordValid);
      var isValid = true;
      this.passwordValid.newPassword.text = '';

      if (this.newPassword.length < 10) {
        this.passwordValid.newPassword.state = false;
        this.passwordValid.newPassword.text = 'least 10 characters; ';
        isValid = false;
      }
      if (!/\d/gi.test(this.newPassword)) {
        this.passwordValid.newPassword.state = false;
        this.passwordValid.newPassword.text += 'at least one number; ';
        isValid = false;
      }
      if (!/(?=.*[A-Z])/.test(this.newPassword)) {
        this.passwordValid.newPassword.state = false;
        this.passwordValid.newPassword.text += 'at least one uppercase letter; ';
        isValid = false;
      }
      if (!/(?=.*[a-z])/.test(this.newPassword)) {
        this.passwordValid.newPassword.state = false;
        this.passwordValid.newPassword.text += 'at least one lowercase letter; ';
        isValid = false;
      }
      if (this.newPassword !== this.reNewPassword) {
        this.passwordValid.reNewPassword.state = false;
        this.passwordValid.reNewPassword.text = 'The new passwords you\'ve entered do not match. Please re-enter.';
        isValid = false;
      }

      if (!isValid) {
        return false;
      }

      this.resetDisabled = true;
      this.$http.post('Login.aspx/ResetPassword', {
        password: this.newPassword
      }, {
        errorType: 'silent'
      }).then(function (resp) {
        if (resp.body.d.DataSource) {
          _this3.user.password = _this3.newPassword;
          _this3.signIn();
        } else {
          _this3.resetDisabled = false;
          notification.notice('error', 'Failed to create a new password , please try again');
        }
      }, function (resp) {
        _this3.resetDisabled = false;
        notification.notice('error', 'Failed to create a new password , please try again');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85cca78e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SignIn.vue
var SignIn_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sigin-page"},[_c('b-container',{staticClass:"sigin-box",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"col"},[_c('b-link',{staticStyle:{"padding-left":"24px"},attrs:{"to":{name: 'landing'}}},[_c('img',{staticStyle:{"margin-bottom":"16px"},attrs:{"src":__webpack_require__("novS")}})]),_vm._v(" "),_c('h1',{directives:[{name:"show",rawName:"v-show",value:(_vm.showType==='signIn'),expression:"showType==='signIn'"}]},[_vm._v("Sign In to your SL360 account")]),_vm._v(" "),_c('h1',{directives:[{name:"show",rawName:"v-show",value:(_vm.showType==='forgotPassword'),expression:"showType==='forgotPassword'"}]},[_vm._v("Forget your password")]),_vm._v(" "),_c('h1',{directives:[{name:"show",rawName:"v-show",value:(_vm.showType==='resetPassword'),expression:"showType==='resetPassword'"}]},[_vm._v("Password Reset for SL360")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"container box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showType==='signIn'),expression:"showType==='signIn'"}]},[_c('b-alert',{attrs:{"show":_vm.errorDesc!=='',"variant":"danger"},domProps:{"innerHTML":_vm._s(_vm.errorDesc)}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email Address")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"email","type":"text","placeholder":"Enter Email Address","state":_vm.userValid.email.state},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}}),_vm._v(" "),(_vm.userValid.email.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userValid.email.text))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"password","type":_vm.passInputType,"placeholder":"Enter Password","state":_vm.userValid.password.state},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.signIn($event)}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),_c('b-link',{staticClass:"hide-password",class:{ errorBtn: _vm.userValid.password.state!==null },attrs:{"href":"javascript:void(0)"},on:{"click":_vm.togglePassword}},[_vm._v(_vm._s(_vm.passButtonText))]),_vm._v(" "),(_vm.userValid.password.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.userValid.password.text))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"half"}),_vm._v(" "),_c('div',{staticClass:"half"},[_c('div',{staticClass:"forgot-link"},[_c('b-link',{attrs:{"href":"javascript:void(0)","data-test":"sigin-forgotpassword"},on:{"click":function($event){_vm.showType='forgotPassword'}}},[_vm._v("Forgot Password?")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('b-btn',{staticClass:"sub-btn",on:{"click":_vm.signIn}},[_vm._v("Sign In")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_vm._v("\n              Don't have an account yet?\n              "),_c('b-link',{attrs:{"href":_vm.$store.state.config.link.signUp,"dtat-test":"signin-signup"}},[_vm._v("Sign up.")])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showType==='forgotPassword'),expression:"showType==='forgotPassword'"}]},[_c('b-alert',{attrs:{"variant":"success","show":_vm.forgotPasswordState}},[_vm._v("\n              Thank you. A temporary password has been emailed to "+_vm._s(_vm.sendEmail)+".\n              When signIng into SL360 with your temporary password,\n              you will be prompted to create a new password. If you have any questions you may contact 800-395-7707 for assistance.\n            ")]),_vm._v(" "),_c('b-alert',{attrs:{"variant":"danger","show":_vm.forgotPasswordState===false}},[_vm._v("\n              Invalid Email Address\n            ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"rePasswordEmail"}},[_vm._v("Email Address")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"rePasswordEmail","type":"text","placeholder":"Enter Email Address","state":_vm.emailValid.email.state},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}}),_vm._v(" "),(_vm.emailValid.email.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.emailValid.email.text))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('b-btn',{staticClass:"sub-btn",on:{"click":_vm.requestPassword}},[_vm._v("Request Your Password")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('b-link',{attrs:{"href":"javascript:void(0)","data-test":"forgetpassword-signin"},on:{"click":function($event){_vm.showType='signIn'}}},[_vm._v("Click here to Sign In.")])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showType==='resetPassword'),expression:"showType==='resetPassword'"}]},[_c('h5',{staticStyle:{"margin-bottom":"16px"}},[_vm._v("Please create a new password below")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"newPassword"}},[_vm._v("Enter New Password*")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"newPassword","type":"password","placeholder":"Enter New Password","state":_vm.passwordValid.newPassword.state},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}}),_vm._v(" "),(_vm.passwordValid.newPassword.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.passwordValid.newPassword.text))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"againPassword"}},[_vm._v("Re-enter Password")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"againPassword","type":"password","placeholder":"Re-enter Password","state":_vm.passwordValid.reNewPassword.state},model:{value:(_vm.reNewPassword),callback:function ($$v) {_vm.reNewPassword=$$v},expression:"reNewPassword"}}),_vm._v(" "),(_vm.passwordValid.reNewPassword.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.passwordValid.reNewPassword.text))]):_vm._e()],1),_vm._v(" "),_c('p',{staticStyle:{"color":"#aaa"}},[_vm._v("Must be between 10-20 characters with at least one number and one upper case letter. Passwords are case-sensitive.")]),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('b-btn',{staticClass:"sub-btn",attrs:{"disabled":_vm.resetDisabled},on:{"click":_vm.resetPassword}},[_vm._v("Reset")])],1)])])])],1)],1),_vm._v(" "),_c('m-footer')],1)}
var SignIn_staticRenderFns = []
var SignIn_esExports = { render: SignIn_render, staticRenderFns: SignIn_staticRenderFns }
/* harmony default export */ var pages_SignIn = (SignIn_esExports);
// CONCATENATED MODULE: ./src/pages/SignIn.vue
function SignIn_injectStyle (ssrContext) {
  __webpack_require__("xAWQ")
}
var SignIn_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SignIn___vue_template_functional__ = false
/* styles */
var SignIn___vue_styles__ = SignIn_injectStyle
/* scopeId */
var SignIn___vue_scopeId__ = "data-v-85cca78e"
/* moduleIdentifier (server only) */
var SignIn___vue_module_identifier__ = null
var SignIn_Component = SignIn_normalizeComponent(
  SignIn,
  pages_SignIn,
  SignIn___vue_template_functional__,
  SignIn___vue_styles__,
  SignIn___vue_scopeId__,
  SignIn___vue_module_identifier__
)

/* harmony default export */ var src_pages_SignIn = (SignIn_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/reward/MRewardSlide.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MRewardSlide = ({
  components: {},
  computed: {
    availablePoint: function availablePoint() {
      return this.$store.state.reward.point.AvailablePoints;
    },
    carts: function carts() {
      return this.$store.state.reward.carts;
    },
    cartNumber: function cartNumber() {
      return this.$store.getters['reward/cartNumber'];
    },
    cartPoint: function cartPoint() {
      return this.$store.getters['reward/cartPoint'];
    }
  },
  methods: {
    addCart: function addCart(item, qunatity) {
      item.quantity = qunatity || 1;
      this.$store.commit('reward/updateCart', item);
    },
    updateCart: function updateCart(item, e) {
      var quantity = parseInt(e.target.value);
      if (isNaN(quantity)) {
        return false;
      }
      item.Id = item.GiftId;
      item.quantity = quantity;
      item.isUpdated = true;
      this.$store.commit('reward/updateCart', item);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12580575","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward/MRewardSlide.vue
var MRewardSlide_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"reward-item"},[_c('h4',{staticClass:"reward-item-text"},[_vm._v("Shopping Cart")]),_vm._v(" "),_c('div',_vm._l((_vm.carts),function(item){return _c('div',{staticClass:"carts-item"},[_vm._v("\n        "+_vm._s(item.GiftName)+"\n        "),_c('div',{staticClass:"carts-btn"},[_c('b-input',{staticClass:"item-input",attrs:{"type":"number","value":item.DesiredQuantity},nativeOn:{"input":function($event){return _vm.updateCart(item, $event)}}})],1)])}),0),_vm._v(" "),_c('p',[_vm._v("Total: "+_vm._s(_vm._f("numberFormat")(_vm.cartPoint,'', 0))+" Point")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.cartNumber === 0),expression:"cartNumber === 0"}],staticStyle:{"margin-bottom":"24px"}},[_vm._v("\n      Please add reward to cart")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.cartPoint > _vm.availablePoint),expression:"cartPoint > availablePoint"}],staticStyle:{"margin-bottom":"24px"}},[_vm._v("\n      Has exceeded the point you have")]),_vm._v(" "),_c('div',{staticClass:"check-out-box"},[_c('b-btn',{attrs:{"variant":"primary","disabled":_vm.cartNumber === 0 || _vm.cartPoint > _vm.availablePoint},on:{"click":function($event){return _vm.$root.$emit('bv::show::modal', 'rewardCheckOutModal')}}},[_vm._v("\n        Check Out")])],1)]),_vm._v(" "),_c('div',{staticClass:"reward-item"},[_c('H4',{staticClass:"reward-item-text"},[_vm._v("Available Point")]),_vm._v(" "),_c('div',{staticClass:"check-out-box"},[_c('b-link',{on:{"click":function($event){return _vm.$root.$emit('bv::show::modal', 'rewardSummaryModal')}}},[_c('h2',{staticClass:"available-point"},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.availablePoint,'', 0)))]),_vm._v("\n        See detail")])],1)],1)])}
var MRewardSlide_staticRenderFns = []
var MRewardSlide_esExports = { render: MRewardSlide_render, staticRenderFns: MRewardSlide_staticRenderFns }
/* harmony default export */ var reward_MRewardSlide = (MRewardSlide_esExports);
// CONCATENATED MODULE: ./src/components/reward/MRewardSlide.vue
function MRewardSlide_injectStyle (ssrContext) {
  __webpack_require__("Dbrg")
}
var MRewardSlide_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MRewardSlide___vue_template_functional__ = false
/* styles */
var MRewardSlide___vue_styles__ = MRewardSlide_injectStyle
/* scopeId */
var MRewardSlide___vue_scopeId__ = "data-v-12580575"
/* moduleIdentifier (server only) */
var MRewardSlide___vue_module_identifier__ = null
var MRewardSlide_Component = MRewardSlide_normalizeComponent(
  MRewardSlide,
  reward_MRewardSlide,
  MRewardSlide___vue_template_functional__,
  MRewardSlide___vue_styles__,
  MRewardSlide___vue_scopeId__,
  MRewardSlide___vue_module_identifier__
)

/* harmony default export */ var components_reward_MRewardSlide = (MRewardSlide_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/reward/MRewardItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MRewardItem = ({
  components: {},
  data: function data() {
    return {
      sortKey: 'normal', // 'normal', 'toMax', 'toMin'
      sortOldKey: 'noOldKey',
      sortOption: [{ value: 'normal', text: 'Normal' }, { value: 'toMax', text: 'Point low to high' }, { value: 'toMin', text: 'Point high to low' }]
    };
  },

  computed: {
    availablePoint: function availablePoint() {
      return this.$store.state.reward.point.AvailablePoints;
    },
    carts: function carts() {
      return this.$store.state.reward.carts;
    },
    items: function items() {
      var _this = this;

      var items = this.$store.state.reward.items[this.currentCategory];
      if (items === undefined || items.length === 0) {
        this.$store.dispatch('reward/getItem', this.currentCategory);
        return [];
      }

      this.sortOldKey = this.sortKey;
      items = items.sort(function (a, b) {
        if (_this.sortKey === 'normal') {
          return a.Id - b.Id;
        }

        if (_this.sortKey === 'toMax') {
          return a.GiftPoint - b.GiftPoint;
        }

        if (_this.sortKey === 'toMin') {
          return b.GiftPoint - a.GiftPoint;
        }
      });

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.quantity = 0;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(this.carts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var cart = _step2.value;

              if (item.Id === cart.GiftId) {
                item.quantity = cart.DesiredQuantity;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return items;
    },
    categories: function categories() {
      return this.$store.state.reward.categories;
    },
    currentCategory: function currentCategory() {
      return this.$store.state.reward.currentCategory;
    }
  },
  methods: {
    addCart: function addCart(item, qunatity) {
      item.quantity = qunatity || 1;
      this.$store.commit('reward/updateCart', item);
    },
    updateCart: function updateCart(item, e) {
      var quantity = parseInt(e.target.value);
      if (isNaN(quantity)) {
        return false;
      }
      item.quantity = quantity;
      item.isUpdated = true;
      this.$store.commit('reward/updateCart', item);
    },
    changeCategory: function changeCategory(id) {
      this.$store.commit('reward/saveKey', ['currentCategory', id]);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8ce02e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward/MRewardItem.vue
var MRewardItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-form-select',{staticClass:"sort-select",attrs:{"options":_vm.sortOption},model:{value:(_vm.sortKey),callback:function ($$v) {_vm.sortKey=$$v},expression:"sortKey"}}),_vm._v(" "),_c('b-nav',{attrs:{"tabs":""}},_vm._l((_vm.categories),function(category){return _c('b-nav-item',{key:category.Id,attrs:{"active":category.Id === _vm.currentCategory},on:{"click":function($event){return _vm.changeCategory(category.Id)}}},[_vm._v("\n      "+_vm._s(category.CategoryName)+"\n    ")])}),1),_vm._v(" "),_c('m-loader',{attrs:{"show":_vm.items.length === 0,"size":"box"}}),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{key:item.ID,staticClass:"item-row"},[_c('div',{staticClass:"item-img"},[_c('b-img',{staticStyle:{"margin-right":"16px"},attrs:{"src":_vm.$store.state.config.rootDomain + item.GiftImage,"height":"160","left":""}}),_vm._v(" "),_c('div',[_c('p',{staticClass:"item-title"},[_vm._v(_vm._s(item.GiftName))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(item.GiftName != item.GiftDesc),expression:"item.GiftName != item.GiftDesc"}]},[_vm._v(_vm._s(item.GiftDesc))]),_vm._v(" "),_c('p',{staticClass:"item-point"},[_c('span',{staticClass:"item-point-desc"},[_vm._v("Points: ")]),_vm._v(_vm._s(_vm._f("numberFormat")(item.GiftPoint,'', 0)))])])],1),_vm._v(" "),_c('div',{staticClass:"add-btn"},[_c('b-btn',{directives:[{name:"show",rawName:"v-show",value:(item.quantity === 0 ),expression:"item.quantity === 0 "}],on:{"click":function($event){return _vm.addCart(item)}}},[_vm._v("\n        Add to Cart\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.quantity > 0),expression:"item.quantity > 0"}]},[_c('b-btn',{staticClass:"item-btn",on:{"click":function($event){return _vm.addCart(item, -1)}}},[_vm._v(" - ")]),_vm._v(" "),_c('b-input',{staticClass:"item-input",attrs:{"type":"number","value":item.quantity},nativeOn:{"input":function($event){return _vm.updateCart(item, $event)}}}),_vm._v(" "),_c('b-btn',{staticClass:"item-btn",on:{"click":function($event){return _vm.addCart(item)}}},[_vm._v(" + ")])],1)],1)])})],2)}
var MRewardItem_staticRenderFns = []
var MRewardItem_esExports = { render: MRewardItem_render, staticRenderFns: MRewardItem_staticRenderFns }
/* harmony default export */ var reward_MRewardItem = (MRewardItem_esExports);
// CONCATENATED MODULE: ./src/components/reward/MRewardItem.vue
function MRewardItem_injectStyle (ssrContext) {
  __webpack_require__("zbch")
}
var MRewardItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MRewardItem___vue_template_functional__ = false
/* styles */
var MRewardItem___vue_styles__ = MRewardItem_injectStyle
/* scopeId */
var MRewardItem___vue_scopeId__ = "data-v-2d8ce02e"
/* moduleIdentifier (server only) */
var MRewardItem___vue_module_identifier__ = null
var MRewardItem_Component = MRewardItem_normalizeComponent(
  MRewardItem,
  reward_MRewardItem,
  MRewardItem___vue_template_functional__,
  MRewardItem___vue_styles__,
  MRewardItem___vue_scopeId__,
  MRewardItem___vue_module_identifier__
)

/* harmony default export */ var components_reward_MRewardItem = (MRewardItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/reward/MRewardSummary.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MRewardSummary = ({
  components: {},
  created: function created() {},
  data: function data() {
    return {};
  },

  computed: {
    histories: function histories() {
      return this.$store.state.reward.histories;
    },
    point: function point() {
      return this.$store.state.reward.point;
    }
  },
  watch: {},
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a06d58b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward/MRewardSummary.vue
var MRewardSummary_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"rewardSummaryModal","title":"Reward History","ok-only":true,"ok-title":"Close","size":"lg","lazy":true}},[_c('div',{staticClass:"point-box"},[_c('h2',[_vm._v("Total Points Activity")]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('td',{staticClass:"th-title"},[_vm._v("Name")]),_vm._v(" "),_c('td',{staticClass:"th-title"},[_vm._v("Point")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Points Balance as of "+_vm._s(_vm._f("formatDate")(new Date(),'MMM Do YY')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.point.AvailablePoints,'', 0)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Earned")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.point.EarnedPoints,'', 0)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Used")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.point.RedeemedPoints,'', 0)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Total Availabel Points")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.point.AvailablePoints,'', 0)))])])])]),_vm._v(" "),_c('h2',[_vm._v("Redemption History")]),_vm._v(" "),_c('div',{staticClass:"table-box"},[_c('table',{staticClass:"table"},[_c('thead',[_c('td',{staticClass:"th-title"},[_vm._v("Order Number")]),_vm._v(" "),_c('td',{staticClass:"th-title"},[_vm._v("Redemption Date")]),_vm._v(" "),_c('td',{staticClass:"th-title"},[_vm._v("Consumed Points")])]),_vm._v(" "),_vm._l((_vm.histories),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.RedeemDesc))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(item.RedeemDate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.RequiredPoint))])])})],2)])])}
var MRewardSummary_staticRenderFns = []
var MRewardSummary_esExports = { render: MRewardSummary_render, staticRenderFns: MRewardSummary_staticRenderFns }
/* harmony default export */ var reward_MRewardSummary = (MRewardSummary_esExports);
// CONCATENATED MODULE: ./src/components/reward/MRewardSummary.vue
function MRewardSummary_injectStyle (ssrContext) {
  __webpack_require__("4LeQ")
}
var MRewardSummary_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MRewardSummary___vue_template_functional__ = false
/* styles */
var MRewardSummary___vue_styles__ = MRewardSummary_injectStyle
/* scopeId */
var MRewardSummary___vue_scopeId__ = "data-v-5a06d58b"
/* moduleIdentifier (server only) */
var MRewardSummary___vue_module_identifier__ = null
var MRewardSummary_Component = MRewardSummary_normalizeComponent(
  MRewardSummary,
  reward_MRewardSummary,
  MRewardSummary___vue_template_functional__,
  MRewardSummary___vue_styles__,
  MRewardSummary___vue_scopeId__,
  MRewardSummary___vue_module_identifier__
)

/* harmony default export */ var components_reward_MRewardSummary = (MRewardSummary_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/reward/MRewardCheckOut.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MRewardCheckOut = ({
  components: {},
  created: function created() {},
  data: function data() {
    return {
      step: 'input',
      okTitle: 'Place Order',
      okOnly: false,
      okDisabled: false,
      orderCode: '',
      contact: {
        AddToMailingList: false,
        AddressLine: '',
        CallMe: false,
        City: '',
        Company: '',
        CountryCode: 'US',
        Email: '',
        FirstName: '',
        IsContactMeByEmail: false,
        IsSendEmailToAudience: false,
        IsSendEmailToList: false,
        IsSendMobileFacebookToAudience: false,
        LastName: '',
        OrderForClients: false,
        OrderName: '',
        Phone: '',
        State: '',
        Zipcode: ''
      }
    };
  },

  computed: {
    histories: function histories() {
      return this.$store.state.reward.histories;
    },
    point: function point() {
      return this.$store.state.reward.point;
    },
    carts: function carts() {
      return this.$store.state.reward.carts;
    },
    cartPoint: function cartPoint() {
      return this.$store.getters['reward/cartPoint'];
    },
    invalidFirstName: function invalidFirstName() {
      if (this.contact.FirstName.length === 0) {
        return "It's required";
      } else {
        return '';
      }
    },
    invalidLastName: function invalidLastName() {
      if (this.contact.LastName.length === 0) {
        return "It's required";
      } else {
        return '';
      }
    },
    invalidCompany: function invalidCompany() {
      if (this.contact.Company.length === 0) {
        return "It's required";
      } else {
        return '';
      }
    },
    invalidAddressLine: function invalidAddressLine() {
      if (this.contact.AddressLine.length === 0) {
        return "It's required";
      } else {
        return '';
      }
    },
    invalidCity: function invalidCity() {
      if (this.contact.City.length === 0) {
        return "It's required";
      } else {
        return '';
      }
    },
    invalidState: function invalidState() {
      if (this.contact.State.length !== 2) {
        return 'Need State Code';
      } else {
        return '';
      }
    },
    invalidZIP: function invalidZIP() {
      if (this.contact.Zipcode.length !== 5) {
        return 'Need ZIP Code';
      } else {
        return '';
      }
    },
    invalidPhone: function invalidPhone() {
      if (this.contact.Phone.length === 0) {
        return "It's required";
      } else {
        return '';
      }
    }
  },
  watch: {},
  methods: {
    show: function show() {
      var _this = this;

      this.step = 'input';
      this.okTitle = 'Place Order';
      this.okOnly = false;
      this.$http.post('ba/RewardCart.aspx/GetCart', {}).then(function (resp) {
        var data = resp.body.d.DataSource;
        var user = data.User;
        _this.contact.FirstName = user.FirstName;
        _this.contact.LastName = user.LastName;
        _this.contact.Company = user.Company;
        _this.contact.AddressLine = user.UsersAddress[0].AddressLine;
        _this.contact.City = user.UsersAddress[0].CityName;
        _this.contact.State = user.UsersAddress[0].StateCode;
        _this.contact.Zipcode = user.UsersAddress[0].ZipCode;
        _this.contact.Phone = user.HomePhone;
      });
    },
    placeOrder: function placeOrder(evt) {
      var _this2 = this;

      evt.preventDefault();
      if (this.step === 'success') {
        this.$root.$emit('bv::hide::modal', 'rewardCheckOutModal');
        return;
      }
      if (this.invalidFirstName !== '') {
        return;
      }
      if (this.invalidLastName !== '') {
        return;
      }
      if (this.invalidCompany !== '') {
        return;
      }
      if (this.invalidAddressLine !== '') {
        return;
      }
      if (this.invalidCity !== '') {
        return;
      }
      if (this.invalidState !== '') {
        return;
      }
      if (this.invalidZIP !== '') {
        return;
      }
      if (this.invalidPhone !== '') {
        return;
      }
      this.okDisabled = true;
      this.$http.post('ba/Reward.aspx/RedeemCartOrder', {
        contact: this.contact,
        cart: {
          Items: this.carts
        }
      }).then(function (resp) {
        _this2.step = 'success';
        _this2.okTitle = 'Close';
        _this2.okOnly = true;
        _this2.okDisabled = false;
        var data = resp.body.d.DataSource;
        _this2.orderCode = data.OrderCode;
        _this2.$store.commit('reward/saveKey', ['point', data.UserPoint]);
        _this2.$store.commit('reward/saveKey', ['carts', []]);
      }, function (resp) {
        _this2.okDisabled = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5949acce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward/MRewardCheckOut.vue
var MRewardCheckOut_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"rewardCheckOutModal","title":"Check Out","ok-title":_vm.okTitle,"ok-only":_vm.okOnly,"ok-disabled":_vm.okDisabled,"size":"lg"},on:{"show":_vm.show,"ok":_vm.placeOrder}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step==='input'),expression:"step==='input'"}]},[_c('b-form',[_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label-size":"sm","label":"First Name :","state":_vm.invalidFirstName === '',"invalid-feedback":_vm.invalidFirstName}},[_c('b-form-input',{attrs:{"size":"sm"},model:{value:(_vm.contact.FirstName),callback:function ($$v) {_vm.$set(_vm.contact, "FirstName", $$v)},expression:"contact.FirstName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label-size":"sm","label":"Last Name :","state":_vm.invalidLastName === '',"invalid-feedback":_vm.invalidLastName}},[_c('b-form-input',{attrs:{"size":"sm"},model:{value:(_vm.contact.LastName),callback:function ($$v) {_vm.$set(_vm.contact, "LastName", $$v)},expression:"contact.LastName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label-size":"sm","label":"Company :","state":_vm.invalidCompany === '',"invalid-feedback":_vm.invalidCompany}},[_c('b-form-input',{attrs:{"size":"sm"},model:{value:(_vm.contact.Company),callback:function ($$v) {_vm.$set(_vm.contact, "Company", $$v)},expression:"contact.Company"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label-size":"sm","label":"Address Name :","state":_vm.invalidAddressLine === '',"invalid-feedback":_vm.invalidAddressLine}},[_c('b-form-input',{attrs:{"size":"sm"},model:{value:(_vm.contact.AddressLine),callback:function ($$v) {_vm.$set(_vm.contact, "AddressLine", $$v)},expression:"contact.AddressLine"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label-size":"sm","label":"City :","state":_vm.invalidCity === '',"invalid-feedback":_vm.invalidCity}},[_c('b-form-input',{attrs:{"size":"sm"},model:{value:(_vm.contact.City),callback:function ($$v) {_vm.$set(_vm.contact, "City", $$v)},expression:"contact.City"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label-size":"sm","label":"State :","state":_vm.invalidState === '',"invalid-feedback":_vm.invalidState}},[_c('b-form-input',{attrs:{"size":"sm"},model:{value:(_vm.contact.State),callback:function ($$v) {_vm.$set(_vm.contact, "State", $$v)},expression:"contact.State"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label-size":"sm","label":"ZIP :","state":_vm.invalidZIP === '',"invalid-feedback":_vm.invalidZIP}},[_c('b-form-input',{attrs:{"size":"sm"},model:{value:(_vm.contact.Zipcode),callback:function ($$v) {_vm.$set(_vm.contact, "Zipcode", $$v)},expression:"contact.Zipcode"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label-size":"sm","label":"Telphone :","state":_vm.invalidPhone === '',"invalid-feedback":_vm.invalidPhone}},[_c('b-form-input',{attrs:{"size":"sm"},model:{value:(_vm.contact.Phone),callback:function ($$v) {_vm.$set(_vm.contact, "Phone", $$v)},expression:"contact.Phone"}})],1)],1),_vm._v(" "),_c('h2',[_vm._v("Rewards")]),_vm._v(" "),_c('div',{staticClass:"table-box"},[_c('table',{staticClass:"table"},[_c('thead',[_c('td',{staticClass:"th-title"},[_vm._v("Rewards")]),_vm._v(" "),_c('td',{staticClass:"th-title"},[_vm._v("Quantity")]),_vm._v(" "),_c('td',{staticClass:"th-title"},[_vm._v("Total Points")])]),_vm._v(" "),_vm._l((_vm.carts),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.GiftName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("numberFormat")(item.DesiredQuantity,'', 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("numberFormat")(item.DesiredQuantity * item.PointForOne,'', 0)))])])}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"th-title"},[_vm._v("Total Cost")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"th-title"},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.cartPoint,'', 0)))])])],2)])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step==='success'),expression:"step==='success'"}]},[_c('p',[_vm._v("Your rewards have been confirmed! We have received your redemption order and have started the fulfillment process. You can expect to receive your rewards within the next 7 business days.")]),_vm._v(" "),_c('p',[_vm._v("f you have any questions, please contact Us and reference Rewards Order "),_c('span',{staticClass:"order-code"},[_vm._v(_vm._s(_vm.orderCode))]),_vm._v(". Thank you for being part of our Loyalty Program.")])])])}
var MRewardCheckOut_staticRenderFns = []
var MRewardCheckOut_esExports = { render: MRewardCheckOut_render, staticRenderFns: MRewardCheckOut_staticRenderFns }
/* harmony default export */ var reward_MRewardCheckOut = (MRewardCheckOut_esExports);
// CONCATENATED MODULE: ./src/components/reward/MRewardCheckOut.vue
function MRewardCheckOut_injectStyle (ssrContext) {
  __webpack_require__("0asO")
}
var MRewardCheckOut_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MRewardCheckOut___vue_template_functional__ = false
/* styles */
var MRewardCheckOut___vue_styles__ = MRewardCheckOut_injectStyle
/* scopeId */
var MRewardCheckOut___vue_scopeId__ = "data-v-5949acce"
/* moduleIdentifier (server only) */
var MRewardCheckOut___vue_module_identifier__ = null
var MRewardCheckOut_Component = MRewardCheckOut_normalizeComponent(
  MRewardCheckOut,
  reward_MRewardCheckOut,
  MRewardCheckOut___vue_template_functional__,
  MRewardCheckOut___vue_styles__,
  MRewardCheckOut___vue_scopeId__,
  MRewardCheckOut___vue_module_identifier__
)

/* harmony default export */ var components_reward_MRewardCheckOut = (MRewardCheckOut_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Reward.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Reward = ({
  components: {
    MContent: components_layouts_MContent,
    MRewardSlide: components_reward_MRewardSlide,
    MRewardSummary: components_reward_MRewardSummary,
    MRewardItem: components_reward_MRewardItem,
    MRewardCheckOut: components_reward_MRewardCheckOut
  },
  data: function data() {
    return {};
  },
  created: function created() {
    this.init();
  },

  computed: {
    availablePoint: function availablePoint() {
      return this.$store.state.reward.point.AvailablePoints;
    }
  },
  methods: {
    init: function init() {
      this.$store.dispatch('reward/init');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c778fc2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reward.vue
var Reward_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-reward-summary'),_vm._v(" "),_c('m-reward-check-out'),_vm._v(" "),_c('m-content',{attrs:{"title":"Reward"}},[_c('div',{attrs:{"slot":"title-right"},slot:"title-right"},[_c('b-link',{on:{"click":function($event){return _vm.$root.$emit('bv::show::modal', 'rewardSummaryModal')}}},[_vm._v("\n        Available Point: "),_c('span',{staticClass:"available-point"},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.availablePoint,'', 0)))])])],1),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"the-slide"},[_c('m-reward-slide')],1),_vm._v(" "),_c('div',{staticClass:"the-content"},[_c('m-reward-item')],1)])])],1)}
var Reward_staticRenderFns = []
var Reward_esExports = { render: Reward_render, staticRenderFns: Reward_staticRenderFns }
/* harmony default export */ var pages_Reward = (Reward_esExports);
// CONCATENATED MODULE: ./src/pages/Reward.vue
function Reward_injectStyle (ssrContext) {
  __webpack_require__("m99Z")
}
var Reward_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Reward___vue_template_functional__ = false
/* styles */
var Reward___vue_styles__ = Reward_injectStyle
/* scopeId */
var Reward___vue_scopeId__ = "data-v-9c778fc2"
/* moduleIdentifier (server only) */
var Reward___vue_module_identifier__ = null
var Reward_Component = Reward_normalizeComponent(
  Reward,
  pages_Reward,
  Reward___vue_template_functional__,
  Reward___vue_styles__,
  Reward___vue_scopeId__,
  Reward___vue_module_identifier__
)

/* harmony default export */ var src_pages_Reward = (Reward_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/DigitalCampaigns.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DigitalCampaigns = ({
  data: function data() {
    return {
      step: 'input',
      okTitle: 'Submit',
      prospectsTypeOther: '',
      other: false,
      order: {
        text: '',
        prospectsType: [],
        budget: '$2,500 - $4,999',
        startDate: 'ASAP',
        name: '',
        email: '',
        phone: ''
      },
      budgetOptions: [{ value: 'Less than $2,500', text: 'Less than $2,500' }, { value: '$2,500 - $4,999', text: '$2,500 - $4,999' }, { value: '$5,000 - $9,999', text: '$5,000 - $9,999' }, { value: '$10,000 - $19,999', text: '$10,000 - $19,999' }, { value: '$20,000 or more', text: '$20,000 or more' }],
      startDateOptions: [{ value: 'ASAP', text: 'ASAP' }, { value: '2-4 Weeks', text: '2-4 Weeks' }, { value: '4-8 Weeks', text: '4-8 Weeks' }, { value: 'More than 8 Weeks', text: 'More than 8 Weeks' }],
      alertDesc: '',
      textValid: {
        state: null,
        text: 'please enter'
      },
      nameValid: {
        state: null,
        text: ''
      },
      emailValid: {
        state: null,
        text: ''
      },
      phoneValid: {
        state: null,
        text: ''
      }
    };
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.getters['user/userInfo'];
    }
  },
  watch: {
    userInfo: function userInfo() {
      this.order.name = this.userInfo.Name;
      this.order.email = this.userInfo.Email;
      this.order.phone = this.userInfo.HomePhone;
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.order.name = this.userInfo.Name;
      this.order.email = this.userInfo.Email;
      this.order.phone = this.userInfo.HomePhone;
      this.step = 'input';
      this.okTitle = 'Submit';
    },
    nameChange: function nameChange() {
      if (this.order.name.length > 0) {
        this.nameValid.state = true;
        this.nameValid.text = '';
      } else {
        this.nameValid.state = false;
        this.nameValid.text = 'Name is required';
      }
    },
    emailChange: function emailChange() {
      if (this.order.email.length > 0) {
        this.emailValid.state = true;
        this.emailValid.text = '';
      } else {
        this.emailValid.state = false;
        this.emailValid.text = 'Email is required or E-mail must be valid';
      }
    },
    phoneChange: function phoneChange() {
      if (this.order.phone.length > 0) {
        this.phoneValid.state = true;
        this.phoneValid.text = '';
      } else {
        this.phoneValid.state = false;
        this.phoneValid.text = 'Phone is required';
      }
    },
    textChange: function textChange() {
      if (this.order.text.length >= 10) {
        this.textValid.state = true;
        this.textValid.text = '';
      } else {
        this.textValid.state = false;
        this.textValid.text = 'Enter at least 10 characters';
      }
    },
    validData: function validData() {
      this.textChange();
      this.nameChange();
      this.emailChange();
      this.phoneChange();
      if (!this.textValid.state || !this.nameValid.state || !this.emailValid.state || !this.phoneValid.state) {
        return true;
      }
      return false;
    },
    submit: function submit(evt) {
      var _this = this;

      this.alertDesc = '';
      if (this.step === 'input') {
        evt.preventDefault();
      } else {
        return;
      }
      var isError = false;
      if (this.other[0] === 'Other' && this.prospectsTypeOther === '') {
        this.alertDesc = 'Please enter other text.';
        return;
      }
      if (this.validData()) {
        return;
      }
      if (this.order.prospectsType.length === 0) {
        this.alertDesc = 'Please select prospects';
        return;
      }
      var prospectString = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.order.prospectsType), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item === 'Other') {
            item = 'Other:' + this.prospectsTypeOther;
          }
          prospectString = prospectString + item + ',';
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      prospectString = prospectString.substring(0, prospectString.length - 1);
      if (!isError) {
        this.$http.post('PlaceOrder.aspx/AddMarketingEmail', {
          name: this.order.name,
          phone: this.order.phone,
          email: this.order.email,
          accomplish: this.order.text,
          prospects: prospectString,
          campaignBudget: this.order.budget,
          startDate: this.order.startDate
        }).then(function (resp) {
          _this.step = 'success';
          _this.okTitle = 'Close';
        }, function (resp) {});
      }
    },
    cancel: function cancel() {
      window.parent.$.fn.colorbox.close();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ade414","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DigitalCampaigns.vue
var DigitalCampaigns_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step==='input'),expression:"step==='input'"}]},[_c('h4',{staticStyle:{"margin-bottom":"16px"}},[_vm._v("Complete the form below and one of our digital experts will reach out to you.")]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"What are you trying to accomplish? (Campaign goals/objectives)","invalid-feedback":_vm.textValid.text,"state":_vm.textValid.state}},[_c('b-form-textarea',{attrs:{"placeholder":"","rows":3,"state":_vm.textValid.state},on:{"input":function($event){return _vm.textChange()}},model:{value:(_vm.order.text),callback:function ($$v) {_vm.$set(_vm.order, "text", $$v)},expression:"order.text"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"How do you wish to reach new prospects? Check all that apply."}},[_c('b-form-checkbox-group',{attrs:{"stacked":""},model:{value:(_vm.order.prospectsType),callback:function ($$v) {_vm.$set(_vm.order, "prospectsType", $$v)},expression:"order.prospectsType"}},[_c('b-form-checkbox',{attrs:{"value":"Email"}},[_vm._v("Email")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"Mobile & Desktop Display banners"}},[_vm._v("Mobile & Desktop Display banners")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"Social Media Ads"}},[_vm._v("Social Media Ads")]),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"display":"inherit"},attrs:{"value":"Other"},model:{value:(_vm.other),callback:function ($$v) {_vm.other=$$v},expression:"other"}},[_vm._v("\n        Other"),_c('b-form-input',{staticStyle:{"margin-left":"16px"},attrs:{"type":"text","size":"sm"},model:{value:(_vm.prospectsTypeOther),callback:function ($$v) {_vm.prospectsTypeOther=$$v},expression:"prospectsTypeOther"}})],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Campaign Budget: (dropdown with these options)"}},[_c('b-form-select',{attrs:{"options":_vm.budgetOptions},model:{value:(_vm.order.budget),callback:function ($$v) {_vm.$set(_vm.order, "budget", $$v)},expression:"order.budget"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Desired Start Date: (dropdown with these options)"}},[_c('b-form-select',{attrs:{"options":_vm.startDateOptions},model:{value:(_vm.order.startDate),callback:function ($$v) {_vm.$set(_vm.order, "startDate", $$v)},expression:"order.startDate"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Name","invalid-feedback":_vm.nameValid.text,"state":_vm.nameValid.state}},[_c('b-form-input',{attrs:{"state":_vm.nameValid.state},on:{"input":_vm.nameChange},model:{value:(_vm.order.name),callback:function ($$v) {_vm.$set(_vm.order, "name", $$v)},expression:"order.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","invalid-feedback":_vm.emailValid.text,"state":_vm.emailValid.state}},[_c('b-form-input',{attrs:{"state":_vm.emailValid.state},on:{"input":_vm.emailChange},model:{value:(_vm.order.email),callback:function ($$v) {_vm.$set(_vm.order, "email", $$v)},expression:"order.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Phone","invalid-feedback":_vm.phoneValid.text,"state":_vm.phoneValid.state}},[_c('b-form-input',{attrs:{"state":_vm.phoneValid.state},on:{"input":_vm.phoneChange},model:{value:(_vm.order.phone),callback:function ($$v) {_vm.$set(_vm.order, "phone", $$v)},expression:"order.phone"}})],1),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.alertDesc!=='',"variant":"warning"}},[_vm._v(_vm._s(_vm.alertDesc))]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[_c('b-btn',{on:{"click":_vm.cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.submit}},[_vm._v("Submit")])],1),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step !='input'),expression:"step !='input'"}]},[_c('H1',[_vm._v("Thank you!")]),_vm._v(" "),_c('p',[_vm._v("A member of our Digital Team will contact you within the next business day to discuss your campaign in more detail.\n    ")])],1)])}
var DigitalCampaigns_staticRenderFns = []
var DigitalCampaigns_esExports = { render: DigitalCampaigns_render, staticRenderFns: DigitalCampaigns_staticRenderFns }
/* harmony default export */ var pages_DigitalCampaigns = (DigitalCampaigns_esExports);
// CONCATENATED MODULE: ./src/pages/DigitalCampaigns.vue
function DigitalCampaigns_injectStyle (ssrContext) {
  __webpack_require__("Y/KP")
}
var DigitalCampaigns_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DigitalCampaigns___vue_template_functional__ = false
/* styles */
var DigitalCampaigns___vue_styles__ = DigitalCampaigns_injectStyle
/* scopeId */
var DigitalCampaigns___vue_scopeId__ = "data-v-55ade414"
/* moduleIdentifier (server only) */
var DigitalCampaigns___vue_module_identifier__ = null
var DigitalCampaigns_Component = DigitalCampaigns_normalizeComponent(
  DigitalCampaigns,
  pages_DigitalCampaigns,
  DigitalCampaigns___vue_template_functional__,
  DigitalCampaigns___vue_styles__,
  DigitalCampaigns___vue_scopeId__,
  DigitalCampaigns___vue_module_identifier__
)

/* harmony default export */ var src_pages_DigitalCampaigns = (DigitalCampaigns_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/FreeDataDiagnostic.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var FreeDataDiagnostic = ({
  data: function data() {
    return {
      info: {
        fname: '',
        lname: '',
        company: '',
        email: '',
        qty: '',
        message: ''
      },
      btnDisable: false,
      infoValid: {
        fname: {
          state: null,
          text: ''
        },
        lname: {
          state: null,
          text: ''
        },
        email: {
          state: null,
          text: ''
        },
        message: {
          state: null,
          text: ''
        }
      },
      isShowSuccess: false
    };
  },

  computed: {
    firstname: {
      get: function get() {
        return this.$store.getters['user/userInfo'].FirstName;
      },
      set: function set(val) {
        this.info.fname = val;
      }
    },
    lastname: {
      get: function get() {
        return this.$store.getters['user/userInfo'].LastName;
      },
      set: function set(val) {
        this.info.lname = val;
      }
    },
    tempemail: {
      get: function get() {
        return this.$store.getters['user/userInfo'].Email;
      },
      set: function set(val) {
        this.info.email = val;
      }
    }
  },
  mounted: function mounted() {
    this.load();
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.clearValid(this.infoValid);
      var that = this;
      if (this.validInfo()) {
        this.btnDisable = true;
        this.$http.post(this.$store.getters['config/link']('sendMessage'), {
          Action: 'save-contact-info',
          FormData: stringify_default()({
            FirstName: this.info.fname,
            LastName: this.info.lname,
            Company: this.info.company,
            Email: this.info.email,
            Phone: '',
            Comment: this.info.message,
            Page: this.info.qty,
            PageInfo: window.location.hostname === 'dev.sl360.com' ? '[Staging] Data Diagnostic Inquiry' : 'Data Diagnostic Inquiry',
            FromSite: 'sl360.com',
            Source: 'Data-Diagnostic'
          })
        }, {
          emulateJSON: true
        }).then(function (resp) {
          that.btnDisable = false;
          if (resp.body.Status === 1) {
            that.isShowSuccess = true;
            // notification.notice('error', 'Failed to sent contact information , please try again')
          }
        }, function (resp) {
          notification.notice('error', 'Failed to sent contact information , please try again');
          _this.btnDisable = false;
        });
      }
    },
    showDemo: function showDemo() {
      window.open('/DHA_v7.pdf');
    },
    validInfo: function validInfo() {
      var isValid = true;
      if (!this.info.fname) {
        this.infoValid.fname.state = false;
        this.infoValid.fname.text = "It's required";
        isValid = false;
      }
      if (!this.info.lname) {
        this.infoValid.lname.state = false;
        this.infoValid.lname.text = "It's required";
        isValid = false;
      }
      if (!(this.info.email.indexOf('@') > 0 && this.info.email.indexOf('@') < this.info.email.length - 1)) {
        this.infoValid.email.state = false;
        this.infoValid.email.text = 'E-mail must be valid';
        isValid = false;
      }
      if (!this.info.email) {
        this.infoValid.email.state = false;
        this.infoValid.email.text = "It's required";
        isValid = false;
      }
      if (!this.info.message) {
        this.infoValid.message.state = false;
        this.infoValid.message.text = "It's required";
        isValid = false;
      }
      return isValid;
    },
    clearValid: function clearValid(items) {
      for (var key in items) {
        items[key].state = null;
        items[key].text = false;
      }
    },
    load: function load() {
      this.info.fname = this.$store.getters['user/userInfo'].FirstName;
      this.info.lname = this.$store.getters['user/userInfo'].LastName;
      this.info.email = this.$store.getters['user/userInfo'].Email;
      this.isShowSuccess = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45311499","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FreeDataDiagnostic.vue
var FreeDataDiagnostic_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShowSuccess),expression:"!isShowSuccess"}]},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-7",staticStyle:{"padding-left":"0","padding-right":"0"}},[_c('h1',[_vm._v("How it Works")]),_vm._v(" "),_c('h4',[_vm._v("1. Send us a file of 10,000 – 25,000 records containing a first name, last name, address, city, state, zip code, phone number (optional), and email address (optional).")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h4',[_vm._v("3. Our Data team will schedule a call to review the report findings with you.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("Have questions or interested in getting started? Complete the form below.")]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"First Name *","state":this.infoValid.fname.state},model:{value:(_vm.firstname),callback:function ($$v) {_vm.firstname=$$v},expression:"firstname"}}),_vm._v(" "),(_vm.infoValid.fname.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.fname.text))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"Last Name *","state":this.infoValid.lname.state},model:{value:(_vm.lastname),callback:function ($$v) {_vm.lastname=$$v},expression:"lastname"}}),_vm._v(" "),(_vm.infoValid.lname.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.lname.text))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"Company Name"},model:{value:(_vm.info.company),callback:function ($$v) {_vm.$set(_vm.info, "company", $$v)},expression:"info.company"}})],1),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"Email Address *","state":this.infoValid.email.state,"type":"email"},model:{value:(_vm.tempemail),callback:function ($$v) {_vm.tempemail=$$v},expression:"tempemail"}}),_vm._v(" "),(_vm.infoValid.email.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.email.text))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"Qty of Records in Database"},model:{value:(_vm.info.qty),callback:function ($$v) {_vm.$set(_vm.info, "qty", $$v)},expression:"info.qty"}})],1),_vm._v(" "),_c('b-form-group',[_c('b-form-textarea',{attrs:{"rows":3,"placeholder":"Questions/Comments *","state":this.infoValid.message.state},model:{value:(_vm.info.message),callback:function ($$v) {_vm.$set(_vm.info, "message", $$v)},expression:"info.message"}}),_vm._v(" "),(_vm.infoValid.message.text)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.infoValid.message.text))]):_vm._e()],1),_vm._v(" "),_vm._m(2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5",staticStyle:{"padding-left":"0","padding-right":"0"}}),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-sm-7"},[_c('b-col',{staticClass:"colcenter"},[_c('b-btn',{attrs:{"disabled":_vm.btnDisable},on:{"click":_vm.submit}},[_vm._v("CONTACT US")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('b-col',{staticClass:"colcenter"},[_c('b-btn',{attrs:{"disabled":_vm.btnDisable},on:{"click":_vm.showDemo}},[_vm._v("VIEW SAMPLE REPORT")])],1)],1)])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowSuccess),expression:"isShowSuccess"}],staticClass:"colcenter"},[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Thanks for contacting us!")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h3',[_vm._v("We will get back to you very soon.")])])],1)],1)])}
var FreeDataDiagnostic_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_vm._v("The Data Diagnostic is an easy way to see the accuracy of your postal, phone, and email data, and the business case for refreshing your data.\n      "),_c('br'),_c('i',[_vm._v("Requires a minimum of 10,000 records.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_vm._v("2. We analyze the postal, email, and phone data and provide you with your Data Diagnostic report within 2-3 business days. "),_c('a',{attrs:{"href":"/DHA_v7.pdf","target":"_blank"}},[_vm._v("View Sample Report")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",staticStyle:{"text-align":"left","font-size":"12px"}},[_c('label',[_c('i',[_vm._v("* Required")])])])}]
var FreeDataDiagnostic_esExports = { render: FreeDataDiagnostic_render, staticRenderFns: FreeDataDiagnostic_staticRenderFns }
/* harmony default export */ var pages_FreeDataDiagnostic = (FreeDataDiagnostic_esExports);
// CONCATENATED MODULE: ./src/pages/FreeDataDiagnostic.vue
function FreeDataDiagnostic_injectStyle (ssrContext) {
  __webpack_require__("1kVi")
}
var FreeDataDiagnostic_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FreeDataDiagnostic___vue_template_functional__ = false
/* styles */
var FreeDataDiagnostic___vue_styles__ = FreeDataDiagnostic_injectStyle
/* scopeId */
var FreeDataDiagnostic___vue_scopeId__ = "data-v-45311499"
/* moduleIdentifier (server only) */
var FreeDataDiagnostic___vue_module_identifier__ = null
var FreeDataDiagnostic_Component = FreeDataDiagnostic_normalizeComponent(
  FreeDataDiagnostic,
  pages_FreeDataDiagnostic,
  FreeDataDiagnostic___vue_template_functional__,
  FreeDataDiagnostic___vue_styles__,
  FreeDataDiagnostic___vue_scopeId__,
  FreeDataDiagnostic___vue_module_identifier__
)

/* harmony default export */ var src_pages_FreeDataDiagnostic = (FreeDataDiagnostic_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/config/order.js
/**
 * Created by pony.ma@nirvana-info on .
 */
/* harmony default export */ var config_order = (function () {
  return {
    AccountId: null,
    AdditionalOutputColumns: '',
    ContactNameFlag: 0,
    ContactNameOption: 0,
    CreativeId: 0,
    CurrentStep: 'input', // 'input', 'count', 'success'
    DemoType: 1, // 99:All hoseholds, 1: others
    GeoType: 5,
    IsSaveCreative: false,
    ListType: 10,
    ListUsage: 1,
    NextStep: 6,
    OrderAddresses: [],
    OrderDate: new Date(),
    OrderGeos: [],
    OrderType: 10,
    ElementsForPricing: [],
    GeoSameState: true,
    // Don't need this
    // OrderDemos: [
    // {
    //   AttributeValue: '0',
    //   ColumnName: 'alvionacxiom30_DOBFlag',
    //   ListType: 10,
    //   OrderDemoId: 9712866,
    //   OrderId: 303144
    // }
    // ],
    // only need this
    OrderSelectedDemos: [
      // {
      //   AttributeName: 'Date of birth',
      //   ColumnName: 'alvionacxiom30_DateOfBirthU',
      //   DemoCategoryType: 3,
      //   Description: 'Date of Birth',
      //   Values: [
      //     {
      //       AttributeName: 'Date of Birth',
      //       AttributeValue: '19510~195310',
      //       AttributeValueName: '10950 to 101953',
      //       ColumnName: 'alvionacxiom30_DateOfBirthU'
      //     }
      //   ]
      // }
    ],
    PhoneOption: 0,
    Radius: 0,
    RadiusTypeChoice: 1,
    ReferFriend: '',
    RouteOption: 7,
    SeeBreakDown: true,
    SuppressionByDomain: false,
    SuppressionType: 0,
    OrderSuppressions: [],
    SaveCountSuppressions: [],
    CustomSuppressions: [],
    SuppressionEndDate: null,
    SuppressionStartDate: null,
    SaveCountSuppressionEndDate: null,
    SaveCountSuppressionStartDate: null,
    CustomSuppressionEndDate: null,
    CustomSuppressionStartDate: null,
    TargetOption: 7,
    TaxCharge: 0,
    TotalPretaxCost: 0,
    UmCode: 2,
    ZipType: 0,
    ZipcodeOriginalType: 1,
    record: '',
    CostPrice: 0,
    MediaTypeName: '',
    ShareAccountId: '',
    PackageName: '',
    TenantId: '',
    DestinationId: '',
    DestinationAccountId: '',
    EmailOption: ''
  };
});
// CONCATENATED MODULE: ./src/store/order/state.js
/**
 * Created by seaasun on 2017/12/8.
 */

/* harmony default export */ var order_state = (config_order());
// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__("kbi+");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__("swUc");
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);

// EXTERNAL MODULE: ./node_modules/lodash/map.js
var lodash_map = __webpack_require__("2247");
var map_default = /*#__PURE__*/__webpack_require__.n(lodash_map);

// EXTERNAL MODULE: ./node_modules/lodash/filter.js
var filter = __webpack_require__("RyI1");
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);

// CONCATENATED MODULE: ./src/store/order/getters.js





 /**
                                      * Created by seaasun on 2018/1/9.
                                      */

/* harmony default export */ var order_getters = ({
  geoItems: function geoItems(state) {
    // for (let geo of state.OrderGeos) {
    //   if (state.GeoType === 10) {
    //     geo.text =
    //   }
    // }
    // let result = []
    // // justifiy use orderGoes, or orderAddress
    // let types = {
    //   geo: [5, 3, 2, 4, 10, 22, 23, 12],
    //   address: [13, 14, 16]
    // }
    // if (types.geo.indexOf(state.GeoType) !== -1) {
    //   result = state.OrderGeos
    // } else {
    //   for (let geo of state.OrderAddresses) {
    //     geo.GeoKeyDesc = geo.AddressLine
    //     geo.GeoKeyCode = geo.AddrSearchString
    //     result.push(geo)
    //   }
    //   // result = state.OrderAddresses
    // }
    return state.OrderGeos;
  },
  demoItems: function demoItems(state, getters) {
    return state.OrderSelectedDemos || [];
  },
  hasGeoItem: function hasGeoItem(state) {
    return function (code) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(keys_default()(state.OrderGeos)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (code === state.OrderGeos[key].GeoKeyCode) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    };
  },
  geos: function geos(state, getters, rootState) {
    var geos = [];
    var orderGeos = state.OrderGeos;

    // preprocessing radius, polygon
    if (state.GeoType === 16 || state.GeoType === 12 || state.GeoType === 13 || state.GeoType === 7) {
      var orderAddress = filter_default()(state.OrderAddresses, function (item) {
        return item.AddrUsageType === 2;
      });
      orderGeos = map_default()(orderAddress, function (item) {
        var result = {
          GeoKeyCode: item.AddrSearchString,
          GeoKeyDesc: item.AddressLine || item.AddressName,
          GeoType: state.GeoType
        };

        if (state.GeoType === 16) {
          result.GeoKeyDesc += '(Radius: ' + item.Radius + ')';
        } else if (state.GeoType === 12) {
          result.GeoKeyDesc += '(Qty: ' + item.Quantity + ')';
        }
        return result;
      });
    }

    // group by geoType
    geos = groupBy_default()(orderGeos, function (item) {
      return item.GeoType;
    });

    var result = [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = get_iterator_default()(keys_default()(geos)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var key = _step2.value;

        geos[key] = map_default()(geos[key], function (item) {
          item.OrderGeoDetails = item.OrderGeoDetails || [];
          if (item.GeoType === rootState.config.geoType.city.code || item.GeoType === rootState.config.geoType.congressionalDistrict.code || rootState.order.ListType === 140 || item.OrderGeoDetails === null || item.OrderGeoDetails.length === 0 || item.OrderGeoDetails[0].DetailDesc === null) {
            item.title = item.GeoKeyDesc;
          } else {
            item.title = item.OrderGeoDetails[0].DetailDesc;
          }
          return item;
        });
        result.push({
          title: getters.getGeoType(parseInt(geos[key][0].GeoType)).title,
          values: geos[key]
        });
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return result;
  },
  demos: function demos(state, getters, rootState) {
    var demos = [];
    if (state.ListType === 50) {
      demos = rootState.demo.option;
      if (demos.length > 0) {
        demos[0].values = map_default()(demos[0].values, function (item) {
          item.title = item.text;
          item.key = demos[0].key;
          item.is50 = true;
          return item;
        });
        demos[1].values = map_default()(demos[1].values, function (item) {
          item.title = item.text;
          item.key = demos[1].key;
          item.is50 = true;
          return item;
        });
      }
    } else if (state.DemoType !== 99) {
      demos = state.OrderSelectedDemos || [];
      demos = map_default()(demos, function (item) {
        item.title = item.AttributeName;
        var demoCategoryType = item.DemoCategoryType;
        item.values = map_default()(item.Values, function (item) {
          item.title = item.AttributeValueName;
          item.DemoCategoryType = demoCategoryType;
          return item;
        });
        return item;
      });
    } else {
      demos.push({
        title: rootState.demo.allHouseholdSetting.SettingDesc
      });
    }

    if (state.SuppressionType > 0) {
      var suppression = {
        title: 'Suppression',
        values: []
      };
      if (getters.suppressionType.order) {
        var items = [];
        if (getters.suppressionType.order === 'date') {
          items.push(state.SuppressionStartDate + '~' + state.SuppressionEndDate);
        } else {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = get_iterator_default()(state.OrderSuppressions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var item = _step3.value;

              items.push(item.SuppressedOrderCode);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
        if (items.length > 0) {
          suppression.values.push({
            title: 'Suppress Prior Order(s)',
            items: items,
            noDelete: true
          });
        }
      }
      if (getters.suppressionType.slc) {
        var _items = [];
        if (getters.suppressionType.slc === 'date') {
          _items.push(state.SaveCountSuppressionStartDate + '~' + state.SaveCountSuppressionEndDate);
        } else {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = get_iterator_default()(state.SaveCountSuppressions), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _item = _step4.value;

              _items.push(_item.SuppressedCountCode);
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
        if (_items.length > 0) {
          suppression.values.push({
            title: 'Suppress Saved List Count(s)',
            items: _items,
            noDelete: true
          });
        }
      }
      if (getters.suppressionType.file) {
        var _items2 = [];
        if (getters.suppressionType.file === 'date') {
          _items2.push(state.CustomSuppressionStartDate + '~' + state.CustomSuppressionEndDate);
        } else {
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = get_iterator_default()(state.CustomSuppressions), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var _item2 = _step5.value;

              _items2.push(_item2.SuppressionValue);
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
        if (_items2.length > 0) {
          suppression.values.push({
            title: 'Suppress Uploaded File',
            items: _items2,
            noDelete: true
          });
        }
      }
      if (suppression.values.length > 0) {
        demos.push(suppression);
      }
    }

    if (getters['currentGeoType'].isDirectCount) {
      demos = [{
        title: 'Multi Saved List Count'
      }];
    }
    return demos;
  },
  hasPhoneOption: function hasPhoneOption(state) {
    if (state.ListType === 50) {
      return true;
    }
    return state.PhoneOption !== 0;
  },
  hasEmailOption: function hasEmailOption(state) {
    if (state.ListType !== 260) {
      return true;
    }
    return state.EmailOption !== '';
  },
  demoColumnIndex: function demoColumnIndex(state, getters) {
    return function (columnName, demoCategoryType) {
      // @cloumnName str
      // retrun index of columnName in OrderSelectDemos
      //        -1 if there is no columnName in OrderSelectDemos
      for (var i = 0; i < getters.demoItems.length; i++) {
        getters.demoItems[i].ColumnName += '';
        if (columnName === getters.demoItems[i].ColumnName && demoCategoryType === getters.demoItems[i].DemoCategoryType) {
          return i;
        }
      }
      return -1;
    };
  },
  demoColumnItem: function demoColumnItem(state, getters) {
    return function (columnName, demoCategoryType) {
      // @cloumnName str
      // retrun {}
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = get_iterator_default()(getters.demoItems), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var item = _step6.value;

          item.ColumnName += '';

          if (columnName === item.ColumnName && demoCategoryType === item.DemoCategoryType) {
            return item;
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return null;
    };
  },
  hasGeo: function hasGeo(state, getters) {
    if (getters.geos) {
      return getters.geos.length > 0;
    } else {
      return false;
    }
  },
  hasDemo: function hasDemo(state, getters) {
    if (state.DemoType === 99 || state.ListType === 50) {
      return true;
    } else if (getters.demoItems.length > 0) {
      return true;
    } else {
      return false;
    }
  },
  hasDemoAndPhoneOption: function hasDemoAndPhoneOption(state, getters) {
    if (state.ListType !== 50 && getters.hasDemo && getters.hasPhoneOption) {
      return true;
    } else if (state.ListType === 50 && getters['demo/isTargetoption'] && getters['demo/isRouteoption']) {
      return true;
    } else {
      return false;
    }
  },
  hasDemoWithotAll: function hasDemoWithotAll(state, getters) {
    if (state.DemoType === 99) {
      return false;
    } else {
      return getters.demoItems.length > 0;
    }
  },
  isAllHoseholds: function isAllHoseholds(state) {
    return state.DemoType === 99;
  },
  contact: function contact(state) {
    return state.OrderContactInformation;
  },
  IsEmailCampaign: function IsEmailCampaign(state) {
    return state.ListType === 200 || state.ListType === 210;
  },
  orderaddress: function orderaddress(state) {
    return state.OrderAddresses;
  },
  orderGeos: function orderGeos(state) {
    return state.OrderGeos;
  },
  contactNameOption: function contactNameOption(state) {
    return state.ContactNameOption;
  },
  targetOption: function targetOption(state) {
    return state.TargetOption;
  },
  routeOption: function routeOption(state) {
    return state.RouteOption;
  },
  demoBusinessTypeAddItem: function demoBusinessTypeAddItem(state) {
    var result = [];

    var demos = state.OrderSelectedDemos;
    if (!demos) {
      return false;
    }
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = get_iterator_default()(demos), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var demo = _step7.value;

        if (demo.AttributeName === 'Retail Trade') {
          result = demo.Values;
          break;
        }
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    return result;
  },
  demoBusinessTypeAdd: function demoBusinessTypeAdd(state, getters) {
    var result = [];
    var adds = getters.demoBusinessTypeAddItem;
    if (adds.length > 0) {
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(adds), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;

          result.push(item.AttributeValue);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    }
    return result;
  },
  isDemoBusinessTypeAdd: function isDemoBusinessTypeAdd(state, getters) {
    return function (code) {
      return getters.demoBusinessTypeAdd.indexOf(code) !== -1;
    };
  },
  demoBusinessTypeOmitItem: function demoBusinessTypeOmitItem(state) {
    var result = [];
    var demos = state.OrderSelectedDemos;
    if (!demos) {
      return false;
    }
    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = get_iterator_default()(demos), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var demo = _step9.value;

        if (demo.AttributeName === 'Retail Trade (Omit)') {
          result = demo.Values;
          break;
        }
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    return result;
  },
  demoBusinessTypeOmit: function demoBusinessTypeOmit(state, getters) {
    var result = [];
    var adds = getters.demoBusinessTypeOmitItem;
    if (adds.length > 0) {
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = get_iterator_default()(adds), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var item = _step10.value;

          result.push(item.AttributeValue);
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    }
    return result;
  },
  isDemoBusinessTypeOmit: function isDemoBusinessTypeOmit(state, getters) {
    return function (code) {
      return getters.demoBusinessTypeOmit.indexOf(code) !== -1;
    };
  },
  totalDesiredQty: function totalDesiredQty(state) {
    return state.TotalDesiredQty;
  },
  suppressionType: function suppressionType(state, getters, rootState) {
    var type = state.SuppressionType || 0;
    var dict = rootState.config.suppressionTypeMap;
    if (dict.hasOwnProperty(type)) {
      return dict[type];
    } else {
      return dict[0];
    }
  },
  getGeoType: function getGeoType(state, getters, rootState) {
    return function (geoType) {
      var geoTypes = rootState.config.geoType;
      var result = find_default()(geoTypes, function (item) {
        return item.code === geoType;
      });
      if (result === undefined) {
        result = geoTypes.unKnow;
      }
      return result;
    };
  },
  currentGeoType: function currentGeoType(state, getters, rootState) {
    var geoTypes = rootState.config.geoType;
    var result = find_default()(geoTypes, function (item) {
      return item.code === state.GeoType;
    });
    if (result === undefined) {
      result = geoTypes.unKnow;
    }
    return result;
  },
  currentPhoneOption: function currentPhoneOption(state, getters, rootState) {
    if (rootState.demo.phoneOptions && rootState.demo.phoneOptions.hasOwnProperty(state.PhoneOption)) {
      return rootState.demo.phoneOptions[state.PhoneOption];
    } else {
      return { val: 0, desc: 'No Phone Option' };
    }
  },
  isCreditCard: function isCreditCard(state) {
    // 1: Using Credit Card
    // 2: Using invoice
    return state.PaymentMethod === 1;
  }
});
// CONCATENATED MODULE: ./src/store/order/mutations.js



/**
 * Created by seaasun on 2017/12/8.
 */




/*
## GEO
### addAddress
### addGeo
### deleteGeo: delete geo and address
### cleanGeo: clean geo and address

## Common
### updateDesiredQty
### saveListType
### saveOrder

## Phone Option
### savePhoneOption

## Demo
### saveDemoType
### setAllHouseholds
### setUnAllHouseholds
### addNewDemo
### addNewDemoValue
### deleteDemo
### deleteDemoValue
### deleteDemoColumnName
### clearDemos

 */
/* harmony default export */ var mutations = ({
  /* ## GEO */
  addAddress: function addAddress(state, item) {
    // add address for order.OrderAddress
    var address = {
      AddrSearchString: '',
      AddrUsageType: 2,
      AddressLine: '',
      AddressName: '',
      CityName: '',
      CountryCode: '',
      Latitude: '',
      Longitude: '',
      Quantity: 0,
      Radius: 0,
      StateCode: '',
      SameState: true
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = get_iterator_default()(keys_default()(item)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        if (address.hasOwnProperty(key)) {
          address[key] = item[key];
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var isExist = false;
    // deduplication checkout
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = get_iterator_default()(keys_default()(state.OrderAddresses)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _key = _step2.value;

        if (state.OrderAddresses[_key].AddrUsageType === 2 && state.OrderAddresses[_key].AddrSearchString.split(':')[0] === address.AddrSearchString.split(':')[0] && state.OrderAddresses[_key].AddrSearchString.split(':')[1] === address.AddrSearchString.split(':')[1]) {
          // state.OrderAddresses[key] = address
          vue_esm["default"].set(state.OrderAddresses, _key, address);
          isExist = true;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    if (!isExist) {
      state.OrderAddresses.push(address);
    }
  },
  updateAddress: function updateAddress(state, item) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = get_iterator_default()(keys_default()(state.OrderAddresses)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var key = _step3.value;

        if (state.OrderAddresses[key].AddrSearchString === item.oldAddrSearchString) {
          vue_esm["default"].set(state.OrderAddresses[key], 'AddrSearchString', item.AddrSearchString);
          vue_esm["default"].set(state.OrderAddresses[key], 'Radius', item.Radius);
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  },
  updateGeo: function updateGeo(state, item) {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = get_iterator_default()(keys_default()(state.OrderGeos)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var key = _step4.value;

        if (state.OrderGeos[key].GeoKeyCode === item.oldGeoKeyCode) {
          vue_esm["default"].set(state.OrderGeos[key], 'GeoKeyCode', item.GeoKeyCode);
          vue_esm["default"].set(state.OrderGeos[key], 'AddressLine', item.GeoKeyCode);
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  },
  addGeo: function addGeo(state, item) {
    // add geo for order.OrderGeos
    // item: {}  geo
    var geo = {
      AddressLine: '',
      AvailableQty: 0,
      CityName: '',
      CountryCode: 'US',
      CountyFips: '',
      CountyCode: '',
      CostPrice: null,
      GeoKeyCode: null,
      GeoKeyDesc: null,
      CountyName: null,
      GeoType: 0,
      StateCode: '',
      OrderGeoDetails: null
    };

    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = get_iterator_default()(keys_default()(item)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var key = _step5.value;

        if (geo.hasOwnProperty(key)) {
          geo[key] = item[key];
        }
      }
      // deduplication checkout
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    var isExist = false;
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = get_iterator_default()(keys_default()(state.OrderGeos)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var _key2 = _step6.value;

        if (typeof state.OrderGeos[_key2].GeoKeyCode === 'string') {
          state.OrderGeos[_key2].GeoKeyCode = state.OrderGeos[_key2].GeoKeyCode || '';
          geo.GeoKeyCode = geo.GeoKeyCode || '';
          geo.GeoKeyCode += '';
          if (state.OrderGeos[_key2].GeoKeyCode.split(':').length > 0 && geo.GeoKeyCode.split(':').length > 0 && state.OrderGeos[_key2].GeoKeyCode.split(':')[0] === geo.GeoKeyCode.split(':')[0] && state.OrderGeos[_key2].GeoKeyCode.split(':')[1] === geo.GeoKeyCode.split(':')[1]) {
            vue_esm["default"].set(state.OrderGeos, _key2, geo);
            isExist = true;
          }
        }
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    if (!isExist) {
      state.OrderGeos.push(geo);
    }
  },
  deleteGeo: function deleteGeo(state, code) {
    /* delete geo and address */
    if (code.GeoKeyCode) {
      code = code.GeoKeyCode;
    }
    for (var i = 0; i < state.OrderAddresses.length; i++) {
      if (state.OrderAddresses[i].AddrSearchString === code) {
        vue_esm["default"].delete(state.OrderAddresses, i);
      }
    }
    for (var _i = 0; _i < state.OrderGeos.length; _i++) {
      if (state.OrderGeos[_i].GeoKeyCode === code) {
        vue_esm["default"].delete(state.OrderGeos, _i);
      }
    }
  },
  cleanGeo: function cleanGeo(state, val) {
    if (val) {
      var geos = filter_default()(state.OrderGeos, function (o) {
        return o.GeoType !== val;
      });
      geos = geos || [];
      vue_esm["default"].set(state, 'OrderGeos', geos);
      state.OrderAddresses = [];
    } else {
      state.RadiusTypeChoice = 1;
      state.OrderAddresses = [];
      state.OrderGeos = [];
    }
  },
  UpdateAddressSameState: function UpdateAddressSameState(state, val) {
    for (var i = 0; i < state.OrderAddresses.length; i++) {
      state.OrderAddresses[i].SameState = val;
    }
  },

  // ## PhoneOption
  savePhoneOption: function savePhoneOption(state, val) {
    state.PhoneOption = val;
  },
  saveEmailOption: function saveEmailOption(state, val) {
    state.EmailOption = val;
  },

  /* ## Demo */
  saveDemoType: function saveDemoType(state, val) {
    // @val int,   99:All  1:others
    state.DemoType = val;
  },
  setAllHouseholds: function setAllHouseholds(state) {
    state.DemoType = 99;
  },
  setUnAllHouseholds: function setUnAllHouseholds(state) {
    state.DemoType = 1;
  },
  addNewDemo: function addNewDemo(state, payload) {
    // @payload {}
    state.OrderSelectedDemos.push(payload);
  },
  addNewDemoValue: function addNewDemoValue(state, payload) {
    // @payload { index: int, val: {}
    state.OrderSelectedDemos[payload.index].Values.push(payload.val);
  },
  deleteDemo: function deleteDemo(state, payload) {
    vue_esm["default"].delete(state.OrderSelectedDemos, payload);
  },
  deleteDemoValue: function deleteDemoValue(state, payload) {
    // @payload { index: int, valIndex: int
    vue_esm["default"].delete(state.OrderSelectedDemos[payload.index].Values, payload.valueIndex);
  },
  deleteDemoColumnName: function deleteDemoColumnName(state, columnName) {
    for (var item in state.OrderSelectedDemos) {
      if (state.OrderSelectedDemos[item].ColumnName === columnName) {
        vue_esm["default"].delete(state.OrderSelectedDemos, item);
      }
    }
  },
  clearDemos: function clearDemos(state) {
    state.OrderSelectedDemos = [];
  },

  /* ## Common */
  updateDesiredQty: function updateDesiredQty(state, payload) {
    var item = state.OrderGeos[payload.index];
    var qty = parseInt(payload.qty);

    // check available qty
    if (!item.AvailableQty) {
      item.AvailableQty = state.TotalAvailableQty;
    }

    // check qty
    if (isNaN(qty)) {
      qty = item.AvailableQty;
    } else if (qty > item.AvailableQty) {
      qty = item.AvailableQty;
    } else if (qty < 0) {
      qty = 0;
    }

    if (state.OrderGeos.length === 0) {
      state.TotalDesiredQty = qty;
    } else {
      // save qty
      item.DesiredQty = qty;

      var left = qty;
      if (item.OrderGeoDetails && item.OrderGeoDetails.length > 0) {
        var geoDetails = item.OrderGeoDetails;
        for (var j = 0; j < geoDetails.length; j++) {
          if (left <= 0) {
            geoDetails[j].DesiredQty = 0;
          } else {
            if (geoDetails[j].AvailableQty >= left) {
              geoDetails[j].DesiredQty = left;
            } else if (geoDetails[j].AvailableQty > 0) {
              geoDetails[j].DesiredQty = geoDetails[j].AvailableQty;
            }
            left = left - geoDetails[j].DesiredQty;
          }
        }
      }

      // calcuate total
      var total = 0;
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = get_iterator_default()(state.OrderGeos), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var geo = _step7.value;

          total += geo.DesiredQty;
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      state.TotalDesiredQty = total;
    }
  },
  saveListType: function saveListType(state, val) {
    // TODO@PONY many save don't use this function
    state.ListType = parseInt(val);
    // state.OrderType = parseInt(val)
  },
  saveOrder: function saveOrder(state, values) {
    if (values) {
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(keys_default()(values)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var key = _step8.value;

          if (values[key] !== null) {
            vue_esm["default"].set(state, key, values[key]);
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    }
  },
  saveKey: function saveKey(state, val) {
    vue_esm["default"].set(state, val[0], val[1]);
  },
  updateContactInformation: function updateContactInformation(state, values) {
    vue_esm["default"].set(state.OrderContactInformation, values.key, values.val);
  },
  updatePaymentInformation: function updatePaymentInformation(state, values) {
    vue_esm["default"].set(state.OrderPaymentInformation, values.key, values.val);
  },
  saveAdditionalOutputColumns: function saveAdditionalOutputColumns(state, values) {
    state.AdditionalOutputColumns = values;
  },
  clearElementsForPricing: function clearElementsForPricing(state) {
    state.ElementsForPricing = [];
  },
  addElementsForPricing: function addElementsForPricing(state, item) {
    var price = {
      ElementDescription: null,
      ElementName: '',
      InternalPrice: 0,
      IsAdditional: false,
      IsGlobal: false,
      IsMultiple: true,
      NotificationRequired: false,
      Price: 0,
      PriceListName: '',
      SubColumnName: '',
      ValuesCount: 1,
      isInternalPrice: 0
    };

    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = get_iterator_default()(keys_default()(item)), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var key = _step9.value;

        if (price.hasOwnProperty(key)) {
          price[key] = item[key];
        }
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    state.ElementsForPricing.push(price);
  },
  saveGeoDesiredQty: function saveGeoDesiredQty(state, payload) {
    vue_esm["default"].set(state.OrderGeos[payload.index].OrderGeoDetails[0], 'DesiredQty', payload.val);
  },
  addOrderSuppressions: function addOrderSuppressions(state, item) {
    state.OrderSuppressions.push({
      OriginalOrderId: item.OrderId,
      SuppressedOrderCode: item.OrderCode,
      SuppressedOrderDesc: item.OrderDesc,
      SuppressedOrderId: item.OrderId,
      SuppressionName: item.OrderDesc,
      SuppressionValue: item.OrderCode
    });
  },
  addSaveCountSuppressions: function addSaveCountSuppressions(state, item) {
    state.SaveCountSuppressions.push({
      OriginalCountId: item.OrderId,
      SuppressedCountCode: item.OrderCode,
      SuppressedCountDesc: item.OrderDesc,
      SuppressedCountId: item.OrderId,
      SuppressionName: item.OrderDesc,
      SuppressionValue: item.CountId
    });
  },

  // TODO@PONY need check
  addCustomSuppressions: function addCustomSuppressions(state, item) {
    state.CustomSuppressions.push({
      FileName: item.SuppressionDesc,
      OrderDate: utils.dateFormat(item.OrderDate, 'MM/DD/YYYY'),
      SuppressionName: item.SuppressionName,
      SuppressionValue: item.SuppressionValue
    });
  },
  cleanSuppressions: function cleanSuppressions(state, item) {
    if (item === 'slc') {
      state.CustomSuppressions = [];
    } else if (item === 'order') {
      state.OrderSuppressions = [];
    }
  },
  removeOrderSuppressions: function removeOrderSuppressions(state, item) {
    for (var i = 0; i < state.OrderSuppressions.length; i++) {
      if (item.value === state.OrderSuppressions[i].SuppressionValue) {
        vue_esm["default"].delete(state.OrderSuppressions, i);
      }
    }
  },
  removeSaveCountSuppressions: function removeSaveCountSuppressions(state, item) {
    for (var i = 0; i < state.SaveCountSuppressions.length; i++) {
      if (item.value === state.SaveCountSuppressions[i].SuppressionValue) {
        vue_esm["default"].delete(state.SaveCountSuppressions, i);
      }
    }
  },

  // TODO@PONY need check
  removeCustomSuppressions: function removeCustomSuppressions(state, item) {
    for (var i = 0; i < state.CustomSuppressions.length; i++) {
      if (item.value === state.CustomSuppressions[i].SuppressionValue) {
        vue_esm["default"].delete(state.CustomSuppressions, i);
      }
    }
  },
  tiggerGeoShowDetail: function tiggerGeoShowDetail(state, index) {
    var ordergeos = state.OrderGeos;
    for (var i = 0; i < ordergeos.length; i++) {
      if (i === index) {
        var showDetail = ordergeos[index].showDetail || false;
        showDetail = !showDetail;
        vue_esm["default"].set(ordergeos[index], 'showDetail', showDetail);
      }
    }
  },
  changeGeoType: function changeGeoType(state, geoType) {
    vue_esm["default"].set(state, 'GeoType', geoType);
    vue_esm["default"].set(state, 'ZipType', 0);
    for (var i = 0; i < state.OrderGeos.length; i++) {
      vue_esm["default"].set(state.OrderGeos[i], 'GeoType', geoType);
    }
  }
});
// CONCATENATED MODULE: ./src/assets/priceHelp.js


/**
 * Created by seaasun on 2017/12/12.
 * This page is copy and edit from old version scripts/helper/helper.order.js
 */


// copy form old sl360 Scripts/entity/entity.enums.js
var enums = {
  PromotionMinPurAmtType: {
    BY_TOTAL_SPEND: 1,
    BY_TOTAL_RECORDS: 2,
    BY_TOTAL_SPEND_RECORDS: 3
  },
  PromotionType: {
    PERCENT_OFF_TOTAL_PRICE: 1,
    FREE_LEADS: 2,
    FLAT_DOLLAR_TOTAL_PRICE: 3,
    XNUMBER_OF_POINT: 4,
    NUMBER_OF_POINT: 5,
    DEBIT_CARD: 6,
    DOLLAR_MOBILE_ONLY: 7,
    DOLLAR_MOBILE_LIST_BOTH: 8,
    PERCENT_OFF_MOBILE_ONLY: 9,
    PERCENT_OFF_MOBILE_LIST_BOTH: 10
  },
  ListUsageType: {
    OneTimes: 1,
    TwoTimes: 2,
    ThreeTimes: 2,
    FourTimes: 4,
    FiveTimes: 5,
    SixTimes: 6,
    MultiTimes: 100
  },
  CalculatePriceMethod: {
    WholeOrder: 0,
    OnlyBase: 1
  }

  /* eslint-disable no-unused-vars */
};function _RecaculateTotalQty(order) {
  if (order.OrderGeos.length > 0) {
    order.DesiredQtyHome = 0;
    order.DesiredQtyApt = 0;
    order.DesiredQtyBuss = 0;
    order.AvailableQtyHome = 0;
    order.AvailableQtyApt = 0;
    order.AvailableQtyBuss = 0;
    order.TotalDesiredQty = 0;
    order.TotalAvailableQty = 0;
    order.TotalEmailDesiredQty = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = get_iterator_default()(order.OrderGeos), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var value = _step.value;

        order.DesiredQtyHome += value.DesiredQtyHome;
        order.DesiredQtyApt += value.DesiredQtyApt;
        order.DesiredQtyBuss += value.DesiredQtyBuss;
        order.AvailableQtyHome += value.AvailableQtyHome;
        order.AvailableQtyApt += value.AvailableQtyApt;
        order.AvailableQtyBuss += value.AvailableQtyBuss;
        order.TotalDesiredQty += value.DesiredQty;
        order.TotalAvailableQty += value.AvailableQty;
        order.TotalEmailDesiredQty += value.EmailDesiredQty;
      }
      // order.TotalDesiredQty = order.DesiredQtyHome + order.DesiredQtyApt + order.DesiredQtyBuss;
      // order.TotalAvailableQty = order.AvailableQtyHome + order.AvailableQtyApt + order.AvailableQtyBuss;
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}

/* eslint-disable no-unused-vars */
function RecaculateTotalGeoQtyAll(order) {
  for (var i = 0; i < order.OrderGeos.length; i++) {
    var geo = order.OrderGeos[i];
    geo.DesiredQtyHome = 0;
    geo.DesiredQtyApt = 0;
    geo.DesiredQtyBuss = 0;
    geo.AvailableQtyHome = 0;
    geo.AvailableQtyApt = 0;
    geo.AvailableQtyBuss = 0;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = get_iterator_default()(order.OrderGeos[i].OrderGeoDetails), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var value = _step2.value;

        geo.DesiredQtyHome += value.DesiredQtyHome;
        geo.DesiredQtyApt += value.DesiredQtyApt;
        geo.DesiredQtyBuss += value.DesiredQtyBuss;
        geo.AvailableQtyHome += value.AvailableQtyHome;
        geo.AvailableQtyApt += value.AvailableQtyApt;
        geo.AvailableQtyBuss += value.AvailableQtyBuss;
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    geo.DesiredQty = geo.DesiredQtyHome + geo.DesiredQtyApt + geo.DesiredQtyBuss;
    geo.AvailableQty = geo.AvailableQtyHome + geo.AvailableQtyApt + geo.AvailableQtyBuss;
  }
}

/* eslint-disable no-unused-vars */
function _RecaculateTotalGeoQty(order, geoIndex) {
  var geo = order.OrderGeos[geoIndex];
  geo.DesiredQtyHome = 0;
  geo.DesiredQtyApt = 0;
  geo.DesiredQtyBuss = 0;
  geo.AvailableQtyHome = 0;
  geo.AvailableQtyApt = 0;
  geo.AvailableQtyBuss = 0;
  geo.DesiredQty = 0;
  geo.AvailableQty = 0;
  geo.EmailDesiredQty = 0;
  geo.EmailAvailableQty = 0;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = get_iterator_default()(order.OrderGeos[geoIndex].OrderGeoDetails), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var value = _step3.value;

      if (order.ListType === 50) {
        geo.DesiredQtyHome += value.DesiredQtyHome;
        geo.DesiredQtyApt += value.DesiredQtyApt;
        geo.DesiredQtyBuss += value.DesiredQtyBuss;
        geo.AvailableQtyHome += value.AvailableQtyHome;
        geo.AvailableQtyApt += value.AvailableQtyApt;
        geo.AvailableQtyBuss += value.AvailableQtyBuss;
      } else {
        geo.DesiredQty += value.DesiredQty;
        geo.AvailableQty += value.AvailableQty;
        geo.EmailDesiredQty = value.Email_DesiredQty;
        geo.EmailAvailableQty = value.Email_AvailableQty;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  if (order.ListType === 50) {
    geo.DesiredQty = geo.DesiredQtyHome + geo.DesiredQtyApt + geo.DesiredQtyBuss;
    geo.AvailableQty = geo.AvailableQtyHome + geo.AvailableQtyApt + geo.AvailableQtyBuss;
  }
  _RecaculateTotalQty(order);
}

function GetMobilePackagePromotionValue(promotionCode, mobilePackageId) {
  var value = 0;
  if (promotionCode === null || promotionCode.Length === 0) {
    return 0;
  }
  var promotion = store.state.summary.Promotion;
  var mobilePackages = store.state.summary.MobilePackages;
  if (promotion != null) {
    if (CheckMobileCondition(mobilePackageId, promotion.PackageIds)) {
      var prom = 0;
      var pack = mobilePackages.getPackageById(mobilePackageId);
      if (promotion === 7) {
        // 7: entity.enums.PromotionType.DOLLAR_MOBILE_ONLY
        prom = promotion.PromotionValue;
      } else if (promotion.PromotionType === 7) {
        // 7: entity.enums.PromotionType.DOLLAR_MOBILE_ONLY
        prom = pack.Cost * promotion.PromotionValue;
      }
    }
    var totalValue = pack.Cost - prom;
    if (totalValue < promotion.MinPurAmount) {
      value = promotion.MinPurAmount - pack.Cost;
    } else {
      value = 0 - prom;
    }
  }
  return value;
}

function CaculateMobilePromotion(order, promotion) {
  var mobilePackages = store.state.summary.MobilePackages;
  if (CheckPromotCode(order)) {
    if (promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_ONLY || promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_LIST_BOTH || promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_ONLY || promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_LIST_BOTH) {
      if (order.MobilePackageId > 0) {
        var pack = mobilePackages.getPackageById(order.MobilePackageId);
        if (CheckMobileCondition(order.MobilePackageId, promotion.PackageIds)) {
          order.MobilePackageCharge = pack.Cost - promotion.PromotionValue;
          var mobileCharge = 0;
          if (promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_ONLY || promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_LIST_BOTH) {
            mobileCharge = pack.Cost - promotion.PromotionValue;
          } else if (promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_ONLY || promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_LIST_BOTH) {
            mobileCharge = pack.Cost - pack.Cost * promotion.PromotionValue;
          }
          if (mobileCharge < promotion.MinPurAmount) {
            mobileCharge = promotion.MinPurAmount;
          }
          order.MobilePackageCharge = mobileCharge;
        } else {
          order.MobilePackageCharge = pack.Cost;
        }
      }
    }
  }
  return order;
}
function CaculateMobilePackageCharge(order, promotion) {
  var mobilePackages = store.state.summary.MobilePackages;
  if (CheckPromotCode(order) === false) {
    if (order.MobilePackageId > 0) {
      var pack = mobilePackages.getPackageById(order.MobilePackageId);
      order.MobilePackageCharge = pack.Cost;
    }
  } else {
    CaculateMobilePromotion(order, promotion);
  }
}

function CheckPromotCode(order) {
  var PCode = order.PromoCode;
  if (PCode == null || PCode.Length === 0) {
    return false;
  } else {
    return true;
  }
}

function CaculatePromotion(order, plUser, promotion) {
  order.PromotionAmount = GetPromotionCharge(order, promotion);
  CaculateMobilePackageCharge(order, promotion);
  var cost = null;
  if (promotion && promotion.PromotionType === enums.PromotionType.DEBIT_CARD && order.PromotionAmount > 0) {
    var total = order.OrderCharge + order.ShippingCharge + order.LabelCharge + order.ServiceCharge + order.GeographyCharge;
    if (total > order.PromotionAmount) {
      order.TotalEstmCost = total - order.PromotionAmount;
    } else {
      order.PromotionAmount = total;
      order.TotalEstmCost = 0;
    }
  } else {
    // get sub total charge
    var subTotalCharge = order.OrderCharge - order.PromotionAmount;
    if (promotion) {
      if (promotion.IsNoRequired) {} else {
        if (order.OrderCharge <= plUser.MinElementsCharge) {
          subTotalCharge = plUser.MinElementsCharge;
          order.PromotionAmount = 0;
        } else if (order.OrderCharge > plUser.MinElementsCharge) {
          cost = order.OrderCharge - plUser.MinElementsCharge;
          if (cost <= order.PromotionAmount) {
            order.OrderCharge = plUser.MinElementsCharge;
            order.PromotionAmount = cost;
          } else {
            order.OrderCharge = subTotalCharge;
          }
        }
      }
    } else {
      if (subTotalCharge < plUser.MinElementsCharge) {
        subTotalCharge = plUser.MinElementsCharge;
      }
    }
    order.SubTotalCharge = subTotalCharge;
    order.TotalEstmCost = order.SubTotalCharge + order.ShippingCharge + order.LabelCharge + order.ServiceCharge + order.GeographyCharge;
    order.MinElementsChargeApply = order.SubTotalCharge === plUser.MinElementsCharge;
  }
  order.TotalPretaxCost = order.TotalEstmCost;
  return order;
}

function GetMultiplePriceByListUsageType(listUsageType, mprice) {
  for (var i = 0; i < mprice.length; i++) {
    if (mprice[i].MultipleId === listUsageType) {
      return mprice[i].Multiple;
    }
  }
}

function GetSinglePrice(order, plUser, plGlobal) {
  var qty = order.TotalDesiredQty;
  var listUsage = order.ListUsage;
  var mprice = plUser === null ? plGlobal.ListMultiplePrice : plUser.ListMultiplePrice;
  var multiplePrice = GetMultiplePriceByListUsageType(listUsage, mprice);
  var myCalculatePriceMethod = store.state.summary.CalculatePriceMethod;
  // caculate demo elements pricing
  var singleprice = 0;
  var singlepriceSubItmes = 0;
  for (var i = 0; i < order.ElementsForPricing.length; i++) {
    var el = order.ElementsForPricing[i];
    // add by erik wang @20210708
    // if order geo type is multi count, we must make sure geo desired qty >0 then add that price element
    if (el.IsMultiCountElement === true) {
      var geoCountIds = el.MultiCountIds.split(',');
      var existed = false;
      for (var c = 0; c < geoCountIds.length; c++) {
        for (var j = 0; j < order.OrderGeos.length; j++) {
          if (geoCountIds[c] === order.OrderGeos[j].GeoKeyCode) {
            if (order.OrderGeos[j].DesiredQty > 0) {
              existed = true;
            }
          }
        }
      }
      if (existed === false) {
        continue;
      }
    }

    if (el.ValuesCount < 1) {
      el.ValuesCount = 1;
    }
    // get from user price list first
    var p = GetPriceByElement(el.ElementName, qty, plUser);
    var valuePrice = null;
    if (p === null) {
      p = GetPriceByElement(el.ElementName, qty, plGlobal);
      el.Price = p === null ? plGlobal.GlobalElementPrice : p.Price1;
      el.IsGlobal = true;
      el.NotificationRequired = p === null ? true : p.NotificationRequired;
      el.PriceListName = p === null ? 'default' : plGlobal.PriceListName;

      valuePrice = p === null ? 0 : p.Price2;
      valuePrice = (el.ValuesCount - 1) * valuePrice;
      el.Price = el.Price + valuePrice;
      singlepriceSubItmes += el.Price;

      if (listUsage > enums.ListUsageType.OneTimes && el.IsMultiple) {
        //  el.Price = el.Price * plGlobal.MultiplePrice;
        if (myCalculatePriceMethod === enums.CalculatePriceMethod.WholeOrder) {
          el.Price = el.Price * multiplePrice;
        } else {
          if (el.ElementName.toUpperCase() === 'BASE') {
            el.Price = el.Price * multiplePrice;
          }
        }
      }
    } else {
      el.Price = p.Price1;
      el.IsGlobal = false;
      el.PriceListName = plUser.PriceListName;
      valuePrice = p === null ? 0 : p.Price2;
      valuePrice = (el.ValuesCount - 1) * valuePrice;
      el.Price = el.Price + valuePrice;
      singlepriceSubItmes += el.Price;

      // var multiplePrice = plUser === null ? plGlobal.MultiplePrice : plUser.MultiplePrice;
      // var mprice = plUser === null ? plGlobal.ListMultiplePrice : plUser.ListMultiplePrice;
      if (listUsage > enums.ListUsageType.OneTimes && el.IsMultiple) {
        // el.Price = el.Price * multiplePrice;
        if (myCalculatePriceMethod === enums.CalculatePriceMethod.WholeOrder) {
          el.Price = el.Price * multiplePrice;
        } else {
          if (el.ElementName.toUpperCase() === 'BASE') {
            el.Price = el.Price * multiplePrice;
          }
        }
      }
    }
    singleprice += el.Price;
  }
  return singleprice;
}

function GetSingleGoodsPrice(order, metadataPriceList) {
  var singleprice = 0;
  var myCalculatePriceMethod = store.state.summary.CalculatePriceMethod;
  if (metadataPriceList !== undefined && metadataPriceList != null) {
    var qty = order.TotalDesiredQty;
    var listUsage = order.ListUsage;
    // caculate demo elements pricing

    var maxBasePrice = 0;
    var maxMapMultiuseFactor = 0;
    var mprice = store.state.summary.UserPriceList === null ? store.state.summary.GlobalPriceList.ListMultiplePrice : store.state.summary.UserPriceList.ListMultiplePrice;
    maxMapMultiuseFactor = GetMultiplePriceByListUsageType(listUsage, mprice);
    for (var i = 0; i < order.ElementsForPricing.length; i++) {
      var el = order.ElementsForPricing[i];
      if (el.ValuesCount < 1) {
        el.ValuesCount = 1;
      }
      // get from user price list first
      var p = GetGoodsPriceByElement(el.ElementName, metadataPriceList);

      // if (p === null && el.ElementName === "BASE") {
      if (p === null && PriceElementEquals(el.ElementName.toUpperCase(), 'BASE')) {
        maxBasePrice = metadataPriceList.MapBasePrice;
      } else {
        if (p != null) {
          el.Price = p.MapColumnPrice === null ? 0 : p.MapColumnPrice;
          el.IsGlobal = false;
          var valuePrice = p === null ? 0 : p.MapColumnPrice2 === null ? 0 : p.MapColumnPrice2;
          valuePrice = (el.ValuesCount - 1) * valuePrice;
          el.Price = el.Price + valuePrice;
          singleprice += el.Price;
        }
      }
    }

    // singleprice = maxBasePrice + singleprice;
    if (listUsage > enums.ListUsageType.OneTimes && el.IsMultiple) {
      if (myCalculatePriceMethod === enums.CalculatePriceMethod.WholeOrder) {
        singleprice = (singleprice + maxBasePrice) * maxMapMultiuseFactor;
      } else {
        singleprice = maxBasePrice * maxMapMultiuseFactor + singleprice;
      }
    } else {
      singleprice = maxBasePrice + singleprice;
    }

    var maxCostOfGoodPrice = store.state.summary.MaxCostOfGoodPrice;
    if (maxCostOfGoodPrice > 0 && singleprice > maxCostOfGoodPrice) {
      singleprice = maxCostOfGoodPrice;
    }
  }
  return singleprice;
}

function GetPriceByElement(element, qty, pricelist) {
  for (var i = 0; i < pricelist.ElementsPrices.length; i++) {
    var priceObj = pricelist.ElementsPrices[i];
    if (PriceElementEquals(priceObj.PriceName, element) && priceObj.Lbound <= qty && priceObj.Ubound >= qty) {
      return priceObj;
    }
  }
  return null;
}

function GetGoodsPriceByElement(element, metadataPricelist) {
  if (metadataPricelist !== undefined && metadataPricelist != null && metadataPricelist.MetadataPricingList !== undefined && metadataPricelist.MetadataPricingList !== null) {
    for (var i = 0; i < metadataPricelist.MetadataPricingList.length; i++) {
      var priceObj = metadataPricelist.MetadataPricingList[i];
      if (PriceElementEquals(priceObj.ColumnName, element)) {
        return priceObj;
      }
    }
  }
  return null;
}

/// <summary>
/// Get label charge by follow steps:
/// 1 find price object by price name : base
/// 2 calculate label charge
/// 2.1 baseprice * qty < min price, return min price
/// 2.2 else return baseprice * qty
/// </summary>
/// <param name="order">order</param>
/// <param name="pl">qlabel price list</param>
function GetLabelBaseCharge(order, pricelist) {
  var qty = order.TotalDesiredQty;
  var labels = order.MailLabelsCount;
  if (labels === 0) {
    return 0;
  }

  var elPrice = 0;
  for (var i = 0; i < pricelist.LabelPrices.length; i++) {
    var priceObj = pricelist.LabelPrices[i];
    if (PriceElementEquals(priceObj.PriceName, 'base') && priceObj.Lbound <= qty && priceObj.Ubound >= qty) {
      elPrice = priceObj.Price1;
      break;
    }
  }

  // get base label charge
  var baseCharge = elPrice * qty * labels;
  if (baseCharge < pricelist.MinLabelCharge) {
    baseCharge = pricelist.MinLabelCharge;
  }
  return baseCharge;
}
/// <summary>
/// Get Shipping charge by follow steps:
/// 1 find price object by price name : shipprice
/// 2 calculate shipping charge
/// 2.1 the first labels' price is price1
/// 2.2 the follow labels' price is price2
/// 2.3 total shipping charge = 1*price1 + (labels-1)*price2
/// </summary>
/// <param name="order">order</param>
/// <param name="pl">qlabel price list</param>
function GetLabelShipCharge(order, pricelist) {
  var qty = order.TotalDesiredQty;
  var labels = order.MailLabelsCount;
  if (labels === 0) {
    return 0;
  }

  var price1 = 0;
  var price2 = 0;
  for (var i = 0; i < pricelist.LabelPrices.length; i++) {
    var priceObj = pricelist.LabelPrices[i];
    if (priceObj.PriceName.toLowerCase() === 'shipprice' && priceObj.Lbound <= qty && priceObj.Ubound >= qty) {
      price1 = priceObj.Price1;
      price2 = priceObj.Price;
      break;
    }
  }

  var firstLabelCharge = price1;
  var additionalLabelCharge = (labels - 1) * price2;
  return firstLabelCharge + additionalLabelCharge;
}

// <summary>
// Get Promotion Amount by follow steps:
// 1 find promotion by promotion code
// 2 check whether qty/amount reach the min requirement
// 3 if reach the min requirement, get promo amount by different promotion type
// </summary>
// <param name="order">The order.</param>
// <param name="listPrice">per record price for calculating list price and promotion amount</param>
// <returns></returns>

function GetPromotionCharge(order, promotion) {
  var PCode = order.PromoCode;
  var qty = order.TotalDesiredQty;
  var singlePrice = order.CostPrice;

  order.PromotionPointType = 0;
  order.PromotionPointValue = 0;

  if (!PCode || Array.isArray(PCode) && PCode.Length === 0) {
    return 0;
  }

  var totalAmt = order.OrderCharge; // singlePrice * qty;

  var promotionAmount = 0;
  if (promotion != null) {
    var isPromotionEffective = false;
    if (promotion.MinPurAmountType === enums.PromotionMinPurAmtType.BY_TOTAL_SPEND) {
      isPromotionEffective = totalAmt >= promotion.MinPurAmount;
    } else if (promotion.MinPurAmountType === enums.PromotionMinPurAmtType.BY_TOTAL_RECORDS) {
      isPromotionEffective = qty >= promotion.MinPurQty;
    } else {
      isPromotionEffective = totalAmt >= promotion.MinPurAmount && qty >= promotion.MinPurQty;
    }
    if (isPromotionEffective) {
      if (promotion.PromotionType === enums.PromotionType.PERCENT_OFF_TOTAL_PRICE) {
        promotionAmount = totalAmt * promotion.PromotionValue;
      } else if (promotion.PromotionType === enums.PromotionType.FLAT_DOLLAR_TOTAL_PRICE) {
        promotionAmount = promotion.PromotionValue;
      } else if (promotion.PromotionType === enums.PromotionType.FREE_LEADS) {
        promotionAmount = singlePrice * promotion.PromotionValue;
      } else if (promotion.PromotionType === enums.PromotionType.XNUMBER_OF_POINT) {
        order.PromotionPointType = enums.PromotionType.XNUMBER_OF_POINT;
        order.PromotionPointValue = promotion.PromotionValue;
      } else if (promotion.PromotionType === enums.PromotionType.NUMBER_OF_POINT) {
        order.PromotionPointType = enums.PromotionType.NUMBER_OF_POINT;
        order.PromotionPointValue = promotion.PromotionValue;
      } else if (promotion.PromotionType === enums.PromotionType.DEBIT_CARD) {
        promotionAmount = promotion.PromotionBalance;
      } else if (promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_ONLY || promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_ONLY) {
        if (CheckMobileCondition(order.MobilePackageId, promotion.PackageIds)) {
          CaculateMobilePromotion(order, promotion);
        }
      } else if (promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_LIST_BOTH || promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_LIST_BOTH) {
        if (CheckMobileCondition(order.MobilePackageId, promotion.PackageIds)) {
          if (promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_LIST_BOTH) {
            promotionAmount = promotion.PromotionValue;
          } else if (promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_LIST_BOTH) {
            promotionAmount = totalAmt * promotion.PromotionValue;
          }
          CaculateMobilePromotion(order, promotion);
        }
      }
    }
  }

  if (promotionAmount > totalAmt && promotion.PromotionType !== enums.PromotionType.DEBIT_CARD) {
    promotionAmount = totalAmt;
  }
  return promotionAmount;
}

function CheckMobileCondition(mobilePackageId, packageIds) {
  var isCheck = false;
  if (mobilePackageId > 0) {
    var ids = packageIds.split(',');
    for (var i = 0; i < ids.length; i++) {
      if (String(mobilePackageId) === String(ids[i]).trim()) {
        isCheck = true;
        break;
      }
    }
  }
  return isCheck;
}

function GetServiceCharge(order, priceList) {
  return priceList.ServiceCharge;
}

function GetGeographyCharge(order, priceList) {
  var geographyCharge = 0;
  for (var i = 0; i < priceList.GeographyPrices.length; i++) {
    var price = priceList.GeographyPrices[i];
    if (price.PriceName === order.GeoType.toString()) {
      geographyCharge = price.Price1;
      break;
    }
  }
  return geographyCharge;
}

function SetGeoDetailsDesiredByDetail(orderGeo, value) {
  if (orderGeo === null) return;
  var left = value;
  if (Array.isArray(orderGeo.OrderGeoDetails) && orderGeo.OrderGeoDetails.length > 0) {
    var geoDetails = orderGeo.OrderGeoDetails;
    for (var j = 0; j < geoDetails.length; j++) {
      if (left <= 0) {
        geoDetails[j].DesiredQty = 0;
      } else {
        if (geoDetails[j].AvailableQty >= left) {
          geoDetails[j].DesiredQty = left;
        } else if (geoDetails[j].AvailableQty > 0) {
          geoDetails[j].DesiredQty = geoDetails[j].AvailableQty;
        }
        left = left - geoDetails[j].DesiredQty;
      }
    }
  }
}

function SetGeoDetailsDesiredByOrder(order) {
  if (order === null) return null;
  if (Array.isArray(order.OrderGeos) && order.OrderGeos.length > 0) {
    for (var i = 0; i < order.OrderGeos.length; i++) {
      SetGeoDetailsDesiredByDetail(order.OrderGeos[i], order.OrderGeos[i].DesiredQty);
    }
  }
}

function CaculatePackage(order, digitalFileQty) {
  if (order === null || order.MobilePackages === undefined || order.MobilePackages === null) return;
  if (Array.isArray(order.MobilePackages) && order.MobilePackages.length > 0) {
    for (var i = 0; i < order.MobilePackages.length; i++) {
      if (order.MobilePackages[i].Details != null) {
        for (var j = 0; j < order.MobilePackages[i].Details.length; j++) {
          if (digitalFileQty >= order.MobilePackages[i].Details[j].MinGoal && digitalFileQty <= order.MobilePackages[i].Details[j].MaxGoal) {
            order.MobilePackages[i].ViewCount = order.MobilePackages[i].Details[j].ViewCount;
            order.MobilePackages[i].Cost = order.MobilePackages[i].Details[j].Price;
            break;
          }
        }
      }
    }
  }
}

function PriceElementEquals(priceName, elementName) {
  return String(priceName) === String(elementName);
}

/* eslint-disable no-unused-vars */
function CaculatePrice(order, plUser, plGlobal, promotion, metadataPriceList) {
  if (store.state.order.ListType === 190) {
    return;
  } // entity.enums.DataSourceType.Mobile_Consumer_Advertising
  order.CostPrice = GetSinglePrice(order, plUser, plGlobal);
  order.GoodsCost = GetSingleGoodsPrice(order, metadataPriceList) * order.TotalDesiredQty;
  if (metadataPriceList !== undefined && metadataPriceList != null && order.GoodsCost < metadataPriceList.MapMinPrice) {
    order.GoodsCost = metadataPriceList.MapMinPrice;
  }
  // get order charge
  order.OrderCharge = order.CostPrice * order.TotalDesiredQty;

  // TODO@PONY need update mulitiCount Price
  // if is MultiCount, re-caculatePrice
  // if (order.OrderGeos.length > 0 && order.OrderGeos[0].GeoType === 24) {
  //   order.OrderCharge = 0

  //   for (let i = 0; i < order.OrderGeos.length; i++) {
  //     order.OrderCharge = order.OrderCharge + order.OrderGeos[i].CostPrice * order.OrderGeos[i].DesiredQty
  //   }

  //   order.CostPrice = order.OrderCharge / order.TotalDesiredQty
  // }

  if (order.OrderCharge < plUser.MinElementsCharge) {
    order.OrderCharge = plUser.MinElementsCharge;
  }

  // get shipping charge
  order.ShippingCharge = GetLabelShipCharge(order, plGlobal);
  order.LabelCharge = GetLabelBaseCharge(order, plGlobal);
  order.PromotionAmount = GetPromotionCharge(order, promotion);
  order.ServiceCharge = GetServiceCharge(order, plUser);
  order.GeographyCharge = GetGeographyCharge(order, plUser);

  var cost = null;
  if (promotion && promotion.PromotionType === enums.PromotionType.DEBIT_CARD && order.PromotionAmount > 0) {
    var total = order.OrderCharge + order.ShippingCharge + order.LabelCharge + order.ServiceCharge + order.GeographyCharge;

    if (total <= plUser.MinElementsCharge) {
      total = plUser.MinElementsCharge;
      order.MinElementsChargeApply = true;
    }

    if (total > order.PromotionAmount) {
      order.TotalEstmCost = total - order.PromotionAmount;
    } else {
      order.PromotionAmount = total;
      order.TotalEstmCost = 0;
    }
  } else {
    // get sub total charge
    var subTotalCharge = order.OrderCharge - order.PromotionAmount;
    if (promotion) {
      if (promotion.IsNoRequired) {} else {
        if (order.OrderCharge <= plUser.MinElementsCharge) {
          subTotalCharge = plUser.MinElementsCharge;
          order.PromotionAmount = 0;
        } else if (order.OrderCharge > plUser.MinElementsCharge) {
          cost = order.OrderCharge - plUser.MinElementsCharge;
          if (cost <= order.PromotionAmount) {
            order.OrderCharge = plUser.MinElementsCharge;
            order.PromotionAmount = cost;
          } else {
            order.OrderCharge = subTotalCharge;
          }
        }
      }
    } else {
      if (subTotalCharge < plUser.MinElementsCharge) {
        subTotalCharge = plUser.MinElementsCharge;
      }
    }
    order.SubTotalCharge = subTotalCharge;

    order.TotalEstmCost = order.SubTotalCharge + order.ShippingCharge + order.LabelCharge + order.ServiceCharge + order.GeographyCharge;
    order.TotalEmailEstmCost = order.CostPrice * order.TotalEmailDesiredQty;
    order.RetailCost = order.TotalEstmCost;
    order.MinElementsChargeApply = order.SubTotalCharge === plUser.MinElementsCharge;
    order.MinLabelChargeApply = order.LabelCharge === plGlobal.MinLabelCharge;
    var orderAmount = order.OrderCharge - order.PromotionAmount + order.ShippingCharge + order.LabelCharge;
    order.MinOrderAmountApply = orderAmount < plUser.MinElementsCharge;
  }

  order.TotalPretaxCost = order.TotalEstmCost;
  return order;
}

/* harmony default export */ var priceHelp = ({
  updatePrice: function updatePrice(order, promotion) {
    order = order || JSON.parse(stringify_default()(store.state.order));
    promotion = promotion || store.state.summary.Promotion;
    // store.state.summary.UserPriceList.MinElementsCharge = 50
    CaculatePrice(order, store.state.summary.UserPriceList, store.state.summary.GlobalPriceList, promotion, store.state.site.BizMetadataPricing);
    return order;
  },
  RecaculateTotalGeoQty: function RecaculateTotalGeoQty(order, index) {
    _RecaculateTotalGeoQty(order, index);
  },
  RecaculateTotalQty: function RecaculateTotalQty(order) {
    _RecaculateTotalQty(order);
  }
});
// CONCATENATED MODULE: ./src/store/order/actions.js


/**
 * Created by seaasun on 2017/12/28.
 */








function hasDemoValue(column, AttributeValue) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = get_iterator_default()(column.Values), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.AttributeValue === AttributeValue) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}

function countError(commit, name, state, resp) {
  utils.progressDone();
  src_main.$root.$emit('bv::hide::modal', 'modal-counting');
  notification.notice('error', 'please try again', {
    title: 'Count Error',
    actions: [],
    duration: 10000
  });
  commit('saveKey', ['CurrentStep', 'input']);
  utils.log('count', name, {
    url: resp.url,
    body: resp.body,
    status: resp.status,
    statusText: resp.statusText
  }, state);
}

/* harmony default export */ var actions = ({
  initOrder: function initOrder(_ref, listType) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    /*  init order
      listType: number
     */
    commit('saveOrder', config_order());
    if (listType) {
      commit('saveListType', listType);
    }
    if (rootState.user.accountId) {
      commit('saveKey', ['AccountId', rootState.user.accountId]);
    }
  },
  slcPollOrder: function slcPollOrder(_ref2) {
    var state = _ref2.state,
        commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        rootState = _ref2.rootState;

    if (state.CurrentStep === 'count') {
      return false;
    }
    if (rootState.site.isSLC) {
      commit('site/saveKey', ['slcCountNum', rootState.site.slcCountNum + 1]);
    }
    commit('saveKey', ['CurrentStep', 'count']);
    utils.progressStart();
    src_main.$root.$emit('bv::show::modal', 'modal-counting');
    utils.log('submitOrder', 'submitOrder', 'submitOrder', state);
    dispatch('pollCount');
  },
  submitOrder: function submitOrder(_ref3) {
    var state = _ref3.state,
        commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        rootState = _ref3.rootState;

    /* start get count
        Get Count work flow:
      1. submitOrder
      2. start poll count
      3. check poll count
      4. get order
      5. progress order
      6. get order contact
     */
    if (state.CurrentStep === 'count') {
      return false;
    }

    if (rootState.site.isSLC) {
      commit('site/saveKey', ['slcCountNum', rootState.site.slcCountNum + 1]);
    }

    commit('saveKey', ['CurrentStep', 'count']);
    utils.progressStart();
    src_main.$root.$emit('bv::show::modal', 'modal-counting');

    utils.log('submitOrder', 'submitOrder', 'submitOrder', state);
    vue_esm["default"].http.post('PlaceOrder.aspx/SubmitOrder', {
      order: state
    }, {
      progressBar: false,
      errorType: 'silent'
    }).then(function (resp) {
      commit('saveOrder', resp.body.d.DataSource);
      dispatch('pollCount');
    }, function (resp) {
      countError(commit, 'submit', state, resp);
    });
  },
  pollCount: function pollCount(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    // Vue.http.post('PlaceOrder.aspx/PollCount', {
    vue_esm["default"].http.post('PlaceOrder.aspx/PollCountWithotSession', {
      orderId: 13402,
      order: state
    }, {
      progressBar: false,
      errorType: 'silent'
    }).then(function (resp) {
      // stop count if users stop
      if (state.CurrentStep !== 'count') {
        return false;
      }
      commit('saveOrder', resp.body.d.DataSource.Order);
      dispatch('checkPollCount', resp.body.d.DataSource.RequestId);

      // setTimeout(() => {
      //   dispatch('checkPollCount', resp.body.d.DataSource.RequestId)
      // }, 1000)
    }, function (resp) {
      utils.progressDone();
      countError(commit, 'pollCount', state, resp);
    });
  },
  checkPollCount: function checkPollCount(_ref5, requestId) {
    var state = _ref5.state,
        commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    // Vue.http.post('PlaceOrder.aspx/CheckPollingStatus', {
    vue_esm["default"].http.post('PlaceOrder.aspx/CheckPollingStatusWithoutSeesion', {
      requestId: requestId,
      order: state
    }, {
      progressBar: false,
      errorType: 'silent'
    }).then(function (resp) {
      // stop count if users stop
      if (state.CurrentStep !== 'count') {
        return false;
      }
      if (resp.body.d.DataSource.PercentComplete < 100) {
        // let count = 0

        setTimeout(function () {
          // count += 1
          dispatch('checkPollCount', resp.body.d.DataSource.RequestId);
        }, 1000);
      } else {
        dispatch('getOrder', requestId);
      }
    }, function (resp) {
      countError(commit, 'checkPollCount', state, resp);
    });
  },
  getOrder: function getOrder(_ref6, requestId) {
    var state = _ref6.state,
        commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    vue_esm["default"].http.post('PlaceOrder.aspx/GetOrderAndPriceList2WithoutSession', {
      // Vue.http.post('PlaceOrder.aspx/PollCount', {
      listtype: 10,
      istest: false,
      order: state,
      requestId: requestId
    }, {
      progressBar: false,
      errorType: 'silent'
    }).then(function (resp) {
      dispatch('user/getUserPaymentCard', null, { root: true });

      commit('saveOrder', resp.body.d.DataSource.Order);
      commit('saveKey', ['CurrentStep', 'count']);

      delete resp.body.d.DataSource.Order;
      commit('summary/saveSummary', resp.body.d.DataSource, { root: true });

      utils.progressDone();
      src_main.$root.$emit('bv::hide::modal', 'modal-counting');
      commit('saveKey', ['CurrentStep', 'summary']);
      dispatch('progressOrder');
      src_router.push({ name: 'summary' });
    }, function (resp) {
      countError(commit, 'pollCount', state, resp);
    });
  },
  progressOrder: function progressOrder(_ref7) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    dispatch('getOrderContact');
    dispatch('calculatePrice');
  },
  getOrderContact: function getOrderContact(_ref8) {
    var state = _ref8.state,
        getters = _ref8.getters,
        commit = _ref8.commit,
        rootState = _ref8.rootState;

    vue_esm["default"].http.post('PlaceOrder.aspx/GetUserInformation', {}).then(function (resp) {
      var user = resp.body.d.DataSource;

      if (user.HomePhone) {
        var phone = user.HomePhone;
        phone = phone.replace('(', '').replace(')', '').replace(' ', '').replace('x', '').replace('-', '');
        phone = '(' + phone.substr(0, 3) + ') ' + phone.substr(3, 3) + '-' + phone.substr(6, 4);
      } else {
        phone = '';
      }

      // TODO@PONY uc.payment.IsContactAddressComplete
      var address = {};
      if (rootState.summary.IsContactAddressComplete && user.UsersAddress.length >= 1) {
        address = user.UsersAddress[0];
      } else {
        address = {
          AddressLine: '',
          CityName: '',
          CountryCode: 'US',
          StateCode: '',
          ZipCode: null
        };
      }

      commit('saveKey', ['OrderContactInformation', {
        AddToMailingList: false,
        AddressLine: address.AddressLine,
        CallMe: false,
        City: address.CityName,
        Company: user.Company,
        CountryCode: address.CountryCode,
        Email: user.Email,
        FirstName: user.FirstName,
        LastName: user.LastName,
        IsContactMeByEmail: false,
        IsSendEmailToAudience: false,
        IsSendEmailToList: false,
        IsSendMobileFacebookToAudience: false,
        LicenseNumber: user.LicenseNumber,
        OrderForClients: false,
        OrderName: '',
        Phone: phone,
        SANNumber: user.SANNumber,
        SANNumberLastUpdatedDateTime: user.SANNumberLastUpdatedDateTime,
        State: address.StateCode,
        Zipcode: address.ZipCode
      }]);
      commit('summary/saveKey', ['userInformation', resp.body.d.DataSource], { root: true });

      // save paymentInformation
      if (getters['isCreditCard']) {
        commit('saveKey', ['OrderPaymentInformation', {
          AddressLine: rootState.user.userPaymentCard.Address || address.AddressLine,
          CardType: rootState.user.userPaymentCard.CardType || 10,
          City: rootState.user.userPaymentCard.City || address.CityName,
          CountryCode: address.CountryCode,
          Email: user.Email,
          ExpiredMonth: rootState.user.userPaymentCard.ExpirationMonth || new Date().getMonth(),
          ExpiredYear: rootState.user.userPaymentCard.ExpirationYear || new Date().getFullYear() + 1,
          HolderName: rootState.user.userPaymentCard.HolderName || '',
          LegatoMessage: '',
          Number: rootState.user.userPaymentCard.CardNumber || '',
          Phone: phone,
          SecurityCode: rootState.user.userPaymentCard.CVV || '',
          State: rootState.user.userPaymentCard.State || address.StateCode || '',
          Token: '',
          Zipcode: rootState.user.userPaymentCard.ZipCode || address.ZipCode || ''
        }]);
      }

      // TODO PONY ,paymentMethod, card:1; no card 2
      // commit('saveKey', ['PaymentMethod', rootState.site.IsUserNoPay ? 1 : 2])
      commit('saveKey', ['OrderDesc', '']);
    });
  },

  //  ==== demo
  addDemoByItem: function addDemoByItem(_ref9, payload) {
    var state = _ref9.state,
        getters = _ref9.getters,
        commit = _ref9.commit;

    // ColumnName
    // DemoCategoryType
    // AttributeName
    // AttributeValue
    // AttributeValueName
    // SortSeq
    // Description
    var index = getters.demoColumnIndex(payload.ColumnName, payload.DemoCategoryType);
    var val = {
      AttributeValue: payload.AttributeValue,
      AttributeValueName: payload.AttributeValueName || '',
      ColumnName: payload.ColumnName,
      SortSeq: payload.SortSeq || ''
      // pusha a new column
    };if (index === -1) {
      commit('addNewDemo', {
        AttributeName: payload.AttributeName || '',
        ColumnName: payload.ColumnName,
        DemoCategoryType: payload.DemoCategoryType || 0,
        Description: payload.Description || '',
        Values: [val]
      });
    } else {
      var column = state.OrderSelectedDemos[index];
      // only push value
      if (!hasDemoValue(column, payload.AttributeValue)) {
        commit('addNewDemoValue', {
          index: index,
          val: val
        });
      }
    }
  },
  deleteDemo: function deleteDemo(_ref10, payload) {
    var state = _ref10.state,
        getters = _ref10.getters,
        commit = _ref10.commit;

    /*
      type: 'value', 'column'
      columnName:
      demoCategoryType:
      attributeValue：
    */
    payload = payload || {};
    var type = payload.type || 'value';
    payload.columnName = payload.columnName + '';
    var index = getters.demoColumnIndex(payload.columnName, payload.demoCategoryType); // TODO@PONY not good var name
    if (type === 'column') {
      commit('deleteDemo', index);
    } else {
      var column = getters.demoColumnItem(payload.columnName, payload.demoCategoryType);
      if (column && column.Values.length === 1) {
        commit('deleteDemo', index);
      } else if (column) {
        for (var i = 0; i < column.Values.length; i++) {
          if (payload.attributeValue === column.Values[i].AttributeValue) {
            commit('deleteDemoValue', {
              index: index,
              valueIndex: i
            });
            break;
          }
        }
      }
    }
  },
  toggleAddDemoBusinessType: function toggleAddDemoBusinessType(_ref11, payload) {
    var dispatch = _ref11.dispatch;

    var val = payload.val;
    var code = payload.industryCode || '';
    var desc = payload.IndustryDesc || '';
    if (payload.deep !== 0) {
      if (val) {
        dispatch('addDemoByItem', {
          AttributeName: 'Retail Trade',
          ColumnName: '7',
          DemoCategoryType: 4,
          AttributeValue: code,
          AttributeValueName: desc,
          SortSeq: 0
        });
      } else {
        dispatch('deleteDemo', {
          type: 'value',
          columnName: 7,
          attributeValue: code,
          demoCategoryType: 4
        });
      }
    }
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = get_iterator_default()(payload.values), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var item = _step2.value;

        if (val) {
          dispatch('addDemoByItem', {
            AttributeName: 'Retail Trade',
            ColumnName: '7',
            DemoCategoryType: 4,
            AttributeValue: item.attributes.IndustryCode,
            AttributeValueName: item.data,
            SortSeq: 0
          });
        } else {
          dispatch('deleteDemo', {
            type: 'value',
            columnName: 7,
            attributeValue: item.attributes.IndustryCode,
            demoCategoryType: 4
          });
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  },
  toggleOmitDemoBusinessType: function toggleOmitDemoBusinessType(_ref12, payload) {
    var dispatch = _ref12.dispatch;

    var val = payload.val;
    var code = payload.industryCode || '';
    var desc = payload.IndustryDesc || '';
    if (payload.deep !== 0) {
      if (val) {
        dispatch('addDemoByItem', {
          AttributeName: 'Retail Trade (Omit)',
          ColumnName: '7',
          DemoCategoryType: 6,
          AttributeValue: code,
          AttributeValueName: desc,
          SortSeq: 0
        });
      } else {
        dispatch('deleteDemo', {
          type: 'value',
          columnName: 7,
          demoCategoryType: 6,
          attributeValue: code // TODO@PONY ColumnName sometimes is same THI
        });
      }
    }
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = get_iterator_default()(payload.values), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var item = _step3.value;

        if (val) {
          dispatch('addDemoByItem', {
            AttributeName: 'Retail Trade (Omit)',
            ColumnName: '7',
            DemoCategoryType: 6,
            AttributeValue: item.attributes.IndustryCode,
            AttributeValueName: item.data,
            SortSeq: 0
          });
        } else {
          dispatch('deleteDemo', {
            type: 'value',
            columnName: 7,
            demoCategoryType: 6,
            attributeValue: item.attributes.IndustryCode // TODO@PONY ColumnName sometimes is same THI
          });
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  },
  changeGeoType: function changeGeoType(_ref13, geoType) {
    var state = _ref13.state,
        commit = _ref13.commit;

    // @geoType int
    if (geoType !== state.GeoType) {
      // If GeoType is more area
      // if (state.GeoType === 23 && (geoType === 5 || geoType === 4 || geoType === 2 || geoType === 3)) {
      //   return
      // }
      commit('cleanGeo');
      commit('saveKey', ['GeoType', geoType]);
    }
  },
  calculatePrice: function calculatePrice(_ref14) {
    var state = _ref14.state,
        commit = _ref14.commit,
        getters = _ref14.getters;

    var order = priceHelp.updatePrice();
    commit('saveOrder', order);
  },
  getReommendOrder: function getReommendOrder(_ref15, payload) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    vue_esm["default"].http.post('PlaceOrder.aspx/GetRecSysDemosNoSession', {
      orderid: payload.orderid,
      columnname: payload.columnname
    }).then(function (resp) {
      // let demos = resp.body.d.DataSource
      commit('demo/saveKey', ['recommendDemos', resp.body.d.DataSource], { root: true });
      src_router.push({
        name: 'demo',
        params: { listType: 10 }
      });
    });
  },
  getOrderAndCount: function getOrderAndCount(_ref16, orderId) {
    var dispatch = _ref16.dispatch,
        commit = _ref16.commit;

    vue_esm["default"].http.post('PlaceOrder.aspx/GetOrder', {
      orderId: 25822
    }).then(function (resp) {
      commit('saveOrder', resp.body.d.DataSource);
      dispatch('submitOrder');
    });
  },
  updateSuppressionType: function updateSuppressionType(_ref17, item) {
    var commit = _ref17.commit,
        rootState = _ref17.rootState;

    var dict = rootState.config.suppressionTypeMap;
    var id = 0;
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = get_iterator_default()(keys_default()(dict)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var key = _step4.value;

        if (item.order === dict[key].order && item.slc === dict[key].slc && item.file === dict[key].file) {
          id = key;
          break;
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    if (item.order === 'date') {
      commit('saveKey', ['OrderSuppressions', []]);
    }
    if (item.slc === 'date') {
      commit('saveKey', ['SaveCountSuppressions', []]);
    }
    if (item.file === 'date') {
      commit('saveKey', ['CustomSuppressions', []]);
    }
    commit('saveKey', ['SuppressionType', parseInt(id)]);
  },
  changeGeoCount: function changeGeoCount(_ref18, payload) {
    var state = _ref18.state,
        commit = _ref18.commit,
        dispatch = _ref18.dispatch;

    var ordergeos = state.OrderGeos;
    var homeTotal = 0;
    var aptsTotal = 0;
    var bussTotal = 0;
    for (var i = 0; i < ordergeos.length; i++) {
      if (i === payload.index) {
        var geo = ordergeos[payload.index];
        if (payload.type === 'homes') {
          if (payload.checked) {
            geo.DesiredQtyHome = geo.AvailableQtyHome;
          } else {
            geo.DesiredQtyHome = 0;
          }
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = get_iterator_default()(geo.OrderGeoDetails), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var item = _step5.value;

              if (payload.checked) {
                item.DesiredQtyHome = item.AvailableQtyHome;
              } else {
                item.DesiredQtyHome = 0;
              }
              item.DesiredQty = item.DesiredQtyApt + item.DesiredQtyBuss + item.DesiredQtyHome;
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        } else if (payload.type === 'apts') {
          if (payload.checked) {
            geo.DesiredQtyApt = geo.AvailableQtyApt;
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = get_iterator_default()(geo.OrderGeoDetails), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _item = _step6.value;

                _item.DesiredQtyApt = _item.AvailableQtyApt;
                _item.DesiredQty = _item.DesiredQtyApt + _item.DesiredQtyBuss + _item.DesiredQtyHome;
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          } else {
            geo.DesiredQtyApt = 0;
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = get_iterator_default()(geo.OrderGeoDetails), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var _item2 = _step7.value;

                _item2.DesiredQtyApt = 0;
                _item2.DesiredQty = _item2.DesiredQtyApt + _item2.DesiredQtyBuss + _item2.DesiredQtyHome;
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          }
        } else if (payload.type === 'business') {
          if (payload.checked) {
            geo.DesiredQtyBuss = geo.AvailableQtyBuss;
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
              for (var _iterator8 = get_iterator_default()(geo.OrderGeoDetails), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var _item3 = _step8.value;

                _item3.DesiredQtyBuss = _item3.AvailableQtyBuss;
                _item3.DesiredQty = _item3.DesiredQtyApt + _item3.DesiredQtyBuss + _item3.DesiredQtyHome;
              }
            } catch (err) {
              _didIteratorError8 = true;
              _iteratorError8 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                  _iterator8.return();
                }
              } finally {
                if (_didIteratorError8) {
                  throw _iteratorError8;
                }
              }
            }
          } else {
            geo.DesiredQtyBuss = 0;
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
              for (var _iterator9 = get_iterator_default()(geo.OrderGeoDetails), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                var _item4 = _step9.value;

                _item4.DesiredQtyBuss = 0;
                _item4.DesiredQty = _item4.DesiredQtyApt + _item4.DesiredQtyBuss + _item4.DesiredQtyHome;
              }
            } catch (err) {
              _didIteratorError9 = true;
              _iteratorError9 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                  _iterator9.return();
                }
              } finally {
                if (_didIteratorError9) {
                  throw _iteratorError9;
                }
              }
            }
          }
        } else if (payload.type === 'total') {
          if (payload.checked) {
            geo.DesiredQtyHome = geo.AvailableQtyHome;
            geo.DesiredQtyApt = geo.AvailableQtyApt;
            geo.DesiredQtyBuss = geo.AvailableQtyBuss;
            geo.DesiredQty = geo.AvailableQty;
            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
              for (var _iterator10 = get_iterator_default()(geo.OrderGeoDetails), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                var _item5 = _step10.value;

                _item5.DesiredQtyHome = _item5.AvailableQtyHome;
                _item5.DesiredQtyApt = _item5.AvailableQtyApt;
                _item5.DesiredQtyBuss = _item5.AvailableQtyBuss;
                _item5.DesiredQty = _item5.AvailableQty;
              }
            } catch (err) {
              _didIteratorError10 = true;
              _iteratorError10 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                  _iterator10.return();
                }
              } finally {
                if (_didIteratorError10) {
                  throw _iteratorError10;
                }
              }
            }
          } else {
            geo.DesiredQtyHome = 0;
            geo.DesiredQtyApt = 0;
            geo.DesiredQtyBuss = 0;
            geo.DesiredQty = 0;
            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
              for (var _iterator11 = get_iterator_default()(geo.OrderGeoDetails), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                var _item6 = _step11.value;

                _item6.DesiredQtyHome = 0;
                _item6.DesiredQtyApt = 0;
                _item6.DesiredQtyBuss = 0;
                _item6.DesiredQty = 0;
              }
            } catch (err) {
              _didIteratorError11 = true;
              _iteratorError11 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                  _iterator11.return();
                }
              } finally {
                if (_didIteratorError11) {
                  throw _iteratorError11;
                }
              }
            }
          }
        }
        geo.DesiredQty = geo.DesiredQtyHome + geo.DesiredQtyApt + geo.DesiredQtyBuss;
      }
      homeTotal = homeTotal + ordergeos[i].DesiredQtyHome;
      aptsTotal = aptsTotal + ordergeos[i].DesiredQtyApt;
      bussTotal = bussTotal + ordergeos[i].DesiredQtyBuss;
    }
    commit('saveKey', ['OrderGeos', ordergeos]);
    commit('saveKey', ['DesiredQtyHome', homeTotal]);
    commit('saveKey', ['DesiredQtyApt', aptsTotal]);
    commit('saveKey', ['DesiredQtyBuss', bussTotal]);
    commit('saveKey', ['TotalDesiredQty', homeTotal + aptsTotal + bussTotal]);
    dispatch('calculatePrice');
  },
  changeZipGeoDetailCount: function changeZipGeoDetailCount(_ref19, payload) {
    var state = _ref19.state,
        commit = _ref19.commit,
        dispatch = _ref19.dispatch;

    vue_esm["default"].http.post('PlaceOrder.aspx/UpdateDesiredQtyOfOrderGeoDetails', {
      DesiredQty: Number(payload.count),
      geoDetailsIndex: payload.index,
      geoIndex: payload.rowIndex
    }).then(function (resp) {});
    var ordergeos = state.OrderGeos;
    var difference = 0;
    for (var i = 0; i < ordergeos.length; i++) {
      if (i === payload.rowIndex) {
        var geo = ordergeos[payload.rowIndex];
        for (var j = 0; j < geo.OrderGeoDetails.length; j++) {
          if (j === payload.index) {
            difference = geo.OrderGeoDetails[j].DesiredQty - payload.count;
            geo.OrderGeoDetails[j].DesiredQty = geo.OrderGeoDetails[j].DesiredQty - difference;
            geo.DesiredQty = geo.DesiredQty - difference;
          }
        }
      }
    }
    commit('saveKey', ['OrderGeos', ordergeos]);
    commit('saveKey', ['TotalDesiredQty', state.TotalDesiredQty - difference]);
    dispatch('calculatePrice');
  },
  changeGeoDetailCount: function changeGeoDetailCount(_ref20, payload) {
    var state = _ref20.state,
        commit = _ref20.commit,
        dispatch = _ref20.dispatch;

    var ordergeos = state.OrderGeos;
    var homeTotal = 0;
    var aptsTotal = 0;
    var bussTotal = 0;
    for (var i = 0; i < ordergeos.length; i++) {
      if (i === payload.rowIndex) {
        var geo = ordergeos[payload.rowIndex];
        if (payload.type === 'homes') {
          geo.DesiredQtyHome = 0;
          for (var j = 0; j < geo.OrderGeoDetails.length; j++) {
            if (j === payload.index) {
              geo.OrderGeoDetails[j].DesiredQtyHome = payload.count;
              geo.OrderGeoDetails[j].DesiredQty = geo.OrderGeoDetails[j].DesiredQtyHome + geo.OrderGeoDetails[j].DesiredQtyBuss + geo.OrderGeoDetails[j].DesiredQtyApt;
            }
            geo.DesiredQtyHome = geo.DesiredQtyHome + geo.OrderGeoDetails[j].DesiredQtyHome;
          }
        } else if (payload.type === 'apts') {
          geo.DesiredQtyApt = 0;
          for (var _j = 0; _j < geo.OrderGeoDetails.length; _j++) {
            if (_j === payload.index) {
              geo.OrderGeoDetails[_j].DesiredQtyApt = payload.count;
              geo.OrderGeoDetails[_j].DesiredQty = geo.OrderGeoDetails[_j].DesiredQtyHome + geo.OrderGeoDetails[_j].DesiredQtyBuss + geo.OrderGeoDetails[_j].DesiredQtyApt;
            }
            geo.DesiredQtyApt = geo.DesiredQtyApt + geo.OrderGeoDetails[_j].DesiredQtyApt;
          }
        } else if (payload.type === 'business') {
          geo.DesiredQtyBuss = 0;
          for (var _j2 = 0; _j2 < geo.OrderGeoDetails.length; _j2++) {
            if (_j2 === payload.index) {
              geo.OrderGeoDetails[_j2].DesiredQtyBuss = payload.count;
              geo.OrderGeoDetails[_j2].DesiredQty = geo.OrderGeoDetails[_j2].DesiredQtyHome + geo.OrderGeoDetails[_j2].DesiredQtyBuss + geo.OrderGeoDetails[_j2].DesiredQtyApt;
            }
            geo.DesiredQtyBuss = geo.DesiredQtyBuss + geo.OrderGeoDetails[_j2].DesiredQtyBuss;
          }
        } else if (payload.type === 'total') {
          geo.DesiredQtyHome = 0;
          geo.DesiredQtyApt = 0;
          geo.DesiredQtyBuss = 0;
          geo.DesiredQty = 0;
          for (var _j3 = 0; _j3 < geo.OrderGeoDetails.length; _j3++) {
            if (_j3 === payload.index) {
              if (payload.count > 0) {
                geo.OrderGeoDetails[_j3].DesiredQtyHome = geo.OrderGeoDetails[_j3].AvailableQtyHome;
                geo.OrderGeoDetails[_j3].DesiredQtyApt = geo.OrderGeoDetails[_j3].AvailableQtyApt;
                geo.OrderGeoDetails[_j3].DesiredQtyBuss = geo.OrderGeoDetails[_j3].AvailableQtyBuss;
                geo.OrderGeoDetails[_j3].DesiredQty = geo.OrderGeoDetails[_j3].AvailableQty;
              } else {
                geo.OrderGeoDetails[_j3].DesiredQtyHome = 0;
                geo.OrderGeoDetails[_j3].DesiredQtyApt = 0;
                geo.OrderGeoDetails[_j3].DesiredQtyBuss = 0;
                geo.OrderGeoDetails[_j3].DesiredQty = 0;
              }
            }
            geo.DesiredQtyHome = geo.DesiredQtyHome + geo.OrderGeoDetails[_j3].DesiredQtyHome;
            geo.DesiredQtyApt = geo.DesiredQtyApt + geo.OrderGeoDetails[_j3].DesiredQtyApt;
            geo.DesiredQtyBuss = geo.DesiredQtyBuss + geo.OrderGeoDetails[_j3].DesiredQtyBuss;
          }
        }
        geo.DesiredQty = geo.DesiredQtyHome + geo.DesiredQtyApt + geo.DesiredQtyBuss;
      }
      homeTotal = homeTotal + ordergeos[i].DesiredQtyHome;
      aptsTotal = aptsTotal + ordergeos[i].DesiredQtyApt;
      bussTotal = bussTotal + ordergeos[i].DesiredQtyBuss;
    }
    commit('saveKey', ['OrderGeos', ordergeos]);
    commit('saveKey', ['DesiredQtyHome', homeTotal]);
    commit('saveKey', ['DesiredQtyApt', aptsTotal]);
    commit('saveKey', ['DesiredQtyBuss', bussTotal]);
    commit('saveKey', ['TotalDesiredQty', homeTotal + aptsTotal + bussTotal]);
    dispatch('calculatePrice');
  },
  changeTotalCount: function changeTotalCount(_ref21, payload) {
    var state = _ref21.state,
        commit = _ref21.commit,
        dispatch = _ref21.dispatch;

    var orderGeos = state.OrderGeos;
    var value = Number(payload.totalCount);
    var maxValue = state.TotalAvailableQty;
    if (value > maxValue) {
      value = maxValue;
    }
    if (orderGeos.length < 1) {
      vue_esm["default"].http.post('PlaceOrder.aspx/RedistributeOrderTotalQty', {
        totalDesiredQty: value }).then(function (resp) {
        if (resp.body.d.ResultFlag) {
          commit('saveKey', ['TotalDesiredQty', value]);
          dispatch('calculatePrice');
        }
      });
    } else {
      var percent = value / maxValue;
      var lostValue = maxValue - value;
      var desired = void 0;
      for (var i = 0; i < orderGeos.length; i++) {
        if (orderGeos[i].OrderGeoDetails && orderGeos[i].OrderGeoDetails.length > 0) {
          orderGeos[i].DesiredQty = 0;
          for (var j = 0; j < orderGeos[i].OrderGeoDetails.length; j++) {
            desired = Math.round(orderGeos[i].OrderGeoDetails[j].AvailableQty * percent);
            orderGeos[i].OrderGeoDetails[j].DesiredQty = desired;
            orderGeos[i].DesiredQty += desired;
            lostValue = lostValue - (orderGeos[i].OrderGeoDetails[j].AvailableQty - orderGeos[i].OrderGeoDetails[j].DesiredQty);
          }
        } else {
          desired = Math.round(orderGeos[i].AvailableQty * percent);
          orderGeos[i].DesiredQty = desired;
          lostValue = lostValue - (orderGeos[i].AvailableQty - orderGeos[i].DesiredQty);
        }
      }
      // Revers the value to help calculate
      lostValue = 0 - lostValue;
      if (lostValue !== 0) {
        for (var _i = 0; _i < orderGeos.length; _i++) {
          if (orderGeos[_i].OrderGeoDetails && orderGeos[_i].OrderGeoDetails.length > 0) {
            for (var _j4 = 0; _j4 < orderGeos[_i].OrderGeoDetails.length; _j4++) {
              if (lostValue === 0) break;
              var newValue = orderGeos[_i].OrderGeoDetails[_j4].DesiredQty + lostValue;
              if (newValue < 0 || newValue > orderGeos[_i].OrderGeoDetails[_j4].AvailableQty) {
                if (orderGeos[_i].OrderGeoDetails[_j4].DesiredQty !== orderGeos[_i].OrderGeoDetails[_j4].AvailableQty) {
                  if (lostValue > 0) {
                    lostValue = lostValue - (orderGeos[_i].OrderGeoDetails[_j4].AvailableQty - orderGeos[_i].OrderGeoDetails[_j4].DesiredQty);
                    orderGeos[_i].OrderGeoDetails[_j4].DesiredQty = orderGeos[_i].OrderGeoDetails[_j4].AvailableQty;
                  } else if (lostValue < 0) {
                    lostValue = lostValue + orderGeos[_i].OrderGeoDetails[_j4].DesiredQty;
                    orderGeos[_i].OrderGeoDetails[_j4].DesiredQty = 0;
                  }
                }
              } else {
                orderGeos[_i].OrderGeoDetails[_j4].DesiredQty = newValue;
                lostValue = 0;
                break;
              }
            }
          }
        }
        // }
        // //orderGeos[index].DesiredQty = value;
        // $.each(orderGeos, function(index, value) {
        //   orderGeos[index].DesiredQty = 0;
        //   $.each(orderGeos[index].OrderGeoDetails, function(index2, value2) {
        //     orderGeos[index].DesiredQty += value2.DesiredQty
        //   })
        // })
        for (var _i2 = 0; _i2 < orderGeos.length; _i2++) {
          orderGeos[_i2].DesiredQty = 0;
          for (var _j5 = 0; _j5 < orderGeos[_i2].OrderGeoDetails.length; _j5++) {
            orderGeos[_i2].DesiredQty += orderGeos[_i2].OrderGeoDetails[_j5].DesiredQty;
          }
        }
      }
      commit('saveKey', ['OrderGeos', orderGeos]);
      commit('saveKey', ['TotalDesiredQty', value]);
      dispatch('calculatePrice');
    }
  }
});
// CONCATENATED MODULE: ./src/store/order/index.js
/**
 * Created by seaasun on 2017/12/8.
 */





/* harmony default export */ var store_order = ({
  namespaced: true,
  state: order_state,
  mutations: mutations,
  actions: actions,
  getters: order_getters
});
// CONCATENATED MODULE: ./src/store/demo/index.js



/**
 * Created by seaasun on 2017/11/24.
 */


/* harmony default export */ var store_demo = ({
  namespaced: true,
  state: {
    isInit: false,
    demoType: 1,
    demos: {},
    // items
    // {
    //   // listType
    //   10：{
    //     // demotype
    //     1: {
    //       // column
    //       columnName: {
    //         Values: [
    //         ]
    //       }
    //     }
    //   }
    // }
    selectedDemos: {}, // orderDemos
    phoneOptions: {},
    quickPicks: [],
    recommendDemos: [],
    option: [],
    SICs: [],
    hasQuickPicks: false,
    saveNewQuickPick: false
  },
  getters: {
    fullUrl: function fullUrl(state) {
      return function (name) {
        return state.root + state[name];
      };
    },
    isResidentOccupant: function isResidentOccupant(state) {
      return state.option.length > 0;
    },
    options: function options(state) {
      return state.option;
    },
    isTargetoption: function isTargetoption(state) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(state.option), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var o = _step.value;

          if (o.key === 'target') {
            return o.values.length > 0;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    isRouteoption: function isRouteoption(state) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(state.option), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var o = _step2.value;

          if (o.key === 'route') {
            return o.values.length > 0;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    },
    phoneOptions: function phoneOptions(state, getters, rootState) {
      if (rootState.order.ListType === 130) {
        return {
          1: {
            desc: 'Exclude phone numbers',
            value: 1
            // 1: {
            //   desc: 'Do not provide phone numbers',
            //   value: 1
            // },
            // 2: {
            //   desc: 'Provide phone numbers where available(approximately 6-9% will include phone numbers)',
            //   value: 2
            // },
            // 3: {
            //   desc: 'Provide only records with phone numbers (100% will include phone numbers)',
            //   value: 3
            // }
          } };
      } else {
        return state.phoneOptions;
      }
    },
    noPhoneOption: function noPhoneOption(state, getters) {
      return state.isInit && getters.phoneOptions && keys_default()(getters.phoneOptions).length === 0;
    },
    isHidePhoneOption: function isHidePhoneOption(state, getters, rootState) {
      if (rootState.order.ListType === 50) {
        return true;
      } else if (state.hasOwnProperty('hidePhoneOption')) {
        return state.hidePhoneOption;
      } else {
        return false;
      }
    },

    isBusiness: function isBusiness(state, getters, rootState) {
      var type = rootState.order.ListType;
      return [20, 90, 120, 160, 170, 180, 210, 260].indexOf(type) > -1;
    }
  },
  mutations: {
    saveDemoType: function saveDemoType(state, demoType) {
      state.demoType = demoType;
    },
    saveListType: function saveListType(state, listType) {
      if (!(listType in state.demos)) {
        vue_esm["default"].set(state.demos, listType, {});
      }
    },
    saveColumns: function saveColumns(state, payload) {
      payload = payload || {};
      var listType = payload.listType || 10;
      var demoType = payload.demoType || 1;
      var data = payload.data || {};
      if (!(listType in state.demos)) {
        vue_esm["default"].set(state.demos, listType, {});
      }
      if (!(demoType in state.demos[listType])) {
        vue_esm["default"].set(state.demos[listType], demoType, {});
      }
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var column = _step3.value;

          vue_esm["default"].set(state.demos[listType][demoType], column.ColumnName, assign_default()(column, { Values: [] }));
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    saveColumnsValues: function saveColumnsValues(state, payload) {
      payload = payload || {};
      var listType = payload.listType || 10;
      var demoType = payload.demoType || 1;
      var data = payload.data || {};
      // check list type
      if (!(listType in state.demos)) {
        vue_esm["default"].set(state.demos, listType, {});
      }
      // check demo type
      if (!(demoType in state.demos[listType])) {
        vue_esm["default"].set(state.demos[listType], demoType, {});
      }
      // Add column
      var demos = state.demos[listType][demoType];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(data), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          if (demos.hasOwnProperty(item.ColumnName)) {
            demos[item.ColumnName].Values.push(item);
          } else {
            vue_esm["default"].set(demos, item.ColumnName, {
              ColumnName: item.ColumnName,
              AttributeName: item.AttributeName,
              AttributeDesc: item.AttributeDesc,
              Values: [item]
            });
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    saveAttributes: function saveAttributes(state, payload) {
      payload = payload || {};
      var listType = payload.listType || 10;
      var demoType = payload.demoType || 1;
      var columnName = payload.columnName || '';
      var demoCategory = payload.demoCategory || 1;
      var data = payload.data || [];
      // TODO@pony need check key
      var column = state.demos[listType][demoType][columnName];
      for (var i = 0; i < data.length; i++) {
        data[i].DemoCategory = demoCategory;
      }
      column.Values = data;
    },
    deleteDemo: function deleteDemo(state, payload) {
      payload = payload || {};
      var type = payload.type || 'attribute';
      var columnName = payload.columnName;
      var attributeValue = payload.attributeValue;

      // delete column
      if (type === 'column') {
        vue_esm["default"].delete(state.selectedDemos, columnName);
      } else {
        var column = state.selectedDemos[columnName];

        // delete column if attribute.length == 1
        if (column.Values.length === 1) {
          vue_esm["default"].delete(state.selectedDemos, columnName);

          // delete attribute
        } else {
          for (var i = 0; i < column.Values.length; i++) {
            if (attributeValue === column.Values[i].AttributeValue) {
              vue_esm["default"].delete(state.selectedDemos[columnName].Values, i);
              break;
            }
          }
        }
      }
    },

    savePhoneOptions: function savePhoneOptions(state, items) {
      vue_esm["default"].set(state, 'phoneOptions', {});
      var descs = {
        '1': "I don't need phone numbers.",
        '2': "I'll take those with and without phone numbers. Only about 5% will have phone numbers.",
        '3': 'I only want leads with phone numbers.'
      };
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(items[0]), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          var val = item.SettingValue;
          var desc = descs[item.SettingValue];
          if (val === '2' && [20, 90, 120, 160, 170, 180, 210, 260].indexOf(items[1]) > -1) {
            desc = "I'll take those with and without phone numbers.";
          }
          vue_esm["default"].set(state.phoneOptions, val, {
            value: val,
            desc: desc
          });
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    saveQuickPicks: function saveQuickPicks(state, payload) {
      state.quickPicks = payload;
    },
    saveKey: function saveKey(state, val) {
      vue_esm["default"].set(state, val[0], val[1]);
    },
    setDemoAccess: function setDemoAccess(state, values) {
      state.types[values.type].access = values.val;
    },
    saveoption: function saveoption(state, payload) {
      if (state.option.length === 0) {
        state.option = [{ title: '', key: 'target', values: [] }, { title: '', key: 'route', values: [] }];
      }
      for (var i = 0; i < state.option.length; i++) {
        if (state.option[i].key === payload.key) {
          vue_esm["default"].set(state.option, i, payload);
        }
      }
    },
    removeoption: function removeoption(state, payload) {
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = get_iterator_default()(state.option), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var o = _step6.value;

          if (o.key === payload.key) {
            for (var val = 0; val < o.values.length; val++) {
              if (o.values[val] === payload.val) {
                vue_esm["default"].delete(o, val);
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    }
  },

  actions: {
    init: function init(_ref, listType) {
      var state = _ref.state,
          commit = _ref.commit;

      commit('saveKey', ['isInit', false]);

      // request demo init
      vue_esm["default"].http.post('PlaceOrder.aspx/GetDemoOptionsAndQuickPickups', {
        demotype: 2,
        listtype: listType
      }).then(function (resp) {
        commit('saveKey', ['isInit', true]);

        var data = resp.body.d.DataSource;
        // init phoneOption
        commit('savePhoneOptions', [data.PhoneOptions.AvailablePhoneOptions, listType]);
        commit('order/savePhoneOption', data.PhoneOptions.DefaultCheckedPhoneOption, { root: true });

        commit('saveKey', ['existAnicoTabs', data.ExistAnicoTabs]); // TODO@PONY doesn't find this tab
        commit('saveKey', ['existAudiencePropensity', data.ExistAudiencePropensity]);
        commit('saveKey', ['existCharitableGiving', data.ExistCharitableGiving]); // TODO@PONY there is no CharitableGiving
        commit('saveKey', ['existQuickPicks', data.ExistQuickPicks]);
        commit('saveKey', ['hidePhoneOption', data.HidePhoneOption]); // TODO@PONY need fix phone option
        commit('saveKey', ['lifeStyle', data.LifeStyle]);
        commit('saveKey', ['allHouseholdSetting', data.AllHouseholdSetting]);
        // if (!data.ExistQuickPicks) {
        //   commit('config/deleteTabType', ['quickPicks', 'demoTabs', listType], {root: true})  // need save quick pick
        // }
        commit('saveKey', ['hasQuickPicks', data.ExistQuickPicks]);
        commit('config/saveDatasourceKey', ['hasQuickPick'], { root: true });
        if (!data.ExistAudiencePropensity) {
          commit('config/deleteTabType', ['audiencePropensities', 'demoTabs', listType], { root: true });
        }
        if (data.LifeStyle.length === 0) {
          commit('config/deleteTabType', ['intrestsPurchasing', 'demoTabs', listType], { root: true });
        }
        if (data.HidePhoneOption) {
          commit('saveKey', ['hasPhoneOption', !data.HidePhoneOption]);
          var phoneOption = data.PhoneOptions.DefaultCheckedPhoneOption || 1; // TODO@PONY need check
          commit('order/saveKey', ['PhoneOption', phoneOption], { root: true });
        }
        if (data.MinQuantity > 0) {
          setTimeout(function () {
            commit('site/saveKey', ['MinQuantityOfOrder', data.MinQuantity], { root: true });
          }, 5000);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./src/store/site/state.js
/**
 * Created by seaasun on 2017/11/24.
 */
/* harmony default export */ var site_state = ({
  // root path
  termsBrief: "By placing your order, you agree to USADATA's terms and conditions of the Data Use Agreement* and acknowledge that orders with consumer Phone numbers of sensitive elements may be put on hold",
  UserImg: 'data:image/png;base64,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',
  lastGeoTab: '',
  lastDemotab: '',
  isSLC: false,
  slcCountNum: 0
});
// CONCATENATED MODULE: ./src/store/site/index.js


/**
 * Created by seaasun on 2017/11/24.
 */



/* harmony default export */ var site = ({
  namespaced: true,
  state: site_state,
  getters: {
    fullUrl: function fullUrl(state) {
      return function (name) {
        return state.root + state[name];
      };
    },
    showPromotion: function showPromotion(state) {
      var showPromotion = state.ShowPromotion || false;
      var IsUserNoPay = state.IsUserNoPay || false;
      // TODO Promotion
      return showPromotion && IsUserNoPay;
    },
    userImg: function userImg(state) {
      if (state.UserImg) {
        return state.UserImg;
      } else {
        return 'data:image/png;base64,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';
      }
    },
    enablePlaceOrder: function enablePlaceOrder(state) {
      return state.IsPlaceOrderEnabled && !state.IsUserNoPay;
    }
  },
  mutations: {
    setRootUrl: function setRootUrl(state, url) {
      state.root = url;
    },
    saveSite: function saveSite(state, values) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(keys_default()(values)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          vue_esm["default"].set(state, key, values[key]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    saveKey: function saveKey(state, val) {
      vue_esm["default"].set(state, val[0], val[1]);
    }
  },
  actions: {
    init: function init(_ref) {
      var commit = _ref.commit,
          rootState = _ref.rootState;

      vue_esm["default"].http.post('PlaceOrder.aspx/InitializeCommonJsConfiguration', {}).then(function (resp) {
        if ("production" === 'production' && resp.body.d.DataSource.User_RoleName === 'Anonymous User') {
          // TODO@PONY need check
          // window.location.href = utils.getRootPath() + '/login.aspx'
        }

        var data = resp.body.d.DataSource;
        data.User_FullName = data.User_FullName.replace('\\', '');
        commit('saveSite', data);

        if (!data.IsEnableMultiCount) {
          commit('config/deleteTabType', ['multiCount', 'geoTabs'], { root: true });
        }

        if (!data.EnableZipCodeOrCarrierRoute) {
          commit('config/deleteTabType', ['zipMap', 'geoTabs'], { root: true });
        }
        if (!data.IsMultipleAddress) {
          commit('config/deleteTabType', ['multiClosex', 'geoRadius'], { root: true });
        }
        if (!data.IsEnableMultiGeo) {
          commit('config/deleteTabType', ['moreArea', 'geoTabs'], { root: true });
        }
        if (!data.IsMultipleAddress) {
          commit('config/deleteTabType', ['acxiomZipRadius', 'geoRadius'], { root: true });
        }

        // TODO@PONY ((key == 7 || key == 19 || key == 20) && (page.global.isMyAcxiomPartnerUSite || page.global.isDatabilitiesUSite))
      });
    }
  }
});
// CONCATENATED MODULE: ./src/store/geo/index.js


/**
 * Created by seaasun on 2017/11/24.
 */





/* harmony default export */ var store_geo = ({
  namespaced: true,
  state: {
    states: {},
    isInitState: false,
    isInitCitiesByState: false,
    // [{
    //   code: 'AL',
    //   name: 'Alabama',
    //   country: 'US'
    // }]
    map: null, // google map
    mapQuery: '',
    circle: [],
    radius: 0,
    geoTypes: {
      Unknown: { Code: 0, DisplayName: 'Unknown', Description: 'Unknown' },
      Country: { Code: 1, DisplayName: 'Country', Description: 'Country' },
      State: { Code: 2, DisplayName: 'State', Description: 'State' },
      County: { Code: 3, DisplayName: 'County', Description: 'County (State)' },
      City: { Code: 4, DisplayName: 'City', Description: 'City (State)' },
      Zip: { Code: 5, DisplayName: 'Zip', Description: 'ZIP (City)' },
      Ziprange: { Code: 6, DisplayName: 'Zip Range', Description: 'ZIP Range' },
      // Radius: { Code: 7, DisplayName: 'Radius', Description: 'Radius Around Single/Multi Address(es)' },
      Radius: { Code: 7, DisplayName: 'Radius', Description: 'Radius around an Address' },
      Scf: { Code: 8, DisplayName: 'SCF', Description: 'SCF' },
      ZipUpload: { Code: 9, DisplayName: 'ZipUpload', Description: 'ZipUpload' },
      Msa: { Code: 10, DisplayName: 'MSA', Description: 'Metro Area' },
      ZipRadius: { Code: 11, DisplayName: 'Zip Radius', Description: 'Radius around ZIP' },
      // Closex: { Code: 12, DisplayName: 'Closest Records', Description: 'Closest Records Single/Multiple Address(es)' },
      Closex: { Code: 12, DisplayName: 'Closest Records', Description: 'Closest Records to an Address' },
      Polygon: { Code: 13, DisplayName: 'Polygon Map', Description: 'Polygon Map' },
      MultiRadius: { Code: 14, DisplayName: 'Multi-Radius', Description: 'Radius around Multiple Addresses' },
      MultiClosex: { Code: 15, DisplayName: 'Multi-Closest Records', Description: 'Closest Records to Multiple Addresses' },
      AcxiomMultiRadius: { Code: 16, DisplayName: 'Multi-Radius', Description: 'Multi-Radius around Address' },
      AcxiomZipRadius: { Code: 17, DisplayName: 'Multi-ZipRadius', Description: 'Multi-Radius around Zip' },
      ZipMap: { Code: 18, DisplayName: 'Zip Map', Description: 'ZIP Codes or Carrier Routes from Map' },
      NationWide: { Code: 20, DisplayName: 'NationWide', Description: 'NationWide' },
      CongressionalDistrict: { Code: 22, DisplayName: 'Congressional-District', Description: 'Congressional District' },
      MultiGeo: { Code: 23, DisplayName: 'MultiGeo', Description: 'Multi Geo' },
      MultiCount: { Code: 24, DisplayName: 'MultiCount', Description: 'Multi Count' }
    },
    zipTypes: {
      zip: {
        code: 1,
        name: 'ZIP Code'
      },
      zip4: {
        code: 2,
        name: 'ZIP+4'
      },
      cr: {
        code: 3,
        name: 'Carrier Routes'
      }
    },
    geos: [],
    alertDesc: '',
    isLoadGoogleMap: false,
    geoUnAdd: false,
    catchZipBounders: {},
    isPolygonDrawing: false
  },
  getters: {
    geoType: function geoType(state) {
      return function (id) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(keys_default()(state.geoTypes)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var item = state.geoTypes[key];
            if (item.Code === parseInt(id)) {
              return item;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return {};
      };
    }
  },
  mutations: {
    addState: function addState(state, item) {
      if (!state.states.hasOwnProperty(item.StateCode)) {
        vue_esm["default"].set(state.states, item.StateCode, {
          code: item.StateCode,
          name: item.StateName,
          country: item.CountryCode
        });
      }
    },
    saveGeos: function saveGeos(state, payload) {
      if (!(payload.geoType in state.geos)) {
        vue_esm["default"].set(state.geos, payload.geoType, {});
      }
      vue_esm["default"].set(state.geos[payload.geoType], payload.stateCode, payload.data);
    },
    saveMap: function saveMap(state, map) {
      state.map = map;
    },
    saveMapQuery: function saveMapQuery(state, query) {
      state.mapQuery = query;
    },
    saveRadius: function saveRadius(state, radius) {
      state.radius = radius;
    },
    saveCircles: function saveCircles(state, circles) {
      state.circle = circles;
    },
    saveKey: function saveKey(state, val) {
      vue_esm["default"].set(state, val[0], val[1]);
    }
  },
  actions: {
    getStates: function getStates(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      if (state.isInitState) {
        return false;
      }
      commit('saveKey', ['isInitState', true]);
      vue_esm["default"].http.post('PlaceOrder.aspx/GetStates', {}).then(function (resp) {
        var data = resp.body.d.DataSource;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            commit('addState', item);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }, function (resp) {
        commit('saveKey', ['isInitState', false]);
      });
    },
    next: function next(_ref2, isGo) {
      var state = _ref2.state,
          commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          rootGetters = _ref2.rootGetters,
          rootState = _ref2.rootState;

      store.commit('geo/saveKey', ['geoUnAdd', false]);
      commit('saveKey', ['alertDesc', '']);
      if (rootGetters['order/geos'].length > 0) {
        this.alertDesc = '';

        // Multi SLC Count
        if (rootGetters['order/currentGeoType'].isDirectCount) {
          dispatch('order/submitOrder', null, { root: true });

          // Normal
        } else if (rootGetters['order/hasDemoAndPhoneOption']) {
          dispatch('order/submitOrder', null, { root: true });

          // datasource 50
        } else if (rootGetters['order/ListType'] === 50) {
          src_router.$router.push({ name: 'demo' });
        } else {
          src_main.$root.$emit('bv::show::modal', 'geoCount');
        }
      } else {
        if (!isGo) {
          commit('saveKey', ['alertDesc', 'Please select at least one Geo Address']);
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/store/summary/index.js


/**
 * Created by seaasun on 2017/11/24.
 */


/* harmony default export */ var summary = ({
  namespaced: true,
  state: {
    isCount: false,
    getCountId: false, // TODO@PONY no need this way
    aggreAgreement: false,
    showError: false,
    ListOutputFields: [],
    SelectCols: [],
    UserPriceList: { // TODO@PONY fix
      PriceListId: 1
    },
    CalculatePriceMethod: 0
  },
  getters: {
    showError: function showError(state) {
      return state.showError;
    },
    breakdown: function breakdown(state) {
      if (state.Breakdown) {
        return state.Breakdown;
      } else {
        return {
          BreakdownUrl: '',
          Exists: false,
          Visible: false
        };
      }
    },
    rewardsPoint: function rewardsPoint(state, getters, rootState) {
      /// Caculate rewards point, refer to sl/selectRestult.js ,line 494
      var order = rootState.order;
      var point = 0;
      if (state.HasRewardsPoint && state.RewardsFromDollar !== 0 && state.RewardsToPoint !== 0) {
        point = order.TotalEstmCost / state.RewardsFromDollar * state.RewardsToPoint;
      }
      if (order.PromotionPointType !== undefined && order.PromotionPointValue > 0) {
        if (order.PromotionPointType === 4) {
          // entity.enums.PromotionType.XNUMBER_OF_POINT
          order.PromotionPoint = point * order.PromotionPointValue - point;
          point = point * order.PromotionPointValue;
        } else if (order.PromotionPointType === 5) {
          // entity.enums.PromotionType.NUMBER_OF_POINT
          order.PromotionPoint = order.PromotionPointValue;
          point = point + state.PromotionPointValue;
        }
      }

      return parseInt(point);
    },
    bonusPoint: function bonusPoint(state, getters, rootState) {
      var order = rootState.order;
      if (order.PromotionAmount > 0) {
        return parseInt((order.TotalEstmCost + order.PromotionAmount) / state.RewardsFromDollar * state.RewardsToPoint);
      } else {
        return 0;
      }
    },
    showBreakDown: function showBreakDown(state, getters, rootState, rootGetters) {
      return state.Breakdown && state.Breakdown.Exists && !rootGetters['order/currentGeoType'].hideTwoDimension && rootState.site.IsDemoBreakdownEnabled
      // !rootGetters['config/datasource'].noDemoSelect &&
      // !rootGetters['order/isAllHoseholds']
      ;
    },
    showTwoDimensional: function showTwoDimensional(state, getters, rootState, rootGetters) {
      return state.Breakdown && state.Breakdown.Exists && !rootGetters['order/currentGeoType'].hideTwoDimension
      // !rootGetters['config/datasource'].noDemoSelect &&
      // !rootGetters['order/isAllHoseholds']
      ;
    }
  },
  mutations: {
    saveAggreAgreement: function saveAggreAgreement(state, val) {
      state.aggreAgreement = val;
    },
    saveShowError: function saveShowError(state, val) {
      state.showError = val;
    },
    saveSummary: function saveSummary(state, values) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(keys_default()(values)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          vue_esm["default"].set(state, key, values[key]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    saveListOutputFields: function saveListOutputFields(state, val) {
      state.ListOutputFields = val;
    },
    saveSelectedCols: function saveSelectedCols(state, item) {
      var col = {
        text: '',
        value: '',
        disabled: false
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(keys_default()(item)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          if (col.hasOwnProperty(key)) {
            col[key] = item[key];
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(keys_default()(state.SelectCols)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _key = _step3.value;

          if (state.SelectCols[_key].value === col.value) {
            return;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      state.SelectCols.push(col);
    },
    deleteCols: function deleteCols(state, item) {
      for (var i in state.SelectCols) {
        if (state.SelectCols[i].value === item) {
          vue_esm["default"].delete(state.SelectCols, i);
        }
      }
    },
    clearCols: function clearCols(state, item) {
      var cols = [];
      for (var i in state.SelectCols) {
        if (state.SelectCols[i].disabled) {
          cols.push(state.SelectCols[i]);
        }
      }
      state.SelectCols = cols;
    },
    saveKey: function saveKey(state, val) {
      vue_esm["default"].set(state, val[0], val[1]);
    }
  },
  actions: {}
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./src/config/datasource.js
/**
 * Created by seaasun on 2018/2/7.
 *
 *  name: just name
 *  title: display in landing page
 *  Description: display in order page
 *  demoTabs:
 *   liCharitableGiving giving: 10, 190, 200
 *   businessQpHelp: ,20,90,120,160,170,210, businessQuickPicks
 *   businessTypeHeader: ,20,90,120,160,170,180,210, businessType
 *   Demographic: 10,20,30,40,50,60,70,80,90,100,110,120,130,150,160,170,180,190,200,210 demoDemographics
 *   lifeStyleHeader: 10,30,40,50,60,70,80,90,100,110,120,130,150,160,190,200, intrestsPurchasing
 *   liAudiencePropensity: 10,190,200, audiencePropensities
 *   quickPickupHeader: 10,20,30,40,50,60,70,80,90,100,110,120,130,150,160,180,190,200 quickPicks
 *   suppressionHeader: ,10,20,30,40,50,60,70,80,90,100,110,120,130,170, suppression
 *   autoSuggestionHeader: ,10,30,40,50,60,70,80,100,110,130,150,190,200, search
 *   define Target audience: ,10,20,30,40,50,60,70,80,90,100,110,120,130,150,160,170,180,190,200,210,
 */

/* harmony default export */ var config_datasource = ({
  10: {
    name: 'Consumer',
    title: 'Consumer',
    code: 10,
    Description: 'Consumer Lists/Leads',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'audiencePropensities', 'quickPicks', 'suppression', 'search'],
    // 10 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_acxiom_radius", "geo_type_msa", "geo_type_zip_map", "geo_type_nationwide", "geo_type_Congressional_District", "geo_type_multigeo", "geo_type_multicount"]
    geoTabs: ['zip', 'radius', 'county', 'polygon', 'totalUSA', 'multiCount', 'congressionalDistrict', 'metroArea', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiZip', 'multi'], // multi === contain multiple or multiZip or both
    saveQuickPick: true,
    hasRecordsWithPhone: true,
    hasBreakDown: true,
    SKU: 'CL',
    icon: 'users',
    hasOutputFields: true,
    brief: 'Reach your best prospects using the widest selection of demographic lifestyle, and purchase behavior selection options.'
  },
  20: {
    name: 'Business',
    title: 'Business',
    code: 20,
    Description: 'Business Lists/Leads',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'quickPicks', 'suppression'],
    // 20 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_nationwide", "geo_type_acxiom_radius", "geo_type_multigeo"]
    geoTabs: ['zip', 'radius', 'polygon', 'totalUSA', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'BL',
    icon: 'bank'
  },
  30: {
    name: 'HomeData',
    title: 'New Homeowners',
    code: 30,
    Description: 'New Homeowners Lists/Leads',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 30 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_closex", "geo_type_county", "geo_type_polygon", "geo_type_state", "geo_type_scf", "geo_type_multigeo", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'radius', 'polygon', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'closex', 'multipe', 'multi'],
    saveQuickPick: true,
    SKU: 'NHL',
    icon: 'home'
  },
  40: {
    name: 'NewMover',
    title: 'New Movers',
    code: 40,
    Description: 'New Movers',
    // 40 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_nationwide", "geo_type_acxiom_radius", "geo_type_multigeo"]
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    geoTabs: ['zip', 'radius', 'polygon', 'totalUSA', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'NM',
    icon: 'car',
    brief: 'Reach brand new homeowners and renters in any U.S. geographic area.'
  },
  50: {
    name: 'Occupant',
    title: 'Occupant/Saturation',
    code: 50,
    Description: 'Occupant/Saturation',
    // demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'search'],
    demoTabs: ['residentOccupantList'],
    // 50 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'city', 'county', 'radius'],
    geoRadius: ['address', 'zip'],
    geoBasedCarrierRoutes: true,
    saveQuickPick: true,
    noDemoSelect: true,
    isDemoOccupant: true,
    SKU: 'ROL',
    icon: 'location-arrow',
    brief: 'Reach all addresses in any U.S. geographic area.'
  },
  60: {
    name: 'NewHomeowner',
    title: 'New Homeowner',
    code: 60,
    Description: 'New Homeowner',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 60 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_closex", "geo_type_county", "geo_type_polygon", "geo_type_state", "geo_type_scf", "geo_type_nationwide", "geo_type_zip_map", "geo_type_multigeo", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'radius', 'polygon', 'totalUSA', 'county', 'city', 'state', 'SCFCode', 'moreArea'],
    geoRadius: ['address', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'NH',
    icon: 'building',
    brief: 'Reach brand new homeowners in any U.S. geographic area'
  },
  70: {
    name: 'Equifaxc',
    title: 'Consumer Mailing Leads',
    code: 70,
    Description: 'Consumer Mailing Lists & Sales Leads – Equifax',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 70 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_polygon", "geo_type_state", "geo_type_scf", "geo_type_multigeo", "geo_type_zip_map"]
    geoTabs: ['zip', 'radius', 'polygon', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'CML',
    icon: 'ticket'
  },
  80: {
    name: 'Experian',
    title: 'Experian',
    code: 80,
    Description: 'Consumer Lists',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 80 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_multigeo", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'radius', 'polygon', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'CL',
    icon: 'ticket'
  },
  90: {
    name: 'Compass',
    title: 'Business',
    code: 90,
    Description: 'Business',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression'],
    // 90 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_msa", "geo_type_acxiom_radius", "geo_type_multigeo"]
    geoTabs: ['zip', 'radius', 'polygon', 'metroArea', 'county', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'B',
    icon: 'compass'
  },
  100: {
    name: 'CompassCanadianConsumer',
    title: 'Canadian Consumer',
    code: 100,
    Description: 'Canadian Consumer',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 100["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_multigeo", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'radius', 'polygon', 'city', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'closex', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'CC',
    icon: 'compass'
  },
  110: {
    name: 'InfoUSAConsumer',
    title: 'InfoUSA Consumer',
    code: 110,
    Description: 'InfoUSA Consumer Lists',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression', 'search'],
    // 110["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map"]
    geoTabs: ['zip', 'radius', 'polygon', 'city', 'county', 'state', 'totalUSA', 'SCFCode'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'ICL',
    icon: 'users'
  },
  120: {
    name: 'InfoUSABusiness',
    title: 'Business',
    code: 120,
    Description: 'Business Lists',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'intrestsPurchasing', 'quickPicks', 'suppression'],
    // 120["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_zip_map", "geo_type_multigeo", "geo_type_multiradius"]
    geoTabs: ['zip', 'radius', 'polygon', 'city', 'county', 'state', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multiZip', 'multiRaius', 'multi'],
    saveQuickPick: true,
    SKU: 'BL',
    icon: 'bank'
  },
  130: {
    name: 'Valassis',
    title: 'Valassis',
    code: 130,
    Description: 'Occupant/Saturation Lists',
    demoTabs: ['demoDemographics', 'quickPicks', 'suppression', 'search'],
    // 130["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_state", "geo_type_closex", "geo_type_scf", "geo_type_polygon", "geo_type_nationwide", "geo_type_zip_map"]
    geoTabs: ['zip', 'city', 'radius', 'polygon', 'state', 'totalUSA', 'SCFCode'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'O/SL',
    icon: 'ticket'
  },
  140: {
    name: 'ResidentOccupant',
    title: 'Resident Occupant',
    code: 140,
    Description: 'Resident Occupant',
    demoTabs: ['demoDemographics'],
    // 140["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_state", "geo_type_closex"]
    geoTabs: ['zip', 'city', 'radius', 'state'],
    geoRadius: ['address', 'zip', 'closex'],
    saveQuickPick: true,
    SKU: 'RO',
    icon: 'university'
  },
  150: {
    name: 'InfoUSA_Consumer',
    title: 'InfoUSA Consumer',
    code: 150,
    Description: 'InfoUSA Consumer Lists',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'search'],
    // 150["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_polygon", "geo_type_state", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'city', 'radius', 'polygon', 'county', 'state'],
    geoRadius: ['address', 'zip', 'multipe', 'multi'],
    saveQuickPick: true,
    SKU: 'ICL',
    icon: 'users',
    isInfoUSACounty: true
  },
  160: {
    name: 'InfoUSA_Business',
    title: 'Business',
    code: 160,
    Description: 'Business Lists',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'intrestsPurchasing', 'quickPicks'],
    // 160["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_polygon", "geo_type_state", "geo_type_acxiom_radius"]
    geoTabs: ['zip', 'city', 'radius', 'polygon', 'county', 'state'],
    geoRadius: ['address', 'zip', 'multipe'],
    saveQuickPick: true,
    SKU: 'IBL',
    icon: 'bank',
    isInfoUSACounty: true,
    brief: 'Reach specific businesses in any U.S. geographic area.'
  },
  170: {
    name: 'InfoBase_BusinessList',
    title: 'Business',
    code: 170,
    Description: 'InfoBase Business List',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'suppression'],
    // 170["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_nationwide", "geo_type_zip_map"]
    geoTabs: ['zip', 'city', 'radius', 'polygon', 'county', 'state', 'totalUSA'],
    geoRadius: ['address', 'zip', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'IBL',
    icon: 'bank',
    brief: 'Pinpoint the true decision makers who need your product or service using the widest available selection criteria including business type (SIC/NAICS code), executive title, and company size.'
  },
  180: {
    name: 'InfoUSA_IDMS_Business',
    title: 'Business',
    code: 180,
    Description: 'Business List',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'businessType', 'quickPicks'],
    // 180["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_zip_map", "geo_type_multigeo", "geo_type_acxiom_radius"]
    geoTabs: ['radius', 'totalUSA', 'county', 'city', 'zip', 'state', 'moreArea'],
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'BL',
    icon: 'bank'
  },
  190: {
    name: 'Mobile_Consumer_Advertising',
    title: 'Mobile Consumer Advertising',
    code: 190,
    Description: 'Mobile Consumer Advertising',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'audiencePropensities', 'quickPicks', 'search'],
    // 190["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_acxiom_radius", "geo_type_msa", "geo_type_multiclosex", "geo_type_nationwide", "geo_type_zip_map", "geo_type_multigeo"]
    geoTabs: ['zip', 'city', 'radius', 'polygon', 'state', 'county', 'totalUSA', 'metroArea', 'SCFCode', 'moreArea'], // scf
    geoRadius: ['address', 'zip', 'closex', 'multipe', 'multiClosex', 'multi'],
    saveQuickPick: true,
    SKU: 'MC',
    icon: 'mobile'
  },
  200: {
    name: 'EmailConsumers',
    title: 'Consumer',
    code: 200,
    Description: 'Consumer Email Marketing Campaign',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'audiencePropensities', 'quickPicks', 'search'],
    // 200["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_polygon", "geo_type_county", "geo_type_zip_map", "geo_type_state", "geo_type_msa", "geo_type_nationwide", "geo_type_multigeo", "geo_type_multicount"]
    geoTabs: ['zip', 'radius', 'polygon', 'totalUSA', 'multiCount', 'metroArea', 'county', 'city', 'state', 'moreArea'],
    geoRadius: ['address', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: 'CL',
    icon: 'users'
  },
  210: {
    name: 'EmailBusinesses',
    title: 'Business',
    code: 210,
    Description: 'Business Email Marketing Campaign',
    demoTabs: ['businessQuickPicks', 'demoDemographics', 'businessType'],
    // 210["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_polygon", "geo_type_county", "geo_type_zip_map", "geo_type_state", "geo_type_msa", "geo_type_nationwide", "geo_type_multigeo", "geo_type_multicount"]
    geoTabs: ['zip', 'radius', 'polygon', 'totalUSA', 'multiCount', 'metroArea', 'county', 'city', 'state', 'moreArea'],
    geoRadius: ['address', 'multiZip', 'multi'],
    saveQuickPick: true,
    SKU: '',
    icon: 'bank'
  },
  250: {
    name: 'InfoUsaNewConsumer',
    title: 'Consumer',
    code: 250,
    Description: 'Consumer Lists/Leads',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'quickPicks', 'search'],
    geoTabs: ['zip', 'radius', 'county', 'polygon', 'congressionalDistrict', 'city', 'state', 'metroArea'], // scf
    geoRadius: ['address', 'zip', 'multipe', 'multiZip', 'multi'], // multi === contain multiple or multiZip or both
    saveQuickPick: true,
    hasRecordsWithPhone: false,
    hasBreakDown: false,
    SKU: 'CL',
    icon: 'users',
    hasOutputFields: false,
    brief: 'Reach your best prospects using the widest selection of demographic lifestyle, and purchase behavior selection options.'
  },
  260: {
    name: 'InfoUSANewBusiness',
    title: 'Business',
    code: 260,
    Description: 'Business Lists/Leads',
    demoTabs: ['businessQuickPicks', 'businessType', 'demoDemographics', 'intrestsPurchasing', 'quickPicks'],
    geoTabs: ['zip', 'radius', 'county', 'polygon', 'city', 'state', 'metroArea'], // scf
    geoRadius: ['address', 'zip', 'multipe', 'multiZip', 'multi'], // multi === contain multiple or multiZip or both
    saveQuickPick: true,
    hasRecordsWithPhone: false,
    hasBreakDown: false,
    SKU: 'CL',
    icon: 'users',
    hasOutputFields: false,
    brief: 'Reach your best prospects using the widest selection of demographic lifestyle, and purchase behavior selection options.'
  },
  270: {
    name: 'Consumer',
    title: 'Consumer',
    code: 270,
    Description: 'Consumer Lists/Leads',
    demoTabs: ['demoDemographics', 'intrestsPurchasing', 'audiencePropensities', 'quickPicks', 'suppression', 'search'],
    // 10 ["geo_type_zip", "geo_type_radius", "geo_type_city", "geo_type_zipradius", "geo_type_county", "geo_type_closex", "geo_type_state", "geo_type_polygon", "geo_type_scf", "geo_type_acxiom_radius", "geo_type_msa", "geo_type_zip_map", "geo_type_nationwide", "geo_type_Congressional_District", "geo_type_multigeo", "geo_type_multicount"]
    geoTabs: ['zip', 'radius', 'county', 'congressionalDistrict', 'metroArea', 'city', 'state'], // scf
    geoRadius: ['address', 'zip', 'multiZip'], // multi === contain multiple or multiZip or both
    saveQuickPick: false,
    hasRecordsWithPhone: false,
    hasBreakDown: false,
    SKU: 'CL',
    icon: 'users',
    hasOutputFields: true,
    brief: 'Reach your best prospects using the widest selection of demographic lifestyle, and purchase behavior selection options.'
  }
});
// CONCATENATED MODULE: ./src/config/geoType.js
/* harmony default export */ var config_geoType = ({
  unKnow: {
    code: 0,
    title: 'Unknow',
    sort: 100,
    video: ''
  },
  zip: {
    code: 5,
    title: 'ZIP',
    name: 'zip',
    sort: 1,
    isMulti: true,
    video: 'https://vimeo.com/387725028/'
  },
  city: {
    code: 4,
    title: 'City',
    name: 'city',
    sort: 6,
    isMulti: true,
    video: 'https://vimeo.com/390977369/'
  },
  state: {
    code: 2,
    title: 'State',
    name: 'state',
    sort: 7,
    isMulti: true,
    video: 'https://vimeo.com/390977352'
  },
  county: {
    code: 3,
    title: 'County',
    name: 'county',
    sort: 4,
    isMulti: true,
    video: 'https://vimeo.com/390977369/'
  },
  moreArea: {
    code: 23,
    name: 'moreArea',
    title: 'Multi Geo',
    sort: 20,
    video: ''
  },
  radius: {
    code: 16, // TODO@PONY need to fix code
    title: 'Radius',
    name: 'radius',
    sort: 2,
    video: 'https://vimeo.com/389566032/'
  },
  singleradius: {
    code: 7,
    title: 'Radius',
    name: 'singleradius'
  },
  polygon: {
    code: 13,
    title: 'Polygon',
    name: 'polygon',
    sort: 3,
    video: 'https://vimeo.com/390508169/'
  },
  totalUSA: {
    code: 20,
    title: 'Total USA',
    name: 'totalUSA',
    routeName: 'demo-demoDemographics',
    notGeo: true,
    sort: 9,
    video: ''
  },
  multiCount: {
    code: 24,
    name: 'multiCount',
    title: 'Multi Saved List Count',
    routeName: 'demo-multiCount',
    notGeo: true,
    isDirectCount: true,
    sort: 10,
    video: ''
  },
  congressionalDistrict: {
    code: 22,
    title: 'Congressional District',
    name: 'congressionalDistrict',
    sort: 11,
    video: 'https://vimeo.com/390977369'
  },
  metroArea: { // msa
    code: 10,
    title: 'Metro Area',
    name: 'metroArea',
    sort: 8,
    video: 'https://vimeo.com/390977369'
  },
  zipMap: { // UN Down
    code: 18,
    title: 'zip'
  },
  acxiomZipRadius: { // UNknow
    code: 17,
    title: 'radius',
    hideTwoDimension: true
  },
  acxiomMultiRadius: { // unknow ,just in InfoUSA_IDMS_Busines, Mobile_Consumer_Advertising
    code: 16, // 14 there is no one use 14
    title: 'radius'
  },
  multiClosex: { // unKnow, just for InfoUSABusiness, InfoUSAConsumer
    code: 15,
    title: 'close record'
  },
  Closex: {
    code: 12,
    name: 'radius',
    title: 'Closest Prospects',
    hideBreakDownIfTwoDimension: true,
    video: ''
  },
  SCFCode: {
    code: 8,
    name: 'SCFCode',
    title: 'SCF Codes',
    sort: 12,
    video: 'https://vimeo.com/390977323/'
  }
});
// CONCATENATED MODULE: ./src/config/demoType.js
/* harmony default export */ var config_demoType = ({
  demoDemographics: {
    title: 'Demographics', // datasource !== 10 or datasource !== 200 Demographic Options
    demoType: 'demoDemographics',
    access: true,
    video: 'https://vimeo.com/408422898/'
  },
  businessType: {
    title: 'Business Type',
    demoType: 'businessType',
    access: true,
    video: ''
  },
  intrestsPurchasing: {
    title: 'Interests & Purchasing',
    demoType: 'intrestsPurchasing',
    access: true,
    video: 'https://vimeo.com/408871974/'
  },
  audiencePropensities: {
    title: 'Audience Propensities',
    demoType: 'audiencePropensities',
    access: true,
    video: 'https://vimeo.com/411034266/'
  },
  quickPicks: {
    title: 'Quick Picks',
    demoType: 'quickPicks',
    access: true,
    video: ''
  },
  businessQuickPicks: {
    title: 'Business Quick Picks',
    demoType: 'businessQuickPicks',
    access: true,
    video: ''
  },
  suppression: {
    title: 'Suppression',
    demoType: 'suppression',
    access: true,
    video: 'https://vimeo.com/411103920/'
  },
  search: {
    title: 'Search',
    demoType: 'search',
    access: true,
    video: ''
  },
  residentOccupantList: {
    title: 'Resident Occupant Lists',
    demoType: 'residentOccupantList',
    access: true,
    video: ''
  }
});
// CONCATENATED MODULE: ./src/config/link.js
/* harmony default export */ var config_link = ({
  // root path
  root: '',
  // Absolute Path
  twitter: '//twitter.com/sl360',
  sl360tourVido: '//vimeo.com/305828142',
  aboutUs: '//sl360.com/about.html',
  privacy: '//sl360.com/privacy.html',
  signUp: '//sl360.com/signup.html',
  home: '//www.usadata.com',
  wmsUrl: '//dev.sl360.com/wms/GetFeature.ashx?',
  mapData: '//www.sl360.com/map/GetData.ashx',

  // Nirvana.SalesLeads.Web as the root directory
  // page
  contactUs: 'contactus.html',
  pricing: 'faq/faqs-pricing.aspx',
  rewards: 'ba/reward.aspx',
  settings: 'ba/editprofile.aspx',
  redeemPoints: 'BA/Reward.aspx',
  logOut: 'logOut.aspx',
  aggrementPDF: 'oc/OrderLicenseTermsPDF.aspx',

  // services
  orderLeads: 'MailingLists.aspx?DataSource=',
  enhanceList: 'EnhanceList.aspx',
  cleanList: 'CleanList.aspx',
  emailAppend: 'BridgeEmail.aspx',
  emailVerification: 'EmailVerification.aspx',
  phoneAppend: 'PhoneAppend.aspx',
  reverseEmailAppend: 'ReverseEmailAppend.aspx',
  phoneReverse: 'PhoneReverse.aspx',
  phoneVerification: 'PhoneVerification.aspx',
  portraitReports: 'PortraitReports.aspx',
  datauseagreement: 'Dialogs/OrderLicenseTerms.aspx',
  mysavecount: 'rpt/MySavedCount.aspx',
  history: 'rpt/myordershistory.aspx',
  enhancelist: 'EnhanceList.aspx',
  cleanlist: 'CleanList.aspx',
  portaitreports: 'PortraitReports.aspx',

  // report
  reportLookALike: 'view/Look-Alike_Report.pdf',
  reportEnhanceLookAlike: 'view/Enhanced_Look-Alike_Report-R3494587.pdf',
  reportPortrait: 'view/Portrait Report.xls',
  reportPortraitRegional: 'view/Data Portrait Analysis (DPA) Sample_AC-0448-14.xlsx',
  reportPortraitNationwide: 'view/Data Portrait Analysis (DPA) Sample_AC-0448-14.xlsx',

  // action
  getSavedCount: 'urlgateway.aspx?type=SavedCountNoEmail&sessionid=',
  getOrderMoreCountGo: 'UrlGateway.aspx?Type=2',
  sendQuote: 'Dialogs/OrderQuoteNew.aspx',
  sampleExample: 'FileOutput/reports/report-output.html',

  // iframe
  breakDown: 'OC/ShowCountBreakdown.aspx?sid=',
  DownsuppressionTempFile: 'common/downloadfile.aspx?file=~/SuppressionTemplate.xls',
  reportBreakdown: 'OC/ShowCountBreakdownAndDetailReport.aspx',

  // sendMessage
  sendMessage: 'Controller/SaveController.ashx',

  // templates
  uploadMultipleAddressTemplates: 'common/downloadfile.aspx?file=~/RadiusAroundAnAddressTemplate.xls',
  radiusQuestion: '//op.usadata.com/sl360_helper/HelpGateway.aspx?pname=Radius%20Granularity&showEdit=false',
  agreementQuestion: '//op.usadata.com/sl360_helper/HelpGateway.aspx?pname=About%20Data%20Use%20Agreement&showEdit=false'
});
// CONCATENATED MODULE: ./src/config/suppressionTypeMap.js
/**
 * Created by pony.ma@nirvana-info on .
 */
/**
 * Created by pony.ma@nirvana-info on .
 */

/* harmony default export */ var suppressionTypeMap = ({
  0: { order: false, slc: false, file: false },
  3: { order: false, slc: false, file: 'item' },
  6: { order: false, slc: false, file: 'date' },
  9: { order: false, slc: 'item', file: false },
  17: { order: false, slc: 'item', file: 'item' },
  18: { order: false, slc: 'item', file: 'date' },
  10: { order: false, slc: 'date', file: false },
  15: { order: false, slc: 'date', file: 'item' },
  16: { order: false, slc: 'date', file: 'date' },
  2: { order: 'item', slc: false, file: false },
  5: { order: 'item', slc: false, file: 'item' },
  8: { order: 'item', slc: false, file: 'date' },
  13: { order: 'item', slc: 'item', file: false },
  26: { order: 'item', slc: 'item', file: 'item' },
  24: { order: 'item', slc: 'item', file: 'date' },
  14: { order: 'item', slc: 'date', file: false },
  25: { order: 'item', slc: 'date', file: 'item' },
  23: { order: 'item', slc: 'date', file: 'date' },
  1: { order: 'date', slc: false, file: false },
  4: { order: 'date', slc: false, file: 'item' },
  7: { order: 'date', slc: false, file: 'date' },
  11: { order: 'date', slc: 'item', file: false },
  22: { order: 'date', slc: 'item', file: 'item' },
  20: { order: 'date', slc: 'item', file: 'date' },
  12: { order: 'date', slc: 'date', file: false },
  21: { order: 'date', slc: 'date', file: 'item' },
  19: { order: 'date', slc: 'date', file: 'date' }
});
// CONCATENATED MODULE: ./src/config/dev.js
/**
 * Created by pony.ma@nirvana-info on .
 */
var config = {
  isAuth: false,
  // apiName: 'local',
  apiName: 'unLogin',
  dev: true
};

if (true) {
  config.isAuth = true;
  config.apiName = 'login';
}

/* harmony default export */ var dev = (config);
// CONCATENATED MODULE: ./src/config/index.js
/**
 * Created by seaasun on 2018/2/7.
 */








/* harmony default export */ var src_config = ({
  datasource: config_datasource,
  geoType: config_geoType,
  demoType: config_demoType,
  link: config_link,
  suppressionTypeMap: suppressionTypeMap,
  order: config_order,
  dev: dev
});
// CONCATENATED MODULE: ./src/store/config/index.js









var theConfig = assign_default()({}, src_config);

/* harmony default export */ var store_config = ({
  namespaced: true,
  state: extends_default()({}, theConfig, {
    rootLink: '',
    rootDomain: '',
    allowDatasources: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 250, 260],
    allowPriceListHelp: [],
    uiVersion: 1
    // TODO@PONY use mobile UI
    // uiVersion: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? 2 : 1
  }),
  mutations: {
    setRootUrl: function setRootUrl(state, url) {
      state.rootLink = url;
      if (false) {
        state.rootDomain = '//dev.sl360.com';
      } else {
        state.rootDomain = '//' + window.document.domain;
      }
    },
    saveKey: function saveKey(state, val) {
      state[val[0]] = val[1];
    },
    deleteTabType: function deleteTabType(state, payload, rootState) {
      var type = payload[0];
      var tab = payload[1] || 'geoTabs';
      var scope = payload[2] || 'all';

      if (scope === 'all') {
        // delete all datasource
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(keys_default()(state.datasource)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var index = state.datasource[key][tab].indexOf(type);
            if (index !== -1) {
              vue_esm["default"].delete(state.datasource[key][tab], index);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        // delete current datasource
        var datasource = state.datasource[scope];
        var _index = datasource[tab].indexOf(type);
        if (_index !== -1) {
          vue_esm["default"].delete(datasource[tab], _index);
        }
      }
    },
    saveDatasourceKey: function saveDatasourceKey(state, payload) {
      // if (!rootState.order.ListType) return
      // Vue.set(state.datasource[rootState.order.ListType], payload[0], paylodad[1])
    }
  },
  getters: {
    datasource: function datasource(state, getters, rootState) {
      if (!rootState.order.ListType) {
        return {};
      }
      var datasource = assign_default()({}, state.datasource[rootState.order.ListType]);
      datasource.geoTabs = map_default()(datasource.geoTabs, function (key) {
        return state.geoType[key];
      });
      // sort moreAreo
      // if (_.findIndex(datasource.geoTabs, item => {
      //   return item.name === 'moreArea'
      // }) > -1) {
      //   datasource.geoTabs = _.map(datasource.geoTabs, item => {
      //     if (item.isMulti && item.sort < 50) {
      //       item.sort += 30
      //     }
      //     return item
      //   })
      // }
      datasource.geoTabs.sort(function (a, b) {
        return a.sort - b.sort;
      });

      datasource.demoTabs = map_default()(datasource.demoTabs, function (key) {
        return state.demoType[key];
      });
      return datasource;
    },
    link: function link(state) {
      return function (name) {
        if (state.link[name].slice(0, 2) === '//') {
          return state.link[name];
        } else {
          return state.rootLink + state.link[name];
        }
      };
    },
    checkDatasource: function checkDatasource(state) {
      return function (listType) {
        if (isNaN(listType)) return false;
        if (!src_config.dev.isAuth) return true;
        return state.allowDatasources.indexOf(parseInt(listType)) >= 0;
      };
    },
    checkDemoTab: function checkDemoTab(state, getters, rootState) {
      return function (demoType) {
        if (!rootState.order.ListType) return false;
        return state.datasource[rootState.order.ListType].demoTabs.hasOwnProperty(demoType);
      };
    },
    checkGeoTab: function checkGeoTab(state, getters, rootState) {
      return function (geoType) {
        if (!rootState.order.ListType) return false;
        return state.datasource[rootState.order.ListType].geoTabs.hasOwnProperty(geoType);
      };
    },
    wmsLink: function wmsLink(state, getters) {
      if (window.location.hostname.indexOf('dev') >= 0 || window.location.hostname === 'localhost') {
        return '//dev.sl360.com/wms/GetFeature.ashx?';
      } else {
        return '//www.sl360.com/boundaries/wms?';
      }
    },
    mapDataLink: function mapDataLink(state, getters) {
      if (window.location.hostname.indexOf('dev') >= 0 || window.location.hostname === 'localhost') {
        return '//dev.sl360.com/map/GetData.ashx?';
      } else {
        return '//www.sl360.com/map/GetData.ashx?';
      }
    }
  }
});
// CONCATENATED MODULE: ./src/store/reward/index.js


/**
 * Created by seaasun on 2017/11/24.
 */

// import utils from '@/assets/utils/index'


/* harmony default export */ var reward = ({
  namespaced: true,
  state: {
    currentCategory: 0,
    isInit: false,
    categories: [{
      Id: 0,
      Active: true,
      CategoryDesc: 'All',
      CategoryName: 'All'
    }],
    histories: [],
    point: {
      AvailablePoints: 0,
      BonusPoints: 0,
      EarnedPoints: 0,
      RedeemedPoints: 0
    },
    carts: [],
    items: {
      0: []
    }
  },
  getters: {
    cartPoint: function cartPoint(state) {
      var total = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(state.carts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          total += item.DesiredQuantity * item.PointForOne;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return total;
    },
    cartNumber: function cartNumber(state) {
      var total = 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(state.carts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          total += item.DesiredQuantity;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return total;
    }
  },
  mutations: {
    saveKey: function saveKey(state, val) {
      vue_esm["default"].set(state, val[0], val[1]);
    },
    saveItems: function saveItems(state, val) {
      vue_esm["default"].set(state.items, val[0], val[1]);
    },
    updateCart: function updateCart(state, paylod) {
      var index = findIndex_default()(state.carts, function (item) {
        return item.GiftId === paylod.Id;
      });
      if (index === -1) {
        state.carts.push({
          CategoryId: paylod.GiftCategoryId,
          DesiredQuantity: paylod.quantity,
          GiftId: paylod.Id,
          GiftName: paylod.GiftName,
          PointForOne: paylod.GiftPoint,
          image: paylod.GiftImage
        });
      } else {
        if (paylod.isUpdated) {
          state.carts[index].DesiredQuantity = paylod.quantity;
        } else {
          state.carts[index].DesiredQuantity += paylod.quantity;
        }
        if (state.carts[index].DesiredQuantity <= 0) {
          vue_esm["default"].delete(state.carts, index);
        }
      }
    }
  },
  actions: {
    init: function init(_ref) {
      var commit = _ref.commit;

      if (this.isInit) {
        return false;
      }
      vue_esm["default"].http.post('ba/Reward.aspx/GetInitReward', {
        availablePoints: 0,
        categoryId: 0,
        isDesc: false,
        onlyEligible: false,
        pageIndex: 1,
        pageSize: 100
      }).then(function (resp) {
        var data = resp.body.d.DataSource;
        commit('saveKey', ['isInit', true]);
        commit('saveKey', ['categories', data.Categories]);
        commit('saveKey', ['histories', data.Histories]);
        commit('saveKey', ['point', data.Point]);
        commit('saveItems', [0, data.RewardDetailList.Items]);
      });
    },
    getItem: function getItem(_ref2, id) {
      var commit = _ref2.commit;

      vue_esm["default"].http.post('ba/Reward.aspx/GetRewards', {
        availablePoints: 0,
        categoryId: id,
        isDesc: false,
        onlyEligible: false,
        pageIndex: 1,
        pageSize: 100
      }).then(function (resp) {
        var data = resp.body.d.DataSource;
        commit('saveItems', [id, data.Items]);
      });
    }
  }
});
// CONCATENATED MODULE: ./src/store/user/index.js

/**
 * Created by seaasun on 2017/11/24.
 */



/* harmony default export */ var store_user = ({
  namespaced: true,
  state: {
    init: {
      userPoint: false,
      recentOrder: false,
      saveOrder: false,
      userInfo: false
    },
    initUserInfo: false,
    userAddress: {
      AddrDesc: 'My Address',
      AddressType: 3,
      CityName: '',
      StateCode: '',
      ZipCode: '',
      AddressLine: '',
      AddressLine2: '',
      AddressName: '',
      CountryCode: '',
      Latitude: 0,
      longitude: 0,
      Userid: ''
    },
    userInfo: {
      AddrType: null,
      FirstName: '',
      LastName: '',
      Userid: null,
      Company: '',
      Name: '',
      UsersAddress: [{
        AddressType: 3,
        CityName: '',
        StateCode: '',
        ZipCode: '',
        AddressLine: ''
      }],
      userAddress: {
        AddrDesc: '',
        AddressType: 3,
        CityName: '',
        StateCode: '',
        ZipCode: '',
        AddressLine: '',
        AddressLine2: '',
        AddressName: '',
        CountryCode: '',
        Latitude: 0,
        longitude: 0,
        Userid: ''
      },
      userHasAddress: false,
      Email: '',
      HomePhone: '',
      UserGuid: ''
    },
    ShowVideos: false,
    UserVideos: [],
    orderDetails: {},
    recentOrder: [],
    saveOrder: [],
    accountLists: [],
    recommendedOrder: [],
    userDataSources: [{
      ListType: 10,
      Desc: 'Consumer',
      Sequence: 1
    }, {
      ListType: 170,
      Desc: 'Business',
      Sequence: 2
    }],
    userAvatar: '',
    userPoint: 0,
    accountId: false,
    userPaymentCard: {
      HolderName: '',
      CardNumber: '',
      CardType: 10,
      CVV: '',
      ExpirationMonth: null,
      ExpirationYear: null,
      Address: '',
      City: '',
      State: '',
      ZipCode: '',
      CompanyName: ''
    },
    userServiceDataSources: {
      showEmailAppend: false,
      showEmailVerification: false,
      showCleanList: false,
      showEnhanceList: false,
      showPortraitReports: false,
      showPhoneAppend: false,
      showPhoneReverse: false,
      showEmailReverse: false,
      showPhoneVerification: false
    },

    dataSources: {
      '-9': 'Phone Reverse',
      '-8': 'Phone Verification',
      '-7': 'Phone Append',
      '-6': 'EnhanceList Bundle',
      '-5': 'Email Verification',
      '-4': 'Email Append',
      '-3': 'Portrait Reports',
      '-2': 'Enhance List',
      '-1': 'Clean List',
      10: 'Consumer',
      20: 'Business',
      30: 'New Homeowner',
      40: 'New Mover',
      50: 'Occupant',
      60: 'New Homeowner',
      70: 'Equifax',
      80: 'Experian',
      90: 'Compass',
      100: 'Canadian',
      110: 'InfoUSA',
      120: 'InfoUSA',
      130: 'Valassis',
      140: 'Resident',
      150: 'InfoUSA',
      160: 'InfoUSA',
      170: 'InfoBase',
      180: 'InfoUSA',
      190: 'Mobile Campaign',
      200: 'Customer',
      210: 'Business',
      270: 'Customer'
    }
  },
  getters: {
    userInfo: function userInfo(state) {
      state.userInfo.Name = state.userInfo.FirstName || '';
      if (state.userInfo.Name) {
        state.userInfo.Name += ' ';
      }
      state.userInfo.Name += state.userInfo.LastName || '';
      return state.userInfo;
    },
    isNewUI: function isNewUI(state) {
      return state.userInfo.IsNewUI;
    },
    accountList: function accountList(state) {
      return state.accountLists;
    },
    accountId: function accountId(state) {
      return state.accountId;
    }
  },
  mutations: {
    saveKey: function saveKey(state, val) {
      vue_esm["default"].set(state, val[0], val[1]);
    },
    saveUserInit: function saveUserInit(state, val) {
      state.accountLists = val.AccountList;
      for (var i = 0; i < state.accountLists.length; i++) {
        var item = state.accountLists[i];
        if (item.IsDefault) {
          state.accountId = item.AccountId;
        }
      }
      if (val.SavedCounts.length >= 2) {
        state.saveOrder = val.SavedCounts.slice(0, 2);
      } else {
        state.saveOrder = val.SavedCounts;
      }
      state.init.saveOrder = true;
      if (val.OrderHistories.length >= 2) {
        state.recentOrder = val.OrderHistories.slice(0, 2);
      } else {
        state.recentOrder = val.OrderHistories;
      }
      state.init.recentOrder = true;

      var point = val.UserPoint;
      if (point > 0) {
        state.userPoint = point;
      } else {
        state.userPoint = 0;
      }
      state.init.userPoint = true;
      state.recommendedOrder = val.RecommendOrders;
    }
  },
  actions: {
    getUserPaymentCard: function getUserPaymentCard(_ref) {
      var commit = _ref.commit;

      vue_esm["default"].http.post('PlaceOrder.aspx/GetUserPaymentCards', {
        userId: 0
      }).then(function (resp) {
        if (resp.body.d.DataSource !== null) {
          commit('saveKey', ['userPaymentCard', resp.body.d.DataSource]);
        }
      });
    },
    getUserInit: function getUserInit(_ref2) {
      var commit = _ref2.commit;

      vue_esm["default"].http.post('LandingPage.aspx/Init', {}).then(function (resp) {
        commit('saveUserInit', resp.body.d.DataSource);
        var state = resp.body.d.DataSource;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(state.AccountList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.IsDefault) {
              commit('order/saveKey', ['AccountId', item.AccountId], { root: true });
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    getEditUserInfo: function getEditUserInfo(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit;

      vue_esm["default"].http.post('ba/EditProfile.aspx/GetInitEditProfileData', {}).then(function (resp) {
        commit('saveKey', ['initUserInfo', true]);
        var user = resp.body.d.DataSource.UserDetails;
        commit('saveKey', ['userInfo', user]);
        utils.log('login', user.Userid, user.IsNewUI, window.location.toString());

        if (!user.IsNewUI && user.Userid !== 11781) {
          window.location = '../login.aspx';
        }

        var address = state.userInfo.UsersAddress;
        var userAddress = false;
        for (var i = 0; i < address.length; i++) {
          if (state.userInfo.AddrType === address[i].AddressType) {
            userAddress = address[i];
          }
        }
        if (userAddress !== false && utils.getUrlParam('address') !== 'true') {
          commit('saveKey', ['userAddress', userAddress]);
          commit('saveKey', ['userHasAddress', true]);
        } else {
          commit('saveKey', ['userAddress', { userAddress: { Userid: state.userInfo.Userid } }]);
        }

        var showVideos = resp.body.d.DataSource.ShowVideos;
        commit('saveKey', ['ShowVideos', showVideos]);
        var userVideos = resp.body.d.DataSource.UserVideos;
        commit('saveKey', ['UserVideos', userVideos]);
      });
    }
  }
});
// CONCATENATED MODULE: ./src/store/index.js
/**
 * Created by seaasun on 2017/11/24.
 */











vue_esm["default"].use(vuex_esm["a" /* default */]);
// const debug = process.env.NODE_ENV !== 'production'

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    order: store_order,
    demo: store_demo,
    geo: store_geo,
    site: site,
    summary: summary,
    config: store_config,
    reward: reward,
    user: store_user
  }
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/MTab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MTab = ({
  props: {
    step: {
      default: 'geo'
    }
  },
  components: {},
  computed: {
    isNoDemo: function isNoDemo() {
      return this.$store.getters['order/currentGeoType'].isDirectCount && this.$store.getters['order/geos'].length !== 0;
    }
  },
  methods: {
    goDemo: function goDemo() {
      if (this.isNoDemo) {
        return false;
      }
      this.$router.push({ name: 'demo' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9760f19a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/MTab.vue
var MTab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box"},[_c('div',{staticClass:"option",class:{active: _vm.step == 'geo'},on:{"click":function($event){return _vm.$router.push({name: 'geo'})}}},[_c('b-link',{staticClass:"option-a",class:{active: _vm.step === 'geo'},attrs:{"data-test":"order-box-selectGeo"}},[_vm._v("\n         Step 1 : Select Target Area(s)\n       ")])],1),_vm._v(" "),_c('div',{staticClass:"option ",class:{active: _vm.step == 'demo', disabled: _vm.isNoDemo},on:{"click":_vm.goDemo}},[_c('b-link',{staticClass:"option-a",class:{active: _vm.step === 'demo', disabled: _vm.isNoDemo},attrs:{"data-test":"order-box-selectDemo"}},[_vm._v("\n         Step 2 : Define Target Audience\n       ")])],1)]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._t("default")],2)])}
var MTab_staticRenderFns = []
var MTab_esExports = { render: MTab_render, staticRenderFns: MTab_staticRenderFns }
/* harmony default export */ var elements_MTab = (MTab_esExports);
// CONCATENATED MODULE: ./src/components/elements/MTab.vue
function MTab_injectStyle (ssrContext) {
  __webpack_require__("oQqv")
}
var MTab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MTab___vue_template_functional__ = false
/* styles */
var MTab___vue_styles__ = MTab_injectStyle
/* scopeId */
var MTab___vue_scopeId__ = "data-v-9760f19a"
/* moduleIdentifier (server only) */
var MTab___vue_module_identifier__ = null
var MTab_Component = MTab_normalizeComponent(
  MTab,
  elements_MTab,
  MTab___vue_template_functional__,
  MTab___vue_styles__,
  MTab___vue_scopeId__,
  MTab___vue_module_identifier__
)

/* harmony default export */ var components_elements_MTab = (MTab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/M1GeoBox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var M1GeoBox = ({
  components: {
    MTab: components_elements_MTab
  },
  props: {
    geoOption: {
      type: String,
      default: 'zip'
    },
    title: {
      type: String
    },
    goNext: {
      type: Number,
      default: 0
    },
    needNext: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},

  computed: {
    datasource: function datasource() {
      return this.$store.getters['config/datasource'];
    },
    alertDesc: function alertDesc() {
      return this.$store.state.geo.alertDesc;
    },
    geoTabs: function geoTabs() {
      var result = {
        defaults: [],
        others: []
      };

      var tabs = this.datasource.geoTabs;
      if (tabs === undefined) {
        result = [];
      } else if (tabs.length <= 5) {
        result.defaults = tabs;
      } else {
        result.defaults = tabs.slice(0, 4);
        result.others = tabs.slice(4);
      }
      return result;
    },
    geoItems: function geoItems() {
      return this.$store.getters['order/geoItems'];
    },
    hasDemoAndPhoneOption: function hasDemoAndPhoneOption() {
      return this.$store.getters['order/hasDemoAndPhoneOption'];
    },
    hasDemo: function hasDemo() {
      return this.$store.getters['order/hasDemo'];
    },
    nextDesc: function nextDesc() {
      if (this.hasDemoAndPhoneOption) {
        return 'Poll Count';
      } else {
        return 'Select Audience';
      }
    },
    listType: function listType() {
      return this.$store.state.order.ListType;
    },
    nextDisabled: function nextDisabled() {
      if (this.$store.state.order.CurrentStep === 'count') {
        return true;
      }

      if (this.$store.state.order.GeoType === 24 && this.geoItems.length < 2) {
        return true;
      }

      if (this.$store.state.order.GeoType === 5 && this.$route.name === 'geo-moreArea' || this.$route.name === 'geo-zip' || this.$route.name === 'geo-SCFCode') {
        return false;
      }
      if (this.geoItems.length === 0 && this.$store.state.order.OrderAddresses.length === 0) {
        return true;
      }
      return false;
    },
    otherText: function otherText() {
      var _this = this;

      var index = lodash_default.a.findIndex(this.geoTabs.others, function (item) {
        return item.name === _this.geoOption;
      });
      if (index !== -1) {
        return this.geoTabs.others[index].title;
      } else {
        return 'Others';
      }
    },
    otherVideo: function otherVideo() {
      var _this2 = this;

      var index = lodash_default.a.findIndex(this.geoTabs.others, function (item) {
        return item.name === _this2.geoOption;
      });
      if (index !== -1) {
        return this.geoTabs.others[index].video;
      } else {
        return '';
      }
    }
  },
  methods: {
    preNext: function preNext() {
      if (this.needNext) {
        this.$emit('go');
      } else {
        this.$store.dispatch('geo/next');
      }
    },
    goBack: function goBack() {
      this.$router.push({ name: 'landing' });
    },
    tabtargt: function tabtargt(item) {
      if (item.routeName) {
        this.$store.dispatch('order/changeGeoType', item.code);
        if (item.code === 20) {
          this.$store.commit('order/addGeo', {
            GeoKeyCode: '1',
            GeoKeyDesc: 'NATIONWIDE',
            GeoType: item.code
          });
        }
        this.$router.push({ name: item.routeName });
      } else {
        this.$router.push({ name: 'geo-' + item.name });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08b5835c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/M1GeoBox.vue
var M1GeoBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-tab',[_c('b-row',{staticClass:"top-row"},[_c('b-col',[_c('div',{staticClass:"m-tab-top-box"},[_vm._v("Choose the type of geographic area you wish to use to target your prospects\n      ")])]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"top-btn"},[_c('b-btn',{on:{"click":_vm.goBack}},[_vm._v("Back")]),_vm._v(" "),_c('div',{staticClass:"next-box"},[_c('b-btn',{attrs:{"variant":"primary","data-test":"geo-next","disabled":_vm.nextDisabled},on:{"click":_vm.preNext}},[_vm._v("Next")])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"m-tabs"},[_vm._l((_vm.geoTabs.defaults),function(item){return _c('div',{key:item.name,staticClass:"m-tab",class:{'m-tab-active': item.name === _vm.geoOption}},[_c('b-link',{key:item.name,style:({'margin-right': (item.video !== '' ? '2%' : '0' )}),on:{"click":function($event){return _vm.tabtargt(item)}}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")]),_vm._v(" "),(item.video !== '')?_c('a',{staticStyle:{"display":"flex"},attrs:{"data-fancybox":"","href":item.video}},[_c('img',{attrs:{"src":__webpack_require__("aQR6"),"alt":"Video"}})]):_vm._e()],1)}),_vm._v(" "),_c('div',{staticClass:"m-tab other-tab",class:{'m-tab-active': _vm.otherText !== 'Others'}},[(_vm.geoTabs.others.length > 0)?_c('b-dropdown',{attrs:{"variant":"link","text":_vm.otherText,"data-test":"geo-box-other","right":""}},_vm._l((_vm.geoTabs.others),function(item){return _c('b-dropdown-item',{key:item.name,on:{"click":function($event){return _vm.tabtargt(item)}}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")])}),1):_vm._e(),_vm._v(" "),(_vm.otherVideo !== '')?_c('a',{staticStyle:{"display":"flex"},attrs:{"data-fancybox":"","href":_vm.otherVideo}},[_c('img',{attrs:{"src":__webpack_require__("aQR6"),"alt":"Video"}})]):_vm._e()],1)],2),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"geo-box"},[_c('b-col',[_vm._t("default")],2)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-alert',{attrs:{"show":_vm.alertDesc!=='',"variant":"warning"}},[_vm._v(_vm._s(_vm.alertDesc))])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-box-bottom"},[_c('div',{staticClass:"bootom-btn"},[_c('b-btn',{on:{"click":_vm.goBack}},[_vm._v("Back")]),_vm._v(" "),_c('div',{staticClass:"next-box"},[_c('b-btn',{attrs:{"variant":"primary","data-test":"geo-next","disabled":_vm.nextDisabled},on:{"click":_vm.preNext}},[_vm._v("Next")])],1)],1),_vm._v(" "),(_vm.datasource.geoBasedCarrierRoutes)?_c('span',[_vm._v("\n          * Based on postal carrier routes\n        ")]):_vm._e()])],1)],1)}
var M1GeoBox_staticRenderFns = []
var M1GeoBox_esExports = { render: M1GeoBox_render, staticRenderFns: M1GeoBox_staticRenderFns }
/* harmony default export */ var geo_M1GeoBox = (M1GeoBox_esExports);
// CONCATENATED MODULE: ./src/components/geo/M1GeoBox.vue
function M1GeoBox_injectStyle (ssrContext) {
  __webpack_require__("AgSV")
  __webpack_require__("F9MN")
}
var M1GeoBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var M1GeoBox___vue_template_functional__ = false
/* styles */
var M1GeoBox___vue_styles__ = M1GeoBox_injectStyle
/* scopeId */
var M1GeoBox___vue_scopeId__ = "data-v-08b5835c"
/* moduleIdentifier (server only) */
var M1GeoBox___vue_module_identifier__ = null
var M1GeoBox_Component = M1GeoBox_normalizeComponent(
  M1GeoBox,
  geo_M1GeoBox,
  M1GeoBox___vue_template_functional__,
  M1GeoBox___vue_styles__,
  M1GeoBox___vue_scopeId__,
  M1GeoBox___vue_module_identifier__
)

/* harmony default export */ var components_geo_M1GeoBox = (M1GeoBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/MGeoSelect.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MGeoSelect = ({
  props: {
    geoType: {
      type: Number,
      default: 1
    },
    changeGeoType: {
      type: Number,
      default: 1
    }
  },
  components: {},
  data: function data() {
    return {
      selectedState: 'AL',
      selectedSubtitle: [],
      unSelectedGeos: []
    };
  },

  computed: {
    listType: function listType() {
      return this.$store.state.order.ListType;
    },
    geos: function geos() {
      return this.$store.state.geo.geos;
    },
    selectedGeos: function selectedGeos() {
      return lodash_default.a.filter(this.$store.getters['order/geoItems'], { GeoType: this.geoType });
    },
    state: function state() {
      return this.$store.state.geo.states;
    },
    substate: function substate() {
      if (this.selectedState !== '') {
        if (!(this.geoType in this.geos) || !(this.selectedState in this.geos[this.geoType]) || this.geos[this.geoType][this.selectedState].length === 0) {
          this.getGeos();
          return [];
        } else {
          return this.geos[this.geoType][this.selectedState];
        }
      } else {
        return [];
      }
    },
    subTitle: function subTitle() {
      if (this.geoType === 3) {
        return 'Choose Counties:';
      }
      if (this.geoType === 10) {
        return 'Choose Area(s):';
      }
      if (this.geoType === 22) {
        return 'Choose District(s):';
      }
      if (this.geoType === 4) {
        return 'Choose Cities:';
      }
    },
    datasource: function datasource() {
      return this.$store.getters['config/datasource'];
    }
  },
  created: function created() {
    this.$store.dispatch('geo/getStates');
  },

  methods: {
    getGeos: function getGeos() {
      var _this = this;

      if (this.geoType === 3) {
        this.$http.post('PlaceOrder.aspx/GetCountiesByState', {
          statecode: this.selectedState
        }).then(function (resp) {
          var data = resp.body.d.DataSource;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = get_iterator_default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              item.GeoKeyCode = item.CountyCode;
              item.GeoKeyDesc = item.CountyName + '(' + item.StateCode + ')';
              item.text = item.CountyName;
              item.ConutryCode = 'US';
              if (_this.datasource.isInfoUSACounty) {
                item.CountyFips = item.CountyName + '_' + _this.selectedState;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.commitData(data);
        });
      } else if (this.geoType === 10) {
        this.$http.post('PlaceOrder.aspx/SearchAreas', {
          state: this.selectedState,
          listType: this.listType
        }).then(function (resp) {
          var data = resp.body.d.DataSource;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              item.GeoKeyCode = item.Code;
              item.GeoKeyDesc = item.DisplayName + '(' + _this.selectedState + ')';
              item.text = item.DisplayName;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          _this.commitData(data);
        });
      } else if (this.geoType === 22) {
        this.$http.post('PlaceOrder.aspx/GetDistrictsByState', {
          statecode: this.selectedState
        }).then(function (resp) {
          var data = resp.body.d.DataSource;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = get_iterator_default()(data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var item = _step3.value;

              item.GeoKeyCode = item.Code;
              item.CityName = item.Name;
              item.GeoKeyDesc = item.Name + '(' + _this.selectedState + ')';
              item.text = item.Name;
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          _this.commitData(data);
        });
      } else if (this.geoType === 4) {
        if (this.$store.state.geo.isInitCitiesByState) {
          return false;
        }
        this.$store.commit('geo/saveKey', ['isInitCitiesByState', true]);
        this.$http.post('PlaceOrder.aspx/GetCitiesByState', {
          statecode: this.selectedState
        }).then(function (resp) {
          var data = resp.body.d.DataSource;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = get_iterator_default()(data), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var item = _step4.value;

              item.GeoKeyCode = item.CityName + ':' + item.StateCode;
              item.GeoKeyDesc = item.CityName + '(' + _this.selectedState + ')';
              item.text = item.CityName;
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          _this.commitData(data);
          _this.$store.commit('geo/saveKey', ['isInitCitiesByState', false]);
        }, function (resp) {
          _this.$store.commit('geo/saveKey', ['isInitCitiesByState', false]);
        });
      }
    },
    addGeos: function addGeos() {
      this.$store.dispatch('order/changeGeoType', this.changeGeoType);
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.selectedSubtitle), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          item.GeoType = this.geoType;
          this.$store.commit('order/addGeo', item);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    cleanGeos: function cleanGeos() {
      this.$store.commit('order/cleanGeo', this.geoType);
    },
    deleteGeos: function deleteGeos() {
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = get_iterator_default()(this.unSelectedGeos), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var item = _step6.value;

          this.$store.commit('order/deleteGeo', item);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    },
    commitData: function commitData(data) {
      this.$store.commit('geo/saveGeos', {
        geoType: this.geoType,
        stateCode: this.selectedState,
        data: data
      });
    }
  },
  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485a2116","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MGeoSelect.vue
var MGeoSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"m-text-deep"},[_c('b-col',{attrs:{"md":"5"}},[_c('h4',{staticClass:"mt-2"},[_vm._v("Choose State: ")]),_vm._v(" "),_c('b-select',{staticClass:"ttt",attrs:{"data-test":"geo-select-state"},model:{value:(_vm.selectedState),callback:function ($$v) {_vm.selectedState=$$v},expression:"selectedState"}},_vm._l((_vm.state),function(item){return _c('option',{domProps:{"value":item.code}},[_vm._v("\n            "+_vm._s(item.name))])}),0),_vm._v(" "),_c('h4',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.subTitle))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.substate.length === 0),expression:"substate.length === 0"}],staticClass:"m-select-spinner"},[_c('div',{staticClass:"m-spinner "})]),_vm._v(" "),_c('b-select',{staticClass:"demo-select",attrs:{"multiple":"","select-size":11,"data-test":"geo-select-subState"},model:{value:(_vm.selectedSubtitle),callback:function ($$v) {_vm.selectedSubtitle=$$v},expression:"selectedSubtitle"}},_vm._l((_vm.substate),function(item){return _c('option',{domProps:{"value":item}},[_vm._v("\n            "+_vm._s(item.text))])}),0)],1),_vm._v(" "),_c('b-col',{staticClass:"m-select-btn-box",attrs:{"md":"2"}},[_c('b-btn',{staticClass:"m-select-btn",staticStyle:{"margin-top":"16px"},attrs:{"data-test":"geo-select-add","size":"sm"},on:{"click":function($event){return _vm.addGeos()}}},[_vm._v("\n          Add")]),_vm._v(" "),_c('b-btn',{staticClass:"m-select-btn",attrs:{"data-test":"geo-select-remove","size":"sm"},on:{"click":function($event){return _vm.deleteGeos()}}},[_vm._v("\n          Remove")]),_vm._v(" "),_c('b-btn',{staticClass:"m-select-btn",attrs:{"data-test":"geo-select-removeAll","size":"sm"},on:{"click":function($event){return _vm.cleanGeos()}}},[_vm._v("\n          Remove All")])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5","rows":"2"}},[_c('h4',{staticClass:"mt-2"},[_vm._v("Your Target Audience:")]),_vm._v(" "),_c('b-select',{staticClass:"demo-select",attrs:{"select-size":16,"multiple":""},model:{value:(_vm.unSelectedGeos),callback:function ($$v) {_vm.unSelectedGeos=$$v},expression:"unSelectedGeos"}},_vm._l((_vm.selectedGeos),function(item){return _c('option',{staticClass:"demos-value",class:{'demos-column':item.type === 'column' },domProps:{"value":item.GeoKeyCode}},[_vm._v("\n            "+_vm._s(item.GeoKeyDesc)+"\n          ")])}),0)],1)],1)],1)],1)}
var MGeoSelect_staticRenderFns = []
var MGeoSelect_esExports = { render: MGeoSelect_render, staticRenderFns: MGeoSelect_staticRenderFns }
/* harmony default export */ var geo_MGeoSelect = (MGeoSelect_esExports);
// CONCATENATED MODULE: ./src/components/geo/MGeoSelect.vue
function MGeoSelect_injectStyle (ssrContext) {
  __webpack_require__("omJa")
}
var MGeoSelect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MGeoSelect___vue_template_functional__ = false
/* styles */
var MGeoSelect___vue_styles__ = MGeoSelect_injectStyle
/* scopeId */
var MGeoSelect___vue_scopeId__ = "data-v-485a2116"
/* moduleIdentifier (server only) */
var MGeoSelect___vue_module_identifier__ = null
var MGeoSelect_Component = MGeoSelect_normalizeComponent(
  MGeoSelect,
  geo_MGeoSelect,
  MGeoSelect___vue_template_functional__,
  MGeoSelect___vue_styles__,
  MGeoSelect___vue_scopeId__,
  MGeoSelect___vue_module_identifier__
)

/* harmony default export */ var components_geo_MGeoSelect = (MGeoSelect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/M2GeoBox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var M2GeoBox = ({
  components: {
    MGeoSelect: components_geo_MGeoSelect
  },
  props: {
    geoOption: {
      type: String,
      default: 'zip'
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    datasource: function datasource() {
      return this.$store.getters['config/datasource'];
    },
    geoTabs: function geoTabs() {
      return this.datasource.geoTabs;
    }
  },
  activated: function activated() {
    var _this = this;

    setTimeout(function () {
      _this.$scrollTo('#geo-tab-' + _this.geoOption, 1, { x: true, y: false, container: '.m-scroll-v', duration: 1 });
    }, 100);
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      _this2.$scrollTo('#geo-tab-' + _this2.geoOption, 1, { x: true, y: false, container: '.m-scroll-v', duration: 1 });
    }, 100);
  },

  methods: {
    go: function go(item) {
      if (item.routeName) {
        this.$store.dispatch('order/changeGeoType', item.code);
        if (item.code === 20) {
          this.$store.commit('order/addGeo', {
            GeoKeyCode: '1',
            GeoKeyDesc: 'NATIONWIDE',
            GeoType: item.code
          });
        }
        this.$router.push({ name: 'order' });
      } else {
        this.$router.push({ name: 'geo-' + item.name });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfb14f0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/M2GeoBox.vue
var M2GeoBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-dialog',{attrs:{"page":"","name":"geo","title":"Select Geographic"},on:{"close":function($event){return _vm.$router.push({name: 'order'})}}},[_c('div',{staticClass:"m-scroll-v",attrs:{"slot":"menu"},slot:"menu"},_vm._l((_vm.geoTabs),function(item){return _c('b-link',{key:item.name,staticClass:"m-scroll-v-tab",class:{'m-scroll-v-tab-active': item.name === _vm.geoOption},attrs:{"id":'geo-tab-' + item.name},on:{"click":function($event){return _vm.go(item)}}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])}),1),_vm._v(" "),_c('m-box',[_vm._t("default")],2),_vm._v(" "),_c('b-btn',{staticStyle:{"margin-left":"8px"},attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$router.push({name: 'order'})}}},[_vm._v("Done")])],1)}
var M2GeoBox_staticRenderFns = []
var M2GeoBox_esExports = { render: M2GeoBox_render, staticRenderFns: M2GeoBox_staticRenderFns }
/* harmony default export */ var geo_M2GeoBox = (M2GeoBox_esExports);
// CONCATENATED MODULE: ./src/components/geo/M2GeoBox.vue
function M2GeoBox_injectStyle (ssrContext) {
  __webpack_require__("qna0")
}
var M2GeoBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var M2GeoBox___vue_template_functional__ = false
/* styles */
var M2GeoBox___vue_styles__ = M2GeoBox_injectStyle
/* scopeId */
var M2GeoBox___vue_scopeId__ = "data-v-dfb14f0c"
/* moduleIdentifier (server only) */
var M2GeoBox___vue_module_identifier__ = null
var M2GeoBox_Component = M2GeoBox_normalizeComponent(
  M2GeoBox,
  geo_M2GeoBox,
  M2GeoBox___vue_template_functional__,
  M2GeoBox___vue_styles__,
  M2GeoBox___vue_scopeId__,
  M2GeoBox___vue_module_identifier__
)

/* harmony default export */ var components_geo_M2GeoBox = (M2GeoBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/MGeoBox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MGeoBox = ({
  components: {
    M1GeoBox: components_geo_M1GeoBox,
    M2GeoBox: components_geo_M2GeoBox
  },
  props: {
    geoOption: {
      type: String,
      default: ''
    },
    title: {
      type: String
    },
    goNext: {
      type: Number,
      default: 0
    },
    needNext: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    uiVersion: function uiVersion() {
      return this.$store.state.config.uiVersion;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73b25cdb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MGeoBox.vue
var MGeoBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.uiVersion === 1)?_c('m1-geo-box',{attrs:{"geoOption":_vm.geoOption,"title":_vm.title,"goNext":_vm.goNext,"needNext":_vm.needNext},on:{"go":function($event){return _vm.$emit('go')}}},[_vm._t("default"),_vm._v(" "),_c('template',{slot:"button-content"},[_vm._t("button-content")],2)],2):_vm._e(),_vm._v(" "),(_vm.uiVersion === 2)?_c('m2-geo-box',{attrs:{"geoOption":_vm.geoOption}},[_vm._t("default")],2):_vm._e()],1)}
var MGeoBox_staticRenderFns = []
var MGeoBox_esExports = { render: MGeoBox_render, staticRenderFns: MGeoBox_staticRenderFns }
/* harmony default export */ var geo_MGeoBox = (MGeoBox_esExports);
// CONCATENATED MODULE: ./src/components/geo/MGeoBox.vue
function MGeoBox_injectStyle (ssrContext) {
  __webpack_require__("tvcE")
}
var MGeoBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MGeoBox___vue_template_functional__ = false
/* styles */
var MGeoBox___vue_styles__ = MGeoBox_injectStyle
/* scopeId */
var MGeoBox___vue_scopeId__ = "data-v-73b25cdb"
/* moduleIdentifier (server only) */
var MGeoBox___vue_module_identifier__ = null
var MGeoBox_Component = MGeoBox_normalizeComponent(
  MGeoBox,
  geo_MGeoBox,
  MGeoBox___vue_template_functional__,
  MGeoBox___vue_styles__,
  MGeoBox___vue_scopeId__,
  MGeoBox___vue_module_identifier__
)

/* harmony default export */ var components_geo_MGeoBox = (MGeoBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/MMap.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MMap = ({
  components: {},
  props: {
    mapId: {
      type: String
    },
    options: { // init option
      type: Object,
      default: function _default() {
        return { // total usa map
          zoom: 4,
          center: {
            lat: 37.1,
            lng: -95.7
          },
          fullscreenControl: false
        };
      }
    },
    textSearchRequest: {
      type: Object,
      default: function _default() {
        return {
          query: ''
        };
      }
    }
  },
  computed: {},
  data: function data() {
    return {
      map: null,
      fullScreen: false
    };
  },

  methods: {
    createMap: function createMap() {
      utils.createMap(this.mapId, this.options);
      this.map = utils.maps[this.mapId];
      this.$emit('load');
    },
    toggleFullScreen: function toggleFullScreen() {
      this.fullScreen = !this.fullScreen;
      this.$emit('full-screen', this.fullScreen);
    }
  },
  mounted: function mounted() {
    if (this.$store.state.geo.isLoadGoogleMap) {
      this.createMap();
    } else {
      this.$store.commit('geo/saveKey', ['isLoadGoogleMap', true]);

      var url = '//maps.google.com/maps/api/js?libraries=places,geometry,drawing';
      if (window.first.env === 'local' || window.first.env === 'dev') {
        url += '&client=gme-usadata&channel=salesleads360_staging';
      } else {
        url += '&client=gme-usadata&channel=salesleads360_prod';
      }
      utils.loadJs(url, this.createMap);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7f0bb34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MMap.vue
var MMap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{class:{'full-screen-btn': _vm.fullScreen},attrs:{"id":"full-btn"},on:{"click":_vm.toggleFullScreen}},[_c('icon',{attrs:{"name":_vm.fullScreen ? 'compress' : 'expand'}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.map),expression:"map"}],staticClass:"map",class:{'full-screen': _vm.fullScreen},attrs:{"id":_vm.mapId}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.map),expression:"!map"}],staticClass:"map map-box"},[_c('div',{staticClass:"m-spinner"})])])}
var MMap_staticRenderFns = []
var MMap_esExports = { render: MMap_render, staticRenderFns: MMap_staticRenderFns }
/* harmony default export */ var geo_MMap = (MMap_esExports);
// CONCATENATED MODULE: ./src/components/geo/MMap.vue
function MMap_injectStyle (ssrContext) {
  __webpack_require__("F2Zz")
}
var MMap_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MMap___vue_template_functional__ = false
/* styles */
var MMap___vue_styles__ = MMap_injectStyle
/* scopeId */
var MMap___vue_scopeId__ = "data-v-f7f0bb34"
/* moduleIdentifier (server only) */
var MMap___vue_module_identifier__ = null
var MMap_Component = MMap_normalizeComponent(
  MMap,
  geo_MMap,
  MMap___vue_template_functional__,
  MMap___vue_styles__,
  MMap___vue_scopeId__,
  MMap___vue_module_identifier__
)

/* harmony default export */ var components_geo_MMap = (MMap_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/MGeoZipMap.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var MGeoZipMap = ({
  name: 'MGeoZipMap',
  components: {
    MGeoBox: components_geo_MGeoBox,
    MMap: components_geo_MMap
  },
  props: {
    geoType: {
      type: Number
    },
    changeGeoType: {
      type: Number,
      default: 5
    },
    pastZipType: {
      type: String,
      default: 0
    }
  },
  data: function data() {
    return {
      map: null,
      radius: '',
      address: '',
      circle: null,
      alertDesc: '',
      geoSlcFitFinish: false,
      fullScreen: false,
      mark: null,
      please: null
    };
  },

  computed: {
    orderGeos: function orderGeos() {
      return this.$store.getters['order/geoItems'];
    },
    order: function order() {
      return this.$store.state.order;
    }
  },
  activated: function activated() {
    this.updateMap();
    if (this.order.GeoType === 5 && this.map) {
      this.map.fitZipBounder();
    }
  },

  watch: {
    orderGeos: function orderGeos() {
      this.updateMap();
    }
  },
  methods: {
    createMap: function createMap() {
      var _this = this;

      this.map = utils.maps['mapZip'];
      this.map.addLayer('ZIP', '', true);
      this.map.startSelect(this.changeGeoType);
      this.map.startPolygonAutocomplete('mapZipInput', function () {
        _this.place = _this.map.autocomplete.getPlace();
        if (_this.radius === '') {
          _this.markMap();
        } else {
          _this.search();
        }
      });
      setTimeout(this.updateMap, 1);
    },
    markMap: function markMap() {
      if (this.mark) {
        this.mark.setMap(null);
      }
      this.map.map.setZoom(12);
      this.map.map.panTo(this.place.geometry.location);
      this.mark = this.map.marker(this.place.geometry.location);
    },
    search: function search() {
      var _this2 = this;

      if (this.pastZipType !== 'zip') {
        this.$store.commit('order/cleanGeo');
        this.$store.commit('order/saveKey', ['ZipType', 0]);
      }

      this.alertDesc = '';
      if (this.address.length === 0) {
        this.alertDesc = 'Please enter ZIP Code or address';
        return;
      }

      var radius = this.radius;
      if (radius === null || radius === '') {
        this.addressChange(this.address);
        return;
      } else if (isNaN(radius)) {
        this.alertDesc = 'radius must be a number';
        return;
      }
      if (this.mark) {
        this.mark.setMap(null);
      }
      this.map.textSearch(this.address, function (resp) {
        if (resp.placesresult !== null) {
          _this2.$store.dispatch('order/changeGeoType', _this2.changeGeoType);
          _this2.$store.commit('order/cleanGeo');
          _this2.map.clearSelecteBounder();
          if (_this2.circle) {
            _this2.circle.setMap(null);
          }
          var lng = resp.placesresult.geometry.location.lng();
          var lat = resp.placesresult.geometry.location.lat();
          _this2.circle = _this2.map.drawCircle(lng, lat, _this2.radius);
          _this2.map.getRadioBounders(lng, lat, _this2.radius, true);
        } else {
          _this2.alertDesc = 'No results found for address';
        }
      }, true);
    },
    updateMap: function updateMap() {
      // Avoid update map in other page
      if (this.$route.name !== 'geo-zip') {
        return;
      }
      if (!this.map) {
        return;
      }
      // add zip bounder in map
      if (this.order.GeoType === 5) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(this.$store.getters['order/geoItems']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var geo = _step.value;

            if (geo.GeoType === 5) {
              var isExist = false;
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = get_iterator_default()(keys_default()(this.map.loadPolygons)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var code = _step2.value;

                  if (geo.GeoKeyCode === code) {
                    isExist = true;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              if (!isExist) {
                this.map.getZipBounder(geo.GeoKeyCode, true, true);
              } else {
                if (this.map.loadPolygons[geo.GeoKeyCode]) {
                  // TODO@PONY here are some error about array index
                  this.map.loadPolygons[geo.GeoKeyCode][0].setOptions({
                    strokeOpacity: 0.8,
                    fillOpacity: 0.2
                  });
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      // delete zip bounder in map
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(keys_default()(this.map.loadPolygons)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _code = _step3.value;

          if (!this.$store.getters['order/hasGeoItem'](_code)) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = get_iterator_default()(this.map.loadPolygons[_code]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var item = _step4.value;

                item.setOptions({
                  strokeOpacity: 0,
                  fillOpacity: 0
                });
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
          this.map.updateZipBounders();
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    toggleFullScreen: function toggleFullScreen(val) {
      this.fullScreen = val;
    },
    addressChange: function addressChange(val) {
      var _this3 = this;

      this.alertDesc = '';
      if (this.radius === '') {
        this.$store.commit('geo/saveKey', ['geoUnAdd', 'radius']);
        this.map.textSearch(val, function (resp) {
          if (resp.placesresult !== null) {
            _this3.place = resp.placesresult;
            _this3.markMap();
          } else {
            _this3.alertDesc = 'No results found for address';
          }
        }, true);
      } else {
        this.search();
      }
    },
    radiusChange: function radiusChange() {
      if (this.address !== '' && this.radius !== '') {
        this.search();
      } else {
        this.alertDesc = 'Radius is required!';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8ff748","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MGeoZipMap.vue
var MGeoZipMap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"row"},[_c('b-col',[_vm._v("To select your target areas by zip code from the map, please enter in the box below a zip code or address, choose a radius (in miles) in the box next to it and click ADD.  We will then present to you a map with zip codes fitting the area and radius that you provided.  Click on the map in order to select or de-select zip codes.")])],1),_vm._v(" "),_c('div',{class:{'map-full-screen-input': _vm.fullScreen}},[_c('b-row',[_c('b-col',{staticStyle:{"padding-left":"0px"},attrs:{"md":"5","sm":"12"}},[_c('b-form-input',{attrs:{"id":"mapZipInput","type":"text","placeholder":"Enter a ZIP Code or Address"},on:{"change":function($event){return _vm.addressChange($event)}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)}},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('b-col',{staticClass:"flex-center",staticStyle:{"padding-left":"0px"},attrs:{"md":"1","sm":"2"}},[_c('span',{staticStyle:{"margin-right":"8px"}},[_vm._v("Radius:")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3","sm":"6"}},[_c('b-form-input',{attrs:{"type":"number"},on:{"change":function($event){return _vm.radiusChange($event)}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)}},model:{value:(_vm.radius),callback:function ($$v) {_vm.radius=$$v},expression:"radius"}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2","sm":"4"}},[_c('b-btn',{staticStyle:{"margin-left":"16px"},on:{"click":_vm.search}},[_vm._v("Show ZIP Codes")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-alert',{attrs:{"show":_vm.alertDesc!=='',"variant":"warning"}},[_vm._v(_vm._s(_vm.alertDesc))])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('m-map',{attrs:{"map-id":"mapZip"},on:{"load":_vm.createMap,"full-screen":_vm.toggleFullScreen}}),_vm._v(" "),_c('span',[_vm._v("Please click on the map above to add or remove zip codes")])],1)],1)],1)],1)}
var MGeoZipMap_staticRenderFns = []
var MGeoZipMap_esExports = { render: MGeoZipMap_render, staticRenderFns: MGeoZipMap_staticRenderFns }
/* harmony default export */ var geo_MGeoZipMap = (MGeoZipMap_esExports);
// CONCATENATED MODULE: ./src/components/geo/MGeoZipMap.vue
function MGeoZipMap_injectStyle (ssrContext) {
  __webpack_require__("AUSj")
}
var MGeoZipMap_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MGeoZipMap___vue_template_functional__ = false
/* styles */
var MGeoZipMap___vue_styles__ = MGeoZipMap_injectStyle
/* scopeId */
var MGeoZipMap___vue_scopeId__ = "data-v-2d8ff748"
/* moduleIdentifier (server only) */
var MGeoZipMap___vue_module_identifier__ = null
var MGeoZipMap_Component = MGeoZipMap_normalizeComponent(
  MGeoZipMap,
  geo_MGeoZipMap,
  MGeoZipMap___vue_template_functional__,
  MGeoZipMap___vue_styles__,
  MGeoZipMap___vue_scopeId__,
  MGeoZipMap___vue_module_identifier__
)

/* harmony default export */ var components_geo_MGeoZipMap = (MGeoZipMap_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/MGeoZip.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MGeoZip = ({
  components: { MGeoZipMap: components_geo_MGeoZipMap },
  props: {
    geoType: {
      type: Number
    },
    changeGeoType: {
      type: Number,
      default: 5
    },
    isGo: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      zips: [],
      zipDesc: '',
      zipType: 1,
      zipFrom: '',
      zipTo: '',
      step: '',
      nextDisabled: false,
      alertDesc: '',
      needCb: false,
      pastZipType: 'zip', // 'zip', 'zip4', 'carrierRoutes'
      zipExample: {
        zip: 'ZIP Code(e.g. 10025',
        zip4: 'ZIP+4(e.g. 071100001',
        carrierRoutes: 'Carrier Routes (e.g. 07110:B001'
      },
      zipsType: {
        zip: 1,
        zip4: 2,
        carrierRoutes: 3
      }
    };
  },

  computed: {
    realGeoType: function realGeoType() {
      return this.$store.state.geo.geoTypes.Zip;
    },
    zipTypes: function zipTypes() {
      return this.$store.state.geo.zipTypes;
    },

    // TODO@Pony need update
    geoItems: function geoItems() {
      return this.$store.getters['order/geoItems'];
    },
    showZip4: function showZip4() {
      return this.$store.state.order.ListType !== 50;
    }
  },
  watch: {
    isGo: function isGo(val) {
      if (val) {
        this.next();
      }
    }
  },
  created: function created() {
    // add zips
    for (var i = 0; i < 25; i++) {
      this.zips.push({ zip: '' });
    }
  },

  methods: {
    next: function next() {
      this.alertDesc = '';
      if (this.step === 'zip') {
        this.addZip();
      } else if (this.step === 'rangezip') {
        this.rangeaddZip();
      } else if (this.step === 'pastezip') {
        this.pastedZip();
      } else if (this.geoItems.length === 0) {
        this.alertDesc = 'Please input ZIP Code.';
        this.unlock();
      } else {
        this.unlock();
      }
    },
    addZip: function addZip() {
      var _this = this;

      if (this.pastZipType !== 'zip') {
        this.$store.commit('order/cleanGeo');
        this.$store.commit('order/saveKey', ['ZipType', 0]);
      }

      // read zip from input
      this.lock();
      var zipInputs = JSON.parse(stringify_default()(this.zips));
      var zips = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(zipInputs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var zip = _step.value;

          if (zip.zip) {
            zips.push(zip.zip);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (zips.length === 0 && this.geoItems.length > 0 && this.isGo) {
        this.unlock();
        return;
      } else if (zips.length === 0) {
        this.alertDesc = 'Please input at least one ZIP Code.';
        this.unlock();
        return;
      }

      // check zip
      this.$http.post('PlaceOrder.aspx/GetZipsByZips', {
        zipType: 1,
        zips: zips
      }).then(function (resp) {
        // add zip to order
        var respZips = resp.body.d.DataSource;
        if (respZips.length !== zips.length) {
          _this.alertDesc = 'Please enter the correct ZIP codes. Invalid or duplicate entries have been removed.';
          _this.$emit('update:isGo', false);
        }
        if (respZips.length === 0 && _this.geoItems.lenght === 0) {
          _this.alertDesc = 'Please input at least one valid zip. Invalid or duplicate entries have been removed.';
          _this.$emit('update:isGo', false);
        }
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(respZips), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _zip = _step2.value;

            _this.$store.commit('order/addGeo', {
              GeoKeyCode: _zip,
              GeoKeyDesc: _zip,
              GeoType: 5
            });
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this.unlock();
      }, function (resp) {
        _this.unlock();
      });
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(this.zips), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          item.zip = '';
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    selectGeoType: function selectGeoType() {
      if (this.order.GeoType !== this.geoType.code) {}
    },
    pastedZip: function pastedZip(isRange) {
      var _this2 = this;

      var pastZipType = this.pastZipType;
      if (isRange) {
        if (this.pastZipType !== 'zip') {
          this.$store.commit('order/cleanGeo');
        }
        pastZipType = 'zip';
      }
      this.$store.commit('order/saveKey', ['ZipType', this.zipsType[pastZipType]]);
      this.lock();
      if (this.zipDesc === '' && this.geoItems.length > 0 && this.isGo) {
        this.unlock();
        return;
      } else if (this.zipDesc === '') {
        this.alertDesc = 'Please input at least one valid ' + this.zipExample[pastZipType] + ').';
        this.unlock();
        return;
      }

      var zips = this.zipDesc.split(/[\s,;]/);
      this.$http.post('PlaceOrder.aspx/GetZipsByZips', {
        zipType: this.zipsType[pastZipType],
        zips: zips
      }).then(function (resp) {
        var respZips = resp.body.d.DataSource;
        if (respZips.length !== zips.length || respZips.length === 0) {
          _this2.alertDesc = 'Please enter the correct ' + _this2.zipExample[pastZipType] + '). Invalid or duplicate entries have been removed.';
        }
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = get_iterator_default()(respZips), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var zip = _step4.value;

            _this2.$store.commit('order/addGeo', {
              GeoKeyCode: zip,
              GeoKeyDesc: zip,
              GeoType: 5
            });
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        _this2.unlock();
      }, function (resp) {
        _this2.unlock();
      });
      this.zipDesc = '';
    },
    validZip: function validZip(zips) {
      var _this3 = this;

      this.$http.post('PlaceOrder.aspx/GetZipsByZips', {
        zipType: 0,
        zips: zips
      }).then(function (resp) {
        // add zip to order
        var zips = resp.body.d.DataSource;
        if (zips.length === 0) {
          _this3.alertDesc = 'Please input at least one valid zip. Invalid or duplicate entries have been removed.';
        }
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = get_iterator_default()(zips), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var zip = _step5.value;

            _this3.$store.commit('order/addGeo', {
              GeoKeyCode: zip,
              GeoKeyDesc: zip,
              GeoType: 5
            });
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        _this3.zipFrom = '';
        _this3.zipTo = '';
        _this3.unlock();
      }, function (resp) {
        _this3.unlock();
      });
    },
    rangeaddZip: function rangeaddZip() {
      var _this4 = this;

      this.lock();
      if (this.pastZipType !== 'zip') {
        this.$store.commit('order/cleanGeo');
        this.$store.commit('order/saveKey', ['ZipType', 0]);
      }
      if ((this.zipFrom === '' || this.zipTo === '') && this.geoItems.length > 0 && this.isGo) {
        this.unlock();
        return;
      } else if (this.zipFrom === '' || this.zipTo === '') {
        this.alertDesc = 'Please input ZIP Code.';
        this.unlock();
        return;
      }

      this.$http.post('PlaceOrder.aspx/GetZipcodesByRange', {
        fromZipcode: this.zipFrom,
        toZipcode: this.zipTo,
        maxLength: 2000
      }).then(function (resp) {
        _this4.validZip(resp.body.d.DataSource);
      }, function (resp) {
        _this4.unlock();
      });
    },
    switchmenu: function switchmenu(val) {
      if (this.step !== val) {
        this.step = val;
      } else {
        if (this.step === 'zip') {
          this.step = '';
        } else if (this.step === 'map') {
          this.step = '';
        } else if (this.step === 'pastezip') {
          this.step = '';
        } else {
          this.step = '';
        }
      }
    },
    lock: function lock() {
      this.$store.dispatch('order/changeGeoType', this.changeGeoType);
      this.nextDisabled = true;
      this.alertDesc = '';
    },
    unlock: function unlock() {
      this.nextDisabled = false;
      this.$emit('update:isGo', false);

      if (this.isGo & this.alertDesc === '') {
        this.$store.dispatch('geo/next', true);
      }
    },
    fromChange: function fromChange(v) {
      if (v.length === 5) {
        document.getElementById('zipto').focus();
      }
    },
    nextInput: function nextInput(index, v) {
      if (v.length === 5 && index < 24) {
        document.getElementById('zip' + (index + 1)).focus();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eb696f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MGeoZip.vue
var MGeoZip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dbox"},[_c('b-alert',{attrs:{"show":_vm.alertDesc!=='',"variant":"warning"}},[_vm._v(_vm._s(_vm.alertDesc))]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"header",on:{"click":function($event){return _vm.switchmenu('zip')}}},[_c('h3',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 'zip'),expression:"step === 'zip'"}],staticClass:"h3-icon",attrs:{"name":"chevron-down"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step !== 'zip'),expression:"step !== 'zip'"}],staticClass:"h3-icon",attrs:{"name":"chevron-right"}}),_vm._v("\n        Enter ZIP Codes\n      ")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 'zip'),expression:"step === 'zip'"}],staticClass:"zipr-box "},[_c('div',{staticClass:"zip-code-box"},_vm._l((_vm.zips),function(item,index){return _c('div',{staticClass:"zip-input-box"},[_c('b-input',{staticClass:"zip-input",attrs:{"id":'zip'+index,"maxlength":"5"},on:{"input":function($event){return _vm.nextInput(index,$event)},"change":function($event){return _vm.$store.commit('geo/saveKey', ['geoUnAdd', 'zip'])}},model:{value:(item.zip),callback:function ($$v) {_vm.$set(item, "zip", $$v)},expression:"item.zip"}})],1)}),0),_vm._v(" "),_c('b-btn',{staticStyle:{"display":"block"},attrs:{"variant":"primary","disabled":_vm.nextDisabled,"data-test":"geo-zip-add"},on:{"click":_vm.addZip}},[_vm._v("Add\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"header",on:{"click":function($event){return _vm.switchmenu('pastezip')}}},[_c('h3',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 'pastezip'),expression:"step === 'pastezip'"}],staticClass:"h3-icon",attrs:{"name":"chevron-down"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step !== 'pastezip'),expression:"step !== 'pastezip'"}],staticClass:"h3-icon",attrs:{"name":"chevron-right"}}),_vm._v("\n        Paste ZIP Codes"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showZip4),expression:"showZip4"}]},[_vm._v(", ZIP+4")]),_vm._v(" or Carrier Routes\n      ")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step=='pastezip'),expression:"step=='pastezip'"}],staticClass:"zipr-box"},[_c('div',{staticClass:"zipbox"},[_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Copy and paste up to 2,000 areas separated by a comma, space, or semicolon, or that wrap with one per line.","rows":5,"max-rows":8},on:{"change":function($event){return _vm.$store.commit('geo/saveKey', ['geoUnAdd', 'zip'])}},model:{value:(_vm.zipDesc),callback:function ($$v) {_vm.zipDesc=$$v},expression:"zipDesc"}})],1),_vm._v(" "),_c('b-form-select',{staticStyle:{"display":"inline-block","width":"300px","margin-right":"16px"},model:{value:(_vm.pastZipType),callback:function ($$v) {_vm.pastZipType=$$v},expression:"pastZipType"}},[_c('option',{attrs:{"value":"zip"}},[_vm._v("ZIP Codes")]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.showZip4),expression:"showZip4"}],attrs:{"value":"zip4"}},[_vm._v("ZIP+4")]),_vm._v(" "),_c('option',{attrs:{"value":"carrierRoutes"}},[_vm._v("Carrier Routes")])]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"primary","disabled":_vm.nextDisabled},on:{"click":function($event){return _vm.pastedZip(false)}}},[_vm._v("Add\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"header",on:{"click":function($event){return _vm.switchmenu('map')}}},[_c('h3',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 'map'),expression:"step === 'map'"}],staticClass:"h3-icon",attrs:{"name":"chevron-down"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step !== 'map'),expression:"step !== 'map'"}],staticClass:"h3-icon",attrs:{"name":"chevron-right"}}),_vm._v("\n        Select ZIP Codes from Map\n      ")],1)]),_vm._v(" "),_c('keep-alive',{staticClass:"zipr-box"},[(_vm.step === 'map')?_c('m-geo-zip-map',{attrs:{"geoType":_vm.geoType,"pastZipType":_vm.pastZipType}}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"header",on:{"click":function($event){return _vm.switchmenu('rangezip')}}},[_c('h3',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 'rangezip'),expression:"step === 'rangezip'"}],staticClass:"h3-icon",attrs:{"name":"chevron-down"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step !== 'rangezip'),expression:"step !== 'rangezip'"}],staticClass:"h3-icon",attrs:{"name":"chevron-right"}}),_vm._v("\n        Enter ZIP Code Range\n      ")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step=='rangezip'),expression:"step=='rangezip'"}],staticClass:"zip-content-box"},[_c('div',{staticClass:"zipbox"},[_c('b-input',{staticClass:"zip-inputr",attrs:{"maxlength":"5"},on:{"input":function($event){return _vm.fromChange($event)},"change":function($event){return _vm.$store.commit('geo/saveKey', ['geoUnAdd', 'zip'])}},model:{value:(_vm.zipFrom),callback:function ($$v) {_vm.zipFrom=$$v},expression:"zipFrom"}}),_vm._v(" "),_c('span',{staticClass:"to"},[_vm._v("to")]),_vm._v(" "),_c('b-input',{staticClass:"zip-inputr zip-to",attrs:{"id":"zipto","maxlength":"5"},on:{"blur":function($event){return _vm.pastedZip(true)},"change":function($event){return _vm.$store.commit('geo/saveKey', ['geoUnAdd', 'zip'])}},model:{value:(_vm.zipTo),callback:function ($$v) {_vm.zipTo=$$v},expression:"zipTo"}})],1)])])],1)}
var MGeoZip_staticRenderFns = []
var MGeoZip_esExports = { render: MGeoZip_render, staticRenderFns: MGeoZip_staticRenderFns }
/* harmony default export */ var geo_MGeoZip = (MGeoZip_esExports);
// CONCATENATED MODULE: ./src/components/geo/MGeoZip.vue
function MGeoZip_injectStyle (ssrContext) {
  __webpack_require__("7gN+")
}
var MGeoZip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MGeoZip___vue_template_functional__ = false
/* styles */
var MGeoZip___vue_styles__ = MGeoZip_injectStyle
/* scopeId */
var MGeoZip___vue_scopeId__ = "data-v-1eb696f8"
/* moduleIdentifier (server only) */
var MGeoZip___vue_module_identifier__ = null
var MGeoZip_Component = MGeoZip_normalizeComponent(
  MGeoZip,
  geo_MGeoZip,
  MGeoZip___vue_template_functional__,
  MGeoZip___vue_styles__,
  MGeoZip___vue_scopeId__,
  MGeoZip___vue_module_identifier__
)

/* harmony default export */ var components_geo_MGeoZip = (MGeoZip_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoZip.vue
//
//
//
//
//
//




/* harmony default export */ var GeoZip = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MGeoZip: components_geo_MGeoZip
  },
  data: function data() {
    return {
      isGo: false
    };
  },

  methods: {
    goNext: function goNext() {
      this.isGo = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd1ee25c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoZip.vue
var GeoZip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"zip","need-next":true},on:{"go":_vm.goNext}},[_c('m-geo-zip',{attrs:{"geoType":5,"is-go":_vm.isGo},on:{"update:isGo":function($event){_vm.isGo=$event},"update:is-go":function($event){_vm.isGo=$event},"updateIsGo":function($event){}}})],1)}
var GeoZip_staticRenderFns = []
var GeoZip_esExports = { render: GeoZip_render, staticRenderFns: GeoZip_staticRenderFns }
/* harmony default export */ var order_GeoZip = (GeoZip_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoZip.vue
var GeoZip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoZip___vue_template_functional__ = false
/* styles */
var GeoZip___vue_styles__ = null
/* scopeId */
var GeoZip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GeoZip___vue_module_identifier__ = null
var GeoZip_Component = GeoZip_normalizeComponent(
  GeoZip,
  order_GeoZip,
  GeoZip___vue_template_functional__,
  GeoZip___vue_styles__,
  GeoZip___vue_scopeId__,
  GeoZip___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoZip = (GeoZip_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/MGeoZipMenu.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MGeoZipMenu = ({
  components: {},
  props: {},
  data: function data() {
    return {
      menus: [{
        name: 'zip',
        desc: 'Enter Zip Codes'
      }, {
        name: 'zipRange',
        desc: 'Zip Code Range'
      }, {
        name: 'zipPaste',
        desc: '2000 ZIP/Carrier Routes/ZIP+4'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ada20a5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MGeoZipMenu.vue
var MGeoZipMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"variant":"link","no-caret":""}},[_c('span',{attrs:{"slot":"button-content"},slot:"button-content"},[_vm._v("Menu")]),_vm._v(" "),_vm._l((_vm.menus),function(item){return _c('b-dropdown-item',{key:item.name,attrs:{"to":{name: 'geo-'+item.name}}},[_vm._v("\n    "+_vm._s(item.desc)+"\n  ")])})],2)}
var MGeoZipMenu_staticRenderFns = []
var MGeoZipMenu_esExports = { render: MGeoZipMenu_render, staticRenderFns: MGeoZipMenu_staticRenderFns }
/* harmony default export */ var geo_MGeoZipMenu = (MGeoZipMenu_esExports);
// CONCATENATED MODULE: ./src/components/geo/MGeoZipMenu.vue
function MGeoZipMenu_injectStyle (ssrContext) {
  __webpack_require__("EX1H")
}
var MGeoZipMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MGeoZipMenu___vue_template_functional__ = false
/* styles */
var MGeoZipMenu___vue_styles__ = MGeoZipMenu_injectStyle
/* scopeId */
var MGeoZipMenu___vue_scopeId__ = "data-v-1ada20a5"
/* moduleIdentifier (server only) */
var MGeoZipMenu___vue_module_identifier__ = null
var MGeoZipMenu_Component = MGeoZipMenu_normalizeComponent(
  MGeoZipMenu,
  geo_MGeoZipMenu,
  MGeoZipMenu___vue_template_functional__,
  MGeoZipMenu___vue_styles__,
  MGeoZipMenu___vue_scopeId__,
  MGeoZipMenu___vue_module_identifier__
)

/* harmony default export */ var components_geo_MGeoZipMenu = (MGeoZipMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoZipRange.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GeoZipRange = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MGeoZipMenu: components_geo_MGeoZipMenu
  },
  data: function data() {
    return {
      zipFrom: '',
      zipTo: '',
      a: ''
    };
  },

  computed: {
    geoType: function geoType() {
      return this.$store.state.geo.geoTypes.Zip;
    }
  },
  methods: {
    validZip: function validZip(zips) {
      var _this = this;

      // zips = utils.validZip(codes, type) TODO@PONY need check
      this.$http.post('PlaceOrder.aspx/GetZipsByZips', {
        zipType: 0,
        zips: zips
      }).then(function (resp) {
        // add zip to order
        var zips = resp.body.d.DataSource;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(zips), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var zip = _step.value;

            _this.$store.commit('order/addGeo', {
              GeoKeyCode: zip,
              GeoKeyDesc: zip,
              GeoType: 5
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    addZip: function addZip() {
      var _this2 = this;

      this.$store.dispatch('order/changeGeoType', this.geoType.Code);
      this.$http.post('PlaceOrder.aspx/GetZipcodesByRange', {
        fromZipcode: this.zipFrom,
        toZipcode: this.zipTo,
        maxLength: 2000
      }).then(function (resp) {
        _this2.validZip(resp.body.d.DataSource);
        _this2.zipFrom = '';
        _this2.zipTo = '';
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54dae688","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoZipRange.vue
var GeoZipRange_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"zip","title":"ZIP Code Rage"}},[_c('span',{attrs:{"slot":"menu"},slot:"menu"},[_c('m-geo-zip-menu')],1),_vm._v(" "),_c('div',{staticClass:"zip-box"},[_c('b-input',{staticClass:"zip-input",attrs:{"type":"number"},model:{value:(_vm.zipFrom),callback:function ($$v) {_vm.zipFrom=$$v},expression:"zipFrom"}}),_vm._v(" "),_c('b-input',{staticClass:"zip-input zip-to",attrs:{"type":"number"},model:{value:(_vm.zipTo),callback:function ($$v) {_vm.zipTo=$$v},expression:"zipTo"}})],1),_vm._v(" "),_c('b-btn',{on:{"click":_vm.addZip}},[_vm._v("Add")])],1)}
var GeoZipRange_staticRenderFns = []
var GeoZipRange_esExports = { render: GeoZipRange_render, staticRenderFns: GeoZipRange_staticRenderFns }
/* harmony default export */ var order_GeoZipRange = (GeoZipRange_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoZipRange.vue
function GeoZipRange_injectStyle (ssrContext) {
  __webpack_require__("BVRP")
}
var GeoZipRange_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoZipRange___vue_template_functional__ = false
/* styles */
var GeoZipRange___vue_styles__ = GeoZipRange_injectStyle
/* scopeId */
var GeoZipRange___vue_scopeId__ = "data-v-54dae688"
/* moduleIdentifier (server only) */
var GeoZipRange___vue_module_identifier__ = null
var GeoZipRange_Component = GeoZipRange_normalizeComponent(
  GeoZipRange,
  order_GeoZipRange,
  GeoZipRange___vue_template_functional__,
  GeoZipRange___vue_styles__,
  GeoZipRange___vue_scopeId__,
  GeoZipRange___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoZipRange = (GeoZipRange_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoZipPaste.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GeoZipPaste = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MGeoZipMenu: components_geo_MGeoZipMenu
  },
  data: function data() {
    return {
      zipDesc: '',
      zipType: 1
    };
  },

  computed: {
    geoType: function geoType() {
      return this.$store.state.geo.geoTypes.Zip;
    },
    zipTypes: function zipTypes() {
      return this.$store.state.geo.zipTypes;
    }
  },
  methods: {
    addZip: function addZip() {
      var _this = this;

      this.$store.dispatch('order/changeGeoType', this.geoType.Code);
      var zips = this.zipDesc.split(/[\s,;]/);
      this.$http.post('PlaceOrder.aspx/GetZipsByZips', {
        zipType: this.zipType,
        zips: zips
      }).then(function (resp) {
        var zips = resp.body.d.DataSource;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(zips), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var zip = _step.value;

            _this.$store.commit('order/addGeo', {
              GeoKeyCode: zip,
              GeoKeyDesc: zip,
              GeoType: 5
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be664c1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoZipPaste.vue
var GeoZipPaste_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"zip","title":"2000 ZIP/Carrier Routes/ZIP+4"}},[_c('span',{attrs:{"slot":"menu"},slot:"menu"},[_c('m-geo-zip-menu')],1),_vm._v(" "),_c('b-form-radio-group',{model:{value:(_vm.zipType),callback:function ($$v) {_vm.zipType=$$v},expression:"zipType"}},_vm._l((_vm.zipTypes),function(item){return _c('b-form-radio',{key:item.code,attrs:{"value":item.code}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),1),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Copy/Paste/Enter upto 2000; Use wrap,space,comma,semicolon to split","rows":5,"max-rows":8},model:{value:(_vm.zipDesc),callback:function ($$v) {_vm.zipDesc=$$v},expression:"zipDesc"}}),_vm._v(" "),_c('b-btn',{staticClass:"add-zip",on:{"click":_vm.addZip}},[_vm._v("Add")])],1)}
var GeoZipPaste_staticRenderFns = []
var GeoZipPaste_esExports = { render: GeoZipPaste_render, staticRenderFns: GeoZipPaste_staticRenderFns }
/* harmony default export */ var order_GeoZipPaste = (GeoZipPaste_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoZipPaste.vue
function GeoZipPaste_injectStyle (ssrContext) {
  __webpack_require__("io1r")
}
var GeoZipPaste_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoZipPaste___vue_template_functional__ = false
/* styles */
var GeoZipPaste___vue_styles__ = GeoZipPaste_injectStyle
/* scopeId */
var GeoZipPaste___vue_scopeId__ = "data-v-2be664c1"
/* moduleIdentifier (server only) */
var GeoZipPaste___vue_module_identifier__ = null
var GeoZipPaste_Component = GeoZipPaste_normalizeComponent(
  GeoZipPaste,
  order_GeoZipPaste,
  GeoZipPaste___vue_template_functional__,
  GeoZipPaste___vue_styles__,
  GeoZipPaste___vue_scopeId__,
  GeoZipPaste___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoZipPaste = (GeoZipPaste_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/MGeoStateMenu.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MGeoStateMenu = ({
  components: {},
  props: {},
  data: function data() {
    return {
      menus: [{
        name: 'stateMap',
        desc: 'Map'
      }, {
        name: 'stateList',
        desc: 'List'
      }]
    };
  },

  methods: {
    isUnActivite: function isUnActivite(item) {
      return 'geo-' + item.name !== this.$route.name;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f9eb845","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MGeoStateMenu.vue
var MGeoStateMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.menus),function(item){return _c('b-link',{key:item.name,class:{'un-activite': _vm.isUnActivite(item)},attrs:{"to":{name: 'geo-'+item.name}}},[_vm._v("\n    "+_vm._s(item.desc)+"\n  ")])}),1)}
var MGeoStateMenu_staticRenderFns = []
var MGeoStateMenu_esExports = { render: MGeoStateMenu_render, staticRenderFns: MGeoStateMenu_staticRenderFns }
/* harmony default export */ var geo_MGeoStateMenu = (MGeoStateMenu_esExports);
// CONCATENATED MODULE: ./src/components/geo/MGeoStateMenu.vue
function MGeoStateMenu_injectStyle (ssrContext) {
  __webpack_require__("osbG")
}
var MGeoStateMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MGeoStateMenu___vue_template_functional__ = false
/* styles */
var MGeoStateMenu___vue_styles__ = MGeoStateMenu_injectStyle
/* scopeId */
var MGeoStateMenu___vue_scopeId__ = "data-v-6f9eb845"
/* moduleIdentifier (server only) */
var MGeoStateMenu___vue_module_identifier__ = null
var MGeoStateMenu_Component = MGeoStateMenu_normalizeComponent(
  MGeoStateMenu,
  geo_MGeoStateMenu,
  MGeoStateMenu___vue_template_functional__,
  MGeoStateMenu___vue_styles__,
  MGeoStateMenu___vue_scopeId__,
  MGeoStateMenu___vue_module_identifier__
)

/* harmony default export */ var components_geo_MGeoStateMenu = (MGeoStateMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoStateMap.vue
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GeoStateMap = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MGeoStateMenu: components_geo_MGeoStateMenu
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31d3e08c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoStateMap.vue
var GeoStateMap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"state"}},[_c('div',{staticClass:"box-t"},[_c('div',{staticClass:"header"},[_c('h3',[_vm._v("State List")]),_vm._v(" "),_c('m-geo-state-menu')],1)])])}
var GeoStateMap_staticRenderFns = []
var GeoStateMap_esExports = { render: GeoStateMap_render, staticRenderFns: GeoStateMap_staticRenderFns }
/* harmony default export */ var order_GeoStateMap = (GeoStateMap_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoStateMap.vue
function GeoStateMap_injectStyle (ssrContext) {
  __webpack_require__("So/r")
}
var GeoStateMap_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoStateMap___vue_template_functional__ = false
/* styles */
var GeoStateMap___vue_styles__ = GeoStateMap_injectStyle
/* scopeId */
var GeoStateMap___vue_scopeId__ = "data-v-31d3e08c"
/* moduleIdentifier (server only) */
var GeoStateMap___vue_module_identifier__ = null
var GeoStateMap_Component = GeoStateMap_normalizeComponent(
  GeoStateMap,
  order_GeoStateMap,
  GeoStateMap___vue_template_functional__,
  GeoStateMap___vue_styles__,
  GeoStateMap___vue_scopeId__,
  GeoStateMap___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoStateMap = (GeoStateMap_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/geo/MStateList.vue


//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MStateList = ({
  data: function data() {
    return {};
  },

  props: {
    geoType: {
      type: Number
    },
    changeGeoType: {
      type: Number,
      default: 2
    }
  },
  created: function created() {
    this.$store.dispatch('geo/getStates');
  },

  computed: {
    realgeoType: function realgeoType() {
      return this.$store.state.geo.geoTypes.State;
    },
    states: function states() {
      return this.$store.state.geo.states;
    }
  },
  methods: {
    toggleGeo: function toggleGeo(item) {
      if (this.getIsSelected(item.code)) {
        this.$store.commit('order/deleteGeo', item.code);
      } else {
        this.$store.dispatch('order/changeGeoType', this.changeGeoType);
        this.$store.commit('order/addGeo', {
          GeoKeyCode: item.code,
          GeoKeyDesc: item.name,
          GeoType: 2
        });
      }
    },
    getIsSelected: function getIsSelected(code) {
      var orderGeos = this.$store.state.order.OrderGeos;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(keys_default()(orderGeos)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (code === orderGeos[key].GeoKeyCode) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eab61988","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/geo/MStateList.vue
var MStateList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stateBox"},[_c('m-loader',{attrs:{"size":"box","show":Object.keys(_vm.states).length === 0}}),_vm._v(" "),_vm._l((_vm.states),function(item){return _c('span',{staticClass:"state",on:{"click":function($event){return _vm.toggleGeo(item)}}},[_c('span',{class:{activite: _vm.getIsSelected(item.code)}},[_vm._v("\n      "+_vm._s(item.name))])])})],2)}
var MStateList_staticRenderFns = []
var MStateList_esExports = { render: MStateList_render, staticRenderFns: MStateList_staticRenderFns }
/* harmony default export */ var geo_MStateList = (MStateList_esExports);
// CONCATENATED MODULE: ./src/Components/geo/MStateList.vue
function MStateList_injectStyle (ssrContext) {
  __webpack_require__("rIPm")
}
var MStateList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MStateList___vue_template_functional__ = false
/* styles */
var MStateList___vue_styles__ = MStateList_injectStyle
/* scopeId */
var MStateList___vue_scopeId__ = "data-v-eab61988"
/* moduleIdentifier (server only) */
var MStateList___vue_module_identifier__ = null
var MStateList_Component = MStateList_normalizeComponent(
  MStateList,
  geo_MStateList,
  MStateList___vue_template_functional__,
  MStateList___vue_styles__,
  MStateList___vue_scopeId__,
  MStateList___vue_module_identifier__
)

/* harmony default export */ var Components_geo_MStateList = (MStateList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/geo/MStateMap.vue


//
//
//
//


/* harmony default export */ var MStateMap = ({
  data: function data() {
    return {
      map: null,
      dataprovider: null
    };
  },

  props: {
    geoType: {
      type: Number
    },
    changeGeoType: {
      type: Number,
      default: 2
    }
  },
  computed: {
    geos: function geos() {
      return this.$store.getters['order/geoItems'];
    },
    selectedGeo: function selectedGeo() {
      var result = [];
      var orderGeos = this.$store.state.order.OrderGeos;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(orderGeos), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var geo = _step.value;

          if (geo.GeoType === this.realgeoType) {
            result.push({
              id: 'US-' + geo.GeoKeyCode,
              showAsSelected: true
            });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.map && this.map.validateData) {
        this.map.dataProvider.areas = result;
        // this.map.validateDate()
      }
      return result;
    },
    realgeoType: function realgeoType() {
      return this.$store.state.geo.geoTypes.State.Code;
    }
  },
  watch: {
    geos: function geos() {
      if (this.$route.name === 'geo-state') {
        this.updateSelect();
      }
    }
  },
  methods: {
    getIsSelected: function getIsSelected(code) {
      var orderGeos = this.$store.state.order.OrderGeos;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(keys_default()(orderGeos)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          if (code === orderGeos[key].GeoKeyCode) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    },
    updateSelect: function updateSelect() {
      this.map.dataProvider.areas = this.selectedGeo;
      this.map.validateData();
    },
    createMap: function createMap() {
      if (this.geoType === this.realgeoType) {
        this.$store.dispatch('order/changeGeoType', this.geoType);
      }
      var that = this;
      this.map = window.AmCharts.makeChart('chartdiv', {
        type: 'map',
        theme: 'light',
        panEventsEnabled: true,
        // 'backgroundColor': '#666666',
        // 'backgroundAlpha': 1,
        dataProvider: {
          map: 'usaLow',
          getAreasFromMap: true,
          areas: this.selectedGeo
        },
        areasSettings: {
          autoZoom: false,
          color: '#CDCDCD',
          colorSolid: '#5EB7DE',
          selectedColor: '#4A90E2',
          outlineColor: '#666666',
          rollOverColor: '#88CAE7',
          rollOverOutlineColor: '#FFFFFF',
          selectable: true
        },
        zoomControl: {
          panControlEnabled: false,
          zoomControlEnabled: true
        },
        imagesSettings: {
          labelPosition: 'middle',
          labelFontSize: 9
        },
        listeners: [{
          event: 'clickMapObject',
          method: function method(event) {
            // deselect the area by assigning all of the dataProvider as selected object
            that.map.selectedObject = that.map.dataProvider;

            // toggle showAsSelected
            event.mapObject.showAsSelected = !event.mapObject.showAsSelected;

            // bring it to an appropriate color
            that.map.returnInitialColor(event.mapObject);

            // let's build a list of currently selected states
            that.$store.commit('order/cleanGeo', that.realgeoType);
            for (var i in that.map.dataProvider.areas) {
              var area = that.map.dataProvider.areas[i];
              if (area.showAsSelected) {
                that.$store.commit('order/addGeo', {
                  GeoKeyCode: area.id.slice(3),
                  GeoKeyDesc: area.title,
                  GeoType: that.realgeoType
                });
              } else {
                that.$store.commit('order/deleteGeo', area.id.slice(3));
              }
            }
          }
        }],
        export: {}
      });

      // sometimes the map created before init event
      this.addStateLabel();
      this.map.addListener('init', function () {
        setTimeout(that.addStateLabel, 10);
        setTimeout(function () {
          that.map.invalidateSize();
        });
      });
    },
    addStateLabel: function addStateLabel() {
      // See detail: https://www.amcharts.com/kbase/display-state-abbreviations-as-labels-over-us-map/
      this.map.dataProvider.images = [];
      for (var x in this.map.dataProvider.areas) {
        var area = this.map.dataProvider.areas[x];
        var image = new window.AmCharts.MapImage();
        image.latitude = this.map.getAreaCenterLatitude(area);
        image.longitude = this.map.getAreaCenterLongitude(area);
        image.label = area.id.substr(3);
        image.title = area.title;
        image.linkToObject = area;
        this.map.dataProvider.images.push(image);
      }
      this.map.validateData();
    }
  },
  mounted: function mounted() {
    if (!window.AmCharts) {
      utils.loadCss('./static/amcharts/export.css');
      utils.loadJs('./static/amcharts/main.js', this.createMap);

      // other link that doesn't use
      // 'https://www.amcharts.com/lib/3/maps/js/usaLow.js'
      // 'https://www.amcharts.com/lib/3/plugins/export/export.min.js'
      // 'https://www.amcharts.com/lib/3/themes/light.js'
    } else {
      this.createMap();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39c84dbd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/geo/MStateMap.vue
var MStateMap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chartdiv"}})}
var MStateMap_staticRenderFns = []
var MStateMap_esExports = { render: MStateMap_render, staticRenderFns: MStateMap_staticRenderFns }
/* harmony default export */ var geo_MStateMap = (MStateMap_esExports);
// CONCATENATED MODULE: ./src/Components/geo/MStateMap.vue
function MStateMap_injectStyle (ssrContext) {
  __webpack_require__("xAfj")
  __webpack_require__("i7rk")
}
var MStateMap_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MStateMap___vue_template_functional__ = false
/* styles */
var MStateMap___vue_styles__ = MStateMap_injectStyle
/* scopeId */
var MStateMap___vue_scopeId__ = "data-v-39c84dbd"
/* moduleIdentifier (server only) */
var MStateMap___vue_module_identifier__ = null
var MStateMap_Component = MStateMap_normalizeComponent(
  MStateMap,
  geo_MStateMap,
  MStateMap___vue_template_functional__,
  MStateMap___vue_styles__,
  MStateMap___vue_scopeId__,
  MStateMap___vue_module_identifier__
)

/* harmony default export */ var Components_geo_MStateMap = (MStateMap_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/MGeoStateBox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MGeoStateBox = ({
  components: {
    MStateList: Components_geo_MStateList,
    MStateMap: Components_geo_MStateMap
  },
  props: {
    geoType: {
      type: Number
    }
  },
  data: function data() {
    return {
      showmap: true
    };
  },

  methods: {
    tiggerShow: function tiggerShow() {
      this.showmap = !this.showmap;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-585101ff","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MGeoStateBox.vue
var MGeoStateBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dbox"},[_c('div',{staticClass:"header"},[_c('h3',[_vm._v("Choose State(s)")]),_vm._v(" "),_c('div',[_c('b-link',{class:{'un-activite': _vm.showmap},attrs:{"data-test":"geo-state-list"},on:{"click":_vm.tiggerShow}},[_vm._v("\n        List")]),_vm._v("\n      |\n      "),_c('b-link',{class:{'un-activite': !_vm.showmap},attrs:{"data-test":"geo-state-map"},on:{"click":_vm.tiggerShow}},[_vm._v("map")])],1)]),_vm._v(" "),(_vm.showmap)?_c('m-state-map',{attrs:{"geoType":_vm.geoType,"changeGeoType":_vm.geoType}}):_vm._e(),_vm._v(" "),_c('m-state-list',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showmap),expression:"!showmap"}],attrs:{"geoType":_vm.geoType,"changeGeoType":_vm.geoType}})],1)}
var MGeoStateBox_staticRenderFns = []
var MGeoStateBox_esExports = { render: MGeoStateBox_render, staticRenderFns: MGeoStateBox_staticRenderFns }
/* harmony default export */ var geo_MGeoStateBox = (MGeoStateBox_esExports);
// CONCATENATED MODULE: ./src/components/geo/MGeoStateBox.vue
function MGeoStateBox_injectStyle (ssrContext) {
  __webpack_require__("U3SM")
}
var MGeoStateBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MGeoStateBox___vue_template_functional__ = false
/* styles */
var MGeoStateBox___vue_styles__ = MGeoStateBox_injectStyle
/* scopeId */
var MGeoStateBox___vue_scopeId__ = "data-v-585101ff"
/* moduleIdentifier (server only) */
var MGeoStateBox___vue_module_identifier__ = null
var MGeoStateBox_Component = MGeoStateBox_normalizeComponent(
  MGeoStateBox,
  geo_MGeoStateBox,
  MGeoStateBox___vue_template_functional__,
  MGeoStateBox___vue_styles__,
  MGeoStateBox___vue_scopeId__,
  MGeoStateBox___vue_module_identifier__
)

/* harmony default export */ var components_geo_MGeoStateBox = (MGeoStateBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoStateList.vue
//
//
//
//
//
//




/* harmony default export */ var GeoStateList = ({
  components: {
    MGeoStateBox: components_geo_MGeoStateBox,
    MGeoBox: components_geo_MGeoBox
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1771d83a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoStateList.vue
var GeoStateList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"stateList","title":"State List"}},[_c('m-geo-state-box',{attrs:{"geoType":2}})],1)}
var GeoStateList_staticRenderFns = []
var GeoStateList_esExports = { render: GeoStateList_render, staticRenderFns: GeoStateList_staticRenderFns }
/* harmony default export */ var order_GeoStateList = (GeoStateList_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoStateList.vue
function GeoStateList_injectStyle (ssrContext) {
  __webpack_require__("brmI")
}
var GeoStateList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoStateList___vue_template_functional__ = false
/* styles */
var GeoStateList___vue_styles__ = GeoStateList_injectStyle
/* scopeId */
var GeoStateList___vue_scopeId__ = "data-v-1771d83a"
/* moduleIdentifier (server only) */
var GeoStateList___vue_module_identifier__ = null
var GeoStateList_Component = GeoStateList_normalizeComponent(
  GeoStateList,
  order_GeoStateList,
  GeoStateList___vue_template_functional__,
  GeoStateList___vue_styles__,
  GeoStateList___vue_scopeId__,
  GeoStateList___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoStateList = (GeoStateList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoState.vue
//
//
//
//
//
//




/* harmony default export */ var GeoState = ({
  components: {
    MGeoStateBox: components_geo_MGeoStateBox,
    MGeoBox: components_geo_MGeoBox
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-021d627a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoState.vue
var GeoState_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"state","title":"State List"}},[_c('m-geo-state-box',{attrs:{"geoType":2}})],1)}
var GeoState_staticRenderFns = []
var GeoState_esExports = { render: GeoState_render, staticRenderFns: GeoState_staticRenderFns }
/* harmony default export */ var order_GeoState = (GeoState_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoState.vue
function GeoState_injectStyle (ssrContext) {
  __webpack_require__("YyTR")
}
var GeoState_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoState___vue_template_functional__ = false
/* styles */
var GeoState___vue_styles__ = GeoState_injectStyle
/* scopeId */
var GeoState___vue_scopeId__ = "data-v-021d627a"
/* moduleIdentifier (server only) */
var GeoState___vue_module_identifier__ = null
var GeoState_Component = GeoState_normalizeComponent(
  GeoState,
  order_GeoState,
  GeoState___vue_template_functional__,
  GeoState___vue_styles__,
  GeoState___vue_scopeId__,
  GeoState___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoState = (GeoState_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/Mquestion.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Mquestion = ({
  props: {
    link: {
      type: String
    }
  },
  data: function data() {
    return {
      links: this.$store.state.links
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d1cb450","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Mquestion.vue
var Mquestion_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"modal-box",attrs:{"id":"question","size":"lg","ok-only":true,"lazy":true,"hide-header":""}},[_c('iframe',{attrs:{"src":_vm.link,"width":"100","frameborder":"0","scrolling":"no","marginheight":"0","marginwidth":"0"}})])}
var Mquestion_staticRenderFns = []
var Mquestion_esExports = { render: Mquestion_render, staticRenderFns: Mquestion_staticRenderFns }
/* harmony default export */ var common_Mquestion = (Mquestion_esExports);
// CONCATENATED MODULE: ./src/components/common/Mquestion.vue
function Mquestion_injectStyle (ssrContext) {
  __webpack_require__("V51N")
}
var Mquestion_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Mquestion___vue_template_functional__ = false
/* styles */
var Mquestion___vue_styles__ = Mquestion_injectStyle
/* scopeId */
var Mquestion___vue_scopeId__ = "data-v-2d1cb450"
/* moduleIdentifier (server only) */
var Mquestion___vue_module_identifier__ = null
var Mquestion_Component = Mquestion_normalizeComponent(
  Mquestion,
  common_Mquestion,
  Mquestion___vue_template_functional__,
  Mquestion___vue_styles__,
  Mquestion___vue_scopeId__,
  Mquestion___vue_module_identifier__
)

/* harmony default export */ var components_common_Mquestion = (Mquestion_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoPolygon.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var GeoPolygon = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MQuestion: components_common_Mquestion,
    MMap: components_geo_MMap
  },
  data: function data() {
    return {
      address: '',
      zipType: 'ZIP',
      step: 'input',
      alertDesc: '',
      map: null,
      autoComplete: null,
      fullScreen: false,
      boundsTypeSelected: 'ZIP'
    };
  },

  computed: {
    order: function order() {
      return this.$store.state.order;
    },
    geoType: function geoType() {
      return this.$store.state.geo.geoTypes.Polygon;
    },

    granularity: {
      get: function get() {
        var choice = this.$store.state.order.RadiusTypeChoice;
        if (choice === null) {
          return 1;
        }
        return choice;
      },
      set: function set(val) {
        this.$store.commit('order/saveKey', ['RadiusTypeChoice', parseInt(val)]);
      }
    },
    orderAddress: function orderAddress() {
      return this.$store.getters['order/orderaddress'];
    },
    isPolygonDrawing: function isPolygonDrawing() {
      return this.$store.state.geo.isPolygonDrawing;
    }
  },
  watch: {
    orderAddress: function orderAddress(val) {
      if (val.length === 0 || this.order.GeoType !== 13) {
        if (this.mpa) {
          this.map.clearPolygon();
          this.map.clearMarkers();
        }
      }
    },
    boundsTypeSelected: function boundsTypeSelected() {
      this.map.addLayer(this.boundsTypeSelected, '', true);
    }
  },
  activated: function activated() {},

  methods: {
    startPolygon: function startPolygon() {
      var _this = this;

      this.alertDesc = '';
      if (this.address === '') {
        this.alertDesc = 'Please input an address';
        return;
      }
      var zoom = this.map.map.getZoom();
      if (zoom < 9) {
        alert('Please Zoom in to use the polygon mapping tool.\nTo select larger geographic regions, please use a radius select, scf, ZIP code, or county selection.');
        return;
      }
      this.$store.commit('geo/saveKey', ['isPolygonDrawing', true]);
      this.$store.dispatch('order/changeGeoType', this.geoType.Code);
      this.map.clearPolygon();
      this.map.textSearch(this.address, function (resp) {
        if (_this.searchCallBack(resp.placesresult)) {
          _this.map.initPolygonDrawing(resp.placesresult);
        }
      });
    },
    onPlaceChanged: function onPlaceChanged() {
      var place = this.autoComplete.getPlace();

      this.address = document.getElementById('polygon-address').value;
      if (!this.searchCallBack(place)) {
        document.getElementById('polygon-address').placeholder = 'Enter a ZIP Code/Address';
      }
    },
    search: function search() {
      var _this2 = this;

      this.map.textSearch(this.address, function (resp) {
        _this2.searchCallBack(resp.placesresult);
      });
    },
    searchCallBack: function searchCallBack(place) {
      if (!(place && place.geometry)) {
        this.alertDesc = 'No results found for address';
        return false;
      }
      var marker = new this.map.googleMap.Marker({
        position: place.geometry.location
      });
      marker.setMap(this.map.map);
      this.map.markers.push(marker);
      this.map.map.panTo(place.geometry.location);
      this.map.map.setZoom(12);
      this.map.addLayer(this.boundsTypeSelected, '', true);
      return true;
    },
    clearPolygon: function clearPolygon() {
      this.$store.commit('order/cleanGeo');
      this.map.clearMarkers();
      this.map.clearPolygon();
    },
    createMap: function createMap() {
      this.map = utils.maps['mapPolygon'];
      var that = this;
      this.map.map.addListener('zoom_changed', function () {
        if (that.map.map.getZoom() >= 12) {
          that.map.addLayer(that.boundsTypeSelected, '', false);
        }
      });
      /* eslint-disable no-undef */
      this.autoComplete = new google.maps.places.Autocomplete(document.getElementById('polygon-address'), {
        types: ['(regions)'],
        componentRestrictions: { 'country': 'us' }
      });
      this.autoComplete.addListener('place_changed', this.onPlaceChanged);
      if (this.orderAddress.length > 0 && this.order.GeoType === 13 && !this.map.polygonBounder) {
        this.map.initPolygon(this.getPaths(), true, {
          address: this.orderAddress[0].AddressName,
          lat: this.orderAddress[0].Latitude,
          lng: this.orderAddress[0].Longitude
        });
      }
    },
    getPaths: function getPaths() {
      if (this.orderAddress.length === 0 && this.order.GeoType !== 13) {
        return false;
      }
      var paths = [];
      var address = this.orderAddress[0];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(address.AddrSearchString.split('|')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var path = _step.value;

          paths.push({ lat: Number(path.split(':')[1]), lng: Number(path.split(':')[0]) });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return paths;
    },
    toggleFullScreen: function toggleFullScreen(val) {
      this.fullScreen = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4575b62e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoPolygon.vue
var GeoPolygon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"polygon"}},[_c('m-question',{attrs:{"link":_vm.$store.getters['config/link']('radiusQuestion')}}),_vm._v(" "),_c('div',{staticClass:"box-t"},[_c('div',{staticClass:"header"},[_c('h3',[_vm._v("Select Target Area(s) - Polygon Map")])]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('div',{class:{'map-full-screen-input': _vm.fullScreen}},[_c('b-row',[_c('b-col',{staticClass:"m-col-top",attrs:{"md":"7"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],ref:"polygonAddress",staticClass:"address-input form-control",attrs:{"id":"polygon-address","placeholder":"Enter a ZIP Code or Address"},domProps:{"value":(_vm.address)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('b-col',{staticClass:"flex-center m-col-top",attrs:{"md":"5"}},[_c('span',{staticStyle:{"margin-right":"16px"}},[_vm._v("Granularity")]),_vm._v(" "),_c('b-form-select',{staticClass:"address-input",attrs:{"data-test":"geo-polygon-granularity"},model:{value:(_vm.granularity),callback:function ($$v) {_vm.granularity=$$v},expression:"granularity"}},[_c('option',{attrs:{"value":"1","checked":""}},[_vm._v("Standard")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("ZIP4")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Carrier Route")])]),_vm._v(" "),_c('icon',{staticStyle:{"color":"#3C96D2","height":"24px","width":"72px","margin-left":"16px","cursor":"pointer"},attrs:{"name":"question-circle","title":"help"},nativeOn:{"click":function($event){return _vm.$root.$emit('bv::show::modal', 'question')}}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-row-top"},[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-radio-group',{staticStyle:{"display":"flex"},attrs:{"name":"boundsType"},model:{value:(_vm.boundsTypeSelected),callback:function ($$v) {_vm.boundsTypeSelected=$$v},expression:"boundsTypeSelected"}},[_c('b-form-radio',{attrs:{"value":"CR"}},[_vm._v("Carrier Routes\n          ")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"ZIP"}},[_vm._v("ZIP Codes\n            ")])],1)],1),_vm._v(" "),_c('b-col',[_c('b-alert',{attrs:{"show":_vm.alertDesc!=='',"variant":"warning"}},[_vm._v(_vm._s(_vm.alertDesc))]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"primary","data-test":"geo-polygon-start","disabled":(_vm.orderAddress.length> 0 || _vm.isPolygonDrawing) && _vm.order.GeoType === 13},on:{"click":function($event){return _vm.startPolygon()}}},[_vm._v("Start")]),_vm._v(" "),_c('b-btn',{attrs:{"data-test":"geo-polygon-clear"},on:{"click":_vm.clearPolygon}},[_vm._v("Clear")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('m-map',{attrs:{"map-id":"mapPolygon"},on:{"load":_vm.createMap,"full-screen":_vm.toggleFullScreen}})],1)],1)],1)],1)],1)}
var GeoPolygon_staticRenderFns = []
var GeoPolygon_esExports = { render: GeoPolygon_render, staticRenderFns: GeoPolygon_staticRenderFns }
/* harmony default export */ var order_GeoPolygon = (GeoPolygon_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoPolygon.vue
function GeoPolygon_injectStyle (ssrContext) {
  __webpack_require__("FXVC")
}
var GeoPolygon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoPolygon___vue_template_functional__ = false
/* styles */
var GeoPolygon___vue_styles__ = GeoPolygon_injectStyle
/* scopeId */
var GeoPolygon___vue_scopeId__ = "data-v-4575b62e"
/* moduleIdentifier (server only) */
var GeoPolygon___vue_module_identifier__ = null
var GeoPolygon_Component = GeoPolygon_normalizeComponent(
  GeoPolygon,
  order_GeoPolygon,
  GeoPolygon___vue_template_functional__,
  GeoPolygon___vue_styles__,
  GeoPolygon___vue_scopeId__,
  GeoPolygon___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoPolygon = (GeoPolygon_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-integer.js
var is_integer = __webpack_require__("RRo+");
var is_integer_default = /*#__PURE__*/__webpack_require__.n(is_integer);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/MUploadMultiAddress.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MUploadMultiAddress = ({
  components: {},
  created: function created() {},
  data: function data() {
    return {
      step: 'file',
      radius: '',
      Miles: '',
      AddressName: '',
      uploadfile: null,
      items: [],
      uploadlistcolumn: [],
      targetFileName: '',
      map: null,
      nextDisabled: false
    };
  },

  computed: {
    geoType: function geoType() {
      return this.$store.state.geo.geoTypes;
    }
  },
  methods: {
    next: function next() {
      var _this = this;

      if (!this.uploadfile) {
        notification.notice('error', 'Please choose a file');
        return false;
      }
      this.nextDisabled = true;
      this.$store.dispatch('order/changeGeoType', this.geoType.Radius.Code);
      var zipFormData = new FormData();
      zipFormData.append('filename', this.uploadfile, this.uploadfile.filename);
      this.$http.post('Common/ExcelUploader.ashx', zipFormData).then(function (resp) {
        if (resp.body.ResultFlag) {
          _this.targetFileName = resp.body.DataSource.TargetFile;
          _this.getRecord(resp.body.DataSource.TargetFile);
        } else {
          _this.nextDisabled = false;
          notification.notice('error', resp.body.ResultMessage);
        }
      }, function (resp) {
        notification.notice('error', 'Please try again');
        _this.nextDisabled = false;
      });
    },
    getRecord: function getRecord(TargetFileName) {
      var _this2 = this;

      // check zip
      this.$http.post('PlaceOrder.aspx/GetRecord', {
        filePath: TargetFileName,
        type: 2
      }).then(function (resp) {
        _this2.items = resp.body.d.DataSource.SuccessRow;
        _this2.uploadlistcolumn = resp.body.d.DataSource.UpLoadListColumn;
        _this2.step = 'result';
        _this2.nextDisabled = false;
      }, function (resp) {
        _this2.nextDisabled = false;
      });
    },
    back: function back() {
      this.step = 'file';
      this.$refs.fileUpload.reset();
    },
    nextmap: function nextmap() {
      var _this3 = this;

      this.nextDisabled = true;
      var that = this;
      this.map = utils.maps['mapCircle'];
      this.$http.post('PlaceOrder.aspx/GetAddressByFile2', {
        FilePath: this.targetFileName,
        type: 1
      }).then(function (resp) {
        var data = resp.body.d.DataSource;
        var geoitems = resp.body.d.DataSource.GeoItems;
        for (var geoitem in geoitems) {
          var searchstring = geoitems[geoitem].Longitude + ':' + geoitems[geoitem].Latitude + ':2';
          _this3.$store.commit('order/addAddress', {
            Radius: geoitems[geoitem].Distance,
            AddrSearchString: searchstring,
            AddressLine: geoitems[geoitem].AddressLine,
            AddressName: geoitems[geoitem].KeyCode,
            Latitude: geoitems[geoitem].Latitude,
            Longitude: geoitems[geoitem].Longitude
          });
          _this3.$store.commit('order/addGeo', {
            AddressLine: searchstring,
            GeoKeyCode: searchstring,
            GeoKeyDesc: geoitems[geoitem].AddressLine,
            GeoType: that.$store.state.order.GeoType
          });
        }
        _this3.$root.$emit('bv::hide::modal', 'modaluploadmultiaddress');
        _this3.$root.$emit('mShowMultiMap');
        _this3.nextDisabled = false;
        notification.notice('info', 'Total records: ' + data.TotalCount + ' records been found on map,  ' + data.FCount + ' records can\'t be found on map,');
      }, function (resp) {
        _this3.nextDisabled = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f4c8bca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MUploadMultiAddress.vue
var MUploadMultiAddress_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modaluploadmultiaddress","hide-footer":"","title":"Upload a File for Multi-address Radius","size":"lg"}},[_c('div',{attrs:{"id":"ct_geo_SelectFile"}},[_c('b-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.step=='file'),expression:"step=='file'"}]},[_c('b-form-file',{ref:"fileUpload",attrs:{"id":"file_input1"},model:{value:(_vm.uploadfile),callback:function ($$v) {_vm.uploadfile=$$v},expression:"uploadfile"}}),_vm._v(" "),_c('br'),_vm._v(" Selected file: "+_vm._s(_vm.uploadfile && _vm.uploadfile.name)+"\n\n    "),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"color":"Red","display":"none"},attrs:{"id":"ct_geo_UploadFail"}}),_vm._v(" "),_c('ul',{staticClass:"vertical"},[_c('li',[_vm._v("File must be a Microsoft Excel file (97 or newer)")]),_vm._v(" "),_c('li',[_vm._v("File must contain the following columns:\n        "),_c('ul',{staticClass:"lower-alpha",staticStyle:{"margin-top":"5px"}},[_c('li',{staticStyle:{"margin-right":"20px"}},[_c('em',[_vm._v("\"Keycode\"")]),_vm._v(" Each input location must have a name, which is stored as a Key code. Key codes must not be more  than 30 characters in length.")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("\"Address\"")]),_vm._v(" for address")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("\"City\"")]),_vm._v(" for city")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("\"State\"")]),_vm._v(" for state")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("\"ZIP\"")]),_vm._v(" for zip")]),_vm._v(" "),_c('li',[_c('em',[_vm._v("\"Distance\"")]),_vm._v(" radius distance around input location")])])]),_vm._v(" "),_c('li',[_vm._v("Address fields (Address, City, State, Zip) should not be empty")]),_vm._v(" "),_c('li',[_c('b-link',{attrs:{"href":_vm.$store.getters['config/link']('uploadMultipleAddressTemplates'),"target":"_blank"}},[_vm._v("Download multi-address radius template file")])],1)]),_vm._v(" "),_c('div',{staticStyle:{"width":"100px","margin-top":"10px","margin":"0 auto","text-align":"center"}},[_c('b-btn',{attrs:{"variant":"primary","disabled":_vm.nextDisabled},on:{"click":_vm.next}},[_vm._v("Next")])],1)],1),_vm._v(" "),_c('b-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.step=='result'),expression:"step=='result'"}]},[_c('div',[_c('table',{staticClass:"table"},[_c('tr',_vm._l((_vm.uploadlistcolumn),function(col){return _c('td',[_vm._v(_vm._s(col.ColumnName))])}),0),_vm._v(" "),_vm._l((_vm.items),function(row){return _c('tr',_vm._l((row.RowData),function(col){return _c('td',[_vm._v(_vm._s(col.Data))])}),0)})],2)]),_vm._v(" "),_c('div',{staticStyle:{"width":"200px","margin-top":"10px","margin":"0 auto","text-align":"center"}},[_c('b-btn',{on:{"click":_vm.back}},[_vm._v("Back")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"primary","disabled":_vm.nextDisabled},on:{"click":_vm.nextmap}},[_vm._v("Next")])],1)])],1)])}
var MUploadMultiAddress_staticRenderFns = []
var MUploadMultiAddress_esExports = { render: MUploadMultiAddress_render, staticRenderFns: MUploadMultiAddress_staticRenderFns }
/* harmony default export */ var geo_MUploadMultiAddress = (MUploadMultiAddress_esExports);
// CONCATENATED MODULE: ./src/components/geo/MUploadMultiAddress.vue
function MUploadMultiAddress_injectStyle (ssrContext) {
  __webpack_require__("mp6T")
}
var MUploadMultiAddress_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MUploadMultiAddress___vue_template_functional__ = false
/* styles */
var MUploadMultiAddress___vue_styles__ = MUploadMultiAddress_injectStyle
/* scopeId */
var MUploadMultiAddress___vue_scopeId__ = "data-v-1f4c8bca"
/* moduleIdentifier (server only) */
var MUploadMultiAddress___vue_module_identifier__ = null
var MUploadMultiAddress_Component = MUploadMultiAddress_normalizeComponent(
  MUploadMultiAddress,
  geo_MUploadMultiAddress,
  MUploadMultiAddress___vue_template_functional__,
  MUploadMultiAddress___vue_styles__,
  MUploadMultiAddress___vue_scopeId__,
  MUploadMultiAddress___vue_module_identifier__
)

/* harmony default export */ var components_geo_MUploadMultiAddress = (MUploadMultiAddress_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/MMapRadius.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var MMapRadius = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MMap: components_geo_MMap,
    MUploadMultiAddress: components_geo_MUploadMultiAddress,
    MQuestion: components_common_Mquestion
  },
  data: function data() {
    return {
      inputvalue: '',
      map: null,
      autocomplete: null,
      place: {},
      markers: [],
      selectedType: 'radius',
      addressSameState: true,
      address: '',
      circleMaps: [],
      alertDesc: '',
      granularityDisable: false,
      fullScreen: false,
      name: ''
    };
  },

  computed: {
    orderaddress: function orderaddress() {
      if (this.geoType === 16 || this.geoType === 7) {
        return lodash_default.a.filter(this.$store.getters['order/orderaddress'], function (item) {
          return item.AddrUsageType === 2;
        });
      } else {
        return this.$store.getters['order/orderaddress'];
      }
    },
    geoType: function geoType() {
      return this.$store.state.order.GeoType;
    },
    showZip4: function showZip4() {
      return this.$store.state.order.ListType !== 50;
    },

    granularity: {
      get: function get() {
        var choice = this.$store.state.order.RadiusTypeChoice;
        if (choice === null) {
          return 1;
        }
        return choice;
      },
      set: function set(val) {
        this.$store.commit('order/saveKey', ['RadiusTypeChoice', parseInt(val)]);
      }
    },
    breakdown: {
      get: function get() {
        return this.$store.state.order.SeeBreakDown;
      },
      set: function set(val) {
        this.$store.commit('order/saveKey', ['SeeBreakDown', val]);
      }
    },
    sameState: {
      get: function get() {
        return this.$store.state.order.GeoSameState;
      },
      set: function set(val) {
        this.addressSameState = val;
        this.$store.commit('order/saveKey', ['GeoSameState', this.addressSameState]);
        this.$store.commit('order/UpdateAddressSameState', val);
      }
    },
    geoItems: function geoItems() {
      return this.$store.getters['order/geoItems'];
    },
    nextDisabled: function nextDisabled() {
      if (this.$store.state.order.CurrentStep === 'count') {
        return true;
      }
      if (this.geoItems.length === 0 && this.orderaddress.length === 0) {
        return true;
      }
      return false;
    },
    datasource: function datasource() {
      return this.$store.getters['config/datasource'];
    },
    hasCloseX: function hasCloseX() {
      if (this.datasource && this.datasource.geoRadius) {
        return this.datasource.geoRadius.indexOf('closex') > 0;
      } else {
        return false;
      }
    },
    hasMulti: function hasMulti() {
      if (this.datasource && this.datasource.geoRadius) {
        return this.datasource.geoRadius.indexOf('multi') > 0;
      } else {
        return false;
      }
    },
    radiusDisable: function radiusDisable() {
      if (this.selectedType === 'radius') {
        var geoCode = this.$store.state.geo.geoTypes.Radius.Code;
        if (!this.hasMulti && this.orderaddress.length > 0) {
          if (this.geoType === geoCode) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else if (this.orderaddress.length === 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    orderaddress: function orderaddress() {
      this.updateMap();
    }
  },
  methods: {
    clearCircle: function clearCircle() {
      this.$store.commit('order/cleanGeo');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.circleMaps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.setMap(null);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    back: function back() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.circleMaps), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.setMap(null);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    uploadFile: function uploadFile() {
      this.$root.$emit('bv::show::modal', 'modaluploadmultiaddress');
    },
    drawingRadius: function drawingRadius() {
      var _this = this;

      this.$store.commit('geo/saveKey', ['geoUnAdd', false]);
      this.alertDesc = '';
      if (this.address === '' || this.inputvalue === null) {
        this.alertDesc = 'Please Input an address/radius/quantity.';
        return false;
      }

      if (this.selectedType === 'radius' && (isNaN(this.inputvalue) || !this.inputvalue || this.inputvalue <= 0)) {
        this.alertDesc = 'Radius must be a number and greater than 0';
        return false;
      }
      if (this.selectedType === 'quantity' && (isNaN(this.inputvalue) || !this.inputvalue || this.inputvalue <= 0)) {
        this.alertDesc = 'Quantity must be an integer and greater than 0';
        return false;
      }
      if (this.selectedType === 'radius') {
        var geoCode = this.$store.state.geo.geoTypes.AcxiomMultiRadius.Code;
        if (this.$store.state.order.ListType === 50) {
          geoCode = this.$store.state.geo.geoTypes.Radius.Code;
        }
        if (this.geoType !== 7 && this.geoType !== 16) {
          this.$store.dispatch('order/changeGeoType', geoCode);
        }
        if (this.place === null) {
          var that = this;
          this.map.textSearch(this.address, function (resp) {
            if (resp.placesresult !== null) {
              that.place = { lat: resp.placesresult.geometry.location.lat(), lng: resp.placesresult.geometry.location.lng() };
              _this.commitGeo(that.place, geoCode);
              that.markers.push(resp.marker);
            } else {
              _this.alertDesc = 'No results found for address';
            }
          });
        } else {
          this.commitGeo(this.place, geoCode);
        }
      } else {
        this.quantityChange();
      }
    },
    onPlaceChanged: function onPlaceChanged() {
      var place = this.autocomplete.getPlace();
      if (place.geometry) {
        this.map.map.setZoom(12);
        this.map.map.panTo(place.geometry.location);
        /* eslint-disable*/
        var m = new google.maps.Marker({
          position: place.geometry.location,
          center: place.geometry.location,
          map: this.map.map
        });
        this.markers.push(m);
        this.place = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
        this.address = document.getElementById('radius-address').value;
      } else {
        document.getElementById('radius-address').placeholder = 'Enter a ZIP Code/Address';
      }
    },
    createMap: function createMap() {
      this.map = utils.maps['mapCircle'];
      /* eslint-disable no-undef */
      this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('radius-address'), {
        types: ['(regions)'],
        componentRestrictions: { 'country': 'us' }
      });
      // let places = new google.maps.places.PlacesService(this.map)
      this.autocomplete.addListener('place_changed', this.onPlaceChanged);
      this.updateMap();
      this.initMap();
    },
    radiusTypeChange: function radiusTypeChange(e) {
      if (e === 'radius') {
        this.selectedType = 'radius';
        if (this.inputvalue !== '' && this.address !== '') {
          this.drawingRadius();
        }
      } else {
        this.selectedType = 'quantity';
        if (this.inputvalue !== '' && this.address !== '') {
          this.quantityChange();
        }
      }
    },
    addressChange: function addressChange(e) {
      var _this2 = this;

      this.$store.commit('geo/saveKey', ['geoUnAdd', 'radius']);
      var that = this;
      if (this.selectedType === 'quantity' && this.inputvalue !== '' && this.address !== '') {
        if (this.place === null) {
          this.map.textSearch(this.address, function (result) {
            _this2.place = { lat: result.placesresult.geometry.location.lat(), lng: result.placesresult.geometry.location.lng() };
            that.commitGeo(_this2.place, _this2.$store.state.geo.geoTypes.Closex.Code);
            that.markers.push(result.marker);
          });
        }
      }
      if (this.selectedType === 'radius' && this.place !== null) {
        this.place = null;
      }
    },
    quantityChange: function quantityChange() {
      var _this3 = this;

      var that = this;
      if (this.selectedType === 'quantity' && this.address !== '') {
        var geoCode = this.$store.state.geo.geoTypes.Closex.Code;
        this.$store.dispatch('order/changeGeoType', geoCode);
        if (isNaN(this.inputvalue) || !this.inputvalue || !is_integer_default()(Number(this.inputvalue)) || this.inputvalue <= 0) {
          this.alertDesc = 'Quantity must be an integer and greater than 0';
          return false;
        }
        this.map.textSearch(this.address, function (result) {
          _this3.markers.push(result.marker);
          _this3.place = { lat: result.placesresult.geometry.location.lat(), lng: result.placesresult.geometry.location.lng() };
          that.commitGeo(_this3.place, geoCode);
        });
      } else if (this.selectedType === 'radius' && this.place !== null) {
        if (this.inputvalue > 200) {
          this.inputvalue = 200;
        }
        var circles = this.map.initCircleDrawing([{
          Radius: Number(this.inputvalue),
          AddrSearchString: '',
          AddressLine: this.address,
          AddressName: this.name || this.address,
          Latitude: this.place.lat,
          Longitude: this.place.lng,
          Quantity: 0,
          SameState: this.addressSameState
        }], false);
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(circles), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var item = _step3.value;

            this.circleMaps.push(item);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
    },
    commitGeo: function commitGeo(result, geoType) {
      var _this4 = this;

      this.alertDesc = '';
      if (result !== null) {
        if (geoType === this.$store.state.geo.geoTypes.Closex.Code) {
          this.$store.commit('order/cleanGeo');
        }
        var radius = 0;
        var quantity = 0;
        if (this.selectedType === 'quantity') {
          quantity = this.inputvalue;
        } else {
          if (this.inputvalue > 200) {
            this.inputvalue = 200;
          }
          radius = this.inputvalue;
        }
        if (this.orderaddress.length >= 1) {
          if (this.name === '') {
            this.alertDesc = 'Please Enter Address Name';
            return;
          }
          var temp = lodash_default.a.filter(this.orderaddress, function (item) {
            return item.AddressName === _this4.name;
          });
          if (temp.length > 0 && temp[0].AddrSearchString.split(':')[0] != this.place.lng && temp[0].AddrSearchString.split(':')[1] != this.place.lat) {
            this.alertDesc = 'Address Name already exists, please change one';
            return;
          }
        }
        var searchstring = this.place.lng + ':' + this.place.lat + ':' + this.inputvalue + ':2';
        this.$store.commit('order/addAddress', {
          Radius: Number(radius),
          AddrSearchString: searchstring,
          AddressLine: this.address,
          AddressName: this.name || this.address,
          Latitude: this.place.lat,
          Longitude: this.place.lng,
          Quantity: quantity,
          SameState: this.addressSameState
        });
        this.$store.commit('order/addGeo', {
          AddressLine: searchstring,
          GeoKeyCode: searchstring,
          GeoKeyDesc: this.address,
          GeoType: geoType
        });
      } else {
        this.alertDesc = 'Please note: The address entered was not found ';
      }
    },
    showQuestion: function showQuestion() {
      this.$root.$emit('bv::show::modal', 'question');
    },
    next: function next() {
      this.$store.dispatch('geo/next');
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    search: function search() {
      var that = this;
      this.map.textSearch(this.address, function (resp) {
        if (resp.placesresult !== null) {
          that.place = { lat: resp.placesresult.geometry.location.lat(), lng: resp.placesresult.geometry.location.lng() };
          that.markers.push(resp.marker);
        } else {
          that.alertDesc = 'No results found for address';
        }
      });
    },
    toggleFullScreen: function toggleFullScreen(val) {
      this.fullScreen = val;
    },
    updateMap: function updateMap() {
      console.log(this.circleMaps);
      // Avoid update map in other page
      if (this.$route.name !== 'geo-radius') {
        return;
      }
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(this.markers), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          if (item) {
            item.setMap(null);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.circleMaps), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _item = _step5.value;

          if (_item.c) {
            _item.c.setMap(null);
          }
          if (_item.m && _item.m !== null) {
            _item.m.setMap(null);
          }
        }
        // GeoType set single radius
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      if (this.orderaddress.length === 1 && this.geoType === this.$store.state.geo.geoTypes.AcxiomMultiRadius.Code) {
        this.granularityDisable = false;
        this.$store.commit('order/changeGeoType', this.$store.state.geo.geoTypes.Radius.Code);
      }

      // GeoType set mult radius
      if (this.orderaddress.length >= 2 && this.geoType === this.$store.state.geo.geoTypes.Radius.Code) {
        this.granularityDisable = true;
        this.$store.commit('order/changeGeoType', this.$store.state.geo.geoTypes.AcxiomMultiRadius.Code);
      }
      if (this.geoType === 16 || this.geoType === 7) {
        this.circleMaps = this.map.initCircleDrawing(this.orderaddress, true) || [];
        this.$store.commit('geo/saveCircles', this.circleMaps);
      }
    },
    initMap: function initMap() {
      // Update Map
      if (this.orderaddress.length > 0) {
        // radius
        if (this.geoType === 16 || this.geoType === 7) {
          this.address = this.orderaddress[0].AddressLine;
          this.inputvalue = this.orderaddress[0].Radius;
          this.name = this.orderaddress[0].AddressName;
          this.place = { lat: this.orderaddress[0].AddrSearchString.split(':')[1], lng: this.orderaddress[0].AddrSearchString.split(':')[0] };
        } else if (this.geoType === 12) {
          // closeX
          this.address = this.orderaddress[0].AddressLine;
          this.inputvalue = this.orderaddress[0].Quantity;
          this.selectedType = 'quantity';
          this.place = { lat: this.orderaddress[0].AddrSearchString.split(':')[1], lng: this.orderaddress[0].AddrSearchString.split(':')[0] };
          this.markers.push(this.map.marker({ lat: Number(this.orderaddress[0].Latitude), lng: Number(this.orderaddress[0].Longitude) }));
          this.map.map.setCenter({ lat: Number(this.orderaddress[0].Latitude), lng: Number(this.orderaddress[0].Longitude) });
          this.map.map.setZoom(12);
        }
      }
    },
    mapPanto: function mapPanto(address, index) {
      // this.map.map.setZoom(12) circleMaps
      this.map.map.fitBounds(this.circleMaps[index].c.getBounds());
      this.map.map.panTo({ lat: Number(address.Latitude), lng: Number(address.Longitude) });
      if (this.address !== address.AddressLine) {
        this.address = address.AddressLine;
        this.inputvalue = address.Radius;
        this.name = address.AddressName;
        this.place = { lat: address.AddrSearchString.split(':')[1], lng: address.AddrSearchString.split(':')[0] };
      }
    },
    deleteGeo: function deleteGeo(keyCode) {
      this.$store.commit('order/deleteGeo', keyCode);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f205fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MMapRadius.vue
var MMapRadius_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-t"},[_c('m-upload-multi-address'),_vm._v(" "),_c('m-question',{attrs:{"link":_vm.$store.getters['config/link']('radiusQuestion') + '&siteId=' + _vm.$store.state.site.SiteId}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('div',{class:{'map-full-screen-input': _vm.fullScreen}},[_c('b-row',[_c('b-col',{staticClass:"inputcol m-col-top",attrs:{"md":"7","sm":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"address-input form-control",attrs:{"id":"radius-address","placeholder":"Enter an address, city or ZIP code"},domProps:{"value":(_vm.address)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"change":function($event){return _vm.addressChange($event)},"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('b-col',{staticClass:"flex-center m-col-top",staticStyle:{"padding-left":"0"},attrs:{"md":"5","sm":"12"}},[_c('span',{staticStyle:{"margin-right":"16px"}},[_vm._v("Granularity")]),_vm._v(" "),_c('b-form-select',{staticClass:"address-input",attrs:{"disabled":_vm.granularityDisable,"data-test":"geo-radius-granularity"},model:{value:(_vm.granularity),callback:function ($$v) {_vm.granularity=$$v},expression:"granularity"}},[_c('option',{attrs:{"value":"1","checked":""}},[_vm._v("Standard")]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.showZip4),expression:"showZip4"}],attrs:{"value":"2"}},[_vm._v("ZIP4")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Carrier Route")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("ZIP Code")])]),_vm._v(" "),_c('icon',{staticStyle:{"color":"#e04557","height":"24px","margin-left":"16px","width":"36px","cursor":"pointer"},attrs:{"name":"question-circle","title":"help"},nativeOn:{"click":function($event){return _vm.showQuestion($event)}}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"padding-left":"0"}},[_c('div',{staticClass:"action-box"},[_c('div',{staticClass:"qty-box"},[_c('b-form-radio-group',{staticClass:"qty-radio",attrs:{"data-test":"geo-radius-type","plain":""},on:{"change":function($event){return _vm.radiusTypeChange($event)}},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}},[_c('b-form-radio',{attrs:{"value":"radius"}},[_vm._v("Radius (miles)")]),_vm._v(" "),(_vm.hasCloseX)?_c('b-form-radio',{attrs:{"value":"quantity"}},[_vm._v(" Closest prospects (quantity)")]):_vm._e()],1),_vm._v(" "),_c('b-input',{staticClass:"qty-input",attrs:{"data-test":"geo-radius-qty"},on:{"change":_vm.quantityChange},model:{value:(_vm.inputvalue),callback:function ($$v) {_vm.inputvalue=$$v},expression:"inputvalue"}}),_vm._v("\n              Address Name:\n              "),_c('b-input',{staticClass:"name-input",attrs:{"data-test":"geo-radius-qty"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('b-btn',{attrs:{"data-test":"geo-radius-add","disabled":_vm.radiusDisable},on:{"click":_vm.drawingRadius}},[_vm._v("Add")])],1)])])],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"0"}},[_c('b-col',{staticStyle:{"padding-left":"0"}},[(_vm.hasMulti)?_c('b-link',{staticStyle:{"margin-right":"32px","margin-bottom":"8px"},attrs:{"disabled":_vm.radiusDisable},on:{"click":_vm.uploadFile}},[_vm._v("> Upload file with multiple addresses\n        ")]):_vm._e(),_vm._v(" "),(_vm.datasource.hasBreakDown)?_c('b-form-checkbox',{staticStyle:{"margin-right":"32px"},model:{value:(_vm.breakdown),callback:function ($$v) {_vm.breakdown=$$v},expression:"breakdown"}},[_vm._v("See breakdown with my results")]):_vm._e(),_vm._v(" "),(_vm.datasource.code != 150 && _vm.datasource.code != 160 && _vm.datasource.code != 250 && _vm.datasource.code != 260 && _vm.datasource.code != 50)?_c('b-form-checkbox',{model:{value:(_vm.sameState),callback:function ($$v) {_vm.sameState=$$v},expression:"sameState"}},[_vm._v("Do not cross state lines")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"circle"},[_c('b-col',[_c('div',{staticClass:"circle",attrs:{"id":"maps"}},[_c('b-alert',{attrs:{"show":_vm.alertDesc!=='',"variant":"warning"}},[_vm._v(_vm._s(_vm.alertDesc))]),_vm._v(" "),_c('m-map',{attrs:{"map-id":"mapCircle"},on:{"load":_vm.createMap,"full-screen":_vm.toggleFullScreen}}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.orderaddress),function(item,index){return (item.AddrUsageType===2 && _vm.geoType !== 12)?_c('div',[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.mapPanto(item, index)}}},[_vm._v(_vm._s(item.AddressLine))]),_c('span',{staticStyle:{"color":"red","margin-left":"8px"},on:{"click":function($event){return _vm.deleteGeo(item.AddrSearchString)}}},[_c('icon',{staticClass:"times-icon",attrs:{"name":"times-circle"}})],1)]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"self-btns"},[_c('b-btn',{on:{"click":_vm.clearCircle}},[_vm._v("Clear")])],1)],2)])],1)],1)],1)}
var MMapRadius_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h3',[_vm._v("\n      Radius around an Address or City\n    ")])])}]
var MMapRadius_esExports = { render: MMapRadius_render, staticRenderFns: MMapRadius_staticRenderFns }
/* harmony default export */ var geo_MMapRadius = (MMapRadius_esExports);
// CONCATENATED MODULE: ./src/components/geo/MMapRadius.vue
function MMapRadius_injectStyle (ssrContext) {
  __webpack_require__("ZRBE")
}
var MMapRadius_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MMapRadius___vue_template_functional__ = false
/* styles */
var MMapRadius___vue_styles__ = MMapRadius_injectStyle
/* scopeId */
var MMapRadius___vue_scopeId__ = "data-v-30f205fa"
/* moduleIdentifier (server only) */
var MMapRadius___vue_module_identifier__ = null
var MMapRadius_Component = MMapRadius_normalizeComponent(
  MMapRadius,
  geo_MMapRadius,
  MMapRadius___vue_template_functional__,
  MMapRadius___vue_styles__,
  MMapRadius___vue_scopeId__,
  MMapRadius___vue_module_identifier__
)

/* harmony default export */ var components_geo_MMapRadius = (MMapRadius_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoRadius.vue
//
//
//
//
//
//




/* harmony default export */ var GeoRadius = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MMapRadius: components_geo_MMapRadius
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  methods: {},
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-883111ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoRadius.vue
var GeoRadius_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"radius"}},[_c('m-map-radius')],1)}
var GeoRadius_staticRenderFns = []
var GeoRadius_esExports = { render: GeoRadius_render, staticRenderFns: GeoRadius_staticRenderFns }
/* harmony default export */ var order_GeoRadius = (GeoRadius_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoRadius.vue
function GeoRadius_injectStyle (ssrContext) {
  __webpack_require__("2mr5")
}
var GeoRadius_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoRadius___vue_template_functional__ = false
/* styles */
var GeoRadius___vue_styles__ = GeoRadius_injectStyle
/* scopeId */
var GeoRadius___vue_scopeId__ = "data-v-883111ca"
/* moduleIdentifier (server only) */
var GeoRadius___vue_module_identifier__ = null
var GeoRadius_Component = GeoRadius_normalizeComponent(
  GeoRadius,
  order_GeoRadius,
  GeoRadius___vue_template_functional__,
  GeoRadius___vue_styles__,
  GeoRadius___vue_scopeId__,
  GeoRadius___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoRadius = (GeoRadius_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoCounty.vue
//
//
//
//
//
//



/* harmony default export */ var GeoCounty = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MGeoSelect: components_geo_MGeoSelect
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9701702","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoCounty.vue
var GeoCounty_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"county"}},[_c('m-geo-select',{attrs:{"geoType":3,"changeGeoType":3}})],1)}
var GeoCounty_staticRenderFns = []
var GeoCounty_esExports = { render: GeoCounty_render, staticRenderFns: GeoCounty_staticRenderFns }
/* harmony default export */ var order_GeoCounty = (GeoCounty_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoCounty.vue
function GeoCounty_injectStyle (ssrContext) {
  __webpack_require__("Ezwu")
}
var GeoCounty_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoCounty___vue_template_functional__ = false
/* styles */
var GeoCounty___vue_styles__ = GeoCounty_injectStyle
/* scopeId */
var GeoCounty___vue_scopeId__ = "data-v-a9701702"
/* moduleIdentifier (server only) */
var GeoCounty___vue_module_identifier__ = null
var GeoCounty_Component = GeoCounty_normalizeComponent(
  GeoCounty,
  order_GeoCounty,
  GeoCounty___vue_template_functional__,
  GeoCounty___vue_styles__,
  GeoCounty___vue_scopeId__,
  GeoCounty___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoCounty = (GeoCounty_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoMetroArea.vue
//
//
//
//
//
//



/* harmony default export */ var GeoMetroArea = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MGeoSelect: components_geo_MGeoSelect
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a17e70e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoMetroArea.vue
var GeoMetroArea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"metroArea"}},[_c('m-geo-select',{attrs:{"geoType":10,"changeGeoType":10}})],1)}
var GeoMetroArea_staticRenderFns = []
var GeoMetroArea_esExports = { render: GeoMetroArea_render, staticRenderFns: GeoMetroArea_staticRenderFns }
/* harmony default export */ var order_GeoMetroArea = (GeoMetroArea_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoMetroArea.vue
function GeoMetroArea_injectStyle (ssrContext) {
  __webpack_require__("n/Ip")
}
var GeoMetroArea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoMetroArea___vue_template_functional__ = false
/* styles */
var GeoMetroArea___vue_styles__ = GeoMetroArea_injectStyle
/* scopeId */
var GeoMetroArea___vue_scopeId__ = "data-v-0a17e70e"
/* moduleIdentifier (server only) */
var GeoMetroArea___vue_module_identifier__ = null
var GeoMetroArea_Component = GeoMetroArea_normalizeComponent(
  GeoMetroArea,
  order_GeoMetroArea,
  GeoMetroArea___vue_template_functional__,
  GeoMetroArea___vue_styles__,
  GeoMetroArea___vue_scopeId__,
  GeoMetroArea___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoMetroArea = (GeoMetroArea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoCity.vue
//
//
//
//
//
//



/* harmony default export */ var GeoCity = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MGeoSelect: components_geo_MGeoSelect
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9d9a8be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoCity.vue
var GeoCity_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"city"}},[_c('m-geo-select',{attrs:{"geoType":4,"changeGeoType":4}})],1)}
var GeoCity_staticRenderFns = []
var GeoCity_esExports = { render: GeoCity_render, staticRenderFns: GeoCity_staticRenderFns }
/* harmony default export */ var order_GeoCity = (GeoCity_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoCity.vue
function GeoCity_injectStyle (ssrContext) {
  __webpack_require__("/RA0")
}
var GeoCity_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoCity___vue_template_functional__ = false
/* styles */
var GeoCity___vue_styles__ = GeoCity_injectStyle
/* scopeId */
var GeoCity___vue_scopeId__ = "data-v-a9d9a8be"
/* moduleIdentifier (server only) */
var GeoCity___vue_module_identifier__ = null
var GeoCity_Component = GeoCity_normalizeComponent(
  GeoCity,
  order_GeoCity,
  GeoCity___vue_template_functional__,
  GeoCity___vue_styles__,
  GeoCity___vue_scopeId__,
  GeoCity___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoCity = (GeoCity_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoCongressionalDistrict.vue
//
//
//
//
//
//



/* harmony default export */ var GeoCongressionalDistrict = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MGeoSelect: components_geo_MGeoSelect
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4795504a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoCongressionalDistrict.vue
var GeoCongressionalDistrict_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"congressionalDistrict"}},[_c('m-geo-select',{attrs:{"geoType":22,"changeGeoType":22}})],1)}
var GeoCongressionalDistrict_staticRenderFns = []
var GeoCongressionalDistrict_esExports = { render: GeoCongressionalDistrict_render, staticRenderFns: GeoCongressionalDistrict_staticRenderFns }
/* harmony default export */ var order_GeoCongressionalDistrict = (GeoCongressionalDistrict_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoCongressionalDistrict.vue
function GeoCongressionalDistrict_injectStyle (ssrContext) {
  __webpack_require__("h72j")
}
var GeoCongressionalDistrict_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoCongressionalDistrict___vue_template_functional__ = false
/* styles */
var GeoCongressionalDistrict___vue_styles__ = GeoCongressionalDistrict_injectStyle
/* scopeId */
var GeoCongressionalDistrict___vue_scopeId__ = "data-v-4795504a"
/* moduleIdentifier (server only) */
var GeoCongressionalDistrict___vue_module_identifier__ = null
var GeoCongressionalDistrict_Component = GeoCongressionalDistrict_normalizeComponent(
  GeoCongressionalDistrict,
  order_GeoCongressionalDistrict,
  GeoCongressionalDistrict___vue_template_functional__,
  GeoCongressionalDistrict___vue_styles__,
  GeoCongressionalDistrict___vue_scopeId__,
  GeoCongressionalDistrict___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoCongressionalDistrict = (GeoCongressionalDistrict_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoMoreArea.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var GeoMoreArea = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MGeoSelect: components_geo_MGeoSelect,
    MGeoZip: components_geo_MGeoZip,
    MGeoStateBox: components_geo_MGeoStateBox
  },
  data: function data() {
    return {
      isGo: false,
      step: 'zip',
      geoOptions: [{
        name: 'zip',
        desc: 'Zip'
      }, {
        name: 'city',
        desc: 'City'
      }, {
        name: 'county',
        desc: 'County'
      }, {
        name: 'state',
        desc: 'State'
      }]
    };
  },

  methods: {
    tigger: function tigger(s) {
      this.step = s;
    },
    goNext: function goNext() {
      this.isGo = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f8372b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoMoreArea.vue
var GeoMoreArea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"moreArea","need-next":this.step === 'zip'},on:{"go":_vm.goNext}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"geoType"},_vm._l((_vm.geoOptions),function(item){return _c('b-link',{key:item.name,staticClass:"m-btn-check",class:{active: item.name === _vm.step},staticStyle:{"width":"20%"},on:{"click":function($event){return _vm.tigger(item.name)}}},[_vm._v("\n        "+_vm._s(item.desc)+"\n      ")])}),1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('m-geo-zip',{directives:[{name:"show",rawName:"v-show",value:(this.step === 'zip'),expression:"this.step === 'zip'"}],attrs:{"geoType":5,"is-go":_vm.isGo,"changeGeoType":23},on:{"update:isGo":function($event){_vm.isGo=$event},"update:is-go":function($event){_vm.isGo=$event}}}),_vm._v(" "),_c('m-geo-select',{directives:[{name:"show",rawName:"v-show",value:(this.step === 'city'),expression:"this.step === 'city'"}],attrs:{"geoType":4,"changeGeoType":23}}),_vm._v(" "),_c('m-geo-select',{directives:[{name:"show",rawName:"v-show",value:(this.step === 'county'),expression:"this.step === 'county'"}],attrs:{"geoType":3,"changeGeoType":23}}),_vm._v(" "),_c('m-geo-state-box',{directives:[{name:"show",rawName:"v-show",value:(this.step === 'state'),expression:"this.step === 'state'"}],attrs:{"geoType":23}})],1)],1)],1)],1)}
var GeoMoreArea_staticRenderFns = []
var GeoMoreArea_esExports = { render: GeoMoreArea_render, staticRenderFns: GeoMoreArea_staticRenderFns }
/* harmony default export */ var order_GeoMoreArea = (GeoMoreArea_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoMoreArea.vue
function GeoMoreArea_injectStyle (ssrContext) {
  __webpack_require__("SJj4")
}
var GeoMoreArea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoMoreArea___vue_template_functional__ = false
/* styles */
var GeoMoreArea___vue_styles__ = GeoMoreArea_injectStyle
/* scopeId */
var GeoMoreArea___vue_scopeId__ = "data-v-3f8372b8"
/* moduleIdentifier (server only) */
var GeoMoreArea___vue_module_identifier__ = null
var GeoMoreArea_Component = GeoMoreArea_normalizeComponent(
  GeoMoreArea,
  order_GeoMoreArea,
  GeoMoreArea___vue_template_functional__,
  GeoMoreArea___vue_styles__,
  GeoMoreArea___vue_scopeId__,
  GeoMoreArea___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoMoreArea = (GeoMoreArea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/MSCFCode.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MSCFCode = ({
  components: {},
  props: {
    geoType: {
      type: Number
    },
    isGo: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      zips: [],
      zipDesc: '',
      zipType: 1,
      zipFrom: '',
      zipTo: '',
      step: 'zip',
      nextDisabled: false,
      alertDesc: '',
      needCb: false
    };
  },

  computed: {
    realGeoType: function realGeoType() {
      return this.$store.state.config.geoTypes.SCFCode;
    },
    zipTypes: function zipTypes() {
      return this.$store.state.geo.zipTypes;
    },

    // TODO@Pony need update
    geoItems: function geoItems() {
      return this.$store.getters['order/geoItems'];
    }
  },
  watch: {
    isGo: function isGo(val) {
      if (val) {
        this.next();
      }
    }
  },
  created: function created() {
    // add zips
    for (var i = 0; i < 25; i++) {
      this.zips.push({ zip: '' });
    }
  },

  methods: {
    next: function next() {
      if (this.step === 'zip') {
        this.addZip();
      } else if (this.step === 'rangezip') {
        this.rangeaddZip();
      } else {
        this.pasteaddZip();
      }
    },
    addZip: function addZip() {
      var _this = this;

      // read zip from input
      this.lock();
      var zipInputs = JSON.parse(stringify_default()(this.zips));
      var zips = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(zipInputs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var zip = _step.value;

          if (zip.zip.length === 3) {
            zips.push(zip.zip);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (zips.length === 0 && this.geoItems.length > 0 && this.isGo) {
        this.unlock();
        return;
      } else if (zips.length === 0) {
        this.alertDesc = 'Please input at least one SCF Code.';
        this.unlock();
        return;
      }

      // check zip
      this.$http.post('PlaceOrder.aspx/GetZipsByScf', {
        zipType: 1,
        zips: zips
      }).then(function (resp) {
        // add zip to order
        var respZips = resp.body.d.DataSource;
        if (respZips.length !== zips.length) {
          _this.alertDesc = 'Please enter the correct ZIP codes. Invalid or duplicate entries have been removed.';
          _this.$emit('update:isGo', false);
        }
        if (respZips.length === 0 && _this.geoItems.lenght === 0) {
          _this.alertDesc = 'Please input at least one valid zip. Invalid or duplicate entries have been removed.';
          _this.$emit('update:isGo', false);
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(respZips), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _zip = _step2.value;

            _this.$store.commit('order/addGeo', {
              GeoKeyCode: _zip,
              GeoKeyDesc: _zip,
              GeoType: 8
            });
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this.unlock();
      }, function (resp) {
        _this.unlock();
      });
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(this.zips), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          item.zip = '';
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    selectGeoType: function selectGeoType() {
      if (this.order.GeoType !== this.geoType.code) {}
    },
    validZip: function validZip(zips) {
      var _this2 = this;

      this.$http.post('PlaceOrder.aspx/GetZipsByScf', {
        zipType: 0,
        zips: zips
      }).then(function (resp) {
        // add zip to order
        var zips = resp.body.d.DataSource;
        if (zips.length === 0) {
          _this2.alertDesc = 'Please input at least one valid zip. Invalid or duplicate entries have been removed.';
          _this2.unlock();
          return;
        }
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = get_iterator_default()(zips), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var zip = _step4.value;

            _this2.$store.commit('order/addGeo', {
              GeoKeyCode: zip,
              GeoKeyDesc: zip,
              GeoType: 8
            });
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        _this2.zipFrom = '';
        _this2.zipTo = '';
        _this2.unlock();
      }, function (resp) {
        _this2.unlock();
      });
    },
    rangeaddZip: function rangeaddZip() {
      var _this3 = this;

      this.lock();
      if ((this.zipFrom === '' || this.zipTo === '') && this.geoItems.length > 0 && this.isGo) {
        this.unlock();
        return;
      } else if (this.zipFrom === '' || this.zipTo === '') {
        this.alertDesc = 'Please input SCF Code.';
        this.unlock();
        return;
      }

      this.$http.post('PlaceOrder.aspx/GetSCFcodesBySCFRange', {
        fromSCF: this.zipFrom,
        toSCF: this.zipTo,
        maxLength: 500
      }).then(function (resp) {
        _this3.validZip(resp.body.d.DataSource);
      }, function (resp) {
        _this3.unlock();
      });
    },
    switchmenu: function switchmenu(val) {
      if (this.step !== val) {
        this.step = val;
      } else {
        if (this.step === 'zip') {
          this.step = 'rangezip';
        } else {
          this.step = 'zip';
        }
      }
    },
    lock: function lock() {
      this.$store.dispatch('order/changeGeoType', this.geoType);
      this.nextDisabled = true;
      this.alertDesc = '';
    },
    unlock: function unlock() {
      this.nextDisabled = false;
      this.$emit('update:isGo', false);
      if (this.isGo & this.alertDesc === '') {
        this.$store.dispatch('geo/next', true);
      }
    },
    fromChange: function fromChange(v) {
      if (v.length === 3) {
        document.getElementById('zipto').focus();
      }
    },
    nextInput: function nextInput(index, v) {
      if (v.length === 3 && index < 24) {
        document.getElementById('zip' + (index + 1)).focus();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a681ec3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MSCFCode.vue
var MSCFCode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dbox"},[_c('b-alert',{attrs:{"show":_vm.alertDesc!=='',"variant":"warning"}},[_vm._v(_vm._s(_vm.alertDesc))]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"header",on:{"click":function($event){return _vm.switchmenu('zip')}}},[_c('h3',{staticClass:"h3-title"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 'zip'),expression:"step === 'zip'"}],staticClass:"h3-icon",attrs:{"name":"chevron-down"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step !== 'zip'),expression:"step !== 'zip'"}],staticClass:"h3-icon",attrs:{"name":"chevron-right"}}),_vm._v("\n        Enter SCF Codes (up to 25)\n      ")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 'zip'),expression:"step === 'zip'"}],staticClass:"zipr-box "},[_c('div',{staticClass:"zip-code-box"},_vm._l((_vm.zips),function(item,index){return _c('div',{staticClass:"zip-input-box"},[_c('b-input',{staticClass:"zip-input",attrs:{"id":'zip'+index,"maxlength":"3"},on:{"input":function($event){return _vm.nextInput(index,$event)},"change":function($event){return _vm.$store.commit('geo/saveKey', ['geoUnAdd', 'zip'])}},model:{value:(item.zip),callback:function ($$v) {_vm.$set(item, "zip", $$v)},expression:"item.zip"}})],1)}),0),_vm._v(" "),_c('b-btn',{staticStyle:{"display":"block"},attrs:{"variant":"primary","disabled":_vm.nextDisabled,"data-test":"geo-scf-add"},on:{"click":_vm.addZip}},[_vm._v("Add\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"header",on:{"click":function($event){return _vm.switchmenu('rangezip')}}},[_c('h3',{staticClass:"h3-title"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 'rangezip'),expression:"step === 'rangezip'"}],staticClass:"h3-icon",attrs:{"name":"chevron-down"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.step !== 'rangezip'),expression:"step !== 'rangezip'"}],staticClass:"h3-icon",attrs:{"name":"chevron-right"}}),_vm._v("\n        Enter SCF Code Range\n      ")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step=='rangezip'),expression:"step=='rangezip'"}],staticClass:"zip-content-box"},[_c('div',{staticClass:"zipbox"},[_c('b-input',{staticClass:"zip-inputr",attrs:{"maxlength":"3"},on:{"input":function($event){return _vm.fromChange($event)}},model:{value:(_vm.zipFrom),callback:function ($$v) {_vm.zipFrom=$$v},expression:"zipFrom"}}),_vm._v(" "),_c('span',{staticClass:"to"},[_vm._v("to")]),_vm._v(" "),_c('b-input',{staticClass:"zip-inputr zip-to",attrs:{"id":"zipto","maxlength":"3"},model:{value:(_vm.zipTo),callback:function ($$v) {_vm.zipTo=$$v},expression:"zipTo"}})],1)])])],1)}
var MSCFCode_staticRenderFns = []
var MSCFCode_esExports = { render: MSCFCode_render, staticRenderFns: MSCFCode_staticRenderFns }
/* harmony default export */ var geo_MSCFCode = (MSCFCode_esExports);
// CONCATENATED MODULE: ./src/components/geo/MSCFCode.vue
function MSCFCode_injectStyle (ssrContext) {
  __webpack_require__("FZdT")
}
var MSCFCode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSCFCode___vue_template_functional__ = false
/* styles */
var MSCFCode___vue_styles__ = MSCFCode_injectStyle
/* scopeId */
var MSCFCode___vue_scopeId__ = "data-v-3a681ec3"
/* moduleIdentifier (server only) */
var MSCFCode___vue_module_identifier__ = null
var MSCFCode_Component = MSCFCode_normalizeComponent(
  MSCFCode,
  geo_MSCFCode,
  MSCFCode___vue_template_functional__,
  MSCFCode___vue_styles__,
  MSCFCode___vue_scopeId__,
  MSCFCode___vue_module_identifier__
)

/* harmony default export */ var components_geo_MSCFCode = (MSCFCode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoSCFCode.vue
//
//
//
//
//
//




/* harmony default export */ var GeoSCFCode = ({
  components: {
    MGeoBox: components_geo_MGeoBox,
    MSCFCode: components_geo_MSCFCode
  },
  data: function data() {
    return {
      isGo: false
    };
  },

  methods: {
    goNext: function goNext() {
      this.isGo = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db0411aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoSCFCode.vue
var GeoSCFCode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"SCFCode","need-next":true},on:{"go":_vm.goNext}},[_c('m-s-c-f-code',{attrs:{"geoType":8,"is-go":_vm.isGo},on:{"update:isGo":function($event){_vm.isGo=$event},"update:is-go":function($event){_vm.isGo=$event}}})],1)}
var GeoSCFCode_staticRenderFns = []
var GeoSCFCode_esExports = { render: GeoSCFCode_render, staticRenderFns: GeoSCFCode_staticRenderFns }
/* harmony default export */ var order_GeoSCFCode = (GeoSCFCode_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoSCFCode.vue
function GeoSCFCode_injectStyle (ssrContext) {
  __webpack_require__("3Im1")
}
var GeoSCFCode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoSCFCode___vue_template_functional__ = false
/* styles */
var GeoSCFCode___vue_styles__ = GeoSCFCode_injectStyle
/* scopeId */
var GeoSCFCode___vue_scopeId__ = "data-v-db0411aa"
/* moduleIdentifier (server only) */
var GeoSCFCode___vue_module_identifier__ = null
var GeoSCFCode_Component = GeoSCFCode_normalizeComponent(
  GeoSCFCode,
  order_GeoSCFCode,
  GeoSCFCode___vue_template_functional__,
  GeoSCFCode___vue_styles__,
  GeoSCFCode___vue_scopeId__,
  GeoSCFCode___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoSCFCode = (GeoSCFCode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/MSuppressionSelectItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MSuppressionSelectItem = ({
  props: {
    configData: {
      type: Object
    },
    suppressions: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      queryName: '',
      queryNumber: '',
      page: {
        PageNumber: 1,
        SortBy: 'OrderDate',
        FetchTotalRecordCount: true,
        PageSize: 12,
        SortDescending: true,
        start: 0,
        TotalRecordCount: 0
      },
      items: [],
      totalCount: 9999,
      addAllItem: false,
      isInitData: false
    };
  },
  created: function created() {
    this.getSuppression();
  },

  watch: {
    addAllItem: function addAllItem(val) {
      if (val) {
        this.clearItems();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            this.addItem(item);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        this.clearItems();
      }
    }
  },
  computed: {
    listType: function listType() {
      return this.$store.state.order.ListType;
    },
    itemDatas: function itemDatas() {
      if (this.suppressions.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(this.items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            if (this.configData.isFile) {
              item.added = lodash_default.a.findIndex(this.suppressions, { 'SuppressionValue': item['SuppressionValue'] }) >= 0;
            } else if (this.configData.isGeoSLC) {
              item.added = lodash_default.a.findIndex(this.suppressions, { 'GeoKeyCode': item['GeoKeyCode'] }) >= 0;
            } else {
              item.added = lodash_default.a.findIndex(this.suppressions, { code: item['OrderCode'] }) >= 0;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return this.items;
      } else {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(this.items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _item = _step3.value;

            _item.added = false;
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return this.items;
      }
    },
    order: function order() {
      return this.$store.state.order;
    }
  },
  methods: {
    search: function search() {
      this.page.PageNumber = 1;
      this.getSuppression();
    },
    getSuppression: function getSuppression() {
      var _this = this;

      this.isInitData = false;
      this.$http.post(this.configData.getItemUrl, {
        accountId: this.order.AccountId || 0,
        listType: this.listType,
        listtype: this.listType,
        orderName: this.queryName,
        orderNumber: this.queryNumber,
        countName: this.queryName,
        countNumber: this.queryNumber,
        pagingOptions: this.page
      }).then(function (resp) {
        _this.items = resp.body.d.DataSource.Items;
        _this.totalCount = resp.body.d.DataSource.TotalRecordCount;
        _this.isInitData = true;
      }, function (resp) {
        _this.isInitData = true;
      });
    },
    addItem: function addItem(item) {
      if (this.configData.isGeoSLC) {
        this.$set(item, 'added', true);
        item.GeoKeyCode = item.CountId;
        item.GeoKeyDesc = item.OrderDesc;
        item.GeoType = 24;
        this.$store.commit('order/setAllHouseholds');
        this.$store.commit('order/saveKey', ['PhoneOption', '1']);
        this.$store.dispatch('order/changeGeoType', 24);
      }
      this.$store.commit(this.configData.addItemKey, item);
    },
    removeItem: function removeItem(item) {
      this.$store.commit(this.configData.removeItemKey, item);
    },
    clearItems: function clearItems() {
      var key = this.configData.clearItemsKey;
      this.$store.commit('order/saveKey', [key, []]);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa1fbe34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/MSuppressionSelectItem.vue
var MSuppressionSelectItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('p',{staticClass:"m-text-deep"},[_vm._v(_vm._s(_vm.configData.itemTitle))]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"10px"}},[_c('b-form',{attrs:{"inline":""}},[_vm._v("\n      "+_vm._s(_vm.configData.searchText1)+":    "),_c('b-input',{model:{value:(_vm.queryName),callback:function ($$v) {_vm.queryName=$$v},expression:"queryName"}})],1),_vm._v(" "),_c('b-form',{attrs:{"inline":""}},[_vm._v("\n        "+_vm._s(_vm.configData.searchText2)+":    "),_c('b-input',{model:{value:(_vm.queryNumber),callback:function ($$v) {_vm.queryNumber=$$v},expression:"queryNumber"}})],1),_vm._v(" "),_c('b-btn',{on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v(" "),_c('b-form-checkbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.configData.isShowAddAll),expression:"configData.isShowAddAll"}],staticStyle:{"margin-left":"4px"},model:{value:(_vm.addAllItem),callback:function ($$v) {_vm.addAllItem=$$v},expression:"addAllItem"}},[_vm._v("Add All")])],1)]),_vm._v(" "),_c('m-loader',{attrs:{"size":"box","show":!_vm.isInitData}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.itemDatas.length === 0 && _vm.isInitData),expression:"itemDatas.length === 0 && isInitData"}],staticClass:"table-notice"},[_vm._v("There is no available data")]),_vm._v(" "),_c('table',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInitData),expression:"isInitData"}],staticClass:"table"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.configData.itemTitle1))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.configData.itemTitle2))]),_vm._v(" "),(_vm.configData.itemTitle3)?_c('th',[_vm._v(_vm._s(_vm.configData.itemTitle3))]):_vm._e(),_vm._v(" "),(_vm.configData.itemTitle4)?_c('th',[_vm._v(_vm._s(_vm.configData.itemTitle4))]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Action")])]),_vm._v(" "),_vm._l((_vm.itemDatas),function(item){return _c('tr',{staticClass:"tr"},[_c('td',{staticClass:"td"},[_vm._v(_vm._s(_vm._f("formatDate")(item.OrderDate,'MM/DD/YYYY')))]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v(_vm._s(item.OrderCode || item.SuppressionDesc || ''))]),_vm._v(" "),(_vm.configData.itemTitle3)?_c('td',{staticClass:"td"},[_vm._v(_vm._s(item.OrderDesc))]):_vm._e(),_vm._v(" "),(_vm.configData.itemTitle4)?_c('td',{staticClass:"td"},[_vm._v(_vm._s(_vm._f("numberFormat")(item.TotalDesiredQty,'', 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"td"},[_c('b-btn',{directives:[{name:"show",rawName:"v-show",value:(!item.added),expression:"!item.added"}],attrs:{"variant":"sm","data-value":item.OrderCode || item.SuppressionDesc || '',"data-test":("demo-suppression-item-add-" + (_vm.configData.type))},on:{"click":function($event){return _vm.addItem(item)}}},[_vm._v("Add")])],1)])})],2),_vm._v(" "),_c('b-pagination',{attrs:{"size":"sm","total-rows":_vm.totalCount,"per-page":12},on:{"input":_vm.getSuppression},model:{value:(_vm.page.PageNumber),callback:function ($$v) {_vm.$set(_vm.page, "PageNumber", $$v)},expression:"page.PageNumber"}})],1),_vm._v(" "),_c('b-card',{staticStyle:{"margin-top":"16px"}},[_c('p',{staticClass:"m-text-deep"},[_vm._v(_vm._s(_vm.configData.selectedTitle))]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tr',[_c('th',{attrs:{"width":"40%"}},[_vm._v(_vm._s(_vm.configData.selectItemTitle1))]),_vm._v(" "),_c('th',{attrs:{"width":"40%"}},[_vm._v(_vm._s(_vm.configData.selectItemTitle2))]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v("Action")])]),_vm._v(" "),_vm._l((_vm.suppressions),function(item){return _c('tr',{staticClass:"tr"},[_c('td',{staticClass:"td"},[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',{staticClass:"td"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticClass:"td"},[_c('b-btn',{attrs:{"variant":"sm","data-value":item.OrderCode,"data-test":("demo-suppression-item-remove-" + (_vm.configData.type))},on:{"click":function($event){return _vm.removeItem(item)}}},[_vm._v("Remove")])],1)])})],2),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.suppressions.length === 0),expression:"suppressions.length === 0"}],staticClass:"table-notice"},[_vm._v("Please click add in the above table")])])],1)}
var MSuppressionSelectItem_staticRenderFns = []
var MSuppressionSelectItem_esExports = { render: MSuppressionSelectItem_render, staticRenderFns: MSuppressionSelectItem_staticRenderFns }
/* harmony default export */ var demo_MSuppressionSelectItem = (MSuppressionSelectItem_esExports);
// CONCATENATED MODULE: ./src/components/demo/MSuppressionSelectItem.vue
function MSuppressionSelectItem_injectStyle (ssrContext) {
  __webpack_require__("gLkS")
}
var MSuppressionSelectItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSuppressionSelectItem___vue_template_functional__ = false
/* styles */
var MSuppressionSelectItem___vue_styles__ = MSuppressionSelectItem_injectStyle
/* scopeId */
var MSuppressionSelectItem___vue_scopeId__ = "data-v-aa1fbe34"
/* moduleIdentifier (server only) */
var MSuppressionSelectItem___vue_module_identifier__ = null
var MSuppressionSelectItem_Component = MSuppressionSelectItem_normalizeComponent(
  MSuppressionSelectItem,
  demo_MSuppressionSelectItem,
  MSuppressionSelectItem___vue_template_functional__,
  MSuppressionSelectItem___vue_styles__,
  MSuppressionSelectItem___vue_scopeId__,
  MSuppressionSelectItem___vue_module_identifier__
)

/* harmony default export */ var components_demo_MSuppressionSelectItem = (MSuppressionSelectItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/GeoSLCCount.vue

//
//
//
//
//
//



/* harmony default export */ var GeoSLCCount = ({
  components: {
    MSuppressionSelectItem: components_demo_MSuppressionSelectItem,
    MDemoBox: components_geo_MGeoBox
  },
  data: function data() {
    return {
      configData: {
        itemTitle: 'Your Saved Count List',
        selectedTitle: 'Saved Counts Selected',
        getItemUrl: 'PlaceOrder.aspx/GetSaveCountSuppressionList',
        addItemKey: 'order/addGeo',
        removeItemKey: 'order/deleteGeo',
        clearItemsKey: 'OrderGeos',
        searchText1: 'Saved Count Name',
        searchText2: 'Saved Count Number ',
        isShowAddAll: false,
        itemTitle1: 'Count Date',
        itemTitle2: 'Count Number',
        itemTitle3: 'Count Name',
        selectItemTitle1: 'Count Number',
        selectItemTitle2: 'Count Name',
        isGeoSLC: true
      }
    };
  },

  computed: {
    suppressionItems: function suppressionItems() {
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.$store.getters['order/geoItems']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          result.push({
            name: item.GeoKeyDesc,
            code: item.GeoKeyCode,
            GeoKeyCode: item.GeoKeyCode
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a790156a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoSLCCount.vue
var GeoSLCCount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"geo-option":"multiCount"}},[_c('m-suppression-select-item',{attrs:{"configData":_vm.configData,"suppressions":_vm.suppressionItems}})],1)}
var GeoSLCCount_staticRenderFns = []
var GeoSLCCount_esExports = { render: GeoSLCCount_render, staticRenderFns: GeoSLCCount_staticRenderFns }
/* harmony default export */ var order_GeoSLCCount = (GeoSLCCount_esExports);
// CONCATENATED MODULE: ./src/pages/order/GeoSLCCount.vue
function GeoSLCCount_injectStyle (ssrContext) {
  __webpack_require__("h79P")
}
var GeoSLCCount_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GeoSLCCount___vue_template_functional__ = false
/* styles */
var GeoSLCCount___vue_styles__ = GeoSLCCount_injectStyle
/* scopeId */
var GeoSLCCount___vue_scopeId__ = "data-v-a790156a"
/* moduleIdentifier (server only) */
var GeoSLCCount___vue_module_identifier__ = null
var GeoSLCCount_Component = GeoSLCCount_normalizeComponent(
  GeoSLCCount,
  order_GeoSLCCount,
  GeoSLCCount___vue_template_functional__,
  GeoSLCCount___vue_styles__,
  GeoSLCCount___vue_scopeId__,
  GeoSLCCount___vue_module_identifier__
)

/* harmony default export */ var pages_order_GeoSLCCount = (GeoSLCCount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/MEmailOption.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MEmailOption = ({
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedEmailOption: {
      get: function get() {
        return this.$store.state.order.EmailOption;
      },
      set: function set(val) {
        this.$store.commit('order/saveEmailOption', val);
      }
    },
    demoInit: function demoInit() {
      return this.$store.state.demo.isInit;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7f506c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/MEmailOption.vue
var MEmailOption_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-loader',{attrs:{"show":!_vm.demoInit,"size":"smBox"}}),_vm._v(" "),_c('b-form-radio-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.demoInit),expression:"demoInit"}],attrs:{"stacked":"","disabled":_vm.disabled},model:{value:(_vm.selectedEmailOption),callback:function ($$v) {_vm.selectedEmailOption=$$v},expression:"selectedEmailOption"}},[_c('b-form-radio',{key:"0",attrs:{"value":"noemail"}},[_vm._v("\n      I don't need business email addresses.\n    ")]),_vm._v(" "),_c('b-form-radio',{key:"1",attrs:{"value":"onlyemail"}},[_vm._v("\n      I'll take only those records with a business email address.\n    ")]),_vm._v(" "),_c('b-form-radio',{key:"2",attrs:{"value":"email"}},[_vm._v("\n      I'll take those with and without business email addresses.\n    ")])],1)],1)}
var MEmailOption_staticRenderFns = []
var MEmailOption_esExports = { render: MEmailOption_render, staticRenderFns: MEmailOption_staticRenderFns }
/* harmony default export */ var demo_MEmailOption = (MEmailOption_esExports);
// CONCATENATED MODULE: ./src/components/demo/MEmailOption.vue
function MEmailOption_injectStyle (ssrContext) {
  __webpack_require__("dn8f")
}
var MEmailOption_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MEmailOption___vue_template_functional__ = false
/* styles */
var MEmailOption___vue_styles__ = MEmailOption_injectStyle
/* scopeId */
var MEmailOption___vue_scopeId__ = "data-v-d7f506c2"
/* moduleIdentifier (server only) */
var MEmailOption___vue_module_identifier__ = null
var MEmailOption_Component = MEmailOption_normalizeComponent(
  MEmailOption,
  demo_MEmailOption,
  MEmailOption___vue_template_functional__,
  MEmailOption___vue_styles__,
  MEmailOption___vue_scopeId__,
  MEmailOption___vue_module_identifier__
)

/* harmony default export */ var components_demo_MEmailOption = (MEmailOption_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/M1DemoBox.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var M1DemoBox = ({
  components: {
    MPhoneOption: components_demo_MPhoneOption,
    MTab: components_elements_MTab,
    MEmailOption: components_demo_MEmailOption
  },
  props: {
    demoOption: {
      type: String,
      default: 'demo' // 'normal', 'quickPick', 'suppression', 'search', 'demo', 'interests', 'audience'
    },
    hasSaveQuickPick: {
      type: Boolean,
      default: true
    },
    hasTotalRecords: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      alertDesc: ''
    };
  },
  created: function created() {},

  computed: {
    isBusiness: function isBusiness() {
      var type = this.$store.state.order.ListType;
      return [20, 90, 120, 160, 170, 180, 210, 260].indexOf(type) > -1;
    },
    showEmailOption: function showEmailOption() {
      // return this.$store.state.order.ListType === 260
      return false;
    },
    datasource: function datasource() {
      return this.$store.getters['config/datasource'];
    },
    listType: function listType() {
      return this.$store.state.order.ListType;
    },
    hasPhoneOption: function hasPhoneOption() {
      return this.$store.getters['order/hasPhoneOption'];
    },
    hasEmailOption: function hasEmailOption() {
      return this.$store.getters['order/hasEmailOption'];
    },
    hasDemo: function hasDemo() {
      return this.$store.getters['order/hasDemo'];
    },
    tabs: function tabs() {
      return this.$store.getters['config/datasource'].demoTabs;
    },
    hasGeo: function hasGeo() {
      return this.$store.getters['order/hasGeo'];
    },
    geoItems: function geoItems() {
      return this.$store.getters['order/geoItems'];
    },
    currentGeoType: function currentGeoType() {
      return this.$store.getters['config/currentGeoType'];
    },
    nextDesc: function nextDesc() {
      if (this.hasGeo) {
        return 'Poll Count';
      } else {
        return 'Select Area';
      }
    },
    isTargetoption: function isTargetoption() {
      return this.$store.getters['demo/isTargetoption'];
    },
    isRouteoption: function isRouteoption() {
      return this.$store.getters['demo/isRouteoption'];
    },
    exitQuickPick: function exitQuickPick() {
      var demoTabs = this.$store.getters['config/datasource'].demoTabs;
      var tabHasQuickPick = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(demoTabs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var demo = _step.value;

          if (demo.demoType === 'quickPicks') {
            tabHasQuickPick = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.$store.state.demo.hasQuickPicks || tabHasQuickPick;
    },
    isHidePhoneOption: function isHidePhoneOption() {
      return this.$store.getters['demo/isHidePhoneOption'];
    },
    nextDisabled: function nextDisabled() {
      if (this.$store.state.order.CurrentStep === 'count') {
        return true;
      }
      if (!this.hasDemo) {
        return true;
      }
      // if (!this.hasPhoneOption) {
      //   return true
      // }
      if (this.listType === 50 && !this.isTargetoption) {
        return true;
      }
      if (this.listType === 50 && !this.isRouteoption) {
        return true;
      }
    },
    noPhoneOption: function noPhoneOption() {
      return this.$store.getters['demo/noPhoneOption'];
    }
  },
  methods: {
    getRoute: function getRoute(item) {
      this.$router.push({ name: 'demo-' + item.demoType });
    },
    saveQuickPick: function saveQuickPick() {
      this.$root.$emit('bv::show::modal', 'saveQuickPick');
    },
    next: function next() {
      this.alertDesc = '';
      // check have phoneOption
      if (!this.hasDemo) {
        this.alertDesc += 'Please Defined Target Audience<br>';
      }
      if (!this.hasPhoneOption && !this.noPhoneOption && this.isHidePhoneOption) {
        this.alertDesc += 'Please select a Phone Option<br>';
      }
      if (this.listType === 50 && !this.isTargetoption) {
        this.alertDesc += 'Please select at least one targeting option<br>';
      }
      if (this.listType === 50 && !this.isRouteoption) {
        this.alertDesc += 'Please select at least one route option<br>';
      }
      if (this.alertDesc === '') {
        if (this.hasGeo || this.$store.state.order.GeoType === 20 || this.$store.state.order.GeoType === 23) {
          this.$store.dispatch('order/submitOrder');
        } else {
          this.$router.push({ name: 'geo' });
        }
      }
    },
    goBack: function goBack() {
      this.$router.push({ name: 'geo' });
    },
    showTotalRecords: function showTotalRecords() {
      this.$root.$emit('bv::show::modal', 'totalRecords');
    }
  },
  watch: {
    '$route.name': function $routeName() {
      if (this.listType === 50 && this.$route.name === 'demo-demoDemographics') {
        this.$router.push('/order/50/demo/residentOccupantList');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-627d0102","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/M1DemoBox.vue
var M1DemoBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-tab',{attrs:{"step":"demo"}},[(!_vm.isBusiness)?_c('div',{staticClass:"m-tab-top-box"},[_vm._v("Use the tabs below to define your target audience using demographic or interest and purchasing attributes")]):_vm._e(),_vm._v(" "),(_vm.isBusiness)?_c('div',{staticClass:"m-tab-top-box"},[_vm._v("Use the tabs below to define your target audience using business types and demographic options")]):_vm._e(),_vm._v(" "),(_vm.tabs.length !== 1)?_c('div',{staticClass:"m-tabs"},_vm._l((_vm.tabs),function(item){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(item.demoType !== 'quickPicks' || (item.demoType === 'quickPicks' && _vm.exitQuickPick)),expression:"item.demoType !== 'quickPicks' || (item.demoType === 'quickPicks' && exitQuickPick)"}],key:item.demoType,staticClass:"m-tab",class:{'m-tab-active': _vm.demoOption === item.demoType}},[(item.access)?_c('b-link',{style:({'margin-right': (item.video !== '' ? '2%' : '0' )}),attrs:{"data-test":("demo-box-tab-" + (item.demoType))},on:{"click":function($event){return _vm.getRoute(item)}}},[_vm._v(_vm._s(item.title))]):_vm._e(),_vm._v(" "),(item.video !== '')?_c('a',{staticStyle:{"display":"flex"},attrs:{"data-fancybox":"","href":item.video}},[_c('img',{attrs:{"src":__webpack_require__("aQR6"),"alt":"Video"}})]):_vm._e()],1)}),0):_vm._e(),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"top-btn-box"},[_c('div',{staticClass:"bootom-btn"},[_c('b-btn',{on:{"click":_vm.goBack}},[_vm._v("Back")]),_vm._v(" "),_c('div',{staticClass:"next-box"},[_c('b-btn',{attrs:{"variant":"primary","disabled":_vm.nextDisabled},on:{"click":_vm.next}},[_vm._v("Next")])],1)],1),_vm._v(" "),_vm._t("top")],2),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"7px"}},[_c('b-col',{attrs:{"md":"5","offset-md":"7"}},[(_vm.hasSaveQuickPick && _vm.exitQuickPick)?_c('span',{staticClass:"m-link-go",on:{"click":_vm.saveQuickPick}},[_vm._v("Save As a QuickPick ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isHidePhoneOption),expression:"!isHidePhoneOption"}],staticClass:"phone-row"},[_c('b-col',[_c('h4',[_vm._v("Phone Option")])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.alertDesc!==''),expression:"alertDesc!==''"}],staticStyle:{"margin-top":"16px","margin-bottom":"-16px","margin-left":"8px"}},[_c('b-col',[_c('b-alert',{attrs:{"variant":"warning","show":""},domProps:{"innerHTML":_vm._s(_vm.alertDesc)}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box"},[_c('m-phone-option')],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEmailOption),expression:"showEmailOption"}],staticClass:"phone-row"},[_c('b-col',[_c('h4',[_vm._v("Email Option")])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEmailOption),expression:"showEmailOption"}]},[_c('b-col',{staticClass:"box"},[_c('m-email-option')],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-box-bottom",staticStyle:{"margin-top":"-8px"}},[_c('div',{staticClass:"bootom-btn"},[_c('b-btn',{on:{"click":_vm.goBack}},[_vm._v("Back")]),_vm._v(" "),_c('div',{staticClass:"next-box"},[_c('b-btn',{attrs:{"variant":"primary","data-test":"demo-next","disabled":_vm.nextDisabled},on:{"click":_vm.next}},[_vm._v("Next")])],1)],1),_vm._v(" "),_c('span'),_vm._v(" "),(_vm.hasTotalRecords && _vm.datasource.hasRecordsWithPhone)?_c('span',{staticClass:"m-link-go"},[_c('span',{directives:[{name:"b-popover",rawName:"v-b-popover.hover",value:('See a total number of records with and without phone numbers.'),expression:"'See a total number of records with and without phone numbers.'",modifiers:{"hover":true}}],on:{"click":_vm.showTotalRecords}},[_vm._v("View breakdown of records with and without phone numbers")])]):_vm._e()])],2)],1)}
var M1DemoBox_staticRenderFns = []
var M1DemoBox_esExports = { render: M1DemoBox_render, staticRenderFns: M1DemoBox_staticRenderFns }
/* harmony default export */ var demo_M1DemoBox = (M1DemoBox_esExports);
// CONCATENATED MODULE: ./src/components/demo/M1DemoBox.vue
function M1DemoBox_injectStyle (ssrContext) {
  __webpack_require__("gqF5")
}
var M1DemoBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var M1DemoBox___vue_template_functional__ = false
/* styles */
var M1DemoBox___vue_styles__ = M1DemoBox_injectStyle
/* scopeId */
var M1DemoBox___vue_scopeId__ = "data-v-627d0102"
/* moduleIdentifier (server only) */
var M1DemoBox___vue_module_identifier__ = null
var M1DemoBox_Component = M1DemoBox_normalizeComponent(
  M1DemoBox,
  demo_M1DemoBox,
  M1DemoBox___vue_template_functional__,
  M1DemoBox___vue_styles__,
  M1DemoBox___vue_scopeId__,
  M1DemoBox___vue_module_identifier__
)

/* harmony default export */ var components_demo_M1DemoBox = (M1DemoBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/M2DemoBox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var M2DemoBox = ({
  components: {},
  props: {
    demoOption: {
      type: String,
      default: 'demo' // 'normal', 'quickPick', 'suppression', 'search', 'demo', 'interests', 'audience'
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    datasource: function datasource() {
      return this.$store.getters['config/datasource'];
    },
    demoTabs: function demoTabs() {
      return this.$store.getters['config/datasource'].demoTabs;
    }
  },
  created: function created() {},
  activated: function activated() {
    var _this = this;

    setTimeout(function () {
      _this.$scrollTo('#demo-tab-' + _this.demoOption, 1, { x: true, y: false, container: '.m-scroll-v', duration: 1 });
    }, 100);
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      _this2.$scrollTo('#demo-tab-' + _this2.demoOption, 1, { x: true, y: false, container: '.m-scroll-v', duration: 1 });
    }, 100);
  },

  methods: {
    go: function go(item) {
      this.$router.push({ name: 'demo-' + item.demoType });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1e890e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/M2DemoBox.vue
var M2DemoBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-dialog',{attrs:{"page":"","name":"demo","title":"Select Demographic"},on:{"close":function($event){return _vm.$router.push({name: 'order'})}}},[_c('div',{staticClass:"m-scroll-v",attrs:{"slot":"menu"},slot:"menu"},_vm._l((_vm.demoTabs),function(item){return _c('b-link',{key:item.name,staticClass:"m-scroll-v-tab",class:{'m-scroll-v-tab-active': item.demoType === _vm.demoOption},attrs:{"id":'demo-tab-' + item.demoType},on:{"click":function($event){return _vm.go(item)}}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])}),1),_vm._v(" "),_c('m-box',[_vm._t("default")],2),_vm._v(" "),_c('b-btn',{staticStyle:{"margin-left":"8px"},attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$router.push({name: 'order'})}}},[_vm._v("Done")])],1)}
var M2DemoBox_staticRenderFns = []
var M2DemoBox_esExports = { render: M2DemoBox_render, staticRenderFns: M2DemoBox_staticRenderFns }
/* harmony default export */ var demo_M2DemoBox = (M2DemoBox_esExports);
// CONCATENATED MODULE: ./src/components/demo/M2DemoBox.vue
function M2DemoBox_injectStyle (ssrContext) {
  __webpack_require__("KHvb")
}
var M2DemoBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var M2DemoBox___vue_template_functional__ = false
/* styles */
var M2DemoBox___vue_styles__ = M2DemoBox_injectStyle
/* scopeId */
var M2DemoBox___vue_scopeId__ = "data-v-f1e890e0"
/* moduleIdentifier (server only) */
var M2DemoBox___vue_module_identifier__ = null
var M2DemoBox_Component = M2DemoBox_normalizeComponent(
  M2DemoBox,
  demo_M2DemoBox,
  M2DemoBox___vue_template_functional__,
  M2DemoBox___vue_styles__,
  M2DemoBox___vue_scopeId__,
  M2DemoBox___vue_module_identifier__
)

/* harmony default export */ var components_demo_M2DemoBox = (M2DemoBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/MDemoBox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MDemoBox = ({
  components: {
    M1DemoBox: components_demo_M1DemoBox,
    M2DemoBox: components_demo_M2DemoBox
  },
  props: {
    demoOption: {
      type: String,
      default: 'demo' // 'normal', 'quickPick', 'suppression', 'search', 'demo', 'interests', 'audience'
    },
    hasSaveQuickPick: {
      type: Boolean,
      default: true
    },
    hasTotalRecords: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    uiVersion: function uiVersion() {
      return this.$store.state.config.uiVersion;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94b6a57c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/MDemoBox.vue
var MDemoBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.uiVersion === 1)?_c('m1-demo-box',{attrs:{"demoOption":_vm.demoOption,"hasSaveQuickPick":_vm.hasSaveQuickPick,"hasTotalRecords":_vm.hasTotalRecords}},[_c('template',{slot:"top"},[_vm._t("top")],2),_vm._v(" "),_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.uiVersion === 2)?_c('m2-demo-box',{attrs:{"demoOption":_vm.demoOption}},[_vm._t("default")],2):_vm._e()],1)}
var MDemoBox_staticRenderFns = []
var MDemoBox_esExports = { render: MDemoBox_render, staticRenderFns: MDemoBox_staticRenderFns }
/* harmony default export */ var demo_MDemoBox = (MDemoBox_esExports);
// CONCATENATED MODULE: ./src/components/demo/MDemoBox.vue
function MDemoBox_injectStyle (ssrContext) {
  __webpack_require__("ZUdV")
}
var MDemoBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MDemoBox___vue_template_functional__ = false
/* styles */
var MDemoBox___vue_styles__ = MDemoBox_injectStyle
/* scopeId */
var MDemoBox___vue_scopeId__ = "data-v-94b6a57c"
/* moduleIdentifier (server only) */
var MDemoBox___vue_module_identifier__ = null
var MDemoBox_Component = MDemoBox_normalizeComponent(
  MDemoBox,
  demo_MDemoBox,
  MDemoBox___vue_template_functional__,
  MDemoBox___vue_styles__,
  MDemoBox___vue_scopeId__,
  MDemoBox___vue_module_identifier__
)

/* harmony default export */ var components_demo_MDemoBox = (MDemoBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/MDemoSelect.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MDemoSelect = ({
  props: {
    propDemoType: {
      type: Number,
      default: 1
    },
    specialDemoCategory: {
      type: [Number, Boolean],
      default: false
    },
    needDemo: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data: function data() {
    return {
      categories: [{
        demoType: 18,
        desc: 'Automotive'
      }, {
        demoType: 16,
        desc: 'Business'
      }, {
        demoType: 15,
        desc: 'Consumer Packaged Goods'
      }, {
        demoType: 14,
        desc: 'Communications'
      }, {
        demoType: 19,
        desc: 'Credit Card'
      }, {
        demoType: 17,
        desc: 'Financial Services'
      }, {
        demoType: 3,
        desc: 'General'
      }, {
        demoType: 4,
        desc: 'Health Care'
      }, {
        demoType: 5,
        desc: 'Insurance'
      }, {
        demoType: 6,
        desc: 'Investment Services'
      }, {
        demoType: 7,
        desc: 'Media'
      }, {
        demoType: 8,
        desc: 'Non-Profit'
      }, {
        demoType: 9,
        desc: 'Political'
      }, {
        demoType: 10,
        desc: 'Retail'
      }, {
        demoType: 12,
        desc: 'Travel Entertainment'
      }, {
        demoType: 13,
        desc: 'Technology'
      }],
      selectedDemoType: 18,
      demoTypeInit: false,
      selectedColumn: '',
      selectedAttributes: [],
      unSelectedDemos: [],
      inputFrom: '',
      inputTo: '',
      inputError: ''
    };
  },

  watch: {
    '$route.params.listType': function $routeParamsListType() {
      // TODO@PONY
      var listType = parseInt(this.$route.params.listType);
      if (listType !== this.$store.state.order.listType) {
        this.selectedColumn = '';
      }
    }
  },
  computed: {
    selectFromHeight: function selectFromHeight() {
      return this.needDemo ? '124px' : '194px';
    },
    selectFormSize: function selectFormSize() {
      return this.needDemo ? 5 : 9;
    },

    demoType: {
      get: function get() {
        if (this.needDemo) {
          return this.selectedDemoType;
        } else {
          return this.propDemoType;
        }
      },
      set: function set(val) {
        if (this.selectedDemoType !== val) {
          this.selectedDemoType = val;
          this.selectedColumn = '';
        }
      }
    },
    listType: function listType() {
      if (this.$store.state.order.ListType) {
        return this.$store.state.order.ListType;
      } else {
        return 10;
      }
    },
    inputFromHolder: function inputFromHolder() {
      var dict = {
        0: '',
        1: 'YYYYMMDD',
        2: 'Interger',
        3: 'MMYYYY',
        4: 'YYYY',
        5: 'MM',
        6: 'SIC Code',
        7: 'String',
        8: 'radio',
        9: 'input or string'
      };
      if (dict.hasOwnProperty(this.selectedColumnItem.DemoInputtype)) {
        var str = dict[this.selectedColumnItem.DemoInputtype];
        var maxmin = '';
        if (this.selectedColumnItem.MinValue) {
          maxmin += 'Min:' + this.selectedColumnItem.MinValue;
        }
        if (maxmin.length > 0) {
          maxmin += ';';
        }
        if (this.selectedColumnItem.MaxValue) {
          maxmin = 'Max:' + this.selectedColumnItem.MaxValue;
        }
        if (maxmin.length > 0) {
          str += '(' + maxmin + ')';
        }
        return str;
      } else {
        return '';
      }
    },
    inputToHolder: function inputToHolder() {
      return this.inputFromHolder;
    },
    selectedColumnItem: function selectedColumnItem() {
      if (this.selectedColumn.length !== 0 && this.columns.hasOwnProperty(this.selectedColumn)) {
        this.inputFrom = '';
        this.inputTo = '';
        this.inputError = '';
        return this.columns[this.selectedColumn];
      } else {
        return {};
      }
    },
    demos: function demos() {
      return this.$store.state.demo.demos;
    },
    selectedDemos: function selectedDemos() {
      var demos = this.$store.getters['order/demoItems'];
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(demos), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column = _step.value;

          // hide quick pick , business type
          if ([2, 5, 4, 6].indexOf(column.DemoCategoryType) === -1) {
            result.push({
              type: 'column',
              columnName: column.ColumnName,
              name: column.AttributeName,
              demoCategoryType: column.DemoCategoryType
            });
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(column.Values), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var value = _step2.value;

                result.push({
                  type: 'value',
                  attributeValue: value.AttributeValue,
                  columnName: value.ColumnName,
                  name: value.AttributeValueName,
                  demoCategoryType: column.DemoCategoryType
                });
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    columns: function columns() {
      if (this.listType in this.demos && this.demoType in this.demos[this.listType]) {
        return this.demos[this.listType][this.demoType];
      } else {
        this.getDemos();
        return [];
      }
    },
    attributes: function attributes() {
      if (this.selectedColumn.length !== 0 && this.columns.hasOwnProperty(this.selectedColumn)) {
        if (this.columns[this.selectedColumn].Values.length === 0) {
          this.getAttributes();
        }
        return this.columns[this.selectedColumn].Values;
      } else {
        return [];
      }
    },
    isAllHoseholds: function isAllHoseholds() {
      return this.$store.getters['order/isAllHoseholds'];
    },
    columnIsTextInput: function columnIsTextInput() {
      return this.selectedColumnItem.DemoInputtype >= 1 && this.selectedColumnItem.DemoInputtype <= 7 || this.selectedColumnItem.DemoInputtype === 9;
    }
  },
  created: function created() {},

  methods: {
    getDemos: function getDemos() {
      var _this = this;

      this.$http.post('PlaceOrder.aspx/GetDemoAttributesList', {
        demotype: this.demoType,
        listtype: this.listType
      }).then(function (resp) {
        var data = resp.body.d.DataSource;
        _this.$store.commit('demo/saveColumns', {
          listType: _this.listType,
          demoType: _this.demoType,
          data: data
        });
      });
    },
    getAttributes: function getAttributes() {
      var _this2 = this;

      this.$http.post('PlaceOrder.aspx/GetDemoAttribute', {
        columnName: this.selectedColumn,
        listtype: this.listType
      }).then(function (resp) {
        var data = resp.body.d.DataSource.DemoValues;
        if (resp.body.d.DataSource.DemoInputtype === 0 && data.length === 0) {
          data = [{
            AttributeValueDesc: 'No available option',
            AttributeValue: 'DoNotChooseThis'
          }];
        } else if (resp.body.d.DataSource.DemoInputtype === 9 && data.length === 0) {
          data = [{
            AttributeValue: null,
            AttributeValueName: null,
            ColumnName: resp.body.d.DataSource.ColumnName

          }];
        }
        _this2.$store.commit('demo/saveAttributes', {
          listType: _this2.listType,
          demoType: _this2.demoType,
          columnName: _this2.selectedColumn,
          demoCategory: resp.body.d.DataSource.DemoCategory,
          data: data
        });
      });
    },
    getAttrbiutesValue: function getAttrbiutesValue(columnName, val) {
      return {
        listType: this.listType,
        demoType: this.demoType,
        columnName: columnName,
        value: val
      };
    },
    addDemos: function addDemos() {
      // demoInputType 1, 2, 3, 4, 5, 6, 7, 9
      if (this.columnIsTextInput) {
        var item = null;
        item = this.addDemoInput();
        if (item !== false) {
          item.DemoCategoryType = this.specialDemoCategory || 3;
          this.$store.dispatch('order/addDemoByItem', item);
        }
      } else if (this.selectedAttributes.length === 0) {
        return false;
      } else if (this.selectedColumnItem.DemoInputtype === 0 || this.selectedColumnItem.DemoInputtype === 8) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(this.selectedAttributes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _item = _step3.value;

            _item.DemoCategoryType = this.specialDemoCategory || 3;
            if (this.selectedColumnItem.DemoInputtype === 8 && this.$store.getters['order/demoColumnIndex'](_item.ColumnName, _item.DemoCategoryType) !== -1) {
              notification.notice('warning', 'You can only choose one item for this category');
              return false;
            }
            _item.AttributeName = this.columns[this.selectedColumn].AttributeName;
            _item.AttributeDesc = this.columns[this.selectedColumn].AttributeDesc;
            this.$store.dispatch('order/addDemoByItem', _item);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      } else {}
    },
    checkIsNumber: function checkIsNumber(val) {
      if (isNaN(val) || val === null || val === '') {
        this.inputError = 'Need Digital';
        return false;
      }
    },
    checkInput1DayMonthYearVal: function checkInput1DayMonthYearVal(val) {
      if (val.length !== 8) {
        this.inputError = 'Need formate: YYYYMMDD';
        return false;
      }

      var day = parseInt(val.substring(6, 8));
      var month = parseInt(val.substring(4, 6));
      var year = parseInt(val.substring(0, 4));

      if (year < 1000 || year > 2099 || month < 1 || month > 12 || day < 1 || day > 31 || isNaN(month) || isNaN(year) || isNaN(day)) {
        this.inputError = 'Need formate: YYYYMMDD';
        return false;
      }
      return {
        day: val.substring(6, 8),
        month: val.substring(4, 6),
        year: val.substring(0, 4)
      };
    },
    checkInput2InterVal: function checkInput2InterVal(val) {
      val = parseInt(val);
      if (isNaN(val)) {
        this.inputError = 'Need Number';
        return false;
      }
      return val;
    },
    checkInput3MonthYearVal: function checkInput3MonthYearVal(val) {
      // 3 month year
      if (val.length !== 6) {
        this.inputError = 'Need formate: MMYYYY';
        return false;
      }
      var month = parseInt(val.substring(0, 2));
      var year = parseInt(val.substring(2, 6));
      if (year < 1000 || year > 2099 || month < 1 || month > 12 || isNaN(month) || isNaN(year)) {
        this.inputError = 'Need formate: MMYYYY';
        return false;
      }
      return { month: val.substring(0, 2), year: val.substring(2, 6) };
    },
    checkInput4YearVal: function checkInput4YearVal(val, rules) {
      // 4 year, datasource10 demographics Year Home Built, checked
      if (val.length !== 4) {
        this.inputError = 'Need formate: YYYY';
        return false;
      }
      var year = parseInt(val);
      if (year < 1900 || year > 2099 || isNaN(year)) {
        this.inputError = 'Need formate: YYYY';
        return false;
      }
      return year;
    },
    checkInput5Month: function checkInput5Month(val) {
      if (val.length !== 2) {
        this.inputError = 'Need formate: MM';
        return false;
      }
      var month = parseInt(val);
      if (month < 1 || month > 12 || isNaN(month)) {
        this.inputError = 'Need formate: MM';
        return false;
      }
      return val;
    },
    checkInput7String: function checkInput7String(val) {
      if (val.length === 0) {
        this.inputError = 'Need String';
        return false;
      }
      return val;
    },
    checkToMoreFrom: function checkToMoreFrom(from, to) {
      if (from > to) {
        this.inputError = 'First input is smaller than second';
        return false;
      } else {
        return true;
      }
    },
    checkMaxMin: function checkMaxMin(from, to, type) {
      var max = this.selectedColumnItem.MaxValue;
      var min = this.selectedColumnItem.MinValue;

      if (max !== null) {
        if (from > max || to > max) {
          this.inputError = 'value must smaller than ' + max;
        }
      }

      if (min !== null) {
        if (from < min || to < min) {
          this.inputError = 'value must bigger than ' + min;
        }
      }
    },
    checkOneMaxMin: function checkOneMaxMin(from) {
      var max = this.selectedColumnItem.MaxValue;
      var min = this.selectedColumnItem.MinValue;
      if (max !== null) {
        if (from > max) {
          this.inputError = 'value must smaller than ' + max;
        }
      }

      if (min !== null) {
        if (from < min) {
          this.inputError = 'value must bigger than ' + min;
        }
      }
    },
    addDemoInput: function addDemoInput() {
      this.inputError = '';
      var item = this.selectedColumnItem;
      var from = null;
      var to = null;
      // check value fromate
      if (item.DemoInputtype === 1) {
        // Input DayMonthyear dataourece 40 data of publication
        from = this.checkInput1DayMonthYearVal(this.inputFrom);
        to = this.checkInput1DayMonthYearVal(this.inputTo);

        if (this.inputError === '') {
          this.checkToMoreFrom('' + from.year + from.month + from.day, '' + to.year + to.month + to.day);
          this.checkMaxMin('' + from.year + from.month + from.day, '' + to.year + to.month + to.day);
        }
      } else if (item.DemoInputtype === 2) {
        // InputInteger,  datasource10 audience propensities -> automotive -> Affinity fro a New
        from = this.checkInput2InterVal(this.inputFrom);
        to = this.checkInput2InterVal(this.inputTo);
      } else if (item.DemoInputtype === 3) {
        // InputMonthyear
        from = this.checkInput3MonthYearVal(this.inputFrom);
        to = this.checkInput3MonthYearVal(this.inputTo);
        if (this.inputError === '') {
          this.checkToMoreFrom('' + from.year + from.month, '' + to.year + to.month);
          this.checkMaxMin('' + from.year + from.month, '' + to.year + to.month);
        }
      } else if (item.DemoInputtype === 4) {
        // InputYear, datasource10 demographics Year Home Built
        from = this.checkInput4YearVal(this.inputFrom);
        to = this.checkInput4YearVal(this.inputTo);
      } else if (item.DemoInputtype === 5) {
        // inputMonth
        from = this.checkInput5Month(this.inputFrom);
        to = this.checkInput5Month(this.inputTo);
      } else if (item.DemoInputtype === 6) {
        // 6 SIC, datasource20 demographic SIC CODE
        // TODO@important I can't understood SIC CODE
        from = this.inputFrom;
        to = this.inputTo;
      } else if (item.DemoInputtype === 7) {
        // 7 InputString, datasource170 demographics upload codes
        // TODO@important maybe it not string
        from = this.inputFrom;
        to = this.inputTo;
        from = this.checkInput7String(this.inputFrom);
        to = this.checkInput7String(this.inputTo);
      } else if (item.DemoInputtype === 8) {
        // RadioSelectBox ,  prod datasource 40 demo，residential/Business Selector
        // TODO@important I can't find this type
        from = this.inputFrom;
        to = this.inputTo;
      } else if (item.DemoInputtype === 9) {
        // InputIntegerSingle,  prod datasource 160 demo  Corporate Sales Volume Actual, dev dataSource 10 small office - home office
        from = this.inputFrom;
        this.checkIsNumber(from);
        this.checkOneMaxMin(from);
      }

      // assignment
      if (this.inputError.length > 0) {
        return false;
      } else if (item.DemoInputtype === 1) {
        item.AttributeValue = '' + from.year + from.month + from.day + '~' + to.year + to.month + to.day;
        item.AttributeValueName = '' + from.year + from.month + from.day + '~' + to.year + to.month + to.day;
      } else if (item.DemoInputtype === 3) {
        item.AttributeValue = '' + from.year + from.month + '~' + to.year + to.month;
        item.AttributeValueName = '' + from.year + from.month + '~' + to.year + to.month;
      } else if (item.DemoInputtype === 9) {
        item.AttributeValue = from;
        item.AttributeValueName = from;
      } else {
        this.checkToMoreFrom(from, to);
        this.checkMaxMin(from, to);
        item.AttributeValue = from + '~' + to;
        item.AttributeValueName = from + ' to ' + to;
      }
      if (this.inputError.length > 0) {
        return false;
      } else {
        this.inputFrom = '';
        this.inputTo = '';
        return item;
      }
    },
    cleanDemos: function cleanDemos() {
      this.$store.commit('order/clearDemos');
    },
    deleteDemos: function deleteDemos() {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(this.unSelectedDemos), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          this.$store.dispatch('order/deleteDemo', item);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aba149a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/MDemoSelect.vue
var MDemoSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"m-text-deep"},[_c('b-col',{attrs:{"md":"5"}},[(_vm.needDemo)?_c('div',[_c('h4',{staticClass:"mt-2"},[_vm._v("Choose Category:")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.categories.length<= 1),expression:"categories.length<= 1"}],staticClass:"m-select-spinner"},[_c('div',{staticClass:"m-spinner "})]),_vm._v(" "),_c('b-form-select',{attrs:{"select-size":_vm.selectFormSize,"disabled":_vm.isAllHoseholds,"data-test":"demo-select-category"},model:{value:(_vm.demoType),callback:function ($$v) {_vm.demoType=$$v},expression:"demoType"}},_vm._l((_vm.categories),function(item){return _c('option',{domProps:{"value":item.demoType}},[_vm._v("\n          "+_vm._s(item.desc))])}),0)],1):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.needDemo ? 'Audience Propensity:' : 'Choose Category:'))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.columns.length === 0),expression:"columns.length === 0"}],staticClass:"m-select-spinner"},[_c('div',{staticClass:"m-spinner "})]),_vm._v(" "),_c('b-select',{staticClass:"ttt",attrs:{"select-size":_vm.selectFormSize,"disabled":_vm.isAllHoseholds,"data-test":"demo-select-column","placeholde":"select demo"},model:{value:(_vm.selectedColumn),callback:function ($$v) {_vm.selectedColumn=$$v},expression:"selectedColumn"}},[_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.columns.length > 0),expression:"columns.length > 0"}],attrs:{"value":""}},[_vm._v("Please select some demo")]),_vm._v(" "),_vm._l((_vm.columns),function(item){return _c('option',{key:item.ColumnName,attrs:{"text-":""},domProps:{"value":item.ColumnName}},[_vm._v("\n          "+_vm._s(item.AttributeDesc))])})],2),_vm._v(" "),_c('h4',{staticClass:"mt-2"},[_vm._v("Choose Filter(s):")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.attributes.length=== 0 && _vm.selectedColumn.length > 0) ),expression:"(attributes.length=== 0 && selectedColumn.length > 0) "}],staticClass:"m-select-spinner"},[_c('div',{staticClass:"m-spinner "})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.attributes.length=== 0 && _vm.selectedColumn.length == 0),expression:"attributes.length=== 0 && selectedColumn.length == 0"}],staticClass:"input-box",style:({height: _vm.selectFromHeight})}),_vm._v(" "),(_vm.selectedColumnItem.DemoInputtype === 0 || _vm.selectedColumnItem.DemoInputtype === 8 || !_vm.selectedColumnItem)?_c('b-select',{staticClass:"demo-select",attrs:{"select-size":_vm.selectFormSize,"disabled":_vm.isAllHoseholds,"data-test":"demo-select-attribute","multiple":""},model:{value:(_vm.selectedAttributes),callback:function ($$v) {_vm.selectedAttributes=$$v},expression:"selectedAttributes"}},_vm._l((_vm.attributes),function(item){return _c('option',{attrs:{"disabled":item.AttributeValue === 'DoNotChooseThis'},domProps:{"value":item}},[_vm._v("\n          "+_vm._s(item.AttributeValueDesc))])}),0):_vm._e(),_vm._v(" "),(_vm.columnIsTextInput)?_c('div',{staticClass:"input-box",style:({height: _vm.selectFromHeight})},[(_vm.attributes.length !== 0)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.attributes[0].AttributeValueDesc))]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-input',{staticClass:"input-box-input",attrs:{"size":"sm","placeholder":_vm.inputFromHolder},model:{value:(_vm.inputFrom),callback:function ($$v) {_vm.inputFrom=$$v},expression:"inputFrom"}})],1),_vm._v(" "),(_vm.selectedColumnItem.DemoInputtype !== 9)?_c('b-col',[_c('b-input',{staticClass:"input-box-input",attrs:{"size":"sm","placeholder":_vm.inputToHolder},model:{value:(_vm.inputTo),callback:function ($$v) {_vm.inputTo=$$v},expression:"inputTo"}})],1):_vm._e()],1),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm"},on:{"click":_vm.addDemos}},[_vm._v("Add")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.inputError !== false),expression:"inputError !== false"}],staticClass:"m-error-text"},[_vm._v(_vm._s(_vm.inputError))])],1):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"m-select-btn-box",attrs:{"md":"2"}},[_c('b-btn',{staticClass:"m-select-btn",staticStyle:{"margin-top":"16px"},attrs:{"size":"sm","data-test":"demo-select-add","disabled":_vm.isAllHoseholds},on:{"click":function($event){return _vm.addDemos()}}},[_vm._v("\n        Add")]),_vm._v(" "),_c('b-btn',{staticClass:"m-select-btn",attrs:{"size":"sm","data-test":"demo-select-delete","disabled":_vm.isAllHoseholds},on:{"click":function($event){return _vm.deleteDemos()}}},[_vm._v("\n        Remove")]),_vm._v(" "),_c('b-btn',{staticClass:"m-select-btn",attrs:{"size":"sm","data-test":"demo-select-clear","disabled":_vm.isAllHoseholds},on:{"click":function($event){return _vm.cleanDemos()}}},[_vm._v("\n        Remove All")])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5","rows":"2"}},[_c('h4',{staticClass:"mt-2"},[_vm._v("Your Target Audience:")]),_vm._v(" "),_c('b-select',{staticClass:"demo-select",attrs:{"select-size":20,"disabled":_vm.isAllHoseholds,"multiple":""},model:{value:(_vm.unSelectedDemos),callback:function ($$v) {_vm.unSelectedDemos=$$v},expression:"unSelectedDemos"}},_vm._l((_vm.selectedDemos),function(item){return _c('option',{staticClass:"demos-value",class:{'demos-column':item.type === 'column' },domProps:{"value":item}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])}),0)],1)],1)],1)}
var MDemoSelect_staticRenderFns = []
var MDemoSelect_esExports = { render: MDemoSelect_render, staticRenderFns: MDemoSelect_staticRenderFns }
/* harmony default export */ var demo_MDemoSelect = (MDemoSelect_esExports);
// CONCATENATED MODULE: ./src/components/demo/MDemoSelect.vue
function MDemoSelect_injectStyle (ssrContext) {
  __webpack_require__("OZdI")
}
var MDemoSelect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MDemoSelect___vue_template_functional__ = false
/* styles */
var MDemoSelect___vue_styles__ = MDemoSelect_injectStyle
/* scopeId */
var MDemoSelect___vue_scopeId__ = "data-v-2aba149a"
/* moduleIdentifier (server only) */
var MDemoSelect___vue_module_identifier__ = null
var MDemoSelect_Component = MDemoSelect_normalizeComponent(
  MDemoSelect,
  demo_MDemoSelect,
  MDemoSelect___vue_template_functional__,
  MDemoSelect___vue_styles__,
  MDemoSelect___vue_scopeId__,
  MDemoSelect___vue_module_identifier__
)

/* harmony default export */ var components_demo_MDemoSelect = (MDemoSelect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/DemoAudiencePropensities.vue
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var DemoAudiencePropensities = ({
  components: {
    MDemoBox: components_demo_MDemoBox,
    MDemoSelect: components_demo_MDemoSelect,
    MDemoAllCheck: components_demo_MDemoAllCheck
  },
  data: function data() {
    return {
      selectColumn: null
    };
  },
  created: function created() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35569dd2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoAudiencePropensities.vue
var DemoAudiencePropensities_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":"audiencePropensities"}},[_c('div',{attrs:{"slot":"top"},slot:"top"},[_c('m-demo-all-check')],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('m-demo-select',{attrs:{"needDemo":true}})],1)],1)}
var DemoAudiencePropensities_staticRenderFns = []
var DemoAudiencePropensities_esExports = { render: DemoAudiencePropensities_render, staticRenderFns: DemoAudiencePropensities_staticRenderFns }
/* harmony default export */ var order_DemoAudiencePropensities = (DemoAudiencePropensities_esExports);
// CONCATENATED MODULE: ./src/pages/order/DemoAudiencePropensities.vue
function DemoAudiencePropensities_injectStyle (ssrContext) {
  __webpack_require__("NUk/")
}
var DemoAudiencePropensities_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DemoAudiencePropensities___vue_template_functional__ = false
/* styles */
var DemoAudiencePropensities___vue_styles__ = DemoAudiencePropensities_injectStyle
/* scopeId */
var DemoAudiencePropensities___vue_scopeId__ = "data-v-35569dd2"
/* moduleIdentifier (server only) */
var DemoAudiencePropensities___vue_module_identifier__ = null
var DemoAudiencePropensities_Component = DemoAudiencePropensities_normalizeComponent(
  DemoAudiencePropensities,
  order_DemoAudiencePropensities,
  DemoAudiencePropensities___vue_template_functional__,
  DemoAudiencePropensities___vue_styles__,
  DemoAudiencePropensities___vue_scopeId__,
  DemoAudiencePropensities___vue_module_identifier__
)

/* harmony default export */ var pages_order_DemoAudiencePropensities = (DemoAudiencePropensities_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/DemoSearch.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var DemoSearch = ({
  components: {
    MDemoAllCheck: components_demo_MDemoAllCheck,
    MDemoBox: components_demo_MDemoBox,
    MErrorText: components_common_MerrorText
  },
  data: function data() {
    return {
      searchKey: '',
      selectedAttributes: [],
      unSelectedDemos: [],
      demos: [],
      hasLoad: true
    };
  },

  watch: {
    '$route.params.listType': function $routeParamsListType() {
      this.demos = [];
      this.searchKey = '';
    },
    searchKey: function searchKey(val) {
      var _this = this;

      if (val.length < 3) {
        return false;
      }
      this.hasLoad = false;
      this.$http.get('BA/DemoAutoSuggestion.ashx', {
        params: {
          Keyword: val,
          ListType: this.$store.state.order.ListType
        }
      }).then(function (resp) {
        _this.demos = resp.body;
        _this.hasLoad = true;
        for (var i = 0; i < _this.demos.length; i++) {
          var demo = _this.demos[i];
          if (demo.IsGroup === 1) {
            _this.demos[i].desc = demo.AttributeDesc;
            _this.demos[i].name = demo.AttributeName;
            _this.demos[i].type = 'column';
          } else {
            _this.demos[i].desc = demo.AttributeValueName;
            _this.demos[i].name = demo.AttributeValue;
            _this.demos[i].type = 'value';
          }
        }
      }, function (resp) {
        _this.hasLoad = true;
      });
    }
  },
  computed: {
    listType: function listType() {
      return this.$store.state.order.ListType;
    },
    selectedDemos: function selectedDemos() {
      var demos = this.$store.getters['order/demoItems'];
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(demos), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column = _step.value;

          result.push({
            type: 'column',
            columnName: column.ColumnName,
            name: column.AttributeName,
            demoCategoryType: column.DemoCategoryType
          });
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(column.Values), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var value = _step2.value;

              result.push({
                type: 'value',
                attributeValue: value.AttributeValue,
                columnName: value.ColumnName,
                name: value.AttributeValueName,
                demoCategoryType: column.DemoCategoryType
              });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    isAllHoseholds: function isAllHoseholds() {
      return this.$store.getters['order/isAllHoseholds'];
    }
  },
  created: function created() {},

  methods: {
    addDemos: function addDemos() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(this.selectedAttributes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          //          item.AttributeName = this.columns[this.selectedColumn].AttributeName
          //          item.AttributeDesc = this.columns[this.selectedColumn].AttributeDesc
          if (item.IsGroup === 0) {
            item.DemoCategoryType = 3;
            this.$store.dispatch('order/addDemoByItem', item);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    cleanDemos: function cleanDemos() {
      this.$store.commit('order/clearDemos');
    },
    deleteDemos: function deleteDemos() {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(this.unSelectedDemos), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          this.$store.dispatch('order/deleteDemo', item);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46a73454","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoSearch.vue
var DemoSearch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":"search"}},[_c('div',{attrs:{"slot":"top"},slot:"top"},[_c('m-demo-all-check')],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"search-box"},[_c('b-input',{staticClass:"search-input",attrs:{"placeholder":"Enter Your Keywords","data-test":"demo-search-searchInput","disabled":_vm.isAllHoseholds},model:{value:(_vm.searchKey),callback:function ($$v) {_vm.searchKey=$$v},expression:"searchKey"}}),_vm._v(" "),_c('m-error-text',{staticClass:"error-notice",attrs:{"val":_vm.searchKey,"immediate":_vm.searchKey.length > 0,"rules":[{
                          type: 'minLength',
                          payload: 3,
                          desc: 'At least 3 words'
                        }]}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"5"}},[_c('m-loader',{attrs:{"size":"before","show":!_vm.hasLoad}}),_vm._v(" "),_c('b-select',{staticClass:"demo-select",attrs:{"select-size":7,"multiple":"","data-test":"demo-search-select","disabled":_vm.isAllHoseholds},model:{value:(_vm.selectedAttributes),callback:function ($$v) {_vm.selectedAttributes=$$v},expression:"selectedAttributes"}},[_vm._l((_vm.demos),function(item){return _c('option',{staticClass:"demos-value",class:{'demos-column':item.IsGroup === 1 },domProps:{"value":item}},[_vm._v("\n            "+_vm._s(item.desc)+"\n          ")])}),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.demos.length === 0 && _vm.hasLoad),expression:"demos.length === 0 && hasLoad"}],attrs:{"disabled":""}},[_vm._v("No Record")])],2)],1),_vm._v(" "),_c('b-col',{staticClass:"m-select-btn-box",attrs:{"md":"2"}},[_c('b-btn',{staticClass:"m-select-btn",attrs:{"size":"sm","data-test":"demo-search-add","disabled":_vm.isAllHoseholds},on:{"click":function($event){return _vm.addDemos()}}},[_vm._v("\n          Add")]),_vm._v(" "),_c('b-btn',{staticClass:"m-select-btn",attrs:{"size":"sm","data-test":"demo-search-remove","disabled":_vm.isAllHoseholds},on:{"click":function($event){return _vm.deleteDemos()}}},[_vm._v("\n          Remove")]),_vm._v(" "),_c('b-btn',{staticClass:"m-select-btn",attrs:{"size":"sm","data-test":"demo-search-clean","disabled":_vm.isAllHoseholds},on:{"click":function($event){return _vm.cleanDemos()}}},[_vm._v("\n          Remove All")])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('b-select',{staticClass:"demo-select",attrs:{"select-size":7,"multiple":"","data-test":"demo-search-selected","disabled":_vm.isAllHoseholds},model:{value:(_vm.unSelectedDemos),callback:function ($$v) {_vm.unSelectedDemos=$$v},expression:"unSelectedDemos"}},_vm._l((_vm.selectedDemos),function(item){return _c('option',{staticClass:"demos-value",class:{'demos-column':item.type === 'column' },domProps:{"value":item}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])}),0)],1)],1)],1)],1)}
var DemoSearch_staticRenderFns = []
var DemoSearch_esExports = { render: DemoSearch_render, staticRenderFns: DemoSearch_staticRenderFns }
/* harmony default export */ var order_DemoSearch = (DemoSearch_esExports);
// CONCATENATED MODULE: ./src/pages/order/DemoSearch.vue
function DemoSearch_injectStyle (ssrContext) {
  __webpack_require__("ztea")
}
var DemoSearch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DemoSearch___vue_template_functional__ = false
/* styles */
var DemoSearch___vue_styles__ = DemoSearch_injectStyle
/* scopeId */
var DemoSearch___vue_scopeId__ = "data-v-46a73454"
/* moduleIdentifier (server only) */
var DemoSearch___vue_module_identifier__ = null
var DemoSearch_Component = DemoSearch_normalizeComponent(
  DemoSearch,
  order_DemoSearch,
  DemoSearch___vue_template_functional__,
  DemoSearch___vue_styles__,
  DemoSearch___vue_scopeId__,
  DemoSearch___vue_module_identifier__
)

/* harmony default export */ var pages_order_DemoSearch = (DemoSearch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/DemoDemographics.vue
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var DemoDemographics = ({
  components: {
    MDemoBox: components_demo_MDemoBox,
    MDemoSelect: components_demo_MDemoSelect,
    MDemoAllCheck: components_demo_MDemoAllCheck
  },
  data: function data() {
    return {
      selectColumn: null
    };
  },
  created: function created() {
    // this.$store.dispatch('demo/init')
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44e0c3f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoDemographics.vue
var DemoDemographics_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":"demoDemographics"}},[_c('div',{attrs:{"slot":"top"},slot:"top"},[_c('m-demo-all-check')],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('m-demo-select',{attrs:{"propDemoType":1}})],1)],1)}
var DemoDemographics_staticRenderFns = []
var DemoDemographics_esExports = { render: DemoDemographics_render, staticRenderFns: DemoDemographics_staticRenderFns }
/* harmony default export */ var order_DemoDemographics = (DemoDemographics_esExports);
// CONCATENATED MODULE: ./src/pages/order/DemoDemographics.vue
function DemoDemographics_injectStyle (ssrContext) {
  __webpack_require__("n2jV")
}
var DemoDemographics_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DemoDemographics___vue_template_functional__ = false
/* styles */
var DemoDemographics___vue_styles__ = DemoDemographics_injectStyle
/* scopeId */
var DemoDemographics___vue_scopeId__ = "data-v-44e0c3f7"
/* moduleIdentifier (server only) */
var DemoDemographics___vue_module_identifier__ = null
var DemoDemographics_Component = DemoDemographics_normalizeComponent(
  DemoDemographics,
  order_DemoDemographics,
  DemoDemographics___vue_template_functional__,
  DemoDemographics___vue_styles__,
  DemoDemographics___vue_scopeId__,
  DemoDemographics___vue_module_identifier__
)

/* harmony default export */ var pages_order_DemoDemographics = (DemoDemographics_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/DemoIntrestsPurchasing.vue
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var DemoIntrestsPurchasing = ({
  components: {
    MDemoBox: components_demo_MDemoBox,
    MDemoSelect: components_demo_MDemoSelect,
    MDemoAllCheck: components_demo_MDemoAllCheck
  },
  data: function data() {
    return {
      selectColumn: null
    };
  },
  created: function created() {
    // this.$store.dispatch('demo/init')
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eba192a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoIntrestsPurchasing.vue
var DemoIntrestsPurchasing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":"intrestsPurchasing"}},[_c('div',{attrs:{"slot":"top"},slot:"top"},[_c('m-demo-all-check')],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('m-demo-select',{attrs:{"propDemoType":2,"specialDemoCategory":3}})],1)],1)}
var DemoIntrestsPurchasing_staticRenderFns = []
var DemoIntrestsPurchasing_esExports = { render: DemoIntrestsPurchasing_render, staticRenderFns: DemoIntrestsPurchasing_staticRenderFns }
/* harmony default export */ var order_DemoIntrestsPurchasing = (DemoIntrestsPurchasing_esExports);
// CONCATENATED MODULE: ./src/pages/order/DemoIntrestsPurchasing.vue
function DemoIntrestsPurchasing_injectStyle (ssrContext) {
  __webpack_require__("KVKU")
}
var DemoIntrestsPurchasing_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DemoIntrestsPurchasing___vue_template_functional__ = false
/* styles */
var DemoIntrestsPurchasing___vue_styles__ = DemoIntrestsPurchasing_injectStyle
/* scopeId */
var DemoIntrestsPurchasing___vue_scopeId__ = "data-v-0eba192a"
/* moduleIdentifier (server only) */
var DemoIntrestsPurchasing___vue_module_identifier__ = null
var DemoIntrestsPurchasing_Component = DemoIntrestsPurchasing_normalizeComponent(
  DemoIntrestsPurchasing,
  order_DemoIntrestsPurchasing,
  DemoIntrestsPurchasing___vue_template_functional__,
  DemoIntrestsPurchasing___vue_styles__,
  DemoIntrestsPurchasing___vue_scopeId__,
  DemoIntrestsPurchasing___vue_module_identifier__
)

/* harmony default export */ var pages_order_DemoIntrestsPurchasing = (DemoIntrestsPurchasing_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/DemoQuickPick.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var DemoQuickPick = ({
  components: {
    MDemoBox: components_demo_MDemoBox,
    MDemoAllCheck: components_demo_MDemoAllCheck
  },
  data: function data() {
    return {
      quickPick: {},
      init: false,
      theQuickPicks: []
    };
  },

  computed: {
    quickPicks: function quickPicks() {
      // let quickPicks = this.$store.state.demo.quickPicks
      if (this.theQuickPicks.length === 0 && !this.init) {
        this.getQuickPick();
        return [];
      }
      if (this.$store.state.demo.saveNewQuickPick) {
        this.getQuickPick();
        return [];
      }
      var quickPicks = this.theQuickPicks;
      for (var i = 0; i < quickPicks.length; i++) {
        if (this.type !== 'normal') {
          quickPicks[i].QpName = quickPicks[i].Name;
          quickPicks[i].QpDesc = quickPicks[i].Name;
        }

        var hasSelected = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(this.selectedQuickPicks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var selected = _step.value;

            if (quickPicks[i].QpName === selected.AttributeValueName) {
              hasSelected = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        quickPicks[i].selected = hasSelected;
      }
      return quickPicks;
    },
    columnQuickPicks: function columnQuickPicks() {
      if (this.type === 'normal') {
        return this.$store.getters['order/demoColumnItem']('Quick Pick', 2);
      } else {
        return this.$store.getters['order/demoColumnItem']('Business QuickPicks', 5);
      }
    },
    selectedQuickPicks: function selectedQuickPicks() {
      if (this.columnQuickPicks && this.columnQuickPicks.Values) {
        return this.columnQuickPicks.Values;
      } else {
        return [];
      }
    },
    listType: function listType() {
      return this.$store.state.order.ListType;
    },
    type: function type() {
      if (this.$route.name === 'demo-businessQuickPicks') {
        return 'business';
      } else {
        return 'normal';
      }
    },
    demoOption: function demoOption() {
      if (this.type === 'business') {
        return 'businessQuickPicks';
      } else {
        return 'quickPicks';
      }
    },
    isAllHoseholds: function isAllHoseholds() {
      return this.$store.getters['order/isAllHoseholds'];
    }
  },
  watch: {
    '$route.params.listType': function $routeParamsListType() {
      this.getQuickPick();
    }
  },
  created: function created() {},

  methods: {
    addQuick: function addQuick(item) {
      this.$store.commit('order/saveDemoType', 1);

      var quickPick = {
        AttributeName: 'Quick Pick',
        DemoCategoryType: 2,
        AttributeValue: item.QpId,
        AttributeValueName: item.QpName,
        ColumnName: 'Quick Pick',
        SortSeq: 0
      };

      if (item.qpType === 1) {
        quickPick.AttributeName = 'Site Quick Pick';
        quickPick.ColumnName = 'Site Quick Pick';
      }

      if (this.type === 'business') {
        quickPick.AttributeValue = item.QpName;
        quickPick.AttributeName = 'Business QuickPicks';
        quickPick.ColumnName = 'Business QuickPicks';
        quickPick.DemoCategoryType = 5;
      } else {
        this.clearQuick();
      }
      this.$store.dispatch('order/addDemoByItem', quickPick);
    },
    askDeleteQuick: function askDeleteQuick(item) {
      this.quickPick = item;
      this.$refs.askDelete.show();
    },
    deleteQuick: function deleteQuick() {
      var _this = this;

      this.$http.post('PlaceOrder.aspx/RemoveQuickPick', {
        id: this.quickPick.QpId
      }).then(function (resp) {
        _this.removeQuick(_this.quickPick);
        for (var i = 0; i <= _this.theQuickPicks.length; i++) {
          if (_this.theQuickPicks[i].QpId === _this.quickPick.QpId) {
            _this.theQuickPicks.splice(i, 1);
            return true;
          }
        }
      });
    },
    removeQuick: function removeQuick(item) {
      if (this.type === 'normal') {
        item.columnName = 'Quick Pick';
        item.type = 'column';
        item.demoCategoryType = 2;
      } else {
        item.columnName = 'Business QuickPicks';
        item.demoCategoryType = 5;
        item.name = '';
        item.attributeValue = item.QpName;
        item.value = 'value';
        item.name = item.QpName;
      }
      this.$store.dispatch('order/deleteDemo', item);
    },
    seeDetail: function seeDetail(item) {
      var _this2 = this;

      this.$http.post('PlaceOrder.aspx/GetQuickPickup', {
        id: item.QpId,
        qpType: item.QpType
      }).then(function (resp) {
        _this2.quickPick = resp.body.d.DataSource;
        _this2.$refs.seeQuickPick.show();
      });
    },
    clearQuick: function clearQuick() {
      this.$store.commit('order/deleteDemoColumnName', 'Quick Pick');
      this.$store.commit('order/deleteDemoColumnName', 'Site Quick Pick');
    },
    getQuickPick: function getQuickPick() {
      var _this3 = this;

      this.theQuickPicks = [];
      this.init = false;
      var url = 'PlaceOrder.aspx/GetQuickPickups';
      if (this.type === 'business') {
        url = 'PlaceOrder.aspx/GetBusinessQuickpicks';
      }
      this.$http.post(url, {
        listType: this.listType
      }).then(function (resp) {
        // this.$store.commit('demo/saveQuickPicks', resp.body.d.DataSource)
        _this3.theQuickPicks = resp.body.d.DataSource;
        _this3.init = true;
        _this3.$store.commit('demo/saveKey', ['saveNewQuickPick', false]);
      }, function (resp) {
        _this3.init = true;
      });
    },
    clear: function clear() {
      this.quickPick = {};
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bdd1082","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoQuickPick.vue
var DemoQuickPick_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":_vm.demoOption,"hasSaveQuickPick":this.type !== 'normal'}},[_c('b-modal',{ref:"askDelete",attrs:{"hide-header":true,"lazy":true},on:{"ok":_vm.deleteQuick}},[_vm._v("\n    Are you Sure to delete this quick pick?"),_c('br'),_vm._v("\n    "+_vm._s(_vm.quickPick.QpName)+"\n  ")]),_vm._v(" "),_c('b-modal',{ref:"seeQuickPick",attrs:{"title":"My Quickpick Information","ok-only":true,"lazy":true},on:{"hidden":_vm.clear}},[_c('p',[_vm._v("Quickpick Name: "+_vm._s(_vm.quickPick.Name))]),_vm._v(" "),_c('p',[_vm._v("Quickpick Desc: "+_vm._s(_vm.quickPick.Description))]),_vm._v(" "),(_vm.quickPick.Categories)?_c('div',{staticClass:"card card-quick-pick"},_vm._l((_vm.quickPick.Categories),function(category){return _c('div',_vm._l((category.Items),function(item){return _c('div',[_c('h5',[_vm._v(_vm._s(item.ItemDesc))]),_vm._v(" "),_vm._l((item.Values),function(val){return _c('p',{staticClass:"item-value"},[_vm._v("\n            "+_vm._s(val.Name)+"\n          ")])})],2)}),0)}),0):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"top"},slot:"top"},[_c('m-demo-all-check')],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"8px"}},[_c('b-col',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllHoseholds),expression:"isAllHoseholds"}],staticClass:"m-disabled-box"}),_vm._v(" "),_c('div',{staticClass:"card  card-quick-pick"},[(_vm.quickPicks.length === 0 && _vm.init)?_c('p',[_vm._v("There is no Quick Pick")]):_vm._e(),_vm._v(" "),_c('m-loader',{attrs:{"show":!_vm.init}}),_vm._v(" "),_vm._l((_vm.quickPicks),function(item){return _c('div',{staticClass:"quick-item"},[_c('span',[_vm._v(_vm._s(item.QpName))]),_vm._v(" "),_c('span',[_c('span',{staticClass:"quick-item-btn"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.selected),expression:"item.selected"}],staticClass:"quick-item-icon light",attrs:{"data-test":"demo-quickPick-remove"},on:{"click":function($event){return _vm.removeQuick(item)}}},[_c('icon',{attrs:{"name":"check-circle"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!item.selected),expression:"!item.selected"}],staticClass:"quick-item-icon",attrs:{"data-test":"demo-quickPick-add"},on:{"click":function($event){return _vm.addQuick(item)}}},[_c('icon',{attrs:{"name":"plus"}})],1)]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'normal'),expression:"type === 'normal'"}],staticClass:"quick-item-icon",attrs:{"data-test":"demo-quickPick-detail"},on:{"click":function($event){return _vm.seeDetail(item)}}},[_c('icon',{attrs:{"name":"eye"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'normal'),expression:"type === 'normal'"}],staticClass:"quick-item-icon",attrs:{"data-test":"demo-quickPick-delete"},on:{"click":function($event){return _vm.askDeleteQuick(item)}}},[_c('icon',{attrs:{"name":"times-circle"}})],1)])])})],2)])],1)],1)}
var DemoQuickPick_staticRenderFns = []
var DemoQuickPick_esExports = { render: DemoQuickPick_render, staticRenderFns: DemoQuickPick_staticRenderFns }
/* harmony default export */ var order_DemoQuickPick = (DemoQuickPick_esExports);
// CONCATENATED MODULE: ./src/pages/order/DemoQuickPick.vue
function DemoQuickPick_injectStyle (ssrContext) {
  __webpack_require__("/5du")
}
var DemoQuickPick_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DemoQuickPick___vue_template_functional__ = false
/* styles */
var DemoQuickPick___vue_styles__ = DemoQuickPick_injectStyle
/* scopeId */
var DemoQuickPick___vue_scopeId__ = "data-v-6bdd1082"
/* moduleIdentifier (server only) */
var DemoQuickPick___vue_module_identifier__ = null
var DemoQuickPick_Component = DemoQuickPick_normalizeComponent(
  DemoQuickPick,
  order_DemoQuickPick,
  DemoQuickPick___vue_template_functional__,
  DemoQuickPick___vue_styles__,
  DemoQuickPick___vue_scopeId__,
  DemoQuickPick___vue_module_identifier__
)

/* harmony default export */ var pages_order_DemoQuickPick = (DemoQuickPick_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/DemoBusinessQuickPick.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var DemoBusinessQuickPick = ({
  components: {
    MDemoBox: components_demo_MDemoBox,
    MDemoAllCheck: components_demo_MDemoAllCheck
  },
  data: function data() {
    return {
      quickPick: {},
      init: false,
      theQuickPicks: [],
      detailList: []
    };
  },

  computed: {
    quickPicks: function quickPicks() {
      // let quickPicks = this.$store.state.demo.quickPicks
      if (this.theQuickPicks.length === 0 && !this.init) {
        this.getQuickPick();
        return [];
      }
      if (this.$store.state.demo.saveNewQuickPick) {
        this.getQuickPick();
        return [];
      }
      var quickPicks = this.theQuickPicks;
      for (var i = 0; i < quickPicks.length; i++) {
        quickPicks[i].QpName = quickPicks[i].Name;
        quickPicks[i].QpDesc = quickPicks[i].Name;

        var hasSelected = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(this.selectedQuickPicks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var selected = _step.value;

            if (quickPicks[i].QpName === selected.AttributeValueName) {
              hasSelected = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        quickPicks[i].selected = hasSelected;
      }
      return quickPicks;
    },
    columnQuickPicks: function columnQuickPicks() {
      return this.$store.getters['order/demoColumnItem']('Business QuickPicks', 5);
    },
    selectedQuickPicks: function selectedQuickPicks() {
      if (this.columnQuickPicks && this.columnQuickPicks.Values) {
        return this.columnQuickPicks.Values;
      } else {
        return [];
      }
    },
    listType: function listType() {
      return this.$store.state.order.ListType;
    },
    type: function type() {
      if (this.$route.name === 'demo-businessQuickPicks') {
        return 'business';
      } else {
        return 'normal';
      }
    },
    demoOption: function demoOption() {
      return 'businessQuickPicks';
    },
    isAllHoseholds: function isAllHoseholds() {
      return this.$store.getters['order/isAllHoseholds'];
    }
  },
  watch: {
    '$route.params.listType': function $routeParamsListType() {
      this.getQuickPick();
    }
  },
  created: function created() {},

  methods: {
    addQuick: function addQuick(item) {
      this.$store.commit('order/saveDemoType', 1);

      var quickPick = {
        AttributeName: 'Quick Pick',
        DemoCategoryType: 2,
        AttributeValue: item.QpId,
        AttributeValueName: item.QpName,
        ColumnName: 'Quick Pick',
        SortSeq: 0
      };

      if (item.qpType === 1) {
        quickPick.AttributeName = 'Site Quick Pick';
        quickPick.ColumnName = 'Site Quick Pick';
      }
      quickPick.AttributeValue = item.QpName;
      quickPick.AttributeName = 'Business QuickPicks';
      quickPick.ColumnName = 'Business QuickPicks';
      quickPick.DemoCategoryType = 5;

      this.$store.dispatch('order/addDemoByItem', quickPick);
    },
    removeQuick: function removeQuick(item) {
      item.columnName = 'Business QuickPicks';
      item.demoCategoryType = 5;
      item.name = '';
      item.attributeValue = item.QpName;
      item.value = 'value';
      item.name = item.QpName;
      this.$store.dispatch('order/deleteDemo', item);
    },
    clickItem: function clickItem(item) {
      if (item.selected) {
        this.removeQuick(item);
      } else {
        this.addQuick(item);
      }
    },
    seeDetail: function seeDetail(item) {
      var _this = this;

      this.detailList = [];
      this.quickPick = item;
      this.$refs.seeQuickPick.show();
      this.$http.post('PlaceOrder.aspx/GetBusinessQuickpicksDetail', {
        quickPickCode: item.Code,
        listType: this.listType
      }).then(function (resp) {
        _this.detailList = resp.body.d.DataSource;
      });
    },
    clearQuick: function clearQuick() {
      this.$store.commit('order/deleteDemoColumnName', 'Quick Pick');
      this.$store.commit('order/deleteDemoColumnName', 'Site Quick Pick');
      this.$store.commit('order/deleteDemoColumnName', 'Business QuickPicks');
    },
    getQuickPick: function getQuickPick() {
      var _this2 = this;

      this.theQuickPicks = [];
      this.init = false;
      this.$http.post('PlaceOrder.aspx/GetBusinessQuickpicks', {
        listType: this.listType
      }).then(function (resp) {
        // this.$store.commit('demo/saveQuickPicks', resp.body.d.DataSource)
        _this2.theQuickPicks = resp.body.d.DataSource;
        _this2.init = true;
        _this2.$store.commit('demo/saveKey', ['saveNewQuickPick', false]);
      }, function () {
        _this2.init = true;
      });
    },
    clear: function clear() {
      this.quickPick = {};
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a38ced54","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoBusinessQuickPick.vue
var DemoBusinessQuickPick_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":"businessQuickPicks","hasSaveQuickPick":true}},[_c('div',{attrs:{"slot":"top"},slot:"top"},[_c('m-demo-all-check')],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"8px"}},[_c('b-col',[_c('div',{staticStyle:{"margin-left":"16px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllHoseholds),expression:"isAllHoseholds"}],staticClass:"m-disabled-box"}),_vm._v(" "),(_vm.quickPicks.length === 0 && _vm.init)?_c('p',[_vm._v("There is no Quick Pick")]):_vm._e(),_vm._v(" "),_c('m-loader',{attrs:{"show":!_vm.init}}),_vm._v(" "),_c('div',{staticClass:"quick-item-box"},[_vm._l((_vm.quickPicks),function(item){return [_c('div',{staticClass:"quick-item",class:{'quick-item-selected': item.selected},attrs:{"data-test":"demo-businessQuickPick-item"},on:{"click":function($event){return _vm.clickItem(item)}}},[_vm._v("\n              "+_vm._s(item.QpName)+" "),_c('span',{staticClass:"item-span",class:{ 'quick-span-selected':item.selected},on:{"click":function($event){$event.stopPropagation();return _vm.seeDetail(item)}}},[_vm._v("View")])])]})],2)],1)])],1),_vm._v(" "),_c('b-modal',{ref:"seeQuickPick",attrs:{"title":"My Business Quickpick Information","ok-only":true,"lazy":true},on:{"hidden":_vm.clear}},[_c('p',[_vm._v("Quickpick Name: "+_vm._s(_vm.quickPick.Name))]),_vm._v(" "),_c('p',[_vm._v("Quickpick Desc: "+_vm._s(_vm.quickPick.QpDesc))]),_vm._v(" "),(_vm.detailList.length > 0)?_c('div',{staticClass:"card card-quick-pick"},_vm._l((_vm.detailList),function(item){return _c('div',[_c('p',{staticClass:"item-value"},[_vm._v(_vm._s(item.IndustryCode + ':' + item.IndustryDesc)+" "),_c('span',{staticClass:"item-span"},[_vm._v(_vm._s(item.IsExcluded? 'Omitted ': 'Selected'))])])])}),0):_vm._e()])],1)}
var DemoBusinessQuickPick_staticRenderFns = []
var DemoBusinessQuickPick_esExports = { render: DemoBusinessQuickPick_render, staticRenderFns: DemoBusinessQuickPick_staticRenderFns }
/* harmony default export */ var order_DemoBusinessQuickPick = (DemoBusinessQuickPick_esExports);
// CONCATENATED MODULE: ./src/pages/order/DemoBusinessQuickPick.vue
function DemoBusinessQuickPick_injectStyle (ssrContext) {
  __webpack_require__("s4pt")
}
var DemoBusinessQuickPick_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DemoBusinessQuickPick___vue_template_functional__ = false
/* styles */
var DemoBusinessQuickPick___vue_styles__ = DemoBusinessQuickPick_injectStyle
/* scopeId */
var DemoBusinessQuickPick___vue_scopeId__ = "data-v-a38ced54"
/* moduleIdentifier (server only) */
var DemoBusinessQuickPick___vue_module_identifier__ = null
var DemoBusinessQuickPick_Component = DemoBusinessQuickPick_normalizeComponent(
  DemoBusinessQuickPick,
  order_DemoBusinessQuickPick,
  DemoBusinessQuickPick___vue_template_functional__,
  DemoBusinessQuickPick___vue_styles__,
  DemoBusinessQuickPick___vue_scopeId__,
  DemoBusinessQuickPick___vue_module_identifier__
)

/* harmony default export */ var pages_order_DemoBusinessQuickPick = (DemoBusinessQuickPick_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/build.js
var build = __webpack_require__("XILU");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/MsuppressionItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import utils from '@/assets/utils'

/* harmony default export */ var MsuppressionItem = ({
  components: {
    MSuppressionSelectItem: components_demo_MSuppressionSelectItem,
    Datepicker: build_default.a
  },
  props: {
    suppressionType: {
      type: String,
      default: 'order' // slc, file
    },
    subType: {
      type: [Boolean, String],
      default: false
    },
    itemTitle: {
      type: String,
      default: 'By Selected Item'
    }
  },
  created: function created() {
    // this.$emit('updateType', this.type)
  },
  data: function data() {
    return {
      type: 'date', // date, item
      startDateDisabled: {
        to: new Date()
      },
      configDatas: {
        order: {
          type: 'order',
          itemTitle: 'Your Order List',
          selectedTitle: 'Prior Orders to Suppress',
          getItemUrl: 'PlaceOrder.aspx/GetSuppressionList',
          addItemKey: 'order/addOrderSuppressions',
          removeItemKey: 'order/removeOrderSuppressions',
          clearItemsKey: 'OrderSuppressions',
          searchText1: 'Order Name',
          searchText2: 'Order Number',
          isShowAddAll: true,
          itemTitle1: 'Order Date',
          itemTitle2: 'Order Code',
          itemTitle3: 'Order Name',
          itemTitle4: 'Quantity',
          selectItemTitle1: 'Order Code',
          selectItemTitle2: 'Order Name',
          filterAdded: 'OrderCode'
        },
        slc: {
          type: 'slc',
          itemTitle: 'Your Saved Count List Count(s)',
          selectedTitle: 'Saved Counts to Suppress',
          getItemUrl: 'PlaceOrder.aspx/GetSaveCountSuppressionList',
          addItemKey: 'order/addSaveCountSuppressions',
          removeItemKey: 'order/removeSaveCountSuppressions',
          clearItemsKey: 'SaveCountSuppressions',
          searchText1: 'Count Name',
          searchText2: 'Count Number',
          isShowAddAll: true,
          itemTitle1: 'Count Date',
          itemTitle2: 'Count ID',
          itemTitle3: 'Count Name',
          itemTitle4: 'Quantity',
          selectItemTitle1: 'Count ID',
          selectItemTitle2: 'Count Name',
          filterAdded: 'OrderCode'
        },
        file: {
          type: 'file',
          itemTitle: 'Your Custom Order List',
          selectedTitle: 'Uploaded Files to Suppress',
          getItemUrl: 'PlaceOrder.aspx/GetCustomSuppressions',
          addItemKey: 'order/addCustomSuppressions',
          removeItemKey: 'order/removeCustomSuppressions',
          clearItemsKey: 'OrderSuppressions',
          searchText1: 'Order Name',
          searchText2: 'Order Number',
          isShowAddAll: true,
          itemTitle1: 'File Date',
          itemTitle2: 'File Name',
          selectItemTitle1: 'Order Date',
          selectItemTitle2: 'File Name',
          filterAdded: 'SuppressionValue',
          isFile: true
        }
      }
    };
  },

  watch: {
    type: function type(val) {
      this.$emit('updateType', val);
    }
  },
  computed: {
    startDate: {
      get: function get() {
        if (this.subType !== 'date') {
          return null;
        }
        var date = null;
        if (this.suppressionType === 'order') {
          date = this.$store.state.order.SuppressionStartDate;
        } else if (this.suppressionType === 'slc') {
          date = this.$store.state.order.SaveCountSuppressionStartDate;
        } else {
          date = this.$store.state.order.CustomSuppressionStartDate;
        }
        if (!date) {
          date = new Date(new Date() - 7 * 86400000);
          var key = 'SuppressionStartDate';
          if (this.suppressionType === 'slc') {
            key = 'SaveCountSuppressionStartDate';
          } else if (this.suppressionType === 'file') {
            key = 'CustomSuppressionStartDate';
          }
          this.$store.commit('order/saveKey', [key, date]);
        }
        return date;
      },
      set: function set(val) {
        if (val === this.startDate) {
          return false;
        }
        var key = 'SuppressionStartDate';
        if (this.suppressionType === 'slc') {
          key = 'SaveCountSuppressionStartDate';
        } else if (this.suppressionType === 'file') {
          key = 'CustomSuppressionStartDate';
        }
        this.$store.commit('order/saveKey', [key, val]);
      }
    },
    endDate: {
      get: function get() {
        if (this.subType !== 'date') {
          return null;
        }
        var date = null;
        if (this.suppressionType === 'order') {
          date = this.$store.state.order.SuppressionEndDate;
        } else if (this.suppressionType === 'slc') {
          date = this.$store.state.order.SaveCountSuppressionEndDate;
        } else {
          date = this.$store.state.order.CustomSuppressionEndDate;
        }
        if (!date) {
          date = new Date();
          var key = 'SuppressionEndDate';
          if (this.suppressionType === 'slc') {
            key = 'SaveCountSuppressionEndDate';
          } else if (this.suppressionType === 'file') {
            key = 'CustomSuppressionEndDate';
          }
          this.$store.commit('order/saveKey', [key, date]);
        }
        return date;
      },
      set: function set(val) {
        if (val === this.endtDate) {
          return false;
        }
        var key = 'SuppressionEndDate';
        if (this.suppressionType === 'slc') {
          key = 'SaveCountSuppressionEndDate';
        } else if (this.suppressionType === 'file') {
          key = 'CustomSuppressionEndDate';
        }
        this.$store.commit('order/saveKey', [key, val]);
      }
    },
    endDateDisabled: function endDateDisabled() {
      return {
        from: new Date(),
        to: this.startDate
      };
    },
    listType: function listType() {
      return this.$store.state.order.ListType;
    },
    orderSuppressions: function orderSuppressions() {
      return this.$store.state.order.OrderSuppressions || [];
    },
    savCountSuppressions: function savCountSuppressions() {
      return this.$store.state.order.SaveCountSuppressions || [];
    },
    customSuppressions: function customSuppressions() {
      return this.$store.state.order.CustomSuppressions || [];
    },
    suppressionItems: function suppressionItems() {
      var result = [];
      if (this.suppressionType === 'order') {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(this.orderSuppressions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            result.push({
              name: item.SuppressionName,
              code: item.SuppressedOrderCode,
              value: item.SuppressionValue
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else if (this.suppressionType === 'slc') {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(this.savCountSuppressions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _item = _step2.value;

            result.push({
              name: _item.SuppressionName,
              code: _item.SuppressedCountCode,
              value: _item.SuppressionValue
            });
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(this.customSuppressions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _item2 = _step3.value;

            result.push({
              code: _item2.OrderDate,
              name: _item2.FileName,
              value: _item2.SuppressionValue,
              SuppressionDesc: _item2.SuppressionDesc,
              OrderDate: _item2.OrderDate,
              SuppressionName: _item2.SuppressionName,
              SuppressionValue: _item2.SuppressionValue
            });
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      return result;
    },
    configeData: function configeData() {
      return this.configDatas[this.suppressionType];
    }
  },
  methods: {
    updateType: function updateType(val) {
      this.$emit('updateType', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-479073a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/MsuppressionItem.vue
var MsuppressionItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-radio-group',{attrs:{"checked":_vm.subType},on:{"change":function($event){return _vm.updateType($event)}}},[_c('b-form-radio',{attrs:{"value":"date","data-test":("demo-suppression-box-date-" + _vm.suppressionType)}},[_vm._v("By Date Range")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"item","data-test":("demo-suppression-box-item-" + _vm.suppressionType)}},[_vm._v("By Selected Order(s)")])],1),_vm._v(" "),(_vm.subType==='date')?_c('div',[_vm._v("\n    Start Date\n    "),_c('datepicker',{model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v("\n    End Date\n    "),_c('datepicker',{attrs:{"disabled":_vm.endDateDisabled},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}),_c('br')],1):_vm._e(),_vm._v(" "),(_vm.subType==='item')?_c('m-suppression-select-item',{attrs:{"configData":_vm.configeData,"suppressions":_vm.suppressionItems}}):_vm._e()],1)}
var MsuppressionItem_staticRenderFns = []
var MsuppressionItem_esExports = { render: MsuppressionItem_render, staticRenderFns: MsuppressionItem_staticRenderFns }
/* harmony default export */ var demo_MsuppressionItem = (MsuppressionItem_esExports);
// CONCATENATED MODULE: ./src/components/demo/MsuppressionItem.vue
function MsuppressionItem_injectStyle (ssrContext) {
  __webpack_require__("KQVM")
}
var MsuppressionItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MsuppressionItem___vue_template_functional__ = false
/* styles */
var MsuppressionItem___vue_styles__ = MsuppressionItem_injectStyle
/* scopeId */
var MsuppressionItem___vue_scopeId__ = "data-v-479073a4"
/* moduleIdentifier (server only) */
var MsuppressionItem___vue_module_identifier__ = null
var MsuppressionItem_Component = MsuppressionItem_normalizeComponent(
  MsuppressionItem,
  demo_MsuppressionItem,
  MsuppressionItem___vue_template_functional__,
  MsuppressionItem___vue_styles__,
  MsuppressionItem___vue_scopeId__,
  MsuppressionItem___vue_module_identifier__
)

/* harmony default export */ var components_demo_MsuppressionItem = (MsuppressionItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/MUploadsuppression.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MUploadsuppression = ({
  components: {},
  props: {},
  created: function created() {},
  data: function data() {
    return {
      uploadfile: null,
      items: [],
      uploadlistcolumns: [],
      targetFile: '',
      alertShow: false
    };
  },

  computed: {
    listType: function listType() {
      return this.$store.state.order.ListType;
    }
  },
  watch: {},
  methods: {
    upload: function upload() {
      var _this = this;

      this.alertShow = false;
      var formData = new FormData();
      formData.append('filename', this.uploadfile, this.uploadfile.filename);
      this.$http.post('Common/ExcelUploader.ashx', formData).then(function (resp) {
        _this.targetFile = resp.body.DataSource;
        _this.targetFile.UserFileName = _this.uploadfile.filename;
        _this.getRecord(resp.body.DataSource.TargetFile);
      });
    },
    getRecord: function getRecord(TargetFile) {
      var _this2 = this;

      this.$http.post('PlaceOrder.aspx/GetRecord', {
        filePath: TargetFile,
        type: 1
      }).then(function (resp) {
        _this2.items = resp.body.d.DataSource.SuccessRow;
        _this2.uploadlistcolumns = resp.body.d.DataSource.UpLoadListColumn;
        _this2.$root.$emit('bv::show::modal', 'upladSuppression');
      });
    },
    save: function save() {
      var _this3 = this;

      this.$http.post('PlaceOrder.aspx/ProcessCustomSuppressionFile', {
        file: this.targetFile,
        listType: this.listType
      }).then(function (resp) {
        _this3.uploadNotifier();
      });
    },
    uploadNotifier: function uploadNotifier() {
      var _this4 = this;

      this.$http.post('PlaceOrder.aspx/SuppressionUploadNotifier', {
        Quantity: this.items.length
      }).then(function (resp) {
        _this4.alertShow = true;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2b3f6a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/MUploadsuppression.vue
var MUploadsuppression_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-file',{attrs:{"placeholder":"Drop file here"},on:{"input":_vm.upload},model:{value:(_vm.uploadfile),callback:function ($$v) {_vm.uploadfile=$$v},expression:"uploadfile"}}),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.alertShow,"variant":"success","dismissible":""}},[_c('p',{staticStyle:{"padding-right":"32px"}},[_vm._v("We're loading your file for suppression. When it is ready, typically within 30 minutes, you will be alerted via email.\n      You will then see this file in the 'Suppress Uploaded File' option when building your list.\n   ")])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"upladSuppression","size":"lg","title":"Upload a File for Suppression"},on:{"ok":_vm.save}},[_vm._v("\n    Your file has uploaded successfully.Total count record is "+_vm._s(_vm.items.length)+"\n    "),_c('div',{staticClass:"table-box"},[_c('table',{staticClass:"table"},[_c('tr',_vm._l((_vm.uploadlistcolumns),function(col){return _c('td',[_vm._v(_vm._s(col.ColumnName))])}),0),_vm._v(" "),_vm._l((_vm.items),function(row){return _c('tr',_vm._l((row.RowData),function(col){return _c('td',[_vm._v(_vm._s(col.Data))])}),0)})],2)])])],1)}
var MUploadsuppression_staticRenderFns = []
var MUploadsuppression_esExports = { render: MUploadsuppression_render, staticRenderFns: MUploadsuppression_staticRenderFns }
/* harmony default export */ var demo_MUploadsuppression = (MUploadsuppression_esExports);
// CONCATENATED MODULE: ./src/components/demo/MUploadsuppression.vue
function MUploadsuppression_injectStyle (ssrContext) {
  __webpack_require__("1IzS")
}
var MUploadsuppression_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MUploadsuppression___vue_template_functional__ = false
/* styles */
var MUploadsuppression___vue_styles__ = MUploadsuppression_injectStyle
/* scopeId */
var MUploadsuppression___vue_scopeId__ = "data-v-a2b3f6a4"
/* moduleIdentifier (server only) */
var MUploadsuppression___vue_module_identifier__ = null
var MUploadsuppression_Component = MUploadsuppression_normalizeComponent(
  MUploadsuppression,
  demo_MUploadsuppression,
  MUploadsuppression___vue_template_functional__,
  MUploadsuppression___vue_styles__,
  MUploadsuppression___vue_scopeId__,
  MUploadsuppression___vue_module_identifier__
)

/* harmony default export */ var components_demo_MUploadsuppression = (MUploadsuppression_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/DemoSuppression.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var DemoSuppression = ({
  components: {
    MDemoBox: components_demo_MDemoBox,
    MSuppressionItem: components_demo_MsuppressionItem,
    MUploadSuppression: components_demo_MUploadsuppression
  },
  data: function data() {
    return {
      file: null
    };
  },

  computed: {
    type: function type() {
      return this.$store.getters['order/suppressionType'];
    },
    listType: function listType() {
      return this.$store.state.order.ListType;
    }
  },
  created: function created() {
    if (this.$store.state.order.SuppressionType === 0) {
      this.$store.dispatch('order/updateSuppressionType', {
        order: false,
        slc: false,
        file: false
      });
    }
  },

  methods: {
    changeSubType: function changeSubType(key, val) {
      var type = assign_default()({}, this.type);
      type[key] = val;
      if (!lodash_default.a.isEqual(this.type, type)) {
        this.$store.dispatch('order/updateSuppressionType', type);
      }
    },
    changeType: function changeType(key, val) {
      if (val === true) {
        val = 'date';
      }
      var type = assign_default()({}, this.type);
      type[key] = val;
      if (!lodash_default.a.isEqual(this.type, type)) {
        this.$store.dispatch('order/updateSuppressionType', type);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0af45eb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoSuppression.vue
var DemoSuppression_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":"suppression"}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"item"},[_c('b-checkbox',{attrs:{"checked":_vm.type.order != false,"data-test":"demo-suppress-order"},on:{"change":function($event){return _vm.changeType('order', $event)}}},[_vm._v("\n          Suppress Prior Order(s)\n        ")]),_vm._v(" "),_c('m-suppression-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.order),expression:"type.order"}],staticClass:"suppression-item",attrs:{"suppressionType":"order","subType":_vm.type.order,"item-title":"By Selected Order(s)"},on:{"updateType":function($event){return _vm.changeSubType('order', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"item"},[_c('b-checkbox',{attrs:{"checked":_vm.type.slc != false,"data-test":"demo-suppress-slc"},on:{"change":function($event){return _vm.changeType('slc', $event)}}},[_vm._v("\n          Suppress Saved List Count(s)\n        ")]),_vm._v(" "),_c('m-suppression-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.slc),expression:"type.slc"}],staticClass:"suppression-item",attrs:{"suppressionType":"slc","subType":_vm.type.slc,"item-title":"By Selected Saved Count(s)"},on:{"updateType":function($event){return _vm.changeSubType('slc', $event)}}})],1),_vm._v(" "),(_vm.listType === 10)?_c('div',{staticClass:"item"},[_c('b-checkbox',{attrs:{"checked":_vm.type.file != false,"data-test":"demo-suppress-file"},on:{"change":function($event){return _vm.changeType('file', $event)}}},[_vm._v("\n          Suppress Uploaded File\n          "),_c('a',{attrs:{"data-fancybox":"","href":'https://vimeo.com/412394699/'}},[_c('img',{attrs:{"src":__webpack_require__("aQR6"),"alt":"Video"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.file),expression:"type.file"}],attrs:{"suppressionType":"file"}},[_c('m-suppression-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.file),expression:"type.file"}],staticClass:"suppression-item",attrs:{"suppressionType":"file","subType":_vm.type.file},on:{"updateType":function($event){return _vm.changeSubType('file', $event)}}}),_vm._v(" "),_c('m-upload-suppression',{staticStyle:{"margin-top":"8px"}}),_vm._v(" "),_c('p',{staticClass:"ml-2 mt-1"},[_vm._v("\n            You have the option to upload a file so that when you order new leads, you may automatically exclude those that appear in the file."),_c('br'),_vm._v(" "),_c('b-link',{attrs:{"href":_vm.$store.getters['config/link']('DownsuppressionTempFile')}},[_vm._v("Download suppression template file")])],1)],1)],1):_vm._e()])],1)],1)}
var DemoSuppression_staticRenderFns = []
var DemoSuppression_esExports = { render: DemoSuppression_render, staticRenderFns: DemoSuppression_staticRenderFns }
/* harmony default export */ var order_DemoSuppression = (DemoSuppression_esExports);
// CONCATENATED MODULE: ./src/pages/order/DemoSuppression.vue
function DemoSuppression_injectStyle (ssrContext) {
  __webpack_require__("fg26")
}
var DemoSuppression_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DemoSuppression___vue_template_functional__ = false
/* styles */
var DemoSuppression___vue_styles__ = DemoSuppression_injectStyle
/* scopeId */
var DemoSuppression___vue_scopeId__ = "data-v-0af45eb6"
/* moduleIdentifier (server only) */
var DemoSuppression___vue_module_identifier__ = null
var DemoSuppression_Component = DemoSuppression_normalizeComponent(
  DemoSuppression,
  order_DemoSuppression,
  DemoSuppression___vue_template_functional__,
  DemoSuppression___vue_styles__,
  DemoSuppression___vue_scopeId__,
  DemoSuppression___vue_module_identifier__
)

/* harmony default export */ var pages_order_DemoSuppression = (DemoSuppression_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/BusinessTypeItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var BusinessTypeItem = ({
  name: 'businessTypeItem',
  props: {
    item: {
      type: Object
    },
    deep: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      isExpand: false,
      thisDeep: 0,
      isAllAddTemple: false,
      isAllOmitTemple: false
    };
  },

  computed: {
    listType: function listType() {
      if (this.$store.state.order.ListType) {
        return this.$store.state.order.ListType;
      } else {
        return 10;
      }
    },
    values: function values() {
      if (this.item.val) {
        return this.item.val;
      } else {
        return [];
      }
    },
    isClose: function isClose() {
      return this.item.state === '';
    },
    isBtns: function isBtns() {
      return this.deep !== 0;
    },

    isAdd: {
      get: function get() {
        return this.$store.getters['order/isDemoBusinessTypeAdd'](this.item.attributes.IndustryCode);
      },
      set: function set(val) {
        if (val === this.isAdd) {
          return;
        }
        this.$store.dispatch('order/toggleAddDemoBusinessType', {
          val: val,
          industryCode: this.item.attributes.IndustryCode,
          IndustryDesc: this.item.data,
          values: this.values
        });
      }
    },
    isOmit: {
      get: function get() {
        return this.$store.getters['order/isDemoBusinessTypeOmit'](this.item.attributes.IndustryCode);
      },
      set: function set(val) {
        if (val === this.isOmit) {
          return;
        }
        this.$store.dispatch('order/toggleOmitDemoBusinessType', {
          val: val,
          industryCode: this.item.attributes.IndustryCode,
          IndustryDesc: this.item.data,
          values: this.values
        });
      }
    },
    isAllAdd: {
      get: function get() {
        return this.isAllAddTemple;
      },
      set: function set(val) {
        this.$store.dispatch('order/toggleAddDemoBusinessType', {
          val: val,
          industryCode: this.item.attributes.IndustryCode,
          IndustryDesc: this.item.data,
          deep: 0,
          values: this.values
        });
        this.isAllAddTemple = val;
      }
    },
    isAllOmit: {
      get: function get() {
        return this.isAllOmitTemple;
      },
      set: function set(val) {
        this.$store.dispatch('order/toggleOmitDemoBusinessType', {
          val: val,
          industryCode: this.item.attributes.IndustryCode,
          IndustryDesc: this.item.data,
          deep: 0,
          values: this.values
        });
        this.isAllOmitTemple = val;
      }
    }
  },
  mounted: function mounted() {
    this.thisDeep = this.deep + 1;
  },

  methods: {
    select: function select() {
      if (this.isExpand) {
        this.isExpand = false;
      } else if (!this.isExpand) {
        this.isExpand = true;
        this.expand();
      }
    },
    shrink: function shrink() {
      this.isExpand = false;
    },
    expand: function expand() {
      var _this = this;

      this.isExpand = true;
      if (this.values.length > 0) {
        return;
      }
      this.$http.post('PlaceOrder.aspx/GetChildrenBySICCode', {
        id: this.item.attributes.IndustryCode,
        listType: this.listType
      }).then(function (resp) {
        var val = resp.body.d.DataSource;
        for (var i = 0; i < val.length; i++) {
          var datas = val[i].data.split('\n');
          val[i].data = datas[0];
        }
        _this.$set(_this.item, 'val', val);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88a9dcce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/BusinessTypeItem.vue
var BusinessTypeItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-box"},[(_vm.isBtns)?_c('span',{staticClass:"btns"},[_c('span',[_c('b-form-checkbox',{staticClass:"custom-control-inline custom-add",attrs:{"disabled":_vm.isOmit,"data-test":"demo-businessType-item-add"},model:{value:(_vm.isAdd),callback:function ($$v) {_vm.isAdd=$$v},expression:"isAdd"}})],1),_vm._v(" "),_c('span',[_c('b-form-checkbox',{staticClass:"custom-control-inline",attrs:{"disabled":_vm.isAdd,"data-test":"demo-businessType-item-omit"},model:{value:(_vm.isOmit),callback:function ($$v) {_vm.isOmit=$$v},expression:"isOmit"}})],1)]):_vm._e(),_vm._v(" "),(!_vm.isBtns&&!_vm.isExpand)?_c('span',{staticClass:"btns-block"}):_vm._e(),_vm._v(" "),(!_vm.isBtns&&_vm.isExpand)?_c('span',{staticClass:"btns"},[_c('span',[_c('b-form-checkbox',{staticClass:"custom-control-inline",attrs:{"disabled":_vm.isAllOmitTemple,"data-test":"demo-businessType-item-add"},model:{value:(_vm.isAllAdd),callback:function ($$v) {_vm.isAllAdd=$$v},expression:"isAllAdd"}})],1),_vm._v(" "),_c('span',[_c('b-form-checkbox',{staticClass:"custom-control-inline",attrs:{"disabled":_vm.isAllAddTemple,"data-test":"demo-businessType-item-omit"},model:{value:(_vm.isAllOmit),callback:function ($$v) {_vm.isAllOmit=$$v},expression:"isAllOmit"}})],1)]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"item",style:({'margin-left': 16 * _vm.deep + 'px'}),attrs:{"data-test":"demo-businessType-item"},on:{"click":_vm.select}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isClose),expression:"!isClose"}]},[(!_vm.isExpand)?_c('span',{staticClass:"item-btn",attrs:{"data-test":"demo-businessType-item-shrink"},on:{"click":_vm.shrink}},[_c('icon',{staticClass:"fold-icon",attrs:{"name":"folder"}})],1):_vm._e(),_vm._v(" "),(_vm.isExpand)?_c('span',{staticClass:"item-btn",attrs:{"data-test":"demo-businessType-item-expand"},on:{"click":_vm.expand}},[_c('icon',{staticClass:"fold-icon",attrs:{"name":"folder-open"}})],1):_vm._e()]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isClose),expression:"isClose"}],staticClass:"icon-close",attrs:{"data-test":"demo-businessType-item-expand2"}},[_c('icon',{staticClass:"fold-icon",attrs:{"name":"file"}})],1),_vm._v(" "),_c('span',{attrs:{"data-test":"demo-businessType-item-expand3"},on:{"click":_vm.expand}},[_vm._v(_vm._s(_vm.item.data))])]),_vm._v(" "),_vm._l((_vm.values),function(val){return (_vm.values.length > 0 && _vm.isExpand)?_c('business-type-item',{key:val.data,attrs:{"item":val,"deep":_vm.thisDeep}}):_vm._e()})],2)}
var BusinessTypeItem_staticRenderFns = []
var BusinessTypeItem_esExports = { render: BusinessTypeItem_render, staticRenderFns: BusinessTypeItem_staticRenderFns }
/* harmony default export */ var demo_BusinessTypeItem = (BusinessTypeItem_esExports);
// CONCATENATED MODULE: ./src/components/demo/BusinessTypeItem.vue
function BusinessTypeItem_injectStyle (ssrContext) {
  __webpack_require__("Lygm")
}
var BusinessTypeItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BusinessTypeItem___vue_template_functional__ = false
/* styles */
var BusinessTypeItem___vue_styles__ = BusinessTypeItem_injectStyle
/* scopeId */
var BusinessTypeItem___vue_scopeId__ = "data-v-88a9dcce"
/* moduleIdentifier (server only) */
var BusinessTypeItem___vue_module_identifier__ = null
var BusinessTypeItem_Component = BusinessTypeItem_normalizeComponent(
  BusinessTypeItem,
  demo_BusinessTypeItem,
  BusinessTypeItem___vue_template_functional__,
  BusinessTypeItem___vue_styles__,
  BusinessTypeItem___vue_scopeId__,
  BusinessTypeItem___vue_module_identifier__
)

/* harmony default export */ var components_demo_BusinessTypeItem = (BusinessTypeItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/BusinessTypeSearchItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var BusinessTypeSearchItem = ({
  props: {
    item: {
      type: Object
    },
    deep: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      isExpand: false,
      thisDeep: 0
    };
  },

  computed: {
    listType: function listType() {
      if (this.$store.state.order.ListType) {
        return this.$store.state.order.ListType;
      } else {
        return 10;
      }
    },
    values: function values() {
      if (this.item.val) {
        return this.item.val;
      } else {
        return [];
      }
    },
    isClose: function isClose() {
      return this.item.state === '';
    },
    isBtns: function isBtns() {
      return this.deep !== 0;
    },

    isAdd: {
      get: function get() {
        return this.$store.getters['order/isDemoBusinessTypeAdd'](this.item.IndustryCode);
      },
      set: function set(val) {
        if (val === this.isAdd) {
          return;
        }
        this.$store.dispatch('order/toggleAddDemoBusinessType', {
          val: val,
          industryCode: this.item.IndustryCode,
          IndustryDesc: this.item.IndustryCode + ':' + this.item.IndustryDesc
        });
      }
    },
    isOmit: {
      get: function get() {
        return this.$store.getters['order/isDemoBusinessTypeOmit'](this.item.IndustryCode);
      },
      set: function set(val) {
        if (val === this.isOmit) {
          return;
        }
        this.$store.dispatch('order/toggleOmitDemoBusinessType', {
          val: val,
          industryCode: this.item.IndustryCode,
          IndustryDesc: this.item.IndustryCode + ':' + this.item.IndustryDesc
        });
      }
    }
  },
  mounted: function mounted() {
    this.thisDeep = this.deep + 1;
  },

  methods: {
    select: function select() {
      if (this.isExpand) {
        this.isExpand = false;
      } else if (!this.isExpand) {
        this.isExpand = true;
        this.expand();
      }
    },
    shrink: function shrink() {
      this.isExpand = false;
    },
    expand: function expand() {
      var _this = this;

      this.isExpand = true;
      if (this.values.length > 0) {
        return;
      }
      this.$http.post('PlaceOrder.aspx/GetChildrenBySICCode', {
        id: this.item.attributes.IndustryCode,
        listType: this.listType
      }).then(function (resp) {
        var val = resp.body.d.DataSource;
        for (var i = 0; i < val.length; i++) {
          var datas = val[i].data.split('\n');
          val[i].data = datas[0];
        }
        _this.$set(_this.item, 'val', val);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51d1b243","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/BusinessTypeSearchItem.vue
var BusinessTypeSearchItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-box"},[(_vm.item.IsBottom === 0)?_c('span',{staticClass:"bottom-item"},[_vm._v("\n     "+_vm._s(_vm.item.IndustryDesc)+"\n   ")]):_vm._e(),_vm._v(" "),(_vm.item.IsBottom === 1)?_c('span',[_c('span',{staticClass:"btns"},[_c('span',[_c('b-form-checkbox',{staticClass:"custom-control-inline",attrs:{"disabled":_vm.isOmit,"data-test":"demo-businessType-search-add"},model:{value:(_vm.isAdd),callback:function ($$v) {_vm.isAdd=$$v},expression:"isAdd"}})],1),_vm._v(" "),_c('span',[_c('b-form-checkbox',{staticClass:"custom-control-inline",attrs:{"disabled":_vm.isAdd,"data-test":"demo-businessType-search-omit"},model:{value:(_vm.isOmit),callback:function ($$v) {_vm.isOmit=$$v},expression:"isOmit"}})],1)]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.item.IndustryCode)+":"+_vm._s(_vm.item.IndustryDesc))])]):_vm._e()])}
var BusinessTypeSearchItem_staticRenderFns = []
var BusinessTypeSearchItem_esExports = { render: BusinessTypeSearchItem_render, staticRenderFns: BusinessTypeSearchItem_staticRenderFns }
/* harmony default export */ var demo_BusinessTypeSearchItem = (BusinessTypeSearchItem_esExports);
// CONCATENATED MODULE: ./src/components/demo/BusinessTypeSearchItem.vue
function BusinessTypeSearchItem_injectStyle (ssrContext) {
  __webpack_require__("M19j")
}
var BusinessTypeSearchItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BusinessTypeSearchItem___vue_template_functional__ = false
/* styles */
var BusinessTypeSearchItem___vue_styles__ = BusinessTypeSearchItem_injectStyle
/* scopeId */
var BusinessTypeSearchItem___vue_scopeId__ = "data-v-51d1b243"
/* moduleIdentifier (server only) */
var BusinessTypeSearchItem___vue_module_identifier__ = null
var BusinessTypeSearchItem_Component = BusinessTypeSearchItem_normalizeComponent(
  BusinessTypeSearchItem,
  demo_BusinessTypeSearchItem,
  BusinessTypeSearchItem___vue_template_functional__,
  BusinessTypeSearchItem___vue_styles__,
  BusinessTypeSearchItem___vue_scopeId__,
  BusinessTypeSearchItem___vue_module_identifier__
)

/* harmony default export */ var components_demo_BusinessTypeSearchItem = (BusinessTypeSearchItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/DemoBusinessType.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var DemoBusinessType = ({
  components: {
    MDemoBox: components_demo_MDemoBox,
    MDemoAllCheck: components_demo_MDemoAllCheck,
    BusinessTypeItem: components_demo_BusinessTypeItem,
    BusinessTypeSearchItem: components_demo_BusinessTypeSearchItem
  },
  data: function data() {
    return {
      searchKey: '',
      demos: [],
      searchDemos: [],
      isSearch: false
    };
  },

  computed: {
    listType: function listType() {
      if (this.$store.state.order.ListType) {
        return this.$store.state.order.ListType;
      } else {
        return 10;
      }
    },
    SICs: function SICs() {
      return this.$store.state.demo.SICs;
    },
    isAllHoseholds: function isAllHoseholds() {
      return this.$store.getters['order/isAllHoseholds'];
    },
    selectAddItem: function selectAddItem() {
      return this.$store.getters['order/demoBusinessTypeAddItem'];
    },
    selectOmitItem: function selectOmitItem() {
      return this.$store.getters['order/demoBusinessTypeOmitItem'];
    }
  },
  created: function created() {
    this.getData();
  },

  watch: {
    '$route.params.listType': function $routeParamsListType() {
      this.getData();
    }
  },
  methods: {
    getData: function getData() {
      var _this = this;

      this.demos = [];
      this.$http.post('PlaceOrder.aspx/GetChildrenBySICCode', {
        id: '',
        listType: this.listType
      }).then(function (resp) {
        _this.demos = resp.body.d.DataSource;
      });
    },
    search: function search() {
      var _this2 = this;

      if (this.searchKey === '') {
        this.isSearch = false;
        return;
      }
      this.isSearch = true;
      this.$http.post('PlaceOrder.aspx/SearchSICByKeyword', {
        keyword: this.searchKey,
        listType: this.listType
      }, {
        abortPre: true
      }).then(function (resp) {
        _this2.searchDemos = resp.body.d.DataSource;
      });
    },
    removeAdd: function removeAdd(item) {
      this.$store.dispatch('order/toggleAddDemoBusinessType', {
        val: false,
        industryCode: item.AttributeValue,
        IndustryDesc: item.AttributeValueName
      });
    },
    removeOmit: function removeOmit(item) {
      this.$store.dispatch('order/toggleOmitDemoBusinessType', {
        val: false,
        industryCode: item.AttributeValue,
        IndustryDesc: item.AttributeValueName
      });
    },
    removeAllAdd: function removeAllAdd() {
      this.$store.dispatch('order/deleteDemo', {
        type: 'column',
        columnName: 7,
        demoCategoryType: 4
      });
    },
    removeAllOmit: function removeAllOmit() {
      this.$store.dispatch('order/deleteDemo', {
        type: 'column',
        columnName: 7,
        demoCategoryType: 6
      });
    },
    removeAll: function removeAll() {
      this.removeAllAdd();
      this.removeAllOmit();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27a8f050","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoBusinessType.vue
var DemoBusinessType_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":"businessType"}},[_c('div',{attrs:{"slot":"top"},slot:"top"},[_c('m-demo-all-check')],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"search-box"},[_c('b-input',{attrs:{"placeholde":"Enter a SIC Code or Search Term Here","disabled":_vm.isAllHoseholds,"data-test":"demo-businessType-search"},on:{"input":_vm.search},model:{value:(_vm.searchKey),callback:function ($$v) {_vm.searchKey=$$v},expression:"searchKey"}}),_vm._v(" "),_c('span',{staticClass:"search-btn",on:{"click":_vm.search}},[_c('icon',{attrs:{"name":"search"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"box-t",class:{disabled: _vm.isAllHoseholds}},[_c('div',[_c('span',{staticClass:"item-btns",attrs:{"href":"javascript:void(0)"}},[_vm._v("Add")]),_vm._v(" "),_c('span',{staticClass:"item-btns",attrs:{"href":"javascript:void(0)"}},[_vm._v("Omit")]),_vm._v(" "),_c('b-link',{staticClass:"item-btns",attrs:{"href":"javascript:void(0)","data-test":"demo-businessType-clearAll"},on:{"click":_vm.removeAll}},[_vm._v("Clear All")])],1),_vm._v(" "),_c('div',{staticClass:"sicitem"},[_vm._l((_vm.demos),function(item){return (!_vm.isSearch)?_c('business-type-item',{key:item.data,attrs:{"item":item,"data-test":("demo-businessType-itemName-" + (item.data))}}):_vm._e()}),_vm._v(" "),_vm._l((_vm.searchDemos),function(item){return (_vm.isSearch)?_c('business-type-search-item',{key:item.data,attrs:{"item":item}}):_vm._e()})],2)])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('b-link',{staticClass:"clear-selection",class:{disabled: _vm.isAllHoseholds},attrs:{"href":"javascript:void(0)","data-test":"demo-businessType-removeAll"},on:{"click":_vm.removeAllAdd}},[_vm._v("Clear\n        Selection")]),_vm._v(" "),_c('h4',[_vm._v("My Selected Industries")]),_vm._v(" "),_c('div',{staticClass:"box-t select",class:{disabled: _vm.isAllHoseholds}},_vm._l((_vm.selectAddItem),function(item){return _c('div',[_vm._v("\n          "+_vm._s(item.AttributeValueName)+"\n          "),_c('b-link',{staticClass:"selected-remove",attrs:{"href":"javascript:void(0)","data-test":"demo-businessType-remove"},on:{"click":function($event){return _vm.removeAdd(item)}}},[_vm._v("Remove")])],1)}),0)],1),_vm._v(" "),_c('b-col',[_c('b-link',{staticClass:"clear-selection",class:{disabled: _vm.isAllHoseholds},attrs:{"href":"javascript:void(0)","data-test":"demo-businessType-removeAllOmit"},on:{"click":_vm.removeAllOmit}},[_vm._v("Clear\n        Selection")]),_vm._v(" "),_c('h4',[_vm._v("My Omitted Industries")]),_vm._v(" "),_c('div',{staticClass:"box-t select",class:{disabled: _vm.isAllHoseholds}},_vm._l((_vm.selectOmitItem),function(item){return _c('div',[_vm._v("\n          "+_vm._s(item.AttributeValueName)+"\n          "),_c('b-link',{staticClass:"selected-remove",attrs:{"href":"javascript:void(0)","data-test":"demo-businessType-removeOmit"},on:{"click":function($event){return _vm.removeOmit(item)}}},[_vm._v("Remove")])],1)}),0)],1)],1)],1)}
var DemoBusinessType_staticRenderFns = []
var DemoBusinessType_esExports = { render: DemoBusinessType_render, staticRenderFns: DemoBusinessType_staticRenderFns }
/* harmony default export */ var order_DemoBusinessType = (DemoBusinessType_esExports);
// CONCATENATED MODULE: ./src/pages/order/DemoBusinessType.vue
function DemoBusinessType_injectStyle (ssrContext) {
  __webpack_require__("8jTq")
}
var DemoBusinessType_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DemoBusinessType___vue_template_functional__ = false
/* styles */
var DemoBusinessType___vue_styles__ = DemoBusinessType_injectStyle
/* scopeId */
var DemoBusinessType___vue_scopeId__ = "data-v-27a8f050"
/* moduleIdentifier (server only) */
var DemoBusinessType___vue_module_identifier__ = null
var DemoBusinessType_Component = DemoBusinessType_normalizeComponent(
  DemoBusinessType,
  order_DemoBusinessType,
  DemoBusinessType___vue_template_functional__,
  DemoBusinessType___vue_styles__,
  DemoBusinessType___vue_scopeId__,
  DemoBusinessType___vue_module_identifier__
)

/* harmony default export */ var pages_order_DemoBusinessType = (DemoBusinessType_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MListOutputFields.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MListOutputFields = ({
  components: {},
  created: function created() {},
  data: function data() {
    return {
      title: 'List Output Fields',
      okTitle: 'OK',
      showError: false,
      selectcolumn: [],
      unselectcolumn: []
    };
  },

  computed: {
    order: function order() {
      return this.$store.state.order;
    },
    summary: function summary() {
      return this.$store.state.summary;
    },
    selectedcol: function selectedcol() {
      return this.$store.state.summary.SelectCols;
    },
    outputcol: function outputcol() {
      return this.$store.state.summary.ListOutputFields;
    }
  },
  methods: {
    addColumns: function addColumns() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.selectcolumn), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          this.$store.commit('summary/saveSelectedCols', { text: item.ColumnDesc, value: item.ColumnName, disabled: false });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.saveorder();
    },
    cleanCloumns: function cleanCloumns() {
      this.$store.commit('summary/clearCols');
      this.saveorder();
    },
    deleteColumns: function deleteColumns() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.unselectcolumn), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          this.$store.commit('summary/deleteCols', item);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.saveorder();
    },
    saveorder: function saveorder() {
      var cols = [];
      for (var i in this.selectedcol) {
        if (!this.selectedcol[i].disabled) {
          cols.push(this.selectedcol[i]);
        }
      }
      var oldelements = this.$store.state.order.ElementsForPricing;
      var olds = [];
      for (var item in oldelements) {
        if (!oldelements[item].IsAdditional) {
          olds.push(oldelements[item]);
        }
      }
      this.$store.commit('order/clearElementsForPricing');
      this.$store.commit('order/saveAdditionalOutputColumns', '');
      for (var _item in olds) {
        this.$store.commit('order/addElementsForPricing', olds[_item]);
      }
      var colums = '';
      for (var _i in cols) {
        var price = void 0;
        for (var j in this.outputcol) {
          if (this.outputcol[j].ColumnName === cols[_i].value) {
            price = this.outputcol[j];
            colums = colums + price.ColumnName + ',';
            var pricecol;
            if (price.IsSubElement) {
              pricecol = {
                ElementName: price.ParentColumnName,
                IsAdditional: true,
                Price: price.ColumnPrice,
                SubColumnName: price.ColumnName
              };
            } else {
              pricecol = {
                ElementName: price.ColumnName,
                IsAdditional: true,
                Price: price.ColumnPrice
              };
            }
            this.$store.commit('order/addElementsForPricing', pricecol);
          }
        }
      }
      if (colums.length > 0) {
        colums = colums.substring(0, colums.length - 1);
      }
      this.$store.commit('order/saveAdditionalOutputColumns', colums);
      this.$store.dispatch('order/calculatePrice');
    },
    getoutputcolumns: function getoutputcolumns() {
      var _this = this;

      var selectedDemo = '';
      var that = this;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(this.order.OrderSelectedDemos), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          selectedDemo = selectedDemo + item.ColumnName + ',';
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      selectedDemo = selectedDemo.substr(0, selectedDemo.length - 1);
      this.$http.post('PlaceOrder.aspx/GetAdditionalOutputColumnsAndPrice', {
        selectedQty: that.order.TotalDesiredQty,
        priceListId: this.summary.UserPriceList.PriceListId,
        currentSelectedCols: that.order.AdditionalOutputColumns,
        selectedDemo: selectedDemo
      }).then(function (resp) {
        var arrdefault = resp.body.d.DataSource.DefaultOutputList.split(',').reverse();
        for (var _item2 in arrdefault) {
          var field = '';
          if (arrdefault[_item2] === 'DSFDeliv') {
            field = { text: 'DSF Delivery Score', value: arrdefault[_item2], disabled: true };
          } else if (arrdefault[_item2] === 'DSFWALK') {
            field = { text: 'DSF Walk Sequence', value: arrdefault[_item2], disabled: true };
          } else {
            field = { text: arrdefault[_item2], value: arrdefault[_item2], disabled: true };
          }
          _this.$store.commit('summary/saveSelectedCols', field);
        }
        var list = resp.body.d.DataSource.AdditionalOutputColumns;
        utils.sortJson(list, 'ColumnDesc', 'asc');
        _this.$store.commit('summary/saveListOutputFields', list);
      });
    },
    save: function save() {},
    showOutPutFiled: function showOutPutFiled() {
      if (this.$store.state.summary.SelectCols.length === 0 || this.$store.state.summary.ListOutputFields.length === 0) {
        this.getoutputcolumns();
      }
    }
  },
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43bc4187","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MListOutputFields.vue
var MListOutputFields_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"listoutputfields","title":_vm.title,"lazy":true,"ok-title":_vm.okTitle,"size":"lg","ok-only":""},on:{"ok":_vm.save,"show":_vm.showOutPutFiled}},[_c('b-row',[_c('b-col',[_vm._v("\n        The fields on the right side of the boxes below will be included in the output of your list order automatically. If you wish to add more fields,\n        simply choose the field(s) from the list at the left and click \"Add\". When your selections have been made click \"Save\" to continue. Please note\n        adding additional fields will increase the price of the list. If you have any questions, you may contact us at 800-399-8611."),_c('br')])],1),_vm._v(" "),_c('b-row',{staticClass:"select-box"},[_c('b-col',{attrs:{"md":"5"}},[_c('h4',[_vm._v("Available Additional Columns:")]),_vm._v(" "),_c('b-select',{staticClass:"demo-select",attrs:{"select-size":10,"multiple":""},model:{value:(_vm.selectcolumn),callback:function ($$v) {_vm.selectcolumn=$$v},expression:"selectcolumn"}},_vm._l((_vm.outputcol),function(item){return _c('option',{domProps:{"value":item}},[_vm._v("\n          "+_vm._s(item.ColumnDesc))])}),0)],1),_vm._v(" "),_c('b-col',{staticClass:"m-select-btn-box",attrs:{"md":"2"}},[_c('b-btn',{staticClass:"m-select-btn",attrs:{"size":"sm"},on:{"click":function($event){return _vm.addColumns()}}},[_vm._v("\n        Add")]),_vm._v(" "),_c('b-btn',{staticClass:"m-select-btn",attrs:{"size":"sm"},on:{"click":function($event){return _vm.deleteColumns()}}},[_vm._v("\n        Remove")]),_vm._v(" "),_c('b-btn',{staticClass:"m-select-btn",attrs:{"size":"sm"},on:{"click":function($event){return _vm.cleanCloumns()}}},[_vm._v("\n        Remove All")])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5","rows":"2"}},[_c('h4',[_vm._v("Fields Included:")]),_vm._v(" "),_c('b-select',{staticClass:"demo-select",attrs:{"select-size":10,"options":_vm.selectedcol,"multiple":""},model:{value:(_vm.unselectcolumn),callback:function ($$v) {_vm.unselectcolumn=$$v},expression:"unselectcolumn"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"totalprice"},[_c('p',[_c('span',{staticClass:"total-price-label"},[_vm._v("Total Price: ")]),_vm._v(_vm._s(_vm._f("numberFormat")(_vm.order.TotalEstmCost))+" + tax")])])],1)],1)}
var MListOutputFields_staticRenderFns = []
var MListOutputFields_esExports = { render: MListOutputFields_render, staticRenderFns: MListOutputFields_staticRenderFns }
/* harmony default export */ var summary_MListOutputFields = (MListOutputFields_esExports);
// CONCATENATED MODULE: ./src/components/summary/MListOutputFields.vue
function MListOutputFields_injectStyle (ssrContext) {
  __webpack_require__("25ou")
}
var MListOutputFields_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MListOutputFields___vue_template_functional__ = false
/* styles */
var MListOutputFields___vue_styles__ = MListOutputFields_injectStyle
/* scopeId */
var MListOutputFields___vue_scopeId__ = "data-v-43bc4187"
/* moduleIdentifier (server only) */
var MListOutputFields___vue_module_identifier__ = null
var MListOutputFields_Component = MListOutputFields_normalizeComponent(
  MListOutputFields,
  summary_MListOutputFields,
  MListOutputFields___vue_template_functional__,
  MListOutputFields___vue_styles__,
  MListOutputFields___vue_scopeId__,
  MListOutputFields___vue_module_identifier__
)

/* harmony default export */ var components_summary_MListOutputFields = (MListOutputFields_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MSummaryInfo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MSummaryInfo = ({
  components: {
    MListOutputFields: components_summary_MListOutputFields
  },
  props: {
    isUi2: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showPromotionSuccess: false,
      showErrorPromotion: false,
      promotionCodeInput: '',
      promotion: { PromotionName: 'text' }
    };
  },

  computed: {
    order: function order() {
      return this.$store.state.order;
    },

    promotionCode: {
      get: function get() {
        this.promotionCodeInput = this.order.PromoCode || '';
        return this.order.PromoCode || '';
      },
      set: function set(val) {
        this.promotionCodeInput = val;
      }
    },
    showPromotion: function showPromotion() {
      return true;
      // return this.$store.getters['site/showPromotion']
    },
    datasource: function datasource() {
      return this.$store.getters['config/datasource'];
    }
  },
  methods: {
    applyPromotionCode: function applyPromotionCode() {
      var _this = this;

      this.showErrorPromotion = false;
      this.$http.post('PlaceOrder.aspx/GetPromotion', {
        listtype: this.order.ListType,
        promotionCode: this.promotionCodeInput
      }).then(function (resp) {
        _this.$store.commit('summary/saveKey', ['Promotion', resp.body.d.DataSource]);

        if (resp.body.d.DataSource !== null) {
          _this.$store.commit('order/saveKey', ['PromoCode', _this.promotionCodeInput]);
          _this.promotion = resp.body.d.DataSource;
        } else {
          _this.showErrorPromotion = true;
          _this.$store.commit('order/saveKey', ['PromoCode', '']);
        }
        _this.$store.dispatch('order/calculatePrice');
      }, function (resp) {
        _this.promotionCodeInput = '';
        _this.$store.commit('order/saveKey', ['PromoCode', _this.promotionCodeInput]);
        _this.$store.commit('summary/saveKey', ['Promotion', resp.body.d.DataSource]);

        // this.$store.dispatch('order/calculatePrice')
      });
    },
    showBreakdown: function showBreakdown() {
      this.$root.$emit('bv::show::modal', 'listoutputfields');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-344146f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MSummaryInfo.vue
var MSummaryInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-list-output-fields'),_vm._v(" "),_c('div',{staticClass:"summary-box",class:{'summar-box-2':_vm.isUi2 }},[_c('b-container',{attrs:{"fluid":""}},[(!_vm.isUi2)?_c('b-row',[_c('b-col',{staticClass:"summary-head"},[_c('h4',[_vm._v("List Buy Order Information")])])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"clos":"6","md":"12"}},[_c('p',[_vm._v("Price Per Record: "),_c('span',{attrs:{"data-test":"summary-info-perPrice"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.order.CostPrice,'$', 5)))])]),_vm._v(" "),_c('p',[_vm._v("Qty Available: "),_c('span',{attrs:{"data-test":"summary-info-availableQty"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.order.TotalAvailableQty,'', 0)))])]),_vm._v(" "),_c('p',[_vm._v("Qty Selected: "),_c('span',{attrs:{"data-test":"summary-info-selectedQty"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.order.TotalDesiredQty,'', 0)))])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.PromoCode !== ''),expression:"order.PromoCode !== ''"}]},[_vm._v("List Price:\n            "),_c('span',{staticClass:"high"}),_c('span',{attrs:{"data-test":"summary-info-listPrice"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.order.OrderCharge)))])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"high"},[_vm._v("Total Price")]),_vm._v(":\n            "),_c('span',{attrs:{"data-test":"summary-info-totalPrice"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.order.TotalEstmCost)))]),_vm._v(" + Tax")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.CostPrice * _vm.order.TotalDesiredQty < _vm.$store.state.summary.UserPriceList.MinElementsCharge),expression:"order.CostPrice * order.TotalDesiredQty < $store.state.summary.UserPriceList.MinElementsCharge"}],staticStyle:{"margin-top":"-12px"},attrs:{"data-test":"summary-info-minimumNotice"}},[_vm._v("\n            A minimum cost of "+_vm._s(_vm._f("numberFormat")(_vm.$store.state.summary.UserPriceList.MinElementsCharge))+" has been applied to your order. "),_c('br'),_vm._v("\n            You may expand your geographic area or your target audience to add approximately\n            "+_vm._s(parseInt(_vm.order.TotalEstmCost/_vm.order.CostPrice - _vm.order.TotalDesiredQty + 1))+" more records at the same price per record, for the same total (minimum) cost.\n          ")])]),_vm._v(" "),_c('b-col',{attrs:{"clos":"6","md":"12"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPromotion),expression:"showPromotion"}]},[_c('p',{attrs:{"size":"sm"}},[_vm._v("Promotion Code")]),_vm._v(" "),_c('div',{staticClass:"promotion-form"},[_c('b-input',{staticStyle:{"margin-bottom":"8px","max-width":"300px"},attrs:{"placehodle":"summer","size":"sm","data-test":"summary-info-promotionCode"},model:{value:(_vm.promotionCode),callback:function ($$v) {_vm.promotionCode=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"promotionCode"}}),_vm._v(" "),_c('b-btn',{on:{"click":_vm.applyPromotionCode}},[_vm._v("Apply")])],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPromotionSuccess),expression:"showPromotionSuccess"}],staticClass:"promot-text"},[_vm._v("Has been promoted")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showErrorPromotion),expression:"showErrorPromotion"}],staticClass:"promot-text"},[_vm._v("Wrong Code")])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.PromoCode !== '' && _vm.order.PromotionAmount > 0),expression:"order.PromoCode !== '' && order.PromotionAmount > 0"}],attrs:{"data-test":"summary-info-promotionAmount"}},[_vm._v("\n            Promotion "+_vm._s(this.promotion.PromotionName)+":\n            "),_c('span',{staticClass:"high"}),_vm._v("-"+_vm._s(_vm._f("numberFormat")(_vm.order.PromotionAmount))+"\n          ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.PromoCode !== '' && _vm.order.PromotionPoint > 0  && _vm.order.PromotionAmount === 0),expression:"order.PromoCode !== '' && order.PromotionPoint > 0  && order.PromotionAmount === 0"}],attrs:{"data-test":"summary-info-promotionPoint"}},[_vm._v("\n            Promotion "+_vm._s(this.promotion.PromotionName)+":\n            "),_c('span',{staticClass:"high"}),_vm._v(_vm._s(_vm.order.PromotionPoint)+"\n          ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.PromoCode !== '' && this.promotion.PromotionType === 6),expression:"order.PromoCode !== '' && this.promotion.PromotionType === 6"}],attrs:{"data-test":"summary-info-promotionType"}},[_vm._v("\n            Balance of "+_vm._s(_vm.promotion.PromotionName)+"\n            "),_c('span',{staticClass:"high"}),_vm._v(":"+_vm._s(_vm._f("numberFormat")(_vm.promotion.PromotionBalance))+"\n            "),_c('span',{staticStyle:{"color":"Red"}},[_vm._v("(doesn't include current expenses)")])]),_vm._v(" "),(_vm.$store.getters['summary/rewardsPoint'] > 0)?_c('p',[_vm._v("Earned Points: "+_vm._s(_vm._f("numberFormat")(_vm.$store.getters['summary/rewardsPoint'],'', 0)))]):_vm._e()])],1),_vm._v(" "),(_vm.datasource.hasOutputFields)?_c('b-row',{attrs:{"data-test":"summary-info-hasOutput"}},[_c('b-col',[_c('b-link',{on:{"click":_vm.showBreakdown}},[_vm._v("> See what's included in list output with option to add more info.")])],1)],1):_vm._e()],1)],1)],1)}
var MSummaryInfo_staticRenderFns = []
var MSummaryInfo_esExports = { render: MSummaryInfo_render, staticRenderFns: MSummaryInfo_staticRenderFns }
/* harmony default export */ var summary_MSummaryInfo = (MSummaryInfo_esExports);
// CONCATENATED MODULE: ./src/components/summary/MSummaryInfo.vue
function MSummaryInfo_injectStyle (ssrContext) {
  __webpack_require__("LRkm")
}
var MSummaryInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MSummaryInfo___vue_template_functional__ = false
/* styles */
var MSummaryInfo___vue_styles__ = MSummaryInfo_injectStyle
/* scopeId */
var MSummaryInfo___vue_scopeId__ = "data-v-344146f2"
/* moduleIdentifier (server only) */
var MSummaryInfo___vue_module_identifier__ = null
var MSummaryInfo_Component = MSummaryInfo_normalizeComponent(
  MSummaryInfo,
  summary_MSummaryInfo,
  MSummaryInfo___vue_template_functional__,
  MSummaryInfo___vue_styles__,
  MSummaryInfo___vue_scopeId__,
  MSummaryInfo___vue_module_identifier__
)

/* harmony default export */ var components_summary_MSummaryInfo = (MSummaryInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MListUsage.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MListUsage = ({
  components: {},
  data: function data() {
    return {
      selected: 1
    };
  },

  props: {
    isUi2: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    listMultiplePrice: function listMultiplePrice() {
      if (this.$store.state.summary.UserPriceList && this.$store.state.summary.UserPriceList.ListMultiplePrice) {
        var lists = this.$store.state.summary.UserPriceList.ListMultiplePrice;
        var order = JSON.parse(stringify_default()(this.$store.state.order));
        order.ListUsage = 1;
        var totalEstmCost = priceHelp.updatePrice(order).TotalEstmCost;
        for (var i = 0; i < lists.length; i++) {
          order.ListUsage = lists[i].MultipleId;
          order = priceHelp.updatePrice(order);
          lists[i].price = (order.ListUsage > 1 ? 1 : -1) * (order.TotalEstmCost - totalEstmCost);
        }
        return lists;
      } else {
        return [];
      }
    },

    listUsage: {
      get: function get() {
        return this.$store.state.order.ListUsage;
      },
      set: function set(val) {
        this.$store.commit('order/saveKey', ['ListUsage', val]);
        this.TotalEstmCost = this.order.TotalEstmCost;
        this.$store.dispatch('order/calculatePrice');
      }
    },
    order: function order() {
      return this.$store.state.order;
    },
    created: function created() {
      this.TotalEstmCost = this.order.TotalEstmCost;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09582ff8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MListUsage.vue
var MListUsage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-box",class:{'summar-box-2':_vm.isUi2 }},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"summary-head"},[(!_vm.isUi2)?_c('h4',[_vm._v("List Usage")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-radio-group',{attrs:{"stacked":""},model:{value:(_vm.listUsage),callback:function ($$v) {_vm.listUsage=$$v},expression:"listUsage"}},_vm._l((_vm.listMultiplePrice),function(item){return _c('b-form-radio',{key:item.MultipleId,staticClass:"item",attrs:{"value":item.MultipleId}},[_vm._v("\n            I will use the list "+_vm._s(item.Desc.toLowerCase())+"\n            "),_c('span',[_vm._v("(+"+_vm._s(_vm._f("numberFormat")(item.price))+")")])])}),1)],1)],1)],1)],1)}
var MListUsage_staticRenderFns = []
var MListUsage_esExports = { render: MListUsage_render, staticRenderFns: MListUsage_staticRenderFns }
/* harmony default export */ var summary_MListUsage = (MListUsage_esExports);
// CONCATENATED MODULE: ./src/components/summary/MListUsage.vue
function MListUsage_injectStyle (ssrContext) {
  __webpack_require__("E7fJ")
}
var MListUsage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MListUsage___vue_template_functional__ = false
/* styles */
var MListUsage___vue_styles__ = MListUsage_injectStyle
/* scopeId */
var MListUsage___vue_scopeId__ = "data-v-09582ff8"
/* moduleIdentifier (server only) */
var MListUsage___vue_module_identifier__ = null
var MListUsage_Component = MListUsage_normalizeComponent(
  MListUsage,
  summary_MListUsage,
  MListUsage___vue_template_functional__,
  MListUsage___vue_styles__,
  MListUsage___vue_scopeId__,
  MListUsage___vue_module_identifier__
)

/* harmony default export */ var components_summary_MListUsage = (MListUsage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MDemoBreakdownReport.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MDemoBreakdownReport = ({
  components: {},
  created: function created() {},
  data: function data() {
    return {};
  },

  computed: {
    url: function url() {
      var demostring = '';
      var demos = this.$store.getters['order/demos'];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(demos), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          demostring = demostring + item.title + ':}}';
          if (demos.length !== 1) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(item.values), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var subitem = _step2.value;

                demostring = demostring + subitem.title + ';';
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
          demostring = demostring + '}}}}';
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.$store.getters['config/link']('reportBreakdown') + '?sid=' + this.$store.state.order.ListModuleSessionId + '&demo=' + demostring;
    }
  },
  watch: {},
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8d878d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MDemoBreakdownReport.vue
var MDemoBreakdownReport_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"seeReport","title":"BreakDown Report","ok-only":true,"ok-title":"Close","lazy":true}},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url,"width":"100","frameborder":"0","size":"lg"}})])}
var MDemoBreakdownReport_staticRenderFns = []
var MDemoBreakdownReport_esExports = { render: MDemoBreakdownReport_render, staticRenderFns: MDemoBreakdownReport_staticRenderFns }
/* harmony default export */ var summary_MDemoBreakdownReport = (MDemoBreakdownReport_esExports);
// CONCATENATED MODULE: ./src/components/summary/MDemoBreakdownReport.vue
function MDemoBreakdownReport_injectStyle (ssrContext) {
  __webpack_require__("5TKu")
  __webpack_require__("BegD")
}
var MDemoBreakdownReport_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MDemoBreakdownReport___vue_template_functional__ = false
/* styles */
var MDemoBreakdownReport___vue_styles__ = MDemoBreakdownReport_injectStyle
/* scopeId */
var MDemoBreakdownReport___vue_scopeId__ = "data-v-c8d878d2"
/* moduleIdentifier (server only) */
var MDemoBreakdownReport___vue_module_identifier__ = null
var MDemoBreakdownReport_Component = MDemoBreakdownReport_normalizeComponent(
  MDemoBreakdownReport,
  summary_MDemoBreakdownReport,
  MDemoBreakdownReport___vue_template_functional__,
  MDemoBreakdownReport___vue_styles__,
  MDemoBreakdownReport___vue_scopeId__,
  MDemoBreakdownReport___vue_module_identifier__
)

/* harmony default export */ var components_summary_MDemoBreakdownReport = (MDemoBreakdownReport_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MTargetArea.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var MTargetArea = ({
  components: {
    MMap: components_geo_MMap,
    MDemoBreakdownReport: components_summary_MDemoBreakdownReport
  },
  props: {
    isUi2: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;

    this.selectGeos = this.$store.state.order.OrderGeos;
    setTimeout(function () {
      _this.selectGeos = _this.$store.state.order.OrderGeos;
    }, 1000);
  },
  data: function data() {
    return {
      selectGeos: {},
      d: '',
      isShow: false,
      map: null,
      zipMap: null,
      graphics: [],
      polygon: null,
      tempAddress: []
    };
  },

  computed: {
    order: function order() {
      return this.$store.state.order;
    },
    geoType: function geoType() {
      return this.order.GeoType;
    },
    geoItems: function geoItems() {
      return this.$store.getters['order/geoItems'];
    },
    isMap: function isMap() {
      return (this.geoType === 12 || this.geoType === 13 || this.geoType === 7 || this.geoType === 16) && this.order.ListType !== 50;
    },
    isZipMap: function isZipMap() {
      if (this.$store.state.order.GeoType === 5 && this.$store.state.order.ZipType === 0) {
        if (this.$store.state.order.OrderGeos.length >= 15) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    btntext: function btntext() {
      return this.isShow ? 'Hide Details' : 'Show Details';
    },
    currentGeoType: function currentGeoType() {
      return this.$store.getters['order/currentGeoType'];
    },

    totalDesiredQty: {
      get: function get() {
        return this.$store.getters['order/totalDesiredQty'];
      },
      set: function set() {}
    },
    orderaddress: function orderaddress() {
      if (this.geoType === 16 || this.geoType === 7) {
        return lodash_default.a.filter(this.$store.getters['order/orderaddress'], function (item) {
          return item.AddrUsageType === 2;
        });
      } else {
        return this.$store.getters['order/orderaddress'];
      }
    },
    isRadius: function isRadius() {
      return this.geoType === 16 || this.geoType === 7;
    },
    isShowDetail: function isShowDetail() {
      var result = (this.order.ListType === 130 || this.order.ListType === 140) && (this.geoType === 5 || this.geoType === 18) || this.geoType === 11;
      return result;
    }
  },
  activated: function activated() {},

  methods: {
    updateDesiredQty: function updateDesiredQty(index, e, max) {
      if (e.target.value === '') {
        return false;
      }
      var desiredQty = this.formateInter(e, max);

      this.$store.commit('order/updateDesiredQty', {
        index: index,
        qty: desiredQty
      });
      this.$store.dispatch('order/calculatePrice');
    },
    updateTotalDesiredQty: function updateTotalDesiredQty(e, max) {
      var _this2 = this;

      if (e.target.value === '') {
        return false;
      }
      var desiredQty = this.formateInter(e, max);
      if (desiredQty > this.order.TotalAvailableQty) {
        desiredQty = this.order.TotalAvailableQty;
      }
      if (this.order.OrderGeos.length === 0) {
        this.$http.post('PlaceOrder.aspx/RedistributeOrderTotalQty', {
          totalDesiredQty: desiredQty
        }).then(function (resp) {
          if (resp.body.d.ResultFlag) {
            _this2.$store.commit('order/saveKey', ['TotalDesiredQty', desiredQty]);
            _this2.$store.dispatch('order/calculatePrice');
          }
        });
      } else {
        this.$store.dispatch('order/changeTotalCount', { 'totalCount': desiredQty });
      }
    },
    updateMapDesiredQty: function updateMapDesiredQty(index, e, max) {
      if (e.target.value === '') {
        return false;
      }
      var desiredQty = this.formateInter(e, max);
      // this.$http.post('PlaceOrder.aspx/UpdateDesiredQtyOfOrderGeoDetails', {
      //   DesiredQty: desiredQty,
      //   geoDetailsIndex: 0,
      //   geoIndex: index
      // }).then(
      //   resp => {
      //     if (resp.body.d.ResultFlag) {
      this.$store.commit('order/saveGeoDesiredQty', { index: index, val: desiredQty });
      priceHelp.RecaculateTotalGeoQty(this.order, index);
      this.$store.dispatch('order/calculatePrice');
      //   }
      // })
    },
    updateCheckDesiredQty: function updateCheckDesiredQty(index, e) {
      var _this3 = this;

      if (e) {
        this.$http.post('PlaceOrder.aspx/UpdateDesiredQtyOfOrderGeoDetails', {
          DesiredQty: this.geoItems[index].AvailableQty,
          geoDetailsIndex: 0,
          geoIndex: index
        }).then(function (resp) {
          if (resp.body.d.ResultFlag) {
            _this3.$store.commit('order/saveGeoDesiredQty', { index: index, val: _this3.geoItems[index].AvailableQty });
            priceHelp.RecaculateTotalGeoQty(_this3.order, index);
            _this3.$store.dispatch('order/calculatePrice');
          }
        });
      } else {
        this.$http.post('PlaceOrder.aspx/UpdateDesiredQtyOfOrderGeoDetails', {
          DesiredQty: 0,
          geoDetailsIndex: 0,
          geoIndex: index
        }).then(function (resp) {
          if (resp.body.d.ResultFlag) {
            _this3.$store.commit('order/saveGeoDesiredQty', { index: index, val: 0 });
            priceHelp.RecaculateTotalGeoQty(_this3.order, index);
            _this3.$store.dispatch('order/calculatePrice');
          }
        });
      }
    },
    formateInter: function formateInter(e, max) {
      var val = e.target.value;
      console.log(val);
      console.log(max);
      var num = parseInt(val);
      if (val === '') {} else if (isNaN(num) || num < 0) {
        val = 0;
      } else if (num > max) {
        val = max;
      }
      if (val + '' !== e.target.value) {
        setTimeout(function () {
          e.target.value = val;
        }, 1);
      }
      return Number(val);
    },
    formateNumber: function formateNumber(val) {
      var num = parseInt(val);
      if (val === '') {
        return val;
      }
      if (isNaN(num)) {
        return 0;
      } else if (num < 0) {
        return 0;
      } else {
        return num;
      }
    },
    goGeo: function goGeo() {
      if (this.currentGeoType.routeName) {
        this.$router.push({ name: 'geo' });
      } else {
        var geoType = this.currentGeoType.name;
        if (this.currentGeoType.title === 'Radius') {
          geoType = 'radius';
        }
        this.$router.push({ name: 'geo-' + geoType });
      }
    },
    tigger: function tigger() {
      var _this4 = this;

      if (this.isShow) {
        this.isShow = false;
      } else {
        if (this.geoItems.length > 0) {
          this.isShow = true;
          return;
        }
        this.$http.post('PlaceOrder.aspx/GetOrderGeos', {
          async: false
        }).then(function (resp) {
          if (resp.body.d.ResultFlag) {
            var geos = lodash_default.a.filter(resp.body.d.DataSource, function (item) {
              return item.AvailableQty > 0;
            });
            _this4.$store.commit('order/saveKey', ['OrderGeos', geos]);
            _this4.isShow = true;
          }
        });
      }
    },
    getGeoDesc: function getGeoDesc(geo) {
      geo.OrderGeoDetails = geo.OrderGeoDetails || [];
      if (geo.OrderGeoDetails === null || geo.OrderGeoDetails.length === 0 || geo.GeoType === 4 || geo.GeoType === 22 || this.order.ListType === 50) {
        return geo.GeoKeyDesc;
      } else {
        if ((geo.GeoType === 12 || geo.geoType === 16 || geo.GeoType === 13) && geo.OrderGeoDetails[0].DetailCode !== geo.OrderGeoDetails[0].DetailDesc) {
          return geo.OrderGeoDetails[0].DetailCode + ',' + geo.OrderGeoDetails[0].DetailDesc;
        } else {
          return geo.OrderGeoDetails[0].DetailDesc;
        }
      }
    },
    getDetailDesc: function getDetailDesc(item, subItem) {
      if (subItem.DetailDesc !== subItem.DetailCode) {
        return subItem.DetailCode + ',' + subItem.DetailDesc;
      } else {
        return item.CityName + ',' + subItem.DetailDesc;
      }
    },
    createMap: function createMap() {
      this.map = utils.maps['summarymap'];
      this.updateMap();
    },
    getDesiredQty: function getDesiredQty(detail) {
      if (detail) {
        return detail.DesiredQty;
      }
      return 0;
    },
    createZipMap: function createZipMap() {
      this.zipMap = utils.maps['summaryZipMap'];
      this.zipMap.addLayer();
      this.updateMap();
    },
    updateMap: function updateMap() {
      // Clear radius
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.graphics), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.c) {
            item.c.setMap(null);
            item.m.setMap(null);
          }
        }

        // clear polygon
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.polygon !== null) {
        this.polygon.setMap(null);
      }

      // draw circle
      if (this.order.GeoType === 16 || this.order.GeoType === 7) {
        this.graphics = this.map.initCircleDrawing(this.orderaddress, true);

        // draw polygon
      } else if (this.order.GeoType === 13) {
        var paths = [];
        var address = this.orderaddress[0];
        if (address.AddrSearchString !== null) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(address.AddrSearchString.split('|')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var path = _step2.value;

              paths.push({ lat: Number(path.split(':')[1]), lng: Number(path.split(':')[0]) });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          this.polygon = this.map.initPolygon(paths);
        }

        // draw closex
      } else if (this.order.GeoType === 12) {
        this.map.marker({ lat: Number(this.orderaddress[0].Latitude), lng: Number(this.orderaddress[0].Longitude) });
        this.map.map.setCenter({ lat: Number(this.orderaddress[0].Latitude), lng: Number(this.orderaddress[0].Longitude) });
        this.map.map.setZoom(12);

        // draw zip
      } else if (this.order.GeoType === 5) {
        this.zipMap.addLayer('ZIP', '', true);
        this.zipMap.updateZipBounders();
      }
    },
    seeReport: function seeReport() {
      this.$root.$emit('bv::show::modal', 'seeReport');
    },
    changeGeoDetailCount: function changeGeoDetailCount(rowIndex, index, e, maxValue) {
      var desiredQty = this.formateInter(e, maxValue);
      this.$store.dispatch('order/changeZipGeoDetailCount', { 'rowIndex': rowIndex, 'index': index, 'count': desiredQty });
    },
    changeTotalCount: function changeTotalCount(e) {
      var totalCount = e.target.value;
      if (e.target.value < this.$store.state.site.MinQuantityOfOrder) {
        this.alertDesc = 'The quantity that you entered is less than the minimum quantity of 20.';
        totalCount = this.$store.state.site.MinQuantityOfOrder;
        notification.notice('warning', 'The quantity that you entered is less than the minimum quantity of ' + totalCount + '.', { title: 'Count Number Error', onlyGroup: 'CountNumberError' });
      }
      this.$store.dispatch('order/changeTotalCount', { 'totalCount': totalCount });
    },
    mapPanto: function mapPanto(address) {
      this.map.map.setZoom(12);
      this.map.map.panTo({ lat: Number(address.Latitude), lng: Number(address.Longitude) });
    },
    recalculate: function recalculate() {
      console.log(this.tempAddress);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(this.tempAddress), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          var searchstring = item.Address.Longitude + ':' + item.Address.Latitude + ':' + item.Radius + ':2';
          this.$store.commit('order/updateAddress', {
            Radius: item.Radius,
            AddrSearchString: searchstring,
            oldAddrSearchString: item.Address.AddrSearchString
          });
          this.$store.commit('order/updateGeo', {
            AddressLine: searchstring,
            GeoKeyCode: searchstring,
            oldGeoKeyCode: item.Address.AddrSearchString
          });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.$store.dispatch('order/submitOrder');
      this.updateMap();
    },
    radiusChange: function radiusChange(address, e) {
      var isExis = false;
      console.log(e);
      var radius = Number(e);
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(this.tempAddress), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          if (item.Address.AddrSearchString === address.AddrSearchString) {
            item.Radius = radius;
            isExis = true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (!isExis) {
        this.tempAddress.push({ 'Address': address, 'Radius': radius });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2230214","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MTargetArea.vue
var MTargetArea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-box m-max-height",class:{'summar-box-2':_vm.isUi2 }},[_c('m-demo-breakdown-report'),_vm._v(" "),_c('b-container',[(!_vm.isUi2 && _vm.isRadius)?_c('b-row',[_c('b-col',{staticClass:"summary-head title"},[_c('h4',[_vm._v("Address Information")]),_vm._v(" "),_c('b-link',{staticClass:"link",on:{"click":_vm.goGeo}},[_vm._v("Edit")])],1)],1):_vm._e(),_vm._v(" "),(_vm.isRadius)?_c('div',[_vm._l((_vm.orderaddress),function(item){return [_c('b-row',{staticStyle:{"padding":"8px 8px 4px 8px"}},[_c('b-col',{attrs:{"md":"6"}},[_c('b-link',{on:{"click":function($event){return _vm.mapPanto(item)}}},[_vm._v(_vm._s(item.AddressName))])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"1.5"}},[_vm._v("Radius:")]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-input',{staticClass:"desired-input total-desired",attrs:{"value":item.Radius},on:{"change":function($event){return _vm.radiusChange(item, $event)}}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"1.5"}},[_vm._v("mile(s)")])],1)]}),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"8px 8px 4px 8px"}},[_c('b-col',[_c('b-link',{on:{"click":_vm.recalculate}},[_vm._v("Recalculate")])],1)],1)],2):_vm._e(),_vm._v(" "),(!_vm.isUi2)?_c('b-row',[_c('b-col',{staticClass:"summary-head title"},[_c('h4',[_vm._v("Target Area")]),_vm._v(" "),_c('b-link',{staticClass:"link",on:{"click":_vm.goGeo}},[_vm._v("Edit")])],1)],1):_vm._e(),_vm._v(" "),(_vm.isZipMap)?_c('div',[_c('b-row',{staticStyle:{"margin-top":"16px"}},[_c('b-col',[_c('m-map',{attrs:{"map-id":"summaryZipMap"},on:{"load":_vm.createZipMap}})],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.isMap&&_vm.order.GeoType===7)?_c('div',[_c('b-row',{staticStyle:{"margin-bottom":"16px"}},[_c('b-col',[_c('div',{staticClass:"circle",attrs:{"id":"maps"}},[_c('m-map',{attrs:{"map-id":"summarymap"},on:{"load":_vm.createMap}})],1)])],1)],1):_vm._e(),_vm._v(" "),(!_vm.isMap&&_vm.order.GeoType!==7)?_c('div',[_c('table',[_c('tr',[_c('th',{attrs:{"width":"50%"}}),_vm._v(" "),_c('th',{attrs:{"width":"25%"}},[_vm._v("\n            Qty Available\n          ")]),_vm._v(" "),_c('th',{attrs:{"width":"25%"}},[_vm._v("\n            Qty Selection\n          ")])]),_vm._v(" "),(_vm.isShowDetail)?[_vm._l((_vm.geoItems),function(item,index){return _vm._l((item.OrderGeoDetails),function(subItem,subIndex){return _c('tr',{staticClass:"sm-row"},[_c('td',[_c('p',[_vm._v(_vm._s(_vm.getDetailDesc(item, subItem)))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(_vm._f("numberFormat")(subItem.AvailableQty,'', 0)))])]),_vm._v(" "),_c('td',[_c('b-input',{staticClass:"desired-input",attrs:{"value":subItem.DesiredQty,"formatter":_vm.formateNumber,"disabled":item.AvailableQty === 0,"max":subItem.AvailableQty},nativeOn:{"change":function($event){return _vm.changeGeoDetailCount(index, subIndex, $event,subItem.AvailableQty)}}})],1)])})})]:_vm._l((_vm.geoItems),function(item,index){return _c('tr',{key:item.GeoKeyCode,staticClass:"sm-row"},[_c('td',[_c('p',[_vm._v(_vm._s(_vm.getGeoDesc(item)))])]),_vm._v(" "),_c('td',[_c('p',[_vm._v(_vm._s(_vm._f("numberFormat")(item.AvailableQty,'', 0)))])]),_vm._v(" "),_c('td',[_c('b-input',{staticClass:"desired-input",attrs:{"value":item.DesiredQty,"formatter":_vm.formateNumber,"disabled":_vm.order.ListType === 50 || item.AvailableQty === 0,"max":item.AvailableQty},nativeOn:{"input":function($event){return _vm.updateDesiredQty(index, $event, item.AvailableQty)}}})],1)])}),_vm._v(" "),(this.order.ListType !== 50)?_c('tr',[_c('th',[_vm._v("\n            Total\n          ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b-input',{staticClass:"desired-input total-desired",attrs:{"value":_vm.order.TotalDesiredQty,"max":_vm.order.TotalAvailableQty},nativeOn:{"change":function($event){return _vm.changeTotalCount($event)}}})],1)]):_vm._e()],2),_vm._v(" "),(this.order.ListType === 50)?_c('b-row',{staticClass:"summary-box"},[_c('b-col',[_c('strong',[_vm._v("You may modify quantities by using the grid below:")]),_c('br'),_vm._v("\n          To select all Homes, Apartments or Businesses, click on the checkmark next to the quantities listed in the TOTAL row.\n          To view and select by carrier route, click on the view/hide icon (/) next to each area. You will also have an option to enter a custom quantity per carrier route. To do this, enter a valid quantity and press the 'Tab' key.\n          "),_c('br'),_c('strong',[_vm._v("Note: Reducing the quantity selected in a given area may disqualify you from receiving the Saturation mail postage discount.")])])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isMap)?_c('div',[_c('b-row',{staticStyle:{"margin-bottom":"16px"}},[_c('b-col',[_c('div',{staticClass:"circle",attrs:{"id":"maps"}},[_c('m-map',{attrs:{"map-id":"summarymap"},on:{"load":_vm.createMap}})],1)])],1),_vm._v(" "),_c('b-row',{staticClass:"sm-row"},[_c('b-col',{staticClass:"title sm-col",attrs:{"lg":"2"}},[_c('h5',[_vm._v("List Quantity")])]),_vm._v(" "),(this.$store.state.order.ListType !== 50 && _vm.geoType !==16 && _vm.geoType !== 13)?_c('b-col',{staticClass:"sm-col",attrs:{"lg":"2"}},[_c('b-link',{on:{"click":function($event){return _vm.tigger()}}},[_vm._v(_vm._s(_vm.btntext))]),_c('br'),_vm._v(" "),_c('b-link',{on:{"click":_vm.seeReport}},[_vm._v(" See Report")])],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"sm-col",attrs:{"lg":"3"}},[_c('h5',[_vm._v("Qty Available")])]),_vm._v(" "),_c('b-col',{staticClass:"sm-col",attrs:{"lg":"2"}},[_c('h5',[_vm._v("Distance")])]),_vm._v(" "),_c('b-col',{staticClass:"sm-col",attrs:{"lg":"3"}},[_c('h5',{staticStyle:{"text-align":"right"}},[_vm._v("Qty Desired")])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow||_vm.geoType===16),expression:"isShow||geoType===16"}]},[_c('b-col',[(_vm.geoItems.length>0&&_vm.geoItems[0].OrderGeoDetails&&_vm.geoType!==13)?_vm._l((_vm.geoItems),function(item,index){return _c('b-row',{key:item.GeoKeyCode,staticClass:"sm-row"},[_c('b-col',{staticClass:"sm-col",attrs:{"sm":"1"}},[_c('b-check',{attrs:{"checked":"true"},on:{"change":function($event){return _vm.updateCheckDesiredQty(index, $event)}}})],1),_vm._v(" "),_c('b-col',{staticClass:"sm-col",attrs:{"sm":"3"}},[_vm._v("\n            "+_vm._s(_vm.getGeoDesc(item))+"\n          ")]),_vm._v(" "),_c('b-col',{staticClass:"sm-col",attrs:{"sm":"3"}},[_vm._v("\n            "+_vm._s(_vm._f("numberFormat")(item.AvailableQty,'', 0))+"\n          ")]),_vm._v(" "),_c('b-col',{staticClass:"sm-col",attrs:{"sm":"2"}},[_vm._v("\n            "+_vm._s(item.DistanceDuration)+"\n          ")]),_vm._v(" "),_c('b-col',{staticClass:"sm-col",attrs:{"sm":"3"}},[_c('b-input',{staticClass:"desired-input",attrs:{"value":_vm.getDesiredQty(item.OrderGeoDetails[0]),"formatter":_vm.formateNumber,"disabled":item.AvailableQty === 0,"max":item.AvailableQty},nativeOn:{"change":function($event){return _vm.updateMapDesiredQty(index, $event,item.AvailableQty)}}})],1)],1)}):[_vm._l((_vm.geoItems),function(item,index){return _vm._l((item.OrderGeoDetails),function(subItem,subIndex){return _c('b-row',{key:item.GeoKeyCode,staticClass:"sm-row"},[_c('b-col',[_c('p',[_vm._v(_vm._s(_vm.getDetailDesc(item, subItem)))])]),_vm._v(" "),_c('v-col',[_c('p',[_vm._v(_vm._s(_vm._f("numberFormat")(subItem.AvailableQty,'', 0)))])]),_vm._v(" "),_c('b-col',[_c('p',[_vm._v(_vm._s(subItem.DistanceDuration))])]),_vm._v(" "),_c('b-col',[_c('b-input',{staticClass:"desired-input",attrs:{"value":subItem.DesiredQty,"formatter":_vm.formateNumber,"disabled":item.AvailableQty === 0,"max":subItem.AvailableQty},nativeOn:{"change":function($event){return _vm.changeGeoDetailCount(index, subIndex, $event, subItem.AvailableQty)}}})],1)],1)})})]],2)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShow||_vm.geoType===16),expression:"!isShow||geoType===16"}],staticClass:"sm-row"},[_c('b-col',{staticClass:"sm-col",attrs:{"sm":"4"}},[_c('h5',[_vm._v("Total:")])]),_vm._v(" "),_c('b-col',{staticClass:"sm-col",attrs:{"sm":"3"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.order.TotalAvailableQty,'', 0)))]),_vm._v(" "),_c('b-col',{staticClass:"sm-col",attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{staticClass:"sm-col",attrs:{"sm":"3"}},[_c('b-input',{staticClass:"desired-input total-desired",attrs:{"formatter":_vm.formateNumber,"max":_vm.order.TotalAvailableQty},nativeOn:{"change":function($event){return _vm.updateTotalDesiredQty($event, _vm.order.TotalAvailableQty)}},model:{value:(_vm.totalDesiredQty),callback:function ($$v) {_vm.totalDesiredQty=$$v},expression:"totalDesiredQty"}})],1)],1)],1):_vm._e()],1)],1)}
var MTargetArea_staticRenderFns = []
var MTargetArea_esExports = { render: MTargetArea_render, staticRenderFns: MTargetArea_staticRenderFns }
/* harmony default export */ var summary_MTargetArea = (MTargetArea_esExports);
// CONCATENATED MODULE: ./src/components/summary/MTargetArea.vue
function MTargetArea_injectStyle (ssrContext) {
  __webpack_require__("5I7h")
}
var MTargetArea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MTargetArea___vue_template_functional__ = false
/* styles */
var MTargetArea___vue_styles__ = MTargetArea_injectStyle
/* scopeId */
var MTargetArea___vue_scopeId__ = "data-v-c2230214"
/* moduleIdentifier (server only) */
var MTargetArea___vue_module_identifier__ = null
var MTargetArea_Component = MTargetArea_normalizeComponent(
  MTargetArea,
  summary_MTargetArea,
  MTargetArea___vue_template_functional__,
  MTargetArea___vue_styles__,
  MTargetArea___vue_scopeId__,
  MTargetArea___vue_module_identifier__
)

/* harmony default export */ var components_summary_MTargetArea = (MTargetArea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MbreakdownReport.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MbreakdownReport = ({
  components: {},
  created: function created() {},
  data: function data() {
    return {};
  },

  computed: {
    url: function url() {
      return this.$store.getters['config/link']('breakDown') + this.$store.state.order.ListModuleSessionId;
    }
  },
  watch: {},
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1584cc6d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MbreakdownReport.vue
var MbreakdownReport_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"breakdownReport","title":"BreakDown Report","ok-only":true,"ok-title":"Close","lazy":true}},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url,"width":"100","frameborder":"0","size":"lg"}})])}
var MbreakdownReport_staticRenderFns = []
var MbreakdownReport_esExports = { render: MbreakdownReport_render, staticRenderFns: MbreakdownReport_staticRenderFns }
/* harmony default export */ var summary_MbreakdownReport = (MbreakdownReport_esExports);
// CONCATENATED MODULE: ./src/components/summary/MbreakdownReport.vue
function MbreakdownReport_injectStyle (ssrContext) {
  __webpack_require__("DBpU")
  __webpack_require__("79lC")
}
var MbreakdownReport_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MbreakdownReport___vue_template_functional__ = false
/* styles */
var MbreakdownReport___vue_styles__ = MbreakdownReport_injectStyle
/* scopeId */
var MbreakdownReport___vue_scopeId__ = "data-v-1584cc6d"
/* moduleIdentifier (server only) */
var MbreakdownReport___vue_module_identifier__ = null
var MbreakdownReport_Component = MbreakdownReport_normalizeComponent(
  MbreakdownReport,
  summary_MbreakdownReport,
  MbreakdownReport___vue_template_functional__,
  MbreakdownReport___vue_styles__,
  MbreakdownReport___vue_scopeId__,
  MbreakdownReport___vue_module_identifier__
)

/* harmony default export */ var components_summary_MbreakdownReport = (MbreakdownReport_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MTwoDimensional.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MTwoDimensional = ({
  data: function data() {
    return {
      selectRF: [],
      selectItem: [],
      selectGeo: 'all',
      selectDemo: '',
      columns: [],
      targetEmail: '',
      selectedGeos: [],
      selectedDemos: [],
      desc: '',
      show: 'from',
      btnDisable: false,
      alertDesc: ''
    };
  },

  computed: {
    geoItems: function geoItems() {
      return this.$store.getters['order/geoItems'];
    }
  },
  methods: {
    addRows: function addRows() {
      var _this = this;

      if (this.selectGeo === 'all') {
        this.selectedGeos = this.geoItems;
      } else {
        if (lodash_default.a.findIndex(this.selectedGeos, { GeoKeyCode: this.selectGeo }) < 0) {
          var geo = lodash_default.a.findIndex(this.geoItems, function (item) {
            return item.GeoKeyCode === _this.selectGeo;
          });
          this.selectedGeos.push(this.geoItems[geo]);
        }
      }
      this.refush();
    },
    addColumns: function addColumns() {
      var _this2 = this;

      this.selectedDemos = [];
      var demo = lodash_default.a.findIndex(this.columns, function (item) {
        return item.ColumnName === _this2.selectDemo;
      });
      this.selectedDemos.push(this.columns[demo]);
      this.refush();
    },
    clearFields: function clearFields() {
      this.selectedGeos = [];
      this.selectedDemos = [];
      this.refush();
    },
    sendMyReport: function sendMyReport(evt) {
      var _this3 = this;

      evt.preventDefault();
      this.alertDesc = '';
      if (this.targetEmail === '') {
        this.alertDesc += 'Please enter the email address; ';
      }

      if (this.desc === '') {
        this.alertDesc += 'Please enter name of report';
      }
      if (this.selectedGeos.length === 0) {
        this.selectedGeos = this.geoItems;
      }
      if (this.selectedDemos.length === 0) {
        this.selectedDemos = this.columns;
      }

      if (this.alertDesc !== '') {
        return false;
      }
      this.btnDisable = true;
      this.$http.post('PlaceOrder.aspx/Submit2DReportConditions', {
        delimiterOfEmails: ',',
        demoCategories: this.selectedDemos,
        desc: this.desc,
        geos: this.selectedGeos,
        targetEmail: this.targetEmail,
        order: this.$store.state.order
      }, {
        errorType: 'silent'
      }).then(function (resp) {
        if (resp.body.d.ResultFlag) {
          _this3.show = 'success';
        } else {
          _this3.btnDisable = false;
          _this3.alertDesc = 'Two dimensional report is not available for the selections you have made.';
        }
      }, function (resp) {
        _this3.btnDisable = false;
        _this3.alertDesc = 'Two dimensional report is not available for the selections you have made.';
      });
    },
    refush: function refush() {
      this.selectItem = [];
      if (this.selectedGeos.length > 0) {
        this.selectItem.push({ 'value': 'geotitle', 'margin': 0, 'text': 'Rows:' });
        this.selectItem.push({ 'value': 'geotitle', 'margin': 10, 'text': 'Geography' });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(this.selectedGeos), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            this.selectItem.push({ 'value': item.GeoKeyCode, 'margin': 20, 'text': item.GeoKeyDesc });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      if (this.selectedDemos.length > 0) {
        this.selectItem.push({ 'value': 'demotitle', 'margin': 0, 'text': 'Columns:' });
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(this.selectedDemos), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _item = _step2.value;

            this.selectItem.push({ 'value': _item.ColumnName, 'margin': 10, 'text': _item.AttributeName });
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    },
    getDemosFrom: function getDemosFrom() {
      var that = this;
      this.$http.post('PlaceOrder.aspx/GetDemosFromDemoBreakdown', {
        order: this.$store.state.order
      }).then(function (resp) {
        that.targetEmail = resp.body.d.DataSource.TargetEmail;
        that.selectDemo = resp.body.d.DataSource.SelectedCategories[0].ColumnName;
        that.columns = resp.body.d.DataSource.SelectedCategories;
      }, function (resp) {
        // TODO@Wison add if show
        // alert('Two dimensional report is not available for the selections you have made.')
      });
    },
    showModal: function showModal() {
      if (this.columns.length === 0) {
        this.getDemosFrom();
      }
      this.selectedDemos = [];
      this.selectedGeos = [];
      this.refush();
      this.btnDisable = false;
      this.show = 'from';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcffc442","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MTwoDimensional.vue
var MTwoDimensional_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"twoDimensional","title":"Create a Two Dimensional Report","ok-title":"Send My Report","ok-disabled":_vm.btnDisable,"lazy":true,"size":"lg","cancel-title":"Close"},on:{"show":_vm.showModal,"ok":function($event){return _vm.sendMyReport($event)}}},[_c('b-container',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show==='from'),expression:"show==='from'"}],staticClass:"fromcontent"},[_c('b-row',[_c('b-col',{attrs:{"cols":"2"}},[_vm._v("\n        Step 1\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_vm._v("\n        Choose Report Rows\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"7"}},[_c('b-select',{model:{value:(_vm.selectGeo),callback:function ($$v) {_vm.selectGeo=$$v},expression:"selectGeo"}},[_c('option',{attrs:{"value":"all"}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.geoItems),function(item){return _c('option',{domProps:{"value":item.GeoKeyCode}},[_vm._v(_vm._s(item.GeoKeyDesc))])})],2)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-btn',{on:{"click":_vm.addRows}},[_vm._v("Add")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"2"}},[_vm._v("\n        Step 2\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_vm._v("\n        Choose Report Columns\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"7"}},[_c('b-select',{model:{value:(_vm.selectDemo),callback:function ($$v) {_vm.selectDemo=$$v},expression:"selectDemo"}},_vm._l((_vm.columns),function(item){return _c('option',{domProps:{"value":item.ColumnName}},[_vm._v(_vm._s(item.AttributeName))])}),0)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-btn',{on:{"click":_vm.addColumns}},[_vm._v("Add")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"rprow"},[_c('b-col',{staticClass:"inputcol",attrs:{"sm":"2","md":"2","lg":"2"}},[_vm._v("\n        Report Fields:\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"sm":"7","md":"7","lg":"7"}},[_c('b-select',{attrs:{"select-size":8,"multiple":""},model:{value:(_vm.selectRF),callback:function ($$v) {_vm.selectRF=$$v},expression:"selectRF"}},_vm._l((_vm.selectItem),function(item){return _c('option',{style:('margin-left:'+ item.margin + 'px')},[_vm._v(_vm._s(item.text))])}),0)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"5","md":"4","lg":"3"}},[_c('b-btn',{on:{"click":_vm.clearFields}},[_vm._v("Clear Fields")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"2"}},[_vm._v("\n        Step 3\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_vm._v("\n        Name Reports\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('b-input',{model:{value:(_vm.desc),callback:function ($$v) {_vm.desc=$$v},expression:"desc"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"2"}},[_vm._v("\n        Step 4\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_vm._v("\n        Email Report to (separate multiple addresses with commas):\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('b-input',{model:{value:(_vm.targetEmail),callback:function ($$v) {_vm.targetEmail=$$v},expression:"targetEmail"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-alert',{staticClass:"rprow",attrs:{"show":_vm.alertDesc!=='',"variant":"warning"}},[_vm._v(_vm._s(_vm.alertDesc))])],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show==='success'),expression:"show==='success'"}]},[_c('b-row',[_c('b-col',[_vm._v("\n          Thank you.\n          We are processing your request now and will send an email with the report attached to\n          the following email addresses when this is complete:\n        ")])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('strong',[_vm._v(_vm._s(_vm.targetEmail))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_vm._v("\n        Reports are typically delivered within 5 minutes.\n      ")])],1)],1)])],1)}
var MTwoDimensional_staticRenderFns = []
var MTwoDimensional_esExports = { render: MTwoDimensional_render, staticRenderFns: MTwoDimensional_staticRenderFns }
/* harmony default export */ var summary_MTwoDimensional = (MTwoDimensional_esExports);
// CONCATENATED MODULE: ./src/components/summary/MTwoDimensional.vue
function MTwoDimensional_injectStyle (ssrContext) {
  __webpack_require__("qPA5")
}
var MTwoDimensional_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MTwoDimensional___vue_template_functional__ = false
/* styles */
var MTwoDimensional___vue_styles__ = MTwoDimensional_injectStyle
/* scopeId */
var MTwoDimensional___vue_scopeId__ = "data-v-dcffc442"
/* moduleIdentifier (server only) */
var MTwoDimensional___vue_module_identifier__ = null
var MTwoDimensional_Component = MTwoDimensional_normalizeComponent(
  MTwoDimensional,
  summary_MTwoDimensional,
  MTwoDimensional___vue_template_functional__,
  MTwoDimensional___vue_styles__,
  MTwoDimensional___vue_scopeId__,
  MTwoDimensional___vue_module_identifier__
)

/* harmony default export */ var components_summary_MTwoDimensional = (MTwoDimensional_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MTargetAudience.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var MTargetAudience = ({
  components: {
    MbreakdownReport: components_summary_MbreakdownReport,
    MSlideItem: components_slide_MSlideItem,
    MTwoDimensional: components_summary_MTwoDimensional
  },
  props: {
    isUi2: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    order: function order() {
      return this.$store.state.order;
    },
    selectedDemos: function selectedDemos() {
      return this.$store.getters['order/demoItems'];
    },
    isAllHoseholds: function isAllHoseholds() {
      return this.$store.getters['order/isAllHoseholds'];
    },
    hasPhoneOption: function hasPhoneOption() {
      return !this.$store.getters['demo/noPhoneOption'];
    },
    demos: function demos() {
      return this.$store.getters['order/demos'];
    },
    currentPhoneOption: function currentPhoneOption() {
      return this.$store.getters['order/currentPhoneOption'];
    },
    hasEmailOption: function hasEmailOption() {
      return this.$store.state.order.ListType === 260 && this.$store.state.order.EmailOption !== '';
    },
    emailOption: function emailOption() {
      var result = "I don't need business email addresses.";
      if (this.$store.state.order.EmailOption === 'onlyemail') {
        result = "I'll take only those records with a business email address.";
      }
      if (this.$store.state.order.EmailOption === 'email') {
        result = "I'll take those with and without business email addresses.";
      }
      return result;
    }
  },
  methods: {
    goDemo: function goDemo() {
      this.$router.push({ name: 'demo' });
    },
    showBreakdown: function showBreakdown() {
      this.$root.$emit('bv::show::modal', 'breakdownReport');
    },
    showTwoDimensional: function showTwoDimensional() {
      this.$root.$emit('bv::show::modal', 'twoDimensional');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bfcf28e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MTargetAudience.vue
var MTargetAudience_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-box m-max-height",class:{'summar-box-2':_vm.isUi2 }},[_c('MbreakdownReport'),_vm._v(" "),_c('m-two-dimensional'),_vm._v(" "),_c('b-container',[(!_vm.isUi2)?_c('b-row',[_c('b-col',{staticClass:"summary-head title"},[_c('h4',[_vm._v("Target Audience")]),_vm._v(" "),_c('b-link',{on:{"click":_vm.goDemo}},[_vm._v("Edit")])],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_c('m-slide-item',{attrs:{"items":_vm.demos,"canDelete":false}}),_vm._v(" "),(_vm.hasPhoneOption)?_c('div',{staticClass:"phone-box"},[_c('h5',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Phone Option:")]),_vm._v(" "+_vm._s(_vm.currentPhoneOption.desc)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasEmailOption)?_c('div',{staticClass:"phone-box"},[_c('h5',{staticStyle:{"margin-bottom":"0"}},[_vm._v("Email Option:")]),_vm._v(" "+_vm._s(_vm.emailOption)+"\n        ")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"other-option"},[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.getters['summary/showBreakDown']),expression:"$store.getters['summary/showBreakDown']"}]},[_c('b-link',{on:{"click":_vm.showBreakdown}},[_vm._v("View Breakdown Report")])],1),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.getters['summary/showTwoDimensional']),expression:"$store.getters['summary/showTwoDimensional']"}]},[_c('b-link',{on:{"click":_vm.showTwoDimensional}},[_vm._v("Two Dimensional Matrix Report")])],1)],1)],1)],1)}
var MTargetAudience_staticRenderFns = []
var MTargetAudience_esExports = { render: MTargetAudience_render, staticRenderFns: MTargetAudience_staticRenderFns }
/* harmony default export */ var summary_MTargetAudience = (MTargetAudience_esExports);
// CONCATENATED MODULE: ./src/components/summary/MTargetAudience.vue
function MTargetAudience_injectStyle (ssrContext) {
  __webpack_require__("n5mI")
}
var MTargetAudience_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MTargetAudience___vue_template_functional__ = false
/* styles */
var MTargetAudience___vue_styles__ = MTargetAudience_injectStyle
/* scopeId */
var MTargetAudience___vue_scopeId__ = "data-v-6bfcf28e"
/* moduleIdentifier (server only) */
var MTargetAudience___vue_module_identifier__ = null
var MTargetAudience_Component = MTargetAudience_normalizeComponent(
  MTargetAudience,
  summary_MTargetAudience,
  MTargetAudience___vue_template_functional__,
  MTargetAudience___vue_styles__,
  MTargetAudience___vue_scopeId__,
  MTargetAudience___vue_module_identifier__
)

/* harmony default export */ var components_summary_MTargetAudience = (MTargetAudience_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MMediaTypeInfo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MMediaTypeInfo = ({
  components: {
    MErrorText: components_common_MerrorText
  },
  props: {
    isUi2: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      options: [{ text: 'Please Select Media Type', value: '' }, { text: 'Facebook', value: 'facebook' }, { text: 'Twitter', value: 'twitter' }]
    };
  },

  computed: {
    showError: function showError() {
      return this.$store.getters['summary/showError'];
    },
    order: function order() {
      return this.$store.state.order;
    }
  },
  methods: {
    updateMediaInfo: function updateMediaInfo(key, e) {
      this.$store.commit('order/saveKey', [key, e.target.value]);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba0d7cf6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MMediaTypeInfo.vue
var MMediaTypeInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-box m-max-height",class:{'summar-box-2':_vm.isUi2 }},[_c('b-container',[(!_vm.isUi2)?_c('b-row',[_c('b-col',{staticClass:"summary-head title"},[_c('h4',[_vm._v("Media Type Info")])])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-select',{staticStyle:{"margin-top":"10px"},model:{value:(_vm.order.MediaTypeName),callback:function ($$v) {_vm.$set(_vm.order, "MediaTypeName", $$v)},expression:"order.MediaTypeName"}},_vm._l((_vm.options),function(item){return _c('option',{domProps:{"value":item.value}},[_vm._v("\n              "+_vm._s(item.text)+"\n            ")])}),0),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.order.MediaTypeName,"immediate":_vm.showError,"rules":['require']}})],1)],1),_vm._v(" "),(_vm.order.MediaTypeName === 'facebook')?[_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Share Account ID(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.order.ShareAccountId,"size":"sm"},nativeOn:{"input":function($event){return _vm.updateMediaInfo('ShareAccountId', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.order.ShareAccountId,"immediate":_vm.showError,"rules":['require']}})],1)],1),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Package Name(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.order.PackageName,"size":"sm"},nativeOn:{"input":function($event){return _vm.updateMediaInfo('PackageName', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.order.PackageName,"immediate":_vm.showError,"rules":['require']}})],1)],1)]:_vm._e(),_vm._v(" "),(_vm.order.MediaTypeName === 'twitter')?[_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Tenant ID(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.order.TenantId,"size":"sm"},nativeOn:{"input":function($event){return _vm.updateMediaInfo('TenantId', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.order.TenantId,"immediate":_vm.showError,"rules":['require']}})],1)],1),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Destination ID(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.order.DestinationId,"size":"sm"},nativeOn:{"input":function($event){return _vm.updateMediaInfo('DestinationId', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.order.DestinationId,"immediate":_vm.showError,"rules":['require']}})],1)],1),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Destination Account ID(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.order.DestinationAccountId,"size":"sm"},nativeOn:{"input":function($event){return _vm.updateMediaInfo('DestinationAccountId', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.order.DestinationAccountId,"immediate":_vm.showError,"rules":['require']}})],1)],1)]:_vm._e()],2)],1)}
var MMediaTypeInfo_staticRenderFns = []
var MMediaTypeInfo_esExports = { render: MMediaTypeInfo_render, staticRenderFns: MMediaTypeInfo_staticRenderFns }
/* harmony default export */ var summary_MMediaTypeInfo = (MMediaTypeInfo_esExports);
// CONCATENATED MODULE: ./src/components/summary/MMediaTypeInfo.vue
function MMediaTypeInfo_injectStyle (ssrContext) {
  __webpack_require__("H6kr")
}
var MMediaTypeInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MMediaTypeInfo___vue_template_functional__ = false
/* styles */
var MMediaTypeInfo___vue_styles__ = MMediaTypeInfo_injectStyle
/* scopeId */
var MMediaTypeInfo___vue_scopeId__ = "data-v-ba0d7cf6"
/* moduleIdentifier (server only) */
var MMediaTypeInfo___vue_module_identifier__ = null
var MMediaTypeInfo_Component = MMediaTypeInfo_normalizeComponent(
  MMediaTypeInfo,
  summary_MMediaTypeInfo,
  MMediaTypeInfo___vue_template_functional__,
  MMediaTypeInfo___vue_styles__,
  MMediaTypeInfo___vue_scopeId__,
  MMediaTypeInfo___vue_module_identifier__
)

/* harmony default export */ var components_summary_MMediaTypeInfo = (MMediaTypeInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MContactInformation.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MContactInformation = ({
  components: {},
  data: function data() {
    return {};
  },

  watch: {},
  created: function created() {},

  methods: {
    updateContact: function updateContact(key, e) {
      this.$store.commit('order/updateContactInformation', {
        key: key,
        val: e.target.value
      });
    },
    updateOrderDesc: function updateOrderDesc(e) {
      this.$store.commit('order/saveKey', ['OrderDesc', e.target.value]);
    }
  },
  computed: {
    order: function order() {
      return this.$store.state.order;
    },
    orderContact: function orderContact() {
      return this.$store.state.order.OrderContactInformation || {};
    },
    showError: function showError() {
      return this.$store.getters['summary/showError'];
    },
    enablePlaceOrder: function enablePlaceOrder() {
      return this.$store.getters['site/enablePlaceOrder'];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cd4084a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MContactInformation.vue
var MContactInformation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-box"},[(!_vm.enablePlaceOrder)?_c('div',{staticClass:"m-disabled-box"}):_vm._e(),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"summary-head"},[_c('h4',[_vm._v("Contact Information")])])],1),_vm._v(" "),_c('b-row'),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("First Name(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderContact.FirstName,"size":"sm"},nativeOn:{"input":function($event){return _vm.updateContact('FirstName', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.FirstName)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Last Name(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderContact.LastName,"size":"sm"},nativeOn:{"input":function($event){return _vm.updateContact('LastName', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.LastName)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Country(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-form-radio-group',{model:{value:(_vm.orderContact.CountryCode),callback:function ($$v) {_vm.$set(_vm.orderContact, "CountryCode", $$v)},expression:"orderContact.CountryCode"}},[_c('b-form-radio',{attrs:{"value":"US"}},[_vm._v("USA")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"CA"}},[_vm._v("Canada")])],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Address(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderContact.AddressLine,"size":"sm"},nativeOn:{"input":function($event){return _vm.updateContact('AddressLine', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.AddressLine)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("City(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderContact.City,"size":"sm"},nativeOn:{"input":function($event){return _vm.updateContact('City', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.City)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("State(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-form-select',{attrs:{"value":_vm.orderContact.State},nativeOn:{"change":function($event){return _vm.updateContact('State', $event)}}},_vm._l((_vm.$store.state.geo.states),function(item){return _c('option',{domProps:{"value":item.code}},[_vm._v("\n            "+_vm._s(item.code)+"\n          ")])}),0),_vm._v(" "),(_vm.showError && !_vm.orderContact.State)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Zip(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderContact.Zipcode,"size":"sm"},nativeOn:{"input":function($event){return _vm.updateContact('Zipcode', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.Zipcode)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Phone(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderContact.Phone,"size":"sm"},nativeOn:{"input":function($event){return _vm.updateContact('Phone', $event)}}}),_vm._v(" "),(_vm.showError && !_vm.orderContact.Phone)?_c('p',{staticClass:"m-error-text"},[_vm._v("Required")]):_vm._e()],1)],1)],1)],1)}
var MContactInformation_staticRenderFns = []
var MContactInformation_esExports = { render: MContactInformation_render, staticRenderFns: MContactInformation_staticRenderFns }
/* harmony default export */ var summary_MContactInformation = (MContactInformation_esExports);
// CONCATENATED MODULE: ./src/components/summary/MContactInformation.vue
function MContactInformation_injectStyle (ssrContext) {
  __webpack_require__("aBUf")
}
var MContactInformation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MContactInformation___vue_template_functional__ = false
/* styles */
var MContactInformation___vue_styles__ = MContactInformation_injectStyle
/* scopeId */
var MContactInformation___vue_scopeId__ = "data-v-8cd4084a"
/* moduleIdentifier (server only) */
var MContactInformation___vue_module_identifier__ = null
var MContactInformation_Component = MContactInformation_normalizeComponent(
  MContactInformation,
  summary_MContactInformation,
  MContactInformation___vue_template_functional__,
  MContactInformation___vue_styles__,
  MContactInformation___vue_scopeId__,
  MContactInformation___vue_module_identifier__
)

/* harmony default export */ var components_summary_MContactInformation = (MContactInformation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MPayment.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MPayment = ({
  components: {
    MErrorText: components_common_MerrorText
  },
  props: {
    isUi2: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      cardType: [{
        value: 10,
        text: 'VISA'
      }, {
        value: 20,
        text: 'MasterCard'
      }, {
        value: 30,
        text: 'American Express'
      }, {
        value: 40,
        text: 'Discover'
      }]
    };
  },

  watch: {},
  created: function created() {},

  methods: {
    updateContact: function updateContact(key, e) {
      this.$store.commit('order/updateContactInformation', {
        key: key,
        val: e.target.value
      });
    },
    updatePayment: function updatePayment(key, e) {
      this.$store.commit('order/updatePaymentInformation', {
        key: key,
        val: e.target.value
      });
    },
    updateOrderDesc: function updateOrderDesc(e) {
      // this.$store.commit('order/saveKey', ['OrderDesc', e.target.value])
      this.$store.commit('order/updateContactInformation', {
        key: 'OrderName',
        val: e.target.value
      });
    }
  },
  computed: {
    order: function order() {
      return this.$store.state.order;
    },
    orderContact: function orderContact() {
      return this.$store.state.order.OrderContactInformation || {};
    },
    orderPayment: function orderPayment() {
      return this.$store.state.order.OrderPaymentInformation || {};
    },
    showError: function showError() {
      return this.$store.getters['summary/showError'];
    },
    isCreditCard: function isCreditCard() {
      return this.$store.getters['order/isCreditCard'];
    },
    expiredYear: function expiredYear() {
      var result = [];
      var now = new Date();
      var year = now.getFullYear();
      for (var i = 0; i <= 10; i++) {
        result.push(year + i);
      }
      return result;
    },
    expiredMonth: function expiredMonth() {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    },
    enablePlaceOrder: function enablePlaceOrder() {
      return this.$store.getters['site/enablePlaceOrder'];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-778ce8f5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MPayment.vue
var MPayment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-box",class:{'summar-box-2':_vm.isUi2}},[(!_vm.enablePlaceOrder)?_c('div',{staticClass:"m-disabled-box"}):_vm._e(),_vm._v(" "),_c('b-container',[(!_vm.isUi2)?_c('b-row',[_c('b-col',{staticClass:"summary-head"},[_c('h4',[_vm._v("Payment Information")])])],1):_vm._e(),_vm._v(" "),_c('b-row'),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Email(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderContact.Email,"data-test":"summary-pay-email","size":"sm"},nativeOn:{"input":function($event){return _vm.updateContact('Email', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.orderContact.Email,"immediate":_vm.showError,"rules":['require', 'email']}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Order Name(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.order.OrderDesc,"data-test":"summary-pay-orderName","size":"sm"},nativeOn:{"input":function($event){return _vm.updateOrderDesc($event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.order.OrderDesc,"immediate":_vm.showError,"rules":['require']}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Company Name(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderContact.Company,"data-test":"summary-pay-company","size":"sm","disabled":""}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.orderContact.Company,"immediate":_vm.showError,"rules":['require']}})],1)],1),_vm._v(" "),(_vm.isCreditCard)?_c('div',[_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Card Type(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-form-select',{attrs:{"options":_vm.cardType,"data-test":"summary-pay-cardType"},model:{value:(_vm.orderPayment.CardType),callback:function ($$v) {_vm.$set(_vm.orderPayment, "CardType", $$v)},expression:"orderPayment.CardType"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Name On Card(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderPayment.HolderName,"data-test":"summary-pay-holderName","size":"sm"},nativeOn:{"input":function($event){return _vm.updatePayment('HolderName', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.orderPayment.HolderName,"immediate":_vm.showError,"rules":['require']}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Card Number(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderPayment.Number,"data-test":"summary-pay-cardNumber","size":"sm"},nativeOn:{"input":function($event){return _vm.updatePayment('Number', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.orderPayment.Number,"immediate":_vm.showError,"rules":['require', 'creditCard']}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Security Code(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderPayment.SecurityCode,"data-test":"summary-pay-securityCode","size":"sm"},nativeOn:{"input":function($event){return _vm.updatePayment('SecurityCode', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.orderPayment.SecurityCode,"immediate":_vm.showError,"rules":['require']}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Card Expiration(*): ")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"3"}},[_c('b-form-select',{attrs:{"options":_vm.expiredMonth,"data-test":"summary-pay-expiredMonth"},model:{value:(_vm.orderPayment.ExpiredMonth),callback:function ($$v) {_vm.$set(_vm.orderPayment, "ExpiredMonth", $$v)},expression:"orderPayment.ExpiredMonth"}})],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('b-form-select',{attrs:{"options":_vm.expiredYear,"data-test":"summary-pay-expiredYear"},model:{value:(_vm.orderPayment.ExpiredYear),callback:function ($$v) {_vm.$set(_vm.orderPayment, "ExpiredYear", $$v)},expression:"orderPayment.ExpiredYear"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Country(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-form-radio-group',{attrs:{"data-test":"summary-pay-country"},model:{value:(_vm.orderPayment.CountryCode),callback:function ($$v) {_vm.$set(_vm.orderPayment, "CountryCode", $$v)},expression:"orderPayment.CountryCode"}},[_c('b-form-radio',{attrs:{"value":"US"}},[_vm._v("USA")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"CA"}},[_vm._v("Canada")])],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Address(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderPayment.AddressLine,"data-test":"summary-pay-address","size":"sm"},nativeOn:{"input":function($event){return _vm.updatePayment('AddressLine', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.orderPayment.AddressLine,"immediate":_vm.showError,"rules":['require']}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("City(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderPayment.City,"data-test":"summary-pay-city","size":"sm"},nativeOn:{"input":function($event){return _vm.updatePayment('City', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.orderPayment.City,"immediate":_vm.showError,"rules":['require']}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("State(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-form-select',{attrs:{"data-test":"summary-pay-state"},model:{value:(_vm.orderPayment.State),callback:function ($$v) {_vm.$set(_vm.orderPayment, "State", $$v)},expression:"orderPayment.State"}},_vm._l((_vm.$store.state.geo.states),function(item){return _c('option',{domProps:{"value":item.code}},[_vm._v("\n                "+_vm._s(item.code)+"\n              ")])}),0),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.orderPayment.State,"immediate":_vm.showError,"rules":['require']}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"item"},[_c('b-col',{staticClass:"item-title",attrs:{"lg":"5"}},[_vm._v("Zip(*):")]),_vm._v(" "),_c('b-col',{attrs:{"lg":"7"}},[_c('b-input',{attrs:{"value":_vm.orderPayment.Zipcode,"data-test":"summary-pay-zip","size":"sm"},nativeOn:{"input":function($event){return _vm.updatePayment('Zipcode', $event)}}}),_vm._v(" "),_c('m-error-text',{attrs:{"val":_vm.orderPayment.Zipcode,"immediate":_vm.showError,"rules":['require', 'zip']}})],1)],1)],1):_vm._e()],1)],1)}
var MPayment_staticRenderFns = []
var MPayment_esExports = { render: MPayment_render, staticRenderFns: MPayment_staticRenderFns }
/* harmony default export */ var summary_MPayment = (MPayment_esExports);
// CONCATENATED MODULE: ./src/components/summary/MPayment.vue
function MPayment_injectStyle (ssrContext) {
  __webpack_require__("xRDv")
}
var MPayment_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MPayment___vue_template_functional__ = false
/* styles */
var MPayment___vue_styles__ = MPayment_injectStyle
/* scopeId */
var MPayment___vue_scopeId__ = "data-v-778ce8f5"
/* moduleIdentifier (server only) */
var MPayment___vue_module_identifier__ = null
var MPayment_Component = MPayment_normalizeComponent(
  MPayment,
  summary_MPayment,
  MPayment___vue_template_functional__,
  MPayment___vue_styles__,
  MPayment___vue_scopeId__,
  MPayment___vue_module_identifier__
)

/* harmony default export */ var components_summary_MPayment = (MPayment_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MCheckTerms.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MCheckTerms = ({
  components: {
    MQuestion: components_common_Mquestion
  },
  computed: {
    aggreAgreement: {
      get: function get() {
        return this.$store.state.summary.aggreAgreement;
      },
      set: function set(val) {
        this.$store.commit('summary/saveAggreAgreement', val);
      }
    },
    IsContactMe: {
      get: function get() {
        return this.$store.state.order.IsContactMe; // @TODO@Wilson  lack not sl360 logic
      },
      set: function set(val) {
        this.$store.commit('order/saveKey', ['IsContactMe', val]);
      }
    },
    ShowIsContactMe: function ShowIsContactMe() {
      return this.$store.state.order.ListType === 10 && Math.min(this.$store.state.order.TotalAvailableQty, this.$store.state.order.TotalDesiredQty) >= 10000;
    },
    IsEmailCampaign: function IsEmailCampaign() {
      return this.$store.getters['order/IsEmailCampaign'];
    },
    showError: function showError() {
      return this.$store.getters['summary/showError'];
    },
    enablePlaceOrder: function enablePlaceOrder() {
      return this.$store.getters['site/enablePlaceOrder'];
    }
  },
  methods: {
    showdatauseagreement: function showdatauseagreement() {
      this.$root.$emit('bv::show::modal', 'datauseagreement');
    },
    showQuestion: function showQuestion() {
      this.$root.$emit('bv::show::modal', 'question');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f06b66b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MCheckTerms.vue
var MCheckTerms_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2",staticStyle:{"position":"relative"}},[_c('m-question',{attrs:{"link":_vm.$store.getters['config/link']('agreementQuestion') + '&siteId=' + _vm.$store.state.site.SiteId}}),_vm._v(" "),(!_vm.enablePlaceOrder)?_c('div',{staticClass:"m-disabled-box"}):_vm._e(),_vm._v(" "),_c('b-form-checkbox',{staticClass:"item",attrs:{"data-test":"summary-term-agree"},model:{value:(_vm.aggreAgreement),callback:function ($$v) {_vm.aggreAgreement=$$v},expression:"aggreAgreement"}},[(_vm.IsEmailCampaign)?_c('span',{attrs:{"name":"email"}},[_vm._v("I understand that USADATA will deploy this campaign and that I will not receive any actual\n      email addresses with this order.")]):_vm._e(),_vm._v(" "),(!_vm.IsEmailCampaign)?_c('span',{attrs:{"name":"notemail"}},[_vm._v("I agree to the terms and conditions of the\n      "),_c('b-link',{attrs:{"tabindex":"-1","href":"javascript:void(0)"},on:{"click":_vm.showdatauseagreement}},[_vm._v("Data Use Agreement")]),_vm._v(" "),_c('span',{staticClass:"color_red",attrs:{"id":"asterisk_before"}},[_vm._v("*")]),_vm._v("\n      and acknowledge that orders with consumer phone numbers or sensitive elements may be put on hold. (*)\n    "),_c('icon',{staticStyle:{"color":"#e04557","height":"20px","width":"36px","cursor":"pointer"},attrs:{"name":"question-circle","title":"help"},nativeOn:{"click":function($event){return _vm.showQuestion($event)}}})],1):_vm._e()]),_vm._v(" "),(_vm.showError && _vm.aggreAgreement === false)?_c('p',{staticClass:"m-error-text item-error"},[_vm._v("You must agree to the terms of the Data Use Agreement to place this order.\n  ")]):_vm._e(),_vm._v(" "),(_vm.ShowIsContactMe)?_c('b-form-checkbox',{staticClass:"item",model:{value:(_vm.IsContactMe),callback:function ($$v) {_vm.IsContactMe=$$v},expression:"IsContactMe"}},[_vm._v("\n    Contact me to discuss reaching these same prospects via email, display, and/or social media.\n  ")]):_vm._e()],1)}
var MCheckTerms_staticRenderFns = []
var MCheckTerms_esExports = { render: MCheckTerms_render, staticRenderFns: MCheckTerms_staticRenderFns }
/* harmony default export */ var summary_MCheckTerms = (MCheckTerms_esExports);
// CONCATENATED MODULE: ./src/components/summary/MCheckTerms.vue
function MCheckTerms_injectStyle (ssrContext) {
  __webpack_require__("gpS1")
}
var MCheckTerms_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MCheckTerms___vue_template_functional__ = false
/* styles */
var MCheckTerms___vue_styles__ = MCheckTerms_injectStyle
/* scopeId */
var MCheckTerms___vue_scopeId__ = "data-v-4f06b66b"
/* moduleIdentifier (server only) */
var MCheckTerms___vue_module_identifier__ = null
var MCheckTerms_Component = MCheckTerms_normalizeComponent(
  MCheckTerms,
  summary_MCheckTerms,
  MCheckTerms___vue_template_functional__,
  MCheckTerms___vue_styles__,
  MCheckTerms___vue_scopeId__,
  MCheckTerms___vue_module_identifier__
)

/* harmony default export */ var components_summary_MCheckTerms = (MCheckTerms_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/summary/MGeoGraphies.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MGeoGraphies = ({
  components: {},
  data: function data() {
    return {
      sort: 'descending',
      sortFild: ''
    };
  },

  computed: {
    geos: function geos() {
      if (this.sortFild !== '') {
        var templGeos = JSON.parse(stringify_default()(this.$store.getters['order/geoItems']));
        for (var item in templGeos) {
          var xx = this.stableSort(templGeos[item].OrderGeoDetails, this.getComparator(this.sort, this.sortFild));
          templGeos[item].OrderGeoDetails = xx;
        }
        return templGeos;
      } else {
        return this.$store.getters['order/geoItems'];
      }
    },
    order: function order() {
      return this.$store.state.order;
    }
  },
  methods: {
    tiggerShow: function tiggerShow(index) {
      this.$store.commit('order/tiggerGeoShowDetail', index);
    },
    changeGeoCount: function changeGeoCount(type, index, e) {
      this.$store.dispatch('order/changeGeoCount', { 'type': type, 'index': index, 'checked': e.target.checked });
    },
    changeGeoDetailCount: function changeGeoDetailCount(t, type, rowIndex, index, e, aq, dq) {
      // t: checkbox/input; type: home/apts/business; rowIndex: row index; index: index; e: input or checkbox value, aq:AvailableQty  dq: DesiredQty
      if (t === 'c') {
        if (e.target.checked) {
          dq = aq;
        } else {
          dq = 0;
        }
      } else {
        if (Number(e) > aq) {
          e = aq;
          dq = aq;
        } else {
          dq = Number(e);
        }
      }
      this.$store.dispatch('order/changeGeoDetailCount', { 'type': type, 'rowIndex': rowIndex, 'index': index, 'count': dq });
    },
    exportCountResult: function exportCountResult() {
      this.$http.post('PlaceOrder.aspx/GenerateCISReportExcel', {
        order: this.$store.state.order
      }, {
        errorType: 'custom'
      }).then(function (resp) {
        if (resp.body.d.ResultFlag) {
          window.location = '' + utils.getRootPath().replace('/r/', '') + resp.body.d.DataSource;
        } else {
          console.log(resp.body.d);
        }
      }, function (resp) {
        console.log(resp);
      });
    },
    descendingComparator: function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      return 0;
    },
    getComparator: function getComparator(order, orderBy) {
      var _this = this;

      return order === 'descending' ? function (a, b) {
        return _this.descendingComparator(a, b, orderBy);
      } : function (a, b) {
        return -_this.descendingComparator(a, b, orderBy);
      };
    },
    stableSort: function stableSort(array, comparator) {
      var stabilizedThis = array.map(function (el, index) {
        return [el, index];
      });
      stabilizedThis.sort(function (a, b) {
        var order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      return stabilizedThis.map(function (el) {
        return el[0];
      });
    },
    sortClick: function sortClick(field) {
      if (this.sortFild === field) {
        if (this.sort === 'descending') {
          this.sort = 'ascending';
        } else {
          this.sortFild = '';
        }
      } else {
        this.sortFild = field;
        this.sort = 'descending';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e89a7b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/MGeoGraphies.vue
var MGeoGraphies_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-box"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-link',{on:{"click":_vm.exportCountResult}},[_vm._v("Export Count Result")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('table',{staticClass:"table b-table table-striped table-hover"},[_c('thead',{attrs:{"role":"rowgroup"}},[_c('tr',[_c('td',{staticClass:" tablehead",staticStyle:{},attrs:{"valign":"middle","align":"center","rowspan":"2"}},[_vm._v("Geographies\n              ")]),_vm._v(" "),_c('td',{staticClass:"tablehead",attrs:{"colspan":"2","align":"center"}},[_vm._v("Homes\n              ")]),_vm._v(" "),_c('td',{staticClass:"tablehead",attrs:{"colspan":"2","align":"center"}},[_vm._v("Apts\n              ")]),_vm._v(" "),_c('td',{staticClass:"tablehead",attrs:{"colspan":"2","align":"center"}},[_vm._v("Business\n              ")]),_vm._v(" "),_c('td',{staticClass:"tablehead",attrs:{"colspan":"2","align":"center"}},[_vm._v("Total\n              ")]),_vm._v(" "),_c('td',{staticClass:" tablehead",staticStyle:{},attrs:{"valign":"middle","align":"center","colspan":"4"}},[_vm._v("Median\n              ")])]),_vm._v(" "),_c('tr',{attrs:{"role":"row"}},[_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='AvailableQtyHome'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('AvailableQtyHome')}}},[_vm._v("Avail.\n              ")]),_vm._v(" "),_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='DesiredQtyHome'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('DesiredQtyHome')}}},[_vm._v("Qty\n              ")]),_vm._v(" "),_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='AvailableQtyApt'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('AvailableQtyApt')}}},[_vm._v("Avail.\n              ")]),_vm._v(" "),_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='DesiredQtyApt'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('DesiredQtyApt')}}},[_vm._v("Qty\n              ")]),_vm._v(" "),_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='AvailableQtyBuss'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('AvailableQtyBuss')}}},[_vm._v("Avail.\n              ")]),_vm._v(" "),_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='DesiredQtyBuss'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('DesiredQtyBuss')}}},[_vm._v("Qty\n              ")]),_vm._v(" "),_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='AvailableQty'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('AvailableQty')}}},[_vm._v("Avail.\n              ")]),_vm._v(" "),_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='DesiredQty'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('DesiredQty')}}},[_vm._v("Qty\n              ")]),_vm._v(" "),_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='Income'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('Income')}}},[_vm._v("Income\n              ")]),_vm._v(" "),_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='HomeValue'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('HomeValue')}}},[_vm._v("Home Value\n              ")]),_vm._v(" "),_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='MedianAge'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('MedianAge')}}},[_vm._v("Age\n              ")]),_vm._v(" "),_c('td',{staticClass:"sorthead",attrs:{"align":"center","aria-sort":_vm.sortFild==='PHWC'?_vm.sort:'none'},on:{"click":function($event){return _vm.sortClick('PHWC')}}},[_vm._v("PHWC\n              ")])])]),_vm._v(" "),_c('tbody',[_c('tr',{attrs:{"id":"results_occu_total_row"}},[_c('td',{attrs:{"align":"left","width":"15%"}},[_c('strong',[_vm._v("Total")])]),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"6%"}}),_vm._v(" "),_c('td',{attrs:{"align":"left","width":"10%"}},[_vm._v(_vm._s(_vm.order.DesiredQtyHome))]),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"6%"}}),_vm._v(" "),_c('td',{attrs:{"align":"left","width":"10%"}},[_vm._v(_vm._s(_vm.order.DesiredQtyApt))]),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"6%"}}),_vm._v(" "),_c('td',{attrs:{"align":"left","width":"10%"}},[_vm._v(_vm._s(_vm.order.DesiredQtyBuss))]),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"6%"}},[_vm._v(_vm._s(_vm.order.TotalAvailableQty))]),_vm._v(" "),_c('td',{attrs:{"align":"left","width":"10%"}},[_vm._v(_vm._s(_vm.order.TotalDesiredQty))]),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"6%"}}),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"9%"}}),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"5%"}}),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"5%"}})]),_vm._v(" "),_vm._l((_vm.geos),function(item,index){return [_c('tr',[_c('td',{attrs:{"align":"left"},on:{"click":function($event){return _vm.tiggerShow(index)}}},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(item.showDetail !== true),expression:"item.showDetail !== true"}],staticClass:"h3-icon",attrs:{"name":"plus-circle"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(item.showDetail === true),expression:"item.showDetail === true"}],staticClass:"h3-icon",attrs:{"name":"minus-circle"}}),_vm._v(_vm._s(item.GeoKeyDesc)+"\n                ")],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('span',[_vm._v(_vm._s(item.AvailableQtyHome))])]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{attrs:{"type":"checkbox","disabled":item.AvailableQtyHome === 0},domProps:{"checked":item.DesiredQtyHome !== 0},on:{"change":function($event){return _vm.changeGeoCount('homes', index, $event)}}}),_vm._v("\n                  "+_vm._s(item.DesiredQtyHome)+"\n                ")]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v("\n                  "+_vm._s(item.AvailableQtyApt)+"\n                ")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{attrs:{"type":"checkbox","disabled":item.AvailableQtyApt === 0},domProps:{"checked":item.DesiredQtyApt !== 0},on:{"change":function($event){return _vm.changeGeoCount('apts', index, $event)}}}),_vm._v("\n                  "+_vm._s(item.DesiredQtyApt)+"\n                ")]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('span',[_vm._v(_vm._s(item.AvailableQtyBuss))])]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{attrs:{"type":"checkbox","disabled":item.AvailableQtyBuss === 0},domProps:{"checked":item.DesiredQtyBuss !== 0},on:{"change":function($event){return _vm.changeGeoCount('business', index, $event)}}}),_vm._v("\n                  "+_vm._s(item.DesiredQtyBuss)+"\n                ")]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('span',[_vm._v(_vm._s(item.AvailableQty))])]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":item.DesiredQty !== 0},on:{"change":function($event){return _vm.changeGeoCount('total', index, $event)}}}),_vm._v("\n                  "+_vm._s(item.DesiredQty)+"\n                ")]),_vm._v(" "),_c('td',{attrs:{"align":"center"}}),_vm._v(" "),_c('td',{attrs:{"align":"center"}}),_vm._v(" "),_c('td',{attrs:{"align":"center"}}),_vm._v(" "),_c('td',{attrs:{"align":"center"}})]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(item.showDetail),expression:"item.showDetail"}]},[_c('td',{attrs:{"colspan":"13"}},[_c('table',{staticStyle:{"background-color":"$color-background"},attrs:{"width":"100%"}},_vm._l((item.OrderGeoDetails),function(detail,dindex){return _c('tr',[_c('td',{staticStyle:{"background-color":"white","border":"0px"},attrs:{"width":"1%"}}),_vm._v(" "),_c('td',{attrs:{"width":"14%"}},[_vm._v("\n                        "+_vm._s(detail.DetailName)+"\n                      ")]),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"6%"}},[_vm._v("\n                        "+_vm._s(detail.AvailableQtyHome)+"\n                      ")]),_vm._v(" "),_c('td',{attrs:{"width":"10%"}},[_c('input',{attrs:{"type":"checkbox","disabled":detail.AvailableQtyHome === 0},domProps:{"checked":detail.DesiredQtyHome > 0 && detail.AvailableQtyHome !== 0},on:{"change":function($event){return _vm.changeGeoDetailCount('c', 'homes', index, dindex, $event, detail.AvailableQtyHome, detail.DesiredQtyHome)}}}),_vm._v(" "),_c('b-input',{staticStyle:{"width":"60px","display":"inline"},attrs:{"max":detail.AvailableQtyHome,"value":detail.DesiredQtyHome,"disabled":detail.AvailableQtyHome === 0},on:{"change":function($event){return _vm.changeGeoDetailCount('t', 'homes', index, dindex, $event, detail.AvailableQtyHome, detail.DesiredQtyHome)}}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"6%"}},[_vm._v("\n                        "+_vm._s(detail.AvailableQtyApt)+"\n                      ")]),_vm._v(" "),_c('td',{attrs:{"width":"10%"}},[_c('input',{attrs:{"type":"checkbox","disabled":detail.AvailableQtyApt === 0},domProps:{"checked":detail.DesiredQtyApt > 0 && detail.AvailableQtyApt !== 0},on:{"change":function($event){return _vm.changeGeoDetailCount('c', 'apts', index, dindex, $event, detail.AvailableQtyApt, detail.DesiredQtyApt)}}}),_vm._v(" "),_c('b-input',{staticStyle:{"width":"60px","display":"inline"},attrs:{"max":detail.AvailableQtyHome,"value":detail.DesiredQtyApt,"disabled":detail.AvailableQtyApt === 0},on:{"change":function($event){return _vm.changeGeoDetailCount('t', 'apts', index, dindex, $event, detail.AvailableQtyApt, detail.DesiredQtyApt)}}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"6%"}},[_vm._v("\n                        "+_vm._s(detail.AvailableQtyBuss)+"\n                      ")]),_vm._v(" "),_c('td',{attrs:{"width":"10%"}},[_c('input',{attrs:{"type":"checkbox","disabled":detail.AvailableQtyBuss === 0},domProps:{"checked":detail.DesiredQtyBuss > 0 && detail.AvailableQtyBuss !== 0},on:{"change":function($event){return _vm.changeGeoDetailCount('c', 'business', index, dindex, $event, detail.AvailableQtyBuss, detail.DesiredQtyBuss)}}}),_vm._v(" "),_c('b-input',{staticStyle:{"width":"60px","display":"inline"},attrs:{"max":detail.AvailableQtyHome,"value":detail.DesiredQtyBuss,"disabled":detail.AvailableQtyBuss === 0},on:{"change":function($event){return _vm.changeGeoDetailCount('t', 'business', index, dindex, $event, detail.AvailableQtyBuss, detail.DesiredQtyBuss)}}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center","width":"6%"}},[_vm._v("\n                        "+_vm._s(detail.AvailableQty)+"\n                      ")]),_vm._v(" "),_c('td',{attrs:{"width":"10%"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":detail.DesiredQty !== 0},on:{"change":function($event){return _vm.changeGeoDetailCount('c', 'total', index, dindex, $event, detail.AvailableQty, detail.DesiredQty)}}}),_vm._v("\n                        "+_vm._s(detail.DesiredQty)+"\n                      ")]),_vm._v(" "),_c('td',{attrs:{"align":"left","width":"6%"}},[_c('span',[_vm._v("$"+_vm._s(detail.Income))])]),_vm._v(" "),_c('td',{attrs:{"align":"left","width":"9%"}},[_c('span',[_vm._v("$"+_vm._s(detail.HomeValue))])]),_vm._v(" "),_c('td',{attrs:{"align":"left","width":"5%"}},[_c('span',[_vm._v(_vm._s(detail.MedianAge))])]),_vm._v(" "),_c('td',{attrs:{"align":"left","width":"5%"}},[_c('span',[_vm._v(_vm._s(detail.PHWC))])])])}),0)])])]})],2)])])],1)],1)],1)}
var MGeoGraphies_staticRenderFns = []
var MGeoGraphies_esExports = { render: MGeoGraphies_render, staticRenderFns: MGeoGraphies_staticRenderFns }
/* harmony default export */ var summary_MGeoGraphies = (MGeoGraphies_esExports);
// CONCATENATED MODULE: ./src/components/summary/MGeoGraphies.vue
function MGeoGraphies_injectStyle (ssrContext) {
  __webpack_require__("rR/S")
}
var MGeoGraphies_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MGeoGraphies___vue_template_functional__ = false
/* styles */
var MGeoGraphies___vue_styles__ = MGeoGraphies_injectStyle
/* scopeId */
var MGeoGraphies___vue_scopeId__ = "data-v-8e89a7b6"
/* moduleIdentifier (server only) */
var MGeoGraphies___vue_module_identifier__ = null
var MGeoGraphies_Component = MGeoGraphies_normalizeComponent(
  MGeoGraphies,
  summary_MGeoGraphies,
  MGeoGraphies___vue_template_functional__,
  MGeoGraphies___vue_styles__,
  MGeoGraphies___vue_scopeId__,
  MGeoGraphies___vue_module_identifier__
)

/* harmony default export */ var components_summary_MGeoGraphies = (MGeoGraphies_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/Summary.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ var Summary = ({
  components: {
    MSummaryInfo: components_summary_MSummaryInfo,
    MListUsage: components_summary_MListUsage,
    MTargetArea: components_summary_MTargetArea,
    MTargetAudience: components_summary_MTargetAudience,
    MPayment: components_summary_MPayment,
    MCheckTerms: components_summary_MCheckTerms,
    MContactInformation: components_summary_MContactInformation,
    MGeoGraphies: components_summary_MGeoGraphies,
    MBox: components_common_MBox,
    MMediaTypeInfo: components_summary_MMediaTypeInfo
  },
  data: function data() {
    return {
      enablePlaceOrderBtn: true
    };
  },
  created: function created() {
    if (false) {
      this.$store.dispatch('order/getOrder', 111);
      this.$store.dispatch('order/getOrderContact');
    }
    window.testPrice = this.test;
  },

  methods: {
    test: function test(order) {
      order = order || {};
      return priceHelp.updatePrice(order);
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    showSaveOrder: function showSaveOrder() {
      this.$root.$emit('bv::show::modal', 'saveorder');
    },
    placeOrder: function placeOrder() {
      var _this = this;

      if (this.$store.state.order.TotalDesiredQty < this.site.MinQuantityOfOrder) {
        notification.notice('error', 'The quantity that you entered is less than the minimum quantity of ' + this.site.MinQuantityOfOrder + '.', { title: 'Total Number Error', onlyGroup: 'CountNumberError' });
        return;
      }
      if (this.validOrder()) {
        if (this.$store.state.site.IsVertaxEnabled) {
          this.$root.$emit('bv::show::modal', 'placeOrderTax');
        } else {
          // this.enablePlaceOrder = false
          if (this.order.MediaTypeName === 'facebook') {
            this.$store.commit('order/saveKey', ['TenantId', '']);
            this.$store.commit('order/saveKey', ['DestinationId', '']);
            this.$store.commit('order/saveKey', ['DestinationAccountId', '']);
          } else if (this.order.MediaTypeName === 'twitter') {
            this.$store.commit('order/saveKey', ['ShareAccountId', '']);
            this.$store.commit('order/saveKey', ['PackageName', '']);
          }
          this.$http.post('PlaceOrder.aspx/ProcessOrder', {
            currentSessionId: this.$store.state.site.CurrentSessionId,
            industry: '',
            licenseName: '',
            password: '',
            sanExpDate: '',
            sanNumber: '',
            order: this.order
          }).then(function (resp) {
            // this.enablePlaceOrder = true
            var data = resp.body.d.DataSource;
            if (!data.IsSuccess) {
              notification.notice('error', 'Unfortunately, the system is unable to process your request. Our technical support specialists have been notified. Thank you for your patience while we work to resolve the error.', { title: 'Place Order Error', onlyGroup: 'placeOrderError' });
              return false;
            }

            _this.$store.commit('order/saveKey', ['OrderCode', data.OrderCode]);
            _this.$store.commit('order/saveKey', ['AccountName', data.AccountName]);
            _this.$store.commit('order/saveKey', ['SessionGuid', data.OrderSessionGuid]);
            _this.$store.commit('order/saveKey', ['OrderSubmittedDate', data.OrderSubmittedDate]);
            _this.$store.commit('order/saveKey', ['CurrentStep', 'success']);

            utils.uaEcommerce(_this.$store.state.order, _this.$store.getters['config/datasource'].name, _this.$store.getters['config/datasource'].SKU);
            _this.$router.push({ path: 'success' });

            // update user point
            // TODO@PONY need to use new api
            _this.$http.post('LandingPage.aspx/GetUserPoint', {}).then(function (resp) {}, function (resp) {
              _this.$store.commit('user/saveKey', ['userPoint', resp.body.d.DataSource.UserPoint]);
            });
          }, function (resp) {
            // this.enablePlaceOrder = true
          });
        }
      }
    },
    showSendQuote: function showSendQuote() {
      var _this2 = this;

      this.$http.post('PlaceOrder.aspx/IsOrderQuoteAvailable', {
        order: this.$store.state.order
      }).then(function (resp) {
        _this2.$root.$emit('bv::show::modal', 'sendQuote');
      }, function (resp) {
        notification.notice('error', 'In order to "send Quote", please first "Save Count"', {});
      });
    },
    validOrder: function validOrder() {
      var existError = false;

      // aggrement
      if (!this.$store.state.summary.aggreAgreement) existError = true;
      if (utils.verify(this.orderContactInformation.OrderName, 'require')) existError = true;
      if (utils.verify(this.orderContactInformation.Email, ['require', 'email'])) existError = true;
      if (utils.verify(this.orderContactInformation.Company, 'require')) existError = true;

      if (this.isCreditCard) {
        // need verify card type
        if (utils.verify(this.orderPayment.HolderName, 'require')) existError = true;
        if (utils.verify(this.orderPayment.Number, ['require', 'creditCard'])) existError = true;
        if (utils.verify(this.orderPayment.SecurityCode, ['require'])) existError = true;
        // need verify card expiration
        // need verify country
        if (utils.verify(this.orderPayment.AddressLine, ['require'])) existError = true;
        if (utils.verify(this.orderPayment.City, ['require'])) existError = true;
        if (utils.verify(this.orderPayment.State, ['require'])) existError = true;
        if (utils.verify(this.orderPayment.Zipcode, ['require', 'zip'])) existError = true;
      }
      if (this.order.ListType === 270) {
        if (utils.verify(this.order.MediaTypeName, ['require'])) existError = true;
      }
      if (this.order.MediaTypeName === 'facebook') {
        if (utils.verify(this.order.ShareAccountId, ['require'])) existError = true;
        if (utils.verify(this.order.PackageName, ['require'])) existError = true;
      } else if (this.order.MediaTypeName === 'twitter') {
        if (utils.verify(this.order.TenantId, ['require'])) existError = true;
        if (utils.verify(this.order.DestinationId, ['require'])) existError = true;
        if (utils.verify(this.order.DestinationAccountId, ['require'])) existError = true;
      }
      this.$store.commit('summary/saveShowError', existError);
      return !existError;
    }
  },
  computed: {
    site: function site() {
      return this.$store.state.site;
    },
    orderContactInformation: function orderContactInformation() {
      return this.$store.state.order.OrderContactInformation || {};
    },
    orderPayment: function orderPayment() {
      return this.$store.state.order.OrderPaymentInformation || {};
    },
    isContactAddressComplete: function isContactAddressComplete() {
      return this.$store.state.summary.IsContactAddressComplete || false;
    },
    isCreditCard: function isCreditCard() {
      return this.$store.getters['order/isCreditCard'];
    },
    isShowGeoGraphies: function isShowGeoGraphies() {
      return this.$store.state.order.ListType === 50;
    },

    enablePlaceOrder: {
      get: function get() {
        return this.$store.getters['site/enablePlaceOrder'] && this.enablePlaceOrderBtn;
      },
      set: function set(newValue) {
        this.enablePlaceOrderBtn = newValue;
      }
    },
    isShowSenderQuote: function isShowSenderQuote() {
      return this.$store.state.site.IsOrderQuoteEnabled;
    },
    order: function order() {
      return this.$store.state.order;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.$on('placeOrder', function () {
      _this3.placeOrder();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73bab8e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/Summary.vue
var Summary_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.config.uiVersion === 1)?_c('b-card',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Your List is Ready to Order")]),_vm._v(" "),_c('p',[_vm._v("Below you’ll see how many prospects are available based on your selections. To place an order, enter your desired quantity in the Total box under Qty Selection, enter your payment info, and click “Place Order.” If you need to make any changes to your selections first, click the appropriate “Edit” button to the left.\n          ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-btn',{on:{"click":_vm.goBack}},[_vm._v("Back")]),_vm._v(" "),_c('b-btn',{attrs:{"data-test":"summary-box-saveCount"},on:{"click":_vm.showSaveOrder}},[_vm._v("Save Count")]),_vm._v(" "),(_vm.isShowSenderQuote)?_c('b-btn',{on:{"click":_vm.showSendQuote}},[_vm._v("Send Quote")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('m-summary-info')],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"7"}},[(_vm.order.ListType === 270)?_c('m-media-type-info'):_vm._e(),_vm._v(" "),_c('m-list-usage'),_vm._v(" "),_c('m-target-area'),_vm._v(" "),(!_vm.isShowGeoGraphies)?_c('m-target-audience'):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"right-zone",attrs:{"lg":"5"}},[_c('m-contact-information',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContactAddressComplete),expression:"!isContactAddressComplete"}]}),_vm._v(" "),_c('m-payment'),_vm._v(" "),_c('m-check-terms'),_vm._v(" "),_c('b-btn',{staticClass:"placeorder-btn",attrs:{"variant":"primary","disabled":!_vm.enablePlaceOrder,"data-test":"summary-placeOrder"},on:{"click":_vm.placeOrder}},[_vm._v("Place Order")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.isShowGeoGraphies)?_c('m-geo-graphies'):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"bottom-btn"},[_c('b-col',[_c('b-btn',{on:{"click":_vm.goBack}},[_vm._v("Back")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.saveorder",modifiers:{"saveorder":true}}]},[_vm._v("Save Count")]),_vm._v(" "),(_vm.isShowSenderQuote)?_c('b-btn',{on:{"click":_vm.showSendQuote}},[_vm._v("Send Quote")]):_vm._e()],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.$store.state.config.uiVersion === 2)?_c('div',[_c('m-box',{attrs:{"title":"Your List is Ready to Order"}},[_c('p',[_vm._v("Below you’ll see how many prospects are available based on your selections. To place an order, enter your desired quantity in the Total box under Qty Selection, enter your payment info, and click “Place Order”. If you need to make any changes to your selections first, click the appropriate “Edit” button to the left.")]),_vm._v(" "),_c('b-link',{on:{"click":function($event){return _vm.$root.$emit('bv::show::modal', 'sampleExample')}}},[_vm._v("\n        Sample Output Example\n      ")]),_vm._v(" "),_c('div',{staticClass:"top-btns"},[_c('b-btn',{staticClass:"top-btn",on:{"click":_vm.goBack}},[_vm._v("Back")]),_vm._v(" "),_c('b-btn',{staticClass:"top-btn",on:{"click":_vm.showSaveOrder}},[_vm._v("Save Count")]),_vm._v(" "),_c('b-btn',{staticClass:"top-btn",on:{"click":_vm.showSendQuote}},[_vm._v("Send Quote")])],1)],1),_vm._v(" "),_c('m-box',{attrs:{"title":"List Buy Order Information"}},[_c('m-summary-info',{attrs:{"isUi2":true}})],1),_vm._v(" "),(_vm.order.ListType === 270)?_c('m-box',{attrs:{"title":"Media Type Info"}},[_c('m-media-type-info',{attrs:{"isUi2":true}})],1):_vm._e(),_vm._v(" "),_c('m-box',{attrs:{"title":"List Usage"}},[_c('m-list-usage',{attrs:{"isUi2":true}})],1),_vm._v(" "),_c('m-box',{attrs:{"title":"Target Area"}},[_c('m-target-area',{attrs:{"isUi2":true}}),_vm._v(" "),(_vm.isShowGeoGraphies)?_c('m-geo-graphies'):_vm._e()],1),_vm._v(" "),_c('m-box',{attrs:{"title":"Target Audience"}},[(!_vm.isShowGeoGraphies)?_c('m-target-audience',{attrs:{"isUi2":true}}):_vm._e()],1),_vm._v(" "),_c('m-box',{attrs:{"title":"payment"}},[_c('m-contact-information',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContactAddressComplete),expression:"!isContactAddressComplete"}],attrs:{"isUi2":true}}),_vm._v(" "),_c('m-payment',{attrs:{"isUi2":true}}),_vm._v(" "),_c('m-check-terms'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","margin-top":"16px"}},[_c('b-btn',{on:{"click":_vm.goBack}},[_vm._v("Back")]),_vm._v(" "),_c('b-btn',{staticClass:"placeorder-btn",attrs:{"variant":"primary","disalbed":!_vm.enablePlaceOrder,"data-test":"summary-placeOrder"},on:{"click":_vm.placeOrder}},[_vm._v("Place Order")])],1)],1)],1):_vm._e()],1)}
var Summary_staticRenderFns = []
var Summary_esExports = { render: Summary_render, staticRenderFns: Summary_staticRenderFns }
/* harmony default export */ var order_Summary = (Summary_esExports);
// CONCATENATED MODULE: ./src/pages/order/Summary.vue
function Summary_injectStyle (ssrContext) {
  __webpack_require__("t8BT")
}
var Summary_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Summary___vue_template_functional__ = false
/* styles */
var Summary___vue_styles__ = Summary_injectStyle
/* scopeId */
var Summary___vue_scopeId__ = "data-v-73bab8e8"
/* moduleIdentifier (server only) */
var Summary___vue_module_identifier__ = null
var Summary_Component = Summary_normalizeComponent(
  Summary,
  order_Summary,
  Summary___vue_template_functional__,
  Summary___vue_styles__,
  Summary___vue_scopeId__,
  Summary___vue_module_identifier__
)

/* harmony default export */ var pages_order_Summary = (Summary_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/DemoResidentOccupantList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DemoResidentOccupantList = ({
  components: {
    MDemoBox: components_demo_MDemoBox
  },
  data: function data() {
    return {
      targetoption: [{ value: 1, text: 'Include homes' }, { value: 2, text: 'Include apartments' }, { value: 4, text: 'Include businesses' }],
      routeoption: [{ value: 1, text: 'Include Carrier Routes' }, { value: 2, text: 'Include PO Boxes' }, { value: 4, text: 'Include Rural Routes' }]
    };
  },

  computed: {
    contactNameOption: {
      get: function get() {
        return this.$store.getters['order/contactNameOption'];
      },
      set: function set(val) {
        this.$store.commit('order/saveKey', ['ContactNameOption', parseInt(val)]);
      }
    },
    selecttarget: {
      get: function get() {
        var selected = [];
        var ts = this.$store.getters['order/targetOption'];
        for (var t in this.targetoption) {
          if ((ts & this.targetoption[t].value) === this.targetoption[t].value) {
            selected.push(this.targetoption[t].value);
          }
        }
        return selected;
      },
      set: function set(val) {
        var targetoption = 0;
        var values = [];
        for (var v in val) {
          targetoption = targetoption + val[v];
          if (val[v] === 1) {
            values.push({ value: 1, text: 'Include homes' });
          } else if (val[v] === 2) {
            values.push({ value: 2, text: 'Include apartments' });
          } else {
            values.push({ value: 4, text: 'Include businesses' });
          }
        }
        this.$store.commit('order/saveKey', ['TargetOption', parseInt(targetoption)]);
        this.$store.commit('demo/saveoption', { key: 'target', title: 'Targeting Options', values: values });
      }
    },
    selectroute: {
      get: function get() {
        var selected = [];
        var ro = this.$store.getters['order/routeOption'];
        for (var t in this.routeoption) {
          if ((ro & this.routeoption[t].value) === this.routeoption[t].value) {
            selected.push(this.routeoption[t].value);
          }
        }
        return selected;
      },
      set: function set(val) {
        var routeoption = 0;
        var values = [];
        for (var v in val) {
          routeoption = routeoption + val[v];
          if (val[v] === 1) {
            values.push({ value: 1, text: 'Include Carrier Routes' });
          } else if (val[v] === 2) {
            values.push({ value: 2, text: 'Include PO Boxes' });
          } else {
            values.push({ value: 4, text: 'Include Rural Routes' });
          }
        }
        this.$store.commit('order/saveKey', ['RouteOption', routeoption]);
        this.$store.commit('demo/saveoption', { key: 'route', title: 'Route Options', values: values });
      }
    }
  },
  mounted: function mounted() {
    this.$store.commit('demo/saveoption', { key: 'target', title: 'Targeting Options', values: this.targetoption });
    this.$store.commit('demo/saveoption', { key: 'route', title: 'Route Options', values: this.routeoption });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30844f67","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoResidentOccupantList.vue
var DemoResidentOccupantList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":"demoresidentoccupantlist","hasSaveQuickPick":false,"hasTotalRecords":false}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"titlecol"},[_c('h4',[_vm._v("\n      Way to go! Now it's time to define your target audience. Use the demographic and/or lifestyle options below to select the categories and variables of your target audience. Choose as many as you like, then select one of the three phone options below. That's it! Click \"Next\" for your count. If you need help, please contact a Digital Expert at 800-399-8611.\n     ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('h4',[_vm._v("Targeting Options:")])]),_vm._v(" "),_c('b-col',[_c('h4',[_vm._v("Route Options:")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-checkbox-group',{attrs:{"plain":"","stacked":"","options":_vm.targetoption},model:{value:(_vm.selecttarget),callback:function ($$v) {_vm.selecttarget=$$v},expression:"selecttarget"}})],1),_vm._v(" "),_c('b-col',[_c('b-form-checkbox-group',{attrs:{"plain":"","stacked":"","options":_vm.routeoption},model:{value:(_vm.selectroute),callback:function ($$v) {_vm.selectroute=$$v},expression:"selectroute"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('h4',[_vm._v("Contact Names:")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-check',{attrs:{"value":"1","unchecked-value":"0"},model:{value:(_vm.contactNameOption),callback:function ($$v) {_vm.contactNameOption=$$v},expression:"contactNameOption"}},[_vm._v("Include contact names where available.")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('h4',[_vm._v("\n        * Occupant Lists are addressed to the \"Current Resident\" or \"Occupant\". Contact names are available upon request\n        for approximately 70% of the list by checking the box above. If you require a contact name for every record on the list,\n        please visit our "),_c('b-link',{attrs:{"to":{name: 'order', params:{ listType: 10}}}},[_vm._v(" Consumer Lists.")])],1)])],1)],1)],1)}
var DemoResidentOccupantList_staticRenderFns = []
var DemoResidentOccupantList_esExports = { render: DemoResidentOccupantList_render, staticRenderFns: DemoResidentOccupantList_staticRenderFns }
/* harmony default export */ var order_DemoResidentOccupantList = (DemoResidentOccupantList_esExports);
// CONCATENATED MODULE: ./src/pages/order/DemoResidentOccupantList.vue
function DemoResidentOccupantList_injectStyle (ssrContext) {
  __webpack_require__("bANw")
}
var DemoResidentOccupantList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DemoResidentOccupantList___vue_template_functional__ = false
/* styles */
var DemoResidentOccupantList___vue_styles__ = DemoResidentOccupantList_injectStyle
/* scopeId */
var DemoResidentOccupantList___vue_scopeId__ = "data-v-30844f67"
/* moduleIdentifier (server only) */
var DemoResidentOccupantList___vue_module_identifier__ = null
var DemoResidentOccupantList_Component = DemoResidentOccupantList_normalizeComponent(
  DemoResidentOccupantList,
  order_DemoResidentOccupantList,
  DemoResidentOccupantList___vue_template_functional__,
  DemoResidentOccupantList___vue_styles__,
  DemoResidentOccupantList___vue_scopeId__,
  DemoResidentOccupantList___vue_module_identifier__
)

/* harmony default export */ var pages_order_DemoResidentOccupantList = (DemoResidentOccupantList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/Success.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Success = ({
  components: {},
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {
    goHome: function goHome() {
      this.$router.push({ name: 'landing' });
    }
  },
  computed: {
    site: function site() {
      return this.$store.state.site;
    },
    order: function order() {
      return this.$store.state.order;
    },
    totalCharge: function totalCharge() {
      return this.order.TotalPretaxCost + this.order.TaxCharge;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65ea0480","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/Success.vue
var Success_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Your Order Is Complete")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Thank You! Your Order Number is "+_vm._s(_vm.order.OrderCode))]),_vm._v(" "),_c('p',[_vm._v("A confirmation email with your receipt has been sent to "),_c('b-link',{attrs:{"href":'mailto:' + _vm.order.OrderContactInformation.Email}},[_vm._v(_vm._s(_vm.order.OrderContactInformation.Email))]),_vm._v(".Your order is currently being processed. When it is complete, typically within 30 minutes, you will receive a second email with links to retrieve your list in MS Excel and comma-delimited text format.")],1),_vm._v(" "),_c('p',[_vm._v("If you have any questions about your order, please contact us at "),_c('b-link',{attrs:{"href":"tel:8003998611"}},[_vm._v("800-399-8611")]),_vm._v(" or at "),_c('b-link',{attrs:{"href":"mailto:orders@sl360.com"}},[_vm._v("orders@sl360.com")]),_vm._v(".")],1),_vm._v(" "),_c('p',[_vm._v("*Please make sure that your email's spam filter is set to allow emails from orders@sl360.com. Lists are fulfilled within 4 hours, typically under 30 minutes during normal business hours (Mon-Fri, 8am-7pm EST). Orders placed after hours from first time customers may be placed on hold for confirmation and are typically fulfilled within one business day.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tr',[_c('td',[_vm._v("Order Number")]),_vm._v(" "),_c('td',{attrs:{"data-test":"success-orderCode"}},[_vm._v(_vm._s(_vm.order.OrderCode))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Order Name")]),_vm._v(" "),_c('td',{attrs:{"data-test":"success-orderDesc"}},[_vm._v(_vm._s(_vm.order.OrderContactInformation.OrderName))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Order Date")]),_vm._v(" "),_c('td',{attrs:{"data-test":"success-orderDate"}},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.order.OrderSubmittedDate)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Qty Available")]),_vm._v(" "),_c('td',{attrs:{"data-test":"success-availableQty"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.order.TotalAvailableQty,'', 0)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Qty Selected")]),_vm._v(" "),_c('td',{attrs:{"data-test":"success-selectedQty"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.order.TotalDesiredQty,'', 0)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Tax")]),_vm._v(" "),_c('td',{attrs:{"data-test":"success-tax"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.order.TaxCharge)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Total Charge")]),_vm._v(" "),_c('td',{attrs:{"data-test":"success-totalCharge"}},[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.totalCharge)))])])]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"primary","data-test":"success-goHome"},on:{"click":_vm.goHome}},[_vm._v("Home")])],1)],1)],1)],1)}
var Success_staticRenderFns = []
var Success_esExports = { render: Success_render, staticRenderFns: Success_staticRenderFns }
/* harmony default export */ var order_Success = (Success_esExports);
// CONCATENATED MODULE: ./src/pages/order/Success.vue
function Success_injectStyle (ssrContext) {
  __webpack_require__("t4JC")
}
var Success_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Success___vue_template_functional__ = false
/* styles */
var Success___vue_styles__ = Success_injectStyle
/* scopeId */
var Success___vue_scopeId__ = "data-v-65ea0480"
/* moduleIdentifier (server only) */
var Success___vue_module_identifier__ = null
var Success_Component = Success_normalizeComponent(
  Success,
  order_Success,
  Success___vue_template_functional__,
  Success___vue_styles__,
  Success___vue_scopeId__,
  Success___vue_module_identifier__
)

/* harmony default export */ var pages_order_Success = (Success_Component.exports);

// CONCATENATED MODULE: ./src/router/orderRoutes.js
/**
 * Created by pony.ma@nirvana-info on .
 */
































/* harmony default export */ var orderRoutes = ([{
  name: 'geo-zip',
  path: 'geo/zip',
  component: pages_order_GeoZip,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'geo-zipRange',
  path: 'geo/zipRange',
  component: pages_order_GeoZipRange,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'geo-zipPaste',
  path: 'geo/zipPaste',
  component: pages_order_GeoZipPaste,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'geo-state',
  path: 'geo/state',
  component: pages_order_GeoState,
  meta: {
    title: 'Leads',
    keepUnAlive: true
  }
}, {
  name: 'geo-stateMap',
  path: 'geo/stateMap',
  component: pages_order_GeoStateMap,
  meta: {
    title: 'Leads',
    keepUnAlive: true
  }
}, {
  name: 'geo-stateList',
  path: 'geo/stateList',
  component: pages_order_GeoStateList,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'geo-polygon',
  path: 'geo/polygon',
  component: pages_order_GeoPolygon,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'geo-radius',
  path: 'geo/radius',
  component: pages_order_GeoRadius,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'geo-city',
  path: 'geo/city',
  component: pages_order_GeoCity,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'geo-county',
  path: 'geo/county',
  component: pages_order_GeoCounty,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'geo-metroArea',
  path: 'geo/metroArea',
  component: pages_order_GeoMetroArea,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'geo-congressionalDistrict',
  path: 'geo/congressionalDistrict',
  component: pages_order_GeoCongressionalDistrict,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'geo-moreArea',
  path: 'geo/moreArea',
  props: true,
  component: pages_order_GeoMoreArea,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'geo',
  path: 'geo',
  redirect: function redirect(to) {
    if (store.getters['config/checkDatasource'](to.params.listType)) {
      if (store.state.site.lastGeoTab) {
        return { name: 'geo-' + store.state.site.lastGeoTab, query: to.query };
      }
      return { name: 'geo-' + store.state.config.datasource[to.params.listType].geoTabs[0], query: to.query };
    } else {
      return { name: 'landing', query: to.query };
    }
  }
}, {
  name: 'demo-multiCount',
  path: 'demo/multiCount',
  props: true,
  component: pages_order_GeoSLCCount,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'demo-audiencePropensities',
  path: 'demo/audiencePropensities',
  props: true,
  component: pages_order_DemoAudiencePropensities,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'demo-demoDemographics',
  path: 'demo/demoDemographics',
  props: true,
  component: pages_order_DemoDemographics,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'demo-intrestsPurchasing',
  path: 'demo/intrestsPurchasing',
  props: true,
  component: pages_order_DemoIntrestsPurchasing,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'demo-quickPicks',
  path: 'demo/quickPicks',
  props: true,
  component: pages_order_DemoQuickPick,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'demo-businessType',
  path: 'demo/businessType',
  props: true,
  component: pages_order_DemoBusinessType,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'demo-businessQuickPicks',
  path: 'demo/businessQuickPicks',
  props: true,
  component: pages_order_DemoBusinessQuickPick,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'demo-suppression',
  path: 'demo/suppression',
  props: true,
  component: pages_order_DemoSuppression,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'demo-search',
  path: 'demo/search',
  props: true,
  component: pages_order_DemoSearch,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'demo-residentOccupantList',
  path: 'demo/residentOccupantList',
  props: true,
  component: pages_order_DemoResidentOccupantList,
  meta: {
    title: 'Leads'
  }
}, {
  name: 'demo',
  path: 'demo',
  redirect: function redirect(to) {
    if (store.getters['config/checkDatasource'](to.params.listType)) {
      if (store.state.site.lastDemoTab) {
        return { name: 'demo-' + store.state.site.lastDemoTab, query: to.query };
      } else {
        return { name: 'demo-' + store.state.config.datasource[to.params.listType].demoTabs[0], query: to.query };
      }
    } else {
      return { name: 'landing', query: to.query };
    }
  }
}, {
  name: 'summary',
  path: 'summary',
  component: pages_order_Summary,
  meta: {
    title: 'Summary',
    isPage: true,
    keepUnAlive: true
  },
  beforeEnter: function beforeEnter(to, from, next) {
    if (!src_config.dev.isAuth) {
      next();
      return false;
    }
    if (!store.getters['config/checkDatasource'](to.params.listType)) {
      next({ name: 'landing', query: to.query });
      return false;
    }

    if (['success', 'summary'].indexOf(store.state.order.CurrentStep) === -1) {
      next({ name: 'order', params: to.params, query: to.query });
      return false;
    }
    next();
  }
}, {
  name: 'success',
  path: 'success',
  component: pages_order_Success,
  meta: {
    title: 'Success',
    isPage: true,
    keepUnAlive: true
  },
  beforeEnter: function beforeEnter(to, from, next) {
    if (!src_config.dev.isAuth) {
      next();
      return false;
    }

    if (!store.getters['config/checkDatasource'](to.params.listType)) {
      next({ name: 'landing' });
      return false;
    }

    if (['success'].indexOf(store.state.order.CurrentStep) === -1) {
      next({ name: 'order', params: to.params });
      return false;
    }
    next();
  }
}, {
  name: 'geo-SCFCode',
  path: 'geo/SCFCode',
  props: true,
  component: pages_order_GeoSCFCode,
  meta: {
    title: 'Leads'
  }
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Videos.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Videos = ({
  components: {
    MBase: components_layouts_MBase
  },
  name: 'Videos',
  computed: {
    categories: function categories() {
      return this.$store.state.user.UserVideos;
    },

    currentVideoUrl: {
      get: function get() {
        if (this.videoUrl !== '') {
          return this.videoUrl;
        } else {
          if (this.$store.state.user.UserVideos.length > 0) {
            return this.$store.state.user.UserVideos[0].videos[0].videoUrl;
          } else {
            return this.videoUrl;
          }
        }
      },
      set: function set(newValue) {
        this.videoUrl = newValue;
      }
    },
    currentVideoList: {
      get: function get() {
        if (this.videoList.length > 0) {
          return this.videoList;
        } else {
          if (this.$store.state.user.UserVideos.length > 0) {
            return this.$store.state.user.UserVideos[0].videos;
          } else {
            return this.videoList;
          }
        }
      },
      set: function set(newValue) {
        this.videoList = newValue;
      }
    }
  },
  methods: {
    changeIndex: function changeIndex(item, index) {
      this.selectedIndex = index;
      this.currentVideoUrl = item.videos[0].videoUrl;
      this.currentVideoList = item.videos;
      this.selectedVideoIndex = 0;
    },
    showVideo: function showVideo(url, index) {
      this.currentVideoUrl = url;
      this.selectedVideoIndex = index;
    }
  },
  data: function data() {
    return {
      selectedIndex: 0,
      selectedVideoIndex: 0,
      videoUrl: '',
      videoList: []
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.$store.state.user.ShowVideos === false) {
        next({ name: 'landing' });
      } else {
        next();
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d1230c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Videos.vue
var Videos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-base',[_c('b-container',{staticClass:"m-layout-content",attrs:{"fluid":true}},[_c('b-row',{staticStyle:{"margin-right":"0","margin-top":"16px"}},[_c('b-col',{staticClass:"title header-title"},[_c('h1',{staticStyle:{"margin-left":"16px"}},[_vm._v("Videos")])])],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-right":"0"}},[_c('b-col',{staticStyle:{"padding-right":"0"}},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"the-content"},[_c('div',[_c('div',{staticClass:"card",staticStyle:{"background-color":"#eee !important","border":"none"}},[_c('div',{staticClass:"m-tabs"},_vm._l((_vm.categories),function(item,index){return _c('b-link',{key:item.categoryName,staticClass:"m-tab",class:{'m-tab-active': _vm.selectedIndex === index},on:{"click":function($event){return _vm.changeIndex(item, index)}}},[_vm._v("\n                    "+_vm._s(item.categoryName)+"\n                  ")])}),1),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#fff","border":"1px solid rgba(0, 0, 0, 0.125)","border-radius":".25rem","border-top":"none"}},[_c('b-row',{attrs:{"cass":"geo-box"}},[_c('b-col',[_c('div',{staticStyle:{"height":"600px","padding":"25px"}},[_c('iframe',{staticClass:"iframe-embed",staticStyle:{"width":"100%","height":"100%","opacity":"1","visibility":"visible"},attrs:{"src":_vm.currentVideoUrl,"frameborder":"0","allowfullscreen":"allowfullscreen"}})])])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"the-slide",staticStyle:{"height":"642px"}},[_c('div',{staticClass:"box",staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"width":"100%"}},[_c('h2',[_vm._v("My Videos")]),_vm._v(" "),_c('div',{staticStyle:{"height":"580px","overflow-y":"auto"}},_vm._l((_vm.currentVideoList),function(item,index){return _c('div',{staticClass:"m-slide-section",class:{'m-slide-section-active': _vm.selectedVideoIndex === index},on:{"click":function($event){return _vm.showVideo(item.videoUrl, index)}}},[_c('div',{staticStyle:{"float":"left"}},[_c('img',{staticStyle:{"width":"120px"},attrs:{"src":__webpack_require__("lfGP")}})]),_vm._v(" "),_c('div',{staticStyle:{"float":"left","margin":"25px"}},[_c('h4',[_vm._v(_vm._s(item.videoName))])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])}),0)])])])])])],1)],1)],1)}
var Videos_staticRenderFns = []
var Videos_esExports = { render: Videos_render, staticRenderFns: Videos_staticRenderFns }
/* harmony default export */ var pages_Videos = (Videos_esExports);
// CONCATENATED MODULE: ./src/pages/Videos.vue
function Videos_injectStyle (ssrContext) {
  __webpack_require__("KnrZ")
}
var Videos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Videos___vue_template_functional__ = false
/* styles */
var Videos___vue_styles__ = Videos_injectStyle
/* scopeId */
var Videos___vue_scopeId__ = "data-v-05d1230c"
/* moduleIdentifier (server only) */
var Videos___vue_module_identifier__ = null
var Videos_Component = Videos_normalizeComponent(
  Videos,
  pages_Videos,
  Videos___vue_template_functional__,
  Videos___vue_styles__,
  Videos___vue_scopeId__,
  Videos___vue_module_identifier__
)

/* harmony default export */ var src_pages_Videos = (Videos_Component.exports);

// CONCATENATED MODULE: ./src/router/routes.js
/**
 * Created by seaasun on 2018/1/31.
 */




// import Code404 from '@/pages/Code404'

// import testt from '@/pages/testt'












/* harmony default export */ var routes = ([{
  path: '/',
  name: 'landing',
  component: src_pages_Landing,
  meta: {
    title: 'Home'
  }
}, {
  path: '/example',
  name: 'landing2',
  component: src_pages_Landing2,
  meta: {
    title: 'Home'
  }
}, {
  path: '/403',
  name: '403',
  component: src_pages_Code403,
  meta: {
    title: '403'
  }
}, {
  path: '/404',
  name: '404',
  // component: Code404,
  meta: {
    title: '404'
  },
  redirect: function redirect(to) {
    notification.notice('error', 'Can not find the page, Take you to the landing page', {
      title: '404'
    });
    return { name: 'landing' };
  }
},
// {
//   path: '/test',
//   name: 'test',
//   component: testt,
//   meta: {
//     title: 'Home'
//   }
// },
{
  path: '/test/summary',
  name: 'test-summary',
  component: src_pages_testSummary,
  meta: {
    title: 'Test'
  }
}, {
  path: '/order/:listType',
  name: 'order',
  component: pages_order_Order,
  children: orderRoutes
}, {
  path: '/order',
  redirect: {
    name: 'landing'
  }
}, {
  name: 'reward',
  path: '/reward',
  component: src_pages_Reward,
  meta: {
    title: 'Reward'
  }
}, {
  name: 'signin',
  path: '/signin',
  component: src_pages_SignIn,
  meta: {
    title: 'Sign Up -Sales Leads On Demand'
  }
}, {
  name: 'digitalCampaigns',
  path: '/digitalCampaigns',
  component: src_pages_DigitalCampaigns,
  meta: {
    title: 'Sign Up -Sales Leads On Demand'
  }
}, {
  name: 'freedatadiagnostic',
  path: '/freedatadiagnostic',
  component: src_pages_FreeDataDiagnostic,
  meta: {
    title: 'Sign Up -Sales Leads On Demand'
  }
}, {
  path: '*',
  redirect: {
    name: '404'
  }
}, {
  path: '/videos',
  name: 'videos',
  component: src_pages_Videos,
  meta: {
    title: 'Home'
  }
}]);
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js







// import _ from 'lodash'

vue_esm["default"].use(vue_router_esm["a" /* default */]);
var router = new vue_router_esm["a" /* default */]({
  routes: routes,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return new promise_default.a(function (resolve, reject) {
      if (store.state.config.uiVersion === 2 && from.name !== 'landing') {} else {
        setTimeout(function () {
          resolve({ selector: '.header-top-scrool' });
        }, 500);
      }
    });
  }
});

router.beforeEach(function (to, from, next) {
  // utils.uaEvent('path')
  // check login
  if (to.name !== 'signin' && window.first.isLogin === 'false') {
    router.push({ name: 'signin' });
    return;
  } else if (to.name === 'signin' && window.first.isLogin === 'ok' && "production" !== 'development') {
    router.push({ name: 'landing' });
    return;
  }

  // update title
  if (to.meta.title) {
    document.title = 'SL360 ' + to.meta.title;
  }
  var urls = to.path.split('/');
  // if (urls[1] === 'order' ) {
  if (urls[1] === 'order') {
    if (to.name === 'order' && store.state.config.uiVersion === 2) {
      next();
      return;
    }

    // check datasource
    if (!store.getters['config/checkDatasource'](to.params.listType)) {
      next({ name: 'landing', query: to.query });
    }

    var listType = parseInt(to.params.listType);
    var datasource = store.state.config.datasource[listType];

    // check geotype
    if (to.name.slice(0, 4) === 'geo-' || urls[3] === undefined || urls[3] === '') {
      if (datasource.geoTabs.indexOf(urls[4]) === -1) {
        router.replace({ name: 'geo-' + datasource.geoTabs[0], params: { listType: listType }, replace: true, query: to.query });
        return;
      } else {
        store.commit('site/saveKey', ['lastGeoTab', urls[4]]);
      }
    }

    // check demotab
    if (to.name.slice(0, 5) === 'demo-') {
      if (store.state.geo.geoUnAdd) {
        var dict = {
          zip: 'ZIP code entered has not been added,  if you would like to use the ZIP as your geographic option please go back',
          radius: 'The radius or ZIP code entered has not been added, if you would like to use the radius or ZIP code as your geographic option please go back'
        };
        notification.notice('info', dict[store.state.geo.geoUnAdd]);
        store.commit('geo/saveKey', ['geoUnAdd', false]);
      }
      if (to.name === 'demo-multiCount') {} else if (datasource.demoTabs.indexOf(urls[4]) === -1) {
        next({ name: 'demo-' + datasource.demoTabs[0], params: { listType: listType }, replace: true, query: to.query });
        return;
      } else {
        store.commit('site/saveKey', ['lastDemoTab', urls[4]]);
      }
    }
  }
  next();
});

router.afterEach(function (to, from) {
  utils.uaEvent('path', to.name, from.name);
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/bootstrap-vue/esm/index.js + 305 modules
var esm = __webpack_require__("Tqaz");

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.css
var nprogress_nprogress = __webpack_require__("UVIz");
var nprogress_nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress_nprogress);

// EXTERNAL MODULE: ./src/assets/style/custom.scss
var custom = __webpack_require__("lsv9");
var custom_default = /*#__PURE__*/__webpack_require__.n(custom);

// EXTERNAL MODULE: ./node_modules/vue-scrollto/vue-scrollto.js
var vue_scrollto = __webpack_require__("bm7V");
var vue_scrollto_default = /*#__PURE__*/__webpack_require__.n(vue_scrollto);

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/chevron-down.js
var chevron_down = __webpack_require__("e0Rn");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/chevron-right.js
var chevron_right = __webpack_require__("kb/u");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/circle.js
var icons_circle = __webpack_require__("pYLg");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/circle-thin.js
var circle_thin = __webpack_require__("VPi6");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/circle-o.js
var circle_o = __webpack_require__("UcI+");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/times-circle.js
var times_circle = __webpack_require__("DMY1");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/close.js
var icons_close = __webpack_require__("nZeE");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/check-circle.js
var check_circle = __webpack_require__("+NLg");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/twitter.js
var twitter = __webpack_require__("acYx");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/eye.js
var eye = __webpack_require__("5O9v");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/plus.js
var plus = __webpack_require__("rcsw");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/plus-circle.js
var plus_circle = __webpack_require__("h+cp");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/minus.js
var minus = __webpack_require__("73KA");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/minus-circle.js
var minus_circle = __webpack_require__("Gslk");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/search.js
var search = __webpack_require__("T4wd");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/folder-open.js
var folder_open = __webpack_require__("1Agw");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/folder.js
var folder = __webpack_require__("n4Bv");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/file.js
var file = __webpack_require__("r24w");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/question-circle.js
var question_circle = __webpack_require__("R3SC");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/commenting-o.js
var commenting_o = __webpack_require__("PlC4");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/check.js
var check = __webpack_require__("D/Bo");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/check-circle-o.js
var check_circle_o = __webpack_require__("hj2v");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/comments-o.js
var comments_o = __webpack_require__("1/28");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/chevron-up.js
var chevron_up = __webpack_require__("CxVc");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/share-alt.js
var share_alt = __webpack_require__("NBSW");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/eraser.js
var eraser = __webpack_require__("iAkl");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/envelope-open-o.js
var envelope_open_o = __webpack_require__("TB4W");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/envelope-o.js
var envelope_o = __webpack_require__("hd27");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/mobile.js
var mobile = __webpack_require__("1vv5");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/phone.js
var phone = __webpack_require__("73Iz");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/volume-control-phone.js
var volume_control_phone = __webpack_require__("PASy");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/file-text-o.js
var file_text_o = __webpack_require__("z/TA");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/history.js
var icons_history = __webpack_require__("Os+9");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/save.js
var icons_save = __webpack_require__("g+VN");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/dollar.js
var dollar = __webpack_require__("azbf");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/gift.js
var gift = __webpack_require__("Epgv");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/user-o.js
var user_o = __webpack_require__("IaG0");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/sign-out.js
var sign_out = __webpack_require__("mgNy");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/at.js
var at = __webpack_require__("Vn/n");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/television.js
var television = __webpack_require__("oA0G");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/ticket.js
var ticket = __webpack_require__("V48i");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/users.js
var users = __webpack_require__("bXQA");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/bank.js
var bank = __webpack_require__("/KQH");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/home.js
var home = __webpack_require__("8AWp");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/car.js
var car = __webpack_require__("vanS");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/location-arrow.js
var location_arrow = __webpack_require__("RIsO");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/building.js
var building = __webpack_require__("cWpK");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/compass.js
var compass = __webpack_require__("kNCX");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/university.js
var university = __webpack_require__("V7q9");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/shopping-bag.js
var shopping_bag = __webpack_require__("5i+G");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/desktop.js
var desktop = __webpack_require__("5eTd");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/adn.js
var adn = __webpack_require__("7zz2");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/envelope.js
var envelope = __webpack_require__("OHUv");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/magic.js
var magic = __webpack_require__("i+WE");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/envelope-square.js
var envelope_square = __webpack_require__("uCCX");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/phone-square.js
var phone_square = __webpack_require__("bBaO");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/expand.js
var expand = __webpack_require__("Gzhx");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/compress.js
var compress = __webpack_require__("QysE");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/caret-right.js
var caret_right = __webpack_require__("Oncp");

// EXTERNAL MODULE: ./node_modules/vue-awesome/components/Icon.vue + 2 modules
var Icon = __webpack_require__("D4uH");

// EXTERNAL MODULE: ./node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__("8+8L");

// CONCATENATED MODULE: ./src/http.js



/**
 * Created by seaasun on 2017/12/12.
 *
 *
 * errorType: 'default' 'custom' 'silent'
 * progressBar: true, false
 *
 */





vue_esm["default"].use(vue_resource_esm["a" /* default */]);
/* harmony default export */ var http = (vue_esm["default"]);

var getLocal = function getLocal() {
  return 'hold';
};
var apiName = src_config.dev.apiName;
if (false) {
  _Promise.resolve().then(function () {
    return require('./assets/dev/localApi');
  }).then(function (resp) {
    getLocal = resp.default;
  });
}

var api = {
  local: '',
  unLogin: 'http://dev.sl360.com/login',
  login: utils.getRootPath()
};

vue_esm["default"].http.options.root = api[apiName];

// Vue.http.headers.common['Access-Control-Allow-Credentials'] = 'true'
// Vue.http.headers.common['Cookie'] = '_acxm=8b4d2ade-a369-11e7-b85b-0ec41ab0532a; LPVID=hhMjc0N2JlMjUxZjdhMGFi; Hm_lvt_8875c662941dbf07e39c556c8d97615f=1510647647; _mkto_trk=id:982-LRE-196&token:_mch-sl360.com-1506663952710-21215; ASP.NET_SessionId=aeaio555e3ko4v55s1izscf1; _ga=GA1.2.2051064206.1506485374; _gid=GA1.2.1900188550.1514367031; _gat=1'

function filterDate(obj) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = get_iterator_default()(keys_default()(obj)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      if (obj[key] instanceof Object) {
        obj[key] = filterDate(obj[key]);
      } else if (typeof obj[key] === 'string' && obj[key].constructor === String && /\/Date\([0-9-]+\)+\//gi.test(obj[key])) {
        obj[key] = new Date(parseInt(/-?\d+/.exec(obj[key])[0]));
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return obj;
}

function filterNull(obj) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = get_iterator_default()(keys_default()(obj)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      if (obj[key] === null) {
        delete obj[key];
      } else if (obj[key] instanceof Object) {
        obj[key] = filterNull(obj[key]);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return obj;
}

function defaultError(code, msg) {
  // Auth error
  if (code === 401 || code === 403) {
    alert('auth error'); // TODO@PONY need to do auth

    // Server error
  } else if (code > 500) {
    msg = msg || 'Sorry, please try again';
    notification.notice('error', msg, { title: 'Server Error', onlyGroup: 'severError' });

    // time out
  } else if (code === 408) {
    notification.notice('error', 'Please check the internet connection', { title: 'Connect Error', onlyGroup: 'connectError' });

    // others
  } else {
    msg = msg || 'Sorry, please try again';
    notification.notice('error', 'Sorry for the server error. If you need help, please contact a Digital Expert at 800-399-8611.', { title: 'Server Error', onlyGroup: 'severError' });
  }
}
function handleError(resp, errorType, req) {
  // all custom rejcet
  if (errorType === 'silent') {
    // 400 - 599: defaul notice, else custom

  } else if (errorType === 'custom') {
    if (resp.status >= 400 && resp.status < 600) {
      defaultError(resp.status, resp.statusText);
    }

    // all use defaut notice
  } else if (errorType === 'default') {
    defaultError(resp.status, resp.statusText);
  }

  var info = {
    reqUrl: req.url,
    reqBody: req.body,
    reqParams: req.params,
    reqCrossOrigin: req.crossOrigin,
    reqHeaders: req.headers,
    respBody: resp.body,
    respStatusText: resp.statusText
  };
  utils.log('web', resp.status, resp.url, info);
}

// TODO@PONY need fix
vue_esm["default"].http.interceptors.before = function (req, next) {
  // abort previous request, if exists
  if (req.hasOwnProperty('abortPre') && req.abortPre) {
    if (this.previousRequest) {
      this.previousRequest.abort();
    }
    this.previousRequest = req;
  }
  next();
};
vue_esm["default"].http.interceptors.push(function (req, next) {
  if (!req.hasOwnProperty('progressBar')) {
    req.progressBar = true;
  }
  if (req.progressBar) {
    utils.progressStart();
  }

  // delete param if null
  if (req.body) {
    req.body = filterNull(req.body);
  }
  // using local api when dev
  if (apiName === 'local') {
    if (getLocal() === 'hold') {
      setTimeout(function () {
        var body = getLocal(req.url);
        body = filterDate(body);
        if (req.progressBar) {
          utils.progressDone();
        }
        next(req.respondWith(body, {
          status: 200
        }));
      }, 3000);
    } else {
      var body = getLocal(req.url);
      body = filterDate(body);
      if (req.progressBar) {
        utils.progressDone();
      }
      next(req.respondWith(body, {
        status: 200
      }));
    }
    // using servers api
  } else {
    next(function (resp) {
      if (req.progressBar) {
        utils.progressDone();
      }
      // when resultFlag = flase, reject
      if (resp.body.d && resp.body.d.hasOwnProperty('ResultFlag') && resp.body.d.ResultFlag === false) {
        resp.ok = false;
        resp.status = 900;
        resp.statusText = resp.body.d.ResultMessage;
      }
      // handle success
      if (resp.ok) {
        resp.body = filterDate(resp.body);
        // handle error
      } else {
        if (!req.hasOwnProperty('errorType')) {
          req.errorType = 'default';
        }
        handleError(resp, req.errorType, req);
      }
    });
  }
});
// CONCATENATED MODULE: ./src/assets/filters.js
/**
 * Created by seaasun on 2017/12/15.
 */


// import _ from 'lodash'

function numberFormat(num, symbol, rounding, decimal, isThousands) {
  return utils.numberFormat(num, symbol, rounding, decimal, isThousands);
}

function formatMonth(date) {
  var month = {
    0: 'JAN',
    1: 'FEB',
    2: 'MAR',
    3: 'APR',
    4: 'MAY',
    5: 'JUN',
    6: 'JUL',
    7: 'AUG',
    8: 'SEP',
    9: 'OCT',
    10: 'NOV',
    11: 'DEC'
  };
  try {
    return month[date.getMonth()];
  } catch (e) {
    return '';
  }
}

function formatDay(date) {
  try {
    return date.getDate();
  } catch (e) {
    return '';
  }
}

function formatYear(date) {
  try {
    return date.getFullYear();
  } catch (e) {
    return '';
  }
}

function formatDate(date, format) {
  try {
    return utils.dateFormat(date, format);
  } catch (e) {
    return '';
  }
}
// CONCATENATED MODULE: ./src/assets/directives.js
/**
 * Created by pony.ma@nirvana-info on .
 */


function mUaEvent(el, binding) {
  // v-m-ua-event(['category', 'action', 'label'])
  var value = [];
  value[0] = binding[0] || 'notSet';
  value[1] = binding[1] || 'notSet';
  value[2] = binding[2] || 'notSet';
  el.addEventListener('click', function () {
    utils.uaEvent(value[0], value[1], value[2]);
  });
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/MLoader.vue
//
//
//
//
//
//


/* harmony default export */ var MLoader = ({
  props: {
    size: {
      type: String,
      default: 'box'
    },
    centerSize: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      defualt: ''
    },
    width: {
      type: String,
      defualt: ''
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    centerStyle: function centerStyle() {
      var style = {
        'smBox': {
          margin: '32px',
          'margin-bottom': '32px',
          width: '32px',
          height: '32px'
        },
        'box': {
          margin: '32px',
          'margin-bottom': '48px',
          width: '32px',
          height: '32px'
        },
        'font': {
          width: '1em',
          height: '1em',
          margin: '0 1em',
          padding: 0,
          display: 'inline-block'
        }
      };
      var result = style[this.size];
      if (!lodash_default.a.isEmpty(this.centerSize)) {
        result.width = this.centerSize;
        result.height = this.centerSize;
      }
      return result;
    },
    boxStyle: function boxStyle() {
      var style = {
        'box': {
          height: '100%',
          width: '100%',
          display: 'flex',
          'justify-content': 'center',
          'align-items': 'center'
        },
        'smBox': {
          height: '100%',
          width: '100%',
          display: 'flex',
          'justify-content': 'center',
          'align-items': 'center'
        },
        'font': {
          margin: 0,
          padding: 0,
          display: 'inline-block'
        },
        'before': {
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
          display: 'flex',
          'justify-content': 'center',
          'align-items': 'center'
        }
      };
      var result = style[this.size];
      if (!lodash_default.a.isEmpty(this.height)) {
        result.height = this.centerSize;
      }
      if (!lodash_default.a.isEmpty(this.width)) {
        result.width = this.centerSize;
      }
      return result;
    }
  },
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7d86684","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MLoader.vue
var MLoader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loder-box",style:(_vm.boxStyle)},[_c('div',{staticClass:"m-loader",style:(_vm.centerStyle)})])}
var MLoader_staticRenderFns = []
var MLoader_esExports = { render: MLoader_render, staticRenderFns: MLoader_staticRenderFns }
/* harmony default export */ var common_MLoader = (MLoader_esExports);
// CONCATENATED MODULE: ./src/components/common/MLoader.vue
function MLoader_injectStyle (ssrContext) {
  __webpack_require__("ddVM")
}
var MLoader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MLoader___vue_template_functional__ = false
/* styles */
var MLoader___vue_styles__ = MLoader_injectStyle
/* scopeId */
var MLoader___vue_scopeId__ = "data-v-b7d86684"
/* moduleIdentifier (server only) */
var MLoader___vue_module_identifier__ = null
var MLoader_Component = MLoader_normalizeComponent(
  MLoader,
  common_MLoader,
  MLoader___vue_template_functional__,
  MLoader___vue_styles__,
  MLoader___vue_scopeId__,
  MLoader___vue_module_identifier__
)

/* harmony default export */ var components_common_MLoader = (MLoader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/MDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MDialog = ({
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    page: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      show: false
    };
  },

  watch: {
    show: function show(val) {
      if (val) {
        this.hideBodyScroll();
      } else {
        this.showBodyScroll();
      }
    }
  },
  activated: function activated() {
    this.show = true;
  },
  deactivated: function deactivated() {
    this.show = false;
  },
  created: function created() {
    var _this = this;

    if (this.page) {
      this.show = true;
      this.hideBodyScroll();
    } else {
      this.$root.$on('mDialogShow', function (name) {
        if (name === _this.name) {}
      });

      this.$root.$on('mDialogClose', function (name) {
        if (name === _this.name) {
          _this.show = false;
        }
      });
    }
  },

  methods: {
    close: function close() {
      this.showBodyScroll();
      this.$emit('close');
    },
    hideBodyScroll: function hideBodyScroll() {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    },
    showBodyScroll: function showBodyScroll() {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7283de8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MDialog.vue
var MDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"dialog-background"},[_c('div',{staticClass:"dialog-box"},[_c('div',{staticClass:"dialog-nav"},[_c('div',{staticClass:"dialog-nav-main"},[_c('div',{staticClass:"dialog-nav-title"},[_c('h2',{staticStyle:{"padding-left":"16px"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h2',{staticStyle:{"margin-right":"24px"},on:{"click":_vm.close}},[_c('icon',{attrs:{"name":"close"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"dialog-nav-menu"},[_vm._t("menu")],2)]),_vm._v(" "),_c('b-container',{staticStyle:{"padding-top":"24px","padding-bottom":"32px"}},[_vm._t("default")],2)],1)])}
var MDialog_staticRenderFns = []
var MDialog_esExports = { render: MDialog_render, staticRenderFns: MDialog_staticRenderFns }
/* harmony default export */ var common_MDialog = (MDialog_esExports);
// CONCATENATED MODULE: ./src/components/common/MDialog.vue
function MDialog_injectStyle (ssrContext) {
  __webpack_require__("eAKE")
}
var MDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MDialog___vue_template_functional__ = false
/* styles */
var MDialog___vue_styles__ = MDialog_injectStyle
/* scopeId */
var MDialog___vue_scopeId__ = "data-v-7283de8a"
/* moduleIdentifier (server only) */
var MDialog___vue_module_identifier__ = null
var MDialog_Component = MDialog_normalizeComponent(
  MDialog,
  common_MDialog,
  MDialog___vue_template_functional__,
  MDialog___vue_styles__,
  MDialog___vue_scopeId__,
  MDialog___vue_module_identifier__
)

/* harmony default export */ var components_common_MDialog = (MDialog_Component.exports);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









// import https://fontawesome.com/v4.7.0/icons/
















































































// init bootstrap vue
vue_esm["default"].use(esm["a" /* default */]);
vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_scrollto_default.a);

// register global utility filters.
keys_default()(filters_namespaceObject).forEach(function (key) {
  vue_esm["default"].filter(key, filters_namespaceObject[key]);
});
// register global utility directives.
keys_default()(directives_namespaceObject).forEach(function (key) {
  vue_esm["default"].directive(key, directives_namespaceObject[key]);
});

vue_esm["default"].component('icon', Icon["a" /* default */]);
vue_esm["default"].component('MLoader', components_common_MLoader);
vue_esm["default"].component('MBox', components_common_MBox);
vue_esm["default"].component('MDialog', components_common_MDialog);

vue_esm["default"].prototype.$notice = function (msg, type, options) {
  notification.notice(msg, type, options);
};

// global error
var main_errorHandler = function errorHandler(error, vm, info) {
  console.error(error);
  utils.log('js', info, error.name + ': ' + error.message, error.stack);
};
vue_esm["default"].config.errorHandler = main_errorHandler;

if (window.first.env === 'local' || window.first.env === 'dev' || window.first.env === 'prod') {
  window.store = store;
}

var app = new vue_esm["default"]({
  store: store,
  router: src_router,
  template: '<App/>',
  components: {
    App: src_App,
    Icon: Icon["a" /* default */]
  }
});

var main = {
  checkLogin: function checkLogin() {
    if (window.first.isLogin === 'ok' || window.first.isLogin === 'false') {
      if (window.first.isLogin === 'ok') {
        window.intercomSettings = {
          app_id: 'onky7rvz',
          name: window.first.fullName,
          email: window.first.email,
          created_at: window.first.createDate.replace('/Date(', '').replace(')/', '').substring(0, 10)
        };
      } else {
        window.intercomSettings = {
          app_id: 'onky7rvz'
        };
      }
      app.$mount('#app');
    } else if (window.first.isLogin === 'hold') {
      window.intercomSettings = {
        app_id: 'onky7rvz'
      };
      setTimeout(main.checkLogin, 10);
    }
  }
};
main.checkLogin();
/* harmony default export */ var src_main = __webpack_exports__["default"] = (app);

/***/ }),

/***/ "NUk/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OZdI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PHAw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q1cx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/counting_new.71de560.gif";

/***/ }),

/***/ "Q5go":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QYvC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RMt6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Roy/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SFhX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SJj4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "So/r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tk57":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U3SM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V51N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W5Ou":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WMdO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y/KP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YyTR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZRBE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZUdV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aBUf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aPG7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aQR6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKTWlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVN3WJP3Fj7f92UPVkLY8LGXbIEAIiOsCMgQWaIQkgBhhBASQMWFiApWFBURnEhVxILVCkidiOKgKLhnQYqIWotVXDjuH9yntX167+3t+9f7vOec5/zOec8PgBESJpHmomoAOVKFPDrYH49PSMTJvYACFUjgBCAQ5svCZwXFAADwA3l4fnSwP/wBr28AAgBw1S4kEsfh/4O6UCZXACCRAOAiEucLAZBSAMguVMgUAMgYALBTs2QKAJQAAGx5fEIiAKoNAOz0ST4FANipk9wXANiiHKkIAI0BAJkoRyQCQLsAYFWBUiwCwMIAoKxAIi4EwK4BgFm2MkcCgL0FAHaOWJAPQGAAgJlCLMwAIDgCAEMeE80DIEwDoDDSv+CpX3CFuEgBAMDLlc2XS9IzFLiV0Bp38vDg4iHiwmyxQmEXKRBmCeQinJebIxNI5wNMzgwAABr50cH+OD+Q5+bk4eZm52zv9MWi/mvwbyI+IfHf/ryMAgQAEE7P79pf5eXWA3DHAbB1v2upWwDaVgBo3/ldM9sJoFoK0Hr5i3k4/EAenqFQyDwdHAoLC+0lYqG9MOOLPv8z4W/gi372/EAe/tt68ABxmkCZrcCjg/1xYW52rlKO58sEQjFu9+cj/seFf/2OKdHiNLFcLBWK8ViJuFAiTcd5uVKRRCHJleIS6X8y8R+W/QmTdw0ArIZPwE62B7XLbMB+7gECiw5Y0nYAQH7zLYwaC5EAEGc0Mnn3AACTv/mPQCsBAM2XpOMAALzoGFyolBdMxggAAESggSqwQQcMwRSswA6cwR28wBcCYQZEQAwkwDwQQgbkgBwKoRiWQRlUwDrYBLWwAxqgEZrhELTBMTgN5+ASXIHrcBcGYBiewhi8hgkEQcgIE2EhOogRYo7YIs4IF5mOBCJhSDSSgKQg6YgUUSLFyHKkAqlCapFdSCPyLXIUOY1cQPqQ28ggMor8irxHMZSBslED1AJ1QLmoHxqKxqBz0XQ0D12AlqJr0Rq0Hj2AtqKn0UvodXQAfYqOY4DRMQ5mjNlhXIyHRWCJWBomxxZj5Vg1Vo81Yx1YN3YVG8CeYe8IJAKLgBPsCF6EEMJsgpCQR1hMWEOoJewjtBK6CFcJg4Qxwicik6hPtCV6EvnEeGI6sZBYRqwm7iEeIZ4lXicOE1+TSCQOyZLkTgohJZAySQtJa0jbSC2kU6Q+0hBpnEwm65Btyd7kCLKArCCXkbeQD5BPkvvJw+S3FDrFiOJMCaIkUqSUEko1ZT/lBKWfMkKZoKpRzame1AiqiDqfWkltoHZQL1OHqRM0dZolzZsWQ8ukLaPV0JppZ2n3aC/pdLoJ3YMeRZfQl9Jr6Afp5+mD9HcMDYYNg8dIYigZaxl7GacYtxkvmUymBdOXmchUMNcyG5lnmA+Yb1VYKvYqfBWRyhKVOpVWlX6V56pUVXNVP9V5qgtUq1UPq15WfaZGVbNQ46kJ1Bar1akdVbupNq7OUndSj1DPUV+jvl/9gvpjDbKGhUaghkijVGO3xhmNIRbGMmXxWELWclYD6yxrmE1iW7L57Ex2Bfsbdi97TFNDc6pmrGaRZp3mcc0BDsax4PA52ZxKziHODc57LQMtPy2x1mqtZq1+rTfaetq+2mLtcu0W7eva73VwnUCdLJ31Om0693UJuja6UbqFutt1z+o+02PreekJ9cr1Dund0Uf1bfSj9Rfq79bv0R83MDQINpAZbDE4Y/DMkGPoa5hpuNHwhOGoEctoupHEaKPRSaMnuCbuh2fjNXgXPmasbxxirDTeZdxrPGFiaTLbpMSkxeS+Kc2Ua5pmutG003TMzMgs3KzYrMnsjjnVnGueYb7ZvNv8jYWlRZzFSos2i8eW2pZ8ywWWTZb3rJhWPlZ5VvVW16xJ1lzrLOtt1ldsUBtXmwybOpvLtqitm63Edptt3xTiFI8p0in1U27aMez87ArsmuwG7Tn2YfYl9m32zx3MHBId1jt0O3xydHXMdmxwvOuk4TTDqcSpw+lXZxtnoXOd8zUXpkuQyxKXdpcXU22niqdun3rLleUa7rrStdP1o5u7m9yt2W3U3cw9xX2r+00umxvJXcM970H08PdY4nHM452nm6fC85DnL152Xlle+70eT7OcJp7WMG3I28Rb4L3Le2A6Pj1l+s7pAz7GPgKfep+Hvqa+It89viN+1n6Zfgf8nvs7+sv9j/i/4XnyFvFOBWABwQHlAb2BGoGzA2sDHwSZBKUHNQWNBbsGLww+FUIMCQ1ZH3KTb8AX8hv5YzPcZyya0RXKCJ0VWhv6MMwmTB7WEY6GzwjfEH5vpvlM6cy2CIjgR2yIuB9pGZkX+X0UKSoyqi7qUbRTdHF09yzWrORZ+2e9jvGPqYy5O9tqtnJ2Z6xqbFJsY+ybuIC4qriBeIf4RfGXEnQTJAntieTE2MQ9ieNzAudsmjOc5JpUlnRjruXcorkX5unOy553PFk1WZB8OIWYEpeyP+WDIEJQLxhP5aduTR0T8oSbhU9FvqKNolGxt7hKPJLmnVaV9jjdO31D+miGT0Z1xjMJT1IreZEZkrkj801WRNberM/ZcdktOZSclJyjUg1plrQr1zC3KLdPZisrkw3keeZtyhuTh8r35CP5c/PbFWyFTNGjtFKuUA4WTC+oK3hbGFt4uEi9SFrUM99m/ur5IwuCFny9kLBQuLCz2Lh4WfHgIr9FuxYji1MXdy4xXVK6ZHhp8NJ9y2jLspb9UOJYUlXyannc8o5Sg9KlpUMrglc0lamUycturvRauWMVYZVkVe9ql9VbVn8qF5VfrHCsqK74sEa45uJXTl/VfPV5bdra3kq3yu3rSOuk626s91m/r0q9akHV0IbwDa0b8Y3lG19tSt50oXpq9Y7NtM3KzQM1YTXtW8y2rNvyoTaj9nqdf13LVv2tq7e+2Sba1r/dd3vzDoMdFTve75TsvLUreFdrvUV99W7S7oLdjxpiG7q/5n7duEd3T8Wej3ulewf2Re/ranRvbNyvv7+yCW1SNo0eSDpw5ZuAb9qb7Zp3tXBaKg7CQeXBJ9+mfHvjUOihzsPcw83fmX+39QjrSHkr0jq/dawto22gPaG97+iMo50dXh1Hvrf/fu8x42N1xzWPV56gnSg98fnkgpPjp2Snnp1OPz3Umdx590z8mWtdUV29Z0PPnj8XdO5Mt1/3yfPe549d8Lxw9CL3Ytslt0utPa49R35w/eFIr1tv62X3y+1XPK509E3rO9Hv03/6asDVc9f41y5dn3m978bsG7duJt0cuCW69fh29u0XdwruTNxdeo94r/y+2v3qB/oP6n+0/rFlwG3g+GDAYM/DWQ/vDgmHnv6U/9OH4dJHzEfVI0YjjY+dHx8bDRq98mTOk+GnsqcTz8p+Vv9563Or59/94vtLz1j82PAL+YvPv655qfNy76uprzrHI8cfvM55PfGm/K3O233vuO+638e9H5ko/ED+UPPR+mPHp9BP9z7nfP78L/eE8/sl0p8zAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAMISURBVHjaZJJLaFxlFMd/3+PeuXPvTDKJeXSaamsTbBZJSI21BhEfGx9Y0ZWLKC6KqHWlILEbBaV2KV115QPsQhAXRgQ3UhHpIqLBSlvTitqkmWTMTDOZ3LnzuPe7n4vREvQsDmdz/vzP73+EtZYP3317+tj1n3/CdVODiNhVSgop6zvBxb797y/cPvb6HfkAp91ySxtl4jiONYBROlCeJ0ySKKTK7xZIpaDjZhhd+uG1+/7azH5156FXihm3s7S4KIsjI0iA3lzOd7XGWst/S1pAaapOhplryy8fb4UfN5wMwg/So0eOSA0QNaOmMWbXliTdriEyHjbwgQQd+ERaMXll6YX4YKN9fnb2pfVKxUiAKGoKay1CCLAW0hRn9BA2bmPCEOVoBvf1MTRWhJECd3duPt/TaQ2sbla7JyglheM4twyYSpn8M3MUTpwkXlvBRhFCKYQAoTWdIJBZ31fDQ4NdgVJpPXFdl38R2CQhDev4Rx+g8OqbdDZuIBt1+kxEbxKS0TLJZP04DEM0QF9fwUThDYT4x4IQpHEMQM+xZ+kpZGh/cIYfG3vwrMdh0RS9hHh+0BVITaqSJOkyAHZ3gGuTj3F80CIL/YjtOn55zd8fXp1QdvM7CZDL543+X4zd+fJanbtOXiA3dZj35qZ48clRtsZnOLtx7/lyIzuhAaSSyvd92rUaCLDW4mVcAOY/X4Z2zDuzHm98+ivxVpXTT+/lqeWcXAkeOSW70IzdrtUQUnbNOy7asVz95lsuXlllfGyA5879QTu1zD8+wi9rTTLJDtvWf1gCbJY3mnG7hZQKBKiBIdLPPmLnk7O4w3uJU/i90uLEg8MUexxOf7mK54DjaKMBAt9XWZMlsekteNX1CtOOYdJusqAnGB9ocW6xSum3NUhTbLafXlP+XgLExnjScUhTi6XLIM4VUEry1s0FhkzIpWQP94/leXSqn1JyG54jOgejC/MaoBMnpvvKdAS0uyFaSrqf6faffL1+hlOFJ/ji0j7kxlYw56+k9xyQDxWHZy7/PQCPEkUcQDadNgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "acLg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bANw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bKA3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landReach.316f8b5.jpg";

/***/ }),

/***/ "bUOA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "boF+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "brmI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c7fO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dE4I":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landManage.23dd3c7.jpg";

/***/ }),

/***/ "dYrh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ddVM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dn8f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e/zq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eAKE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eVSk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eq/4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fHIT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fg26":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gLkS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gpS1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gqF5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gvFx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h72j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h79P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i7rk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "io1r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kQX9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ld55":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lfGP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/VideoMarketing.e72b926.jpg";

/***/ }),

/***/ "lsv9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m564":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m99Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mp6T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n/Ip":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n1Zb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n2Tx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n2jV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n5mI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "novS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo_SL360_transparent.63677d2.png";

/***/ }),

/***/ "oCzI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oQqv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "omJa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "osbG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qPA5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qna0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r4Fl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rIPm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rR/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rzMY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landAnalyze.742aa21.jpg";

/***/ }),

/***/ "s4pt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sxFT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t/Eq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t4JC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t8BT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvcE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xAWQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xAfj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xRDv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xYc4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xZyS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xcFm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zbch":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zrWs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ztea":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.397bf606f0faaa02cd6b.js